import { Injectable, NgModule, Directive, ElementRef, Input, HostListener, EventEmitter, Component, Output, ComponentFactoryResolver, ViewChild, ViewContainerRef, ɵɵdefineInjectable, ɵɵinject, Pipe, forwardRef, Optional, Injector, SkipSelf, ViewEncapsulation, NgZone, ErrorHandler, ChangeDetectorRef, isDevMode } from '@angular/core';
import { FormControl, FormBuilder, NG_VALUE_ACCESSOR, NgControl, FormsModule, NG_VALIDATORS, Validators, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { HttpHeaders, HttpClient, HttpClientModule, HttpResponse, HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Router, RouterModule, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, ActivatedRoute } from '@angular/router';
import { Subject, Observable, BehaviorSubject as BehaviorSubject$1 } from 'rxjs/Rx';
import { CommonModule, Location } from '@angular/common';
import { ToasterModule } from 'angular2-toaster/angular2-toaster';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule as CollapseModule$1 } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule as TooltipModule$1 } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import { BlockUIModule, BlockUI } from 'ng-block-ui';
import { DatatableComponent, NgxDatatableModule } from '@swimlane/ngx-datatable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { BehaviorSubject, Subject as Subject$1, Observable as Observable$1, throwError, of, from } from 'rxjs';
import * as cloneDeep_ from 'lodash/cloneDeep';
import { map, takeUntil, debounceTime, distinctUntilChanged, retry, catchError, publishReplay, refCount, switchMap, tap, filter } from 'rxjs/operators';
import * as swal$3 from 'sweetalert';
import swal__default, {  } from 'sweetalert';
import { isNullOrUndefined } from 'util';
import { CollapseModule, TooltipModule } from 'ngx-bootstrap';
import { LocaleService } from 'angular-l10n';
import { LogLevel, LocalizationModule, LocaleValidationModule, LocaleService as LocaleService$1 } from 'node_modules/angular-l10n';
import { BrowserModule, Title } from '@angular/platform-browser';
import { __decorate, __metadata } from 'tslib';
import { CustomValidators } from 'ng2-validation';
export { AccordionModule } from 'ngx-bootstrap/accordion/accordion.module';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/settings/settings.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SettingsService {
    constructor() {
        // User Settings
        // -----------------------------------
        this.user = {
            name: 'John',
            job: 'ng-developer',
            picture: 'assets/img/user/02.jpg'
        };
        // App Settings
        // -----------------------------------
        this.app = {
            name: 'Sizing Suite',
            description: '© Spirax Sarco',
            year: ((new Date()).getFullYear())
        };
        // Layout Settings
        // -----------------------------------
        this.layout = {
            isFixed: true,
            isCollapsed: false,
            isBoxed: false,
            isRTL: false,
            horizontal: false,
            isFloat: false,
            asideHover: false,
            theme: null,
            asideScrollbar: false,
            isCollapsedText: false,
            useFullLayout: false,
            hiddenFooter: false,
            offsidebarOpen: false,
            asideToggled: false,
            viewAnimation: 'ng-fadeInUp'
        };
    }
    /**
     * @param {?} name
     * @return {?}
     */
    getAppSetting(name) {
        return name ? this.app[name] : this.app;
    }
    /**
     * @param {?} name
     * @return {?}
     */
    getUserSetting(name) {
        return name ? this.user[name] : this.user;
    }
    /**
     * @param {?} name
     * @return {?}
     */
    getLayoutSetting(name) {
        return name ? this.layout[name] : this.layout;
    }
    /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    setAppSetting(name, value) {
        if (typeof this.app[name] !== 'undefined') {
            this.app[name] = value;
        }
    }
    /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    setUserSetting(name, value) {
        if (typeof this.user[name] !== 'undefined') {
            this.user[name] = value;
        }
    }
    /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    setLayoutSetting(name, value) {
        if (typeof this.layout[name] !== 'undefined') {
            return this.layout[name] = value;
        }
    }
    /**
     * @param {?} name
     * @return {?}
     */
    toggleLayoutSetting(name) {
        return this.setLayoutSetting(name, !this.getLayoutSetting(name));
    }
}
SettingsService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
SettingsService.ctorParameters = () => [];
if (false) {
    /** @type {?} */
    SettingsService.prototype.user;
    /** @type {?} */
    SettingsService.prototype.app;
    /** @type {?} */
    SettingsService.prototype.layout;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/menu/menu.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MenuService {
    constructor() {
        this.menuItems = [];
    }
    /**
     * @param {?} items
     * @return {?}
     */
    addMenu(items) {
        items.forEach((/**
         * @param {?} item
         * @return {?}
         */
        (item) => {
            this.menuItems.push(item);
        }));
    }
    /**
     * @return {?}
     */
    getMenu() {
        return this.menuItems;
    }
    /**
     * @param {?} url
     * @return {?}
     */
    getMenuObjByUrl(url) {
        // Normalise the url if it is the root.
        url = url === "/" ? "/home" : url;
        /** @type {?} */
        var menuItem = (/** @type {?} */ (this.menuItems.find((/**
         * @param {?} mu
         * @return {?}
         */
        mu => mu.link === url))));
        if (!menuItem) {
            // No top-level menu item found. Search all nodes that contain sub-menus.
            for (const item in this.menuItems) {
                if (this.menuItems.hasOwnProperty(item)) {
                    /** @type {?} */
                    const currentItem = this.menuItems[item];
                    // Search through sub-menu items to find a link there.
                    if (!!currentItem.submenu) {
                        menuItem = currentItem.submenu.find((/**
                         * @param {?} su
                         * @return {?}
                         */
                        su => su.link === url));
                        break;
                    }
                }
            }
        }
        return !!menuItem ? menuItem : null;
    }
}
MenuService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
MenuService.ctorParameters = () => [];
if (false) {
    /** @type {?} */
    MenuService.prototype.menuItems;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/module-import-guard.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// https://angular.io/styleguide#!#04-12
/**
 * @param {?} parentModule
 * @param {?} moduleName
 * @return {?}
 */
function throwIfAlreadyLoaded(parentModule, moduleName) {
    if (parentModule) {
        throw new Error(`${moduleName} has already been loaded. Import Core modules in the AppModule only.`);
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/authentication/authenticatedUser.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthenticatedUser {
    constructor() {
        this.permissions = {
            "canAccessSizingSuite": false,
            "canManageModuleAccess": false,
            "canManageModulePreferences": false,
            "canManageOpCoPreferences": false,
            "canManageProductSelection": false,
            "canViewAdminTasks": false,
            "canViewCurrencyInfo": false,
            "canViewMyProfile": false,
            "canViewNotifications": false,
            "canViewProjects&Jobs": false,
            "canViewUserPreferences": false,
            "canManageEasiheatBillOfMaterials": false,
            "canDownloadOfflineClient": false,
            "canExportExcelDocuments": false,
            "canExportToCRM": false
        };
    }
}
if (false) {
    /** @type {?} */
    AuthenticatedUser.prototype.name;
    /** @type {?} */
    AuthenticatedUser.prototype.impersonator;
    /** @type {?} */
    AuthenticatedUser.prototype.expiryMilliseconds;
    /** @type {?} */
    AuthenticatedUser.prototype.isLoggedIn;
    /** @type {?} */
    AuthenticatedUser.prototype.isImpersonating;
    /** @type {?} */
    AuthenticatedUser.prototype.picture;
    /** @type {?} */
    AuthenticatedUser.prototype.permissions;
    /** @type {?} */
    AuthenticatedUser.prototype.clientMode;
    /** @type {?} */
    AuthenticatedUser.prototype.newClientUser;
    /** @type {?} */
    AuthenticatedUser.prototype.syncAccess;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/authentication/authentication.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthenticationService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
        this.loginHeaders = new HttpHeaders({ "Content-Type": "application/x-www-form-urlencoded" });
        this.authenticatedUser = new AuthenticatedUser();
        this.authUserChange = new Subject();
        // When the class in constructed, initialise the subject so that whenever it is called, its subscriber resolves the result to the provided object.
        this.authUserChange.subscribe((/**
         * @return {?}
         */
        () => {
            this.authenticatedUser = new AuthenticatedUser();
            /** @type {?} */
            let userObj = JSON.parse(localStorage.getItem("userObj"));
            if (!!userObj) {
                // let currentdateTime = new Date();
                // const expires = currentdateTime.setMilliseconds(currentdateTime.getMilliseconds() + (userObj[".expires_in"])) ;
                /** @type {?} */
                const ticketDurationMilliseconds = userObj["expires_in"];
                this.authenticatedUser.name = userObj["Name"];
                this.authenticatedUser.isLoggedIn = ticketDurationMilliseconds > 0;
                this.authenticatedUser.expiryMilliseconds = ticketDurationMilliseconds;
                this.authenticatedUser.impersonator = userObj["impersonator"];
                this.authenticatedUser.isImpersonating = !!userObj["impersonator"];
                this.authenticatedUser.clientMode = (userObj["ClientMode"] === "True");
                this.authenticatedUser.syncAccess = (userObj["SyncAccess"] === "True");
                this.authenticatedUser.newClientUser = (userObj["NewClientUser"] === "True");
                // Set the individual permissions here. Double exclamation is done to handle undefined permissions.
                this.authenticatedUser.permissions["canEditTranslations"] = !!(userObj["CanEditTranslations"] === "True");
                this.authenticatedUser.permissions["canAccessSizingSuite"] = !!(userObj["CanAccessSizingSuite"] === "True");
                this.authenticatedUser.permissions["canManageModuleAccess"] = !!(userObj["CanManageModuleAccess"] === "True");
                this.authenticatedUser.permissions["canManageModulePreferences"] = !!(userObj["CanManageModulePreferences"] === "True");
                this.authenticatedUser.permissions["canManageOpCoPreferences"] = !!(userObj["CanManageOpCoPreferences"] === "True");
                this.authenticatedUser.permissions["canManageProductSelection"] = !!(userObj["CanManageProductSelection"] === "True");
                this.authenticatedUser.permissions["canViewAdminTasks"] = !!(userObj["CanViewAdminTasks"] === "True");
                this.authenticatedUser.permissions["canViewCurrencyInfo"] = !!(userObj["CanViewCurrencyInfo"] === "True");
                this.authenticatedUser.permissions["canViewMyProfile"] = !!(userObj["CanViewMyProfile"] === "True");
                this.authenticatedUser.permissions["canViewNotifications"] = !!(userObj["CanViewNotifications"] === "True");
                this.authenticatedUser.permissions["canViewProjectsJobs"] = !!(userObj["CanViewProjectsJobs"] === "True");
                this.authenticatedUser.permissions["canViewUserPreferences"] = !!(userObj["CanViewUserPreferences"] === "True");
                this.authenticatedUser.permissions["canManageEasiheatBillOfMaterials"] = !!(userObj["CanManageEasiheatBillOfMaterials"] === "True");
                this.authenticatedUser.permissions["canDownloadOfflineClient"] = !!(userObj["CanDownloadOfflineClient"] === "True");
                this.authenticatedUser.permissions["canExportExcelDocuments"] = !!(userObj["CanExportExcelDocuments"] === "True");
                this.authenticatedUser.permissions["canExportToCRM"] = !!(userObj["CanExportToCRM"] === "True");
                this.authenticatedUser.permissions["canManagePricingAccessLevel"] = !!(userObj["CanManagePricingAccessLevel"] === "True");
                if (!this.authenticatedUser.picture) {
                    // Set the default picture if there is none.
                    //this.authenticatedUser.picture = 'assets/img/user/default_user.png';
                    this.authenticatedUser.picture = 'assets/img/user/blueLogo.jpg';
                }
            }
        }));
    }
    /**
     * @return {?}
     */
    checkUser() {
        return this.http.get(`./Api/user/IsUserAuthenticated`).map((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            // Update the subject with the data that's just been retrieved (see the constructor).
            this.authUserChange.next();
            // Return the response
            return response;
        }), (/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            // Anything that's not 200, is an error
            return false;
        }));
    }
    /**
     * @param {?} username
     * @param {?} password
     * @param {?} language
     * @return {?}
     */
    getAuthToken(username, password, language) {
        /** @type {?} */
        var user = { client_id: "sizingClient", client_secret: "secret", grant_type: 'password', username: "username", password: "password", scope: 'obApi' };
        return this.http.post("./Api/identity/connect/token", `username=${username}&password=${password}&culture=${language}&grant_type=password&client_id=sizingsuite_v2_clientid&client_secret=sizingsuite_v2_secret&scope=sizingsuite_v2_api_all_scope offline_access`, { headers: this.loginHeaders })
            .map((/**
         * @param {?} responseObj
         * @return {?}
         */
        (responseObj) => {
            localStorage.clear();
            localStorage.setItem("userObj", `${JSON.stringify(responseObj)}`);
            // Update the subject with the data that's just been retrieved (see the constructor).
            this.authUserChange.next();
            return true;
        }), (/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            throw error;
        }));
    }
    /**
     * @param {?} username
     * @return {?}
     */
    impersonateUser(username) {
        return this.http.post("./Api/identity/Api/Token", `username=${username}&grant_type=impersonate_user`, { headers: this.loginHeaders })
            .map((/**
         * @param {?} responseObj
         * @return {?}
         */
        (responseObj) => {
            localStorage.clear();
            // Override the original token with the new
            localStorage.setItem("userObj", `${JSON.stringify(responseObj)}`);
            // Update the subject with the data that's just been retrieved (see the constructor).
            this.authUserChange.next();
            return true;
        }), (/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            throw error;
        }));
    }
    /**
     * @return {?}
     */
    logoutUser() {
        localStorage.clear();
        /** @type {?} */
        var authenticatedUser = new AuthenticatedUser();
        authenticatedUser.name = null;
        authenticatedUser.isLoggedIn = false;
        authenticatedUser.impersonator = null;
        authenticatedUser.isImpersonating = false;
        // Update the subject with the data that's just been retrieved (see the constructor).
        this.authUserChange.next(authenticatedUser);
        console.info("User logged out");
    }
    /**
     * @return {?}
     */
    endImpersonation() {
        return this.http.post("./Api/identity/Token", `grant_type=revoke_impersonation`, { headers: this.loginHeaders })
            .map((/**
         * @param {?} responseObj
         * @return {?}
         */
        (responseObj) => {
            localStorage.clear();
            // Override the original token with the new
            localStorage.setItem("userObj", `${JSON.stringify(responseObj)}`);
            // Update the subject with the data that's just been retrieved (see the constructor).
            this.authUserChange.next();
            return true;
        }), (/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            throw error;
        }));
    }
}
AuthenticationService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
AuthenticationService.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    AuthenticationService.prototype.loginHeaders;
    /** @type {?} */
    AuthenticationService.prototype.authenticatedUser;
    /** @type {?} */
    AuthenticationService.prototype.authUserChange;
    /**
     * @type {?}
     * @private
     */
    AuthenticationService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/authentication/authentication.guard.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * An authentication guard that decides if a child route can be activated.
 */
class AuthenticationGuard {
    /**
     * @param {?} router
     * @param {?} authenticationService
     */
    constructor(router, authenticationService) {
        this.router = router;
        this.authenticationService = authenticationService;
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    canActivateChild(route, state) {
        return this.authenticationService.checkUser().map((/**
         * @param {?} result
         * @return {?}
         */
        result => {
            if (result === false) {
                // not logged in so redirect to login page with the return url and return false
                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            }
            return result;
        })).catch((/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            if (error.status === 401) {
                this.authenticationService.logoutUser();
                // not logged in so redirect to login page with the return url and return false
                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            }
            else {
                // Any other error from the server regardless of error code is an internal error to the front-end, so redirect to 500 page.
                this.router.navigate(['/500'], { queryParams: { returnUrl: state.url } });
            }
            return Observable.of(false);
        }));
    }
}
AuthenticationGuard.decorators = [
    { type: Injectable }
];
/** @nocollapse */
AuthenticationGuard.ctorParameters = () => [
    { type: Router },
    { type: AuthenticationService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    AuthenticationGuard.prototype.router;
    /**
     * @type {?}
     * @private
     */
    AuthenticationGuard.prototype.authenticationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/authentication/authentication.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthenticationModule {
}
AuthenticationModule.decorators = [
    { type: NgModule, args: [{
                imports: [HttpClientModule],
                declarations: [],
                providers: [AuthenticationService, AuthenticationGuard],
                exports: []
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/directives/sparkline/sparkline.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SparklineDirective {
    /**
     * @param {?} el
     */
    constructor(el) {
        this.el = el;
        // generate a unique resize event so we can detach later
        this.resizeEventId = 'resize.sparkline' + 1324;
        // this.$element = $(el.nativeElement);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.initSparkLine();
    }
    /**
     * @return {?}
     */
    initSparkLine() {
        /** @type {?} */
        let options = this.sparkline;
        /** @type {?} */
        let data = this.$element.data();
        if (!options) { // if no scope options, try with data attributes
            options = data;
        }
        else {
            if (data) { // data attributes overrides scope options
                options = $.extend({}, options, data);
            }
        }
        options.type = options.type || 'bar'; // default chart is bar
        options.disableHiddenCheck = true;
        this.runSparkline(options);
        if (options.resize) {
            $(window).on(this.resizeEventId, (/**
             * @return {?}
             */
            () => {
                this.runSparkline(options);
            }));
        }
    }
    /**
     * @param {?} options
     * @return {?}
     */
    runSparkline(options) {
        if (this.values) {
            if (typeof this.values === 'string')
                this.values = this.values.split(','); // assume comma separated string
            this.$element.sparkline(this.values, options);
        }
        else {
            this.$element.sparkline('html', options);
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        $(window).off(this.resizeEventId);
    }
}
SparklineDirective.decorators = [
    { type: Directive, args: [{
                selector: '[sparkline]'
            },] }
];
/** @nocollapse */
SparklineDirective.ctorParameters = () => [
    { type: ElementRef }
];
SparklineDirective.propDecorators = {
    sparkline: [{ type: Input }],
    values: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    SparklineDirective.prototype.sparkline;
    /** @type {?} */
    SparklineDirective.prototype.values;
    /**
     * @type {?}
     * @private
     */
    SparklineDirective.prototype.resizeEventId;
    /**
     * @type {?}
     * @private
     */
    SparklineDirective.prototype.$element;
    /**
     * @type {?}
     * @private
     */
    SparklineDirective.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/colors/colors.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ColorsService {
    constructor() {
        this.APP_COLORS = {
            'primary': '#5d9cec',
            'success': '#27c24c',
            'info': '#23b7e5',
            'warning': '#ff902b',
            'danger': '#f05050',
            'inverse': '#131e26',
            'green': '#37bc9b',
            'pink': '#f532e5',
            'purple': '#7266ba',
            'dark': '#3a3f51',
            'yellow': '#fad732',
            'gray-darker': '#232735',
            'gray-dark': '#3a3f51',
            'gray': '#dde6e9',
            'gray-light': '#e4eaec',
            'gray-lighter': '#edf1f2'
        };
    }
    /**
     * @param {?} name
     * @return {?}
     */
    byName(name) {
        // console.log(name +' -> ' + this.APP_COLORS[name])
        return (this.APP_COLORS[name] || '#fff');
    }
}
ColorsService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ColorsService.ctorParameters = () => [];
if (false) {
    /** @type {?} */
    ColorsService.prototype.APP_COLORS;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/directives/checkall/checkall.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CheckallDirective {
    /**
     * @param {?} el
     */
    constructor(el) {
        //let $element = $(el.nativeElement);
        this.el = el;
        //$element.on('change', function() {
        //    let index = $element.index() + 1,
        //        checkbox = $element.find('input[type="checkbox"]'),
        //        table = $element.parents('table');
        //    // Make sure to affect only the correct checkbox column
        //    table.find('tbody > tr > td:nth-child(' + index + ') input[type="checkbox"]')
        //        .prop('checked', checkbox[0].checked);
        //});
    }
}
CheckallDirective.decorators = [
    { type: Directive, args: [{
                selector: '[checkAll]'
            },] }
];
/** @nocollapse */
CheckallDirective.ctorParameters = () => [
    { type: ElementRef }
];
if (false) {
    /** @type {?} */
    CheckallDirective.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/directives/now/now.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NowDirective {
    /**
     * @param {?} element
     */
    constructor(element) {
        this.element = element;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.updateTime();
        this.intervalId = setInterval(this.updateTime.bind(this), 1000);
    }
    /**
     * @return {?}
     */
    updateTime() {
        //let dt = moment().format(this.format);
        //this.element.nativeElement.innerHTML = dt;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        clearInterval(this.intervalId);
    }
}
NowDirective.decorators = [
    { type: Directive, args: [{
                selector: '[now]'
            },] }
];
/** @nocollapse */
NowDirective.ctorParameters = () => [
    { type: ElementRef }
];
NowDirective.propDecorators = {
    format: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    NowDirective.prototype.format;
    /** @type {?} */
    NowDirective.prototype.intervalId;
    /** @type {?} */
    NowDirective.prototype.element;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/directives/scrollable/scrollable.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ScrollableDirective {
    /**
     * @param {?} element
     */
    constructor(element) {
        this.element = element;
        this.defaultHeight = 250;
        this.defaultWidth = '100%';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        //$(this.element.nativeElement).slimScroll({
        //  height: (this.height || this.defaultHeight),
        //  width: (this.width || this.defaultWidth)
        //});
    }
}
ScrollableDirective.decorators = [
    { type: Directive, args: [{
                selector: 'scrollable'
            },] }
];
/** @nocollapse */
ScrollableDirective.ctorParameters = () => [
    { type: ElementRef }
];
ScrollableDirective.propDecorators = {
    height: [{ type: Input }],
    width: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ScrollableDirective.prototype.height;
    /** @type {?} */
    ScrollableDirective.prototype.defaultHeight;
    /** @type {?} */
    ScrollableDirective.prototype.width;
    /** @type {?} */
    ScrollableDirective.prototype.defaultWidth;
    /** @type {?} */
    ScrollableDirective.prototype.element;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/directives/jqcloud/jqcloud.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class JqcloudDirective {
    // flag to not update before plugin was initialized
    /**
     * @param {?} element
     */
    constructor(element) {
        this.initialized = false; // flag to not update before plugin was initialized
        // this.$elem = $(element.nativeElement);
        this.options = $.fn.jQCloud.defaults.get();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        let opts = {};
        if (this.width) {
            opts.width = this.width;
        }
        if (this.height) {
            opts.height = this.height;
        }
        if (this.steps) {
            opts.steps = this.steps;
        }
        $.extend(this.options, opts);
        this.$elem.jQCloud(this.words, opts);
        this.initialized = true;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (this.initialized && this.words && changes['words']) {
            this.$elem.jQCloud('update', this.words);
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.$elem.jQCloud('destroy');
    }
}
JqcloudDirective.decorators = [
    { type: Directive, args: [{
                selector: '[jqcloud]'
            },] }
];
/** @nocollapse */
JqcloudDirective.ctorParameters = () => [
    { type: ElementRef }
];
JqcloudDirective.propDecorators = {
    words: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    steps: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    JqcloudDirective.prototype.words;
    /** @type {?} */
    JqcloudDirective.prototype.width;
    /** @type {?} */
    JqcloudDirective.prototype.height;
    /** @type {?} */
    JqcloudDirective.prototype.steps;
    /** @type {?} */
    JqcloudDirective.prototype.$elem;
    /** @type {?} */
    JqcloudDirective.prototype.options;
    /** @type {?} */
    JqcloudDirective.prototype.initialized;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/directives/numberOnly/numberonly.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NumberOnlyDirective {
    /**
     * @param {?} el
     */
    constructor(el) {
        this.el = el;
        // Allow decimal numbers and negative values
        this.regex = new RegExp(/^-?[0-9]+(\.[0-9]*){0,1}$/g);
        // Allow key codes for special events. Reflect :
        // Backspace, tab, end, home
        this.specialKeys = ['Backspace', 'Tab', 'End', 'Home', '-'];
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyDown(event) {
        // Allow Backspace, tab, end, and home keys
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        //let current: string = this.el.nativeElement.value;
        //let next: string = current.concat(event.key);
        //if (next && !String(next).match(this.regex)) {
        // event.preventDefault();
        //}
    }
}
NumberOnlyDirective.decorators = [
    { type: Directive, args: [{
                selector: '[numberOnly]'
            },] }
];
/** @nocollapse */
NumberOnlyDirective.ctorParameters = () => [
    { type: ElementRef }
];
NumberOnlyDirective.propDecorators = {
    onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    NumberOnlyDirective.prototype.regex;
    /**
     * @type {?}
     * @private
     */
    NumberOnlyDirective.prototype.specialKeys;
    /**
     * @type {?}
     * @private
     */
    NumberOnlyDirective.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/directives/twodigitdecimalnumber/twodigitdecimalnumber.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TwoDigitDecimalNumberDirective {
    /**
     * @param {?} el
     */
    constructor(el) {
        this.el = el;
        // Allow decimal numbers and negative values
        this.regex = new RegExp(/^\d*\.?\d{0,2}$/g);
        // Allow key codes for special events. Reflect :
        // Backspace, tab, end, home
        this.specialKeys = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight'];
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyDown(event) {
        //console.log(this.el.nativeElement.value);
        // Allow Backspace, tab, end, and home keys
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        //let current: string = this.el.nativeElement.value;
        //let next: string = current.concat(event.key);
        //if (next && !String(next).match(this.regex)) {
        //event.preventDefault();
        //}
    }
}
TwoDigitDecimalNumberDirective.decorators = [
    { type: Directive, args: [{
                selector: '[twoDigitDecimalNumber]'
            },] }
];
/** @nocollapse */
TwoDigitDecimalNumberDirective.ctorParameters = () => [
    { type: ElementRef }
];
TwoDigitDecimalNumberDirective.propDecorators = {
    onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    TwoDigitDecimalNumberDirective.prototype.regex;
    /**
     * @type {?}
     * @private
     */
    TwoDigitDecimalNumberDirective.prototype.specialKeys;
    /**
     * @type {?}
     * @private
     */
    TwoDigitDecimalNumberDirective.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/alerts/alerts.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AlertsComponent {
    constructor() {
        this.type = "success";
        this.message = null;
        this.autoClose = false;
        this.autoCloseTimeout = 10000;
        this.closeCallback = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.alertClass = `alert alert-${this.type} alert-dismissible ng-star-inserted`;
        /** @type {?} */
        let icon;
        switch (this.type) {
            case "danger": {
                icon = "exclamation-circle";
                break;
            }
            case "warning": {
                icon = "exclamation-circle";
                break;
            }
            case "info": {
                icon = "info-circle";
                break;
            }
            case "inverse": {
                icon = "info-circle";
                break;
            }
            default: {
                icon = "check-circle";
                break;
            }
        }
        this.alertIconClass = `fa fa-${icon}`;
        // Initialise an auto-close interval if it's been specified
        if (this.autoClose) {
            /** @type {?} */
            const interval = setTimeout((/**
             * @return {?}
             */
            () => {
                this.dismissAlert();
                clearInterval(interval);
            }), this.autoCloseTimeout);
        }
    }
    /**
     * @return {?}
     */
    dismissAlert() {
        this.message = null;
        this.closeCallback.emit();
    }
}
AlertsComponent.decorators = [
    { type: Component, args: [{
                selector: 'alert-block',
                exportAs: 'alert-block',
                template: "<div *ngIf=\"!!message\" [class]=\"alertClass\">\r\n    <button (click)=\"dismissAlert()\" class=\"close ng-star-inserted\" type=\"button\">\r\n        <span>&times;</span><span class=\"sr-only\">Close</span>\r\n    </button>\r\n    <span [class]=\"alertIconClass\"></span> {{message}}\r\n</div>",
                styles: [""]
            }] }
];
AlertsComponent.propDecorators = {
    type: [{ type: Input, args: ["type",] }],
    message: [{ type: Input, args: ["message",] }],
    autoClose: [{ type: Input, args: ["auto-close",] }],
    autoCloseTimeout: [{ type: Input, args: ["auto-close-timeout",] }],
    closeCallback: [{ type: Output, args: ["close-callback",] }]
};
if (false) {
    /** @type {?} */
    AlertsComponent.prototype.type;
    /** @type {?} */
    AlertsComponent.prototype.message;
    /** @type {?} */
    AlertsComponent.prototype.autoClose;
    /** @type {?} */
    AlertsComponent.prototype.autoCloseTimeout;
    /** @type {?} */
    AlertsComponent.prototype.closeCallback;
    /** @type {?} */
    AlertsComponent.prototype.alertClass;
    /** @type {?} */
    AlertsComponent.prototype.alertIconClass;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/alerts/alerts.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AlertsModule {
}
AlertsModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [AlertsComponent],
                exports: [AlertsComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/sizing-suite-modal/sizing-suite-modal.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SizingSuiteModalComponent {
    /**
     * @param {?} resolver
     */
    constructor(resolver) {
        this.resolver = resolver;
        this.modalTitle = "";
        this.loadedchildcomponentOpen = null;
        this.loadedchildcomponentSubmitCallback = null;
        this.modalOkText = "OK";
        this.modalOkIcon = "'fa fa-check'"; // default icon
        // default icon
        this.modalCancelText = "Cancel";
        this.modalCancelIcon = "'fa fa-times'"; // default icon
        // default icon
        this.modalCloseText = "Close";
        this.onContainerClick = new EventEmitter();
        this.modalCancel = new EventEmitter();
        this.modalOk = new EventEmitter();
        this.loadedchildcomponentSubmitIsDisabledFunction = new EventEmitter();
        this.closeOnSubmit = true;
        this.errorList = [];
        this.visible = false;
        this.visibleAnimate = false;
        this.showOnlyCloseButton = false;
        this.submitIsDisabled = false;
        this.init = false;
        this.successCallback = (/**
         * @return {?}
         */
        () => { console.info("OK has been called and closed!"); this.hideModal(100); });
        this.errorCallback = this.errorCallbackImplementation;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    open() {
        // Set all fields
        this.visible = true;
        this.errorList = [];
        console.info("Open has been called!");
        // Load a dynamic component, if it is specified
        if (!!this.loadedchildcomponentOpen) {
            this.loadDynamicComponent();
        }
        setTimeout((/**
         * @return {?}
         */
        () => this.visibleAnimate = true), 100);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onContainerClicked(event) {
        if (((/** @type {?} */ (event.target))).classList.contains("modal")) {
            this.onContainerClick.emit();
        }
    }
    /**
     * @param {?} errors
     * @return {?}
     */
    error(errors) {
        this.errorCallbackImplementation(errors);
    }
    /**
     * @return {?}
     */
    close() {
        console.info("Close has been called!");
        // Call the bespoke callback
        this.modalCancel.emit();
        this.hideModal(300);
    }
    /**
     * @return {?}
     */
    ok() {
        console.info("OK has been called!");
        // Call the bespoke callback if no dynamic component is loaded
        if (this.componentRef) {
            // To use a component reference, a callback function can be specified.
            if (typeof this.componentRef.instance[this.loadedchildcomponentSubmitCallback] !== "undefined") {
                /** @type {?} */
                const responseObj = this.componentRef.instance[this.loadedchildcomponentSubmitCallback]();
                // If the function return something (anything), then return it to the subsequent function.
                this.modalOk.emit(responseObj);
            }
            if (this.loadedchildcomponentOpen == "UserFeedbackComponent") {
                this.showOnlyCloseButton = true;
            }
        }
        else {
            // Callback for the parent node
            this.modalOk.emit();
        }
        if (this.closeOnSubmit) {
            this.hideModal(300);
        }
    }
    /**
     * @return {?}
     */
    isSubmitDisabledByChildComponent() {
        if (this.componentRef) {
            // To use a component reference, a callback function can be specified.
            if (typeof this.componentRef.instance['checkIfSubmitIsDisabled'] !== "undefined") {
                /** @type {?} */
                const responseObj = this.componentRef.instance['checkIfSubmitIsDisabled']();
                // If the function return something (anything), then return it to the subsequent function.
                this.loadedchildcomponentSubmitIsDisabledFunction.emit(responseObj);
                if (responseObj) {
                    this.submitIsDisabled = responseObj;
                }
                else {
                    // Default to enable the submit button on the Modal container component
                    this.submitIsDisabled = false;
                }
            }
            else {
                // Default to enable the submit button on the Modal container component
                this.submitIsDisabled = false;
            }
        }
        else {
            // Default to enable the submit button on the Modal container component
            this.submitIsDisabled = false;
        }
        return this.submitIsDisabled;
    }
    /**
     * @private
     * @return {?}
     */
    destroyComponentReference() {
        // Destroy any dynamic components that have been loaded
        if (!!this.componentRef) {
            console.info(`Destroying component reference: ${this.componentRef.instance.constructor.name}`);
            this.componentRef.destroy();
            this.componentRef = null;
            this.init = false;
        }
    }
    /**
     * @private
     * @param {?} timeout
     * @return {?}
     */
    hideModal(timeout) {
        this.visibleAnimate = false;
        //this will allow user feedback window to stay open for 5 more seconds to display thank you message
        if (timeout > 0) {
            /** @type {?} */
            let interval = setTimeout((/**
             * @return {?}
             */
            () => {
                this.visible = false;
                this.showOnlyCloseButton = false;
                // Destroy any dynamically loaded components
                this.destroyComponentReference();
                clearTimeout(interval);
            }), timeout);
        }
        else {
            this.visible = false;
            // Destroy any dynamically loaded components
            this.destroyComponentReference();
        }
    }
    /**
     * @private
     * @param {?} errors
     * @return {?}
     */
    errorCallbackImplementation(errors) {
        console.info("OK has been called with errors and not closed!");
        this.errorList = errors;
    }
    /**
     * @private
     * @return {?}
     */
    loadDynamicComponent() {
        if (!this.loadedchildcomponentOpen || this.init)
            return;
        /** @type {?} */
        var factories = Array.from(this.resolver['_factories'].keys());
        /** @type {?} */
        let factoryClass = (/** @type {?} */ (factories.find((/**
         * @param {?} x
         * @return {?}
         */
        (x) => x.name === this.loadedchildcomponentOpen))));
        /** @type {?} */
        const factory = this.resolver.resolveComponentFactory(factoryClass);
        /** @type {?} */
        const compRef = this.placeholderContainer.createComponent(factory);
        if (this.componentRef) {
            this.componentRef.destroy();
        }
        this.componentRef = compRef;
        this.init = true;
    }
}
SizingSuiteModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'sizing-suite-modal',
                exportAs: 'sizing-suite-modal',
                template: "<div (click)=\"onContainerClicked($event)\" class=\"modal fade\" tabindex=\"-1\" [style.display]=\"visible ? 'block' : 'none'\" [style.opacity]=\"visibleAnimate ? 1 : 0\" [ngClass]=\"{'show': visibleAnimate}\" >\r\n    \r\n    <div class=\"modal-dialog modal-lg\">\r\n      <div class=\"modal-content\">\r\n        <div class=\"modal-header\">\r\n          <button id=\"closeButton\" type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"close()\"><span aria-hidden=\"true\">&times;</span></button>\r\n          <h4 class=\"modal-title\">{{modalTitle}}</h4>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n          <div *ngIf=\"errorList.length > 0\" class=\"row\">\r\n            <div class=\"col-xs-12\">\r\n              <div class=\"alert alert-danger\">\r\n                <ul>\r\n                  <li *ngFor=\"let error of errorList\">{{error}}</li>\r\n                </ul>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"component-wrapper\">\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-12\">\r\n                <ng-content *ngIf=\"!componentRef\"></ng-content>\r\n                <div #componentLoaderPlaceholder></div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"modal-footer\" [hidden]=\"showOnlyCloseButton\">\r\n          <button id=\"cancelButton\" type=\"button\" class=\"btn btn-default\" (click)=\"close()\"><i class=\"{{modalCancelIcon}}\">  {{modalCancelText}}</i></button>\r\n          <button id=\"okButton\" [disabled]=\"isSubmitDisabledByChildComponent()\" type=\"button\" class=\"btn btn-primary\" (click)=\"ok()\"><i class=\"{{modalOkIcon}}\">  {{modalOkText}}</i></button>\r\n        </div>\r\n        <div class=\"modal-footer\" [hidden]=\"!showOnlyCloseButton\">\r\n          <button id=\"cancelButton\" type=\"button\" class=\"btn btn-default\" (click)=\"close()\"><i class=\"{{modalCancelIcon}}\">  {{modalCloseText}}</i></button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n</div>\r\n",
                styles: [".modal-body{overflow-y:auto;overflow-x:hidden;max-height:700px}.modal-dialog{top:185px}.modal{position:fixed;background-color:rgba(86,86,86,.4)}"]
            }] }
];
/** @nocollapse */
SizingSuiteModalComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver }
];
SizingSuiteModalComponent.propDecorators = {
    modalTitle: [{ type: Input, args: ["modal-title",] }],
    loadedchildcomponentOpen: [{ type: Input, args: ["loaded-child-component-onOpen",] }],
    loadedchildcomponentSubmitCallback: [{ type: Input, args: ["loaded-child-component-submit-callback",] }],
    modalOkText: [{ type: Input, args: ["modal-ok-text",] }],
    modalOkIcon: [{ type: Input, args: ["modal-ok-icon",] }],
    modalCancelText: [{ type: Input, args: ["modal-cancel-text",] }],
    modalCancelIcon: [{ type: Input, args: ["modal-cancel-icon",] }],
    modalCloseText: [{ type: Input, args: ["modal-close-text",] }],
    onContainerClick: [{ type: Output, args: ["on-container-click",] }],
    modalCancel: [{ type: Output, args: ["modal-cancel",] }],
    modalOk: [{ type: Output, args: ["modal-ok",] }],
    loadedchildcomponentSubmitIsDisabledFunction: [{ type: Output, args: ["loaded-child-component-submit-is-disabled-function",] }],
    closeOnSubmit: [{ type: Input, args: ["close-on-submit",] }],
    placeholderContainer: [{ type: ViewChild, args: ["componentLoaderPlaceholder", { read: ViewContainerRef, static: false },] }]
};
if (false) {
    /** @type {?} */
    SizingSuiteModalComponent.prototype.modalTitle;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.loadedchildcomponentOpen;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.loadedchildcomponentSubmitCallback;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.modalOkText;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.modalOkIcon;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.modalCancelText;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.modalCancelIcon;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.modalCloseText;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.onContainerClick;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.modalCancel;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.modalOk;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.loadedchildcomponentSubmitIsDisabledFunction;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.closeOnSubmit;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.placeholderContainer;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.errorList;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.successCallback;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.errorCallback;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.visible;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.visibleAnimate;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.showOnlyCloseButton;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.submitIsDisabled;
    /** @type {?} */
    SizingSuiteModalComponent.prototype.componentRef;
    /**
     * @type {?}
     * @private
     */
    SizingSuiteModalComponent.prototype.init;
    /**
     * @type {?}
     * @private
     */
    SizingSuiteModalComponent.prototype.resolver;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/sizing-suite-modal/sizing-suite-modal.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SizingSuiteModalModule {
}
SizingSuiteModalModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [SizingSuiteModalComponent],
                exports: [SizingSuiteModalComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/translation/translation.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TranslationService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
        this.displayGroup = null;
        this.layoutDisplayGroup = null;
        this.displayGroupChange = new BehaviorSubject(null);
        // When the class in constructed, initialise the subject so that whenever it is called, its subscriber resolves the result to the current Display Group object.
        this.displayGroupChange.subscribe((/**
         * @param {?} newDisplayGroup
         * @return {?}
         */
        newDisplayGroup => {
            this.displayGroup = newDisplayGroup;
            console.log("Translation Service Const called");
        }));
    }
    /**
     * Gets Translated DisplayGroup (normally for a page).
     * @param {?} displayGroupName
     * @return {?}
     */
    getTranslatedDisplayGroup(displayGroupName) {
        if (!!displayGroupName) {
            return this.http.get(`./Api/Translation/GetTranslatedDisplayGroup/${displayGroupName}`)
                .map((/**
             * @param {?} displayGroupData
             * @return {?}
             */
            (displayGroupData) => {
                // Publish the next set of changes to the subject.
                this.displayGroupChange.next(displayGroupData);
                return displayGroupData;
            }));
        }
        return Observable.of(null);
    }
    /**
     * Gets Translated Layout DisplayGroup (normally for a page).
     * @return {?}
     */
    getLayoutTranslatedDisplayGroup() {
        return this.http.get(`./Api/Translation/GetTranslatedDisplayGroup/LAYOUT`).map((/**
         * @param {?} displayGroupData
         * @return {?}
         */
        (displayGroupData) => {
            this.layoutDisplayGroup = displayGroupData;
            return displayGroupData;
        }));
    }
    /**
     * Manages the specified transaltion changes.
     * @param {?} displayGroup
     * @return {?}
     */
    manageTranslationTexts(displayGroup) {
        return this.http.post(`./Api/Translation/InsertUpdateDeleteTranslationText`, { displayGroup: displayGroup });
    }
    /**
     * @param {?} listName
     * @param {?} valueString
     * @return {?}
     */
    getEnumerationMasterKeyText(listName, valueString) {
        /** @type {?} */
        let specificList = this.displayGroup.enumerations.filter((/**
         * @param {?} us
         * @return {?}
         */
        us => us.enumerationName === (listName) && us.opCoOverride === false))[0];
        /** @type {?} */
        let masterKeyText = specificList.enumerationDefinitions.filter((/**
         * @param {?} s
         * @return {?}
         */
        s => s.value === valueString))[0].masterTextKey;
        return masterKeyText;
    }
}
TranslationService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
TranslationService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ TranslationService.ngInjectableDef = ɵɵdefineInjectable({ factory: function TranslationService_Factory() { return new TranslationService(ɵɵinject(HttpClient)); }, token: TranslationService, providedIn: "root" });
if (false) {
    /** @type {?} */
    TranslationService.prototype.displayGroup;
    /** @type {?} */
    TranslationService.prototype.layoutDisplayGroup;
    /** @type {?} */
    TranslationService.prototype.displayGroupChange;
    /**
     * @type {?}
     * @private
     */
    TranslationService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/translation/translate.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TranslatePipe {
    /**
     * @param {?} translationService
     */
    constructor(translationService) {
        this.translationService = translationService;
    }
    /**
     * @param {?} value
     * @param {?=} isLayout
     * @return {?}
     */
    transform(value, isLayout = false) {
        /** @type {?} */
        let result;
        // Normalise isLayout
        isLayout = !!isLayout;
        if (isLayout) {
            result = this.translationService.layoutDisplayGroup; // loaded layoutDisplayGroup.
        }
        else {
            result = this.translationService.displayGroup; // loaded displayGroup.
        }
        /** @type {?} */
        const defaultTrans = `** ${value} **`;
        if (!!result) {
            /** @type {?} */
            const translation = result.translations.find((/**
             * @param {?} t
             * @return {?}
             */
            t => t.masterTextKey === value));
            if (!translation) {
                if (value.indexOf('DEBUG_') == 0) {
                    return ''; // show empty text string for missing DEBUG_VISUAL_IDENTIFIER_LABEL_x keys
                }
                // log missing translations
                //console.log(`-- Missing MasterTextKey: DisplayGroupId=${result.id}, DisplayGroupName=${result.name}, value=${value}, isLayout=${isLayout}, translationText=${!!translation ? translation.translationText : defaultTrans}`);
                //// SQL helpers
                //console.log(` SELECT * FROM [SizingSuite_V2].[trans].[MasterTexts] WHERE  DefaultText LIKE '${value.replace('_', ' ')}%' OR [Key] LIKE '${value.replace(' ', '_').toUpperCase()}%'  -- INSERT #MasterTextData SELECT '${value.replace(' ', '_').toUpperCase()}', '${value.replace('_', ' ')}'  `);
                //console.log(` SELECT * FROM [SizingSuite_V2].[trans].[DisplayGroups_MasterTexts] WHERE  [MasterTextKey] LIKE '${value.replace(' ', '_')}%' AND DisplayGroupId=${result.id} `);
                //console.log(`-- INSERT #MasterTexts SELECT N'${value.replace(' ', '_').toUpperCase()}', N'${result.name}' `) ;
                //console.log(`-- INSERT #DisplayGroups_MasterTexts SELECT 0, (SELECT TOP 1 DG.Id FROM trans.DisplayGroups DG WHERE DG.Name = N'${result.name}'), N'${value.replace(' ', '_').toUpperCase()}', (SELECT TOP 1 TT.Id FROM trans.TextTypes TT WHERE TT.Name = 'Word') ; `);
                /** @type {?} */
                let listTranslationText = defaultTrans;
                // Try to find a match in the lists on page:
                for (let e of this.translationService.displayGroup.enumerations) {
                    /** @type {?} */
                    var ed = e.enumerationDefinitions.find((/**
                     * @param {?} ed
                     * @return {?}
                     */
                    ed => ed.masterTextKey == value && !!ed.translationText));
                    if (!!ed) {
                        listTranslationText = JSON.parse(JSON.stringify(ed.translationText)); // clone string or it will be linked to the trans of the list item in the UI and reflect any changes.
                        break;
                    }
                }
                return !!listTranslationText ? listTranslationText : defaultTrans; // find and return first match
            }
            return !!translation ? translation.translationText : defaultTrans;
        }
        if (value.indexOf('DEBUG_') == 0) {
            return ''; // show empty text string for missing DEBUG_VISUAL_IDENTIFIER_LABEL_x keys
        }
        // console.log(`value=${value}, isLayout=${isLayout}, defaultTrans=${defaultTrans}`);
        return defaultTrans;
    }
}
TranslatePipe.decorators = [
    { type: Pipe, args: [{
                name: 'translate',
                pure: false
            },] }
];
/** @nocollapse */
TranslatePipe.ctorParameters = () => [
    { type: TranslationService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    TranslatePipe.prototype.translationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/translation/translation.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The DisplayGroup model class.
 */
class DisplayGroup {
}
if (false) {
    /**
     * Gets or sets the DisplayGroup Id.
     * @type {?}
     */
    DisplayGroup.prototype.id;
    /**
     * Gets or sets the DisplayGroup name.
     * @type {?}
     */
    DisplayGroup.prototype.name;
    /**
     * Gets or sets the Language Id.
     * @type {?}
     */
    DisplayGroup.prototype.languageId;
    /**
     * Gets or sets the Translations.
     * @type {?}
     */
    DisplayGroup.prototype.translations;
    /**
     * Gets or sets the Enumerations.
     * @type {?}
     */
    DisplayGroup.prototype.enumerations;
}
/**
 * The Translation model class.
 */
class Translation {
}
if (false) {
    /**
     * Gets or sets the masterTextKey.
     * @type {?}
     */
    Translation.prototype.masterTextKey;
    /**
     * Gets or sets the translationText.
     * @type {?}
     */
    Translation.prototype.translationText;
    /**
     * Gets or sets the translationText.
     * @type {?}
     */
    Translation.prototype.defaultText;
    /**
     * Gets or sets the textTypeId (Enum).
     * @type {?}
     */
    Translation.prototype.textTypeId;
}
/**
 * The Enumeration model class.
 */
class Enumeration {
}
if (false) {
    /**
     * Gets or sets the enumerationName.
     * @type {?}
     */
    Enumeration.prototype.enumerationName;
    /**
     * Gets or sets the opCoOverride.
     * @type {?}
     */
    Enumeration.prototype.opCoOverride;
    /**
     * Gets or sets the enumerationDefinitions.
     * @type {?}
     */
    Enumeration.prototype.enumerationDefinitions;
}
/**
 * The EnumerationDefinition model class.
 */
class EnumerationDefinition {
    constructor() {
        /**
         * Gets or sets the extraPreText.
         * Usefull to augment prepend data, such as the Nomenclature code helper in list items (CSG).
         */
        this.extraPreText = '';
        /**
         * Gets or sets the extraPostText.
         * Usefull to augment append data, such as pricing helpers in list items (CSG).
         */
        this.extraPostText = '';
    }
}
if (false) {
    /**
     * Gets item ID.
     * @type {?}
     */
    EnumerationDefinition.prototype.id;
    /**
     * Gets or sets the masterTextKey.
     * @type {?}
     */
    EnumerationDefinition.prototype.masterTextKey;
    /**
     * Gets or sets the defaultText.
     * @type {?}
     */
    EnumerationDefinition.prototype.defaultText;
    /**
     * Gets or sets the translationText.
     * @type {?}
     */
    EnumerationDefinition.prototype.translationText;
    /**
     * Gets or sets the extraPreText.
     * Usefull to augment prepend data, such as the Nomenclature code helper in list items (CSG).
     * @type {?}
     */
    EnumerationDefinition.prototype.extraPreText;
    /**
     * Gets or sets the extraPostText.
     * Usefull to augment append data, such as pricing helpers in list items (CSG).
     * @type {?}
     */
    EnumerationDefinition.prototype.extraPostText;
    /**
     * Gets or sets the value.
     * @type {?}
     */
    EnumerationDefinition.prototype.value;
    /**
     * Gets or sets the sequence.
     * @type {?}
     */
    EnumerationDefinition.prototype.sequence;
    /**
     * Gets or sets the isDeleted.
     * @type {?}
     */
    EnumerationDefinition.prototype.isDeleted;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/user-profile/user-profile.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UserProfileService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @return {?}
     */
    getUserDetails() {
        return this.http.get("./Api/User/GetUserDetails");
    }
    /**
     * @param {?} user
     * @return {?}
     */
    updateUserDetails(user) {
        return this.http.post("./Api/User/UpdateUserDetails", user);
    }
    /**
     * @param {?} userName
     * @param {?} currentPassword
     * @param {?} newPassword
     * @param {?} confirmPassword
     * @return {?}
     */
    resetPassword(userName, currentPassword, newPassword, confirmPassword) {
        return this.http.post("./Api/User/ResetPassword/", { UserName: userName, CurrentPassword: currentPassword, NewPassword: newPassword, ConfirmPassword: confirmPassword });
    }
    /**
     * Register current user login entry.
     * @return {?}
     */
    logUserLogin() {
        return this.http.get(`./Api/User/LogUserLogin`);
    }
}
UserProfileService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
UserProfileService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ UserProfileService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UserProfileService_Factory() { return new UserProfileService(ɵɵinject(HttpClient)); }, token: UserProfileService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    UserProfileService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/admin/admin.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AdminService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
        this.vettedUsers = [];
        this.vettedUsersChange = new Subject();
        // When the class in constructed, initialise the subject so that whenever it is called, its subscriber resolves the result to the current vetted users object.
        this.vettedUsersChange.subscribe((/**
         * @param {?} vettedUsers
         * @return {?}
         */
        vettedUsers => {
            this.vettedUsers = vettedUsers;
        }));
    }
    /**
     * Checks whether or not the provided username exists.
     * @param {?} username
     * @return {?}
     */
    checkUsernameExists(username) {
        return this.http.post(`./Api/User/CheckUsernameExists`, { Username: username });
    }
    /**
     * Checks whether or not the provided email address exists.
     * @param {?} email
     * @return {?}
     */
    checkEmailExists(email) {
        return this.http.post(`./Api/User/CheckEmailExists/`, { Email: email });
    }
    /**
     * Registers the specified user.
     * @param {?} userData
     * @return {?}
     */
    registerUser(userData) {
        return this.http.post(`./Api/User/Register/`, userData);
    }
    /**
     * Gets all supported currencies.
     * @return {?}
     */
    getCurrencyData() {
        this.currenciesPending = true;
        return this.http.get(`./Api/Admin/GetCurrencyData`).pipe(map((/**
         * @param {?} currencies
         * @return {?}
         */
        (currencies) => {
            this.currenciesPending = false;
            return currencies;
        })));
    }
    /**
     * Gets all supported languages.
     * @return {?}
     */
    getLanguages() {
        return this.http.get(`./Api/Admin/GetLanguages`);
    }
    /**
     * Gets all countries.
     * @return {?}
     */
    getCountries() {
        return this.http.get(`./Api/Admin/GetCountries`);
    }
    /**
     * Gets all operating companies.
     * @return {?}
     */
    getOperatingCompanies() {
        return this.http.get(`./Api/Admin/GetOperatingCompanies`);
    }
    /**
     * Gets all the module group that requires preferences.
     * @return {?}
     */
    getModuleRequiredPreferences() {
        return this.http.get(`./Api/Admin/GetModuleRequiredPreferences`);
    }
    /**
     * Gets all accessible modules.
     * @return {?}
     */
    getAccessibleModuleGroups() {
        return this.http.get(`./Api/Admin/GetAccessibleModuleGroups`);
    }
    /**
     * Gets all accessible modules for the current operating company.
     * @param {?} moduleName
     * @return {?}
     */
    getModuleAccessByModuleName(moduleName) {
        return this.http.get(`./Api/Admin/GetAccessibleModuleGroups/${moduleName}`);
    }
    /**
     * Gets all users regardless of their vetted type based on the provided module group Id.
     * @param {?} moduleGroupId The module group Id.
     * @return {?}
     */
    getAllVettedTypeUsersByModuleGroupId(moduleGroupId) {
        return this.http.get(`./Api/Admin/GetAllVettedTypeUsersByModuleGroupId/${moduleGroupId}`).map(this.mapUserObj).map((/**
         * @param {?} vettedUsers
         * @return {?}
         */
        vettedUsers => {
            // Assign the new users to the subject.
            this.vettedUsersChange.next(vettedUsers);
        }));
    }
    /**
     *
     * @private
     * @param {?} vettedUsers
     * @return {?}
     */
    mapUserObj(vettedUsers) {
        if (!vettedUsers || vettedUsers.length === 0) {
            return [];
        }
        // Rationalise the UI properties here.
        vettedUsers.forEach((/**
         * @param {?} vu
         * @return {?}
         */
        vu => { vu.hideFromDisplay = false; }));
        return vettedUsers;
    }
    /**
     * @param {?} userToChange
     * @param {?} isVetted
     * @return {?}
     */
    updateVettedUser(userToChange, isVetted) {
        // Go through each user
        this.vettedUsers.forEach((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            // If a match is found, update the vetted status.
            if (user.userId === userToChange.userId) {
                user.isVetted = isVetted;
                // For vetted users, default access level to one star (No Pricing).
                if (isVetted) {
                    user.accessLevel = 1;
                }
            }
        }));
        // Update the subject
        this.vettedUsersChange.next(this.vettedUsers);
    }
    /**
     * Searches all vetted/non-vetted users for the provided search term.
     * @param {?} searchVal The search term.
     * @return {?}
     */
    searchVettedUsers(searchVal) {
        // Searching through the global object means
        // that no - user gets accidently removed and
        // retains the original array of users.
        this.vettedUsers.forEach((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            // Rationalise the search term
            searchVal = searchVal.toLowerCase();
            // Reset the user to its original state.
            user.hideFromDisplay = true;
            // Exclude users from display if they do not match the provided (valid) search term.
            // Username
            if (!!user && !!user.username) {
                if (user.username.toLowerCase().indexOf(searchVal) > -1 || !searchVal) {
                    user.hideFromDisplay = false;
                }
            }
            // First name
            if (!!user && !!user.firstname) {
                if (user.firstname.toLowerCase().indexOf(searchVal) > -1 || !searchVal) {
                    user.hideFromDisplay = false;
                }
            }
            // Last name
            if (!!user && !!user.lastname) {
                if (user.lastname.toLowerCase().indexOf(searchVal) > -1 || !searchVal) {
                    user.hideFromDisplay = false;
                }
            }
            // First & Last name
            if (!!user && !!user.firstname && !!user.lastname) {
                if (`${user.firstname} ${user.lastname}`.toLowerCase().indexOf(searchVal) > -1 || !searchVal) {
                    user.hideFromDisplay = false;
                }
            }
            // Email
            if (!!user && !!user.email) {
                if (user.email.toLowerCase().indexOf(searchVal) > -1 || !searchVal) {
                    user.hideFromDisplay = false;
                }
            }
        }));
        // Update the subject
        this.vettedUsersChange.next(this.vettedUsers);
    }
    /**
     * @param {?} user
     * @return {?}
     */
    deleteUser(user) {
        return this.http.post(`./Api/Admin/DeleteUser/${user}`, user);
    }
    /**
     * @param {?} isVetted
     * @param {?} moduleGroupId
     * @return {?}
     */
    manageModuleAccess(isVetted, moduleGroupId) {
        // Only send the users that have been marked as isVetted = true
        return this.http.post(`./Api/Admin/ManageVettedUsersForModule/${isVetted}/${moduleGroupId}`, this.vettedUsers.filter((/**
         * @param {?} vu
         * @return {?}
         */
        vu => vu.isVetted)));
    }
    /**
     * Gets all supported currencies.
     * @param {?} moduleGroupId
     * @return {?}
     */
    getManufacturerData(moduleGroupId) {
        return this.http.get(`./Api/Admin/GetManufacturersData/${moduleGroupId}`);
    }
    /**
     * Updates all enumeration module preferences.
     * @param {?} enumerations
     * @return {?}
     */
    manageEnumerationModulePreferences(enumerations) {
        return this.http.post(`./Api/Admin/ManageEnumerationModulePreferences`, enumerations);
    }
    /**
     * Updates all module preferences.
     * @param {?} modPrefs
     * @return {?}
     */
    manageModulePreferences(modPrefs) {
        return this.http.post(`./Api/Admin/ManageModulePreferences`, modPrefs);
    }
    /**
     * Gets the module access level for the current user.
     * @param {?} moduleGroupId
     * @return {?}
     */
    getUserModuleAccessDataByModuleGroupId(moduleGroupId) {
        return this.http.get(`./Api/Admin/GetUserModuleAccessDataByModuleGroupId/${moduleGroupId}`);
    }
}
AdminService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
AdminService.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /** @type {?} */
    AdminService.prototype.vettedUsers;
    /** @type {?} */
    AdminService.prototype.vettedUsersChange;
    /** @type {?} */
    AdminService.prototype.currenciesPending;
    /**
     * @type {?}
     * @private
     */
    AdminService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/translation/translation.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const swal$1 = (/** @type {?} */ (swal$3));
class TranslationComponent {
    /**
     * @param {?} translationService
     * @param {?} translatePipe
     * @param {?} userProfileService
     * @param {?} adminService
     * @param {?} fb
     */
    constructor(translationService, translatePipe, userProfileService, adminService, fb) {
        this.translationService = translationService;
        this.translatePipe = translatePipe;
        this.userProfileService = userProfileService;
        this.adminService = adminService;
        this.fb = fb;
        this.parentSubmitIsDisabled = true; // Modal parent container component submit button state (enabled/disabled)
        // Modal parent container component submit button state (enabled/disabled)
        this.cloneDeep = cloneDeep_;
        // The active display group on the content page
        this.rows = []; // Display Data in the UI grid/table (filtered/sorted)
        // Display Data in the UI grid/table (filtered/sorted)
        this.rowsEnum = []; // Initial Enumeration translations collection
        // Initial Enumeration translations collection
        this.rowsBackingData = []; // Current state of all the backing data rows for the UI, latest changes.
        // Current state of all the backing data rows for the UI, latest changes.
        this.editing = {}; // Edited row indexe, forced to only 1 at a time.
        this.selected = [];
        this.changedTranslations = [];
        this.changedEnumerationTranslations = [];
        this.languageName = "-";
    }
    /**
     * @param {?} cb
     * @return {?}
     */
    fetchTranslations(cb) {
        cb(JSON.parse(JSON.stringify(this.displayGroup.translations)));
    }
    /**
     * @param {?} cb
     * @return {?}
     */
    fetchEnumerations(cb) {
        cb(JSON.parse(JSON.stringify(this.displayGroup.enumerations)));
        this.languageIsoNameControl = new FormControl('');
        this.transForm = this.fb.group({
            languageIsoName: this.languageIsoNameControl
        });
    }
    /**
     * Get the Active Display Gropup Translations, the translation changes for the LAYOUT display group or for a regular display group?
     * @return {?}
     */
    getActiveDisplayGropup() {
        return (this.translationService.displayGroup.name === "LAYOUT") ? this.translationService.layoutDisplayGroup : this.translationService.displayGroup; // loaded displayGroup.
    }
    /**
     * Support this method is you require Modal Submit button state handling. ie. disable the submit button if any validation errors exist.
     * @return {?}
     */
    checkIfSubmitIsDisabled() {
        return this.parentSubmitIsDisabled;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.displayGroup = this.getActiveDisplayGropup();
        this.fetchEnumerations((/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            // cache translation data
            this.rowsEnum = this.cloneDeep(data);
        }));
        this.fetchTranslations((/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            // cache translation data
            this.rowsBackingData = this.cloneDeep(data.filter((/**
             * @param {?} t
             * @return {?}
             */
            t => t.masterTextKey.indexOf('DEBUG_') !== 0))); // Block trans changes to DEBUG_VISUAL_IDENTIFIER_LABEL_x keys
            this.rows = this.cloneDeep(data.filter((/**
             * @param {?} t
             * @return {?}
             */
            t => t.masterTextKey.indexOf('DEBUG_') !== 0))); // Block trans changes to DEBUG_VISUAL_IDENTIFIER_LABEL_x keys
            // Include all the Enumeration Definitions (list items)
            for (var enumeration of this.rowsEnum) {
                for (var edef of enumeration.enumerationDefinitions) {
                    // Avoid adding the duplicate MasterTextKeys (label translations may also occur in the Enumeration Definitions).
                    if (!this.rows.find((/**
                     * @param {?} t
                     * @return {?}
                     */
                    t => t.masterTextKey === edef.masterTextKey))) {
                        /** @type {?} */
                        let edefTranslation = new Translation;
                        edefTranslation.masterTextKey = edef.masterTextKey;
                        edefTranslation.defaultText = edef.defaultText;
                        edefTranslation.translationText = edef.translationText;
                        edefTranslation.textTypeId = 0; // Enum ToDo: Can/should we drive this more correctly that hard coded?
                        this.rows.push(JSON.parse(JSON.stringify(edefTranslation)));
                        this.rowsBackingData.push(JSON.parse(JSON.stringify(edefTranslation)));
                    }
                }
            }
        }));
        // Get the target language name
        this.adminService.getLanguages().subscribe((/**
         * @param {?} languages
         * @return {?}
         */
        (languages) => {
            if (!!languages) {
                this.languages = languages;
                this.userProfileService.getUserDetails().subscribe((/**
                 * @param {?} user
                 * @return {?}
                 */
                user => {
                    if (!!user) {
                        /** @type {?} */
                        var userLanguage = languages.find((/**
                         * @param {?} l
                         * @return {?}
                         */
                        l => user.languageIsoName === l.isoName));
                        this.languageName = userLanguage.masterTextKey;
                        // Disable translation editing and submit button on modal for English translastions, as it is the master/system language text already.
                        if (this.languageName === 'LANGUAGE_ENGLISH_UK') {
                            this.parentSubmitIsDisabled = true;
                            // Simple popup message box
                            swal$1('Information', 'Translations for English (en-gb) cannot be edited as they are the default system text.', 'warning');
                        }
                    }
                }));
            }
        }));
    }
    /**
     * Callback function that is dynamically called by a modal popup when "Save/Submit/Ok" is clicked.
     * @return {?}
     */
    modalSubmitCallback() {
        if (this.changedTranslations.length <= 0) {
            // nothing to do
            console.info(`Translation submit - There where no translation changes to save.`);
            return;
        }
        /** @type {?} */
        let displayGroup = new DisplayGroup();
        displayGroup.languageId = this.translationService.displayGroup.languageId;
        displayGroup.translations = this.changedTranslations;
        console.info(`Saving translation changes....`);
        this.translationService.manageTranslationTexts(displayGroup).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => { }));
        console.info(`Updating UI with translations changes....`);
        // Translation changes for the LAYOUT display group or regular display group?
        /** @type {?} */
        var displayGroupUI = this.getActiveDisplayGropup();
        // Update UI with changes:
        // For each translation change, search the UI display groups for masterKeys and update translationTexts
        // both Translations array and Enumerations->Definitions arrays.
        for (var change of this.changedTranslations) {
            // Set newTRanslationText to defaultText if string is empty. Empty Translations are removed from the database, thus reverts to default Text.
            /** @type {?} */
            let newTRanslationText = change.translationText.length > 0 ? change.translationText : change.defaultText;
            // Apply changes to the current Active Display Group (page), DisplayGroup and Layout Group
            // UI regular Translations
            if (!!displayGroupUI.translations.find((/**
             * @param {?} t
             * @return {?}
             */
            t => t.masterTextKey === change.masterTextKey))) {
                displayGroupUI.translations.find((/**
                 * @param {?} t
                 * @return {?}
                 */
                t => t.masterTextKey === change.masterTextKey)).translationText = newTRanslationText;
            }
            // UI Enumeration Translations on page Display Group, set changed translationText      
            for (var enumeration of displayGroupUI.enumerations) {
                if (!!enumeration.enumerationDefinitions.find((/**
                 * @param {?} t
                 * @return {?}
                 */
                t => t.masterTextKey === change.masterTextKey))) {
                    enumeration.enumerationDefinitions.find((/**
                     * @param {?} t
                     * @return {?}
                     */
                    t => t.masterTextKey === change.masterTextKey)).translationText = newTRanslationText;
                }
            }
            // Apply UI changes to the LAYOUT group
            if (this.translationService.layoutDisplayGroup.translations.find((/**
             * @param {?} t
             * @return {?}
             */
            t => t.masterTextKey === change.masterTextKey))) {
                this.translationService.layoutDisplayGroup.translations.find((/**
                 * @param {?} t
                 * @return {?}
                 */
                t => t.masterTextKey === change.masterTextKey)).translationText = newTRanslationText;
            }
            // UI Enumerations Translations changes to the LAYOUT group, set changed translationText   
            for (var enumeration of this.translationService.layoutDisplayGroup.enumerations) {
                if (!!enumeration.enumerationDefinitions.find((/**
                 * @param {?} t
                 * @return {?}
                 */
                t => t.masterTextKey === change.masterTextKey))) {
                    enumeration.enumerationDefinitions.find((/**
                     * @param {?} t
                     * @return {?}
                     */
                    t => t.masterTextKey === change.masterTextKey)).translationText = newTRanslationText;
                }
            }
        }
        console.info(`Translation submit done. ${JSON.stringify(this.changedTranslations[0])}`);
    }
    /**
     * Handle paging
     * @param {?} event
     * @return {?}
     */
    onPage(event) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout((/**
         * @return {?}
         */
        () => {
            console.log('paged!', event);
        }), 100);
    }
    /**
     * Update tranlation in modal, add to list changes by MasterKeyText
     * @param {?} event
     * @param {?} cell
     * @param {?} rowMasterTextKey
     * @return {?}
     */
    updateValue(event, cell, rowMasterTextKey) {
        //console.log('inline editing rowMasterTextKey', rowMasterTextKey);    
        if (this.languageName === 'LANGUAGE_ENGLISH_UK') {
            this.parentSubmitIsDisabled = true;
            return;
        }
        // Has the translation changed for the edited rowMasterTextKey? This is the cell is being edited?
        if (this.rows.find((/**
         * @param {?} t
         * @return {?}
         */
        t => t.masterTextKey === rowMasterTextKey)).translationText !== event.target.value && this.editing[rowMasterTextKey + '-' + cell]) {
            this.editing[rowMasterTextKey + '-' + cell] = false;
            /** @type {?} */
            const theUpdatingRow = this.rows.find((/**
             * @param {?} t
             * @return {?}
             */
            t => t.masterTextKey === rowMasterTextKey));
            // Update the row for UI display data. Set a blank/empty/deletion back to defaultText for display, when saved to DB the translation will be deleted.
            theUpdatingRow.translationText = !!event.target.value ? event.target.value : theUpdatingRow.defaultText;
            // Enable submit button in parent Modal
            this.parentSubmitIsDisabled = false;
            this.rows = [...this.rows];
            // Update backing data or a filter change will loose this update in the modal row data
            this.rowsBackingData.find((/**
             * @param {?} t
             * @return {?}
             */
            t => t.masterTextKey === rowMasterTextKey)).translationText = theUpdatingRow.translationText;
            // Add change or update existing change
            if (!this.changedTranslations.find((/**
             * @param {?} t
             * @return {?}
             */
            t => t.masterTextKey === rowMasterTextKey))) {
                this.changedTranslations.push(theUpdatingRow);
                console.log('Translation change added: ', theUpdatingRow);
            }
            else {
                // A change has already stored for this masterKeyText
            }
        }
    }
    /**
     * Updates the filteed rows on UI data grid.
     * @param {?} event
     * @return {?}
     */
    updateFilter(event) {
        /** @type {?} */
        const val = event.target.value.toLowerCase();
        // filter our data
        /** @type {?} */
        const rowsBackingData = this.rowsBackingData.filter((/**
         * @param {?} d
         * @return {?}
         */
        function (d) {
            // Test if the defaultText is like the filter text
            if (!!d.defaultText) {
                if (d.defaultText.toLowerCase().indexOf(val) !== -1 || !val) {
                    return true;
                }
            }
            // Test if the translationText is like the filter text
            if (!!d.translationText) {
                if (d.translationText.toLowerCase().indexOf(val) !== -1 || !val) {
                    return true;
                }
            }
            // Missing translatioText, allow all if filter text is empty
            if (!d.translationText) {
                return !val;
            }
            // default allow all
            return d.defaultText.indexOf(val) !== -1 || d.translationText.indexOf(val) !== -1 || !val;
        }));
        // update the rows
        this.rows = rowsBackingData;
        // Whenever the filter changes, always go back to the first page
        this.table.offset = 0;
    }
    /**
     * Allows a custom sort for translations not set, equal to the default Text
     * @param {?} rowA The row data to compare and sort.
     * @return {?}
     */
    translationComparator(rowA) {
        //console.log('Sorting Comparator', rowA);
        //do compare with fields in rowA.
        if (rowA.translationText === rowA.defaultText) {
            return -1;
        }
        else {
            return 1;
        }
    }
    /**
     * Build text data for TextTypeId.
     * ToDo: Create an Enumeration in the databse and use to drive UI?
     * @param {?} id The TextTypeId.
     * @return {?}
     */
    getTextTypeFromId(id) {
        // console.log(`getTextTypeFromId(${id}) called.`);
        // console.log(`getTextTypeFromId(${id}) called.`);
        /** @type {?} */
        let textypeName;
        switch (id) {
            case 0:
                textypeName = `LIST`;
                break;
            case 1:
                textypeName = `WORD`;
                break;
            case 2:
                textypeName = `MESSAGE`;
                break;
            case 3:
                textypeName = `HELP`;
                break;
            case 4:
                textypeName = `GRID`;
                break;
            case 5:
                textypeName = `SHEET`;
                break;
            default:
                textypeName = `UNKNOWN`;
        }
        return textypeName;
    }
}
TranslationComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-translation',
                template: "\r\n<form>\r\n<div class=\"panel-body\">\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-md-1\">\r\n        <label class=\"control-label\">{{\"FILTER\" | translate:true}}</label>\r\n      </div>\r\n\r\n      <div class=\"col-md-4\">\r\n        <input autocomplete=\"off\" type='text' title=\"{{'TYPE_TO_FILTER' | translate:true}}\" class=\"form-control\" placeholder=\"{{'TYPE_TO_FILTER' | translate:true}}...\" (keyup)='updateFilter($event)' />\r\n      </div>\r\n\r\n      <!--Language-->\r\n      <div class=\"form-group\">\r\n        <label style=\"font-weight: bolder\">{{'LANGUAGE' | translate:true}} : {{languageName | translate:true}}</label>\r\n        <!--<label *ngIf=\"languageName  === 'LANGUAGE_ENGLISH_UK'\" style=\"font-weight: bolder\">{ {'LANGUAGE' | translate:true}} : { {languageName | translate:true}} ({ {DEFAULT | translate:true}} { {INTERFACE_TRANSLATIONS | translate:true}})</label>-->\r\n\r\n        <!--<select class=\"form-control\" formControlName=\"languageIsoNameControl\" [disabled]=\"false\">\r\n    <option [value]=\"language.isoName\" *ngFor=\"let language of languages\">\r\n      { {language.name}}\r\n    </option>\r\n  </select>-->\r\n      </div>\r\n    </div>  \r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n\r\n        <!-- Note that rowIndex is not sort safe, use rows[rows.indexOf(row)] for the real index of the row data. -->\r\n        <ngx-datatable #translationsTable class=\"bootstrap\" [headerHeight]=\"40\" [limit]=\"4\" [columnMode]=\"'force'\" [footerHeight]=\"40\" [rowHeight]=\"'auto'\" [rows]=\"rows\" (page)=\"onPage($event)\" [messages]=\"{emptyMessage: translatePipe.transform('NO_DATA_TO_DISPLAY', true), totalMessage: translatePipe.transform('TOTAL', true), selectedMessage: false}\">\r\n\r\n          <ngx-datatable-column name=\"*\" prop=\"\" maxWidth=\"30\" [comparator]=\"translationComparator\">\r\n            <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n              <strong>\r\n                <span title=\"{{'CLICK_TO_EDIT' | translate:true}}\" (click)=\"editing = {}; editing[rows[rows.indexOf(row)].masterTextKey + '-translationText'] = (this.languageName  === 'LANGUAGE_ENGLISH_UK') ? false : true;\" *ngIf=\"rows[rows.indexOf(row)].translationText !== rows[rows.indexOf(row)].defaultText\">\r\n                  *\r\n                </span>\r\n              </strong>\r\n              <span title=\"{{'CLICK_TO_EDIT' | translate:true}}\" (click)=\"editing = {}; editing[rows[rows.indexOf(row)].masterTextKey + '-translationText'] = (this.languageName  === 'LANGUAGE_ENGLISH_UK') ? false : true;\" *ngIf=\"rows[rows.indexOf(row)].translationText === rows[rows.indexOf(row)].defaultText\">\r\n                -\r\n              </span>\r\n            </ng-template>\r\n          </ngx-datatable-column>\r\n\r\n          <ngx-datatable-column name=\"{{'DEFAULT_TEXT' | translate:true}}\" prop=\"defaultText\">\r\n            <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n\r\n              <!--Bold text, a translation exists for this language -->\r\n              <strong *ngIf=\"rows[rows.indexOf(row)].translationText != rows[rows.indexOf(row)].defaultText\">\r\n                <span title=\"{{'CLICK_TO_EDIT' | translate:true}}\" (click)=\" editing = {}; editing[rows[rows.indexOf(row)].masterTextKey + '-translationText'] = (this.languageName  === 'LANGUAGE_ENGLISH_UK') ? false : true;\">\r\n                  {{value}}\r\n                </span>\r\n              </strong>\r\n              <!--regular text-->\r\n              <div *ngIf=\"rows[rows.indexOf(row)].translationText == rows[rows.indexOf(row)].defaultText\">\r\n                <span title=\"{{'CLICK_TO_EDIT' | translate:true}}\" (click)=\"editing = {}; editing[rows[rows.indexOf(row)].masterTextKey + '-translationText'] = (this.languageName  === 'LANGUAGE_ENGLISH_UK') ? false : true;\">\r\n                  {{value}}\r\n                </span>\r\n              </div>\r\n            </ng-template>\r\n          </ngx-datatable-column>\r\n\r\n          <ngx-datatable-column name=\"{{'TRANSLATION_TEXT' | translate:true}}\" prop=\"translationText\">\r\n            <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" minwidth=\"80\" let-value=\"value\" let-row=\"row\">\r\n\r\n              <!--Bold text, a translation exists for this language -->\r\n              <strong *ngIf=\"rows[rows.indexOf(row)].translationText != rows[rows.indexOf(row)].defaultText\">\r\n                <span title=\"{{'CLICK_TO_EDIT' | translate:true}}\" (click)=\"editing = {}; editing[rows[rows.indexOf(row)].masterTextKey + '-translationText'] = (this.languageName  === 'LANGUAGE_ENGLISH_UK') ? false : true;\" *ngIf=\"!editing[rows[rows.indexOf(row)].masterTextKey + '-translationText']\">\r\n                  {{value}}\r\n                </span>\r\n              </strong>\r\n              <!--regular text-->\r\n              <div *ngIf=\"rows[rows.indexOf(row)].translationText == rows[rows.indexOf(row)].defaultText\">\r\n                <span title=\"{{'CLICK_TO_EDIT' | translate:true}}\" (click)=\"editing = {}; editing[rows[rows.indexOf(row)].masterTextKey + '-translationText'] = (this.languageName  === 'LANGUAGE_ENGLISH_UK') ? false : true;\" *ngIf=\"!editing[rows[rows.indexOf(row)].masterTextKey + '-translationText']\">\r\n                  {{value}}\r\n                </span>\r\n              </div>\r\n\r\n              <!-- {rows.indexOf(row) is the shaddow row index regardless of sort order, rowIndex is the UI index, useless if the data is sorted. -->\r\n              <input autocomplete=\"off\" autofocus (blur)=\"updateValue($event, 'translationText', rows[rows.indexOf(row)].masterTextKey)\" *ngIf=\"!!editing[rows[rows.indexOf(row)].masterTextKey+ '-translationText']\" type=\"text\" [value]=\"value\" style=\"font-weight: bolder; color: red;\" />\r\n            </ng-template>\r\n          </ngx-datatable-column>\r\n\r\n          <ngx-datatable-column name=\"{{'TEXT_TYPE' | translate:true}}\" prop=\"textTypeId\" maxWidth=\"100\">\r\n            <ng-template let-column=\"column\" let-sort=\"sortFn\" ngx-datatable-header-template>\r\n              <span (click)=\"sort()\">{{'TEXT_TYPE' | translate:true}}</span>\r\n            </ng-template>\r\n\r\n            <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n              <!--Bold text, a translation exists for this language -->\r\n              <strong *ngIf=\"rows[rows.indexOf(row)].translationText != rows[rows.indexOf(row)].defaultText\">\r\n                <span title=\"{{'CLICK_TO_EDIT' | translate:true}}\" (click)=\"editing = {}; editing[rows[rows.indexOf(row)].masterTextKey + '-translationText'] = (this.languageName  === 'LANGUAGE_ENGLISH_UK') ? false : true;\">\r\n                  {{getTextTypeFromId(value) | translate:true}}\r\n                </span>\r\n              </strong>\r\n              <!--regular text-->\r\n              <div *ngIf=\"rows[rows.indexOf(row)].translationText == rows[rows.indexOf(row)].defaultText\">\r\n                <span title=\"{{'CLICK_TO_EDIT' | translate:true}}\" (click)=\"editing = {}; editing[rows[rows.indexOf(row)].masterTextKey + '-translationText'] = (this.languageName  === 'LANGUAGE_ENGLISH_UK') ? false : true;\">\r\n                  {{getTextTypeFromId(value) | translate:true}}\r\n                </span>\r\n              </div>\r\n\r\n            </ng-template>\r\n          </ngx-datatable-column>\r\n\r\n        </ngx-datatable>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</form>\r\n\r\n  <!--<strong class=\"thisTingHere\">Login as 'hakon thomas' 'spirax13'</strong> for French demo (sort, filter, paging). ToDo:\r\n  <br />\r\n  - Language Name label (or list to change trans language for admins, get all translations form server).\r\n  <br />\r\n  - Is Translation Type filtering required? Handle base table list item grouping vs Enumeration Lists (both have no support for TextType eg. Units(list of words) vs Media (EnumerationDefinitions))?\r\n  <br />\r\n  - Duplication of MasterTextKey partially supported, a label and in an Enumeration Definition (list item) eg. filter for \"Standard\" in SafetyValves page, note that the data saves but UI require a refresh.\r\n  <br />\r\n  - Block and warn when UK en-gb editing (better to fix base master text in database).\r\n  <br />\r\n  - Support messages on modal exit/cancel. 'Changes saved' message, 'Discard changes' message. Add dirty form/grid support?\r\n  <br />-->\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
TranslationComponent.ctorParameters = () => [
    { type: TranslationService },
    { type: TranslatePipe },
    { type: UserProfileService },
    { type: AdminService },
    { type: FormBuilder }
];
TranslationComponent.propDecorators = {
    table: [{ type: ViewChild, args: [DatatableComponent, { static: false },] }],
    tableExp: [{ type: ViewChild, args: ['translationsTable', { static: false },] }]
};
if (false) {
    /** @type {?} */
    TranslationComponent.prototype.table;
    /** @type {?} */
    TranslationComponent.prototype.tableExp;
    /** @type {?} */
    TranslationComponent.prototype.parentSubmitIsDisabled;
    /** @type {?} */
    TranslationComponent.prototype.cloneDeep;
    /** @type {?} */
    TranslationComponent.prototype.displayGroup;
    /** @type {?} */
    TranslationComponent.prototype.rows;
    /** @type {?} */
    TranslationComponent.prototype.rowsEnum;
    /** @type {?} */
    TranslationComponent.prototype.rowsBackingData;
    /** @type {?} */
    TranslationComponent.prototype.editing;
    /** @type {?} */
    TranslationComponent.prototype.timeout;
    /** @type {?} */
    TranslationComponent.prototype.selected;
    /** @type {?} */
    TranslationComponent.prototype.changedTranslations;
    /** @type {?} */
    TranslationComponent.prototype.changedEnumerationTranslations;
    /** @type {?} */
    TranslationComponent.prototype.transForm;
    /** @type {?} */
    TranslationComponent.prototype.languageIsoNameControl;
    /** @type {?} */
    TranslationComponent.prototype.languageName;
    /** @type {?} */
    TranslationComponent.prototype.languages;
    /** @type {?} */
    TranslationComponent.prototype.userLanguageIsoName;
    /**
     * @type {?}
     * @private
     */
    TranslationComponent.prototype.translationService;
    /** @type {?} */
    TranslationComponent.prototype.translatePipe;
    /**
     * @type {?}
     * @private
     */
    TranslationComponent.prototype.userProfileService;
    /**
     * @type {?}
     * @private
     */
    TranslationComponent.prototype.adminService;
    /**
     * @type {?}
     * @private
     */
    TranslationComponent.prototype.fb;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/translation/translation.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TranslationModule {
}
TranslationModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    NgxDatatableModule
                ],
                declarations: [TranslationComponent, TranslatePipe],
                providers: [TranslatePipe],
                exports: [TranslationComponent, TranslatePipe]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/enumeration/enumeration.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EnumerationComponent {
    /**
     * @param {?} translationService
     */
    constructor(translationService) {
        this.translationService = translationService;
        this.opCoOverride = false;
        // To notifiy a selection change to an external component's method.
        // Example html template usage: <enumeration formControlName = "tradeEnum"(on - change) = "handleTradeEnumChanging($event)"... </enumeration> 
        this.externalOnChange = new EventEmitter();
        this.externalOnLoad = new EventEmitter();
        this.onChange = (/**
         * @return {?}
         */
        () => { });
        this.onTouched = (/**
         * @return {?}
         */
        () => { });
        this.cloneDeep = cloneDeep_;
        this.enumerationCollection = [];
    }
    /**
     * @return {?}
     */
    get enumerationItem() {
        return this.internalValue;
    }
    /**
     * @return {?}
     */
    get enumerationItemTranslationText() {
        if (!!this.enumeration && this.enumeration.enumerationDefinitions.length > 0
            && !!this.enumeration.enumerationDefinitions.find((/**
             * @param {?} e
             * @return {?}
             */
            e => this.enumeration.enumerationName && e.value === this.internalValue))) {
            /** @type {?} */
            var translationText = this.enumeration.enumerationDefinitions.find((/**
             * @param {?} e
             * @return {?}
             */
            e => this.enumeration.enumerationName && e.value === this.internalValue)).translationText;
            /** @type {?} */
            var extraPreText = this.enumeration.enumerationDefinitions.find((/**
             * @param {?} e
             * @return {?}
             */
            e => this.enumeration.enumerationName && e.value === this.internalValue)).extraPreText;
            if (!extraPreText) {
                extraPreText = '';
            }
            /** @type {?} */
            var extraPostText = this.enumeration.enumerationDefinitions.find((/**
             * @param {?} e
             * @return {?}
             */
            e => this.enumeration.enumerationName && e.value === this.internalValue)).extraPostText;
            if (!extraPostText) {
                extraPostText = '';
            }
            return extraPreText + translationText + extraPostText;
        }
        return "";
    }
    /**
     * @param {?} enumerationValue
     * @return {?}
     */
    set enumerationItem(enumerationValue) {
        if (enumerationValue !== this.internalValue) {
            this.internalValue = enumerationValue;
            this.onChange(this.internalValue);
        }
        this.onTouched();
    }
    /**
     * Gets the enumerations that matches the specified \@Input enumeration name.
     * @return {?} The array of enumerations sorted by Sequence order.
     */
    getEnumerationCollection() {
        this.enumeration = this.translationService.displayGroup.enumerations.filter((/**
         * @param {?} us
         * @return {?}
         */
        us => us.enumerationName === this.enumerationName && us.opCoOverride === this.opCoOverride))[0];
        // Check if enumerations with overrides NOT found? If so, then populate this with the base enumerations.
        if (!this.enumeration) {
            this.enumeration = this.translationService.displayGroup.enumerations.filter((/**
             * @param {?} us
             * @return {?}
             */
            us => us.enumerationName === this.enumerationName && us.opCoOverride === false))[0];
        }
        if (!!this.enumeration) {
            /** @type {?} */
            let definitions = this.enumeration.enumerationDefinitions.sort((/**
             * @param {?} currentenumeration
             * @param {?} nextenumeration
             * @return {?}
             */
            (currentenumeration, nextenumeration) => {
                if (currentenumeration.sequence > nextenumeration.sequence) {
                    return 1;
                }
                if (currentenumeration.sequence < nextenumeration.sequence) {
                    return -1;
                }
                return 0;
            }));
            if (!!this.filterBy && this.filterBy.length > 0) {
                //definitions = cloneDeep(definitions.filter(ed => this.filterBy.includes(ed.value))); // deep clone prevents the UI trans text from being changed on the UI list item.
                definitions = definitions.filter((/**
                 * @param {?} ed
                 * @return {?}
                 */
                ed => this.filterBy.includes(ed.value)));
            }
            // Disable selection if list has got one item only.
            this.isDisabled = (definitions && definitions.length === 1);
            return definitions;
        }
        return null;
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (this.isInitialised) {
            this.initialiseEnumerationCollection();
            if (this.enumerationItem && this.enumerationCollection) {
                this.externalOnLoad.emit({ selectedValue: this.enumerationItem, itemsCount: this.enumerationCollection.length });
            }
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.initialiseEnumerationCollection();
        if (this.enumerationItem && this.enumerationCollection) {
            this.externalOnLoad.emit({ selectedValue: this.enumerationItem, itemsCount: this.enumerationCollection.length });
        }
        this.isInitialised = true;
    }
    // This breaks CSG Communications List setValue fails/defaults on job load! (see HKO)
    //ngAfterContentInit(): void {
    //  this.initialiseEnumerationCollection();
    //}
    /**
     * @return {?}
     */
    initialiseEnumerationCollection() {
        this.enumerationCollection = this.getEnumerationCollection();
        // If no value has initially been set for the enumerationItem, set it to the first item
        if ((!this.enumerationItem || this.isInitialised) && !!this.enumerationCollection) {
            if (!this.allowBlank || this.isDisabled == true) {
                if (this.enumerationCollection.length > 0) {
                    /** @type {?} */
                    var x = this.index ? this.index : this.enumerationCollection.find((/**
                     * @param {?} e
                     * @return {?}
                     */
                    e => e.value === this.enumerationItem)) ? this.enumerationCollection.findIndex((/**
                     * @param {?} e
                     * @return {?}
                     */
                    e => e.value === this.enumerationItem)) : 0;
                    this.internalValue = this.enumerationCollection[x].value; // DO NOT use the setter for this.enumerationItem as it fire OnChange that breaks P&Js when selecting a project with both Trade and Industry lists set.
                }
            }
        }
        else if (!this.opCoOverride) {
            console.error(`enumerationCollection should not be empty? Routing / resolver problem?`);
        }
    }
    /**
     * Registers any changes to the directive and applies the provided callback function.
     * @param {?} fn The callback function.
     * @return {?}
     */
    registerOnChange(fn) {
        /** @type {?} */
        const bespokeChange = (/**
         * @param {?} newValue
         * @return {?}
         */
        (newValue) => {
            //console.log(`bespokeChange err=${newValue}`);
            // The Enumeration Definition is still in memory, so only apply the changed value.
            this.internalValue = newValue; //this.enumerationItem = newValue; this changes the setter that then fires the onchange again, multiple onChange events generated.
            this.onTouched();
            fn(this.enumerationItem);
            // Emit the latest change to anything that may be listening.
            this.externalOnChange.emit({ selectedValue: newValue, itemsCount: (this.enumerationCollection ? this.enumerationCollection.length : 0) });
        });
        this.onChange = bespokeChange;
    }
    /**
     * Registers the touched event to the directive and applies the provided callback function.
     * @param {?} fn The callback function.
     * @return {?}
     */
    registerOnTouched(fn) {
        /** @type {?} */
        const bespokeTouched = (/**
         * @return {?}
         */
        () => {
            //console.log(`onTouched set`);
            fn();
        });
        this.onTouched = bespokeTouched;
    }
    /**
     * Registers a final change to the provided directive's value and provides a space to apply it.
     * @param {?} value The directive's implicit value.
     * @return {?}
     */
    writeValue(value) {
        this.enumerationItem = value;
        if (!value) {
            this.ngOnInit();
        }
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
}
EnumerationComponent.decorators = [
    { type: Component, args: [{
                selector: 'enumeration',
                exportAs: 'enumeration',
                template: "<!-- Layout for enumerations -->\r\n<div *ngIf=\"!useNewStyling\">\r\n  <!--class=\"col-lg-4 col-xs-12\">-->\r\n  <select [disabled]=\"isDisabled\" class=\"form-control\" (blur)=\"onTouched()\" (ngModelChange)=\"onChange($event)\" [ngModel]=\"enumerationItem\" title=\"{{enumerationItemTranslationText}}\">\r\n    <option *ngFor=\"let enumerationDefinition of enumerationCollection; let i = index\" [value]=\"enumerationDefinition.value\" [selected]=\"i==0\" title=\"{{enumerationDefinition.extraPreText}}{{enumerationDefinition.translationText}}{{enumerationDefinition.extraPostText}}\">{{enumerationDefinition.extraPreText}}{{enumerationDefinition.translationText}}{{enumerationDefinition.extraPostText}}</option>\r\n  </select>\r\n</div>\r\n\r\n<!-- New UX Guidelines -->\r\n<div *ngIf=\"useNewStyling\">\r\n  <!--class=\"col-lg-4 col-xs-12\">-->\r\n  <select spirax-input [disabled]=\"isDisabled\" [unitsStr]=\"unit\" [label]=\"label\" [tooltipSXS]=\"tooltipSXS\" (blur)=\"onTouched()\" (ngModelChange)=\"onChange($event)\" [ngModel]=\"enumerationItem\" title=\"{{enumerationItemTranslationText}}\">\r\n    <option *ngFor=\"let enumerationDefinition of enumerationCollection; let i = index\" [value]=\"enumerationDefinition.value\" [selected]=\"i==0\" title=\"{{enumerationDefinition.extraPreText}}{{enumerationDefinition.translationText}}{{enumerationDefinition.extraPostText}}\">{{enumerationDefinition.extraPreText}}{{enumerationDefinition.translationText}}{{enumerationDefinition.extraPostText}}</option>\r\n  </select>\r\n</div>\r\n\r\n",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => EnumerationComponent)),
                    }],
                styles: [""]
            }] }
];
/** @nocollapse */
EnumerationComponent.ctorParameters = () => [
    { type: TranslationService }
];
EnumerationComponent.propDecorators = {
    enumerationName: [{ type: Input, args: ["enumeration-name",] }],
    index: [{ type: Input, args: ["display-index",] }],
    filterBy: [{ type: Input, args: ["filter-by",] }],
    opCoOverride: [{ type: Input, args: ["opco-override",] }],
    label: [{ type: Input, args: ["label",] }],
    unit: [{ type: Input, args: ["unit",] }],
    tooltipSXS: [{ type: Input, args: ["tooltipSXS",] }],
    allowBlank: [{ type: Input, args: ["allow-blank",] }],
    useNewStyling: [{ type: Input, args: ["use-new-styling",] }],
    externalOnChange: [{ type: Output, args: ["on-change",] }],
    externalOnLoad: [{ type: Output, args: ["on-load",] }],
    internalValue: [{ type: Input, args: ['value',] }]
};
if (false) {
    /** @type {?} */
    EnumerationComponent.prototype.enumerationName;
    /** @type {?} */
    EnumerationComponent.prototype.index;
    /** @type {?} */
    EnumerationComponent.prototype.filterBy;
    /** @type {?} */
    EnumerationComponent.prototype.opCoOverride;
    /** @type {?} */
    EnumerationComponent.prototype.label;
    /** @type {?} */
    EnumerationComponent.prototype.unit;
    /** @type {?} */
    EnumerationComponent.prototype.tooltipSXS;
    /** @type {?} */
    EnumerationComponent.prototype.allowBlank;
    /** @type {?} */
    EnumerationComponent.prototype.useNewStyling;
    /** @type {?} */
    EnumerationComponent.prototype.externalOnChange;
    /** @type {?} */
    EnumerationComponent.prototype.externalOnLoad;
    /** @type {?} */
    EnumerationComponent.prototype.internalValue;
    /** @type {?} */
    EnumerationComponent.prototype.onChange;
    /** @type {?} */
    EnumerationComponent.prototype.onTouched;
    /** @type {?} */
    EnumerationComponent.prototype.isDisabled;
    /** @type {?} */
    EnumerationComponent.prototype.isInitialised;
    /** @type {?} */
    EnumerationComponent.prototype.cloneDeep;
    /** @type {?} */
    EnumerationComponent.prototype.enumerationCollection;
    /** @type {?} */
    EnumerationComponent.prototype.enumeration;
    /**
     * @type {?}
     * @protected
     */
    EnumerationComponent.prototype.translationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/units/units.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UnitsService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
        this.units = [];
        this.unitsChange = new Subject();
        // When the class in constructed, initialise the subject so that whenever it is called, its subscriber resolves the result to the current units.
        this.unitsChange.subscribe((/**
         * @param {?} val
         * @return {?}
         */
        val => {
            if (!!val) {
                this.units = val;
            }
        }));
        // If no units are loaded, get it ONCE from the server.
        if (this.units.length === 0) {
            this.getAllUnitsByAllTypes().subscribe((/**
             * @param {?} units
             * @return {?}
             */
            (units) => {
                // Update the subject with the data that's just been retrieved (see the constructor).
                this.unitsChange.next(units);
            }));
        }
    }
    /**
     * Gets all units and their respective unit types.
     * @return {?}
     */
    getAllUnitsByAllTypes() {
        return this.http.get(`./Api/Calculations/GetAllUnitsByAllTypes`).map((/**
         * @param {?} __0
         * @return {?}
         */
        ({ units }) => {
            return units;
        }));
    }
    /**
     * @param {?} unitsConverter
     * @return {?}
     */
    unitsConverter(unitsConverter) {
        return this.http.post(`./Api/Calculations/UnitsConverter`, unitsConverter).map((/**
         * @param {?} unitsConvertedData
         * @return {?}
         */
        (unitsConvertedData) => {
            return unitsConvertedData;
        }));
    }
}
UnitsService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
UnitsService.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /** @type {?} */
    UnitsService.prototype.units;
    /** @type {?} */
    UnitsService.prototype.unitsChange;
    /**
     * @type {?}
     * @private
     */
    UnitsService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/directives/spirax-input/spirax-input.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SpiraxInputDirective {
    /**
     * @param {?} el
     * @param {?} unitsService
     * @param {?} translatePipe
     * @param {?} control
     */
    constructor(el, unitsService, translatePipe, control) {
        this.el = el;
        this.unitsService = unitsService;
        this.translatePipe = translatePipe;
        this.control = control;
        this.radioClick = new EventEmitter();
        this.ngUnsubscribe = new Subject$1();
        this.wrapperClickHandle = (/**
         * @param {?} data
         * @return {?}
         */
        (data) => this.radioClick.emit(data));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.generateInputWrapper(); // Call first
        this.fieldMessageChange(); // Call second
        if (this.unitsStr && this.unitsStr.length) {
            this.generateUnits(this.unitsStr[0], this.unitsStr[1]);
        }
        else if (this.unitIds && this.unitIds.length) {
            this.unitsService.unitsChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe((/**
             * @param {?} units
             * @return {?}
             */
            (units) => {
                this.units = units.reduce((/**
                 * @param {?} obj
                 * @param {?} unit
                 * @return {?}
                 */
                (obj, unit) => (Object.assign({}, obj, { [unit.id]: unit.units }))), {});
                this.generateUnits(this.units[this.unitIds[0]], this.units[this.unitIds[1]]);
            }));
        }
        if (this.currencyStr && this.currencyStr.length) {
            this.generateCurrency(this.currencyStr[0], this.currencyStr[1]);
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        //debugger;
        if (!this.unitsStr && changes.unitIds && !changes.unitIds.firstChange &&
            this.el && this.el.nativeElement && this.el.nativeElement.parentNode) {
            const [left, right] = this.unitIds;
            /** @type {?} */
            const units = this.units || this.unitsService.units.reduce((/**
             * @param {?} obj
             * @param {?} unit
             * @return {?}
             */
            (obj, unit) => (Object.assign({}, obj, { [unit.id]: unit.units }))), {});
            /** @type {?} */
            const unitWrapper = this.el.nativeElement.parentNode.querySelector('.spiraxInput_unit');
            this.generateUnits(units[left], units[right], unitWrapper);
        }
        else if (this.unitsStr && this.unitsStr.length && changes.unitsStr && !changes.unitsStr.firstChange &&
            this.el && this.el.nativeElement && this.el.nativeElement.parentNode) {
            /** @type {?} */
            const unitWrapper = this.el.nativeElement.parentNode.querySelector('.spiraxInput_unit');
            this.generateUnits(this.unitsStr[0], this.unitsStr[1], unitWrapper);
        }
        //else if (changes.label) { check where and how this changes interface is created and perhaps add currency symbol
        //  if (changes.label) {
        //  }
        //  debugger;
        //}
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.wrapperNode && this.wrapperNode.removeEventListener && this.radio !== undefined) {
            this.wrapperNode.removeEventListener('click', this.wrapperClickHandle);
        }
    }
    /**
     * @private
     * @return {?}
     */
    generateInputWrapper() {
        if (this.el && this.el.nativeElement) {
            this.wrapperNode = document.createElement('div');
            /** @type {?} */
            const message = document.createElement('p');
            if ((this.unitIds && this.unitIds.length) || (this.unitsStr && this.unitsStr.length)) {
                this.el.nativeElement.classList.add('loading');
            }
            if (this.label) {
                /** @type {?} */
                const label = document.createElement('label');
                label.classList.add('spiraxInput_label');
                label.innerHTML = this.label;
                this.wrapperNode.appendChild(label);
            }
            if (this.tooltipSXS) {
                //create tooltip icon
                /** @type {?} */
                const icon = document.createElement('tooltipIcon');
                icon.classList.add('spiraxInput_tooltipIcon');
                icon.innerHTML = "<i class='fa fa-info-circle'></i>";
                this.wrapperNode.appendChild(icon);
                //translate message text from this.tooltip
                /** @type {?} */
                let translatedTooltipText = this.translatePipe.transform(this.tooltipSXS);
                //create tooltip text window and pass the translatedTooltipText in to it
                /** @type {?} */
                const tooltipTextWindow = document.createElement('tooltipTextWindow');
                tooltipTextWindow.classList.add('spiraxInput_tooltipTextWindow');
                tooltipTextWindow.innerHTML = translatedTooltipText;
                this.wrapperNode.appendChild(tooltipTextWindow);
            }
            this.wrapperNode.classList.add('spiraxInput');
            message.classList.add('spiraxInput_message');
            message.innerHTML = this.generateMessage(this.control && this.control.control);
            this.el.nativeElement.setAttribute('placeholder', ' ');
            this.el.nativeElement.classList.add('spiraxInput_control');
            if (this.el.nativeElement.parentNode) {
                this.el.nativeElement.parentNode.insertBefore(this.wrapperNode, this.el.nativeElement);
            }
            this.wrapperNode.appendChild(this.el.nativeElement);
            if (this.radio !== undefined) {
                /** @type {?} */
                const radioCheck = document.createElement('span');
                radioCheck.classList.add('spiraxInput_radio');
                this.wrapperNode.appendChild(radioCheck);
                this.wrapperNode.addEventListener('click', this.wrapperClickHandle);
            }
            this.wrapperNode.appendChild(message);
        }
    }
    /**
     * @private
     * @param {?=} c
     * @return {?}
     */
    fieldMessageChange(c) {
        /** @type {?} */
        const control = c || this.control && this.control.control;
        /** @type {?} */
        const errorNode = this.el && this.el.nativeElement &&
            this.el.nativeElement.parentNode &&
            this.el.nativeElement.parentNode.querySelector('.spiraxInput_message');
        if (control && errorNode && control.statusChanges && control.valueChanges) {
            /** @type {?} */
            const updateMsgFn = (/**
             * @return {?}
             */
            () => errorNode.innerHTML = control.valid ? '' : this.generateMessage(control));
            control.statusChanges.pipe(debounceTime(400), distinctUntilChanged()).subscribe(updateMsgFn);
            control.valueChanges.pipe(debounceTime(400), distinctUntilChanged()).subscribe(updateMsgFn);
        }
    }
    /**
     * @private
     * @param {?} control
     * @return {?}
     */
    generateMessage(control) {
        /** @type {?} */
        const errors = control && control.errors || this.error;
        if (!errors) {
            return null;
        }
        if (typeof errors === 'string') {
            return errors;
        }
        if (errors && errors.required) {
            return null;
        }
        /** @type {?} */
        let error;
        /** @type {?} */
        let attemptValue;
        /** @type {?} */
        let errorMessage = null;
        if (errors.min) {
            error = errors.message || 'THE_VALUE_MUST_BE_GREATER_THAN_THE_MINIMUM_VALUE_MESSAGE';
            attemptValue = errors.min && errors.min.min;
        }
        if (errors.max) {
            error = errors.message || 'THE_VALUE_MUST_BE_LESS_THEN_THE_MAXIMUM_VALUE_MESSAGE';
            attemptValue = errors.max && errors.max.max;
        }
        if (errors.error) {
            error = errors.error;
        }
        if (errors.message) {
            attemptValue = errors.message;
        }
        if (error) {
            errorMessage = this.translatePipe.transform(error);
            if (attemptValue || attemptValue === 0) {
                if (!isNaN(attemptValue) && this.unitsStr && this.unitsStr[0]) {
                    /** @type {?} */
                    const units = this.unitsStr[1] ? `${this.unitsStr[0]}/${this.unitsStr[1]}` : this.unitsStr[0];
                    errorMessage += ` ${attemptValue} ${units || ''}`;
                }
                else {
                    errorMessage += ` ${attemptValue}`;
                }
            }
        }
        return errorMessage;
    }
    /**
     * @private
     * @param {?} leftUnit
     * @param {?} rightUnit
     * @param {?=} wrapper
     * @return {?}
     */
    generateUnits(leftUnit, rightUnit, wrapper) {
        /** @type {?} */
        let html = '';
        if (!wrapper) {
            html = '<div class="spiraxInput_unit">';
        }
        if (leftUnit) {
            html += `<span>${leftUnit}</span>`;
        }
        if (leftUnit && rightUnit) {
            html += '/';
        }
        if (rightUnit) {
            html += `<span>${rightUnit}</span>`;
        }
        if (!wrapper) {
            html += '</div>';
            this.el.nativeElement.classList.remove('loading');
            this.el.nativeElement.insertAdjacentHTML('afterend', html);
            return this.el.nativeElement.parentNode.querySelector('.spiraxInput_unit');
        }
        else {
            if (html) {
                wrapper.innerHTML = html;
            }
            else {
                wrapper.remove();
            }
        }
    }
    /**
     * @private
     * @param {?} leftSymbol
     * @param {?} rightSymbol
     * @param {?=} wrapper
     * @return {?}
     */
    generateCurrency(leftSymbol, rightSymbol, wrapper) {
        /** @type {?} */
        let html = '';
        if (!wrapper) {
            html = '<div class="spiraxInput_currencyStr">';
        }
        if (leftSymbol) {
            html += `<span>${leftSymbol}</span>`;
        }
        if (leftSymbol && rightSymbol) {
            html += '/';
        }
        if (rightSymbol) {
            html += `<span>${rightSymbol}</span>`;
        }
        if (!wrapper) {
            html += '</div>';
            this.el.nativeElement.classList.remove('loading');
            this.el.nativeElement.insertAdjacentHTML('afterend', html);
            return this.el.nativeElement.parentNode.querySelector('.spiraxInput_currencyStr');
        }
        else {
            if (html) {
                wrapper.innerHTML = html;
            }
            else {
                wrapper.remove();
            }
        }
    }
}
SpiraxInputDirective.decorators = [
    { type: Directive, args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[spirax-input]',
            },] }
];
/** @nocollapse */
SpiraxInputDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: UnitsService },
    { type: TranslatePipe },
    { type: NgControl, decorators: [{ type: Optional }] }
];
SpiraxInputDirective.propDecorators = {
    unitIds: [{ type: Input }],
    unitsStr: [{ type: Input }],
    currencyStr: [{ type: Input }],
    tooltipSXS: [{ type: Input }],
    label: [{ type: Input }],
    error: [{ type: Input }],
    radio: [{ type: Input }],
    radioClick: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    SpiraxInputDirective.prototype.unitIds;
    /** @type {?} */
    SpiraxInputDirective.prototype.unitsStr;
    /** @type {?} */
    SpiraxInputDirective.prototype.currencyStr;
    /** @type {?} */
    SpiraxInputDirective.prototype.tooltipSXS;
    /** @type {?} */
    SpiraxInputDirective.prototype.label;
    /** @type {?} */
    SpiraxInputDirective.prototype.error;
    /** @type {?} */
    SpiraxInputDirective.prototype.radio;
    /** @type {?} */
    SpiraxInputDirective.prototype.radioClick;
    /**
     * @type {?}
     * @private
     */
    SpiraxInputDirective.prototype.ngUnsubscribe;
    /**
     * @type {?}
     * @private
     */
    SpiraxInputDirective.prototype.units;
    /**
     * @type {?}
     * @private
     */
    SpiraxInputDirective.prototype.wrapperNode;
    /**
     * @type {?}
     * @private
     */
    SpiraxInputDirective.prototype.wrapperClickHandle;
    /**
     * @type {?}
     * @private
     */
    SpiraxInputDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    SpiraxInputDirective.prototype.unitsService;
    /**
     * @type {?}
     * @private
     */
    SpiraxInputDirective.prototype.translatePipe;
    /**
     * @type {?}
     * @private
     */
    SpiraxInputDirective.prototype.control;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/directives/spirax-input/spirax-input.directive.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SpiraxInputDirectiveModule {
}
SpiraxInputDirectiveModule.decorators = [
    { type: NgModule, args: [{
                imports: [],
                exports: [SpiraxInputDirective],
                declarations: [SpiraxInputDirective]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/enumeration/enumeration.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EnumerationModule {
}
EnumerationModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslationModule,
                    SpiraxInputDirectiveModule,
                ],
                exports: [
                    EnumerationComponent,
                ],
                declarations: [EnumerationComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/enumeration-picker/enumeration-picker.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const swal$2 = (/** @type {?} */ (swal$3));
class EnumerationPickerComponent {
    /**
     * @param {?} translationService
     * @param {?} fb
     * @param {?} translatePipe
     */
    constructor(translationService, fb, translatePipe) {
        this.translationService = translationService;
        this.fb = fb;
        this.translatePipe = translatePipe;
        this.readOnly = false;
        /* Boilerplate directive component code */
        this.internalValue = [];
        // To notifiy a selection change to an external component's method.
        // Example html template usage: <enumeration formControlName = "tradeEnum"(on - change) = "handleTradeEnumChanging($event)"... </enumeration> 
        this.externalOnChange = new EventEmitter();
        this.enumerationPickerCollection = [];
        this.internalSelectedItem = [];
        this.internalOpCoSelectedItem = [];
        this.onChange = (/**
         * @return {?}
         */
        () => { });
        this.onTouched = (/**
         * @return {?}
         */
        () => { });
        this.moveOptionsDownSelected = false;
        this.moveOptionsUpSelected = false;
    }
    /**
     * @return {?}
     */
    get enumerationPickerOpCoCollection() {
        return this.internalValue;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set enumerationPickerOpCoCollection(val) {
        this.internalValue = val;
        this.onChange(this.internalValue);
        this.onTouched();
    }
    /* Available Options*/
    /**
     * @return {?}
     */
    get enumerationPickerSelectedItem() {
        return this.internalSelectedItem;
    }
    /**
     * @param {?} enumerationPickerValue
     * @return {?}
     */
    set enumerationPickerSelectedItem(enumerationPickerValue) {
        if (enumerationPickerValue !== this.internalSelectedItem) {
            this.internalSelectedItem = enumerationPickerValue;
            //this.onChange(this.internalValue);
        }
        //this.onTouched();
    }
    /* OpCo Selected Options*/
    /**
     * @return {?}
     */
    get enumerationPickerOpCoSelectedItem() {
        return this.internalOpCoSelectedItem;
    }
    /**
     * @param {?} enumerationPickerValue
     * @return {?}
     */
    set enumerationPickerOpCoSelectedItem(enumerationPickerValue) {
        if (enumerationPickerValue !== this.internalOpCoSelectedItem) {
            this.internalOpCoSelectedItem = enumerationPickerValue;
            //this.onChange(this.internalOpCoSelectedItem);
        }
        //this.onTouched();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.enumerationPickerCollection = this.getEnumerationPickerCollection(this.enumerationPickerName, false);
    }
    /**
     * @param {?} enumerationPickerName
     * @param {?} opCoOverride
     * @return {?}
     */
    getEnumerationPickerCollection(enumerationPickerName, opCoOverride) {
        /** @type {?} */
        const enumeration = this.translationService.displayGroup.enumerations.filter((/**
         * @param {?} us
         * @return {?}
         */
        us => us.enumerationName === enumerationPickerName && us.opCoOverride === opCoOverride));
        if (!!enumeration && enumeration.length > 0) {
            /** @type {?} */
            let definitions = enumeration[0].enumerationDefinitions.sort((/**
             * @param {?} currentenumeration
             * @param {?} nextenumeration
             * @return {?}
             */
            (currentenumeration, nextenumeration) => {
                if (currentenumeration.sequence > nextenumeration.sequence) {
                    return 1;
                }
                if (currentenumeration.sequence < nextenumeration.sequence) {
                    return -1;
                }
                return 0;
            }));
            definitions.forEach((/**
             * @param {?} i
             * @return {?}
             */
            i => i.isDeleted = false));
            this.onChange(definitions);
            return definitions;
        }
    }
    /**
     * Registers any changes to the directive and applies the provided callback function.
     * @param {?} fn The callback function.
     * @return {?}
     */
    registerOnChange(fn) {
        /** @type {?} */
        const bespokeChange = (/**
         * @param {?} newValue
         * @return {?}
         */
        (newValue) => {
            // The Enumeration Definition is still in memory, so only apply the changed value.
            //this.enumerationPickerOpCoCollection = newValue;
            // Now, ensure that the Sequencing is correct?
            newValue.sort((/**
             * @param {?} v1
             * @param {?} v2
             * @return {?}
             */
            (v1, v2) => {
                if (!v1.isDeleted && v2.isDeleted) {
                    return -1;
                }
                if (v1.isDeleted && !v2.isDeleted) {
                    return 1;
                }
                return 0;
            }));
            for (let i of newValue) {
                i.sequence = newValue.indexOf(i) + 1;
            }
            fn(newValue);
            //Emit the latest change to anything that may be listening.
            this.externalOnChange.emit(newValue);
        });
        this.onChange = bespokeChange;
    }
    /**
     * Registers the touched event to the directive and applies the provided callback function.
     * @param {?} fn The callback function.
     * @return {?}
     */
    registerOnTouched(fn) {
        /** @type {?} */
        const bespokeTouched = (/**
         * @return {?}
         */
        () => {
            fn();
        });
        this.onTouched = bespokeTouched;
    }
    /**
     * Registers a final change to the provided directive's value and provides a space to apply it.
     * @param {?} value The directive's implicit value.
     * @return {?}
     */
    writeValue(value) {
        if (!!value) {
            this.enumerationPickerOpCoCollection = value;
        }
    }
    /**
     * @param {?} event
     * @param {?} isSelected
     * @return {?}
     */
    onEnumerationPickerSelect(event, isSelected) {
        /*debugger;*/
        //if (event.selected[0].value == 'G1') {
        //  this.moveOptionsUpSelected = false;
        //}
        //else {
        // Set the flags appropriately
        this.moveOptionsDownSelected = isSelected;
        this.moveOptionsUpSelected = !isSelected;
        // Empty out the appropriate list
        if (!isSelected) {
            this.enumerationPickerSelectedItem = [];
        }
        else {
            this.enumerationPickerOpCoSelectedItem = [];
        }
        /** @type {?} */
        const op = (/** @type {?} */ (event.selected));
        // If no items are selected, then nothing is selected
        if (op.length === 0) {
            this.enumerationPickerSelectedItem = false;
            this.enumerationPickerOpCoSelectedItem = false;
        }
        //}
    }
    /**
     * Method to add/remove items from the OpCo selected list.
     * @param {?} $event
     * @param {?} isMovingSelectedOptions
     * @return {?}
     */
    moveSelectedOptions($event, isMovingSelectedOptions) {
        //debugger;
        if (!!$event.cancelable && $event.cancelable) {
            $event.preventDefault();
        }
        // Check if Add is selected?
        if (isMovingSelectedOptions) {
            // Set the selected vetted users back to non-vetted
            for (const selectedOption of this.enumerationPickerSelectedItem) {
                /** @type {?} */
                const option = this.enumerationPickerCollection.find((/**
                 * @param {?} o
                 * @return {?}
                 */
                o => o.value === selectedOption.value));
                if (!!this.enumerationPickerOpCoCollection) {
                    if (!this.enumerationPickerOpCoCollection.find((/**
                     * @param {?} o
                     * @return {?}
                     */
                    o => o.value === option.value))) {
                        this.enumerationPickerOpCoCollection.push(option);
                    }
                    else {
                        this.enumerationPickerOpCoCollection.find((/**
                         * @param {?} o
                         * @return {?}
                         */
                        o => o.value === option.value)).isDeleted = false;
                    }
                }
            }
        }
        else {
            // Set the selected items to delete.
            //debugger;
            if ((this.enumerationPickerName.includes('_ManualIsolation') || this.enumerationPickerName.includes('_HighLimit')) && this.enumerationPickerOpCoSelectedItem[0].masterTextKey == "NONE") {
                // Simple popup message box
                this.displayNotAllowedMsg('REMOVING_NONE_OPTION_FOR_THIS_LIST_IS_NOT_ALLOWED');
                return;
            }
            else if ((this.enumerationPickerName.includes('_Actuator'))) {
                this.displayNotAllowedMsg('REMOVING_ANY_OPTION_FOR_THIS_LIST_IS_NOT_ALLOWED');
                return;
            }
            else if (this.enumerationPickerName.includes('_GasketMaterial') && this.enumerationPickerOpCoSelectedItem[0].masterTextKey == "EPDMP") {
                this.displayNotAllowedMsg('REMOVING_EPDMP_OPTION_FOR_THIS_LIST_IS_NOT_ALLOWED');
                return;
            }
            else {
                for (const selectedOption of this.enumerationPickerOpCoSelectedItem) {
                    // Ensure that at least one item is left in the list.
                    if (this.enumerationPickerOpCoCollection.filter((/**
                     * @param {?} i
                     * @return {?}
                     */
                    i => i.isDeleted === false)).length > 1) {
                        selectedOption.isDeleted = true;
                    }
                }
            }
        }
        // Empty out the selected users
        //this.enumerationPickerSelectedItem = [];
        //this.enumerationPickerOpCoSelectedItem = [];
        // Reset the buttons
        this.moveOptionsDownSelected = false;
        // this.moveOptionsUpSelected = false;
        // Reset the rows (to update the view)
        this.enumerationPickerTable.rows = this.enumerationPickerCollection;
        this.enumerationPickerOpCoTable.rows = this.enumerationPickerOpCoCollection.filter((/**
         * @param {?} i
         * @return {?}
         */
        i => i.isDeleted === false));
        // Changes can be saved
        //this.moduleChangesMade = true;
        this.onChange(this.enumerationPickerOpCoCollection);
    }
    /**
     * Method to move item up/down on the OpCo selected list.
     * @param {?} $event
     * @param {?} isMovingSelectedOptionsSequence
     * @return {?}
     */
    moveSelectedOptionsSequence($event, isMovingSelectedOptionsSequence) {
        //debugger;
        if (!!$event.cancelable && $event.cancelable) {
            $event.preventDefault();
        }
        // Set the selected
        for (const selectedOption of this.enumerationPickerOpCoSelectedItem) {
            //if (selectedOption.value != 'G1') {
            /** @type {?} */
            const option = this.enumerationPickerOpCoCollection.find((/**
             * @param {?} o
             * @return {?}
             */
            o => o.value === selectedOption.value));
            /** @type {?} */
            const index = this.enumerationPickerOpCoCollection.indexOf(option);
            /** @type {?} */
            const index2 = isMovingSelectedOptionsSequence ? index + 1 : index - 1;
            //if (this.enumerationPickerName.includes('_GasketMaterial') && index2 == 0) {
            //  this.displayNotAllowedMsg('CANNOT_CHANGE_GAKSET_DEFAULT_MSG');
            //  return;
            //}
            //else {
            // Check and ensure that indexs are within range?
            if (index >= 0 && index2 >= 0) {
                this.moveSequence(this.enumerationPickerOpCoCollection, index, index2);
            }
            //}
            //}
        }
        // Empty out the selected     
        //this.enumerationPickerOpCoSelectedItem = [];
        // Reset the buttons
        //this.moveOptionsUpSelected = false;
        // Reset the rows (to update the view)
        //this.enumerationPickerOpCoTable.rows = this.enumerationPickerOpCoCollection;
        this.enumerationPickerOpCoTable.rows = this.enumerationPickerOpCoCollection.filter((/**
         * @param {?} i
         * @return {?}
         */
        i => i.isDeleted === false));
        // Changes can be saved
        //this.moduleChangesMade = true;
        this.onChange(this.enumerationPickerOpCoCollection);
    }
    /**
     * Method to move sequence of list items in line with the OpCo selection.
     * @param {?} optionList
     * @param {?} oldIndex
     * @param {?} newIndex
     * @return {?}
     */
    moveSequence(optionList, oldIndex, newIndex) {
        if (newIndex < optionList.length) {
            optionList.splice(newIndex, 0, optionList.splice(oldIndex, 1)[0]);
            return optionList;
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onActivateAddOption(event) {
        if (event.type == 'click' && !this.readOnly) {
            //console.log(event.row);
        }
        if (event.type == 'dblclick' && !this.readOnly) {
            console.log(event.row);
            this.moveSelectedOptions(event, true);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onActivateRemoveOption(event) {
        if (event.type == 'click' && !this.readOnly) {
            //console.log(event.row);
        }
        if (event.type == 'dblclick' && !this.readOnly) {
            console.log(event.row);
            this.moveSelectedOptions(event, false);
        }
    }
    /**
     * @param {?} msg
     * @return {?}
     */
    displayNotAllowedMsg(msg) {
        /** @type {?} */
        let cantRemoveNoneOptions = this.translatePipe.transform(msg);
        /** @type {?} */
        let trans_Info = this.translatePipe.transform('INFO');
        swal$2({
            title: trans_Info + ':',
            text: cantRemoveNoneOptions,
            icon: "info",
            dangerMode: true,
        }).then((/**
         * @param {?=} okbuttoncClicked
         * @return {?}
         */
        (okbuttoncClicked) => {
            console.info("Ok clicked...");
            // The parameter can also enter as null
            /** @type {?} */
            const returnVal = !(okbuttoncClicked === null);
        }));
    }
}
EnumerationPickerComponent.decorators = [
    { type: Component, args: [{
                selector: 'enumeration-picker',
                exportAs: 'enumeration-picker',
                template: "<!-- Layout for enumeration-picker\\ -->\r\n<!--Available options-->\r\n<div class=\"row\">\r\n  <div class=\"col-xs-12\">\r\n    <ngx-datatable #enumerationPickerTable\r\n                   class=\"bootstrap\"\r\n                   [headerHeight]=\"40\"\r\n                   [limit]=\"15\"\r\n                   [columnMode]=\"'force'\"\r\n                   [footerHeight]=\"40\"\r\n                   [rowHeight]=\"'auto'\"\r\n                   [rows]=\"enumerationPickerCollection\"\r\n                   [selected]=\"enumerationPickerSelectedItem\"\r\n                   [selectionType]=\"'multi'\"\r\n                   (select)=\"onEnumerationPickerSelect($event, true)\"\r\n                   (activate)=\"onActivateAddOption($event)\">\r\n\r\n      <ngx-datatable-footer>\r\n        <ng-template ngx-datatable-footer-template\r\n                     let-rowCount=\"rowCount\"\r\n                     let-pageSize=\"pageSize\"\r\n                     let-selectedCount=\"selectedCount\"\r\n                     let-curPage=\"curPage\"\r\n                     let-offset=\"offset\">\r\n        </ng-template>\r\n      </ngx-datatable-footer>\r\n\r\n      <ngx-datatable-column [name]=\"'AVAILABLE_OPTIONS' | translate\" prop=\"translationText\">\r\n        <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n          <span title=\"{{row['extraPreText']}}{{value}}{{row['extraPostText']}}\">{{row['extraPreText']}}{{value}}{{row['extraPostText']}}</span>\r\n        </ng-template>\r\n      </ngx-datatable-column>\r\n    </ngx-datatable>\r\n  </div>\r\n</div>\r\n<div class=\"panel panel-primary\" style=\"padding-bottom: 20px; padding-top: 10px; \">\r\n  <!--Add/Remove buttons-->\r\n  <div class=\"row\" [hidden]=\"readOnly\" style=\"padding-left: 10px; padding-right: 10px;\">\r\n    <div class=\"col-xs-6\">\r\n      <button (click)=\"moveSelectedOptions($event, true)\" [disabled]=\"readOnly || !moveOptionsDownSelected\" class=\"btn btn-primary btn-block\" style=\"padding-left: 10px; padding-right: 10px;\" [title]=\"'ADD' | translate\">{{\"ADD\" | translate}}</button>\r\n    </div>\r\n    <div class=\"col-xs-6\">\r\n      <button (click)=\"moveSelectedOptions($event, false)\" [disabled]=\"readOnly || !moveOptionsUpSelected\" class=\"btn btn-primary btn-block\" style=\"padding-left: 10px; padding-right: 10px;\" [title]=\"'REMOVE' | translate\">{{\"REMOVE\" | translate}}</button>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row\" [hidden]=\"!readOnly\">\r\n    <div class=\"col-xs-6\">\r\n      <label class=\"fa fa-lock fa-fw\"></label>\r\n    </div>\r\n  </div>\r\n\r\n  <!--OpCo selected options-->\r\n  <div class=\"row\" style=\"padding-left: 10px; padding-right: 10px;\">\r\n    <div class=\"col-xs-12\">\r\n      <ngx-datatable #enumerationPickerOpCoTable\r\n                     class=\"bootstrap\"\r\n                     [headerHeight]=\"40\"\r\n                     [limit]=\"15\"\r\n                     [columnMode]=\"'force'\"\r\n                     [footerHeight]=\"40\"\r\n                     [rowHeight]=\"'auto'\"\r\n                     [rows]=\"enumerationPickerOpCoCollection\"\r\n                     [selected]=\"enumerationPickerOpCoSelectedItem\"\r\n                     [selectionType]=\"'multi'\"\r\n                     (select)=\"onEnumerationPickerSelect($event, false)\"\r\n                     (activate)=\"onActivateRemoveOption($event)\">\r\n        <ngx-datatable-footer>\r\n          <ng-template ngx-datatable-footer-template\r\n                       let-rowCount=\"rowCount\"\r\n                       let-pageSize=\"pageSize\"\r\n                       let-selectedCount=\"selectedCount\"\r\n                       let-curPage=\"curPage\"\r\n                       let-offset=\"offset\">\r\n          </ng-template>\r\n        </ngx-datatable-footer>\r\n\r\n        <ngx-datatable-column [name]=\"'SELECTED_OPTIONS' | translate\" prop=\"translationText\">\r\n          <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n            <div style=\"font-weight:bolder\" *ngIf=\"rowIndex === 0\" title=\"{{row['extraPreText']}}{{value}} [{{translatePipe.transform('DEFAULT')}}]{{row['extraPostText']}}\">{{row['extraPreText']}}{{value}} [{{translatePipe.transform('DEFAULT')}}]{{row['extraPostText']}}</div>\r\n            <div style=\"font-weight:bolder\" *ngIf=\"rowIndex !== 0\" title=\"{{row['extraPreText']}}{{value}}{{row['extraPostText']}}\">{{row['extraPreText']}}{{value}}{{row['extraPostText']}}</div>\r\n          </ng-template>\r\n        </ngx-datatable-column>\r\n      </ngx-datatable>\r\n    </div>\r\n  </div>\r\n  <!--Change sequence buttons-->\r\n  <div class=\"row\" [hidden]=\"readOnly\" style=\"padding-left: 10px; padding-right: 10px;\">\r\n    <div class=\"col-xs-6\">\r\n      <button (click)=\"moveSelectedOptionsSequence($event, true)\" [disabled]=\"readOnly || !moveOptionsUpSelected\" class=\"btn btn-labeled btn-default pull-left\" style=\"padding-left: 10px; padding-right: 10px;\" [title]=\"'MOVE_DOWN' | translate\"><span class=\"btn-label\"><i class=\"fa fa-arrow-down\"></i></span>{{\"MOVE_DOWN\" | translate}}</button>\r\n    </div>\r\n    <div class=\"col-xs-6 pull-right\">\r\n      <button (click)=\"moveSelectedOptionsSequence($event, false)\" [disabled]=\"readOnly || !moveOptionsUpSelected\" class=\"btn btn-labeled btn-default pull-right\" style=\"padding-left: 10px; padding-right: 10px;\" [title]=\"'MOVE_UP' | translate\"><span class=\"btn-label\"><i class=\"fa fa-arrow-up\"></i></span>{{\"MOVE_UP\" | translate}}</button>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => EnumerationPickerComponent)),
                    }],
                styles: [".ngx-datatable.bootstrap .datatable-footer{display:none}"]
            }] }
];
/** @nocollapse */
EnumerationPickerComponent.ctorParameters = () => [
    { type: TranslationService },
    { type: FormBuilder },
    { type: TranslatePipe }
];
EnumerationPickerComponent.propDecorators = {
    enumerationPickerName: [{ type: Input, args: ["enumeration-picker-name",] }],
    readOnly: [{ type: Input, args: ["readOnly",] }],
    internalValue: [{ type: Input, args: ['value',] }],
    externalOnChange: [{ type: Output, args: ["on-change",] }],
    enumerationPickerTable: [{ type: ViewChild, args: ["enumerationPickerTable", { static: false },] }],
    enumerationPickerOpCoTable: [{ type: ViewChild, args: ["enumerationPickerOpCoTable", { static: false },] }]
};
if (false) {
    /** @type {?} */
    EnumerationPickerComponent.prototype.enumerationPickerName;
    /** @type {?} */
    EnumerationPickerComponent.prototype.readOnly;
    /** @type {?} */
    EnumerationPickerComponent.prototype.internalValue;
    /** @type {?} */
    EnumerationPickerComponent.prototype.externalOnChange;
    /** @type {?} */
    EnumerationPickerComponent.prototype.enumerationPickerTable;
    /** @type {?} */
    EnumerationPickerComponent.prototype.enumerationPickerOpCoTable;
    /** @type {?} */
    EnumerationPickerComponent.prototype.enumerationPickerCollection;
    /** @type {?} */
    EnumerationPickerComponent.prototype.internalSelectedItem;
    /** @type {?} */
    EnumerationPickerComponent.prototype.internalOpCoSelectedItem;
    /** @type {?} */
    EnumerationPickerComponent.prototype.onChange;
    /** @type {?} */
    EnumerationPickerComponent.prototype.onTouched;
    /** @type {?} */
    EnumerationPickerComponent.prototype.moveOptionsDownSelected;
    /** @type {?} */
    EnumerationPickerComponent.prototype.moveOptionsUpSelected;
    /**
     * @type {?}
     * @private
     */
    EnumerationPickerComponent.prototype.translationService;
    /**
     * @type {?}
     * @private
     */
    EnumerationPickerComponent.prototype.fb;
    /** @type {?} */
    EnumerationPickerComponent.prototype.translatePipe;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/enumeration-picker/enumeration-picker.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EnumerationPickerModule {
}
EnumerationPickerModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslationModule,
                    NgxDatatableModule
                ],
                exports: [EnumerationPickerComponent],
                declarations: [EnumerationPickerComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/preference/preference.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The Operating Company Preferences model.
 */
class Preference {
}
if (false) {
    /**
     * Gets or sets the name.
     * @type {?}
     */
    Preference.prototype.name;
    /**
     * Gets or sets the label.
     * @type {?}
     */
    Preference.prototype.label;
    /**
     * Gets or sets the value.
     * @type {?}
     */
    Preference.prototype.value;
    /**
     * Gets or sets the number of decima places.
     * @type {?}
     */
    Preference.prototype.decimalPlaces;
    /**
     * Gets or sets a value indicating whether or not the current preference is a unit.
     * @type {?}
     */
    Preference.prototype.isUnit;
    /**
     * Gets or sets the unit name, if the preference is a unit.
     * @type {?}
     */
    Preference.prototype.unitName;
    /**
     * Gets or sets the master text key, if the preference is a unit.
     * @type {?}
     */
    Preference.prototype.masterTextKey;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/preference/preference.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PreferenceComponent {
    /**
     * @param {?} unitsService
     */
    constructor(unitsService) {
        this.unitsService = unitsService;
        this.requiresDecimals = false;
        /* Boilerplate directive component code */
        this.internalValue = null;
        this.onChange = (/**
         * @return {?}
         */
        () => { });
        this.onTouched = (/**
         * @return {?}
         */
        () => { });
        this.minDecimalPlaces = 0;
        this.maxDecimalPlaces = 5;
    }
    /**
     * @return {?}
     */
    get preference() {
        return this.internalValue;
    }
    /**
     * @param {?} pref
     * @return {?}
     */
    set preference(pref) {
        // Provide a default if nothing has been provided.
        if (!!pref && !pref.value) {
            pref.value = this.defaultValue;
        }
        if (!!pref && !pref.label) {
            pref.label = this.unitLabel;
        }
        this.internalValue = pref;
        this.onChange(this.internalValue);
        this.onTouched();
    }
    /**
     * Gets the units that matches the specified \@Input Unit Type.
     * @return {?} The array of units sorted by Name.
     */
    get unitCollection() {
        //const units = this.unitsService.units.filter(us => us.unitType === this.unitType);
        //const units = this.unitsService.units.filter(us => us.unitType === this.unitType);
        //RPU 21 / 09 / 2022 - bug fix #6330 above line of code have been replaced with the one below(extra filtering has been added)
        /** @type {?} */
        const units = this.unitsService.units.filter((/**
         * @param {?} us
         * @return {?}
         */
        us => us.unitType === this.unitType)).filter((/**
         * @param {?} us
         * @return {?}
         */
        us => (this.unitType == 'MassFlowUnits' || this.unitType == 'VolumetricFlowUnits') ? !us.units.includes('/yr') : us));
        return units.sort((/**
         * @param {?} currentUnit
         * @param {?} nextUnit
         * @return {?}
         */
        (currentUnit, nextUnit) => {
            if (currentUnit.name > nextUnit.name) {
                return 1;
            }
            if (currentUnit.name < nextUnit.name) {
                return -1;
            }
            return 0;
        }));
    }
    /**
     * Registers any changes to the directive and applies the provided callback function.
     * @param {?} fn The callback function.
     * @return {?}
     */
    registerOnChange(fn) {
        /** @type {?} */
        const bespokeChange = (/**
         * @param {?} newValue
         * @param {?} changeType
         * @return {?}
         */
        (newValue, changeType) => {
            // The prefernce is still in memory, so only apply the changed value.
            if (changeType === 'value') {
                this.preference.value = newValue;
            }
            else if (changeType === 'decimalPlaces') {
                this.preference.decimalPlaces = newValue;
            }
            fn(this.preference);
        });
        this.onChange = bespokeChange;
    }
    /**
     * Registers the touched event to the directive and applies the provided callback function.
     * @param {?} fn The callback function.
     * @return {?}
     */
    registerOnTouched(fn) {
        /** @type {?} */
        const bespokeTouched = (/**
         * @return {?}
         */
        () => {
            fn();
        });
        this.onTouched = bespokeTouched;
    }
    /**
     * Registers a final change to the provided directive's value and provides a space to apply it.
     * @param {?} value The directive's implicit value.
     * @return {?}
     */
    writeValue(value) {
        if (value) {
            this.preference = value;
        }
    }
    /**
     * Callback event that rationalises the number of decimal places.
     * @param {?} decimalPlaces The number of decimal places.
     * @return {?}
     */
    changeDecimalPlaces(decimalPlaces) {
        // Normalise the number in case anyone gets any ideas.
        if (decimalPlaces <= this.minDecimalPlaces) {
            decimalPlaces = this.minDecimalPlaces;
        }
        if (decimalPlaces >= this.maxDecimalPlaces) {
            decimalPlaces = this.maxDecimalPlaces;
        }
        // Do not return anything, but set the value implicitly.
        this.preference.decimalPlaces = decimalPlaces;
        // This has been changed
        //this.onChange(this.preference);
        this.onChange(this.preference.decimalPlaces, 'decimalPlaces');
    }
}
PreferenceComponent.decorators = [
    { type: Component, args: [{
                selector: 'preference',
                exportAs: 'preference',
                template: "<!-- Layout for preferences that DO require decimal places -->\r\n<div class=\"form-group\" *ngIf=\"!!requiresDecimals\">\r\n  <div class=\"col-lg-3 col-md-12 col-xs-12 text-right\">\r\n    <label class=\"control-label\">{{preference.label | translate}}</label>\r\n  </div>\r\n\r\n\r\n  <div class=\"col-lg-2 col-xs-4\">\r\n    <input autocomplete=\"off\" type=\"number\" style=\"min-width:55px;\" (blur)=\"onTouched()\" (change)=\"changeDecimalPlaces(preference.decimalPlaces)\" [(ngModel)]=\"preference.decimalPlaces\" [min]=\"minDecimalPlaces\" [max]=\"maxDecimalPlaces\" class=\"form-control\" />\r\n  </div>\r\n  <div class=\"col-lg-4 col-xs-8\">\r\n    <select class=\"form-control\" (blur)=\"onTouched()\" (ngModelChange)=\"onChange($event, 'value')\" [ngModel]=\"preference.value\">\r\n      <option *ngFor=\"let unit of unitCollection\" [value]=\"unit.id\">{{unit.masterTextKey | translate}}</option>\r\n    </select>\r\n  </div>\r\n</div>\r\n\r\n\r\n<!-- Layout for preferences that DO NOT require decimal places -->\r\n<div class=\"form-group\" *ngIf=\"!requiresDecimals\">\r\n  <div class=\"col-lg-4 col-md-12 col-xs-12 text-right\">\r\n    <label class=\"control-label\">{{preference.label | translate}}</label>\r\n  </div>\r\n\r\n  <div class=\"col-lg-4 col-xs-12\">\r\n    <select class=\"form-control\" (blur)=\"onTouched()\" (ngModelChange)=\"onChange($event, 'value')\" [ngModel]=\"preference.value\">\r\n      <option *ngFor=\"let unit of unitCollection\" [value]=\"unit.id\">{{unit.masterTextKey | translate}}</option>\r\n    </select>\r\n  </div>\r\n</div>\r\n",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => PreferenceComponent)),
                    }],
                styles: [""]
            }] }
];
/** @nocollapse */
PreferenceComponent.ctorParameters = () => [
    { type: UnitsService }
];
PreferenceComponent.propDecorators = {
    unitType: [{ type: Input, args: ["unit-type",] }],
    unitLabel: [{ type: Input, args: ["unit-label",] }],
    defaultValue: [{ type: Input, args: ["default-value",] }],
    requiresDecimals: [{ type: Input, args: ["requires-decimals",] }],
    internalValue: [{ type: Input, args: ['value',] }]
};
if (false) {
    /** @type {?} */
    PreferenceComponent.prototype.unitType;
    /** @type {?} */
    PreferenceComponent.prototype.unitLabel;
    /** @type {?} */
    PreferenceComponent.prototype.defaultValue;
    /** @type {?} */
    PreferenceComponent.prototype.requiresDecimals;
    /** @type {?} */
    PreferenceComponent.prototype.internalValue;
    /** @type {?} */
    PreferenceComponent.prototype.onChange;
    /** @type {?} */
    PreferenceComponent.prototype.onTouched;
    /** @type {?} */
    PreferenceComponent.prototype.minDecimalPlaces;
    /** @type {?} */
    PreferenceComponent.prototype.maxDecimalPlaces;
    /**
     * @type {?}
     * @private
     */
    PreferenceComponent.prototype.unitsService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/preference/sizing-unit-preference.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SizingUnitPreference {
}
if (false) {
    /**
     * Gets or sets the preference.
     * @type {?}
     */
    SizingUnitPreference.prototype.preference;
    /**
     * Gets or sets the unit type.
     * @type {?}
     */
    SizingUnitPreference.prototype.unitType;
    /**
     * Gets or sets the units.
     * @type {?}
     */
    SizingUnitPreference.prototype.units;
    /**
     * Gets or sets the currencies.
     * @type {?}
     */
    SizingUnitPreference.prototype.currencies;
    /**
     * Gets or sets the masterTextKey.
     * Defined in the parent html template [display-masterTextKey], used to extract the translated UI label.
     * @type {?}
     */
    SizingUnitPreference.prototype.masterTextKey;
    /**
     * Gets or sets the moduleGroupId.
     * @type {?}
     */
    SizingUnitPreference.prototype.moduleGroupId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/preference/preference.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PreferenceService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
        // Exposed field and private subject for when preferences change.
        this.allPreferences = null;
        this.allPreferencesChange = new Subject();
        // Exposed field and private subject for when a new preference and unit type
        // is added for unit selection during a sizing process.
        this.sizingUnitPreferences = [];
        this.sizingUnitPreferencesUpdate = new Subject();
        this.sizingUnitPreferenceChange = new Subject();
        // Create a subscriber for when preferences change.
        console.log('prefernce service created..');
        this.allPreferencesChange.subscribe((/**
         * @param {?} preferences
         * @return {?}
         */
        (preferences) => {
            this.allPreferences = preferences;
            console.log("all Preferences changed -" + this.allPreferences);
        }));
        // Create a subscriber for when a new sizing unit preference is added.
        this.sizingUnitPreferenceChange.subscribe((/**
         * @param {?} sizingUnitPreference
         * @return {?}
         */
        (sizingUnitPreference) => {
            // Reset sizing preferences for new modules.
            if (this.sizingUnitPreferences.filter((/**
             * @param {?} p
             * @return {?}
             */
            p => p.moduleGroupId != sizingUnitPreference.moduleGroupId)).length > 0) {
                this.sizingUnitPreferences = [];
                console.log("Reset units preference because there exists some non module group preferences");
            }
            // Check if the preference is already added
            /** @type {?} */
            const sizingPref = this.sizingUnitPreferences.find((/**
             * @param {?} s
             * @return {?}
             */
            s => !!s && s.preference.name === sizingUnitPreference.preference.name &&
                s.unitType === sizingUnitPreference.unitType));
            // Remove if it exists
            if (!!sizingPref) {
                /** @type {?} */
                const index = this.sizingUnitPreferences.indexOf(sizingPref);
                if (index > -1) {
                    this.sizingUnitPreferences.splice(index, 1);
                }
            }
            // Add the new preference
            this.sizingUnitPreferences.push(sizingUnitPreference);
            this.sizingUnitPreferencesUpdate.next({ list: this.sizingUnitPreferences, updated: sizingUnitPreference });
            console.log("New preference added " + sizingUnitPreference.unitType);
        }));
    }
    /**
     * @return {?}
     */
    clearUnitPreferences() {
        this.sizingUnitPreferences = [];
    }
    /**
     * Gets all operating company specific preferences.
     * @return {?}
     */
    getOperatingCompanyPreferences() {
        return this.http.get(`./Api/Admin/GetOperatingCompanyPreferences`);
    }
    /**
     * Gets all user specific preferences.
     * @return {?}
     */
    getUserPreferences() {
        return this.http.get(`./Api/Admin/GetUserPreferences`);
    }
    /**
     * Manages the specified preferences for the operating company Id assigned to the current user.
     * @param {?} preferences The array of preferences.
     * @return {?}
     */
    manageOperatingCompanyPreferences(preferences) {
        return this.http.post(`./Api/Admin/ManageOperatingCompanyPreferences`, preferences);
    }
    /**
     * Manages the specified preferences for the current user.
     * @param {?} preferences The array of preferences.
     * @return {?}
     */
    manageUserPreferences(preferences) {
        return this.http.post(`./Api/Admin/ManageUserPreferences`, preferences);
    }
    /**
     * Gets all preferences for the current user.
     * @return {?}
     */
    getAllPreferences() {
        return this.http.get(`./Api/Admin/GetAllPreferences`).map((/**
         * @param {?} preferences
         * @return {?}
         */
        (preferences) => {
            //debugger;
            /*********************************************************************************************************************************************
             * RPU 01/07/2022 code below set up default values for BoilerHouseSmallMassFlowUnits & BoilerHouseSmallVolumetricFlowUnits based on selected *
             * unit preferences for "BoilerHouseMassFlowUnits" & BoilerHouseVolumetricFlowUnits                                                                        *
             *                                                                                                                                           *
             * NOTICE!!! this code have been moved on to Admin solution as part of method "GetUserPreferences" within "Admin.Logic" layer                *
             *********************************************************************************************************************************************/
            //if (preferences.find(pref => pref.name == 'BoilerHouseSmallMassFlowUnits')) {
            //  for (let pref of preferences) {
            //    if (pref.name == 'BoilerHouseSmallVolumetricFlowUnits' && pref.unitName == null) {
            //      var lookUpVolumetricFlow = preferences.find(pref => pref.name == 'BoilerHouseVolumetricFlowUnits');
            //      if (lookUpVolumetricFlow.unitName.includes('(UK)')) {
            //          pref.value = '80',
            //          pref.decimalPlaces = 2,
            //          pref.unitName = 'gallon/h (UK)',
            //          pref.masterTextKey = 'UNIT_GALLON_FSLASH_H_UK'
            //      }
            //      else if (lookUpVolumetricFlow.unitName.includes('(US)')) {
            //          pref.value = '82',
            //          pref.decimalPlaces = 2,
            //          pref.unitName = 'gallon/h (US)',
            //          pref.masterTextKey = 'UNIT_GALLON_FSLASH_H_US'
            //      }
            //      else {
            //          pref.value = '76',
            //          pref.decimalPlaces = 2,
            //          pref.unitName = 'm³/h',
            //          pref.masterTextKey = 'UNIT_M3_FSLASH_H'
            //      }
            //    }
            //    if (pref.name == 'BoilerHouseSmallMassFlowUnits' && pref.unitName == null) {
            //      var lookUpMassFlow = preferences.find(pref => pref.name == '"BoilerHouseMassFlowUnits"');
            //      if (lookUpMassFlow.unitName.includes('(UK)') || lookUpMassFlow.unitName.includes('tonnes')) {
            //          pref.value = '84',
            //          pref.decimalPlaces = 2,
            //          pref.unitName = 'kg/h',
            //          pref.masterTextKey = 'UNIT_KG_FSLASH_H'
            //      }
            //      else { //if includes '(US)' or 'klb'))
            //          pref.value = '86',
            //          pref.decimalPlaces = 2,
            //          pref.unitName = 'lb/h',
            //          pref.masterTextKey = 'UNIT_LB_FSLASH_H'
            //      }
            //    }
            //  }
            //}
            // Publish the next set of changes to the subject.
            this.allPreferencesChange.next(preferences);
            return preferences;
        }));
    }
    /**
     * Inspects the specified preference and returns a rationalised object if no match was found.
     * @param {?} preferences
     * @param {?} prefName
     * @param {?=} prefLabel
     * @return {?}
     */
    rationalisePreferenceObjectByName(preferences, prefName, prefLabel) {
        /** @type {?} */
        let specifiedPreference;
        if (!!preferences) {
            specifiedPreference = preferences.find((/**
             * @param {?} o
             * @return {?}
             */
            o => o.name === prefName));
            // Return only if a valid preference is found
            if (!!specifiedPreference) {
                return specifiedPreference;
            }
        }
        // Return a new preference, with default values.
        specifiedPreference = new Preference();
        specifiedPreference.name = prefName;
        specifiedPreference.label = prefLabel;
        specifiedPreference.decimalPlaces = 0;
        specifiedPreference.value = null;
        return specifiedPreference;
    }
    /**
     * Adds the specified preference name and unit type to a subject so that it can be interrogated later.
     * @param {?} preference The preference.
     * @param {?} unitType {String} The unit type.
     * @param {?} masterTextKey {String} The modal label translation.
     * @param {?} moduleGroupId {Number} The module group ID.
     * @param {?=} units The list of units.
     * @param {?=} currencies The list of units.
     * @return {?}
     */
    addSizingUnitPreference(preference, unitType, masterTextKey, moduleGroupId, units, currencies) {
        /** @type {?} */
        const sizingUnitPreference = new SizingUnitPreference();
        sizingUnitPreference.preference = preference;
        sizingUnitPreference.unitType = unitType;
        sizingUnitPreference.masterTextKey = masterTextKey;
        sizingUnitPreference.units = units;
        sizingUnitPreference.currencies = currencies;
        sizingUnitPreference.moduleGroupId = moduleGroupId;
        this.sizingUnitPreferenceChange.next(sizingUnitPreference);
        //console.log("addingSizingPreference " + this.sizingUnitPreferences);
    }
    /*
       * Gets the preference details by pref name.
       */
    /**
     * @param {?} preferenceName
     * @return {?}
     */
    getUserPreferenceByName(preferenceName) {
        if (this.allPreferences == null) {
            return null;
        }
        /** @type {?} */
        let specifiedPreference = this.allPreferences.find((/**
         * @param {?} o
         * @return {?}
         */
        o => o.name === preferenceName));
        return specifiedPreference;
    }
}
PreferenceService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
PreferenceService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ PreferenceService.ngInjectableDef = ɵɵdefineInjectable({ factory: function PreferenceService_Factory() { return new PreferenceService(ɵɵinject(HttpClient)); }, token: PreferenceService, providedIn: "root" });
if (false) {
    /** @type {?} */
    PreferenceService.prototype.allPreferences;
    /**
     * @type {?}
     * @private
     */
    PreferenceService.prototype.allPreferencesChange;
    /** @type {?} */
    PreferenceService.prototype.sizingUnitPreferences;
    /** @type {?} */
    PreferenceService.prototype.sizingUnitPreferencesUpdate;
    /**
     * @type {?}
     * @private
     */
    PreferenceService.prototype.sizingUnitPreferenceChange;
    /**
     * @type {?}
     * @private
     */
    PreferenceService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/preference/display-preference.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DisplayPreferenceDirective {
    /**
     * @param {?} preferenceService
     */
    constructor(preferenceService) {
        this.preferenceService = preferenceService;
        this.pending = false;
        this.cloneDeep = cloneDeep_;
    }
    /**
     * @return {?}
     */
    get preference() {
        if (!!this.displayPreference === false) {
            return null;
        }
        /** @type {?} */
        const sizingUnitPreference = this.preferenceService.sizingUnitPreferences &&
            this.preferenceService.sizingUnitPreferences.find((/**
             * @param {?} su
             * @return {?}
             */
            su => su.preference && su.preference.name === this.displayPreference));
        return !!sizingUnitPreference ? sizingUnitPreference.preference : null;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.displayPreference) {
            console.log('initializing display directive for ' + this.displayPreference);
            /** @type {?} */
            const sizingUnitPreference = this.preferenceService.sizingUnitPreferences &&
                this.preferenceService.sizingUnitPreferences.find((/**
                 * @param {?} su
                 * @return {?}
                 */
                su => su.preference && su.preference.name === this.displayPreference && su.moduleGroupId === this.moduleGroupId));
            if (!sizingUnitPreference) {
                console.log("unit preference does not exist so adding it");
                // Clone the object so that it does not interfere with the original preferences.
                /** @type {?} */
                const preference = this.cloneDeep(this.preference || this.preferenceService.allPreferences.find((/**
                 * @param {?} prefs
                 * @return {?}
                 */
                prefs => prefs.name === this.displayPreference)));
                ;
                if (!!preference && preference.isUnit && !!this.unitType === false) {
                    console.error(`The preference '${this.displayPreference}' is a unit, but no 'display-preference-unit-type' parameter was provided.`);
                }
                // Add the preference name and unit type to the preference service, so that it can be used later (e.g. the unit modal component).
                this.preferenceService.addSizingUnitPreference(preference, this.unitType, this.displayMasterTextKey, this.moduleGroupId);
            }
        }
    }
}
DisplayPreferenceDirective.decorators = [
    { type: Injectable },
    { type: Directive, args: [{
                selector: "[display-preference]",
                exportAs: "display-preference"
            },] }
];
/** @nocollapse */
DisplayPreferenceDirective.ctorParameters = () => [
    { type: PreferenceService }
];
DisplayPreferenceDirective.propDecorators = {
    displayPreference: [{ type: Input, args: ["display-preference",] }],
    unitType: [{ type: Input, args: ["display-preference-unit-type",] }],
    displayMasterTextKey: [{ type: Input, args: ["display-masterTextKey",] }],
    moduleGroupId: [{ type: Input, args: ["display-preference-module-group-id",] }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    DisplayPreferenceDirective.prototype.pending;
    /** @type {?} */
    DisplayPreferenceDirective.prototype.cloneDeep;
    /**
     * @type {?}
     * @private
     */
    DisplayPreferenceDirective.prototype.displayPreference;
    /**
     * @type {?}
     * @private
     */
    DisplayPreferenceDirective.prototype.unitType;
    /**
     * @type {?}
     * @private
     */
    DisplayPreferenceDirective.prototype.displayMasterTextKey;
    /**
     * @type {?}
     * @private
     */
    DisplayPreferenceDirective.prototype.moduleGroupId;
    /**
     * @type {?}
     * @private
     */
    DisplayPreferenceDirective.prototype.preferenceService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/preference/preference-decimal.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PreferenceDecimalPipe {
    /**
     * @param {?} preferenceService
     */
    constructor(preferenceService) {
        this.preferenceService = preferenceService;
    }
    /**
     * Transforms the provided value and rounds it to the decimal places based
     * on the preference provided by the preferenceName parameter.
     * @param {?} value
     * @param {?} preferenceName
     * @return {?}
     */
    transform(value, preferenceName) {
        if (!value) {
            return value;
        }
        /** @type {?} */
        const preference = this.preferenceService.allPreferences.find((/**
         * @param {?} p
         * @return {?}
         */
        p => p.name === preferenceName));
        /** @type {?} */
        const roundedValue = Math.round(value * Math.pow(10, preference.decimalPlaces)) / Math.pow(10, preference.decimalPlaces);
        return roundedValue;
    }
}
PreferenceDecimalPipe.decorators = [
    { type: Pipe, args: [{
                name: 'preferenceDecimal',
                pure: false
            },] }
];
/** @nocollapse */
PreferenceDecimalPipe.ctorParameters = () => [
    { type: PreferenceService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    PreferenceDecimalPipe.prototype.preferenceService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/preference/preference.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PreferenceModule {
}
PreferenceModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslationModule
                ],
                exports: [PreferenceComponent, DisplayPreferenceDirective, PreferenceDecimalPipe],
                providers: [PreferenceDecimalPipe, PreferenceService],
                declarations: [PreferenceComponent, DisplayPreferenceDirective, PreferenceDecimalPipe]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/units/units.modal.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UnitsModalComponent {
    /**
     * @param {?} preferenceService
     * @param {?} unitsService
     */
    constructor(preferenceService, unitsService) {
        this.preferenceService = preferenceService;
        this.unitsService = unitsService;
        this.parentSubmitIsDisabled = true; // Modal parent container component submit button state (enabled/disabled)
        // Modal parent container component submit button state (enabled/disabled)
        this.cloneDeep = cloneDeep_;
        this.moduleGroupId = 0;
        this.selectableUnitPreferences = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        // Get all the units
        this.unitsService.getAllUnitsByAllTypes().subscribe((/**
         * @param {?} units
         * @return {?}
         */
        (units) => {
            // Get all the preferences eligble for changing and sort by unit type.
            /** @type {?} */
            const sizingUnitPreferences = this.preferenceService.sizingUnitPreferences.sort((/**
             * @param {?} currentUnitPreference
             * @param {?} nextUnitPreference
             * @return {?}
             */
            (currentUnitPreference, nextUnitPreference) => {
                this.moduleGroupId = currentUnitPreference.moduleGroupId;
                if (currentUnitPreference.unitType > nextUnitPreference.unitType) {
                    return 1;
                }
                if (currentUnitPreference.unitType < nextUnitPreference.unitType) {
                    return -1;
                }
                return 0;
            }));
            for (let sizingUnitPreference of sizingUnitPreferences) {
                /** @type {?} */
                const selectableUnitPreference = new SizingUnitPreference();
                // Deep copy the object
                selectableUnitPreference.preference = this.cloneDeep(sizingUnitPreference.preference);
                selectableUnitPreference.unitType = sizingUnitPreference.unitType;
                selectableUnitPreference.masterTextKey = sizingUnitPreference.masterTextKey;
                selectableUnitPreference.moduleGroupId = this.moduleGroupId;
                selectableUnitPreference.currencies = sizingUnitPreference.currencies;
                // Get the relevant units
                selectableUnitPreference.units = sizingUnitPreference.units
                    || units.filter((/**
                     * @param {?} u
                     * @return {?}
                     */
                    u => u.unitType === sizingUnitPreference.unitType));
                // Add the new item to the array.
                this.selectableUnitPreferences.push(selectableUnitPreference);
            }
        }));
    }
    /**
     * Callback function that is dynamically called by a modal popup when "Save/Submit/Ok" is clicked.
     * @return {?}
     */
    modalSubmitCallback() {
        // This is the OK event, so commit the changes
        for (var selectedUnitPreference of this.selectableUnitPreferences) {
            // Publish the new changes.
            this.preferenceService.addSizingUnitPreference(selectedUnitPreference.preference, selectedUnitPreference.unitType, selectedUnitPreference.masterTextKey, selectedUnitPreference.moduleGroupId, selectedUnitPreference.units, selectedUnitPreference.currencies);
        }
    }
    /**
     * Support this method is you require Modal Submit button state handling. ie. disable the submit button if any validation errors exist.
     * @return {?}
     */
    checkIfSubmitIsDisabled() {
        return this.parentSubmitIsDisabled;
    }
    /**
     * @param {?} newValue
     * @param {?} unitPreference
     * @return {?}
     */
    onChange(newValue, unitPreference) {
        /** @type {?} */
        const index = this.selectableUnitPreferences.indexOf(unitPreference);
        if (index > -1) {
            /** @type {?} */
            const matchedPreference = this.selectableUnitPreferences[index];
            // Get the new unit
            /** @type {?} */
            let unit;
            if (matchedPreference.currencies) {
                unit = matchedPreference.currencies.find((/**
                 * @param {?} __0
                 * @return {?}
                 */
                ({ currencyCode }) => currencyCode === newValue));
                matchedPreference.preference.unitName = unit.symbol;
            }
            else {
                unit = matchedPreference.units.find((/**
                 * @param {?} __0
                 * @return {?}
                 */
                ({ id }) => id === parseInt(newValue)));
                matchedPreference.preference.unitName = unit.units;
            }
            // Update the object
            matchedPreference.preference.value = newValue;
            matchedPreference.preference.masterTextKey = unit.masterTextKey;
            this.selectableUnitPreferences[index] = matchedPreference;
            this.parentSubmitIsDisabled = false; // signal parent modal to enable Submit button
        }
    }
}
UnitsModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'units-modal',
                template: "\r\n<div *ngFor=\"let unitPreference of selectableUnitPreferences\" class=\"form-group\">\r\n  <div class=\"col-lg-6 col-xs-12 text-center\">\r\n    {{unitPreference.masterTextKey | translate}}\r\n  </div>\r\n  <div class=\"col-lg-6 col-xs-12\">\r\n    <select class=\"form-control\"\r\n            (ngModelChange)=\"onChange($event, unitPreference)\"\r\n            [ngModel]=\"unitPreference.preference.value\">\r\n      <ng-container *ngIf=\"unitPreference?.currencies?.length; else defaultTemplate;\">\r\n        <option *ngFor=\"let unit of unitPreference.currencies\" [value]=\"unit.currencyCode\">\r\n          {{unit.currencyCode}} - {{unit.symbol}}\r\n        </option>\r\n      </ng-container>\r\n      <ng-template #defaultTemplate>\r\n        <option *ngFor=\"let unit of unitPreference.units\" [value]=\"unit.id\">{{unit.masterTextKey | translate}}</option>\r\n      </ng-template>\r\n    </select>\r\n  </div>\r\n</div>\r\n\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
UnitsModalComponent.ctorParameters = () => [
    { type: PreferenceService },
    { type: UnitsService }
];
if (false) {
    /** @type {?} */
    UnitsModalComponent.prototype.parentSubmitIsDisabled;
    /** @type {?} */
    UnitsModalComponent.prototype.cloneDeep;
    /**
     * @type {?}
     * @private
     */
    UnitsModalComponent.prototype.moduleGroupId;
    /** @type {?} */
    UnitsModalComponent.prototype.selectableUnitPreferences;
    /**
     * @type {?}
     * @private
     */
    UnitsModalComponent.prototype.preferenceService;
    /**
     * @type {?}
     * @private
     */
    UnitsModalComponent.prototype.unitsService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/units/units.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UnitsModule {
}
UnitsModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    TranslationModule
                ],
                declarations: [UnitsModalComponent],
                exports: [UnitsModalComponent],
                providers: [UnitsService]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/module-ribbon/module-ribbon.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModuleRibbonComponent {
    /**
     * @param {?} menuService
     * @param {?} userProfileService
     */
    constructor(menuService, userProfileService) {
        this.menuService = menuService;
        this.userProfileService = userProfileService;
        this.moduleGroups = [];
        this.moduleIdentifier = "";
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.userProfileService.getUserDetails().subscribe((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            this.user = user;
        }));
    }
    /**
     * @param {?} masterTextKey
     * @return {?}
     */
    getRoute(masterTextKey) {
        // Get the menu item based on the module group's master text key and identifier
        /** @type {?} */
        const menuItem = this.menuService.menuItems.find((/**
         * @param {?} mu
         * @return {?}
         */
        mu => mu[this.moduleIdentifier] === true && mu.text === masterTextKey));
        if (!!menuItem) {
            if (!!menuItem.displayOperatingCompany && !!this.user) {
                this.operatingCompany = " : " + this.user.operatingCompanyName;
            }
            else {
                this.operatingCompany = "";
            }
            return menuItem.link;
        }
        return null;
    }
    /**
     * @param {?} masterTextKey
     * @return {?}
     */
    getIcon(masterTextKey) {
        // Get the menu item based on the module group's master text key and identifier
        /** @type {?} */
        const menuItem = this.menuService.menuItems.find((/**
         * @param {?} mu
         * @return {?}
         */
        mu => mu[this.moduleIdentifier] === true && mu.text === masterTextKey));
        if (!!menuItem) {
            return menuItem.icon;
        }
        return null;
    }
    /**
     * Determines which image dimension to use on image load (width or height of 100px).
     * @param {?} image
     * @return {?}
     */
    useWidthOrHeight(image) {
        /** @type {?} */
        const useWidth = image.naturalWidth > image.naturalHeight;
        // Assign a new property to the image.
        // @ts-ignore
        image["useWidth"] = useWidth;
    }
}
ModuleRibbonComponent.decorators = [
    { type: Component, args: [{
                selector: 'module-ribbon',
                exportAs: 'module-ribbon',
                template: "<!-- Iterate through the modules here -->\r\n<!-- Enter the module Identifier as a CSS class here so that each layout could be customised if needed e.g. the Home screen -->\r\n<div class=\"module-ribbon-container\" [class]=\"moduleIdentifier\" *ngFor=\"let moduleGroup of moduleGroups\">\r\n\r\n  <!--[title] is the tooltip text-->\r\n  <a class=\"btn btn-primary btn-outline module-ribbon\" [title]=\"moduleGroup.masterTextKey | translate:true\" *ngIf=\"!!moduleGroup\" [routerLink]=\"getRoute(moduleGroup.masterTextKey)\" routerLinkActive=\"active\">\r\n    <div class=\"module-image-container\" style=\"margin-bottom:10px; margin-top:10px; \">\r\n      <span class=\"module-icon\"> <i [class]=\"getIcon(moduleGroup.masterTextKey)\" style=\"font-size: 85px\"></i> </span>\r\n    </div>\r\n\r\n    <!-- Button Text in vertical ribbon --->\r\n    <span class=\"text-center module-text\">{{moduleGroup.masterTextKey | translate:true}}</span>\r\n  </a>\r\n</div>\r\n",
                styles: [".module-ribbon{margin:0 5px 5px 0;padding:0;white-space:pre-wrap;overflow:visible;text-overflow:ellipsis;min-width:60px;width:100%;max-width:110px;height:170px;float:left}@media (min-width:768px){.module-ribbon{float:left}}@media (min-width:992px){.module-ribbon{display:block}}@media (min-width:1200px){.module-ribbon{display:block}}.module-ribbon .module-image-container{height:80px;margin:2px 0}.module-ribbon .module-image-container .image-positioner{display:inline-block;height:100%;vertical-align:middle}.module-ribbon .module-image-container img{vertical-align:middle}.module-ribbon .module-image-container .module-img-width{max-width:80px;height:auto}.module-ribbon .module-image-container .module-img-height{max-height:80px;height:auto}.module-ribbon .module-image-container .module-icon{font-size:55px}.isSizingModule .module-ribbon{margin:0 30px 30px 0;max-width:180px;height:150px}.isSizingModule .module-ribbon .module-icon{font-size:60px}.isSizingModule .module-ribbon .module-text{font-size:1.2em}"]
            }] }
];
/** @nocollapse */
ModuleRibbonComponent.ctorParameters = () => [
    { type: MenuService },
    { type: UserProfileService }
];
ModuleRibbonComponent.propDecorators = {
    moduleGroups: [{ type: Input, args: ['module-groups',] }],
    moduleIdentifier: [{ type: Input, args: ['module-identifier',] }]
};
if (false) {
    /** @type {?} */
    ModuleRibbonComponent.prototype.user;
    /** @type {?} */
    ModuleRibbonComponent.prototype.operatingCompany;
    /** @type {?} */
    ModuleRibbonComponent.prototype.moduleGroups;
    /** @type {?} */
    ModuleRibbonComponent.prototype.moduleIdentifier;
    /**
     * @type {?}
     * @private
     */
    ModuleRibbonComponent.prototype.menuItem;
    /**
     * @type {?}
     * @private
     */
    ModuleRibbonComponent.prototype.menuService;
    /**
     * @type {?}
     * @private
     */
    ModuleRibbonComponent.prototype.userProfileService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/product-selector/product-selector.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductSelectorService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * Gets all product ranges for the given module group Id.
     * @param {?} moduleGroupId The Module Group Id.
     * @param {?} productTypeId
     * @return {?}
     */
    getAllProductRanges(moduleGroupId, productTypeId) {
        return this.http.get(`./Api/safetyvalves/GetAllProductRanges/${moduleGroupId}/${productTypeId}`);
    }
    /**
     * @param {?} moduleGroupId
     * @return {?}
     */
    getProductExclusionRanges(moduleGroupId) {
        return this.http.get(`./Api/SafetyValves/GetProductExclusionRanges/${moduleGroupId}`);
    }
}
ProductSelectorService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ProductSelectorService.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    ProductSelectorService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/product-selector/product-selection.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductSelection {
}
if (false) {
    /**
     * Gets or sets the product names for the product range.
     * @type {?}
     */
    ProductSelection.prototype.productNames;
    /**
     * Gets or sets the product range Id.
     * @type {?}
     */
    ProductSelection.prototype.productRangeId;
    /**
     * Gets or sets the product range name.
     * @type {?}
     */
    ProductSelection.prototype.productRangeName;
    /**
     * Gets or sets the module group Id.
     * @type {?}
     */
    ProductSelection.prototype.moduleGroupId;
    /**
     * Gets or sets the product type Id.
     * @type {?}
     */
    ProductSelection.prototype.productTypeId;
    /**
     * Gets or sets a value indicating whether or not the current product range is selected.
     * @type {?}
     */
    ProductSelection.prototype.isSelected;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/product-selector/product-selector.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductSelectorComponent {
    /**
     * @param {?} productSelectorService
     */
    constructor(productSelectorService) {
        this.productSelectorService = productSelectorService;
        this.productSelectorOnChange = new EventEmitter();
        this.moduleGroupId = 0;
        this.productTypeId = 0;
        this.products = [];
        /* Boilerplate directive component code */
        this.internalValue = null;
        this.onChange = (/**
         * @return {?}
         */
        () => { });
        this.onTouched = (/**
         * @return {?}
         */
        () => { });
    }
    /**
     * @return {?}
     */
    get selectedProducts() {
        return this.internalValue;
    }
    /**
     * @param {?} products
     * @return {?}
     */
    set selectedProducts(products) {
        this.internalValue = products;
        this.onChange(this.internalValue);
        this.onTouched();
    }
    /**
     * @param {?} __0
     * @return {?}
     */
    validate({ value }) {
        /** @type {?} */
        const isNotValid = this.selectedProducts.length === 0;
        return isNotValid && {
            invalid: true
        };
    }
    /**
     * Registers any changes to the directive and applies the provided callback function.
     * @param {?} fn The callback function.
     * @return {?}
     */
    registerOnChange(fn) {
        /** @type {?} */
        const bespokeChange = (/**
         * @param {?} newValue
         * @return {?}
         */
        (newValue) => {
            fn(newValue);
        });
        this.onChange = bespokeChange;
    }
    /**
     * Registers the touched event to the directive and applies the provided callback function.
     * @param {?} fn The callback function.
     * @return {?}
     */
    registerOnTouched(fn) {
        /** @type {?} */
        const bespokeTouched = (/**
         * @return {?}
         */
        () => {
            fn();
        });
        this.onTouched = bespokeTouched;
    }
    /**
     * Registers a final change to the provided directive's value and provides a space to apply it.
     * @param {?} value The directive's implicit value.
     * @return {?}
     */
    writeValue(value) {
        if (!!value) {
            this.selectedProducts = value;
            // Enable selected products!
            this.products.forEach((/**
             * @param {?} p
             * @return {?}
             */
            p => p.productNames.some((/**
             * @param {?} r
             * @return {?}
             */
            r => this.selectedProducts.indexOf(r) >= 0)) ? p.isSelected = true : p.isSelected = false));
        }
        else {
            // If no value is specified, use a default and set it to an empty array.
            this.selectedProducts = [];
            // Set the products to be no longer selected
            this.products.forEach((/**
             * @param {?} p
             * @return {?}
             */
            p => p.isSelected = false));
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        // Call the service that gets the product ranges for the given module group Id.
        this.productSelectorService.getProductExclusionRanges(this.moduleGroupId).toPromise().then((/**
         * @param {?} excludedProducts
         * @return {?}
         */
        excludedProducts => {
            /** @type {?} */
            var productToHideList = [];
            if (!isNullOrUndefined(excludedProducts)) {
                excludedProducts.forEach((/**
                 * @param {?} valve
                 * @return {?}
                 */
                valve => productToHideList.push(valve)));
            }
            // Call the service that gets the product ranges for the given module group Id.
            if (this.moduleGroupId > 0) {
                this.productSelectorService.getAllProductRanges(this.moduleGroupId, this.productTypeId).subscribe((/**
                 * @param {?} products
                 * @return {?}
                 */
                products => {
                    // The returned array of products is for every single iteration of a product for a given product range.
                    // This should be condensed into product ranges only, with each product listed as an array item of that product range.
                    for (const product of products) {
                        if (productToHideList.includes(product.productName)) {
                            continue;
                        }
                        /** @type {?} */
                        const index = this.products.findIndex((/**
                         * @param {?} p
                         * @return {?}
                         */
                        p => p.productRangeId === product.productRangeId));
                        if (index > -1) {
                            // It already exists in the array, so push the product name
                            this.products[index].productNames.push(product.productName);
                        }
                        else {
                            // No item found, so create a new product selection item
                            /** @type {?} */
                            const productSelectionItem = new ProductSelection();
                            productSelectionItem.productRangeId = product.productRangeId;
                            productSelectionItem.productRangeName = product.productRangeName;
                            productSelectionItem.productNames = [];
                            productSelectionItem.productNames.push(product.productName);
                            productSelectionItem.moduleGroupId = product.moduleGroupId;
                            productSelectionItem.productTypeId = product.productTypeId;
                            // Determine the selected status depending on whether or not it is contained in the selected products property.
                            productSelectionItem.isSelected =
                                this.selectedProducts.findIndex((/**
                                 * @param {?} sp
                                 * @return {?}
                                 */
                                sp => sp === product.productName)) > -1;
                            // Push the new item into the global products array
                            this.products.push(productSelectionItem);
                        }
                    }
                }));
            }
        }));
        this.internalModuleName = this.moduleName.toLowerCase().replace(/\s/g, '');
    }
    /**
     * Clicking on a product range should either add all the products in the range
     * or remove all the products from the range that has been de-selected.
     * @param {?} product
     * @return {?}
     */
    productRangeClick(product) {
        product.isSelected = !product.isSelected;
        // If the product range is now selected, add the products of the range to the array of selected products.
        if (product.isSelected) {
            this.selectedProducts = this.selectedProducts.concat(product.productNames);
        }
        else {
            // Otherwise remove all the products from the list of products for that range.
            for (const productName of product.productNames) {
                /** @type {?} */
                const index = this.selectedProducts.findIndex((/**
                 * @param {?} sp
                 * @return {?}
                 */
                sp => sp === productName));
                this.selectedProducts.splice(index, 1);
            }
        }
        this.onChange(this.selectedProducts);
        this.productSelectorOnChange.emit(this.selectedProducts);
    }
}
ProductSelectorComponent.decorators = [
    { type: Component, args: [{
                selector: 'product-selector',
                exportAs: 'product-selector',
                template: "<div class=\"row\" style=\"margin-top:-30px\">\r\n  <div style=\"height:50px\" *ngIf=\"selectedProducts.length\"></div>\r\n  <label style=\"font-size: medium; color: brown; background-color: white; z-index: 1; height: 28px\" *ngIf=\"!selectedProducts.length\">Please select one or more Products</label>\r\n  <div class=\"col-xs-12 text-center product-selector-container\">\r\n    <button #productSelectionButton\r\n            class=\"btn product-selection-item\"\r\n            [class.btn-default]=\"!product.isSelected\"\r\n            [class.btn-primary]=\"product.isSelected\"\r\n            *ngFor=\"let product of products\"\r\n            (click)=\"productRangeClick(product)\">\r\n\r\n      <img [src]=\"'assets/img/' + internalModuleName + '/' + product.productRangeName + '.png'\" /> <br />\r\n      {{product.productRangeName}}\r\n    </button>\r\n  </div>\r\n</div>\r\n\r\n<!--<pre>{{products | json}}</pre>-->\r\n",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => ProductSelectorComponent)),
                    }, {
                        provide: NG_VALIDATORS,
                        useExisting: ProductSelectorComponent,
                        multi: true
                    }
                ],
                styles: [".product-selector-container{background-color:#edf1f2;border-radius:8px;padding:5px}.btn-default.product-selection-item{background-color:#e4eaec}.btn-default.product-selection-item img{background-color:#fff;opacity:.5}.btn-primary.product-selection-item img{background-color:#edf1f2}.product-selection-item{margin:0 10px 10px 0;width:120px}.product-selection-item img{width:60px;height:112px;border-radius:8px;padding:5px}"]
            }] }
];
/** @nocollapse */
ProductSelectorComponent.ctorParameters = () => [
    { type: ProductSelectorService }
];
ProductSelectorComponent.propDecorators = {
    productSelectorOnChange: [{ type: Output, args: ['productSelectorOnChange',] }],
    moduleName: [{ type: Input, args: ["module-name",] }],
    moduleGroupId: [{ type: Input, args: ["module-group-id",] }],
    productTypeId: [{ type: Input, args: ["product-type-id",] }],
    internalValue: [{ type: Input, args: ['value',] }]
};
if (false) {
    /** @type {?} */
    ProductSelectorComponent.prototype.productSelectorOnChange;
    /** @type {?} */
    ProductSelectorComponent.prototype.moduleName;
    /** @type {?} */
    ProductSelectorComponent.prototype.moduleGroupId;
    /** @type {?} */
    ProductSelectorComponent.prototype.productTypeId;
    /** @type {?} */
    ProductSelectorComponent.prototype.products;
    /** @type {?} */
    ProductSelectorComponent.prototype.internalModuleName;
    /** @type {?} */
    ProductSelectorComponent.prototype.internalValue;
    /** @type {?} */
    ProductSelectorComponent.prototype.onChange;
    /** @type {?} */
    ProductSelectorComponent.prototype.onTouched;
    /**
     * @type {?}
     * @private
     */
    ProductSelectorComponent.prototype.productSelectorService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/product-selector/product-selector.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductSelectorModule {
}
ProductSelectorModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslationModule
                ],
                declarations: [ProductSelectorComponent],
                providers: [ProductSelectorService],
                exports: [ProductSelectorComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/sizing-module-saveload/saveload.modal.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SaveLoadService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
}
SaveLoadService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
SaveLoadService.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    SaveLoadService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/projects-jobs/projects-jobs.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProjectsAndJobs {
}
if (false) {
    /**
     * Gets or sets the projects.
     * @type {?}
     */
    ProjectsAndJobs.prototype.projects;
}
/**
 * The Projects model.
 */
class Project {
}
if (false) {
    /**
     * Gets or sets the Guid Id.
     * @type {?}
     */
    Project.prototype.id;
    /**
     * Gets or sets the name.
     * @type {?}
     */
    Project.prototype.name;
    /**
     * Gets or sets the projectReference.
     * @type {?}
     */
    Project.prototype.projectReference;
    /**
     * Gets or sets the userId.
     * @type {?}
     */
    Project.prototype.userId;
    /**
     * Gets or sets the tradeEnum.
     * @type {?}
     */
    Project.prototype.tradeEnum;
    /**
     * Gets or sets the industryEnum.
     * @type {?}
     */
    Project.prototype.industryEnum;
    /**
     * Gets or sets the customerName.
     * @type {?}
     */
    Project.prototype.customerName;
    /**
     * Gets or sets the customerLocation.
     * @type {?}
     */
    Project.prototype.customerLocation;
    /**
     * Gets or sets the quoteReference.
     * @type {?}
     */
    Project.prototype.quoteReference;
    /**
     * Gets or sets isDeleted.
     * @type {?}
     */
    Project.prototype.isDeleted;
    /**
     * Gets or sets the created date.
     * @type {?}
     */
    Project.prototype.created;
    /**
     * Gets or sets the updated date.
     * @type {?}
     */
    Project.prototype.updated;
    /**
     * Gets or sets the Jobs.
     * @type {?}
     */
    Project.prototype.jobs;
    /**
     * Gets or sets flag used by saveload modal pop up.
     * @type {?}
     */
    Project.prototype.existingProjectSave;
}
/**
 * The ProjectResponse model.
 */
class ProjectResponse {
}
if (false) {
    /**
     * Gets or sets a value indicating whether or not it has succeeded.
     * @type {?}
     */
    ProjectResponse.prototype.succeeded;
    /**
     * Gets or sets the projects.
     * @type {?}
     */
    ProjectResponse.prototype.project;
}
class Job {
}
if (false) {
    /**
     * Gets or sets the Guid Id.
     * @type {?}
     */
    Job.prototype.id;
    /**
     * Gets or sets the Guid projectId.
     * @type {?}
     */
    Job.prototype.projectId;
    /**
     * Gets or sets the name.
     * @type {?}
     */
    Job.prototype.name;
    /**
     * Gets or sets the modueleId.
     * @type {?}
     */
    Job.prototype.moduleId;
    /**
     * Gets or sets the productName.
     * @type {?}
     */
    Job.prototype.productName;
    /**
     * Gets or sets the plantOwner.
     * @type {?}
     */
    Job.prototype.plantOwner;
    /**
     * Gets or sets the jobStatusId.
     * @type {?}
     */
    Job.prototype.jobStatusId;
    /**
     * Gets or sets the created date.
     * @type {?}
     */
    Job.prototype.created;
    /**
     * Gets or sets the updated date.
     * @type {?}
     */
    Job.prototype.updated;
    /**
     * Gets or sets the lastExported date.
     * @type {?}
     */
    Job.prototype.lastExported;
    /**
     * Gets or sets isDeleted.
     * @type {?}
     */
    Job.prototype.isDeleted;
    /** @type {?} */
    Job.prototype.jobSizing;
}
/**
 * The JobResponse model.
 */
class JobResponse {
}
if (false) {
    /**
     * Gets or sets a value indicating whether or not it has succeeded.
     * @type {?}
     */
    JobResponse.prototype.succeeded;
    /**
     * Gets or sets the jobs.
     * @type {?}
     */
    JobResponse.prototype.job;
}
class GetSizingJobRequest {
}
if (false) {
    /** @type {?} */
    GetSizingJobRequest.prototype.jobId;
    /** @type {?} */
    GetSizingJobRequest.prototype.projectId;
}
class GetJobRequest {
}
if (false) {
    /** @type {?} */
    GetJobRequest.prototype.jobId;
}
/**
 * The JobStatusesResponse model.
 */
class JobStatusesResponse {
}
if (false) {
    /**
     * Gets or sets the JobStatuses.
     * @type {?}
     */
    JobStatusesResponse.prototype.jobStatuses;
}
/**
 * The JobStatus model.
 */
class JobStatus {
}
if (false) {
    /**
     * Gets or sets the  Id.
     * @type {?}
     */
    JobStatus.prototype.id;
    /**
     * Gets or sets the name.
     * @type {?}
     */
    JobStatus.prototype.name;
    /**
     * Gets or sets the masterTextKey.
     * @type {?}
     */
    JobStatus.prototype.masterTextKey;
}
class JobSizing {
}
if (false) {
    /** @type {?} */
    JobSizing.prototype.project;
    /** @type {?} */
    JobSizing.prototype.sizingData;
    /** @type {?} */
    JobSizing.prototype.jobStatusId;
}
class SizingData {
}
if (false) {
    /** @type {?} */
    SizingData.prototype.processConditions;
    /** @type {?} */
    SizingData.prototype.sizingOutput;
}
class ProcessCondition {
}
if (false) {
    /** @type {?} */
    ProcessCondition.prototype.name;
    /** @type {?} */
    ProcessCondition.prototype.processInputs;
    /** @type {?} */
    ProcessCondition.prototype.unitPreferences;
}
class ProcessInput {
}
if (false) {
    /** @type {?} */
    ProcessInput.prototype.name;
    /** @type {?} */
    ProcessInput.prototype.value;
    /** @type {?} */
    ProcessInput.prototype.unitId;
    /** @type {?} */
    ProcessInput.prototype.listItemId;
    /** @type {?} */
    ProcessInput.prototype.value2;
    /** @type {?} */
    ProcessInput.prototype.childInputs;
}
class SizingOutput {
}
if (false) {
    /** @type {?} */
    SizingOutput.prototype.outputItems;
    /** @type {?} */
    SizingOutput.prototype.outputGrid;
}
class OutputGrid {
}
if (false) {
    /** @type {?} */
    OutputGrid.prototype.outputGridRows;
}
class OutputGridRow {
}
if (false) {
    /** @type {?} */
    OutputGridRow.prototype.outputItems;
    /** @type {?} */
    OutputGridRow.prototype.messages;
}
class OutputItem {
}
if (false) {
    /** @type {?} */
    OutputItem.prototype.name;
    /** @type {?} */
    OutputItem.prototype.value;
    /** @type {?} */
    OutputItem.prototype.unitId;
    /** @type {?} */
    OutputItem.prototype.selected;
    /** @type {?} */
    OutputItem.prototype.listItemId;
    /** @type {?} */
    OutputItem.prototype.type;
}
class OutputGridRowMessageItem {
}
if (false) {
    /** @type {?} */
    OutputGridRowMessageItem.prototype.messageKey;
    /** @type {?} */
    OutputGridRowMessageItem.prototype.value;
    /** @type {?} */
    OutputGridRowMessageItem.prototype.unitKey;
    /** @type {?} */
    OutputGridRowMessageItem.prototype.severity;
    /** @type {?} */
    OutputGridRowMessageItem.prototype.displayValue;
    /** @type {?} */
    OutputGridRowMessageItem.prototype.additionalMessage;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/projects-jobs/projects-jobs.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProjectsJobsService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
        this.projectJobsChange = new Subject();
        this.projectsJobsData = new ProjectsAndJobs();
        // When the class in constructed, initialise the subject so that whenever it is called, its subscriber resolves the result to the current projects and Jobss object.
        this.projectJobsChange.subscribe((/**
         * @param {?} projectsJobs
         * @return {?}
         */
        projectsJobs => {
            this.projectsJobsData = projectsJobs; // subject
        }));
    }
    /**
     * @return {?}
     */
    get projectsJobs() {
        return this.projectsJobsData;
    }
    /**
     * @param {?} projectsAndJobs
     * @return {?}
     */
    set projectsJobs(projectsAndJobs) {
        // Assign the new users to the subject.
        this.projectJobsChange.next(projectsAndJobs);
    }
    /**
     * Gets the Projects and Jobs for this user.
     * @return {?}
     */
    getProjectsAndJobs() {
        return this.http.get(`./Api/ProjectsAndJobs/GetProjectsAndJobs/`).map((
        // ToDo: This is hit twice, once from the Projects component and again from Jobs component. Optimise the "Subject" later!
        /**
         * @param {?} projectsJobsData
         * @return {?}
         */
        projectsJobsData => {
            // Assign the new P&J header to the subject.
            this.projectJobsChange.next(projectsJobsData);
        }));
    }
    /**
     *  Gets all job Statuses.
     * @return {?}
     */
    getAllJobStatuses() {
        return this.http.get(`./Api/ProjectsAndJobs/GetAllJobStatuses`);
    }
    /**
     * Signal Data Has Changed, to all subject subscribers.
     * @param {?} projectsAndJobs
     * @return {?}
     */
    signalProjectsAndJobsDataHasChanged(projectsAndJobs) {
        this.projectsJobs = projectsAndJobs; // the setting fires .next on the Angular subject
    }
    /**
     * Gets a single Project and Job (with foreign userId support for CRM loading).
     * @param {?} jobRequest
     * @return {?}
     */
    getSingleProjectAndJob(jobRequest) {
        return this.http.post(`./Api/ProjectsAndJobs/GetSingleProjectAndJob/`, jobRequest);
    }
    /**
     * Insert a Project
     * @param {?} project The Project.
     * @return {?}
     */
    insertProject(project) {
        return this.http.post(`./Api/ProjectsAndJobs/InsertProject`, { project: project });
    }
    /**
     * insertProjectInToServiceMemoryAndSignalChanges
     * Used in Save/Load from sizing pages
     * @param {?} project
     * @return {?}
     */
    insertProjectInToServiceMemoryAndSignalChanges(project) {
        if (!project.id) {
            debugger; // invalid data?
            return;
        }
        /** @type {?} */
        let newProject = new Project();
        newProject.id = project.id;
        newProject.name = project.name;
        newProject.projectReference = project.projectReference;
        newProject.userId = project.userId;
        newProject.tradeEnum = project.tradeEnum;
        newProject.industryEnum = project.industryEnum;
        newProject.customerName = project.customerName;
        newProject.customerLocation = project.customerLocation;
        newProject.quoteReference = project.quoteReference;
        newProject.isDeleted = project.isDeleted;
        newProject.created = project.created;
        newProject.updated = project.updated;
        newProject.jobs = []; // default
        this.projectsJobs[this.projectsJobs.projects.length] = newProject;
        this.signalProjectsAndJobsDataHasChanged(this.projectsJobs);
    }
    /**
     * updateProjectInToServiceMemoryAndSignalChanges
     * Used in Save/Load from sizing pages
     * @param {?} project
     * @return {?}
     */
    updateProjectInToServiceMemoryAndSignalChanges(project) {
        if (!project.id) {
            debugger; // invalid data?
            return;
        }
        /** @type {?} */
        let theProjectIndex = this.projectsJobs.projects.findIndex((/**
         * @param {?} p
         * @return {?}
         */
        p => p.id === project.id));
        /** @type {?} */
        let updateProject = new Project();
        updateProject = this.projectsJobs.projects[theProjectIndex];
        updateProject.name = project.name;
        updateProject.projectReference = project.projectReference;
        updateProject.tradeEnum = project.tradeEnum;
        updateProject.industryEnum = project.industryEnum;
        updateProject.customerName = project.customerName;
        updateProject.customerLocation = project.customerLocation;
        updateProject.quoteReference = project.quoteReference;
        updateProject.isDeleted = project.isDeleted;
        updateProject.updated = project.updated;
        // FYI:
        //updateProject.id = project.id; should not be changing!
        //updateProject.userId = project.userId; should not be changing!
        //updateProject.created = project.created; should not be changing!
        //updateProject.jobs = project.jobs; should not be changing! use update job methods
        this.projectsJobs[theProjectIndex] = updateProject; // assign updated project
        this.signalProjectsAndJobsDataHasChanged(this.projectsJobs); // signal changes
    }
    /**
     * Update a Project
     * @param {?} project The Project.
     * @return {?}
     */
    updateProject(project) {
        return this.http.post(`./Api/ProjectsAndJobs/UpdateProject`, { project: project });
    }
    /**
     * Delete a Project
     * @param {?} project The Project.
     * @return {?}
     */
    deleteProject(project) {
        return this.http.post(`./Api/ProjectsAndJobs/DeleteProject`, { project: project });
    }
    /**
     * Insert a Job
     * @param {?} job The Job.
     * @return {?}
     */
    insertJob(job) {
        return this.http.post(`./Api/ProjectsAndJobs/InsertJob`, { job: job });
    }
    /**
     * Update a Job
     * @param {?} job The Job.
     * @return {?}
     */
    updateJob(job) {
        return this.http.post(`./Api/ProjectsAndJobs/UpdateJob`, { job: job });
    }
    /**
     * insertJobInToServiceMemoryAndSignalChanges
     * Used in Save/Load from sizing pages
     * @param {?} job
     * @return {?}
     */
    insertJobInToServiceMemoryAndSignalChanges(job) {
        if (!job.projectId || !job.id) {
            debugger; // invalid data?
            return;
        }
        /** @type {?} */
        let theProjectIndex = this.projectsJobs.projects.findIndex((/**
         * @param {?} p
         * @return {?}
         */
        p => p.id === job.projectId));
        /** @type {?} */
        let theJobIndex = this.projectsJobs.projects[theProjectIndex].jobs.length;
        /** @type {?} */
        let newJob = new Job();
        newJob.id = job.id;
        newJob.projectId = job.projectId;
        newJob.name = job.name;
        newJob.moduleId = job.moduleId;
        newJob.productName = job.productName;
        newJob.plantOwner = job.plantOwner;
        newJob.jobStatusId = job.jobStatusId;
        newJob.isDeleted = job.isDeleted;
        newJob.created = job.created;
        newJob.updated = job.updated;
        //newJob.jobSizing = new JobSizing; // default
        this.projectsJobs.projects[theProjectIndex].jobs[theJobIndex] = newJob; // assign updated job
        this.signalProjectsAndJobsDataHasChanged(this.projectsJobs); // signal changes
    }
    /**
     * updateJobInToServiceMemoryAndSignalChanges
     * Used in Save/Load from sizing pages
     * @param {?} job
     * @return {?}
     */
    updateJobInToServiceMemoryAndSignalChanges(job) {
        if (!job.projectId || !job.id) {
            debugger; // invalid data?
            return;
        }
        /** @type {?} */
        let theProjectIndex = this.projectsJobs.projects.findIndex((/**
         * @param {?} p
         * @return {?}
         */
        p => p.id === job.projectId));
        /** @type {?} */
        let theJobIndex = this.projectsJobs.projects[theProjectIndex].jobs.findIndex((/**
         * @param {?} j
         * @return {?}
         */
        j => j.id === job.id));
        /** @type {?} */
        let updateJob = new Job();
        updateJob = this.projectsJobs.projects[theProjectIndex].jobs[theJobIndex];
        updateJob.name = job.name;
        updateJob.moduleId = job.moduleId;
        updateJob.productName = job.productName;
        updateJob.plantOwner = job.plantOwner;
        updateJob.jobStatusId = job.jobStatusId;
        updateJob.isDeleted = job.isDeleted;
        updateJob.updated = job.updated;
        //updateJob.jobSizing = new JobSizing; // default
        // FYI:
        //updateJob.id = job.id; should not be changing!
        //updateJob.projectId = job.projectId; should not be changing!
        //updateJob.created = job.created; should not be changing!
        this.projectsJobs.projects[theProjectIndex].jobs[theJobIndex] = updateJob; // assign updated job
        this.signalProjectsAndJobsDataHasChanged(this.projectsJobs); // signal changes
    }
    /**
     * Delete a Job
     * @param {?} job The Job.
     * @return {?}
     */
    deleteJob(job) {
        return this.http.post(`./Api/ProjectsAndJobs/DeleteJob`, { job: job });
    }
    /**
     * @param {?} jobSizing
     * @return {?}
     */
    saveJobSizing(jobSizing) {
        return this.http.post(`./Api/ProjectsAndJobs/SaveJobSizing`, jobSizing);
    }
    /**
     * @param {?} request
     * @return {?}
     */
    getJobSizing(request) {
        return this.http.post(`./Api/ProjectsAndJobs/GetJobSizing`, request);
    }
    /**
     * @param {?} jobSizing
     * @return {?}
     */
    updateJobSizing(jobSizing) {
        return this.http.post(`./Api/ProjectsAndJobs/UpdateJobSizing`, jobSizing);
    }
}
ProjectsJobsService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ProjectsJobsService.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /** @type {?} */
    ProjectsJobsService.prototype.projectJobsChange;
    /**
     * @type {?}
     * @private
     */
    ProjectsJobsService.prototype.projectsJobsData;
    /**
     * @type {?}
     * @private
     */
    ProjectsJobsService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/sizing-module-saveload/saveload.modal.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SaveLoadModalComponent {
    /**
     * @param {?} saveloadService
     * @param {?} fb
     * @param {?} projectsJobsService
     * @param {?} translatePipe
     */
    constructor(saveloadService, fb, projectsJobsService, translatePipe) {
        this.saveloadService = saveloadService;
        this.fb = fb;
        this.projectsJobsService = projectsJobsService;
        this.translatePipe = translatePipe;
        this.nameDuplicate = false;
        this.parentSubmitIsDisabled = true; // Modal parent container component submit button state (enabled/disabled)
        // Modal parent container component submit button state (enabled/disabled)
        this.isExistingProjectDisabled = false;
        this.isNewProjectDisabled = false;
        this.existingProjectDataRows = [];
        this.selectedExistingProjectData = [];
        this.projectName = new FormControl('', [Validators.required]);
        this.customer = new FormControl('');
        this.projectReference = new FormControl('');
        this.jobName = new FormControl('', [Validators.required]);
        this.plantOwner = new FormControl('');
        this.showHideNewProject = new FormControl(false);
        this.showHideExistingProject = new FormControl(false);
        this.saveLoadForm = this.fb.group({
            projectname: this.projectName,
            customer: this.customer,
            projectreference: this.projectReference,
            jobname: this.jobName,
            plantowner: this.plantOwner,
            showHideNewProject: this.showHideNewProject,
            showHideExistingProject: this.showHideExistingProject
        });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.saveLoadForm.valueChanges.subscribe((/**
         * @param {?} val
         * @return {?}
         */
        val => {
            this.setSubmitButtonStatus();
        }));
        // default to new project mode, quicker for user.
        this.onClickNewProject();
    }
    /*
      * Enable/Disable submit button based on the requird fields validations and projects selection.
      */
    /**
     * @return {?}
     */
    setSubmitButtonStatus() {
        if ((this.showHideNewProject.value && this.projectName.valid && this.jobName.valid)
            || (this.showHideExistingProject.value && this.jobName.valid && this.selectedExistingProjectData && this.selectedExistingProjectData.length > 0)) {
            this.parentSubmitIsDisabled = false;
        }
        else {
            this.parentSubmitIsDisabled = true;
        }
    }
    /**
     * Support this method is you require Modal Submit button state handling. ie. disable the submit button if any validation errors exist.
     * @return {?}
     */
    checkIfSubmitIsDisabled() {
        return this.parentSubmitIsDisabled;
    }
    /**
     * @return {?}
     */
    onClickNewProject() {
        this.showHideNewProject.setValue(true);
        this.showHideExistingProject.setValue(false);
        this.isExistingProjectDisabled = false;
        this.isNewProjectDisabled = true;
        //need existing project data for name check
        this.projectsJobsService.getProjectsAndJobs().subscribe((/**
         * @return {?}
         */
        () => {
            this.existingProjectDataRows = this.projectsJobsService.projectsJobs.projects;
        }));
    }
    /**
     * @return {?}
     */
    onClickExistingProject() {
        this.showHideExistingProject.setValue(true);
        this.showHideNewProject.setValue(false);
        this.isExistingProjectDisabled = true;
        this.isNewProjectDisabled = false;
        this.projectsJobsService.getProjectsAndJobs().subscribe((/**
         * @return {?}
         */
        () => {
            this.existingProjectDataRows = this.projectsJobsService.projectsJobs.projects;
        }));
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onSelect(event) {
        /** @type {?} */
        var selectedRow = (/** @type {?} */ (event.selected));
        this.selectedExistingProjectData = selectedRow;
        this.setSubmitButtonStatus();
    }
    /**
     * Callback function that is dynamically called by a modal popup when "Save/Submit/Ok" is clicked.
     * @return {?}
     */
    modalSubmitCallback() {
        // Project {
        /** @type {?} */
        let someObservable = Observable$1.of(null);
        /** @type {?} */
        let project;
        /** @type {?} */
        let projecttest;
        // Saving to a new project
        if (this.showHideNewProject.value === true) {
            //check project name
            if (!!this.existingProjectDataRows && this.existingProjectDataRows.find((/**
             * @param {?} x
             * @return {?}
             */
            x => x.name === this.saveLoadForm.controls["projectname"].value))) {
                // name exists - display warning popup
                /** @type {?} */
                const title = this.translatePipe.transform("DUPLICATE_PROJECT", true);
                /** @type {?} */
                const text = this.translatePipe.transform("A_PROJECT_WITH_THE_SAME_NAME_ALREADY_EXISTS_CLICK_YES_TO_SAVE_ANYWAY_OR_NO_TO_CHANGE_THE_NAME_OF_THE_PROJECT_YOU_ARE_SAVING_MESSAGE", true);
                /** @type {?} */
                const saveDuplicateProject = this.translatePipe.transform("YES", true);
                /** @type {?} */
                const noButtonText = this.translatePipe.transform("NO", true);
                return swal__default({
                    title: title,
                    text: text,
                    icon: "warning",
                    dangerMode: true,
                    buttons: [saveDuplicateProject, noButtonText]
                }).then((/**
                 * @param {?=} discardChanges
                 * @return {?}
                 */
                (discardChanges) => {
                    // The parameter can also enter as null
                    /** @type {?} */
                    const returnVal = !(discardChanges === null);
                    /** @type {?} */
                    let project = null;
                    if (!returnVal) {
                        // Go ahead and save anyway
                        project = this.createNewProject();
                    }
                    console.info(`SaveLoad Modal Sweet Alert has resolved. Project ${!!project ? 'exists!' : 'is empty.'}`);
                    return project;
                }));
            }
            // Go ahead and save anyway.
            someObservable = Observable$1.of(this.createNewProject());
        }
        else {
            if (this.selectedExistingProjectData[0].jobs.find((/**
             * @param {?} job
             * @return {?}
             */
            job => job.name === this.saveLoadForm.controls["jobname"].value))) {
                // name exists - display warning popup
                /** @type {?} */
                const title = this.translatePipe.transform("DUPLICATE_JOB_NAME", true);
                /** @type {?} */
                const text = this.translatePipe.transform("A_JOB_WITH_THE_SAME_NAME_EXISTS_IN_THIS_PROJECT_CLICK_YES_TO_SAVE_ANYWAY_OR_NO_TO_CHANGE_THE_NAME_OF_THE_JOB_YOU_ARE_SAVING_MESSAGE", true);
                /** @type {?} */
                const saveDuplicateJobName = this.translatePipe.transform("YES", true);
                /** @type {?} */
                const noButtonText = this.translatePipe.transform("NO", true);
                return swal__default({
                    title: title,
                    text: text,
                    icon: "warning",
                    dangerMode: true,
                    buttons: [saveDuplicateJobName, noButtonText]
                }).then((/**
                 * @param {?=} discardChanges
                 * @return {?}
                 */
                (discardChanges) => {
                    // The parameter can also enter as null
                    /** @type {?} */
                    const returnVal = !(discardChanges === null);
                    /** @type {?} */
                    let project = null;
                    if (!returnVal) {
                        // Go ahead and save anyway
                        project = this.createFromExistingProject();
                    }
                    console.info(`SaveLoad Modal Sweet Alert has resolved. Project ${!!project ? 'exists!' : 'is empty.'}`);
                    return project;
                }));
            }
            someObservable = Observable$1.of(this.createFromExistingProject());
        }
        return someObservable.toPromise();
    }
    /**
     * @private
     * @return {?}
     */
    createFromExistingProject() {
        /** @type {?} */
        const project = this.selectedExistingProjectData[0];
        /** @type {?} */
        const newJob = this.createNewJob(project);
        project.jobs.push(newJob);
        project.existingProjectSave = true;
        return project;
    }
    /**
     * @private
     * @return {?}
     */
    createNewProject() {
        // Create a new project instance.
        /** @type {?} */
        const project = new Project();
        project.name = this.saveLoadForm.controls["projectname"].value;
        project.customerName = this.saveLoadForm.controls["customer"].value;
        project.projectReference = this.saveLoadForm.controls["projectreference"].value;
        project.jobs = [];
        /** @type {?} */
        const newJob = this.createNewJob(project);
        project.jobs.push(newJob);
        project.existingProjectSave = false;
        return project;
    }
    /**
     * @private
     * @param {?} project
     * @return {?}
     */
    createNewJob(project) {
        /** @type {?} */
        const newJob = new Job();
        newJob.projectId = project.id;
        //newJob.moduleId = project.
        newJob.name = this.saveLoadForm.controls["jobname"].value;
        newJob.plantOwner = this.saveLoadForm.controls["plantowner"].value;
        return newJob;
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    onChange(newValue) {
    }
}
SaveLoadModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'saveload-modal',
                template: "<form [formGroup]=\"saveLoadForm\" class=\"form-horizontal modal-component\" role=\"form\" novalidate>\r\n\r\n  <div class=\"row\">\r\n\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"custom-nav\">\r\n        <div class=\"nav-item\" [ngClass]=\"{'selected-nav-item': !showHideExistingProject.value }\" role=\"tab\" id=\"saveNewProjectHeading\" (click)=\"onClickNewProject()\">\r\n          <span class=\"nav-text\">{{\"SAVE_TO_A_NEW_PROJECT\" | translate}}</span>\r\n          <i class=\"fa fa-chevron-down\"></i>\r\n        </div>\r\n\r\n        <div class=\"nav-item\" [ngClass]=\"{'selected-nav-item': showHideExistingProject.value }\" role=\"tab\" id=\"saveExistingProjectHeading\" (click)=\"onClickExistingProject()\">\r\n          <span class=\"nav-text\">{{\"SAVE_TO_AN_EXISTING_PROJECT\" | translate}}</span>\r\n          <i class=\"fa fa-chevron-down\"></i>\r\n        </div>\r\n      </div>\r\n\r\n      <div *ngIf=\"!showHideExistingProject.value\" id=\"saveNewProjectContent\" role=\"tabpanel\">\r\n        <div class=\"panel-body\">\r\n          <div class=\"col-xs-1\"></div>\r\n\r\n          <div class=\"col-xs-5\">\r\n            <input spirax-input [label]=\"'PROJECT_NAME' | translate\" type=\"text\" formControlName=\"projectname\" maxlength=\"40\" required/>\r\n            <input spirax-input [label]=\"'JOB_NAME' | translate\" autocomplete=\"off\" type=\"text\" formControlName=\"jobname\" maxlength=\"30\" required/>\r\n          </div>\r\n          <div class=\"col-xs-5\">\r\n            <input spirax-input [label]=\"'PROJECT_REFERENCE' | translate\" autocomplete=\"off\" type=\"text\" formControlName=\"projectreference\" maxlength=\"40\" />\r\n            <input spirax-input [label]=\"'CUSTOMER' | translate\" autocomplete=\"off\" type=\"text\" formControlName=\"customer\" maxlength=\"50\" />\r\n            <input spirax-input [label]=\"'PLANT_OWNER' | translate\" autocomplete=\"off\" type=\"text\" formControlName=\"plantowner\" />\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n\r\n\r\n      <div *ngIf=\"showHideExistingProject.value\" id=\"saveNewProjectContent\" role=\"tabpanel\">\r\n        <div class=\"panel-body\">\r\n\r\n          <div>\r\n            <ngx-datatable #existingProjectDataTable\r\n                           class=\"bootstrap\"\r\n                           [headerHeight]=\"40\"\r\n                           [limit]=\"5\"\r\n                           [columnMode]=\"'force'\"\r\n                           [footerHeight]=\"40\"\r\n                           [rowHeight]=\"'auto'\"\r\n                           [rows]=\"existingProjectDataRows\"\r\n                           [selected]=\"selectedExistingProjectData\"\r\n                           [selectionType]=\"'single'\"\r\n                           (select)=\"onSelect($event)\">\r\n\r\n              <ngx-datatable-column [name]=\"'PROJECT_NAME' | translate\" prop=\"name\">\r\n                <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                  {{value}}\r\n                </ng-template>\r\n              </ngx-datatable-column>\r\n\r\n              <ngx-datatable-column [name]=\"'CUSTOMER' | translate\" prop=\"customerName\">\r\n                <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                  {{value}}\r\n                </ng-template>\r\n              </ngx-datatable-column>\r\n\r\n              <ngx-datatable-column [name]=\"'PROJECT_REFERENCE' | translate\" prop=\"projectReference\">\r\n                <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                  {{value}}\r\n                </ng-template>\r\n              </ngx-datatable-column>\r\n\r\n              <ngx-datatable-column [name]=\"'LAST_UPDATED' | translate\" prop=\"updated\">\r\n                <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                  {{value}}\r\n                </ng-template>\r\n              </ngx-datatable-column>\r\n\r\n            </ngx-datatable>\r\n\r\n          </div>\r\n\r\n          <div class=\"col-xs-1\"></div>\r\n          <div class=\"col-xs-5\">\r\n            <input spirax-input [label]=\"'JOB_NAME' | translate\" autocomplete=\"off\" type=\"text\" formControlName=\"jobname\" maxlength=\"30\" required/>\r\n          </div>\r\n\r\n          <div class=\"col-xs-5\">\r\n            <input spirax-input [label]=\"'PLANT_OWNER' | translate\" autocomplete=\"off\" type=\"text\" formControlName=\"plantowner\" />\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n\r\n\r\n  </div>\r\n\r\n</form>\r\n\r\n",
                styles: ["*{box-sizing:border-box}body{font-family:Arial,Helvetica,sans-serif}.header{padding:30px;text-align:center;font-size:35px}.column{float:left;padding:10px}.modal-component{margin:10px}.custom-nav{display:flex;flex-direction:row;align-items:center;margin-bottom:10px;margin-left:0;margin-right:0}.nav-item{font-weight:600;flex:1;font-size:18px;color:#002d72;background:#edf2f4;height:60px;text-transform:uppercase;display:flex;justify-content:center;align-items:center;cursor:pointer}.nav-item .nav-text{flex:1;text-align:center}.nav-item:hover .nav-text{-webkit-text-decoration-line:underline;text-decoration-line:underline}.selected-nav-item{background-color:#fff}.selected-nav-item .nav-text{-webkit-text-decoration-line:underline;text-decoration-line:underline}.fa-chevron-down{padding:3%}.column.leftside{width:25%}.column.rightside{width:75%}.row:after{content:\"\";display:table;clear:both}.footer{background-color:#f1f1f1;padding:10px;text-align:center}.btn-space{margin-bottom:5px}@media (max-width:800px){.column.leftside,.column.rightside{width:100%}}"]
            }] }
];
/** @nocollapse */
SaveLoadModalComponent.ctorParameters = () => [
    { type: SaveLoadService },
    { type: FormBuilder },
    { type: ProjectsJobsService },
    { type: TranslatePipe }
];
SaveLoadModalComponent.propDecorators = {
    existingProjectDataTable: [{ type: ViewChild, args: ["existingProjectDataTable", { static: false },] }]
};
if (false) {
    /** @type {?} */
    SaveLoadModalComponent.prototype.nameDuplicate;
    /** @type {?} */
    SaveLoadModalComponent.prototype.saveLoadForm;
    /** @type {?} */
    SaveLoadModalComponent.prototype.parentSubmitIsDisabled;
    /** @type {?} */
    SaveLoadModalComponent.prototype.isExistingProjectDisabled;
    /** @type {?} */
    SaveLoadModalComponent.prototype.isNewProjectDisabled;
    /** @type {?} */
    SaveLoadModalComponent.prototype.projectName;
    /** @type {?} */
    SaveLoadModalComponent.prototype.customer;
    /** @type {?} */
    SaveLoadModalComponent.prototype.projectReference;
    /** @type {?} */
    SaveLoadModalComponent.prototype.jobName;
    /** @type {?} */
    SaveLoadModalComponent.prototype.plantOwner;
    /** @type {?} */
    SaveLoadModalComponent.prototype.showHideNewProject;
    /** @type {?} */
    SaveLoadModalComponent.prototype.showHideExistingProject;
    /** @type {?} */
    SaveLoadModalComponent.prototype.existingProjectDataRows;
    /** @type {?} */
    SaveLoadModalComponent.prototype.selectedExistingProjectData;
    /** @type {?} */
    SaveLoadModalComponent.prototype.existingProjectDataTable;
    /**
     * @type {?}
     * @private
     */
    SaveLoadModalComponent.prototype.saveloadService;
    /**
     * @type {?}
     * @private
     */
    SaveLoadModalComponent.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    SaveLoadModalComponent.prototype.projectsJobsService;
    /**
     * @type {?}
     * @private
     */
    SaveLoadModalComponent.prototype.translatePipe;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/sizing-module-saveload/saveload.modal.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SaveLoadModule {
}
SaveLoadModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    TranslationModule,
                    ReactiveFormsModule,
                    NgxDatatableModule,
                    SpiraxInputDirectiveModule
                ],
                declarations: [SaveLoadModalComponent],
                exports: [SaveLoadModalComponent],
                providers: [SaveLoadService]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/calculations/calculations.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CalculationsService {
    /**
     * @param {?} httpClient
     */
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
}
CalculationsService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CalculationsService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ CalculationsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CalculationsService_Factory() { return new CalculationsService(ɵɵinject(HttpClient)); }, token: CalculationsService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    CalculationsService.prototype.httpClient;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/shared.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SharedService {
    constructor() { }
    /**
     * Set the Industrial Enumeration Name dependant on the selected Trade Enumeration definition. (switch to new list)
     * @param {?} tradeEnum
     * @return {?}
     */
    getIndustryEnumNameForProvidedTrade(tradeEnum) {
        // Load the corresponding Industry Enumeration list into the <Enumeration> control
        switch (tradeEnum) {
            case "0":
                return "PrimaryIndustry_Platform";
            case "1":
                return "EnergyAndWater_Platform";
            case "2":
                return "ChemicalIndustry_Platform";
            case "3":
                return "MetalIndustry_Platform";
            case "4":
                return "TextilesAndFibres_Platform";
            case "5":
                return "FoodIndustry_Platform";
            case "6":
                return "OtherManufacturing_Platform";
            case "7":
                return "ServicesIndustry_Platform";
            case "8":
                return "None_Platform";
            default:
                return "None_Platform";
        }
    }
}
SharedService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
SharedService.ctorParameters = () => [];
/** @nocollapse */ SharedService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SharedService_Factory() { return new SharedService(); }, token: SharedService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/validators/user.validator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UserValidator {
    /**
     * @param {?} adminService
     */
    constructor(adminService) {
        this.adminService = adminService;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    isEmptyInputValue(value) {
        // we don't check for string here so it also works with arrays
        return value == null || value.length === 0;
    }
    /**
     * @param {?} control
     * @return {?}
     */
    usernameValidator(control) {
        return this.adminService.checkUsernameExists(control.value).map((/**
         * @param {?} userExists
         * @return {?}
         */
        (userExists) => {
            if (!!userExists) {
                console.log("Username Validator status: " + control.status);
                return { existingUserByUsername: true };
            }
            else {
                return null;
            }
        }));
    }
    /**
     * @param {?} control
     * @return {?}
     */
    emailValidator(control) {
        return this.adminService.checkEmailExists(control.value).map((/**
         * @param {?} userExists
         * @return {?}
         */
        (userExists) => {
            if (!!userExists) {
                console.log("Email Validator status: " + control.status);
                return { existingUserByEmail: true };
            }
            else {
                return null;
            }
        }));
    }
    /**
     * @param {?} control
     * @return {?}
     */
    countryValidator(control) {
        return (/**
         * @return {?}
         */
        () => {
            console.log(control);
            if (!control.dirty) {
                return Observable$1.of(null);
            }
            if (control.value === '0') {
                return Observable$1.of({ 'countrySelected': true });
            }
            return Observable$1.of(null);
        });
    }
}
UserValidator.decorators = [
    { type: Injectable }
];
/** @nocollapse */
UserValidator.ctorParameters = () => [
    { type: AdminService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    UserValidator.prototype.adminService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/directives/spirax-textarea/spirax-textarea.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SpiraxTextareaDirective {
    /**
     * @param {?} el
     * @param {?} translatePipe
     * @param {?} control
     */
    constructor(el, translatePipe, control) {
        this.el = el;
        this.translatePipe = translatePipe;
        this.control = control;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.generateTextareaWrapper(); // Call first
        this.fieldMessageChange(); // Call second
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        //if (this.wrapperNode && this.wrapperNode.removeEventListener && this.radio !== undefined) {
        //  this.wrapperNode.removeEventListener('click', this.wrapperClickHandle);
        //}
    }
    /**
     * @private
     * @return {?}
     */
    generateTextareaWrapper() {
        if (this.el && this.el.nativeElement) {
            this.wrapperNode = document.createElement('div');
            /** @type {?} */
            const message = document.createElement('p');
            //if ((this.unitIds && this.unitIds.length) || (this.unitsStr && this.unitsStr.length)) {
            //  this.el.nativeElement.classList.add('loading');
            //}
            if (this.label) {
                /** @type {?} */
                const label = document.createElement('label');
                label.classList.add('spiraxTextarea_label');
                label.innerHTML = this.label;
                this.wrapperNode.appendChild(label);
            }
            this.wrapperNode.classList.add('spiraxTextarea');
            message.classList.add('spiraxTextarea_message');
            message.innerHTML = this.generateMessage(this.control && this.control.control);
            this.el.nativeElement.setAttribute('placeholder', ' ');
            this.el.nativeElement.classList.add('spiraxTextarea_control');
            if (this.el.nativeElement.parentNode) {
                this.el.nativeElement.parentNode.insertBefore(this.wrapperNode, this.el.nativeElement);
            }
            this.wrapperNode.appendChild(this.el.nativeElement);
            this.wrapperNode.appendChild(message);
        }
    }
    /**
     * @private
     * @param {?=} c
     * @return {?}
     */
    fieldMessageChange(c) {
        /** @type {?} */
        const control = c || this.control && this.control.control;
        /** @type {?} */
        const errorNode = this.el && this.el.nativeElement &&
            this.el.nativeElement.parentNode &&
            this.el.nativeElement.parentNode.querySelector('.spiraxTextarea_message');
        if (control && errorNode && control.statusChanges && control.valueChanges) {
            /** @type {?} */
            const updateMsgFn = (/**
             * @return {?}
             */
            () => errorNode.innerHTML = control.valid ? '' : this.generateMessage(control));
            control.statusChanges.pipe(debounceTime(400), distinctUntilChanged()).subscribe(updateMsgFn);
            control.valueChanges.pipe(debounceTime(400), distinctUntilChanged()).subscribe(updateMsgFn);
        }
    }
    /**
     * @private
     * @param {?} control
     * @return {?}
     */
    generateMessage(control) {
        /** @type {?} */
        const errors = control && control.errors || this.error;
        if (!errors) {
            return null;
        }
        if (typeof errors === 'string') {
            return errors;
        }
        if (errors && errors.required) {
            return null;
        }
        /** @type {?} */
        let error;
        //let attemptValue: any;
        /** @type {?} */
        let errorMessage = null;
        if (errors.error) {
            error = errors.error;
        }
        if (error) {
            errorMessage = this.translatePipe.transform(error);
        }
        return errorMessage;
    }
    /**
     * @private
     * @param {?} leftUnit
     * @param {?} rightUnit
     * @param {?=} wrapper
     * @return {?}
     */
    generateUnits(leftUnit, rightUnit, wrapper) {
        /** @type {?} */
        let html = '';
        if (!wrapper) {
            html = '<div class="spiraxTextarea_unit">';
        }
        if (leftUnit) {
            html += `<span>${leftUnit}</span>`;
        }
        if (leftUnit && rightUnit) {
            html += '/';
        }
        if (rightUnit) {
            html += `<span>${rightUnit}</span>`;
        }
        if (!wrapper) {
            html += '</div>';
            this.el.nativeElement.classList.remove('loading');
            this.el.nativeElement.insertAdjacentHTML('afterend', html);
            return this.el.nativeElement.parentNode.querySelector('.spiraxTextarea_unit');
        }
        else {
            if (html) {
                wrapper.innerHTML = html;
            }
            else {
                wrapper.remove();
            }
        }
    }
}
SpiraxTextareaDirective.decorators = [
    { type: Directive, args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[spirax-textarea]',
            },] }
];
/** @nocollapse */
SpiraxTextareaDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: TranslatePipe },
    { type: NgControl, decorators: [{ type: Optional }] }
];
SpiraxTextareaDirective.propDecorators = {
    label: [{ type: Input }],
    error: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    SpiraxTextareaDirective.prototype.label;
    /** @type {?} */
    SpiraxTextareaDirective.prototype.error;
    /**
     * @type {?}
     * @private
     */
    SpiraxTextareaDirective.prototype.wrapperNode;
    /**
     * @type {?}
     * @private
     */
    SpiraxTextareaDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    SpiraxTextareaDirective.prototype.translatePipe;
    /**
     * @type {?}
     * @private
     */
    SpiraxTextareaDirective.prototype.control;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/spirax-forms/components/spirax-panel/spirax-panel.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SpiraxPanelComponent {
    constructor() {
        this.id = 'SgaPanelComponent-ID';
        this.titleSize = '16px';
        this.showSeparator = true;
        this.expanded = true;
        this.expandedChange = new EventEmitter();
    }
    /**
     * @return {?}
     */
    togglePanel() {
        this.expanded = !this.expanded;
        this.expandedChange.emit(this.expanded);
    }
}
SpiraxPanelComponent.decorators = [
    { type: Component, args: [{
                // tslint:disable-next-line:component-selector
                selector: 'spirax-panel',
                template: "<div class=\"panel ssPanel\" [ngStyle]=\"{ background: background }\">\r\n  <div class=\"panel-heading\" [ngClass]=\"{invalid: invalid}\">\r\n    <ng-template *ngIf=\"!!headingRef\" [ngTemplateOutlet]=\"headingRef\"></ng-template>\r\n    <div *ngIf=\"!headingRef\">\r\n      <h4 class=\"panel-title\" *ngIf=\"!!title\" [ngStyle]=\"{fontSize: titleSize }\">\r\n        <i *ngIf=\"!!invalid\" class=\"fa fa-warning\"></i>\r\n        <span>{{title}}</span>\r\n        <i class=\"fa fa-info-circle ssPanel_tooltip\" [tooltip]=\"titleTooltip\" placement=\"bottom\" *ngIf=\"!!titleTooltip\"></i>\r\n      </h4>\r\n      <p class=\"ssPanel_subtitle\" *ngIf=\"!!subtitle\">{{subtitle}}</p>\r\n    </div>\r\n    <button class=\"ssPanel_toggle\"\r\n            type=\"button\"\r\n            [disabled]=\"disabled\"\r\n            *ngIf=\"!disableToggle\"\r\n            [attr.aria-controls]=\"id\"\r\n            [attr.aria-expanded]=\"expanded\"\r\n            (click)=\"togglePanel()\">\r\n      {{!expanded ? '+' : '\u2212'}}\r\n    </button>\r\n  </div>\r\n\r\n  <div class=\"collapse\" [id]=\"id\" [collapse]=\"!expanded\">\r\n    <div class=\"panel-body\">\r\n      <hr *ngIf=\"showSeparator\">\r\n      <ng-content select=\"[body]\"></ng-content>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                styles: [".ssPanel .collapse{transition:.3s ease-out;display:block!important;overflow:hidden!important;max-height:0}.ssPanel .collapse.in{transition:.7s;max-height:20000px}.ssPanel_toggle{background:var(--color-background-panel);border:none;outline:0;box-shadow:none;margin:0;padding:0;width:32px;height:32px;min-width:32px;min-height:32px;border-radius:50%;line-height:1;font-size:28px;display:inline-flex;justify-content:center;align-items:center}.ssPanel_tooltip{margin-left:5px}.ssPanel_subtitle{margin-top:16px;margin-bottom:0;font-family:var(--font-proxima-nova);font-style:normal;font-weight:600;font-size:16px;line-height:105%;display:flex;align-items:center;color:var(--color-blue-40)}.panel-heading{display:flex;align-items:center;justify-content:space-between;padding:24px}.panel-heading.invalid .panel-title{color:var(--color-alarm-red)}.panel-title{font-family:var(--font-proxima-nova);font-style:normal;font-weight:600;font-size:18px;line-height:105%;text-transform:uppercase;color:var(--color-blue)}.panel-body{padding:0 24px 24px}.panel-body>:first-child{padding-top:24px}.panel-body>hr{border-top:1px solid var(--color-steel-40);margin:0}"]
            }] }
];
/** @nocollapse */
SpiraxPanelComponent.ctorParameters = () => [];
SpiraxPanelComponent.propDecorators = {
    id: [{ type: Input }],
    title: [{ type: Input }],
    subtitle: [{ type: Input }],
    titleSize: [{ type: Input }],
    titleTooltip: [{ type: Input }],
    background: [{ type: Input }],
    showSeparator: [{ type: Input }],
    disableToggle: [{ type: Input }],
    headingRef: [{ type: Input }],
    disabled: [{ type: Input }],
    invalid: [{ type: Input }],
    expanded: [{ type: Input }],
    expandedChange: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    SpiraxPanelComponent.prototype.id;
    /** @type {?} */
    SpiraxPanelComponent.prototype.title;
    /** @type {?} */
    SpiraxPanelComponent.prototype.subtitle;
    /** @type {?} */
    SpiraxPanelComponent.prototype.titleSize;
    /** @type {?} */
    SpiraxPanelComponent.prototype.titleTooltip;
    /** @type {?} */
    SpiraxPanelComponent.prototype.background;
    /** @type {?} */
    SpiraxPanelComponent.prototype.showSeparator;
    /** @type {?} */
    SpiraxPanelComponent.prototype.disableToggle;
    /** @type {?} */
    SpiraxPanelComponent.prototype.headingRef;
    /** @type {?} */
    SpiraxPanelComponent.prototype.disabled;
    /** @type {?} */
    SpiraxPanelComponent.prototype.invalid;
    /** @type {?} */
    SpiraxPanelComponent.prototype.expanded;
    /** @type {?} */
    SpiraxPanelComponent.prototype.expandedChange;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/spirax-forms/components/spirax-form-radio-group/spirax-form-radio-group.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SpiraxFormRadioGroupComponent {
    constructor() {
        this.value = true;
        this.valueChange = new EventEmitter();
        this.onChange = (/**
         * @param {?} value
         * @return {?}
         */
        (value) => { });
        this.onTouched = (/**
         * @return {?}
         */
        () => { });
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    writeValue(val) {
        this.value = val;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    updateValue(val) {
        // If fields from one group has different formGroupNames
        this.value = this.inputValue || val;
        this.onTouched();
        this.onChange(this.value);
        this.valueChange.emit({ ref: this.inputRef, value: this.value, group: this.name });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
SpiraxFormRadioGroupComponent.decorators = [
    { type: Component, args: [{
                // tslint:disable-next-line:component-selector
                selector: 'spirax-form-radio-group',
                template: "<label class=\"formRadio\">\r\n  <span class=\"formRadio-above\">\r\n    <ng-content></ng-content>\r\n  </span>\r\n  <span class=\"formRadio-row\">\r\n    <input type=\"radio\"\r\n           #inputRef\r\n           [name]=\"name\"\r\n           [value]=\"value\"\r\n           (change)=\"updateValue($event)\"\r\n           [defaultChecked]=\"defaultChecked\"\r\n           [required]=\"required\"\r\n           [disabled]=\"disabled\">\r\n    <span class=\"formRadio-label\" *ngIf=\"!!label\">{{label | translate}}</span>\r\n  </span>\r\n</label>\r\n",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => SpiraxFormRadioGroupComponent)),
                        multi: true,
                    }],
                styles: [".formRadio{display:flex;flex-direction:column}.formRadio-above{margin-bottom:25px}.formRadio-above::ng-deep img{cursor:pointer;padding:10px;max-height:100%;max-width:100%;height:180px;width:100%;background-color:var(--color-white);-o-object-fit:contain;object-fit:contain}.formRadio-row{display:flex;align-items:center}.formRadio-row input{margin:0 40px 20px 0;width:0;height:0;outline:0;position:relative;-ms-grid-row-align:center;align-self:center}.formRadio-row input:active,.formRadio-row input:focus{outline:0}.formRadio-row input:after{content:\"\";display:inline-block;visibility:visible;border:1px solid var(--color-steel-80);background-color:var(--color-white);box-sizing:border-box;border-radius:50%;width:20px;height:20px;min-width:20px;min-height:20px}.formRadio-row input:checked:after{border-color:var(--color-blue);background-color:var(--color-white);border-width:6px}.formRadio-row input:hover{cursor:pointer}.formRadio-label{font-family:var(--font-proxima-nova);font-style:normal;font-weight:600;font-size:16px;line-height:105%;text-transform:uppercase;color:var(--color-blue);word-break:break-word}.formRadio-label:hover{cursor:pointer}"]
            }] }
];
/** @nocollapse */
SpiraxFormRadioGroupComponent.ctorParameters = () => [];
SpiraxFormRadioGroupComponent.propDecorators = {
    value: [{ type: Input }],
    defaultChecked: [{ type: Input }],
    inputValue: [{ type: Input }],
    name: [{ type: Input }],
    label: [{ type: Input }],
    required: [{ type: Input }],
    disabled: [{ type: Input }],
    valueChange: [{ type: Output }],
    inputRef: [{ type: ViewChild, args: ['inputRef', { static: false },] }]
};
if (false) {
    /** @type {?} */
    SpiraxFormRadioGroupComponent.prototype.value;
    /** @type {?} */
    SpiraxFormRadioGroupComponent.prototype.defaultChecked;
    /** @type {?} */
    SpiraxFormRadioGroupComponent.prototype.inputValue;
    /** @type {?} */
    SpiraxFormRadioGroupComponent.prototype.name;
    /** @type {?} */
    SpiraxFormRadioGroupComponent.prototype.label;
    /** @type {?} */
    SpiraxFormRadioGroupComponent.prototype.required;
    /** @type {?} */
    SpiraxFormRadioGroupComponent.prototype.disabled;
    /** @type {?} */
    SpiraxFormRadioGroupComponent.prototype.valueChange;
    /** @type {?} */
    SpiraxFormRadioGroupComponent.prototype.inputRef;
    /**
     * @type {?}
     * @private
     */
    SpiraxFormRadioGroupComponent.prototype.onChange;
    /** @type {?} */
    SpiraxFormRadioGroupComponent.prototype.onTouched;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/spirax-forms/components/spirax-toggle/spirax-toggle.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SpiraxToggleComponent {
    /**
     * @param {?} inj
     */
    constructor(inj) {
        this.inj = inj;
        this.valueChange = new EventEmitter();
        // fake functions
        this.onChange = (/**
         * @param {?} value
         * @return {?}
         */
        (value) => { });
        this.onTouched = (/**
         * @return {?}
         */
        () => { });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.ngControl = this.inj.get(NgControl);
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        this._setFalseToDisabledControls();
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    writeValue(val) {
        this.value = !!val;
        if (val === null) {
            this.onChange(this.value);
        }
    }
    /**
     * @param {?} val
     * @return {?}
     */
    updateValue(val) {
        this.value = val;
        this.onTouched();
        this.onChange(this.value);
        this.valueChange.emit(this.value);
    }
    /**
     * @private
     * @return {?}
     */
    _setFalseToDisabledControls() {
        if (this.ngControl && this.disabled && this.ngControl.control && !this.ngControl.disabled) {
            this.ngControl.control.patchValue(false);
        }
    }
}
SpiraxToggleComponent.decorators = [
    { type: Component, args: [{
                // tslint:disable-next-line:component-selector
                selector: 'spirax-toggle',
                template: "<div class=\"formToggle\" [ngClass]=\"{disabled: disabled}\">\r\n  <p class=\"formToggle-label\" *ngIf=\"!!label\">{{label | translate}}</p>\r\n  <div class=\"formToggle-row\">\r\n    <label>\r\n      <input type=\"radio\"\r\n             [value]=\"true\"\r\n             [name]=\"name || formControlName\"\r\n             [ngModel]=\"value\"\r\n             (ngModelChange)=\"updateValue($event)\"\r\n             (blur)=\"onTouched()\"\r\n             [disabled]=\"disabled\"\r\n             [required]=\"required\">\r\n      <span>{{'YES' | translate}}</span>\r\n    </label>\r\n    <label>\r\n      <input type=\"radio\"\r\n             [value]=\"false\"\r\n             [name]=\"name || formControlName\"\r\n             [ngModel]=\"value\"\r\n             (ngModelChange)=\"updateValue($event)\"\r\n             (blur)=\"onTouched()\"\r\n             [disabled]=\"disabled\"\r\n             [required]=\"required\">\r\n      <span>{{'NO' | translate}}</span>\r\n    </label>\r\n  </div>\r\n</div>\r\n\r\n<!--  Selection content -->\r\n<ng-content *ngIf=\"value === true\" select=\"[yes]\"></ng-content>\r\n<ng-content *ngIf=\"value === false\" select=\"[no]\"></ng-content>\r\n",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => SpiraxToggleComponent)),
                        multi: true,
                    }],
                styles: [".formToggle{color:var(--color-blue);font-family:var(--font-open-sans);font-style:normal;font-weight:400;font-size:16px;margin-bottom:30px}.formToggle.disabled{opacity:.3;cursor:not-allowed}.formToggle-label{display:inline-block;width:100%;font-family:var(--font-proxima-nova);font-weight:600!important;font-size:inherit;color:inherit;line-height:105%;text-transform:uppercase;margin-bottom:8px;padding-left:0;word-break:break-word}.formToggle-row{display:flex;align-items:stretch;min-height:50px}.formToggle-row label{font-weight:600!important;text-transform:uppercase;color:var(--color-blue);margin-bottom:0;display:flex;align-self:center}.formToggle-row label:hover{cursor:pointer}.formToggle-row label:not(.formToggle-rowlabel:last-child){margin-right:45px}.formToggle-row input[type=radio]{margin:0 40px 20px 0;width:0;height:0;outline:0;position:relative;-ms-grid-row-align:center;align-self:center}.formToggle-row input[type=radio]:active,.formToggle-row input[type=radio]:focus{outline:0}.formToggle-row input[type=radio]:after{content:\"\";display:inline-block;visibility:visible;border:1px solid var(--color-steel-80);background-color:var(--color-white);box-sizing:border-box;border-radius:50%;width:20px;height:20px;min-width:20px;min-height:20px}.formToggle-row input[type=radio]:checked:after{border-color:var(--color-blue);background-color:var(--color-white);border-width:6px}.formToggle-row input[type=radio]:hover{cursor:pointer}"]
            }] }
];
/** @nocollapse */
SpiraxToggleComponent.ctorParameters = () => [
    { type: Injector }
];
SpiraxToggleComponent.propDecorators = {
    name: [{ type: Input }],
    formControlName: [{ type: Input }],
    label: [{ type: Input }],
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    required: [{ type: Input }],
    valueChange: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    SpiraxToggleComponent.prototype.name;
    /** @type {?} */
    SpiraxToggleComponent.prototype.formControlName;
    /** @type {?} */
    SpiraxToggleComponent.prototype.label;
    /** @type {?} */
    SpiraxToggleComponent.prototype.value;
    /** @type {?} */
    SpiraxToggleComponent.prototype.disabled;
    /** @type {?} */
    SpiraxToggleComponent.prototype.required;
    /** @type {?} */
    SpiraxToggleComponent.prototype.valueChange;
    /**
     * @type {?}
     * @private
     */
    SpiraxToggleComponent.prototype.ngControl;
    /**
     * @type {?}
     * @private
     */
    SpiraxToggleComponent.prototype.onChange;
    /** @type {?} */
    SpiraxToggleComponent.prototype.onTouched;
    /**
     * @type {?}
     * @private
     */
    SpiraxToggleComponent.prototype.inj;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/spirax-forms/spirax-forms.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SpiraxFormsModule {
}
SpiraxFormsModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslationModule,
                    CollapseModule.forRoot(),
                    TooltipModule.forRoot(),
                ],
                exports: [
                    TooltipModule,
                    SpiraxPanelComponent,
                    SpiraxFormRadioGroupComponent,
                    SpiraxToggleComponent,
                ],
                declarations: [
                    SpiraxPanelComponent,
                    SpiraxFormRadioGroupComponent,
                    SpiraxToggleComponent,
                ],
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/spec-sheet-header-details/spec-sheet-header-details.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SpecSheetHeaderDetailsComponent {
    /**
     * @param {?} fb
     * @param {?} translatePipe
     */
    constructor(fb, translatePipe) {
        this.fb = fb;
        this.translatePipe = translatePipe;
        this.externalOnChange = new EventEmitter();
        this.specSheetHeaderDetailsChanged = new EventEmitter();
        this.onTouched = (/**
         * @return {?}
         */
        () => { });
        this.specSheetForm = this.fb.group({
            sheet: this.sheet,
            quantity: this.quantity,
            revisionNumber: this.revisionNumber,
            aoNumber: this.aoNumber,
            projectType: this.projectType,
            orderNumber: this.orderNumber,
            notes: this.notes
        }, { updateOn: "blur" });
    }
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        if (value) {
            this.specSheetForm.setValue(value);
        }
    }
    /**
     * @param {?} onChange
     * @return {?}
     */
    registerOnChange(onChange) {
        this.onChangeSub = this.specSheetForm.valueChanges.subscribe(onChange);
        //this.specSheetForm.valueChanges.subscribe(onChange);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.onChangeSub.unsubscribe();
    }
    /**
     * @param {?} onTouched
     * @return {?}
     */
    registerOnTouched(onTouched) {
        this.onTouched = onTouched;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        throw new Error('Method not implemented.');
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
SpecSheetHeaderDetailsComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-spec-sheet-header-details',
                template: "\r\n<form [formGroup]=\"specSheetForm\" class=\"form-horizontal\" role=\"form\" novalidate>\r\n\r\n  <div class=\"panel-body\">\r\n\r\n    <!--Col 1-->\r\n    <div class=\"col-lg-5\">\r\n\r\n      <div *ngIf=\"!hideSheet\" class=\"row\">\r\n        <div class=\"col-xs-5\">\r\n          <input spirax-input id=\"sheet\" [hidden]=\"hideSheet\" [label]=\"'SHEET' | translate\" formControlName=\"sheet\" (blur)=\"onTouched()\" />\r\n        </div>\r\n      </div>\r\n\r\n      <div *ngIf=\"!hideRevisionNumber\" class=\"row\">\r\n        <div class=\"col-xs-5\">\r\n          <input spirax-input id=\"revisionNumber\" [hidden]=\"hideRevisionNumber\" [label]=\"'REVISION_NUMBER' | translate\" formControlName=\"revisionNumber\" (blur)=\"onTouched()\" />\r\n        </div>\r\n      </div>\r\n\r\n      <div *ngIf=\"!hideProjectType\" class=\"row\">\r\n        <div class=\"col-xs-5\">\r\n          <input spirax-input id=\"projectType\" [hidden]=\"hideProjectType\" [label]=\"'PROJECT_TYPE' | translate\" formControlName=\"projectType\" (blur)=\"onTouched()\" />\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n    <!--Col 2-->\r\n    <div class=\"col-lg-6\">\r\n\r\n      <div *ngIf=\"!hideQuantity\" class=\"row\">\r\n        <div class=\"col-xs-5\">\r\n          <input spirax-input id=\"quantity\" [hidden]=\"hideQuantity\" [label]=\"'QUANTITY' | translate\" formControlName=\"quantity\" (blur)=\"onTouched()\" />\r\n        </div>\r\n      </div>\r\n\r\n      <div *ngIf=\"!hideAoNumber\" class=\"row\">\r\n        <div class=\"col-xs-5\">\r\n          <input spirax-input id=\"aoNumber\" [hidden]=\"hideAoNumber\" [label]=\"'AO_NUMBER' | translate\" formControlName=\"aoNumber\" (blur)=\"onTouched()\" />\r\n        </div>\r\n      </div>\r\n\r\n      <div *ngIf=\"!hideOrderNumber\" class=\"row\">\r\n        <div class=\"col-xs-5\">\r\n          <input spirax-input id=\"orderNumber\" [hidden]=\"hideOrderNumber\" [label]=\"'ORDER_NUMBER' | translate\" formControlName=\"orderNumber\" (blur)=\"onTouched()\" />\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--Col 3-->\r\n    <div class=\"col-lg-12\">\r\n      <div *ngIf=\"!hideNotes\" class=\"row\">\r\n        <div class=\"col-xs-10\">\r\n          <input spirax-input id=\"notes\" [hidden]=\"hideNotes\" [label]=\"'NOTES_TEXT_DUPLICATE_ID_959' | translate\" formControlName=\"notes\" (blur)=\"onTouched()\" />\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n\r\n</form>\r\n",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: SpecSheetHeaderDetailsComponent
                    }],
                styles: [""]
            }] }
];
/** @nocollapse */
SpecSheetHeaderDetailsComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: TranslatePipe }
];
SpecSheetHeaderDetailsComponent.propDecorators = {
    hideSheet: [{ type: Input }],
    hideQuantity: [{ type: Input }],
    hideRevisionNumber: [{ type: Input }],
    hideAoNumber: [{ type: Input }],
    hideProjectType: [{ type: Input }],
    hideOrderNumber: [{ type: Input }],
    hideNotes: [{ type: Input }],
    externalOnChange: [{ type: Output, args: ['on-change',] }],
    specSheetHeaderDetailsChanged: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.specSheetForm;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.sheet;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.quantity;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.revisionNumber;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.aoNumber;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.projectType;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.orderNumber;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.notes;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.hideSheet;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.hideQuantity;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.hideRevisionNumber;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.hideAoNumber;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.hideProjectType;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.hideOrderNumber;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.hideNotes;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.externalOnChange;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.specSheetHeaderDetailsChanged;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.onChangeSub;
    /** @type {?} */
    SpecSheetHeaderDetailsComponent.prototype.onTouched;
    /**
     * @type {?}
     * @private
     */
    SpecSheetHeaderDetailsComponent.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    SpecSheetHeaderDetailsComponent.prototype.translatePipe;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/spec-sheet-header-details/spec-sheet-header-details.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SpecSheetHeaderDetailsModule {
}
SpecSheetHeaderDetailsModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    TranslationModule,
                    ReactiveFormsModule,
                    SpiraxInputDirectiveModule,
                ],
                declarations: [SpecSheetHeaderDetailsComponent],
                exports: [SpecSheetHeaderDetailsComponent],
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/shared.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// https://angular.io/styleguide#!#04-10
class SharedModule {
}
SharedModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    RouterModule,
                    ReactiveFormsModule,
                    AccordionModule.forRoot(),
                    AlertModule.forRoot(),
                    ButtonsModule.forRoot(),
                    CarouselModule.forRoot(),
                    CollapseModule$1.forRoot(),
                    DatepickerModule.forRoot(),
                    BsDropdownModule.forRoot(),
                    ModalModule.forRoot(),
                    PaginationModule.forRoot(),
                    ProgressbarModule.forRoot(),
                    RatingModule.forRoot(),
                    TabsModule.forRoot(),
                    TimepickerModule.forRoot(),
                    TooltipModule$1.forRoot(),
                    PopoverModule.forRoot(),
                    TypeaheadModule.forRoot(),
                    BlockUIModule,
                    ToasterModule,
                    AlertsModule,
                    SizingSuiteModalModule,
                    TranslationModule,
                    EnumerationModule,
                    EnumerationPickerModule,
                    PreferenceModule,
                    ProductSelectorModule,
                    UnitsModule,
                    SaveLoadModule,
                    NgxDatatableModule,
                    SpiraxFormsModule,
                    SpiraxInputDirectiveModule,
                    SpecSheetHeaderDetailsModule
                ],
                providers: [
                    ColorsService,
                    CalculationsService,
                    SharedService,
                    UserValidator
                ],
                declarations: [
                    SparklineDirective,
                    CheckallDirective,
                    NowDirective,
                    ScrollableDirective,
                    JqcloudDirective,
                    NumberOnlyDirective,
                    TwoDigitDecimalNumberDirective,
                    ModuleRibbonComponent,
                    SpiraxTextareaDirective
                ],
                exports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    RouterModule,
                    AccordionModule,
                    AlertModule,
                    ButtonsModule,
                    CarouselModule,
                    CollapseModule$1,
                    DatepickerModule,
                    BsDropdownModule,
                    ModalModule,
                    PaginationModule,
                    ProgressbarModule,
                    RatingModule,
                    TabsModule,
                    TimepickerModule,
                    TooltipModule$1,
                    PopoverModule,
                    TypeaheadModule,
                    ToasterModule,
                    AlertsModule,
                    SizingSuiteModalModule,
                    SparklineDirective,
                    CheckallDirective,
                    NowDirective,
                    ScrollableDirective,
                    JqcloudDirective,
                    NumberOnlyDirective,
                    TwoDigitDecimalNumberDirective,
                    TranslationModule,
                    EnumerationModule,
                    EnumerationPickerModule,
                    PreferenceModule,
                    ProductSelectorModule,
                    ModuleRibbonComponent,
                    NgxDatatableModule,
                    SpiraxInputDirectiveModule,
                    SpecSheetHeaderDetailsModule,
                    SpiraxFormsModule,
                    SpiraxTextareaDirective
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/messages/messages.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MessagesService {
    constructor() {
        // Exposed field and private subject for when module groups change.
        this.messages = null;
        this.allMessages = [];
        this.allInternalMessages = new BehaviorSubject$1([]);
        this.currentMessage = this.allInternalMessages.asObservable(); //RPU 2022/09/13 bug fix #6284 - add this to keep an eye on any changes within allInternalMessages[]. We subscribing to currentMessage in sizingModule.component.ts within ngOnInit() 
        //RPU 2022/09/13 bug fix #6284 - add this to keep an eye on any changes within allInternalMessages[]. We subscribing to currentMessage in sizingModule.component.ts within ngOnInit() 
        this.messagesChange = new Subject();
        // Create a subscriber for when preferences change.
        this.messagesChange.subscribe((/**
         * @param {?} messages
         * @return {?}
         */
        (messages) => {
            this.messages = messages;
        }));
    }
    /**
     * @param {?} newMessages
     * @return {?}
     */
    addMessage(newMessages) {
        if (newMessages != null) {
            if (this.messages == null) {
                this.messages = [];
            }
            //check and remove if the message is already there
            for (var msg of newMessages) {
                /** @type {?} */
                var x = this.messages.findIndex((/**
                 * @param {?} allMsg
                 * @return {?}
                 */
                allMsg => allMsg.messageKey == msg.messageKey));
                if (x > -1) {
                    newMessages = newMessages.filter((/**
                     * @param {?} newMsg
                     * @return {?}
                     */
                    newMsg => newMsg != msg));
                }
            }
            if (newMessages.length > 0) {
                newMessages.forEach((/**
                 * @param {?} msg
                 * @return {?}
                 */
                msg => this.messages.push(msg)));
                this.allMessages = this.messages;
                this.allInternalMessages.next(this.messages);
                this.messagesChange.next(this.messages);
            }
            else {
                this.messagesChange.next(null);
            }
        }
        else {
            this.messagesChange.next(newMessages);
        }
    }
    /**
     * @param {?} newMessages
     * @return {?}
     */
    addMessageEhGen4(newMessages) {
        /** @type {?} */
        var unitType;
        if (newMessages != null) {
            if (this.messages == null) {
                this.messages = [];
            }
            //check and remove if the message is already there
            for (var msg of newMessages) {
                unitType = msg.eH_Gen4_Unit;
                /** @type {?} */
                var x = this.messages.findIndex((/**
                 * @param {?} allMsg
                 * @return {?}
                 */
                allMsg => allMsg.messageKey == msg.messageKey && allMsg.eH_Gen4_Unit == msg.eH_Gen4_Unit));
                if (x > -1) {
                    newMessages = newMessages.filter((/**
                     * @param {?} newMsg
                     * @return {?}
                     */
                    newMsg => newMsg != msg));
                }
            }
            if (newMessages.length > 0) {
                newMessages.forEach((/**
                 * @param {?} msg
                 * @return {?}
                 */
                msg => this.messages.push(msg)));
                if (!isNullOrUndefined(this.allMessages)) {
                    this.allMessages = this.allMessages.filter((/**
                     * @param {?} msg
                     * @return {?}
                     */
                    msg => msg.eH_Gen4_Unit !== unitType));
                    for (var msg of this.messages) {
                        /** @type {?} */
                        var x = this.allMessages.findIndex((/**
                         * @param {?} allMsg
                         * @return {?}
                         */
                        allMsg => allMsg.messageKey == msg.messageKey && allMsg.eH_Gen4_Unit == msg.eH_Gen4_Unit));
                        if (x > -1) {
                            this.allMessages = this.allMessages.filter((/**
                             * @param {?} x
                             * @return {?}
                             */
                            x => x.messageKey != msg.messageKey && x.eH_Gen4_Unit != msg.eH_Gen4_Unit));
                        }
                    }
                    this.allMessages = [...this.allMessages, ...this.messages];
                }
                else {
                    this.allMessages = this.messages;
                }
                this.allInternalMessages.next(this.messages);
                this.messagesChange.next(this.messages);
            }
        }
        else {
            this.messagesChange.next(newMessages);
        }
    }
    /**
     * @return {?}
     */
    getAllMessages() {
        return this.allMessages;
    }
    /**
     * @param {?} messages
     * @return {?}
     */
    hideMessage(messages) {
        if (messages != null && messages.length > 0) {
            this.messages = [];
            messages.forEach((/**
             * @param {?} msg
             * @return {?}
             */
            msg => this.messages.push(msg)));
            this.messagesChange.next(this.messages);
        }
        else {
            this.messagesChange.next(messages);
        }
    }
    /**
     * @param {?=} unit
     * @return {?}
     */
    clearMessages(unit) {
        if (this.allMessages != null) {
            if (unit) {
                this.allMessages = this.allMessages.filter((/**
                 * @param {?} msg
                 * @return {?}
                 */
                msg => !msg.eH_Gen4_Unit.includes(unit)));
            }
            else {
                this.allMessages = null;
            }
        }
    }
}
MessagesService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
MessagesService.ctorParameters = () => [];
if (false) {
    /** @type {?} */
    MessagesService.prototype.messages;
    /** @type {?} */
    MessagesService.prototype.allMessages;
    /** @type {?} */
    MessagesService.prototype.allInternalMessages;
    /** @type {?} */
    MessagesService.prototype.currentMessage;
    /**
     * @type {?}
     * @private
     */
    MessagesService.prototype.messagesChange;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/messages/messages.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MessagesComponent {
    /**
     * @param {?} messagesService
     */
    constructor(messagesService) {
        this.messagesService = messagesService;
        this.cloneDeep = cloneDeep_;
        // RPU added 15/06/2023 to be able to see which msg for which unit.  
        /**
         * Anonymous hash to determine severity icons.
         */
        this.severityHash = [
            { icon: "fa fa-info-circle" },
            { icon: "fa fa-exclamation-circle" },
            { icon: "fa fa-times-circle" }
        ];
    }
    /**
     * @return {?}
     */
    get messages() {
        /** @type {?} */
        const messages = this.messagesService.messages;
        return messages;
    }
    /**
     * Dismisses the alert by clearing the messages.
     * @return {?}
     */
    dismissAlert() {
        // To dismiss the alert, clear the messages.
        this.messagesService.addMessage(null);
    }
    /**
     * Dismisses the individual message.
     * @param {?} message
     * @return {?}
     */
    dismissMessage(message) {
        /** @type {?} */
        const messagesCopy = this.cloneDeep(this.messages);
        /** @type {?} */
        const index = this.messages.indexOf(message);
        if (index > -1) {
            messagesCopy.splice(index, 1);
            // Reapply the new messages
            //this.messagesService.addMessage(messagesCopy);
            this.messagesService.hideMessage(messagesCopy);
        }
    }
    /**
     * Determines which icon to use based on the given severity.
     * @param {?} severity
     * @return {?}
     */
    getSeverityIcon(severity) {
        /** @type {?} */
        const hashItem = this.severityHash[severity];
        return !!hashItem ? hashItem.icon : this.severityHash[0].icon;
    }
    /**
     * Determines whether or not the translation term is an internal error.
     * @param {?} message
     * @return {?}
     */
    isInternalError(message) {
        return message === "INTERNAL_ERROR";
    }
}
MessagesComponent.decorators = [
    { type: Component, args: [{
                selector: 'messages',
                template: "<div class=\"messages-alert-wrapper\">\r\n\r\n  <div *ngIf=\"!!messages && messages.length > 0\" class=\"row\">\r\n    <div class=\"col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-12\">\r\n\r\n      \r\n      <!-- The alert box -->\r\n      <div class=\"alert alert-grey\">\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-xs-11\">\r\n\r\n            <div class=\"notification-messages row\" *ngFor=\"let message of messages\">\r\n              <div class=\"col-xs-1 text-right\">\r\n                <i [class]=\"getSeverityIcon(message.severity)\"></i>\r\n              </div>\r\n              <div class=\"col-xs-10\">\r\n                <span>{{message.eH_Gen4_Unit}} {{message.messageKey | translate:isInternalError(message.messageKey)}} {{message.additionalMessage}} </span>\r\n                <span *ngIf=\"message.value !== 0 && message.unitKey\"> ({{message.displayValue}} {{message.unitKey | translate:false}} )</span>\r\n                <span *ngIf=\"message.value !== 0 && !message.unitKey\">{{message.value}}</span>\r\n              </div>\r\n\r\n              <div class=\"col-xs-1\">\r\n                <a (click)=\"dismissMessage(message)\">{{'CLOSE' | translate:true}}</a>\r\n              </div>\r\n\r\n            </div>\r\n\r\n\r\n          </div>\r\n\r\n          <div class=\"col-xs-1\">\r\n            <button (click)=\"dismissAlert()\" class=\"close ng-star-inserted\" type=\"button\">\r\n              <span>&times;</span><span class=\"sr-only\">Close</span>\r\n            </button>\r\n          </div>\r\n\r\n        </div>\r\n\r\n        \r\n\r\n\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n",
                styles: ["div.notification-messages i{font-size:1.4em;margin-right:5px;margin-top:5px;vertical-align:bottom}div.notification-messages .fa-info-circle{color:#00f}div.notification-messages .fa-exclamation-circle{color:orange}div.notification-messages .fa-times-circle{color:red}"]
            }] }
];
/** @nocollapse */
MessagesComponent.ctorParameters = () => [
    { type: MessagesService }
];
if (false) {
    /** @type {?} */
    MessagesComponent.prototype.cloneDeep;
    /** @type {?} */
    MessagesComponent.prototype.EH_Gen4_Unit;
    /**
     * Anonymous hash to determine severity icons.
     * @type {?}
     */
    MessagesComponent.prototype.severityHash;
    /** @type {?} */
    MessagesComponent.prototype.messagesService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/messages/messages.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MessagesModule {
}
MessagesModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule
                ],
                providers: [MessagesService],
                declarations: [MessagesComponent],
                exports: [MessagesComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/core.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CoreModule {
    /**
     * @param {?} parentModule
     */
    constructor(parentModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
CoreModule.decorators = [
    { type: NgModule, args: [{
                imports: [FormsModule, AuthenticationModule],
                providers: [
                    SettingsService,
                    MenuService
                ], exports: [AuthenticationModule, MessagesModule]
            },] }
];
/** @nocollapse */
CoreModule.ctorParameters = () => [
    { type: CoreModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizing-shared-lib/sizing-shared-lib.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//import * as $ from "node_modules/jquery/dist/jquery.js";
//import * as pre from "../core/preloader/preloader.js";
//"node_modules/jquery-sparkline/jquery.sparkline.js",
//"node_modules/jquery-slimscroll/jquery.slimscroll.js",
//"node_modules/jqcloud2/dist/jqcloud.js",
//"node_modules/popper.js/dist/umd/popper.js",
//"node_modules/bootstrap/dist/js/bootstrap.js",
//"node_modules/summernote/dist/summernote.js",
//"node_modules/moment/min/moment-with-locales.min.js",
//"node_modules/fullcalendar/dist/fullcalendar.js"
class SizingSharedLibComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
SizingSharedLibComponent.decorators = [
    { type: Component, args: [{
                selector: 'sizing-sizing-shared-lib',
                template: "<div></div>",
                encapsulation: ViewEncapsulation.None //for styling inheritence - libraries
                ,
                styles: ["@charset \"UTF-8\";.preloader{position:fixed;top:0;left:0;width:100%;height:100%;overflow:hidden;background-color:#053775;background-image:linear-gradient(90deg,#053775 10%,#042c5d 90%);z-index:9999;transition:opacity .65s}.preloader-progress{position:absolute;top:0;left:0;bottom:0;right:0;width:128px;height:30px;margin:auto;overflow:auto;background-image:url(../../../assets/img/preloader/preloader.sizingsuite.empty.png);background-size:128px 30px}.preloader-progress-bar{position:absolute;top:0;left:0;bottom:0;min-width:10px;background-image:url(../../../assets/img/preloader/preloader.sizingsuite.full.png);background-size:128px 30px}.preloader-hidden{display:none}.preloader-hidden-add{opacity:1;display:block}.preloader-hidden-add .preloader-progress{transition:transform .4s;transform:scale(0)}.preloader-hidden-add-active{opacity:0}/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a:active,a:hover{outline:0}b,optgroup,strong{font-weight:700}dfn{font-style:italic}h1{margin:.67em 0}mark{background:#ff0;color:#000}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0;vertical-align:middle}svg:not(:root){overflow:hidden}code,kbd,pre,samp{font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box;box-sizing:border-box;-webkit-appearance:none}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}textarea{overflow:auto}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{background:0 0!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:transparent;direction:ltr;touch-action:manipulation}body{margin:0;font-size:14px;line-height:1.528571429}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{background-color:transparent;color:#649cb4;text-decoration:none;outline:0!important;cursor:pointer}a:focus,a:hover{color:#427489;text-decoration:underline}a:focus{outline:-webkit-focus-ring-color auto 5px;outline-offset:-2px}figure{margin:0}.img-responsive{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:2px;line-height:1.528571429;background-color:#e1e2e3;border:1px solid #e1e2e3;border-radius:3px;transition:.2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{box-sizing:content-box;height:0;margin-top:21px;margin-bottom:21px;border:0}.sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#3a3f51}.h1,.h2,.h3,h1,h2,h3{margin-top:21px;margin-bottom:10.5px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10.5px;margin-bottom:10.5px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10.5px}#noMargins{margin:0}.lead{margin-bottom:21px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}.small,small{font-size:85%}.mark,mark{background-color:#fcf8e3;padding:.2em}.text-left{text-align:left}.text-center{text-align:center}.text-justify{text-align:justify}.text-lowercase{text-transform:lowercase}.initialism,.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#909fa7}.text-primary{color:#649cb4}a.text-primary:focus,a.text-primary:hover{color:#4b829a}.text-success{color:#27c24c}a.text-success:focus,a.text-success:hover{color:#1e983b}.text-info{color:#23b7e5}a.text-info:focus,a.text-info:hover{color:#1797be}.text-warning{color:#ff902b}a.text-warning:focus,a.text-warning:hover{color:#f77600}.text-danger{color:#f05050}a.text-danger:focus,a.text-danger:hover{color:#ec2121}a.bg-primary:focus,a.bg-primary:hover{background-color:#4b829a}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9.5px;margin:42px 0 21px;border-bottom:1px solid #edf1f2}ol,ul{margin-top:0;margin-bottom:10.5px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-unstyled{padding-left:0;list-style:none}.list-inline{padding-left:0;list-style:none;margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dl{margin-top:0;margin-bottom:21px}dd,dt{line-height:1.528571429}dt{font-weight:700}dd{margin-left:0}.dl-horizontal dd:after,.dl-horizontal dd:before{content:\" \";display:table}.dl-horizontal dd:after{clear:both}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #3a3f51}.initialism{font-size:90%}blockquote{padding:10.5px 21px;margin:0 0 21px;font-size:17.5px;border-left:5px solid #edf1f2}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.528571429;color:#3a3f51}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\u2014\u00A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;border-right:5px solid #edf1f2;border-left:0;text-align:right}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\u00A0\u2014\"}address{margin-bottom:21px;font-style:normal;line-height:1.528571429}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,\"Courier New\",monospace}code{padding:2px 4px;font-size:90%;color:#c7254e;background-color:#f9f2f4;border-radius:4px}kbd{padding:2px 4px;font-size:90%;color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{overflow:auto;display:block;padding:10px;margin:0 0 10.5px;font-size:13px;line-height:1.528571429;word-break:break-all;word-wrap:break-word;color:#3a3f51;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container:after,.container:before{content:\" \";display:table}.container:after{clear:both}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container-fluid:after,.container-fluid:before{content:\" \";display:table}.container-fluid:after{clear:both}.row{margin-left:-15px;margin-right:-15px}.row:after,.row:before{content:\" \";display:table}.row:after{clear:both}.col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-xs-1,.col-xs-10,.col-xs-11,.col-xs-12,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9{position:relative;min-height:1px;padding-left:15px;padding-right:15px}.col-xs-1,.col-xs-10,.col-xs-11,.col-xs-12,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9{float:left}.col-xs-1{width:8.3333333333%}.col-xs-2{width:16.6666666667%}.col-xs-3{width:25%}.col-xs-4{width:33.3333333333%}.col-xs-5{width:41.6666666667%}.col-xs-6{width:50%}.col-xs-7{width:58.3333333333%}.col-xs-8{width:66.6666666667%}.col-xs-9{width:75%}.col-xs-10{width:83.3333333333%}.col-xs-11{width:91.6666666667%}.col-xs-12{width:100%}.col-xs-pull-0{right:auto}.col-xs-pull-1{right:8.3333333333%}.col-xs-pull-2{right:16.6666666667%}.col-xs-pull-3{right:25%}.col-xs-pull-4{right:33.3333333333%}.col-xs-pull-5{right:41.6666666667%}.col-xs-pull-6{right:50%}.col-xs-pull-7{right:58.3333333333%}.col-xs-pull-8{right:66.6666666667%}.col-xs-pull-9{right:75%}.col-xs-pull-10{right:83.3333333333%}.col-xs-pull-11{right:91.6666666667%}.col-xs-pull-12{right:100%}.col-xs-push-0{left:auto}.col-xs-push-1{left:8.3333333333%}.col-xs-push-2{left:16.6666666667%}.col-xs-push-3{left:25%}.col-xs-push-4{left:33.3333333333%}.col-xs-push-5{left:41.6666666667%}.col-xs-push-6{left:50%}.col-xs-push-7{left:58.3333333333%}.col-xs-push-8{left:66.6666666667%}.col-xs-push-9{left:75%}.col-xs-push-10{left:83.3333333333%}.col-xs-push-11{left:91.6666666667%}.col-xs-push-12{left:100%}.col-xs-offset-0{margin-left:0}.col-xs-offset-1{margin-left:8.3333333333%}.col-xs-offset-2{margin-left:16.6666666667%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.3333333333%}.col-xs-offset-5{margin-left:41.6666666667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-7{margin-left:58.3333333333%}.col-xs-offset-8{margin-left:66.6666666667%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.3333333333%}.col-xs-offset-11{margin-left:91.6666666667%}.col-xs-offset-12{margin-left:100%}@media (min-width:768px){.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9{float:left}.col-sm-1{width:8.3333333333%}.col-sm-2{width:16.6666666667%}.col-sm-3{width:25%}.col-sm-4{width:33.3333333333%}.col-sm-5{width:41.6666666667%}.col-sm-6{width:50%}.col-sm-7{width:58.3333333333%}.col-sm-8{width:66.6666666667%}.col-sm-9{width:75%}.col-sm-10{width:83.3333333333%}.col-sm-11{width:91.6666666667%}.col-sm-12{width:100%}.col-sm-pull-0{right:auto}.col-sm-pull-1{right:8.3333333333%}.col-sm-pull-2{right:16.6666666667%}.col-sm-pull-3{right:25%}.col-sm-pull-4{right:33.3333333333%}.col-sm-pull-5{right:41.6666666667%}.col-sm-pull-6{right:50%}.col-sm-pull-7{right:58.3333333333%}.col-sm-pull-8{right:66.6666666667%}.col-sm-pull-9{right:75%}.col-sm-pull-10{right:83.3333333333%}.col-sm-pull-11{right:91.6666666667%}.col-sm-pull-12{right:100%}.col-sm-push-0{left:auto}.col-sm-push-1{left:8.3333333333%}.col-sm-push-2{left:16.6666666667%}.col-sm-push-3{left:25%}.col-sm-push-4{left:33.3333333333%}.col-sm-push-5{left:41.6666666667%}.col-sm-push-6{left:50%}.col-sm-push-7{left:58.3333333333%}.col-sm-push-8{left:66.6666666667%}.col-sm-push-9{left:75%}.col-sm-push-10{left:83.3333333333%}.col-sm-push-11{left:91.6666666667%}.col-sm-push-12{left:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.3333333333%}.col-sm-offset-2{margin-left:16.6666666667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.3333333333%}.col-sm-offset-5{margin-left:41.6666666667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.3333333333%}.col-sm-offset-8{margin-left:66.6666666667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.3333333333%}.col-sm-offset-11{margin-left:91.6666666667%}.col-sm-offset-12{margin-left:100%}}@media (min-width:992px){.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9{float:left}.col-md-1{width:8.3333333333%}.col-md-2{width:16.6666666667%}.col-md-3{width:25%}.col-md-4{width:33.3333333333%}.col-md-5{width:41.6666666667%}.col-md-6{width:50%}.col-md-7{width:58.3333333333%}.col-md-8{width:66.6666666667%}.col-md-9{width:75%}.col-md-10{width:83.3333333333%}.col-md-11{width:91.6666666667%}.col-md-12{width:100%}.col-md-pull-0{right:auto}.col-md-pull-1{right:8.3333333333%}.col-md-pull-2{right:16.6666666667%}.col-md-pull-3{right:25%}.col-md-pull-4{right:33.3333333333%}.col-md-pull-5{right:41.6666666667%}.col-md-pull-6{right:50%}.col-md-pull-7{right:58.3333333333%}.col-md-pull-8{right:66.6666666667%}.col-md-pull-9{right:75%}.col-md-pull-10{right:83.3333333333%}.col-md-pull-11{right:91.6666666667%}.col-md-pull-12{right:100%}.col-md-push-0{left:auto}.col-md-push-1{left:8.3333333333%}.col-md-push-2{left:16.6666666667%}.col-md-push-3{left:25%}.col-md-push-4{left:33.3333333333%}.col-md-push-5{left:41.6666666667%}.col-md-push-6{left:50%}.col-md-push-7{left:58.3333333333%}.col-md-push-8{left:66.6666666667%}.col-md-push-9{left:75%}.col-md-push-10{left:83.3333333333%}.col-md-push-11{left:91.6666666667%}.col-md-push-12{left:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1{margin-left:8.3333333333%}.col-md-offset-2{margin-left:16.6666666667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.3333333333%}.col-md-offset-5{margin-left:41.6666666667%}.col-md-offset-6{margin-left:50%}.col-md-offset-7{margin-left:58.3333333333%}.col-md-offset-8{margin-left:66.6666666667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.3333333333%}.col-md-offset-11{margin-left:91.6666666667%}.col-md-offset-12{margin-left:100%}}@media (min-width:1200px){.col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9{float:left}.col-lg-1{width:8.3333333333%}.col-lg-2{width:16.6666666667%}.col-lg-3{width:25%}.col-lg-4{width:33.3333333333%}.col-lg-5{width:41.6666666667%}.col-lg-6{width:50%}.col-lg-7{width:58.3333333333%}.col-lg-8{width:66.6666666667%}.col-lg-9{width:75%}.col-lg-10{width:83.3333333333%}.col-lg-11{width:91.6666666667%}.col-lg-12{width:100%}.col-lg-pull-0{right:auto}.col-lg-pull-1{right:8.3333333333%}.col-lg-pull-2{right:16.6666666667%}.col-lg-pull-3{right:25%}.col-lg-pull-4{right:33.3333333333%}.col-lg-pull-5{right:41.6666666667%}.col-lg-pull-6{right:50%}.col-lg-pull-7{right:58.3333333333%}.col-lg-pull-8{right:66.6666666667%}.col-lg-pull-9{right:75%}.col-lg-pull-10{right:83.3333333333%}.col-lg-pull-11{right:91.6666666667%}.col-lg-pull-12{right:100%}.col-lg-push-0{left:auto}.col-lg-push-1{left:8.3333333333%}.col-lg-push-2{left:16.6666666667%}.col-lg-push-3{left:25%}.col-lg-push-4{left:33.3333333333%}.col-lg-push-5{left:41.6666666667%}.col-lg-push-6{left:50%}.col-lg-push-7{left:58.3333333333%}.col-lg-push-8{left:66.6666666667%}.col-lg-push-9{left:75%}.col-lg-push-10{left:83.3333333333%}.col-lg-push-11{left:91.6666666667%}.col-lg-push-12{left:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1{margin-left:8.3333333333%}.col-lg-offset-2{margin-left:16.6666666667%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.3333333333%}.col-lg-offset-5{margin-left:41.6666666667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-7{margin-left:58.3333333333%}.col-lg-offset-8{margin-left:66.6666666667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.3333333333%}.col-lg-offset-11{margin-left:91.6666666667%}.col-lg-offset-12{margin-left:100%}}table{border-collapse:collapse;border-spacing:0;background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#909fa7;text-align:left}th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:21px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.528571429;vertical-align:top;border-top:1px solid #eee}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #eee}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #eee}.table .table{background-color:#f5f7fa}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #eee}.table-hover>tbody>tr:hover,.table-striped>tbody>tr:nth-of-type(odd){background-color:#fafbfc}table col[class*=col-]{position:static;float:none;display:table-column}table td[class*=col-],table th[class*=col-]{position:static;float:none;display:table-cell}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#fafbfc}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#eaeef2}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{overflow-x:auto;min-height:.01%}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15.75px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #eee}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{padding:0;margin:0;border:0;min-width:0}legend{display:block;width:100%;padding:0;margin-bottom:21px;font-size:21px;line-height:inherit;color:#3a3f51;border:0;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=checkbox],input[type=radio]{margin:4px 0 0;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:-webkit-focus-ring-color auto 5px;outline-offset:-2px}output{display:block;padding-top:7px;font-size:14px;line-height:1.528571429;color:#3a3f51}.form-control{display:block;width:100%;height:35px;padding:6px 16px;font-size:14px;line-height:1.528571429;color:#3a3f51;background-color:#fff;background-image:none;border:1px solid #dde6e9;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#b7bac9;opacity:1}.form-control:-ms-input-placeholder{color:#b7bac9}.form-control::-webkit-input-placeholder{color:#b7bac9}.form-control::-ms-expand{border:0;background-color:transparent}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#edf1f2;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:35px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],.input-group-sm>.input-group-btn>input[type=date].btn,.input-group-sm>.input-group-btn>input[type=datetime-local].btn,.input-group-sm>.input-group-btn>input[type=month].btn,.input-group-sm>.input-group-btn>input[type=time].btn,input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],.input-group-lg>.input-group-btn>input[type=date].btn,.input-group-lg>.input-group-btn>input[type=datetime-local].btn,.input-group-lg>.input-group-btn>input[type=month].btn,.input-group-lg>.input-group-btn>input[type=time].btn,input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:21px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox input[type=checkbox],.checkbox-inline input[type=checkbox],.radio input[type=radio],.radio-inline input[type=radio]{position:absolute;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .radio label,fieldset[disabled] .radio-inline,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0;min-height:35px}.form-control-static.input-lg,.form-control-static.input-sm,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn{padding-left:0;padding-right:0}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.input-group-sm>.input-group-btn>select.btn,.input-group-sm>select.form-control,.input-group-sm>select.input-group-addon,select.input-sm{height:30px;line-height:30px}.input-group-sm>.input-group-btn>select[multiple].btn,.input-group-sm>.input-group-btn>textarea.btn,.input-group-sm>select[multiple].form-control,.input-group-sm>select[multiple].input-group-addon,.input-group-sm>textarea.form-control,.input-group-sm>textarea.input-group-addon,select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:33px;padding:6px 10px;font-size:12px;line-height:1.5}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{height:46px;padding:10px 20px;font-size:18px;line-height:1.33;border-radius:6px}.input-group-lg>.input-group-btn>select.btn,.input-group-lg>select.form-control,.input-group-lg>select.input-group-addon,select.input-lg{height:46px;line-height:46px}.input-group-lg>.input-group-btn>select[multiple].btn,.input-group-lg>.input-group-btn>textarea.btn,.input-group-lg>select[multiple].form-control,.input-group-lg>select[multiple].input-group-addon,.input-group-lg>textarea.form-control,.input-group-lg>textarea.input-group-addon,select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 20px;font-size:18px;line-height:1.33;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:39px;padding:11px 20px;font-size:18px;line-height:1.33}.has-feedback{position:relative}.has-feedback .form-control{padding-right:43.75px}.form-control-feedback{position:absolute;top:0;z-index:2;display:block;width:35px;height:35px;line-height:35px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-group-lg>.form-control+.form-control-feedback,.input-group-lg>.input-group-addon+.form-control-feedback,.input-group-lg>.input-group-btn>.btn+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.checkbox label,.has-success.checkbox-inline label,.has-success.radio label,.has-success.radio-inline label{color:#27c24c}.has-success .form-control{border-color:#27c24c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#1e983b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #6de289}.has-success .input-group-addon{color:#27c24c;border-color:#27c24c;background-color:#dff0d8}.has-success .form-control-feedback{color:#27c24c}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.checkbox label,.has-warning.checkbox-inline label,.has-warning.radio label,.has-warning.radio-inline label{color:#ff902b}.has-warning .form-control{border-color:#ff902b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#f77600;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ffc591}.has-warning .input-group-addon{color:#ff902b;border-color:#ff902b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#ff902b}.has-error .checkbox,.has-error .checkbox-inline,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.checkbox label,.has-error.checkbox-inline label,.has-error.radio label,.has-error.radio-inline label{color:#f05050}.has-error .form-control{border-color:#f05050;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#ec2121;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #f8aeae}.has-error .input-group-addon{color:#f05050;border-color:#f05050;background-color:#f2dede}.has-error .form-control-feedback{color:#f05050}.has-feedback label~.form-control-feedback{top:26px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#909293}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:28px}.form-horizontal .form-group{margin-left:-15px;margin-right:-15px}.form-horizontal .form-group:after,.form-horizontal .form-group:before{content:\" \";display:table}.form-horizontal .form-group:after{clear:both}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 16px;line-height:1.528571429;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:-webkit-focus-ring-color auto 5px;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;opacity:.65;box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#eaeaea}.btn-default.active,.btn-default.focus,.btn-default:active,.btn-default:focus,.btn-default:hover,.open>.btn-default.dropdown-toggle{color:#333;background-color:#f5f5f5;border-color:#d6d6d6}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.btn-default.dropdown-toggle.focus,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle:hover{color:#333;background-color:#f5f5f5;border-color:#d6d6d6}.btn-default.active,.btn-default:active,.open>.btn-default.dropdown-toggle{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#eaeaea}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#649cb4;border-color:#619ab2}.btn-primary.active,.btn-primary.focus,.btn-primary:active,.btn-primary:focus,.btn-primary:hover,.open>.btn-primary.dropdown-toggle{color:#fff;background-color:#5693ad;border-color:#4c859e}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.btn-primary.dropdown-toggle.focus,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle:hover{color:#fff;background-color:#5693ad;border-color:#4c859e}.btn-primary.active,.btn-primary:active,.open>.btn-primary.dropdown-toggle{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#649cb4;border-color:#619ab2}.btn-primary .badge{color:#649cb4;background-color:#fff}.btn-success{color:#fff;background-color:#27c24c;border-color:#26be4a}.btn-success.active,.btn-success.focus,.btn-success:active,.btn-success:focus,.btn-success:hover,.open>.btn-success.dropdown-toggle{color:#fff;background-color:#24b145;border-color:#1f9c3d}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.btn-success.dropdown-toggle.focus,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle:hover{color:#fff;background-color:#24b145;border-color:#1f9c3d}.btn-success.active,.btn-success:active,.open>.btn-success.dropdown-toggle{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#27c24c;border-color:#26be4a}.btn-success .badge{color:#27c24c;background-color:#fff}.btn-info.active,.btn-info.focus,.btn-info:active,.btn-info:focus,.btn-info:hover,.open>.btn-info.dropdown-toggle{color:#fff;background-color:#1aacda;border-color:#179ac3}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.btn-info.dropdown-toggle.focus,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle:hover{color:#fff;background-color:#1aacda;border-color:#179ac3}.btn-info.active,.btn-info:active,.open>.btn-info.dropdown-toggle{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#23b7e5;border-color:#1eb6e4}.btn-info .badge{color:#23b7e5;background-color:#fff}.btn-warning{color:#fff;background-color:#ff902b;border-color:#ff8d26}.btn-warning.active,.btn-warning.focus,.btn-warning:active,.btn-warning:focus,.btn-warning:hover,.open>.btn-warning.dropdown-toggle{color:#fff;background-color:#ff8517;border-color:#fc7800}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.btn-warning.dropdown-toggle.focus,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle:hover{color:#fff;background-color:#ff8517;border-color:#fc7800}.btn-warning.active,.btn-warning:active,.open>.btn-warning.dropdown-toggle{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#ff902b;border-color:#ff8d26}.btn-warning .badge{color:#ff902b;background-color:#fff}.btn-danger{color:#fff;background-color:#f05050;border-color:#f04b4b}.btn-danger.active,.btn-danger.focus,.btn-danger:active,.btn-danger:focus,.btn-danger:hover,.open>.btn-danger.dropdown-toggle{color:#fff;background-color:#ee3d3d;border-color:#ec2626}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.btn-danger.dropdown-toggle.focus,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle:hover{color:#fff;background-color:#ee3d3d;border-color:#ec2626}.btn-danger.active,.btn-danger:active,.open>.btn-danger.dropdown-toggle{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#f05050;border-color:#f04b4b}.btn-danger .badge{color:#f05050;background-color:#fff}.btn-link{color:#649cb4;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#427489;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#e4eaec;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 20px;font-size:18px;line-height:1.33;border-radius:6px}.btn-group-sm>.btn,.btn-sm,.calendar-app .fc-button{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #e1e1e1;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9.5px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.528571429;color:#5f5f5f;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#2f3342;background-color:#fafbfc}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#649cb4}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#e4eaec}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.528571429;white-space:nowrap}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px dashed;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar:after,.btn-toolbar:before{content:\" \";display:table}.btn-toolbar:after{clear:both}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group-lg.btn-group>.btn+.dropdown-toggle,.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-group-lg>.btn .caret,.btn-lg .caret{border-width:5px 5px 0}.dropup .btn-group-lg>.btn .caret,.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before{content:\" \";display:table}.btn-group-vertical>.btn-group:after{clear:both}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-radius:4px 4px 0 0}.btn-group-vertical>.btn:last-child:not(:first-child){border-radius:0 0 4px 4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio],[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group .form-control,.input-group-addon,.input-group-btn{display:table-cell}.input-group .form-control:not(:first-child):not(:last-child),.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 16px;font-size:14px;font-weight:400;line-height:1;color:#3a3f51;text-align:center;background-color:#edf1f2;border:1px solid #dde6e9;border-radius:4px}.input-group-addon.input-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn{padding:10px 20px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group .form-control:first-child,.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group .form-control:last-child,.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{position:relative;font-size:0;white-space:nowrap}.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav:after,.nav:before{content:\" \";display:table}.nav:after{clear:both}.nav>li{position:relative;display:block}.nav>li>a{position:relative;display:block;padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:transparent}.nav>li.disabled>a{color:#e4eaec}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#e4eaec;text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:transparent;border-color:#649cb4}.nav .nav-divider{height:1px;margin:9.5px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{line-height:1.528571429}.nav-tabs>li>a:hover{border-color:#ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#dde6e9;background-color:#fff;border:1px solid #ddd;cursor:default}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#649cb4}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified,.nav-tabs.nav-justified{width:100%}.nav-justified>li,.nav-tabs.nav-justified>li{float:none}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}.nav-tabs-justified,.nav-tabs.nav-justified{border-bottom:0}.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a{border:1px solid #ddd}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{left:0;right:auto}.nav-justified>li,.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{margin-bottom:0}.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a{border-bottom-color:#f5f7fa}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.navbar{position:relative;min-height:55px;margin-bottom:21px;border:1px solid transparent}.navbar:after,.navbar:before{content:\" \";display:table}.navbar:after{clear:both}.navbar-header:after,.navbar-header:before{content:\" \";display:table}.navbar-header:after{clear:both}.navbar-collapse{overflow-x:visible;padding-right:15px;padding-left:15px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 rgba(255,255,255,.1);-webkit-overflow-scrolling:touch}.navbar-collapse:after,.navbar-collapse:before{content:\" \";display:table}.navbar-collapse:after{clear:both}.navbar-collapse.in{overflow-y:auto}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.navbar{border-radius:4px}.navbar-header{float:left}.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-left:0;padding-right:0}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}.navbar-static-top{border-radius:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;padding:17px 15px;font-size:18px;line-height:21px;height:55px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}.navbar>.container .navbar-brand,.navbar>.container-fluid .navbar-brand{margin-left:-15px}.navbar-toggle{display:none}}.navbar-toggle{position:relative;float:right;margin-right:15px;padding:9px 10px;margin-top:10.5px;margin-bottom:10.5px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}.navbar-nav{margin:8.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:21px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:21px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:17px;padding-bottom:17px}.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}.navbar-form{padding:10px 15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 rgba(255,255,255,.1),0 1px 0 rgba(255,255,255,.1);margin:10px -15px}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#fff}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#ddd;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#ddd;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}@media (min-width:768px){.navbar-form{width:auto;border:0;margin-left:0;margin-right:0;padding-top:0;padding-bottom:0;box-shadow:none}.navbar-text{float:left;margin-left:15px;margin-right:15px}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-right-radius:0;border-top-left-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-radius:4px 4px 0 0}.navbar-btn{margin-top:10px;margin-bottom:10px}.btn-group-sm>.navbar-btn.btn,.calendar-app .navbar-btn.fc-button,.navbar-btn.btn-sm{margin-top:12.5px;margin-bottom:12.5px}.btn-group-xs>.navbar-btn.btn,.navbar-btn.btn-xs{margin-top:16.5px;margin-bottom:16.5px}.navbar-text{margin-top:17px;margin-bottom:17px}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#fff}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#e6e6e6;background-color:transparent}.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a{color:#fff}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#ddd;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#ddd;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{background-color:#e7e7e7;color:#ddd}.navbar-default .navbar-link{color:#fff}.navbar-default .navbar-link:hover{color:#ddd}.navbar-default .btn-link{color:#fff}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#ddd}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#090909}.navbar-inverse .navbar-brand{color:#e4eaec}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#e4eaec}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{background-color:#090909;color:#fff}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#e4eaec}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#e4eaec}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#e4eaec}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{margin-bottom:21px;list-style:none;background-color:#fafafa}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{content:\"/\u00A0\";padding:0 5px;color:#c1c2c3}.breadcrumb>.active{color:#515253}.pagination{display:inline-block;padding-left:0;margin:21px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 16px;line-height:1.528571429;text-decoration:none;color:#515253;background-color:#fff;border:1px solid #eee;margin-left:-1px}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-bottom-left-radius:4px;border-top-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-bottom-right-radius:4px;border-top-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#427489;background-color:#fafafa;border-color:#eee}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;background-color:#649cb4;border-color:#649cb4;cursor:default}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#e4eaec;background-color:#fff;border-color:#eee;cursor:not-allowed}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 20px;font-size:18px;line-height:1.33}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-bottom-left-radius:6px;border-top-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-bottom-right-radius:6px;border-top-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pager{padding-left:0;margin:21px 0;list-style:none;text-align:center}.pager:after,.pager:before{content:\" \";display:table}.pager:after{clear:both}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #eee;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#fafafa}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#e4eaec;background-color:#fff;cursor:not-allowed}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}.label:empty{display:none}.btn .label{position:relative;top:-1px}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label-default{background-color:#e4eaec}.label-default[href]:focus,.label-default[href]:hover{background-color:#c6d3d7}.label-primary{background-color:#649cb4}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#4b829a}.label-success{background-color:#27c24c}.label-success[href]:focus,.label-success[href]:hover{background-color:#1e983b}.label-info{background-color:#23b7e5}.label-info[href]:focus,.label-info[href]:hover{background-color:#1797be}.label-warning{background-color:#ff902b}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#f77600}.label-danger{background-color:#f05050}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#ec2121}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;color:#fff;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;background-color:#e4eaec;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#649cb4;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;color:inherit;background-color:#fcfcfc}.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#e3e3e3}.container .jumbotron,.container-fluid .jumbotron{border-radius:6px;padding-left:15px;padding-right:15px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container .jumbotron,.container-fluid .jumbotron{padding-left:60px;padding-right:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:2px;margin-bottom:21px;line-height:1.528571429;background-color:#e1e2e3;border:1px solid #e1e2e3;border-radius:3px;transition:border .2s ease-in-out}.thumbnail a>img,.thumbnail>img{display:block;max-width:100%;height:auto;margin-left:auto;margin-right:auto}.thumbnail .caption{padding:9px;color:#515253}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#649cb4}.alert{padding:8px;margin-bottom:21px;border:1px solid transparent;border-radius:3px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:28px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#27c24c;border-color:rgba(0,0,0,.1);color:#fff}.alert-success hr{border-top-color:rgba(0,0,0,.1)}.alert-success .alert-link{color:#e6e6e6}.alert-info{background-color:#23b7e5;border-color:rgba(0,0,0,.1);color:#fff}.alert-info hr{border-top-color:rgba(0,0,0,.1)}.alert-info .alert-link{color:#e6e6e6}.alert-warning{background-color:#ff902b;border-color:rgba(0,0,0,.1);color:#fff}.alert-warning hr{border-top-color:rgba(0,0,0,.1)}.alert-warning .alert-link{color:#e6e6e6}.alert-danger{background-color:#f05050;border-color:rgba(0,0,0,.1);color:#fff}.alert-danger hr{border-top-color:rgba(0,0,0,.1)}.alert-danger .alert-link{color:#e6e6e6}@-webkit-keyframes progress-bar-stripes{from{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{from{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:21px;margin-bottom:21px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0%;height:100%;font-size:12px;line-height:21px;color:#fff;text-align:center;background-color:#649cb4;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:2s linear infinite progress-bar-stripes;animation:2s linear infinite progress-bar-stripes}.progress-bar-success{background-color:#27c24c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)}.progress-bar-info{background-color:#23b7e5}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)}.progress-bar-warning{background-color:#ff902b}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)}.progress-bar-danger{background-color:#f05050}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{zoom:1;overflow:hidden}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{margin-bottom:20px;padding-left:0}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #e4eaec}.list-group-item:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{text-decoration:none;color:#555;background-color:#fafbfc}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{background-color:#edf1f2;color:#e4eaec;cursor:not-allowed}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#e4eaec}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#649cb4;border-color:#649cb4}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#edf4f7}.list-group-item-success{color:#27c24c;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#27c24c}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#27c24c;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#27c24c;border-color:#27c24c}.list-group-item-info{color:#23b7e5;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#23b7e5}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#23b7e5;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#23b7e5;border-color:#23b7e5}.list-group-item-warning{color:#ff902b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#ff902b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#ff902b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#ff902b;border-color:#ff902b}.list-group-item-danger{color:#f05050;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#f05050}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#f05050;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#f05050;border-color:#f05050}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:21px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-body:after,.panel-body:before{content:\" \";display:table}.panel-body:after{clear:both}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-right-radius:3px;border-top-left-radius:3px}.panel-heading>.dropdown .dropdown-toggle{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px;color:inherit}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#fafafa;border-top:1px solid #eee;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-right-radius:3px;border-top-left-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-right-radius:0;border-top-left-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table caption,.panel>.table-responsive>.table caption{padding-left:15px;padding-right:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table:first-child{border-top-right-radius:3px;border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-left-radius:3px;border-bottom-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #eee}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{border:0;margin-bottom:0}.panel-group{margin-bottom:21px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #eee}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #eee}.panel-default{border-color:#cfdbe2}.panel-default>.panel-heading{color:#444;background-color:#fff;border-color:#cfdbe2}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#cfdbe2}.panel-default>.panel-heading .badge{color:#fff;background-color:#444}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#cfdbe2}.panel-primary{border-color:#cfdbe2}.panel-primary>.panel-heading{color:#fff;background-color:#649cb4;border-color:#cfdbe2}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#cfdbe2}.panel-primary>.panel-heading .badge{color:#649cb4;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#cfdbe2}.panel-success{border-color:#cfdbe2}.panel-success>.panel-heading{color:#fff;background-color:#27c24c;border-color:#cfdbe2}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#cfdbe2}.panel-success>.panel-heading .badge{color:#27c24c;background-color:#fff}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#cfdbe2}.panel-info{border-color:#cfdbe2}.panel-info>.panel-heading{color:#fff;background-color:#23b7e5;border-color:#cfdbe2}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#cfdbe2}.panel-info>.panel-heading .badge{color:#23b7e5;background-color:#fff}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#cfdbe2}.panel-warning{border-color:#cfdbe2}.panel-warning>.panel-heading{color:#fff;background-color:#ff902b;border-color:#cfdbe2}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#cfdbe2}.panel-warning>.panel-heading .badge{color:#ff902b;background-color:#fff}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#cfdbe2}.panel-danger{border-color:#cfdbe2}.panel-danger>.panel-heading{color:#fff;background-color:#f05050;border-color:#cfdbe2}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#cfdbe2}.panel-danger>.panel-heading .badge{color:#f05050;background-color:#fff}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#cfdbe2}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;left:0;bottom:0;height:100%;width:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#fff;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5}button.close{padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.modal-open{overflow:hidden}.modal{display:none;overflow:hidden;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{transform:translate(0,-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{transform:translate(0,0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);background-clip:padding-box;outline:0}.modal-backdrop{top:0;right:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop.in{opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header:after,.modal-header:before{content:\" \";display:table}.modal-header:after{clear:both}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.528571429}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer:after,.modal-footer:before{content:\" \";display:table}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.528571429;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:12px;pointer-events:none;opacity:0}.tooltip.in{opacity:.9}.tooltip.top{margin-top:30px;padding:5px 0}.tooltip.right{margin-left:3px;padding:0 5px}.tooltip.bottom{margin-top:3px;padding:5px 0}.tooltip.left{margin-left:-10px;padding:0 5px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#222;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#222}.tooltip.top-left .tooltip-arrow{bottom:0;right:5px;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#222}.tooltip.top-right .tooltip-arrow{bottom:0;left:5px;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#222}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#222}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#222}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#222}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#222}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#222}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.528571429;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #e1e1e1;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{margin:0;padding:8px 14px;font-size:14px;background-color:#fafafa;border-bottom:1px solid #ededed;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{border-width:10px;content:\"\"}.popover.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#e1e1e1;bottom:-11px}.popover.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fafafa}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#e1e1e1}.popover.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fafafa}.popover.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#e1e1e1;top:-11px}.popover.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fafafa}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#e1e1e1}.popover.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fafafa;bottom:-10px}.carousel{position:relative}.carousel-inner{position:relative;overflow:hidden;width:100%}.carousel-inner>.item{display:none;position:relative;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{display:block;max-width:100%;height:auto;line-height:1}@media all and (transform-3d),(-webkit-transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{transform:translate3d(0,0,0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;left:0;bottom:0;width:15%;opacity:.5;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:rgba(0,0,0,0)}.carousel-control.left{background-image:linear-gradient(to right,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001) 100%);background-repeat:repeat-x}.carousel-control.right{left:auto;right:0;background-image:linear-gradient(to right,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5) 100%);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{outline:0;color:#fff;text-decoration:none;opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;margin-top:-10px;z-index:5;display:inline-block}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;line-height:1;font-family:serif}.carousel-control .icon-prev:before{content:\"\u2039\"}.carousel-control .icon-next:before{content:\"\u203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;margin-left:-30%;padding-left:0;list-style:none;text-align:center}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;border:1px solid #fff;border-radius:10px;cursor:pointer;background-color:rgba(0,0,0,0)}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#fff}.carousel-caption{position:absolute;left:15%;right:15%;bottom:20px;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{left:20%;right:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}.visible-xs-block{display:block!important}.visible-xs-inline{display:inline!important}.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}.visible-sm-block{display:block!important}.visible-sm-inline{display:inline!important}.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}.visible-md-block{display:block!important}.visible-md-inline{display:inline!important}.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}.visible-lg-block{display:block!important}.visible-lg-inline{display:inline!important}.visible-lg-inline-block{display:inline-block!important}.hidden-lg{display:none!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}.hidden-print{display:none!important}}@font-face{font-family:SizingSuiteV2;src:url(assets/ssv2Font/files/SizingSuiteV2.ttf?fehyx8) format(\"truetype\"),url(assets/ssv2Font/files/SizingSuiteV2.woff?fehyx8) format(\"woff\"),url(assets/ssv2Font/files/SizingSuiteV2.svg?fehyx8#SizingSuiteV2) format(\"svg\");font-weight:400;font-style:normal;font-display:block}[class*=\" ssv2-\"],[class^=ssv2-]{font-family:SizingSuiteV2!important;speak:never;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.ssv2-home-dark:before{content:\"\uE900\"}.ssv2-home-white:before{content:\"\uE901\"}.ssv2-control-valve-dark:before{content:\"\uE902\"}.ssv2-control-valve-white:before{content:\"\uE903\"}.ssv2-csg-fb-dark .path1:before{content:\"\uE904\"}.ssv2-csg-fb-dark .path2:before{content:\"\uE905\";margin-left:-1em}.ssv2-csg-fb-dark .path3:before{content:\"\uE906\";margin-left:-1em}.ssv2-csg-fb-dark .path4:before{content:\"\uE907\";margin-left:-1em}.ssv2-csg-fb-dark .path5:before{content:\"\uE908\";margin-left:-1em}.ssv2-csg-fb-dark .path6:before{content:\"\uE909\";margin-left:-1em}.ssv2-csg-fb-white:before{content:\"\uE90A\"}.ssv2-csg-healthcare-dark .path1:before{content:\"\uE90B\"}.ssv2-csg-healthcare-dark .path2:before{content:\"\uE90C\";margin-left:-1em}.ssv2-csg-healthcare-dark .path3:before{content:\"\uE90D\";margin-left:-1em}.ssv2-csg-healthcare-dark .path4:before{content:\"\uE90E\";margin-left:-1em}.ssv2-csg-healthcare-dark .path5:before{content:\"\uE90F\";margin-left:-1em}.ssv2-csg-healthcare-white:before{content:\"\uE910\"}.ssv2-easiheat-dark:before{content:\"\uE911\"}.ssv2-easiheat-white:before{content:\"\uE912\"}.ssv2-flowmetering-dark:before{content:\"\uE913\"}.ssv2-flowmetering-white:before{content:\"\uE914\"}.ssv2-pressure-reducing-valve-dark:before{content:\"\uE915\"}.ssv2-pressure-reducing-valve-white:before{content:\"\uE916\"}.ssv2-safety-valve-dark:before{content:\"\uE917\"}.ssv2-safety-valve-white:before{content:\"\uE918\"}.ssv2-shell-tube-dark:before{content:\"\uE919\"}.ssv2-shell-tube-white:before{content:\"\uE91A\"}.ssv2-steam-generation-efficiency-dark:before{content:\"\uE91B\"}.ssv2-steam-generation-efficiency-white:before{content:\"\uE91C\"}/*!\n *\n * Angle - Bootstrap Admin App + AngularJS\n *\n * Version: 3.8.9.1\n * Author: @themicon_co\n * Website: http://themicon.co\n * License: https://wrapbootstrap.com/help/licenses\n *\n */:focus{outline:0!important}a.text-muted:focus,a.text-muted:hover{color:#748690}hr{border-top:1px solid #e4eaec}[now]{display:inline-block}.list-group{line-height:1.3}.list-group .list-group-item{padding:10px}.panel>.list-group .list-group-item{border-top:0}.navbar-toggle .icon-bar{background-color:#fff}.page-header{border-bottom-color:#e4eaec}.panel .panel-heading{border-bottom:0;font-size:14px}.panel .panel-heading a{text-decoration:none!important}.panel.panel-default{border-top-width:3px}.jumbotron,.well{border:1px solid #dde6e9}@media only screen and (min-width:768px){.jumbotron{padding:30px 15px}}.nav-tabs>li>a{font-weight:700;color:#515253;background-color:#edf1f2;margin:0;border:1px solid #dde6e9;border-radius:0;padding:10px 20px}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:inherit;border-bottom-color:#fff}.tab-content{padding:10px 20px;border-style:solid;border-width:0 1px 1px;border-color:#dde6e9}.p0 .tab-content{padding:0!important}.nav-pills+.tab-content{border:0;padding:0}.btn{border-radius:3px;font-size:13px;border-color:transparent;-webkit-appearance:none;outline:0!important;transition:.1s}.btn.btn-link{box-shadow:none;border:0}.btn.btn-default{border-color:#eaeaea}.input-group .btn{font-size:14px;border-color:#dde6e9}.input-group .input-group-sm>.form-control+.input-group-btn .btn,.input-group .input-group-sm>.input-group-addon+.input-group-btn .btn,.input-group .input-group-sm>.input-group-btn>.btn+.input-group-btn .btn,.input-group .input-sm+.input-group-btn .btn{font-size:13px}.form-control{box-shadow:0 0 0 #000!important}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-sm,select.input-sm{height:31px}fieldset{padding-bottom:20px;border-bottom:1px dashed #eee;margin-bottom:20px}fieldset.last-child,fieldset:last-child{border-bottom:0}fieldset .form-group{margin-bottom:0}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th,.table>tbody+tbody,.table>thead>tr>th{border-bottom-width:1px}.progress{box-shadow:0 0 0 #000;border-radius:3px;border:1px solid #f1f1f1;background-color:#fff}.progress .progress-bar{box-shadow:0 0 0 #000}.popover{box-shadow:0 0 0 #000;border-color:#eee;border-bottom:2px solid #e4eaec;border-radius:3px}.popover .popover-title{border:0}.nav.nav-pills .active>a{background-color:#649cb4}.dropdown-menu{border-radius:3px}.dropdown-header{color:#a1a2a3}.navbar-top .navbar-nav>.active>a{color:#999}.navbar-top .navbar-nav>.active>a:focus,.navbar-top .navbar-nav>.active>a:hover{color:#d1d2d3}.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#666}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#222}.carousel .carousel-indicators{bottom:0}.carousel .carousel-control.left,.carousel .carousel-control.right{background-image:none}.carousel .carousel-control em{position:absolute;top:50%;left:50%;z-index:5;display:inline-block;width:20px;height:20px;margin-top:-10px;margin-left:-10px}.carousel,.nav,.pagination,.panel-title a{cursor:pointer}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom:0}.modal-backdrop{position:fixed;bottom:0}.navbar,.navbar .dropdown-menu,.topnavbar{-webkit-filter:none!important;filter:none!important}.glyphicon{display:inline-block;font:14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon.glyphicon-chevron-right:before{content:\"\uF054\"}.glyphicon.glyphicon-chevron-left:before{content:\"\uF053\"}.glyphicon.glyphicon-chevron-up:before{content:\"\uF077\"}.glyphicon.glyphicon-chevron-down:before{content:\"\uF078\"}.glyphicon.glyphicon-folder-open:before{content:\"\uF07C\"}body{font-family:\"Source Sans Pro\",sans-serif;color:#656565}h1,h2,h3,h4{font-weight:700}app-root,body,html{height:100%}.wrapper,app-root{display:block}.wrapper{position:relative;width:100%;height:auto;min-height:100%;overflow-x:hidden}.wrapper.ng-leave{display:none}.wrapper>.aside{position:absolute;width:220px;top:0;left:0;bottom:0;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:width .2s cubic-bezier(.35,0,.25,1),translate .2s cubic-bezier(.35,0,.25,1)}.wrapper>.aside .aside-inner{padding-top:110px;height:100%;width:220px;overflow:hidden}.wrapper>.aside>.nav-floating{left:inherit;margin-left:220px;z-index:1110;min-width:190px;overflow:auto}.wrapper>.aside .dropdown-backdrop{z-index:-1}.wrapper>section{position:relative;height:100%;margin-left:0;z-index:111;margin-bottom:60px!important;transition:margin-left .2s cubic-bezier(.35,0,.25,1)}.wrapper>footer{position:absolute;left:0;right:0;bottom:0;height:60px;border-top:1px solid #e4eaec;padding:20px;z-index:109}.wrapper>footer>p{margin:0}.modal-open .wrapper>section{z-index:inherit;transform:none!important;-webkit-transform:none!important}.content-wrapper{padding:15px;width:100%;border-top:1px solid rgba(0,0,0,.15);margin-top:-1px}.content-wrapper .unwrap{margin:-15px}@media only screen and (min-width:768px){.content-wrapper .unwrap{margin:-20px}}.content-wrapper .content-heading{font-size:24px;line-height:1.1;color:#929292;margin:-15px -15px 20px;padding:15px;font-weight:400;background-color:#fafbfc;border-bottom:1px solid #cfdbe2}.content-wrapper .content-heading>small{display:block;font-size:12px;color:#909fa7}.content-wrapper>.btn,.content-wrapper>button{margin:10px 10px 0 0}.content-wrapper .container,.content-wrapper .container-fluid{padding-left:0;padding-right:0}@media only screen and (min-width:768px){.content-wrapper{padding:20px}.content-wrapper .content-heading{margin:-20px -20px 20px;padding:20px}.content-wrapper>.btn,.content-wrapper>button{margin:0}body{min-height:100%}.wrapper>.aside .aside-inner{padding-top:55px}.wrapper>footer,.wrapper>section{margin-left:220px}.wrapper>section.has-sidebar-right{margin-right:240px}.wrapper>section.has-sidebar-right+.offsidebar{z-index:1}}@media only screen and (max-width:767px){input[type=email],input[type=password],input[type=search],input[type=text]{-webkit-appearance:none}.wrapper>.aside{margin-left:-220px}.aside-toggled .wrapper>footer,.aside-toggled .wrapper>section{margin-left:220px}.aside-toggled .wrapper>.aside{margin-left:0}.csstransforms3d .wrapper{-webkit-backface-visibility:hidden;backface-visibility:hidden}.csstransforms3d .wrapper>footer,.csstransforms3d .wrapper>section{margin-left:0;transform:translate3d(0,0,0);transition:transform .3s}.csstransforms3d .wrapper>.aside{margin-left:0;transform:translate3d(-100%,0,0);transition:transform .3s}.csstransforms3d .aside-toggled .wrapper>footer,.csstransforms3d .aside-toggled .wrapper>section{transform:translate3d(220px,0,0)}.csstransforms3d .aside-toggled .wrapper>.aside{transform:translate3d(0,0,0)}.aside-collapsed .wrapper>.aside{margin-left:-70px}.aside-collapsed.aside-toggled .wrapper>footer,.aside-collapsed.aside-toggled .wrapper>section{margin-left:70px}.aside-collapsed.aside-toggled .wrapper>.aside{margin-left:0}.csstransforms3d .aside-collapsed .wrapper{-webkit-backface-visibility:hidden;backface-visibility:hidden}.csstransforms3d .aside-collapsed .wrapper>footer,.csstransforms3d .aside-collapsed .wrapper>section{margin-left:0;transform:translate3d(0,0,0);transition:transform .3s}.csstransforms3d .aside-collapsed .wrapper>.aside{margin-left:0;transform:translate3d(-70px,0,0);transition:transform .3s}.csstransforms3d .aside-collapsed.aside-toggled .wrapper>footer,.csstransforms3d .aside-collapsed.aside-toggled .wrapper>section{transform:translate3d(70px,0,0)}.csstransforms3d .aside-collapsed.aside-toggled .wrapper>.aside{transform:translate3d(0,0,0)}}.aside-collapsed{overflow-y:auto;-webkit-overflow-scrolling:touch}.aside-collapsed .wrapper>.aside,.aside-collapsed .wrapper>.aside>.aside-inner{width:70px}.aside-collapsed .wrapper>.aside>.nav-floating{margin-left:70px}@media only screen and (max-width:767px){.aside-collapsed-text .wrapper>.aside{margin-left:-90px}.aside-collapsed-text.aside-toggled .wrapper>footer,.aside-collapsed-text.aside-toggled .wrapper>section{margin-left:90px}.aside-collapsed-text.aside-toggled .wrapper>.aside{margin-left:0}.csstransforms3d .aside-collapsed-text .wrapper{-webkit-backface-visibility:hidden;backface-visibility:hidden}.csstransforms3d .aside-collapsed-text .wrapper>footer,.csstransforms3d .aside-collapsed-text .wrapper>section{margin-left:0;transform:translate3d(0,0,0);transition:transform .3s}.csstransforms3d .aside-collapsed-text .wrapper>.aside{margin-left:0;transform:translate3d(-90px,0,0);transition:transform .3s}.csstransforms3d .aside-collapsed-text.aside-toggled .wrapper>footer,.csstransforms3d .aside-collapsed-text.aside-toggled .wrapper>section{transform:translate3d(90px,0,0)}.csstransforms3d .aside-collapsed-text.aside-toggled .wrapper>.aside{transform:translate3d(0,0,0)}}.aside-collapsed-text{overflow-y:auto;-webkit-overflow-scrolling:touch}.aside-collapsed-text .wrapper>.aside,.aside-collapsed-text .wrapper>.aside>.aside-inner{width:90px}.aside-collapsed-text .wrapper>.aside>.nav-floating{margin-left:90px}@media (max-width:1140px){.layout-fixed.aside-toggled,.layout-fixed.offsidebar-open{overflow-y:hidden}}.layout-fixed .wrapper .topnavbar-wrapper{position:fixed;top:0;width:100%;z-index:121}.layout-fixed .wrapper>.aside,.layout-fixed .wrapper>.offsidebar{position:fixed}.layout-fixed .wrapper>.aside{height:1px;min-height:100%}.layout-fixed .wrapper>.aside>.aside-inner{position:fixed;top:0;bottom:0}.layout-fixed .wrapper>section{margin-top:114px}@media only screen and (min-width:768px){.aside-collapsed .wrapper>footer,.aside-collapsed .wrapper>section{margin-left:70px}.aside-collapsed-text .wrapper>footer,.aside-collapsed-text .wrapper>section{margin-left:90px}.layout-fixed .wrapper>section{margin-top:55px}}_:-ms-lang(x),.layout-fixed .wrapper > .aside > .aside-inner{position:static!important}@media only screen and (min-width:992px){.layout-boxed{overflow:auto!important}.layout-boxed .wrapper{margin:0 auto;overflow:hidden;box-shadow:0 0 13px rgba(0,0,0,.25)}.layout-boxed .wrapper .offsidebar{position:absolute!important}.layout-boxed .wrapper>.aside{left:inherit}.layout-boxed .wrapper,.layout-boxed .wrapper .topnavbar-wrapper{width:970px}.layout-boxed.layout-fixed .wrapper>.aside>.aside-inner{left:inherit}}@media only screen and (min-width:1200px){.layout-boxed .wrapper,.layout-boxed .wrapper .topnavbar-wrapper{width:1140px}}.hidden-footer .wrapper>footer{display:none}.hidden-footer .wrapper>section{margin-bottom:0!important}.layout-fs .wrapper>section{position:absolute;top:114px;left:0;right:0;bottom:60px;height:auto;margin-top:0!important;margin-bottom:0!important;overflow-y:auto;-webkit-overflow-scrolling:touch}.layout-fs .wrapper>section>.content-wrapper{width:100%;height:100%;padding:0}.layout-fs .wrapper>section>.content-wrapper>*{height:100%}.layout-fs.hidden-footer .wrapper>section{bottom:0}.d-table,.d-table-fixed{display:table;width:100%;height:100%;min-height:240px;border-spacing:0}.d-table-fixed{table-layout:fixed}.d-row{display:table-row;height:100%}.d-cell,.d-cell-wrapper{position:relative;display:table-cell;height:100%;width:100%;vertical-align:top;overflow:auto}.d-cell-wrapper{display:block}.d-cell-wrapper .d-cell-inner{position:absolute;top:0;right:0;bottom:0;left:0}@-moz-document url-prefix(){.d-table,.d-table-desktop{height:240px;min-height:100%}.d-cell-inner{overflow:auto}}.fh{height:100%!important}.fw{width:100%!important}.scroll{overflow:auto}.scroll-y{overflow-y:auto}.layout-h .wrapper>section{max-width:1140px;margin-left:auto;margin-right:auto}.layout-h .wrapper>section>.content-wrapper .content-heading{display:none}.layout-h .wrapper>.offsidebar{margin-top:55px}.layout-h .wrapper>footer{margin:0}.layout-h>.layout-fixed .wrapper>.offsidebar,.layout-h>.layout-fixed .wrapper>section{margin-top:55px}.aside-float .wrapper{box-shadow:0 0 0 #000}.aside-float .wrapper>footer{border:0}.aside-float .wrapper>.aside{padding:15px 0;background:0 0}.aside-float .wrapper>.aside>.aside-inner{height:100%;top:15px;bottom:15px;left:inherit}.aside-float .wrapper>.aside .sidebar{border:1px solid #e4eaec}.aside-float .wrapper>.aside .sidebar:after{display:none}.aside-float .wrapper .content-wrapper{border:0}.aside-float .wrapper .content-wrapper .content-heading{padding-top:30px;border:0;background-color:transparent}.aside-float .wrapper .content-wrapper .unwrap{margin:0!important}.aside-float.aside-toggled .wrapper>.aside{transition-delay:50ms}.aside-float.aside-toggled .wrapper>.aside>.aside-inner{margin-left:15px}.aside-float.aside-toggled .wrapper>section{padding-left:15px}.aside-float.aside-toggled .wrapper>footer{left:15px}@media only screen and (min-width:992px){.aside-float.layout-boxed .wrapper>.aside>.aside-inner{margin-left:0}.aside-float.layout-boxed .wrapper>section{padding-left:0}}.aside-float.aside-toggled.layout-fs .wrapper>section>.content-wrapper{padding:0 0 0 20px}.aside-inner,.navbar-header,.sidebar>.nav>li{transition:width .2s cubic-bezier(.35,0,.25,1)}.sidebar>.nav .label{-webkit-animation:1s both fadeInRight;animation:1s both fadeInRight}.aside-collapsed .sidebar>.nav .label,.aside-collapsed-text .sidebar>.nav .label{-webkit-animation:1s fadeIn;animation:1s fadeIn}.sidebar .nav>li>a{-webkit-animation:.5s fadeInLeft;animation:.5s fadeInLeft}.navbar-brand .brand-logo,.sidebar>.nav>.nav-heading,.sidebar>.nav>li>a>span{-webkit-animation:1s fadeIn;animation:1s fadeIn}.sidebar li>.nav-item,.sidebar li>a,.sidebar>.nav>.nav-heading{white-space:nowrap}.aside-collapsed .user-block-picture,.aside-collapsed-text .user-block-picture{transition:width .2s cubic-bezier(.35,0,.25,1)}.aside-collapsed .user-block,.aside-collapsed-text .user-block{transition:padding .2s cubic-bezier(.35,0,.25,1)}.topnavbar{-webkit-backface-visibility:hidden;margin-bottom:0;border-radius:0;z-index:1050;border:0;border-bottom:1px solid rgba(0,0,0,.15);position:relative}.topnavbar .navbar-header{position:relative;z-index:11}.topnavbar .navbar-header .navbar-brand{padding:0}.topnavbar .navbar-header .brand-logo-collapsed>img,.topnavbar .navbar-header .brand-logo>img{margin:0 auto}.topnavbar .navbar-header .brand-logo{display:block;padding:10px 15px}.topnavbar .navbar-header .brand-logo-collapsed{display:none;padding:6px 15px}.topnavbar .navbar-nav>li>[data-toggle=navbar-search]{position:absolute;top:0;right:0;z-index:20;font-size:16px;line-height:55px;padding-top:0;padding-bottom:0;transition:color .3s}@media only screen and (max-width:767px){.d-table-fixed{display:block}.d-table-fixed>.d-cell{display:block;width:auto;height:auto}.layout-h .wrapper>section{margin-top:0}.topnavbar .navbar-text{margin:10px}.sidebar-toggle{position:absolute!important;top:5px;right:0;z-index:3001}.sidebar-toggle>em{color:#fff}}.nav-wrapper{padding:0 15px;background-color:transparent}.nav-wrapper .nav.navbar-nav{float:left}.nav-wrapper .nav.navbar-nav.navbar-right{float:right}.nav-wrapper .nav>li{position:static;float:left}.nav-wrapper .navbar-nav .open .dropdown-menu{position:absolute;background-color:#fff;left:0;right:0;border-top:1px solid #e1e1e1;border-bottom:1px solid #e1e1e1}.topnavbar .navbar-form{position:absolute;top:-100%;left:0;right:0;margin:0;padding:0;height:55px;z-index:9001;transition:.3s;border:0;border-bottom:1px solid #e1e2e3}.topnavbar .navbar-form .form-group{height:100%;width:100%}.topnavbar .navbar-form .form-control{height:100%;border:0;border-radius:0;width:100%}.topnavbar .navbar-form.open{top:0}.topnavbar .navbar-form .has-feedback .form-control-feedback{height:30px;cursor:pointer;top:50%;margin-top:-15px;line-height:30px;margin-right:10px;color:#c1c2c3;font-size:1.5em;pointer-events:auto}@media only screen and (min-width:768px){.layout-fs .wrapper>section{top:55px}.aside-float .wrapper>section{padding-left:15px}.aside-float .wrapper>footer{left:15px}.aside-float.aside-collapsed .topnavbar .navbar-header{width:100px}.aside-float.aside-collapsed-text .topnavbar .navbar-header{width:120px}.aside-float.layout-fs .wrapper>section>.content-wrapper{padding:0 0 0 20px}.aside-float .wrapper>.aside>.aside-inner{margin-left:15px}.topnavbar .navbar-header{width:220px;text-align:center;background-image:none;background-repeat:no-repeat;-webkit-filter:none;filter:none}.topnavbar .navbar-header .navbar-brand{width:100%}.topnavbar .navbar-nav>li>[data-toggle=navbar-search]{color:#fff;position:static}.topnavbar .navbar-form{left:220px}.topnavbar{border:0;background-color:#053775;background-image:linear-gradient(to right,#053775 0,#51c6ea 100%);background-repeat:repeat-x}.topnavbar .navbar-nav>a{box-shadow:0 0 0 #000 inset;transition:.2s}.topnavbar .navbar-nav>.open>a,.topnavbar .navbar-nav>.open>a:focus,.topnavbar .navbar-nav>.open>a:hover{box-shadow:0 -3px 0 #649cb4 inset;transition:.2s}.topnavbar .navbar-nav>.open>a,.topnavbar .navbar-nav>li>.navbar-text,.topnavbar .navbar-nav>li>a{color:#fff}.topnavbar .navbar-nav>.open>a:focus,.topnavbar .navbar-nav>.open>a:hover,.topnavbar .navbar-nav>li>a:focus,.topnavbar .navbar-nav>li>a:hover{color:#010913}.nav-wrapper{position:relative;box-shadow:0 1px 2px rgba(0,0,0,.15);z-index:10}.nav-wrapper:after,.nav-wrapper:before{content:\" \";display:table}.nav-wrapper:after{clear:both}.nav-wrapper .nav>li{position:relative}.nav-wrapper .navbar-nav .open .dropdown-menu{left:auto;right:auto}.nav-wrapper .navbar-nav.navbar-right .open .dropdown-menu{left:auto;right:0}.aside-collapsed .topnavbar .navbar-header .brand-logo{display:none}.aside-collapsed .topnavbar .navbar-header .brand-logo-collapsed{display:block}.aside-collapsed .topnavbar .navbar-header{width:70px}.aside-collapsed .topnavbar .navbar-form{left:70px}.aside-collapsed-text .topnavbar .navbar-header .brand-logo{display:none}.aside-collapsed-text .topnavbar .navbar-header .brand-logo-collapsed{display:block}.aside-collapsed-text .topnavbar .navbar-header{width:90px}.aside-collapsed-text .topnavbar .navbar-form{left:90px}.sidebar>.nav .label{margin:2px 0 0}}.sidebar{height:100%;padding-bottom:20px;overflow-x:hidden;-webkit-overflow-scrolling:touch}.sidebar:after{content:\"\";background:rgba(0,0,0,.15);position:absolute;display:block;top:0;bottom:0;right:0;width:1px;-webkit-transform:translateZ(0)}.sidebar .nav-heading{padding:12px 15px;font-size:13px;letter-spacing:.035em;pointer-events:none;cursor:default}.sidebar>.nav{position:relative}.sidebar>.nav>.nav-heading:first-child{padding-top:20px}.sidebar>.nav>li{border-left:3px solid transparent;transition:border-left-color .4s}.sidebar>.nav>li>.nav-item,.sidebar>.nav>li>a{padding:12px 24px;color:#515253;letter-spacing:.025em;font-weight:400;cursor:pointer}.sidebar>.nav>li>.nav-item:focus,.sidebar>.nav>li>.nav-item:hover,.sidebar>.nav>li>a:focus,.sidebar>.nav>li>a:hover{text-decoration:none;outline:0;color:#053775}.sidebar>.nav>li>.nav-item>em,.sidebar>.nav>li>a>em{width:1.8em;display:inline-block;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;color:inherits}.sidebar>.nav>li.active,.sidebar>.nav>li.active .nav,.sidebar>.nav>li.active>.nav-item,.sidebar>.nav>li.active>a,.sidebar>.nav>li.open,.sidebar>.nav>li.open .nav,.sidebar>.nav>li.open>.nav-item,.sidebar>.nav>li.open>a{background-color:#fcfcfc;color:#053775}.sidebar>.nav>li.active>.nav-item>em,.sidebar>.nav>li.active>a>em,.sidebar>.nav>li.open>.nav-item>em,.sidebar>.nav>li.open>a>em{color:#053775}.sidebar>.nav>li.active{border-left-color:#053775}.sidebar>.nav .label{display:block}@media only screen and (min-width:1025px){.sidebar:not(.show-scrollbar){margin-right:-17px;overflow-y:scroll}}.sidebar-subnav>.sidebar-subnav-header{display:none;padding:10px 20px;font-weight:700}.sidebar-subnav>li{border-left:0!important}.sidebar-subnav>li>.nav-item,.sidebar-subnav>li>a{display:block;position:relative;padding:10px 20px 10px 53px;font-weight:400;background-color:transparent!important}.sidebar-subnav>li>.nav-item>em,.sidebar-subnav>li>a>em{display:inline-block;width:2em;margin:0 0 0 -2em}.sidebar-subnav>li .nav>li{padding-left:5px}.sidebar-subnav.nav-floating{border:1px solid rgba(0,0,0,.15);margin-left:-1px}.sidebar-subnav.nav-floating,.sidebar-subnav.nav-floating .sidebar-subnav{height:auto!important;display:block!important;visibility:visible!important;-webkit-animation:none!important;animation:none!important}.sidebar-subnav.nav-floating>.sidebar-subnav-header{display:block}.sidebar-subnav.nav-floating li>.nav-item,.sidebar-subnav.nav-floating li>a{padding-left:20px}.sidebar-subnav.nav-floating li>.nav-item em,.sidebar-subnav.nav-floating li>a em{margin-left:0}.aside-collapsed .sidebar,.aside-collapsed-text .sidebar{overflow-x:hidden}.aside-collapsed .sidebar>.nav .nav,.aside-collapsed .sidebar>.nav>.nav-heading,.aside-collapsed .sidebar>.nav>li>.nav-item>span,.aside-collapsed .sidebar>.nav>li>a>span,.aside-collapsed-text .sidebar>.nav .nav,.aside-collapsed-text .sidebar>.nav>.nav-heading,.aside-collapsed-text .sidebar>.nav>li>.nav-item>span,.aside-collapsed-text .sidebar>.nav>li>a>span{display:none!important}.aside-collapsed .sidebar>.nav>li,.aside-collapsed-text .sidebar>.nav>li{width:69px}.aside-collapsed .sidebar>.nav>li>.nav-item,.aside-collapsed .sidebar>.nav>li>a,.aside-collapsed-text .sidebar>.nav>li>.nav-item,.aside-collapsed-text .sidebar>.nav>li>a{text-indent:-3px;padding:20px 0;text-align:center}.aside-collapsed .sidebar>.nav>li>.nav-item>em,.aside-collapsed .sidebar>.nav>li>a>em,.aside-collapsed-text .sidebar>.nav>li>.nav-item>em,.aside-collapsed-text .sidebar>.nav>li>a>em{font-size:1.6em;width:auto}.aside-collapsed .sidebar>.nav>li>.nav-item:focus,.aside-collapsed .sidebar>.nav>li>a:focus,.aside-collapsed-text .sidebar>.nav>li>.nav-item:focus,.aside-collapsed-text .sidebar>.nav>li>a:focus{background-color:transparent}.aside-collapsed .sidebar>.nav>li>.nav-item:focus>em,.aside-collapsed .sidebar>.nav>li>a:focus>em,.aside-collapsed-text .sidebar>.nav>li>.nav-item:focus>em,.aside-collapsed-text .sidebar>.nav>li>a:focus>em{color:inherit}.aside-collapsed .sidebar>.nav .nav .label,.aside-collapsed-text .sidebar>.nav .nav .label{position:absolute;top:10px;right:5px;text-indent:0}.aside-collapsed .hide-logo-when-collapsed,.aside-collapsed-text .hide-logo-when-collapsed{display:none}.aside-collapsed .show-logo-when-collapsed,.aside-collapsed-text .show-logo-when-collapsed{display:block;bottom:8px}.aside-collapsed .show-logo-when-collapsed>img,.aside-collapsed-text .show-logo-when-collapsed>img{width:40px;height:40px;margin-left:14px}@media (max-height:550px){.aside-collapsed .content-to-hide-vertical,.aside-collapsed-text .content-to-hide-vertical{display:none}}.aside-collapsed .aside-collapsed-text .sidebar>.nav>li>.nav-item>span,.aside-collapsed .aside-collapsed-text .sidebar>.nav>li>a>span,.aside-collapsed-text .aside-collapsed-text .sidebar>.nav>li>.nav-item>span,.aside-collapsed-text .aside-collapsed-text .sidebar>.nav>li>a>span{display:block!important;font-size:12px}.aside-collapsed .aside-collapsed-text .sidebar>.nav>li,.aside-collapsed-text .aside-collapsed-text .sidebar>.nav>li{width:88px}.aside-collapsed .aside-collapsed-text .sidebar>.nav>li>a,.aside-collapsed-text .aside-collapsed-text .sidebar>.nav>li>a{padding:14px 0}.aside-collapsed .aside-collapsed-text .sidebar>.nav>li>a>em,.aside-collapsed-text .aside-collapsed-text .sidebar>.nav>li>a>em{font-size:1.4em}.aside-collapsed .sidebar-subnav,.aside-collapsed-text .sidebar-subnav{height:0;overflow:hidden;transition:height .2s}.aside-collapsed .sidebar-subnav.opening,.aside-collapsed-text .sidebar-subnav.opening{height:auto;transition:height .2s;-webkit-animation:.5s fadeInLeft;animation:.5s fadeInLeft}.offsidebar{position:absolute;top:0;bottom:0;right:0;width:235px;margin-top:114px;z-index:116;overflow:auto;-webkit-overflow-scrolling:touch;transition:.3s}.offsidebar>nav{min-height:100%;overflow:hidden;-webkit-transform:translateZ(0)}.offsidebar .progress{border:0}.offsidebar .nav>li>a:focus,.offsidebar .nav>li>a:hover{background-color:rgba(0,0,0,.025)}.offsidebar .tab-content{padding:0;border:0}.offsidebar .nav-tabs.nav-justified>li>a,.offsidebar .nav-tabs.nav-justified>li>a:focus,.offsidebar .nav-tabs.nav-justified>li>a:hover{background-color:transparent;border:0;border-right:1px solid rgba(0,0,0,.05);border-bottom:1px solid rgba(0,0,0,.05);border-radius:0;color:#909fa7}.offsidebar .nav-tabs.nav-justified>li.active>a{color:#649cb4}.offsidebar-open{-webkit-overflow-scrolling:touch}.offsidebar-open .offsidebar{overflow-y:auto}@media only screen and (min-width:768px){.offsidebar{margin-top:55px}.offsidebar-open{overflow-y:auto}}.no-csstransforms3d .offsidebar{right:-235px}.no-csstransforms3d .offsidebar-open .offsidebar{right:0}.csstransforms3d .offsidebar{transform:translate3d(235px,0,0)}.csstransforms3d .offsidebar-open .offsidebar{transform:translate3d(0,0,0)}.breadcrumb{font-weight:400;border-radius:0;color:#909fa7;padding:10px 20px}.content-heading+.breadcrumb{margin:-25px -25px 20px -20px;background-color:#fafbfc;border-top:1px solid #cfdbe2;border-bottom:1px solid #cfdbe2}.content-heading>.breadcrumb{background:0 0;font-size:13px;border:0;padding:10px 10px 0 0;margin-bottom:0}.content-heading>.breadcrumb.pull-right{margin:-2px 0 0}#loading-bar{position:absolute;z-index:90002;top:0;left:0;right:0;height:3px}#loading-bar,#loading-bar-spinner{pointer-events:none;-webkit-pointer-events:none;transition:350ms linear}#loading-bar-spinner.ng-enter,#loading-bar-spinner.ng-leave.ng-leave-active,#loading-bar.ng-enter,#loading-bar.ng-leave.ng-leave-active{opacity:0}#loading-bar-spinner.ng-enter.ng-enter-active,#loading-bar-spinner.ng-leave,#loading-bar.ng-enter.ng-enter-active,#loading-bar.ng-leave{opacity:1}#loading-bar .bar{height:100%;width:100%;transition:width 350ms;background:#053775;border-bottom-right-radius:1px;border-top-right-radius:1px}#loading-bar .peg{position:absolute;width:70px;right:0;top:0;height:2px;opacity:.45;-ms-box-shadow:#053775 1px 0 6px 1px;box-shadow:#053775 1px 0 6px 1px;border-radius:100%}#loading-bar-spinner{display:block;position:fixed;z-index:90002;top:10px;left:10px}#loading-bar-spinner .spinner-icon{width:14px;height:14px;border:2px solid transparent;border-top-color:#053775;border-left-color:#053775;border-radius:10px;-webkit-animation:.4s linear infinite loading-bar-spinner;animation:.4s linear infinite loading-bar-spinner}@-webkit-keyframes loading-bar-spinner{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes loading-bar-spinner{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}app-layout router-outlet+*{display:block;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:backwards;animation-fill-mode:backwards}.animated{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.animated.infinite{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.animated.hinge{-webkit-animation-duration:2s;animation-duration:2s}@-webkit-keyframes bounce{0%,100%,20%,53%,80%{transition-timing-function:cubic-bezier(.215,.61,.355,1);transform:translate3d(0,0,0)}40%,43%{transition-timing-function:cubic-bezier(.755,.05,.855,.06);transform:translate3d(0,-30px,0)}70%{transition-timing-function:cubic-bezier(.755,.05,.855,.06);transform:translate3d(0,-15px,0)}90%{transform:translate3d(0,-4px,0)}}@keyframes bounce{0%,100%,20%,53%,80%{transition-timing-function:cubic-bezier(.215,.61,.355,1);transform:translate3d(0,0,0)}40%,43%{transition-timing-function:cubic-bezier(.755,.05,.855,.06);transform:translate3d(0,-30px,0)}70%{transition-timing-function:cubic-bezier(.755,.05,.855,.06);transform:translate3d(0,-15px,0)}90%{transform:translate3d(0,-4px,0)}}.bounce{-webkit-animation-name:bounce;animation-name:bounce;transform-origin:center bottom}@-webkit-keyframes flash{0%,100%,50%{opacity:1}25%,75%{opacity:0}}@keyframes flash{0%,100%,50%{opacity:1}25%,75%{opacity:0}}.flash{-webkit-animation-name:flash;animation-name:flash}@-webkit-keyframes pulse{0%,100%{transform:scale3d(1,1,1)}50%{transform:scale3d(1.05,1.05,1.05)}}@keyframes pulse{0%,100%{transform:scale3d(1,1,1)}50%{transform:scale3d(1.05,1.05,1.05)}}.pulse{-webkit-animation-name:pulse;animation-name:pulse}@-webkit-keyframes rubberBand{0%,100%{transform:scale3d(1,1,1)}30%{transform:scale3d(1.25,.75,1)}40%{transform:scale3d(.75,1.25,1)}50%{transform:scale3d(1.15,.85,1)}65%{transform:scale3d(.95,1.05,1)}75%{transform:scale3d(1.05,.95,1)}}@keyframes rubberBand{0%,100%{transform:scale3d(1,1,1)}30%{transform:scale3d(1.25,.75,1)}40%{transform:scale3d(.75,1.25,1)}50%{transform:scale3d(1.15,.85,1)}65%{transform:scale3d(.95,1.05,1)}75%{transform:scale3d(1.05,.95,1)}}.rubberBand{-webkit-animation-name:rubberBand;animation-name:rubberBand}@-webkit-keyframes shake{0%,100%{transform:translate3d(0,0,0)}10%,30%,50%,70%,90%{transform:translate3d(-10px,0,0)}20%,40%,60%,80%{transform:translate3d(10px,0,0)}}@keyframes shake{0%,100%{transform:translate3d(0,0,0)}10%,30%,50%,70%,90%{transform:translate3d(-10px,0,0)}20%,40%,60%,80%{transform:translate3d(10px,0,0)}}.shake{-webkit-animation-name:shake;animation-name:shake}@-webkit-keyframes swing{20%{transform:rotate3d(0,0,1,15deg)}40%{transform:rotate3d(0,0,1,-10deg)}60%{transform:rotate3d(0,0,1,5deg)}80%{transform:rotate3d(0,0,1,-5deg)}100%{transform:rotate3d(0,0,1,0deg)}}@keyframes swing{20%{transform:rotate3d(0,0,1,15deg)}40%{transform:rotate3d(0,0,1,-10deg)}60%{transform:rotate3d(0,0,1,5deg)}80%{transform:rotate3d(0,0,1,-5deg)}100%{transform:rotate3d(0,0,1,0deg)}}.swing{transform-origin:top center;-webkit-animation-name:swing;animation-name:swing}@-webkit-keyframes tada{0%,100%{transform:scale3d(1,1,1)}10%,20%{transform:scale3d(.9,.9,.9) rotate3d(0,0,1,-3deg)}30%,50%,70%,90%{transform:scale3d(1.1,1.1,1.1) rotate3d(0,0,1,3deg)}40%,60%,80%{transform:scale3d(1.1,1.1,1.1) rotate3d(0,0,1,-3deg)}}@keyframes tada{0%,100%{transform:scale3d(1,1,1)}10%,20%{transform:scale3d(.9,.9,.9) rotate3d(0,0,1,-3deg)}30%,50%,70%,90%{transform:scale3d(1.1,1.1,1.1) rotate3d(0,0,1,3deg)}40%,60%,80%{transform:scale3d(1.1,1.1,1.1) rotate3d(0,0,1,-3deg)}}.tada{-webkit-animation-name:tada;animation-name:tada}@-webkit-keyframes wobble{0%,100%{transform:none}15%{transform:translate3d(-25%,0,0) rotate3d(0,0,1,-5deg)}30%{transform:translate3d(20%,0,0) rotate3d(0,0,1,3deg)}45%{transform:translate3d(-15%,0,0) rotate3d(0,0,1,-3deg)}60%{transform:translate3d(10%,0,0) rotate3d(0,0,1,2deg)}75%{transform:translate3d(-5%,0,0) rotate3d(0,0,1,-1deg)}}@keyframes wobble{0%,100%{transform:none}15%{transform:translate3d(-25%,0,0) rotate3d(0,0,1,-5deg)}30%{transform:translate3d(20%,0,0) rotate3d(0,0,1,3deg)}45%{transform:translate3d(-15%,0,0) rotate3d(0,0,1,-3deg)}60%{transform:translate3d(10%,0,0) rotate3d(0,0,1,2deg)}75%{transform:translate3d(-5%,0,0) rotate3d(0,0,1,-1deg)}}.wobble{-webkit-animation-name:wobble;animation-name:wobble}@-webkit-keyframes bounceIn{0%,100%,20%,40%,60%,80%{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:scale3d(.3,.3,.3)}20%{transform:scale3d(1.1,1.1,1.1)}40%{transform:scale3d(.9,.9,.9)}60%{opacity:1;transform:scale3d(1.03,1.03,1.03)}80%{transform:scale3d(.97,.97,.97)}100%{opacity:1;transform:scale3d(1,1,1)}}@keyframes bounceIn{0%,100%,20%,40%,60%,80%{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:scale3d(.3,.3,.3)}20%{transform:scale3d(1.1,1.1,1.1)}40%{transform:scale3d(.9,.9,.9)}60%{opacity:1;transform:scale3d(1.03,1.03,1.03)}80%{transform:scale3d(.97,.97,.97)}100%{opacity:1;transform:scale3d(1,1,1)}}.bounceIn{-webkit-animation-name:bounceIn;animation-name:bounceIn;-webkit-animation-duration:.75s;animation-duration:.75s}@-webkit-keyframes bounceInDown{0%,100%,60%,75%,90%{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}100%{transform:none}}@keyframes bounceInDown{0%,100%,60%,75%,90%{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}100%{transform:none}}.bounceInDown{-webkit-animation-name:bounceInDown;animation-name:bounceInDown}@-webkit-keyframes bounceInLeft{0%,100%,60%,75%,90%{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}100%{transform:none}}@keyframes bounceInLeft{0%,100%,60%,75%,90%{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}100%{transform:none}}.bounceInLeft{-webkit-animation-name:bounceInLeft;animation-name:bounceInLeft}@-webkit-keyframes bounceInRight{0%,100%,60%,75%,90%{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}100%{transform:none}}@keyframes bounceInRight{0%,100%,60%,75%,90%{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}100%{transform:none}}.bounceInRight{-webkit-animation-name:bounceInRight;animation-name:bounceInRight}@-webkit-keyframes bounceInUp{0%,100%,60%,75%,90%{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}100%{transform:translate3d(0,0,0)}}@keyframes bounceInUp{0%,100%,60%,75%,90%{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}100%{transform:translate3d(0,0,0)}}.bounceInUp{-webkit-animation-name:bounceInUp;animation-name:bounceInUp}@-webkit-keyframes bounceOut{20%{transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;transform:scale3d(1.1,1.1,1.1)}100%{opacity:0;transform:scale3d(.3,.3,.3)}}@keyframes bounceOut{20%{transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;transform:scale3d(1.1,1.1,1.1)}100%{opacity:0;transform:scale3d(.3,.3,.3)}}.bounceOut{-webkit-animation-name:bounceOut;animation-name:bounceOut;-webkit-animation-duration:.75s;animation-duration:.75s}@-webkit-keyframes bounceOutDown{20%{transform:translate3d(0,10px,0)}40%,45%{opacity:1;transform:translate3d(0,-20px,0)}100%{opacity:0;transform:translate3d(0,2000px,0)}}@keyframes bounceOutDown{20%{transform:translate3d(0,10px,0)}40%,45%{opacity:1;transform:translate3d(0,-20px,0)}100%{opacity:0;transform:translate3d(0,2000px,0)}}.bounceOutDown{-webkit-animation-name:bounceOutDown;animation-name:bounceOutDown}@-webkit-keyframes bounceOutLeft{20%{opacity:1;transform:translate3d(20px,0,0)}100%{opacity:0;transform:translate3d(-2000px,0,0)}}@keyframes bounceOutLeft{20%{opacity:1;transform:translate3d(20px,0,0)}100%{opacity:0;transform:translate3d(-2000px,0,0)}}.bounceOutLeft{-webkit-animation-name:bounceOutLeft;animation-name:bounceOutLeft}@-webkit-keyframes bounceOutRight{20%{opacity:1;transform:translate3d(-20px,0,0)}100%{opacity:0;transform:translate3d(2000px,0,0)}}@keyframes bounceOutRight{20%{opacity:1;transform:translate3d(-20px,0,0)}100%{opacity:0;transform:translate3d(2000px,0,0)}}.bounceOutRight{-webkit-animation-name:bounceOutRight;animation-name:bounceOutRight}@-webkit-keyframes bounceOutUp{20%{transform:translate3d(0,-10px,0)}40%,45%{opacity:1;transform:translate3d(0,20px,0)}100%{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes bounceOutUp{20%{transform:translate3d(0,-10px,0)}40%,45%{opacity:1;transform:translate3d(0,20px,0)}100%{opacity:0;transform:translate3d(0,-2000px,0)}}.bounceOutUp{-webkit-animation-name:bounceOutUp;animation-name:bounceOutUp}@-webkit-keyframes fadeIn{0%{opacity:0}100%{opacity:1}}@keyframes fadeIn{0%{opacity:0}100%{opacity:1}}.fadeIn,app-layout router-outlet+*{-webkit-animation-name:fadeIn;animation-name:fadeIn}@-webkit-keyframes fadeInDown{0%{opacity:0;transform:translate3d(0,-18px,0)}100%{opacity:1;transform:none}}@keyframes fadeInDown{0%{opacity:0;transform:translate3d(0,-18px,0)}100%{opacity:1;transform:none}}.fadeInDown{-webkit-animation-name:fadeInDown;animation-name:fadeInDown}@-webkit-keyframes fadeInDownBig{0%{opacity:0;transform:translate3d(0,-2000px,0)}100%{opacity:1;transform:none}}@keyframes fadeInDownBig{0%{opacity:0;transform:translate3d(0,-2000px,0)}100%{opacity:1;transform:none}}.fadeInDownBig{-webkit-animation-name:fadeInDownBig;animation-name:fadeInDownBig}@-webkit-keyframes fadeInLeft{0%{opacity:0;transform:translate3d(-18px,0,0)}100%{opacity:1;transform:none}}@keyframes fadeInLeft{0%{opacity:0;transform:translate3d(-18px,0,0)}100%{opacity:1;transform:none}}.fadeInLeft{-webkit-animation-name:fadeInLeft;animation-name:fadeInLeft}@-webkit-keyframes fadeInLeftBig{0%{opacity:0;transform:translate3d(-2000px,0,0)}100%{opacity:1;transform:none}}@keyframes fadeInLeftBig{0%{opacity:0;transform:translate3d(-2000px,0,0)}100%{opacity:1;transform:none}}.fadeInLeftBig{-webkit-animation-name:fadeInLeftBig;animation-name:fadeInLeftBig}@-webkit-keyframes fadeInRight{0%{opacity:0;transform:translate3d(18px,0,0)}100%{opacity:1;transform:none}}@keyframes fadeInRight{0%{opacity:0;transform:translate3d(18px,0,0)}100%{opacity:1;transform:none}}.fadeInRight{-webkit-animation-name:fadeInRight;animation-name:fadeInRight}@-webkit-keyframes fadeInRightBig{0%{opacity:0;transform:translate3d(2000px,0,0)}100%{opacity:1;transform:none}}@keyframes fadeInRightBig{0%{opacity:0;transform:translate3d(2000px,0,0)}100%{opacity:1;transform:none}}.fadeInRightBig{-webkit-animation-name:fadeInRightBig;animation-name:fadeInRightBig}@-webkit-keyframes fadeInUp{0%{opacity:0;transform:translate3d(0,18px,0)}100%{opacity:1;transform:none}}@keyframes fadeInUp{0%{opacity:0;transform:translate3d(0,18px,0)}100%{opacity:1;transform:none}}.fadeInUp{-webkit-animation-name:fadeInUp;animation-name:fadeInUp}@-webkit-keyframes fadeInUpBig{0%{opacity:0;transform:translate3d(0,2000px,0)}100%{opacity:1;transform:none}}@keyframes fadeInUpBig{0%{opacity:0;transform:translate3d(0,2000px,0)}100%{opacity:1;transform:none}}.fadeInUpBig{-webkit-animation-name:fadeInUpBig;animation-name:fadeInUpBig}@-webkit-keyframes fadeOut{0%{opacity:1}100%{opacity:0}}@keyframes fadeOut{0%{opacity:1}100%{opacity:0}}.fadeOut{-webkit-animation-name:fadeOut;animation-name:fadeOut}@-webkit-keyframes fadeOutDown{0%{opacity:1}100%{opacity:0;transform:translate3d(0,18px,0)}}@keyframes fadeOutDown{0%{opacity:1}100%{opacity:0;transform:translate3d(0,18px,0)}}.fadeOutDown{-webkit-animation-name:fadeOutDown;animation-name:fadeOutDown}@-webkit-keyframes fadeOutDownBig{0%{opacity:1}100%{opacity:0;transform:translate3d(0,2000px,0)}}@keyframes fadeOutDownBig{0%{opacity:1}100%{opacity:0;transform:translate3d(0,2000px,0)}}.fadeOutDownBig{-webkit-animation-name:fadeOutDownBig;animation-name:fadeOutDownBig}@-webkit-keyframes fadeOutLeft{0%{opacity:1}100%{opacity:0;transform:translate3d(-18px,0,0)}}@keyframes fadeOutLeft{0%{opacity:1}100%{opacity:0;transform:translate3d(-18px,0,0)}}.fadeOutLeft{-webkit-animation-name:fadeOutLeft;animation-name:fadeOutLeft}@-webkit-keyframes fadeOutLeftBig{0%{opacity:1}100%{opacity:0;transform:translate3d(-2000px,0,0)}}@keyframes fadeOutLeftBig{0%{opacity:1}100%{opacity:0;transform:translate3d(-2000px,0,0)}}.fadeOutLeftBig{-webkit-animation-name:fadeOutLeftBig;animation-name:fadeOutLeftBig}@-webkit-keyframes fadeOutRight{0%{opacity:1}100%{opacity:0;transform:translate3d(18px,0,0)}}@keyframes fadeOutRight{0%{opacity:1}100%{opacity:0;transform:translate3d(18px,0,0)}}.fadeOutRight{-webkit-animation-name:fadeOutRight;animation-name:fadeOutRight}@-webkit-keyframes fadeOutRightBig{0%{opacity:1}100%{opacity:0;transform:translate3d(2000px,0,0)}}@keyframes fadeOutRightBig{0%{opacity:1}100%{opacity:0;transform:translate3d(2000px,0,0)}}.fadeOutRightBig{-webkit-animation-name:fadeOutRightBig;animation-name:fadeOutRightBig}@-webkit-keyframes fadeOutUp{0%{opacity:1}100%{opacity:0;transform:translate3d(0,-18px,0)}}@keyframes fadeOutUp{0%{opacity:1}100%{opacity:0;transform:translate3d(0,-18px,0)}}.fadeOutUp{-webkit-animation-name:fadeOutUp;animation-name:fadeOutUp}@-webkit-keyframes fadeOutUpBig{0%{opacity:1}100%{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes fadeOutUpBig{0%{opacity:1}100%{opacity:0;transform:translate3d(0,-2000px,0)}}.fadeOutUpBig{-webkit-animation-name:fadeOutUpBig;animation-name:fadeOutUpBig}@-webkit-keyframes flip{0%{transform:perspective(400px) rotate3d(0,1,0,-360deg);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}40%{transform:perspective(400px) translate3d(0,0,150px) rotate3d(0,1,0,-190deg);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}50%{transform:perspective(400px) translate3d(0,0,150px) rotate3d(0,1,0,-170deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}80%{transform:perspective(400px) scale3d(.95,.95,.95);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}100%{transform:perspective(400px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}}@keyframes flip{0%{transform:perspective(400px) rotate3d(0,1,0,-360deg);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}40%{transform:perspective(400px) translate3d(0,0,150px) rotate3d(0,1,0,-190deg);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}50%{transform:perspective(400px) translate3d(0,0,150px) rotate3d(0,1,0,-170deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}80%{transform:perspective(400px) scale3d(.95,.95,.95);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}100%{transform:perspective(400px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}}.animated.flip{-webkit-backface-visibility:visible;backface-visibility:visible;-webkit-animation-name:flip;animation-name:flip}@-webkit-keyframes flipInX{0%{transform:perspective(400px) rotate3d(1,0,0,90deg);transition-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotate3d(1,0,0,-20deg);transition-timing-function:ease-in}60%{transform:perspective(400px) rotate3d(1,0,0,10deg);opacity:1}80%{transform:perspective(400px) rotate3d(1,0,0,-5deg)}100%{transform:perspective(400px)}}@keyframes flipInX{0%{transform:perspective(400px) rotate3d(1,0,0,90deg);transition-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotate3d(1,0,0,-20deg);transition-timing-function:ease-in}60%{transform:perspective(400px) rotate3d(1,0,0,10deg);opacity:1}80%{transform:perspective(400px) rotate3d(1,0,0,-5deg)}100%{transform:perspective(400px)}}.flipInX{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:flipInX;animation-name:flipInX}@-webkit-keyframes flipInY{0%{transform:perspective(400px) rotate3d(0,1,0,90deg);transition-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotate3d(0,1,0,-20deg);transition-timing-function:ease-in}60%{transform:perspective(400px) rotate3d(0,1,0,10deg);opacity:1}80%{transform:perspective(400px) rotate3d(0,1,0,-5deg)}100%{transform:perspective(400px)}}@keyframes flipInY{0%{transform:perspective(400px) rotate3d(0,1,0,90deg);transition-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotate3d(0,1,0,-20deg);transition-timing-function:ease-in}60%{transform:perspective(400px) rotate3d(0,1,0,10deg);opacity:1}80%{transform:perspective(400px) rotate3d(0,1,0,-5deg)}100%{transform:perspective(400px)}}.flipInY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:flipInY;animation-name:flipInY}@-webkit-keyframes flipOutX{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotate3d(1,0,0,-20deg);opacity:1}100%{transform:perspective(400px) rotate3d(1,0,0,90deg);opacity:0}}@keyframes flipOutX{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotate3d(1,0,0,-20deg);opacity:1}100%{transform:perspective(400px) rotate3d(1,0,0,90deg);opacity:0}}.flipOutX{-webkit-animation-name:flipOutX;animation-name:flipOutX;-webkit-animation-duration:.75s;animation-duration:.75s;-webkit-backface-visibility:visible!important;backface-visibility:visible!important}@-webkit-keyframes flipOutY{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotate3d(0,1,0,-15deg);opacity:1}100%{transform:perspective(400px) rotate3d(0,1,0,90deg);opacity:0}}@keyframes flipOutY{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotate3d(0,1,0,-15deg);opacity:1}100%{transform:perspective(400px) rotate3d(0,1,0,90deg);opacity:0}}.flipOutY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:flipOutY;animation-name:flipOutY;-webkit-animation-duration:.75s;animation-duration:.75s}@-webkit-keyframes lightSpeedIn{0%{transform:translate3d(18px,0,0) skewX(-30deg);opacity:0}60%{transform:skewX(20deg);opacity:1}80%{transform:skewX(-5deg);opacity:1}100%{transform:none;opacity:1}}@keyframes lightSpeedIn{0%{transform:translate3d(18px,0,0) skewX(-30deg);opacity:0}60%{transform:skewX(20deg);opacity:1}80%{transform:skewX(-5deg);opacity:1}100%{transform:none;opacity:1}}.lightSpeedIn{-webkit-animation-name:lightSpeedIn;animation-name:lightSpeedIn;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}@-webkit-keyframes lightSpeedOut{0%{opacity:1}100%{transform:translate3d(18px,0,0) skewX(30deg);opacity:0}}@keyframes lightSpeedOut{0%{opacity:1}100%{transform:translate3d(18px,0,0) skewX(30deg);opacity:0}}.lightSpeedOut{-webkit-animation-name:lightSpeedOut;animation-name:lightSpeedOut;-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}@-webkit-keyframes rotateIn{0%{transform-origin:center;transform:rotate3d(0,0,1,-200deg);opacity:0}100%{transform-origin:center;transform:none;opacity:1}}@keyframes rotateIn{0%{transform-origin:center;transform:rotate3d(0,0,1,-200deg);opacity:0}100%{transform-origin:center;transform:none;opacity:1}}.rotateIn{-webkit-animation-name:rotateIn;animation-name:rotateIn}@-webkit-keyframes rotateInDownLeft{0%{transform-origin:left bottom;transform:rotate3d(0,0,1,-45deg);opacity:0}100%{transform-origin:left bottom;transform:none;opacity:1}}@keyframes rotateInDownLeft{0%{transform-origin:left bottom;transform:rotate3d(0,0,1,-45deg);opacity:0}100%{transform-origin:left bottom;transform:none;opacity:1}}.rotateInDownLeft{-webkit-animation-name:rotateInDownLeft;animation-name:rotateInDownLeft}@-webkit-keyframes rotateInDownRight{0%{transform-origin:right bottom;transform:rotate3d(0,0,1,45deg);opacity:0}100%{transform-origin:right bottom;transform:none;opacity:1}}@keyframes rotateInDownRight{0%{transform-origin:right bottom;transform:rotate3d(0,0,1,45deg);opacity:0}100%{transform-origin:right bottom;transform:none;opacity:1}}.rotateInDownRight{-webkit-animation-name:rotateInDownRight;animation-name:rotateInDownRight}@-webkit-keyframes rotateInUpLeft{0%{transform-origin:left bottom;transform:rotate3d(0,0,1,45deg);opacity:0}100%{transform-origin:left bottom;transform:none;opacity:1}}@keyframes rotateInUpLeft{0%{transform-origin:left bottom;transform:rotate3d(0,0,1,45deg);opacity:0}100%{transform-origin:left bottom;transform:none;opacity:1}}.rotateInUpLeft{-webkit-animation-name:rotateInUpLeft;animation-name:rotateInUpLeft}@-webkit-keyframes rotateInUpRight{0%{transform-origin:right bottom;transform:rotate3d(0,0,1,-90deg);opacity:0}100%{transform-origin:right bottom;transform:none;opacity:1}}@keyframes rotateInUpRight{0%{transform-origin:right bottom;transform:rotate3d(0,0,1,-90deg);opacity:0}100%{transform-origin:right bottom;transform:none;opacity:1}}.rotateInUpRight{-webkit-animation-name:rotateInUpRight;animation-name:rotateInUpRight}@-webkit-keyframes rotateOut{0%{transform-origin:center;opacity:1}100%{transform-origin:center;transform:rotate3d(0,0,1,200deg);opacity:0}}@keyframes rotateOut{0%{transform-origin:center;opacity:1}100%{transform-origin:center;transform:rotate3d(0,0,1,200deg);opacity:0}}.rotateOut{-webkit-animation-name:rotateOut;animation-name:rotateOut}@-webkit-keyframes rotateOutDownLeft{0%{transform-origin:left bottom;opacity:1}100%{transform-origin:left bottom;transform:rotate(0,0,1,45deg);opacity:0}}@keyframes rotateOutDownLeft{0%{transform-origin:left bottom;opacity:1}100%{transform-origin:left bottom;transform:rotate(0,0,1,45deg);opacity:0}}.rotateOutDownLeft{-webkit-animation-name:rotateOutDownLeft;animation-name:rotateOutDownLeft}@-webkit-keyframes rotateOutDownRight{0%{transform-origin:right bottom;opacity:1}100%{transform-origin:right bottom;transform:rotate3d(0,0,1,-45deg);opacity:0}}@keyframes rotateOutDownRight{0%{transform-origin:right bottom;opacity:1}100%{transform-origin:right bottom;transform:rotate3d(0,0,1,-45deg);opacity:0}}.rotateOutDownRight{-webkit-animation-name:rotateOutDownRight;animation-name:rotateOutDownRight}@-webkit-keyframes rotateOutUpLeft{0%{transform-origin:left bottom;opacity:1}100%{transform-origin:left bottom;transform:rotate3d(0,0,1,-45deg);opacity:0}}@keyframes rotateOutUpLeft{0%{transform-origin:left bottom;opacity:1}100%{transform-origin:left bottom;transform:rotate3d(0,0,1,-45deg);opacity:0}}.rotateOutUpLeft{-webkit-animation-name:rotateOutUpLeft;animation-name:rotateOutUpLeft}@-webkit-keyframes rotateOutUpRight{0%{transform-origin:right bottom;opacity:1}100%{transform-origin:right bottom;transform:rotate3d(0,0,1,90deg);opacity:0}}@keyframes rotateOutUpRight{0%{transform-origin:right bottom;opacity:1}100%{transform-origin:right bottom;transform:rotate3d(0,0,1,90deg);opacity:0}}.rotateOutUpRight{-webkit-animation-name:rotateOutUpRight;animation-name:rotateOutUpRight}@-webkit-keyframes hinge{0%{transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}20%,60%{transform:rotate3d(0,0,1,80deg);transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}40%,80%{transform:rotate3d(0,0,1,60deg);transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;opacity:1}100%{transform:translate3d(0,700px,0);opacity:0}}@keyframes hinge{0%{transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}20%,60%{transform:rotate3d(0,0,1,80deg);transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}40%,80%{transform:rotate3d(0,0,1,60deg);transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;opacity:1}100%{transform:translate3d(0,700px,0);opacity:0}}.hinge{-webkit-animation-name:hinge;animation-name:hinge}@-webkit-keyframes rollIn{0%{opacity:0;transform:translate3d(-18px,0,0) rotate3d(0,0,1,-120deg)}100%{opacity:1;transform:none}}@keyframes rollIn{0%{opacity:0;transform:translate3d(-18px,0,0) rotate3d(0,0,1,-120deg)}100%{opacity:1;transform:none}}.rollIn{-webkit-animation-name:rollIn;animation-name:rollIn}@-webkit-keyframes rollOut{0%{opacity:1}100%{opacity:0;transform:translate3d(18px,0,0) rotate3d(0,0,1,120deg)}}@keyframes rollOut{0%{opacity:1}100%{opacity:0;transform:translate3d(18px,0,0) rotate3d(0,0,1,120deg)}}.rollOut{-webkit-animation-name:rollOut;animation-name:rollOut}@-webkit-keyframes zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}.zoomIn{-webkit-animation-name:zoomIn;animation-name:zoomIn}@-webkit-keyframes zoomInDown{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInDown{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInDown{-webkit-animation-name:zoomInDown;animation-name:zoomInDown}@-webkit-keyframes zoomInLeft{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInLeft{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInLeft{-webkit-animation-name:zoomInLeft;animation-name:zoomInLeft}@-webkit-keyframes zoomInRight{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInRight{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInRight{-webkit-animation-name:zoomInRight;animation-name:zoomInRight}@-webkit-keyframes zoomInUp{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInUp{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInUp{-webkit-animation-name:zoomInUp;animation-name:zoomInUp}@-webkit-keyframes zoomOut{0%{opacity:1}50%{opacity:0;transform:scale3d(.3,.3,.3)}100%{opacity:0}}@keyframes zoomOut{0%{opacity:1}50%{opacity:0;transform:scale3d(.3,.3,.3)}100%{opacity:0}}.zoomOut{-webkit-animation-name:zoomOut;animation-name:zoomOut}@-webkit-keyframes zoomOutDown{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}100%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomOutDown{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}100%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutDown{-webkit-animation-name:zoomOutDown;animation-name:zoomOutDown}@-webkit-keyframes zoomOutLeft{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}100%{opacity:0;transform:scale(.1) translate3d(-2000px,0,0);transform-origin:left center}}@keyframes zoomOutLeft{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}100%{opacity:0;transform:scale(.1) translate3d(-2000px,0,0);transform-origin:left center}}.zoomOutLeft{-webkit-animation-name:zoomOutLeft;animation-name:zoomOutLeft}@-webkit-keyframes zoomOutRight{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}100%{opacity:0;transform:scale(.1) translate3d(2000px,0,0);transform-origin:right center}}@keyframes zoomOutRight{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}100%{opacity:0;transform:scale(.1) translate3d(2000px,0,0);transform-origin:right center}}.zoomOutRight{-webkit-animation-name:zoomOutRight;animation-name:zoomOutRight}@-webkit-keyframes zoomOutUp{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}100%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomOutUp{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}100%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutUp{-webkit-animation-name:zoomOutUp;animation-name:zoomOutUp}@-webkit-keyframes fadeOutUpShort{0%{opacity:1}100%{opacity:0;transform:translate3d(0,-20px,0)}}@keyframes fadeOutUpShort{0%{opacity:1}100%{opacity:0;transform:translate3d(0,-20px,0)}}.fadeOutUpShort{-webkit-animation-name:fadeOutUpShort;animation-name:fadeOutUpShort}@-webkit-keyframes fadeInUpShort{0%{opacity:0;transform:translate3d(0,20px,0)}100%{opacity:1;transform:none}}@keyframes fadeInUpShort{0%{opacity:0;transform:translate3d(0,20px,0)}100%{opacity:1;transform:none}}.fadeInUpShort{-webkit-animation-name:fadeInUpShort;animation-name:fadeInUpShort}@-webkit-keyframes zoomInShort{0%{opacity:0;transform:scale3d(.95,.95,.95)}50%{opacity:1}}@keyframes zoomInShort{0%{opacity:0;transform:scale3d(.95,.95,.95)}50%{opacity:1}}.zoomInShort{-webkit-animation-name:zoomInShort;animation-name:zoomInShort}@-webkit-keyframes zoomBack{0%{opacity:1}50%{opacity:0;transform:scale3d(.5,.5,.5)}100%{opacity:0}}@keyframes zoomBack{0%{opacity:1}50%{opacity:0;transform:scale3d(.5,.5,.5)}100%{opacity:0}}.zoomBack{-webkit-animation-name:zoomBack;animation-name:zoomBack}.btn-inverse{color:#fff;background-color:#131e26;border-color:#131e26}.btn-inverse.active,.btn-inverse.focus,.btn-inverse:active,.btn-inverse:focus,.btn-inverse:hover,.open>.btn-inverse.dropdown-toggle{color:#fff;background-color:#0c1318;border-color:#05090b}.btn-inverse.active.focus,.btn-inverse.active:focus,.btn-inverse.active:hover,.btn-inverse:active.focus,.btn-inverse:active:focus,.btn-inverse:active:hover,.open>.btn-inverse.dropdown-toggle.focus,.open>.btn-inverse.dropdown-toggle:focus,.open>.btn-inverse.dropdown-toggle:hover{color:#fff;background-color:#0c1318;border-color:#05090b}.btn-inverse.active,.btn-inverse:active,.open>.btn-inverse.dropdown-toggle{background-image:none}.btn-inverse.disabled.focus,.btn-inverse.disabled:focus,.btn-inverse.disabled:hover,.btn-inverse[disabled].focus,.btn-inverse[disabled]:focus,.btn-inverse[disabled]:hover,fieldset[disabled] .btn-inverse.focus,fieldset[disabled] .btn-inverse:focus,fieldset[disabled] .btn-inverse:hover{background-color:#131e26;border-color:#131e26}.btn-inverse .badge{color:#131e26;background-color:#fff}.btn-green{color:#fff;background-color:#37bc9b;border-color:transparent}.btn-green.active,.btn-green.focus,.btn-green:active,.btn-green:focus,.btn-green:hover,.open>.btn-green.dropdown-toggle{color:#fff;background-color:#32ac8e;border-color:transparent}.btn-green.active.focus,.btn-green.active:focus,.btn-green.active:hover,.btn-green:active.focus,.btn-green:active:focus,.btn-green:active:hover,.open>.btn-green.dropdown-toggle.focus,.open>.btn-green.dropdown-toggle:focus,.open>.btn-green.dropdown-toggle:hover{color:#fff;background-color:#32ac8e;border-color:transparent}.btn-green.active,.btn-green:active,.open>.btn-green.dropdown-toggle{background-image:none}.btn-green.disabled.focus,.btn-green.disabled:focus,.btn-green.disabled:hover,.btn-green[disabled].focus,.btn-green[disabled]:focus,.btn-green[disabled]:hover,fieldset[disabled] .btn-green.focus,fieldset[disabled] .btn-green:focus,fieldset[disabled] .btn-green:hover{background-color:#37bc9b;border-color:transparent}.btn-green .badge{color:#37bc9b;background-color:#fff}.btn-purple{color:#fff;background-color:#7266ba;border-color:transparent}.btn-purple.active,.btn-purple.focus,.btn-purple:active,.btn-purple:focus,.btn-purple:hover,.open>.btn-purple.dropdown-toggle{color:#fff;background-color:#6558b4;border-color:transparent}.btn-purple.active.focus,.btn-purple.active:focus,.btn-purple.active:hover,.btn-purple:active.focus,.btn-purple:active:focus,.btn-purple:active:hover,.open>.btn-purple.dropdown-toggle.focus,.open>.btn-purple.dropdown-toggle:focus,.open>.btn-purple.dropdown-toggle:hover{color:#fff;background-color:#6558b4;border-color:transparent}.btn-purple.active,.btn-purple:active,.open>.btn-purple.dropdown-toggle{background-image:none}.btn-purple.disabled.focus,.btn-purple.disabled:focus,.btn-purple.disabled:hover,.btn-purple[disabled].focus,.btn-purple[disabled]:focus,.btn-purple[disabled]:hover,fieldset[disabled] .btn-purple.focus,fieldset[disabled] .btn-purple:focus,fieldset[disabled] .btn-purple:hover{background-color:#7266ba;border-color:transparent}.btn-purple .badge{color:#7266ba;background-color:#fff}.btn-pink{color:#fff;background-color:#f532e5;border-color:transparent}.btn-pink.active,.btn-pink.focus,.btn-pink:active,.btn-pink:focus,.btn-pink:hover,.open>.btn-pink.dropdown-toggle{color:#fff;background-color:#f41fe3;border-color:transparent}.btn-pink.active.focus,.btn-pink.active:focus,.btn-pink.active:hover,.btn-pink:active.focus,.btn-pink:active:focus,.btn-pink:active:hover,.open>.btn-pink.dropdown-toggle.focus,.open>.btn-pink.dropdown-toggle:focus,.open>.btn-pink.dropdown-toggle:hover{color:#fff;background-color:#f41fe3;border-color:transparent}.btn-pink.active,.btn-pink:active,.open>.btn-pink.dropdown-toggle{background-image:none}.btn-pink.disabled.focus,.btn-pink.disabled:focus,.btn-pink.disabled:hover,.btn-pink[disabled].focus,.btn-pink[disabled]:focus,.btn-pink[disabled]:hover,fieldset[disabled] .btn-pink.focus,fieldset[disabled] .btn-pink:focus,fieldset[disabled] .btn-pink:hover{background-color:#f532e5;border-color:transparent}.btn-pink .badge{color:#f532e5;background-color:#fff}.btn-flat{border-bottom-width:1px;border-radius:0;box-shadow:0 0 0 #000}.btn-xl{padding:20px 16px;font-size:18px}.btn-square{border-radius:0}.btn-oval,.btn-pill-left{border-top-left-radius:50px;border-bottom-left-radius:50px;padding-left:18px}.btn-oval,.btn-pill-right{border-top-right-radius:50px;border-bottom-right-radius:50px;padding-right:18px}.btn-labeled{padding-top:0;padding-bottom:0}.btn-label{position:relative;background:rgba(0,0,0,.05);display:inline-block;padding:6px 16px;left:-16px;border-radius:3px 0 0 3px}.btn-label.btn-label-right{left:auto;right:-16px;border-radius:0 3px 3px 0}.btn-group-lg>.btn .btn-label,.btn-lg .btn-label{padding:10px 20px;left:-20px;border-radius:5px 0 0 5px}.btn-group-lg>.btn .btn-label.btn-label-right,.btn-lg .btn-label.btn-label-right{left:auto;right:-20px;border-radius:0 5px 5px 0}.btn-group-sm>.btn .btn-label,.btn-sm .btn-label,.calendar-app .fc-button .btn-label{padding:5px 10px;left:-10px;border-radius:2px 0 0 2px}.btn-group-sm>.btn .btn-label.btn-label-right,.btn-sm .btn-label.btn-label-right,.calendar-app .fc-button .btn-label.btn-label-right{left:auto;right:-10px;border-radius:0 2px 2px 0}.btn-group-xs>.btn .btn-label,.btn-xs .btn-label{padding:1px 5px;left:-5px;border-radius:2px 0 0 2px}.btn-group-xs>.btn .btn-label.btn-label-right,.btn-xs .btn-label.btn-label-right{left:auto;right:-5px;border-radius:0 2px 2px 0}.btn-fw{min-width:80px}.btn-fw.btn-sm,.btn-group-sm>.btn-fw.btn,.calendar-app .btn-fw.fc-button{min-width:40px}.btn-fw.btn-md{min-width:60px}.btn-fw.btn-lg,.btn-group-lg>.btn-fw.btn{min-width:140px}.btn-circle{width:35px;height:35px;text-align:center;font-size:12px;line-height:35px;border-radius:500px;padding:0;border:0}.btn-circle>*{line-height:inherit!important}.btn-circle.btn-lg,.btn-group-lg>.btn-circle.btn{width:50px;height:50px;font-size:18px;line-height:50px}.btn-outline{background-color:transparent}.btn-outline.btn-default{border-color:#eaeaea;color:#333!important}.btn-outline.btn-primary{border-color:#649cb4;color:#649cb4}.btn-outline.btn-success{border-color:#27c24c;color:#27c24c}.btn-outline.btn-info{border-color:#053775;color:#053775}.btn-outline.btn-warning{border-color:#ff902b;color:#ff902b}.btn-outline.btn-danger{border-color:#f05050;color:#f05050}.btn-outline.btn-inverse{border-color:#131e26;color:#131e26}.btn-outline.btn-green{border-color:#37bc9b;color:#37bc9b}.btn-outline.btn-purple{border-color:#7266ba;color:#7266ba}.btn-outline.btn-pink{border-color:#f532e5;color:#f532e5}.btn-outline.active,.btn-outline.focus,.btn-outline.hover,.btn-outline:active,.btn-outline:focus,.btn-outline:hover{color:#fff}.btn-info>.text-info{color:#fff!important}.box-placeholder{margin-bottom:15px;padding:20px;border:1px dashed #ddd;background:#fafafa;color:#444}.box-placeholder>:last-child{margin-bottom:0}.box-placeholder-lg{padding-top:80px;padding-bottom:80px}.panel .table{margin-bottom:0;border:0}.panel.panel-transparent{border:0;background-color:transparent;box-shadow:0 0 0 #000}.panel.panel-transparent .panel-body,.panel.panel-transparent .panel-heading{background-color:transparent;padding-left:0;padding-right:0}.panel-flat{margin:0!important;border:0}.panel-group .panel-flat{box-shadow:0 0 0 #000}.panel-group .panel-flat:first-child{border-radius:4px 4px 0 0}.panel-group .panel-flat:last-child{border-radius:0 0 4px 4px}.panel-heading paneltool>a{display:inline-block;color:#fff;width:2em;text-align:center}.panel-default .panel-heading paneltool>a{color:#c1c2c3}.panel-heading>.label.pull-right{margin-top:3px}.panel-heading>.label.pull-right+.label.pull-right{margin-right:10px}.panel-heading.panel-heading-collapsed{border-radius:3px}.panel-footer .pagination{margin:0}.panel-footer .radial-bar,.panel-footer p{margin-bottom:0}.panel-heading-active{background-color:#27c24c!important;font-weight:700;font-size:16px}.panel-heading-active>a{padding:15px 0;color:#fff!important;transition:padding .5s}.panel-heading-active+.panel-collapse:after{content:\"\";display:block;width:60%;margin:0 auto;height:0;border-bottom:1px solid #e1e2e3}.panel-inverse{border-color:#cfdbe2}.panel-inverse>.panel-heading{color:#fff;background-color:#131e26;border-color:#131e26}.panel-inverse>.panel-heading+.panel-collapse>.panel-body{border-top-color:#cfdbe2}.panel-inverse>.panel-heading .badge{color:#131e26;background-color:#fff}.panel-inverse>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#cfdbe2}.panel-green{border-color:#cfdbe2}.panel-green>.panel-heading{color:#fff;background-color:#37bc9b;border-color:#37bc9b}.panel-green>.panel-heading+.panel-collapse>.panel-body{border-top-color:#cfdbe2}.panel-green>.panel-heading .badge{color:#37bc9b;background-color:#fff}.panel-green>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#cfdbe2}.panel-pink{border-color:#cfdbe2}.panel-pink>.panel-heading{color:#fff;background-color:#f532e5;border-color:#f532e5}.panel-pink>.panel-heading+.panel-collapse>.panel-body{border-top-color:#cfdbe2}.panel-pink>.panel-heading .badge{color:#f532e5;background-color:#fff}.panel-pink>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#cfdbe2}.panel-purple{border-color:#cfdbe2}.panel-purple>.panel-heading{color:#fff;background-color:#7266ba;border-color:#7266ba}.panel-purple>.panel-heading+.panel-collapse>.panel-body{border-top-color:#cfdbe2}.panel-purple>.panel-heading .badge{color:#7266ba;background-color:#fff}.panel-purple>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#cfdbe2}.panel-dark{border-color:#cfdbe2}.panel-dark>.panel-heading{color:#fff;background-color:#3a3f51;border-color:#3a3f51}.panel-dark>.panel-heading+.panel-collapse>.panel-body{border-top-color:#cfdbe2}.panel-dark>.panel-heading .badge{color:#3a3f51;background-color:#fff}.panel-dark>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#cfdbe2}.progress-sm .progress,.progress-sm.progress{height:15px}.progress-xs .progress,.progress-xs.progress{height:8px}.m0 .progress{margin:0}.progress-bar-purple{background-color:#7266ba}.progress-striped .progress-bar-purple{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)}.progress-bar-inverse{background-color:#131e26}.progress-striped .progress-bar-inverse{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)}.progress-bar-green{background-color:#37bc9b}.progress-striped .progress-bar-green{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)}.progress-bar-pink{background-color:#f532e5}.progress-striped .progress-bar-pink{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)}.progress-bar-yellow{background-color:#fad732}.progress-striped .progress-bar-yellow{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)}.progress-1{width:1%}.progress-2{width:2%}.progress-3{width:3%}.progress-4{width:4%}.progress-5{width:5%}.progress-6{width:6%}.progress-7{width:7%}.progress-8{width:8%}.progress-9{width:9%}.progress-10{width:10%}.progress-11{width:11%}.progress-12{width:12%}.progress-13{width:13%}.progress-14{width:14%}.progress-15{width:15%}.progress-16{width:16%}.progress-17{width:17%}.progress-18{width:18%}.progress-19{width:19%}.progress-20{width:20%}.progress-21{width:21%}.progress-22{width:22%}.progress-23{width:23%}.progress-24{width:24%}.progress-25{width:25%}.progress-26{width:26%}.progress-27{width:27%}.progress-28{width:28%}.progress-29{width:29%}.progress-30{width:30%}.progress-31{width:31%}.progress-32{width:32%}.progress-33{width:33%}.progress-34{width:34%}.progress-35{width:35%}.progress-36{width:36%}.progress-37{width:37%}.progress-38{width:38%}.progress-39{width:39%}.progress-40{width:40%}.progress-41{width:41%}.progress-42{width:42%}.progress-43{width:43%}.progress-44{width:44%}.progress-45{width:45%}.progress-46{width:46%}.progress-47{width:47%}.progress-48{width:48%}.progress-49{width:49%}.progress-50{width:50%}.progress-51{width:51%}.progress-52{width:52%}.progress-53{width:53%}.progress-54{width:54%}.progress-55{width:55%}.progress-56{width:56%}.progress-57{width:57%}.progress-58{width:58%}.progress-59{width:59%}.progress-60{width:60%}.progress-61{width:61%}.progress-62{width:62%}.progress-63{width:63%}.progress-64{width:64%}.progress-65{width:65%}.progress-66{width:66%}.progress-67{width:67%}.progress-68{width:68%}.progress-69{width:69%}.progress-70{width:70%}.progress-71{width:71%}.progress-72{width:72%}.progress-73{width:73%}.progress-74{width:74%}.progress-75{width:75%}.progress-76{width:76%}.progress-77{width:77%}.progress-78{width:78%}.progress-79{width:79%}.progress-80{width:80%}.progress-81{width:81%}.progress-82{width:82%}.progress-83{width:83%}.progress-84{width:84%}.progress-85{width:85%}.progress-86{width:86%}.progress-87{width:87%}.progress-88{width:88%}.progress-89{width:89%}.progress-90{width:90%}.progress-91{width:91%}.progress-92{width:92%}.progress-93{width:93%}.progress-94{width:94%}.progress-95{width:95%}.progress-96{width:96%}.progress-97{width:97%}.progress-98{width:98%}.progress-99{width:99%}.progress-100{width:100%}.radial-bar{position:relative;display:inline-block;border-radius:50%;border:2px solid #fafafa;background-color:transparent;margin-bottom:20px;box-sizing:content-box;width:80px;height:80px;font-size:18px}.radial-bar:after,.radial-bar>img{display:inline-block;position:absolute;top:0;left:0;border-radius:50%;text-align:center;font-weight:700;color:#a1a2a3;width:56px;height:56px;margin-left:12px;margin-top:12px;line-height:56px}.radial-bar:after{content:attr(data-label);background-color:#fff;z-index:101}.radial-bar>img{z-index:102}.radial-bar.radial-bar-0{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(90deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-5{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(108deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-10{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(126deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-15{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(144deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-20{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(162deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-25{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(180deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-30{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(198deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-35{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(216deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-40{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(234deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-45{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(252deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-50{background-image:linear-gradient(-90deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-55{background-image:linear-gradient(-72deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-60{background-image:linear-gradient(-54deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-65{background-image:linear-gradient(-36deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-70{background-image:linear-gradient(-18deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-75{background-image:linear-gradient(0deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-80{background-image:linear-gradient(18deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-85{background-image:linear-gradient(36deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-90{background-image:linear-gradient(54deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-95{background-image:linear-gradient(72deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar.radial-bar-100{background-image:linear-gradient(90deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-0{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(90deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-5{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(108deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-10{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(126deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-15{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(144deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-20{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(162deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-25{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(180deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-30{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(198deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-35{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(216deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-40{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(234deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-45{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(252deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-50{background-image:linear-gradient(-90deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-55{background-image:linear-gradient(-72deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-60{background-image:linear-gradient(-54deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-65{background-image:linear-gradient(-36deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-70{background-image:linear-gradient(-18deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-75{background-image:linear-gradient(0deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-80{background-image:linear-gradient(18deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-85{background-image:linear-gradient(36deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-90{background-image:linear-gradient(54deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-95{background-image:linear-gradient(72deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-primary.radial-bar-100{background-image:linear-gradient(90deg,#649cb4 50%,transparent 50%,transparent),linear-gradient(270deg,#649cb4 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-0{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(90deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-5{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(108deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-10{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(126deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-15{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(144deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-20{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(162deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-25{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(180deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-30{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(198deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-35{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(216deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-40{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(234deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-45{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(252deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-50{background-image:linear-gradient(-90deg,#27c24c 50%,transparent 50%,transparent),linear-gradient(270deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-55{background-image:linear-gradient(-72deg,#27c24c 50%,transparent 50%,transparent),linear-gradient(270deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-60{background-image:linear-gradient(-54deg,#27c24c 50%,transparent 50%,transparent),linear-gradient(270deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-65{background-image:linear-gradient(-36deg,#27c24c 50%,transparent 50%,transparent),linear-gradient(270deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-70{background-image:linear-gradient(-18deg,#27c24c 50%,transparent 50%,transparent),linear-gradient(270deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-75{background-image:linear-gradient(0deg,#27c24c 50%,transparent 50%,transparent),linear-gradient(270deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-80{background-image:linear-gradient(18deg,#27c24c 50%,transparent 50%,transparent),linear-gradient(270deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-85{background-image:linear-gradient(36deg,#27c24c 50%,transparent 50%,transparent),linear-gradient(270deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-90{background-image:linear-gradient(54deg,#27c24c 50%,transparent 50%,transparent),linear-gradient(270deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-95{background-image:linear-gradient(72deg,#27c24c 50%,transparent 50%,transparent),linear-gradient(270deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-success.radial-bar-100{background-image:linear-gradient(90deg,#27c24c 50%,transparent 50%,transparent),linear-gradient(270deg,#27c24c 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-0{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(90deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-5{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(108deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-10{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(126deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-15{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(144deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-20{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(162deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-25{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(180deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-30{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(198deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-35{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(216deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-40{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(234deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-45{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(252deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-50{background-image:linear-gradient(-90deg,#053775 50%,transparent 50%,transparent),linear-gradient(270deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-55{background-image:linear-gradient(-72deg,#053775 50%,transparent 50%,transparent),linear-gradient(270deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-60{background-image:linear-gradient(-54deg,#053775 50%,transparent 50%,transparent),linear-gradient(270deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-65{background-image:linear-gradient(-36deg,#053775 50%,transparent 50%,transparent),linear-gradient(270deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-70{background-image:linear-gradient(-18deg,#053775 50%,transparent 50%,transparent),linear-gradient(270deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-75{background-image:linear-gradient(0deg,#053775 50%,transparent 50%,transparent),linear-gradient(270deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-80{background-image:linear-gradient(18deg,#053775 50%,transparent 50%,transparent),linear-gradient(270deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-85{background-image:linear-gradient(36deg,#053775 50%,transparent 50%,transparent),linear-gradient(270deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-90{background-image:linear-gradient(54deg,#053775 50%,transparent 50%,transparent),linear-gradient(270deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-95{background-image:linear-gradient(72deg,#053775 50%,transparent 50%,transparent),linear-gradient(270deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-info.radial-bar-100{background-image:linear-gradient(90deg,#053775 50%,transparent 50%,transparent),linear-gradient(270deg,#053775 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-0{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(90deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-5{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(108deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-10{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(126deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-15{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(144deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-20{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(162deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-25{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(180deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-30{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(198deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-35{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(216deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-40{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(234deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-45{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(252deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-50{background-image:linear-gradient(-90deg,#ff902b 50%,transparent 50%,transparent),linear-gradient(270deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-55{background-image:linear-gradient(-72deg,#ff902b 50%,transparent 50%,transparent),linear-gradient(270deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-60{background-image:linear-gradient(-54deg,#ff902b 50%,transparent 50%,transparent),linear-gradient(270deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-65{background-image:linear-gradient(-36deg,#ff902b 50%,transparent 50%,transparent),linear-gradient(270deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-70{background-image:linear-gradient(-18deg,#ff902b 50%,transparent 50%,transparent),linear-gradient(270deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-75{background-image:linear-gradient(0deg,#ff902b 50%,transparent 50%,transparent),linear-gradient(270deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-80{background-image:linear-gradient(18deg,#ff902b 50%,transparent 50%,transparent),linear-gradient(270deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-85{background-image:linear-gradient(36deg,#ff902b 50%,transparent 50%,transparent),linear-gradient(270deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-90{background-image:linear-gradient(54deg,#ff902b 50%,transparent 50%,transparent),linear-gradient(270deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-95{background-image:linear-gradient(72deg,#ff902b 50%,transparent 50%,transparent),linear-gradient(270deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-warning.radial-bar-100{background-image:linear-gradient(90deg,#ff902b 50%,transparent 50%,transparent),linear-gradient(270deg,#ff902b 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-0{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(90deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-5{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(108deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-10{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(126deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-15{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(144deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-20{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(162deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-25{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(180deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-30{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(198deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-35{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(216deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-40{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(234deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-45{background-image:linear-gradient(90deg,#fafafa 50%,transparent 50%,transparent),linear-gradient(252deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-50{background-image:linear-gradient(-90deg,#f05050 50%,transparent 50%,transparent),linear-gradient(270deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-55{background-image:linear-gradient(-72deg,#f05050 50%,transparent 50%,transparent),linear-gradient(270deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-60{background-image:linear-gradient(-54deg,#f05050 50%,transparent 50%,transparent),linear-gradient(270deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-65{background-image:linear-gradient(-36deg,#f05050 50%,transparent 50%,transparent),linear-gradient(270deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-70{background-image:linear-gradient(-18deg,#f05050 50%,transparent 50%,transparent),linear-gradient(270deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-75{background-image:linear-gradient(0deg,#f05050 50%,transparent 50%,transparent),linear-gradient(270deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-80{background-image:linear-gradient(18deg,#f05050 50%,transparent 50%,transparent),linear-gradient(270deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-85{background-image:linear-gradient(36deg,#f05050 50%,transparent 50%,transparent),linear-gradient(270deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-90{background-image:linear-gradient(54deg,#f05050 50%,transparent 50%,transparent),linear-gradient(270deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-95{background-image:linear-gradient(72deg,#f05050 50%,transparent 50%,transparent),linear-gradient(270deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-danger.radial-bar-100{background-image:linear-gradient(90deg,#f05050 50%,transparent 50%,transparent),linear-gradient(270deg,#f05050 50%,#fafafa 50%,#fafafa)}.radial-bar-lg{width:100px;height:100px;font-size:22px}.radial-bar-lg:after,.radial-bar-lg>img{width:70px;height:70px;margin-left:15px;margin-top:15px;line-height:70px}.radial-bar-sm{width:50px;height:50px;font-size:12px}.radial-bar-sm:after,.radial-bar-sm>img{width:35px;height:35px;margin-left:7.5px;margin-top:7.5px;line-height:35px}.radial-bar-xs{width:30px;height:30px;font-size:8px}.radial-bar-xs:after,.radial-bar-xs>img{width:21px;height:21px;margin-left:4.5px;margin-top:4.5px;line-height:21px}.radial-bar,x:-o-prefocus{background-clip:content-box}.has-user-block{display:block;overflow:hidden;border:0!important;width:100%!important}.user-block{position:relative;padding:25px 0 10px;cursor:pointer}.user-block:after,.user-block:before{content:\" \";display:table}.user-block:after{clear:both}.user-block>.user-block-picture{position:relative;width:60px;margin:0 auto}.user-block>.user-block-picture>img{max-width:100%;height:auto}.user-block .user-block-info{padding-top:5px;text-align:center;white-space:nowrap}.user-block .user-block-info .user-block-name,.user-block .user-block-info .user-block-role{display:block}.user-block .user-block-info .user-block-username{color:#fff;font-weight:700}.user-block .user-block-info .user-block-name{color:#7d848f}.user-block .user-block-info .user-block-role{font-size:12px;color:#aaa}.user-block-logout{margin-top:15px}.user-block-status{position:relative;text-align:center}.user-block-status>.circle{position:absolute;bottom:0;right:0;border:2px solid #fff}.aside-collapsed .user-block,.aside-collapsed-text .user-block{padding:15px 0 14px;margin:0;text-align:center}.aside-collapsed .user-block>.user-block-picture,.aside-collapsed-text .user-block>.user-block-picture{float:none;margin:0 auto;width:50px}.aside-collapsed .user-block>.user-block-picture>.user-block-status,.aside-collapsed-text .user-block>.user-block-picture>.user-block-status{display:block}.aside-collapsed .user-block .user-block-info,.aside-collapsed-text .user-block .user-block-info{display:none}.aside-collapsed .user-block .user-block-logout em,.aside-collapsed-text .user-block .user-block-logout em{font-size:1.6em}.circle{display:inline-block;width:7px;height:7px;border-radius:500px;margin:0 .5em;background-color:#ddd;vertical-align:baseline;border:2px solid transparent}.circle.text-left{margin-left:0}.circle.text-right{margin-right:0}.circle-primary{background-color:#649cb4}.circle-success{background-color:#27c24c}.circle-info{background-color:#053775}.circle-warning{background-color:#ff902b}.circle-danger{background-color:#f05050}.circle-green{background-color:#37bc9b}.circle-pink{background-color:#f532e5}.circle-inverse{background-color:#131e26}.circle-purple{background-color:#7266ba}.circle-sm{width:5px;height:5px}.circle-lg{width:11px;height:11px}.circle-xl{width:18px;height:18px}.circle-outline{background-color:transparent}.circle-outline.circle-primary{border:1px solid #649cb4}.circle-outline.circle-success{border:1px solid #27c24c}.circle-outline.circle-info{border:1px solid #053775}.circle-outline.circle-warning{border:1px solid #ff902b}.circle-outline.circle-danger{border:1px solid #f05050}.timeline,.timeline-alt{list-style:none;padding:0 0 20px;position:relative;z-index:0}.timeline-alt:before,.timeline:before{position:absolute;top:0;bottom:0;content:\" \";width:1px;background-color:#d1d2d3;left:18px}.timeline .timeline-end,.timeline-alt .timeline-end{float:none;clear:both}.timeline .popover.left>.arrow:after,.timeline-alt .popover.left>.arrow:after{border-left-color:#fff}.timeline .popover.right>.arrow:after,.timeline-alt .popover.right>.arrow:after{border-right-color:#fff}.timeline .popover.left>.popover-title+.arrow:after,.timeline-alt .popover.left>.popover-title+.arrow:after{border-left-color:#fafafa}.timeline .popover.right>.popover-title+.arrow:after,.timeline-alt .popover.right>.popover-title+.arrow:after{border-right-color:#fafafa}.timeline-alt>li,.timeline>li{margin-bottom:20px}.timeline-alt>li:after,.timeline-alt>li:before,.timeline>li:after,.timeline>li:before{content:\" \";display:table}.timeline-alt>li:after,.timeline>li:after{clear:both}.timeline-alt>li.timeline-separator,.timeline>li.timeline-separator{position:relative;float:none;clear:both;margin:0 auto;padding:40px 0}.timeline-alt>li.timeline-separator:first-child,.timeline>li.timeline-separator:first-child{padding-top:0}.timeline-alt>li.timeline-separator:before,.timeline>li.timeline-separator:before{content:attr(data-datetime);display:inline-block;width:120px;text-align:center;padding:0 20px;line-height:30px;background-color:#b6c5da;color:#fff}.timeline-alt>li>.timeline-panel,.timeline>li>.timeline-panel{margin-left:60px}.timeline-alt>li>.timeline-panel .popover,.timeline>li>.timeline-panel .popover{position:relative;display:block;margin:0;width:100%;max-width:none}.timeline-alt>li>.timeline-panel .popover .arrow,.timeline>li>.timeline-panel .popover .arrow{top:18px;display:none}.timeline-alt>li>.timeline-panel .popover .popover-content .popover-title,.timeline>li>.timeline-panel .popover .popover-content .popover-title{background-color:transparent;border:0;padding-left:0;padding-top:0}.timeline-alt>li>.timeline-date,.timeline>li>.timeline-date{margin:-20px 0 0;display:block;height:20px;line-height:20px;font-size:13px}.timeline-alt>li>.timeline-date>time:after,.timeline>li>.timeline-date>time:after{content:attr(datetime)}.timeline-alt>li>.timeline-badge,.timeline>li>.timeline-badge{position:absolute;left:0;width:36px;height:36px;border-radius:500px;line-height:36px;font-size:1em;text-align:center;color:#fff;background-color:#999;z-index:100}.timeline-alt>li>.timeline-badge.primary,.timeline>li>.timeline-badge.primary{background-color:#649cb4}.timeline-alt>li>.timeline-badge.success,.timeline>li>.timeline-badge.success{background-color:#27c24c}.timeline-alt>li>.timeline-badge.warning,.timeline>li>.timeline-badge.warning{background-color:#ff902b}.timeline-alt>li>.timeline-badge.danger,.timeline>li>.timeline-badge.danger{background-color:#f05050}.timeline-alt>li>.timeline-badge.info,.timeline>li>.timeline-badge.info{background-color:#053775}.timeline-alt>li>.timeline-badge.inverse,.timeline>li>.timeline-badge.inverse{background-color:#131e26}.timeline-alt>li>.timeline-badge.green,.timeline>li>.timeline-badge.green{background-color:#37bc9b}.timeline-alt>li>.timeline-badge.pink,.timeline>li>.timeline-badge.pink{background-color:#f532e5}.timeline-alt>li>.timeline-badge.purple,.timeline>li>.timeline-badge.purple{background-color:#7266ba}.timeline-alt>li>.timeline-badge.dark,.timeline>li>.timeline-badge.dark{background-color:#3a3f51}.timeline-alt>li>.timeline-badge.yellow,.timeline>li>.timeline-badge.yellow{background-color:#fad732}.timeline-alt .popover .arrow{display:block!important}.timeline-title{margin-top:0;color:inherit}.timeline-body>p,.timeline-body>ul{margin-bottom:0}.timeline-body>p+p{margin-top:5px}@media only screen and (min-width:992px){.timeline:before{left:50%;margin-left:18px}.timeline>li{float:left;clear:left;width:45%}.timeline>li.timeline-inverted{float:right;clear:right;margin-top:50px}.timeline>li.timeline-separator{text-align:center}.timeline>li.timeline-separator:before{margin-left:36px}.timeline>li>.timeline-badge{left:50%;margin-left:0}.timeline>li>.timeline-date{float:none;position:absolute;width:40%;left:50%;top:18px;margin-left:54px;margin-top:-10px}.timeline>li>.timeline-panel{margin:0}.timeline>li>.timeline-panel:before{border-left-width:15px;border-right-width:0;top:26px;right:-15px;left:auto}.timeline>li>.timeline-panel:after{border-left-width:14px;border-right-width:0;top:27px;right:-14px;left:auto}.timeline>li>.timeline-panel .popover .arrow{display:block}.timeline>li.timeline-inverted>.timeline-panel{padding-left:36px}.timeline>li.timeline-inverted .timeline-date{left:auto;right:50%;width:auto;margin-left:0;margin-right:36px}}.dropdown-lg>.dropdown-menu{min-width:200px}.dropdown-list>.dropdown-menu{padding:0;min-width:220px}.dropdown-list .list-group{margin:0}.dropdown-list .list-group-item{border-radius:0;border-left:0;border-right:0}.dropdown-list .list-group-item:first-child{border-top:0}.dropdown-list .list-group-item:last-child{border-bottom:0}.dropdown>a{position:relative}.dropdown>a>.label{position:absolute;top:0;right:0;padding:2px 5px}.dropdown-menu-header{padding:10px 15px;background-color:#fafafa;border-bottom:1px solid #e1e1e1}.container-sm{max-width:750px;width:auto}.container-md{max-width:970px;width:auto}.container-lg{max-width:1170px;width:auto}.row-table{display:table;table-layout:fixed;height:100%;width:100%;margin:0}.row-table>[class*=col-]{display:table-cell;float:none;table-layout:fixed;vertical-align:middle}.row-flush>[class*=col-]{padding-left:0;padding-right:0}.half-float{position:relative;margin-bottom:65px}.half-float .half-float-bottom,.half-float .half-float-top{position:absolute;left:50%;bottom:-60px;width:120px;height:120px;margin-left:-60px;z-index:2}.half-float .half-float-top{bottom:auto;top:-60px}.half-float+*{margin-top:-55px;padding-top:65px}.row-masonry{position:relative;margin:0;padding:0;width:100%}.row-masonry>.col-masonry{display:inline-block;width:100%;min-height:1em;margin-bottom:15px}@media only screen and (min-width:480px){.layout-fs .wrapper>section{overflow:hidden}.row-masonry-sm-1{-moz-column-count:1;column-count:1;-moz-column-gap:15px;column-gap:15px;-moz-columns:1;columns:1}.no-csscolumns .row-masonry-sm-1{text-align:justify}.no-csscolumns .row-masonry-sm-1:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-sm-1>.col-masonry{vertical-align:top;display:inline-block;width:99%}.row-masonry-sm-2{-moz-column-count:2;column-count:2;-moz-column-gap:15px;column-gap:15px;-moz-columns:2;columns:2}.no-csscolumns .row-masonry-sm-2{text-align:justify}.no-csscolumns .row-masonry-sm-2:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-sm-2>.col-masonry{vertical-align:top;display:inline-block;width:49%}.row-masonry-sm-3{-moz-column-count:3;column-count:3;-moz-column-gap:15px;column-gap:15px;-moz-columns:3;columns:3}.no-csscolumns .row-masonry-sm-3{text-align:justify}.no-csscolumns .row-masonry-sm-3:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-sm-3>.col-masonry{vertical-align:top;display:inline-block;width:32%}.row-masonry-sm-4{-moz-column-count:4;column-count:4;-moz-column-gap:15px;column-gap:15px;-moz-columns:4;columns:4}.no-csscolumns .row-masonry-sm-4{text-align:justify}.no-csscolumns .row-masonry-sm-4:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-sm-4>.col-masonry{vertical-align:top;display:inline-block;width:24%}.row-masonry-sm-5{-moz-column-count:5;column-count:5;-moz-column-gap:15px;column-gap:15px;-moz-columns:5;columns:5}.no-csscolumns .row-masonry-sm-5{text-align:justify}.no-csscolumns .row-masonry-sm-5:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-sm-5>.col-masonry{vertical-align:top;display:inline-block;width:19%}.row-masonry-sm-6{-moz-column-count:6;column-count:6;-moz-column-gap:15px;column-gap:15px;-moz-columns:6;columns:6}.no-csscolumns .row-masonry-sm-6{text-align:justify}.no-csscolumns .row-masonry-sm-6:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-sm-6>.col-masonry{vertical-align:top;display:inline-block;width:15%}.row-masonry-sm-7{-moz-column-count:7;column-count:7;-moz-column-gap:15px;column-gap:15px;-moz-columns:7;columns:7}.no-csscolumns .row-masonry-sm-7{text-align:justify}.no-csscolumns .row-masonry-sm-7:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-sm-7>.col-masonry{vertical-align:top;display:inline-block;width:13%}.row-masonry-sm-8{-moz-column-count:8;column-count:8;-moz-column-gap:15px;column-gap:15px;-moz-columns:8;columns:8}.no-csscolumns .row-masonry-sm-8{text-align:justify}.no-csscolumns .row-masonry-sm-8:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-sm-8>.col-masonry{vertical-align:top;display:inline-block;width:11%}.row-masonry-sm-9{-moz-column-count:9;column-count:9;-moz-column-gap:15px;column-gap:15px;-moz-columns:9;columns:9}.no-csscolumns .row-masonry-sm-9{text-align:justify}.no-csscolumns .row-masonry-sm-9:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-sm-9>.col-masonry{vertical-align:top;display:inline-block;width:10%}.row-masonry-sm-10{-moz-column-count:10;column-count:10;-moz-column-gap:15px;column-gap:15px;-moz-columns:10;columns:10}.no-csscolumns .row-masonry-sm-10{text-align:justify}.no-csscolumns .row-masonry-sm-10:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-sm-10>.col-masonry{vertical-align:top;display:inline-block;width:9%}.row-masonry-sm-11{-moz-column-count:11;column-count:11;-moz-column-gap:15px;column-gap:15px;-moz-columns:11;columns:11}.no-csscolumns .row-masonry-sm-11{text-align:justify}.no-csscolumns .row-masonry-sm-11:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-sm-11>.col-masonry{vertical-align:top;display:inline-block;width:8%}.row-masonry-sm-12{-moz-column-count:12;column-count:12;-moz-column-gap:15px;column-gap:15px;-moz-columns:12;columns:12}.no-csscolumns .row-masonry-sm-12{text-align:justify}.no-csscolumns .row-masonry-sm-12:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-sm-12>.col-masonry{vertical-align:top;display:inline-block;width:7%}}@media only screen and (min-width:768px){.dropdown>a>.label{top:10px}.row-masonry-md-1{-moz-column-count:1;column-count:1;-moz-column-gap:15px;column-gap:15px;-moz-columns:1;columns:1}.no-csscolumns .row-masonry-md-1{text-align:justify}.no-csscolumns .row-masonry-md-1:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-md-1>.col-masonry{vertical-align:top;display:inline-block;width:99%}.row-masonry-md-2{-moz-column-count:2;column-count:2;-moz-column-gap:15px;column-gap:15px;-moz-columns:2;columns:2}.no-csscolumns .row-masonry-md-2{text-align:justify}.no-csscolumns .row-masonry-md-2:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-md-2>.col-masonry{vertical-align:top;display:inline-block;width:49%}.row-masonry-md-3{-moz-column-count:3;column-count:3;-moz-column-gap:15px;column-gap:15px;-moz-columns:3;columns:3}.no-csscolumns .row-masonry-md-3{text-align:justify}.no-csscolumns .row-masonry-md-3:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-md-3>.col-masonry{vertical-align:top;display:inline-block;width:32%}.row-masonry-md-4{-moz-column-count:4;column-count:4;-moz-column-gap:15px;column-gap:15px;-moz-columns:4;columns:4}.no-csscolumns .row-masonry-md-4{text-align:justify}.no-csscolumns .row-masonry-md-4:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-md-4>.col-masonry{vertical-align:top;display:inline-block;width:24%}.row-masonry-md-5{-moz-column-count:5;column-count:5;-moz-column-gap:15px;column-gap:15px;-moz-columns:5;columns:5}.no-csscolumns .row-masonry-md-5{text-align:justify}.no-csscolumns .row-masonry-md-5:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-md-5>.col-masonry{vertical-align:top;display:inline-block;width:19%}.row-masonry-md-6{-moz-column-count:6;column-count:6;-moz-column-gap:15px;column-gap:15px;-moz-columns:6;columns:6}.no-csscolumns .row-masonry-md-6{text-align:justify}.no-csscolumns .row-masonry-md-6:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-md-6>.col-masonry{vertical-align:top;display:inline-block;width:15%}.row-masonry-md-7{-moz-column-count:7;column-count:7;-moz-column-gap:15px;column-gap:15px;-moz-columns:7;columns:7}.no-csscolumns .row-masonry-md-7{text-align:justify}.no-csscolumns .row-masonry-md-7:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-md-7>.col-masonry{vertical-align:top;display:inline-block;width:13%}.row-masonry-md-8{-moz-column-count:8;column-count:8;-moz-column-gap:15px;column-gap:15px;-moz-columns:8;columns:8}.no-csscolumns .row-masonry-md-8{text-align:justify}.no-csscolumns .row-masonry-md-8:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-md-8>.col-masonry{vertical-align:top;display:inline-block;width:11%}.row-masonry-md-9{-moz-column-count:9;column-count:9;-moz-column-gap:15px;column-gap:15px;-moz-columns:9;columns:9}.no-csscolumns .row-masonry-md-9{text-align:justify}.no-csscolumns .row-masonry-md-9:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-md-9>.col-masonry{vertical-align:top;display:inline-block;width:10%}.row-masonry-md-10{-moz-column-count:10;column-count:10;-moz-column-gap:15px;column-gap:15px;-moz-columns:10;columns:10}.no-csscolumns .row-masonry-md-10{text-align:justify}.no-csscolumns .row-masonry-md-10:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-md-10>.col-masonry{vertical-align:top;display:inline-block;width:9%}.row-masonry-md-11{-moz-column-count:11;column-count:11;-moz-column-gap:15px;column-gap:15px;-moz-columns:11;columns:11}.no-csscolumns .row-masonry-md-11{text-align:justify}.no-csscolumns .row-masonry-md-11:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-md-11>.col-masonry{vertical-align:top;display:inline-block;width:8%}.row-masonry-md-12{-moz-column-count:12;column-count:12;-moz-column-gap:15px;column-gap:15px;-moz-columns:12;columns:12}.no-csscolumns .row-masonry-md-12{text-align:justify}.no-csscolumns .row-masonry-md-12:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-md-12>.col-masonry{vertical-align:top;display:inline-block;width:7%}.table-grid{display:table;width:100%;height:100%;table-layout:fixed}.col{display:table-cell;vertical-align:top;height:100%}.col.col-full-center{vertical-align:middle}.col-1{width:8.333333%}.col-2{width:16.666667%}.col-3{width:25%}.col-4{width:33.333333%}.col-5{width:41.666667%}.col-6{width:50%}.col-7{width:58.333333%}.col-8{width:66.666667%}.col-9{width:75%}.col-10{width:83.333333%}.col-11{width:91.666667%}.col-12{width:100%}.col-xxs{width:60px}.col-xs{width:90px}.col-sm{width:150px}.col-sd{width:200px}.col-md{width:240px}.col-lg{width:280px}.col-xl{width:320px}.col-xxl{width:360px}.col-wide{width:100%}.col-auto{width:auto}.table-grid-padded{margin-left:-1rem;margin-right:-1rem}.table-grid-padded .table-grid{border-spacing:1rem 0}}@media only screen and (min-width:992px){.row-masonry-lg-1{-moz-column-count:1;column-count:1;-moz-column-gap:15px;column-gap:15px;-moz-columns:1;columns:1}.no-csscolumns .row-masonry-lg-1{text-align:justify}.no-csscolumns .row-masonry-lg-1:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-lg-1>.col-masonry{vertical-align:top;display:inline-block;width:99%}.row-masonry-lg-2{-moz-column-count:2;column-count:2;-moz-column-gap:15px;column-gap:15px;-moz-columns:2;columns:2}.no-csscolumns .row-masonry-lg-2{text-align:justify}.no-csscolumns .row-masonry-lg-2:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-lg-2>.col-masonry{vertical-align:top;display:inline-block;width:49%}.row-masonry-lg-3{-moz-column-count:3;column-count:3;-moz-column-gap:15px;column-gap:15px;-moz-columns:3;columns:3}.no-csscolumns .row-masonry-lg-3{text-align:justify}.no-csscolumns .row-masonry-lg-3:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-lg-3>.col-masonry{vertical-align:top;display:inline-block;width:32%}.row-masonry-lg-4{-moz-column-count:4;column-count:4;-moz-column-gap:15px;column-gap:15px;-moz-columns:4;columns:4}.no-csscolumns .row-masonry-lg-4{text-align:justify}.no-csscolumns .row-masonry-lg-4:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-lg-4>.col-masonry{vertical-align:top;display:inline-block;width:24%}.row-masonry-lg-5{-moz-column-count:5;column-count:5;-moz-column-gap:15px;column-gap:15px;-moz-columns:5;columns:5}.no-csscolumns .row-masonry-lg-5{text-align:justify}.no-csscolumns .row-masonry-lg-5:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-lg-5>.col-masonry{vertical-align:top;display:inline-block;width:19%}.row-masonry-lg-6{-moz-column-count:6;column-count:6;-moz-column-gap:15px;column-gap:15px;-moz-columns:6;columns:6}.no-csscolumns .row-masonry-lg-6{text-align:justify}.no-csscolumns .row-masonry-lg-6:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-lg-6>.col-masonry{vertical-align:top;display:inline-block;width:15%}.row-masonry-lg-7{-moz-column-count:7;column-count:7;-moz-column-gap:15px;column-gap:15px;-moz-columns:7;columns:7}.no-csscolumns .row-masonry-lg-7{text-align:justify}.no-csscolumns .row-masonry-lg-7:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-lg-7>.col-masonry{vertical-align:top;display:inline-block;width:13%}.row-masonry-lg-8{-moz-column-count:8;column-count:8;-moz-column-gap:15px;column-gap:15px;-moz-columns:8;columns:8}.no-csscolumns .row-masonry-lg-8{text-align:justify}.no-csscolumns .row-masonry-lg-8:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-lg-8>.col-masonry{vertical-align:top;display:inline-block;width:11%}.row-masonry-lg-9{-moz-column-count:9;column-count:9;-moz-column-gap:15px;column-gap:15px;-moz-columns:9;columns:9}.no-csscolumns .row-masonry-lg-9{text-align:justify}.no-csscolumns .row-masonry-lg-9:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-lg-9>.col-masonry{vertical-align:top;display:inline-block;width:10%}.row-masonry-lg-10{-moz-column-count:10;column-count:10;-moz-column-gap:15px;column-gap:15px;-moz-columns:10;columns:10}.no-csscolumns .row-masonry-lg-10{text-align:justify}.no-csscolumns .row-masonry-lg-10:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-lg-10>.col-masonry{vertical-align:top;display:inline-block;width:9%}.row-masonry-lg-11{-moz-column-count:11;column-count:11;-moz-column-gap:15px;column-gap:15px;-moz-columns:11;columns:11}.no-csscolumns .row-masonry-lg-11{text-align:justify}.no-csscolumns .row-masonry-lg-11:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-lg-11>.col-masonry{vertical-align:top;display:inline-block;width:8%}.row-masonry-lg-12{-moz-column-count:12;column-count:12;-moz-column-gap:15px;column-gap:15px;-moz-columns:12;columns:12}.no-csscolumns .row-masonry-lg-12{text-align:justify}.no-csscolumns .row-masonry-lg-12:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-lg-12>.col-masonry{vertical-align:top;display:inline-block;width:7%}}@media only screen and (min-width:1200px){.row-masonry-xl-1{-moz-column-count:1;column-count:1;-moz-column-gap:15px;column-gap:15px;-moz-columns:1;columns:1}.no-csscolumns .row-masonry-xl-1{text-align:justify}.no-csscolumns .row-masonry-xl-1:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-xl-1>.col-masonry{vertical-align:top;display:inline-block;width:99%}.row-masonry-xl-2{-moz-column-count:2;column-count:2;-moz-column-gap:15px;column-gap:15px;-moz-columns:2;columns:2}.no-csscolumns .row-masonry-xl-2{text-align:justify}.no-csscolumns .row-masonry-xl-2:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-xl-2>.col-masonry{vertical-align:top;display:inline-block;width:49%}.row-masonry-xl-3{-moz-column-count:3;column-count:3;-moz-column-gap:15px;column-gap:15px;-moz-columns:3;columns:3}.no-csscolumns .row-masonry-xl-3{text-align:justify}.no-csscolumns .row-masonry-xl-3:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-xl-3>.col-masonry{vertical-align:top;display:inline-block;width:32%}.row-masonry-xl-4{-moz-column-count:4;column-count:4;-moz-column-gap:15px;column-gap:15px;-moz-columns:4;columns:4}.no-csscolumns .row-masonry-xl-4{text-align:justify}.no-csscolumns .row-masonry-xl-4:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-xl-4>.col-masonry{vertical-align:top;display:inline-block;width:24%}.row-masonry-xl-5{-moz-column-count:5;column-count:5;-moz-column-gap:15px;column-gap:15px;-moz-columns:5;columns:5}.no-csscolumns .row-masonry-xl-5{text-align:justify}.no-csscolumns .row-masonry-xl-5:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-xl-5>.col-masonry{vertical-align:top;display:inline-block;width:19%}.row-masonry-xl-6{-moz-column-count:6;column-count:6;-moz-column-gap:15px;column-gap:15px;-moz-columns:6;columns:6}.no-csscolumns .row-masonry-xl-6{text-align:justify}.no-csscolumns .row-masonry-xl-6:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-xl-6>.col-masonry{vertical-align:top;display:inline-block;width:15%}.row-masonry-xl-7{-moz-column-count:7;column-count:7;-moz-column-gap:15px;column-gap:15px;-moz-columns:7;columns:7}.no-csscolumns .row-masonry-xl-7{text-align:justify}.no-csscolumns .row-masonry-xl-7:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-xl-7>.col-masonry{vertical-align:top;display:inline-block;width:13%}.row-masonry-xl-8{-moz-column-count:8;column-count:8;-moz-column-gap:15px;column-gap:15px;-moz-columns:8;columns:8}.no-csscolumns .row-masonry-xl-8{text-align:justify}.no-csscolumns .row-masonry-xl-8:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-xl-8>.col-masonry{vertical-align:top;display:inline-block;width:11%}.row-masonry-xl-9{-moz-column-count:9;column-count:9;-moz-column-gap:15px;column-gap:15px;-moz-columns:9;columns:9}.no-csscolumns .row-masonry-xl-9{text-align:justify}.no-csscolumns .row-masonry-xl-9:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-xl-9>.col-masonry{vertical-align:top;display:inline-block;width:10%}.row-masonry-xl-10{-moz-column-count:10;column-count:10;-moz-column-gap:15px;column-gap:15px;-moz-columns:10;columns:10}.no-csscolumns .row-masonry-xl-10{text-align:justify}.no-csscolumns .row-masonry-xl-10:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-xl-10>.col-masonry{vertical-align:top;display:inline-block;width:9%}.row-masonry-xl-11{-moz-column-count:11;column-count:11;-moz-column-gap:15px;column-gap:15px;-moz-columns:11;columns:11}.no-csscolumns .row-masonry-xl-11{text-align:justify}.no-csscolumns .row-masonry-xl-11:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-xl-11>.col-masonry{vertical-align:top;display:inline-block;width:8%}.row-masonry-xl-12{-moz-column-count:12;column-count:12;-moz-column-gap:15px;column-gap:15px;-moz-columns:12;columns:12}.no-csscolumns .row-masonry-xl-12{text-align:justify}.no-csscolumns .row-masonry-xl-12:after{content:\"\";display:inline-block;width:100%}.no-csscolumns .row-masonry-xl-12>.col-masonry{vertical-align:top;display:inline-block;width:7%}}.widget{margin-bottom:20px;border:0}.widget .panel,.widget.panel{overflow:hidden}.widget .lateral-picture{position:relative;display:block;height:240px;width:auto;overflow:hidden}.widget .lateral-picture>img{position:absolute;top:0;left:0;max-height:100%;width:auto}.typeahead-ctrl .dropdown-menu{max-height:300px;overflow:auto}/*!\n * table-grid (http://mdo.github.io/table-grid)\n * Released under MIT, (c) 2014 Mark Otto\n */@media only screen and (max-width:991px){.table-grid-desktop .col,.table-grid-desktop.table-grid{display:block;width:auto}}.table-grid-align-middle .col{vertical-align:middle}.todo .todo-item-list{position:relative}.todo .todo-item.ng-enter{-webkit-animation:1s fadeInLeft;animation:1s fadeInLeft}.todo .todo-item.ng-leave{position:absolute;left:0;right:0;-webkit-animation:.7s both fadeOutDown;animation:.7s both fadeOutDown}.todo .todo-item .todo-edit{display:none;cursor:pointer}.todo .todo-item:hover .todo-edit{display:inline}.todo .todo-item.todo-complete .todo-edit{display:none}.todo textarea{resize:none;max-width:100%;min-width:100%}.todo .todo-complete{opacity:.6;color:#232735}.todo .todo-complete .todo-title{text-decoration:line-through}.todo .panel-group>.panel{border:1px;margin:0}.todo .panel-group>.panel .panel-body{border-bottom:1px solid #edf1f2}.file-upload{display:block;overflow:hidden;position:relative}.file-upload [type=file]{cursor:pointer;display:block;min-height:100%;min-width:100%;opacity:0;position:absolute;right:0;text-align:right;top:0}.c-checkbox,.c-radio{margin-right:4px}.c-checkbox *,.c-radio *{cursor:pointer}.c-checkbox input,.c-radio input{opacity:0;position:absolute;margin-left:0!important}.c-checkbox span,.c-radio span{position:relative;display:inline-block;vertical-align:top;margin-left:-20px;width:20px;height:20px;border-radius:2px;border:1px solid #ccc;margin-right:5px;text-align:center}.c-checkbox span:before,.c-radio span:before{margin-left:1px;position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;text-align:center!important;font-size:12px;line-height:18px;vertical-align:middle}.c-checkbox:hover span,.c-radio:hover span{border-color:#649cb4}.form-inline .c-checkbox span,.form-inline .c-radio span{margin-left:0}.c-checkbox.c-checkbox-rounded span,.c-checkbox.c-radio-rounded span,.c-radio span,.c-radio.c-checkbox-rounded span,.c-radio.c-radio-rounded span{border-radius:500px}.c-checkbox input[type=checkbox]:checked+span:before,.c-checkbox input[type=radio]:checked+span:before,.c-radio input[type=checkbox]:checked+span:before,.c-radio input[type=radio]:checked+span:before{color:#fff;opacity:1;transition:color .3s ease-out}.c-checkbox input[type=checkbox]:checked+span,.c-checkbox input[type=radio]:checked+span,.c-radio input[type=checkbox]:checked+span,.c-radio input[type=radio]:checked+span{border-color:#649cb4;background-color:#649cb4}.c-checkbox input[type=radio]:checked+span,.c-radio input[type=radio]:checked+span{background-color:#fff}.c-checkbox input[type=radio]:checked+span:before,.c-radio input[type=radio]:checked+span:before{color:#649cb4}.c-checkbox input[type=checkbox]:disabled+span,.c-checkbox input[type=radio]:disabled+span,.c-radio input[type=checkbox]:disabled+span,.c-radio input[type=radio]:disabled+span{border-color:#ddd!important;background-color:#ddd!important}.c-checkbox input[type=radio]:disabled+span,.c-radio input[type=radio]:disabled+span{background-color:#fff!important}.c-checkbox input[type=radio]:disabled+span:before,.c-radio input[type=radio]:disabled+span:before{color:#ddd}.c-radio.c-radio-nofont span:before{content:\"\";width:10px;height:10px;top:50%;left:50%;margin-top:-5px;margin-left:-5px;border-radius:500px}.c-radio.c-radio-nofont input[type=radio]:checked+span:before{color:#fff;opacity:1;transition:color .3s ease-out;background-color:#649cb4}.c-radio.c-radio-nofont input[type=radio]:checked+span{border-color:#649cb4;background-color:#fff}.c-radio.c-radio-nofont input[type=radio]:disabled+span{border-color:#ddd!important;background-color:#fff!important}.c-radio.c-radio-nofont input[type=radio]:disabled+span:before{background-color:#ddd}.form-control-rounded{border-radius:100px}.switch .form-control{padding-top:7px;margin-bottom:0}.switch *{cursor:pointer}.switch input{opacity:0;position:absolute;z-index:-1}.switch span{position:relative;display:inline-block;width:40px;height:20px;background-color:#fff;border:1px solid #ddd;border-radius:100px;transition:.5s;box-shadow:1px 2px 3px rgba(0,0,0,.1) inset;vertical-align:middle}.switch span:after{content:\"\";position:absolute;background-color:#fff;top:0;left:0;height:18px;width:18px;border:1px solid #ddd;border-radius:400px;box-shadow:1px 1px 3px rgba(0,0,0,.1);-webkit-transition:.2s}.switch.switch-lg span{width:50px;height:25px}.switch.switch-lg span:after{height:23px;width:23px}.switch.switch-sm span{width:30px;height:15px}.switch.switch-sm span:after{height:13px;width:13px}.switch input:checked+span{background-color:#649cb4;border-color:#649cb4;transition:.5s}.switch input:checked+span:after{left:50%;transition:.2s}.switch input:disabled+span{background-color:#f1f1f1;cursor:not-allowed}.form-control-feedback{left:16px;right:auto}.form-control+.form-control-feedback,.form-control+.parsley-errors-list+.form-control-feedback{right:0;left:auto}.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.form-control+.parsley-errors-list+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-addon+.parsley-errors-list+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.parsley-errors-list+.form-control-feedback,.input-sm+.form-control-feedback,.input-sm+.parsley-errors-list+.form-control-feedback{top:0}.input-md{width:260px}.note-editor{background-image:linear-gradient(#eee .1em,transparent .1em);background-size:100% 20px;background-color:#fff;line-height:20px;margin-top:5px;padding:0 0 1px;border:none}.note-editor.note-editor-margin{background-image:linear-gradient(90deg,transparent 49px,#ffe0c4 49px,#ffe0c4 51px,transparent 51px),linear-gradient(#eee .1em,transparent .1em);padding-left:55px}.summernote+.note-editor{background-image:none!important}.summernote+.note-editor.note-frame{border-color:#e4eaec}.summernote+.note-editor.note-frame.fullscreen{margin-top:0}.code-container{margin:0;padding:0;background-color:#fff}.code-files{border-right:1px solid #dde6e9;background-color:#edf1f2}.code-files .nav.nav-pills{padding:10px;overflow:hidden}.code-files .nav.nav-pills>li>a{color:#3a3f51}.code-files .nav.nav-pills>li>a:hover{background-color:#e4eaec}.code-files .nav.nav-pills>li.active>a{background-color:#053775;color:#fff}.code-toolbar{position:absolute;top:0;left:0;right:0;height:50px;margin:0;border-bottom:1px solid #dde6e9;background:#fff;z-index:5}.code-editor{position:relative;padding-top:50px}@media only screen and (min-width:480px){.code-editor .CodeMirror{max-height:100%;min-height:180px;height:100%}}.code-editor .CodeMirror .CodeMirror-scroll{height:100%}.code-editor .CodeMirror .CodeMirror-gutters{min-height:100%}.table>thead>tr>th{padding:14px 8px;color:#888}.table>tbody>tr>td{vertical-align:middle}.table>tbody>tr>td>.media img{width:36px;height:36px;margin:0 auto}.table .checkbox{margin:0 auto;width:20px}.table .progress{margin-bottom:0}.table .radial-bar{margin:0 auto}.jqstooltip{box-sizing:content-box}#table-ext-1 th:nth-child(1){width:3%}#table-ext-1 th:nth-child(2),#table-ext-1 th:nth-child(7),#table-ext-1 th:nth-child(9),#table-ext-2 th:nth-child(1){width:5%}#table-ext-2 th:nth-child(3){width:10%}.ag-angle .ag-root{border:1px solid #e4eaec}.ag-angle .ag-cell{padding:4px 15px}.ag-angle .ag-cell-focus{border:1px solid #becfd5}.ag-angle .ag-cell-no-focus{border-right:1px dotted #e4eaec;border-top:1px solid transparent;border-left:1px solid transparent;border-bottom:1px solid transparent}.ag-angle .ag-header-container,.ag-angle .ag-pinned-header{border-bottom:1px solid #e4eaec}.ag-angle .ag-header{border-top:2px solid #e4eaec}.ag-angle .ag-header-cell{border-right:1px solid #e4eaec;background-color:#fff}.ag-angle .ag-header-group-cell{border-right:1px solid #e4eaec}.ag-angle .ag-header-group-cell-with-group{border-bottom:1px solid #e4eaec}.ag-angle .ag-header-cell-label{padding:8px 15px}.ag-angle .ag-header-cell-text{padding-left:2px}.ag-angle .ag-header-group-cell-label{padding:4px;font-weight:700}.ag-angle .ag-header-group-text{margin-right:2px}.ag-angle .ag-header-cell-menu-button{padding:2px;margin-top:6px;border-radius:2px;cursor:pointer}.ag-angle .ag-header-cell-menu-button .ag-header-icon{color:#edf1f2}.ag-angle .ag-header-cell-menu-button:hover .ag-header-icon{color:#dde6e9}.ag-angle .ag-header-icon{color:maroon}.ag-angle .ag-dark .ag-header-expand-icon:hover{cursor:pointer}.ag-angle .ag-header-row{min-height:35px}.ag-angle .ag-row-odd{background-color:#edf1f2}.ag-angle .ag-row-even{background-color:#fff}.ag-angle .ag-loading-panel{background-color:rgba(255,255,255,.5)}.ag-angle .ag-loading-center{background-color:#fff;border:1px solid #e4eaec;border-radius:4px;padding:10px}.ag-angle .ag-body{background-color:#fff}.ag-angle .ag-row-selected{background-color:#b0e0e6}.ag-angle .ag-footer-cell-entire-row,.ag-angle .ag-group-cell-entire-row{background-color:#aaa;padding:4px}.ag-angle .ag-footer-cell,.ag-angle .ag-group-cell{font-style:italic}.ag-angle .ag-filter-checkbox{position:relative;top:2px;left:2px}.ag-angle .ag-filter-header-container{border-bottom:1px solid #dde6e9}.ag-angle .ag-filter{border:1px solid #e4eaec;background-color:#fff}.ag-angle .ag-filter input[type=text],.ag-angle .ag-filter select{width:95%;height:30px;padding:5px 10px;font-size:12px;line-height:1.5;color:#3a3f51;background-color:#fff;background-image:none;border:1px solid #dde6e9;border-radius:4px}.ag-angle .ag-filter input[type=text]:focus,.ag-angle .ag-filter select:focus{border-color:#649cb4}.ag-angle .ag-selection-checkbox{margin-left:4px}.ag-angle .ag-paging-panel{padding:4px}.ag-angle .ag-paging-button{margin-left:4px;margin-right:4px}.ag-angle .ag-paging-row-summary-panel{display:inline-block;width:300px}.ag-angle-grouped .ag-body{padding-top:60px!important}.ag-angle-grouped .ag-header{height:60px!important}.ag-angle-grouped .ag-header-group-cell{border-right:1px solid #e4eaec}.ag-angle-grouped .ag-header-cell-label{padding:4px}.ag-angle-grouped .ag-header-group-text{margin-right:6px}scrollable{display:block}.slimScrollBar{opacity:1!important;background-color:rgba(0,0,0,.35)!important;border:0!important;border-radius:1px!important}.slimScrollRail{opacity:1!important;background-color:rgba(0,0,0,.15)!important;border:0!important;border-radius:0!important;bottom:0}.calendar-app .fc-button{color:#333;background-color:#fff;border-color:#eaeaea;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px;height:auto;background-image:none}.calendar-app .fc-button.active,.calendar-app .fc-button.focus,.calendar-app .fc-button:active,.calendar-app .fc-button:focus,.calendar-app .fc-button:hover,.open>.calendar-app .fc-button.dropdown-toggle{color:#333;background-color:#f5f5f5;border-color:#d6d6d6}.calendar-app .fc-button.active.focus,.calendar-app .fc-button.active:focus,.calendar-app .fc-button.active:hover,.calendar-app .fc-button:active.focus,.calendar-app .fc-button:active:focus,.calendar-app .fc-button:active:hover,.open>.calendar-app .fc-button.dropdown-toggle.focus,.open>.calendar-app .fc-button.dropdown-toggle:focus,.open>.calendar-app .fc-button.dropdown-toggle:hover{color:#333;background-color:#f5f5f5;border-color:#d6d6d6}.calendar-app .fc-button.active,.calendar-app .fc-button:active,.open>.calendar-app .fc-button.dropdown-toggle{background-image:none}.calendar-app .fc-button.disabled.focus,.calendar-app .fc-button.disabled:focus,.calendar-app .fc-button.disabled:hover,.calendar-app .fc-button[disabled].focus,.calendar-app .fc-button[disabled]:focus,.calendar-app .fc-button[disabled]:hover,fieldset[disabled] .calendar-app .fc-button.focus,fieldset[disabled] .calendar-app .fc-button:focus,fieldset[disabled] .calendar-app .fc-button:hover{background-color:#fff;border-color:#eaeaea}.calendar-app .fc-button .badge{color:#fff;background-color:#333}.calendar-app .fc-button.active,.calendar-app .fc-button.fc-state-active,.calendar-app .fc-button:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.calendar-app .fc-button .fc-icon{margin:0 .1em;font-size:inherit;font-family:FontAwesome!important;vertical-align:baseline;color:#555;top:2px}.calendar-app .fc-button .fc-icon:after{display:none}.calendar-app .fc-day:hover,.calendar-app .fc-state-highlight{background-color:#f7f8f9}.calendar-app .fc-day-number{font-size:18px;font-weight:700;color:#a1a2a3}.calendar-app .fc-view{overflow:visible}.calendar-app .external-events{margin:0}.calendar-app .external-events>div{margin-right:5px;margin-bottom:5px;padding:6px 10px;color:#fff;font-size:11px;border-radius:2px;cursor:move}.calendar-app .external-events:empty{content:\"EMRTPUY\"}.calendar-app .external-events-trash{position:relative;min-height:120px}.calendar-app .external-events-trash:after{content:\"\uF00D\";position:absolute;top:0;left:0;right:0;bottom:0;background-color:#131e26;opacity:0;font-family:FontAwesome;color:#fff;text-align:center;font-size:50px;padding:8%;max-height:100%;transition:.3s;z-index:-1}.calendar-app .external-events-trash.active:after{opacity:1;z-index:1}.calendar-app .external-events-trash.hovered:after{background-color:#fb797e}.calendar-app .external-event-color-selector .circle.selected{border:3px solid rgba(255,255,255,.5)}body .ball-beat>div,body .ball-grid-beat>div,body .ball-grid-pulse>div,body .ball-pulse-rise>div,body .ball-pulse-sync>div,body .ball-pulse>div,body .ball-rotate>div,body .ball-rotate>div:after,body .ball-rotate>div:before,body .ball-scale-multiple>div,body .ball-scale>div,body .ball-spin-fade-loader>div,body .ball-triangle-path>div,body .ball-zig-zag-deflect>div,body .ball-zig-zag>div,body .cube-transition>div,body .line-scale-party>div,body .line-scale-pulse-out-rapid>div,body .line-scale-pulse-out>div,body .line-scale>div,body .line-spin-fade-loader>div,body .semi-circle-spin>div,body .square-spin>div,body .triangle-skew-spin>div{background-color:#649cb4}body .ball-clip-rotate-multiple{width:1px}body .ball-clip-rotate-multiple>div{border-color:#649cb4 transparent}body .ball-clip-rotate-multiple>div:last-child{border-color:transparent #649cb4}body .ball-clip-rotate{width:55px;height:55px;margin:1em auto}body .ball-clip-rotate>div{border:2px solid;border-color:#649cb4 #649cb4 transparent;width:100%;height:100%;background:0 0;border-radius:100%;-webkit-animation:.75s linear infinite ball-clip-rotate;animation:.75s linear infinite ball-clip-rotate}body .ball-clip-rotate-pulse>div:first-child{background-color:#649cb4;top:5px;left:-8px}body .ball-clip-rotate-pulse>div:last-child{border-color:#649cb4 transparent}body .ball-scale-ripple-multiple>div,body .ball-scale-ripple>div,body .square-spin>div{border-color:#649cb4}body .pacman>div:first-of-type,body .pacman>div:nth-child(2){border-top-color:#649cb4;border-left-color:#649cb4;border-bottom-color:#649cb4}body .pacman>div:nth-child(3),body .pacman>div:nth-child(4),body .pacman>div:nth-child(5),body .pacman>div:nth-child(6){background-color:#649cb4}body .sk-chasing-dots .sk-dot1,body .sk-chasing-dots .sk-dot2,body .sk-circle .sk-child:before,body .sk-cube-grid .sk-cube,body .sk-double-bounce .sk-double-bounce1,body .sk-double-bounce .sk-double-bounce2,body .sk-fading-circle .sk-circle:before,body .sk-rotating-plane,body .sk-rotating-plane.sk-spinner,body .sk-spinner-pulse.sk-spinner,body .sk-three-bounce div,body .sk-wandering-cubes .sk-cube1,body .sk-wandering-cubes .sk-cube2,body .sk-wave .sk-rect{background-color:#649cb4!important}body .sk-wordpress .sk-inner-circle{background-color:#fff}.loader-demo{height:150px;text-align:center}.loader-demo>div{display:inline-block}@-webkit-keyframes ball-clip-rotate{0%{transform:rotate(0)}50%{transform:rotate(180deg)}100%{transform:rotate(360deg)}}@keyframes ball-clip-rotate{0%{transform:rotate(0)}50%{transform:rotate(180deg)}100%{transform:rotate(360deg)}}.gmap{height:300px}.gmap.gmap-sm{height:150px}body .jvectormap-label{position:absolute;display:none;border:1px solid #313232;border-radius:2px;background:#313232;color:#fff;padding:3px 6px;opacity:.9;z-index:1100}body .jvectormap-zoomin,body .jvectormap-zoomout{position:absolute;left:10px;width:22px;height:22px;border-radius:2px;background:#515253;padding:5px;color:#fff;cursor:pointer;line-height:10px;text-align:center}body .jvectormap-zoomin{top:10px}body .jvectormap-zoomout{top:30px}.mb-boxes{overflow:hidden}.mb-boxes .nav>li>a{font-weight:600;color:#3a3f51;margin:5px 0;transition:background-color .3s}.mb-boxes .nav>li>a:focus,.mb-boxes .nav>li>a:hover{background-color:#c0d0d3}.mb-boxes .nav>li.active>a{background-color:#649cb4!important;color:#fff}@media only screen and (min-width:992px){.mb-boxes{height:auto!important;visibility:visible!important;display:block}.mb-compose-button{display:block;width:100%}.mb-toggle-button{display:none}}.mb-mails>tbody>tr>td{border-top-color:transparent;cursor:pointer}.mb-mails .mb-mail-active{background-color:#f7f8f9!important}.mb-mails .mb-mail-avatar{float:left;margin-right:10px;width:40px;height:40px;border-radius:3px}.mb-mails .mb-mail-date{display:block;float:right;color:#909fa7;font-size:12px;font-weight:700}.mb-mails .mb-mail-from{font-size:14px;font-weight:600;line-height:1}.mb-mails .mb-mail-meta{overflow:hidden}.mb-mails .mb-mail-subject{font-size:18px;font-weight:600;line-height:1.1;margin-bottom:6px}.mb-mails .mb-mail-preview{clear:both;color:#909fa7;margin-top:2px}.mb-mails .mb-attachment{margin-top:30px;padding-top:30px;border-top:1px solid #e4eaec}.mb-view>tbody>tr>td{cursor:auto}.mb-view .mb-mail-to-list{margin-top:6px}.mb-view .mb-mail-to-list>a{margin-right:5px;color:#909fa7}.plan{background-color:#edf1f2;overflow:auto;border-radius:4px;padding-bottom:30px}.plan .plan-header{background-color:#053775;color:#fff;margin:0;padding:20px 10px;text-align:center}.plan .plan-price{background:#fff;padding:16px 8px;text-align:center}.plan .plan-price h2{margin:0}.plan .plan-period{font-size:16px}.plan hr{display:block;margin:24px;border-top:1px solid rgba(0,0,0,.05);height:0}.plan .plan-description{padding:0 24px;text-align:center}.plan .plan-features{list-style-type:none;padding-left:0;margin-top:25px;margin-bottom:25px;text-align:left}.plan .plan-features>li{padding:8px 24px}.plan .plan-features>li>em{color:#053775;margin-right:7px}.plan .plan-features>li:last-child{padding-bottom:0}.plan .plan-feature-disable{color:#f05050!important}.m0{margin:0!important}.ml0{margin-left:0!important}.mr0{margin-right:0!important}.mt0{margin-top:0!important}.mb0{margin-bottom:0!important}.m{margin:10px!important}.mh,.ml{margin-left:10px!important}.mh,.mr{margin-right:10px!important}.mt,.mv{margin-top:10px!important}.mb,.mv{margin-bottom:10px!important}.m-sm{margin:5px!important}.mh-sm,.ml-sm{margin-left:5px!important}.mh-sm,.mr-sm{margin-right:5px!important}.mt-sm,.mv-sm{margin-top:5px!important}.mb-sm,.mv-sm{margin-bottom:5px!important}.m-lg{margin:15px!important}.mh-lg,.ml-lg{margin-left:15px!important}.mh-lg,.mr-lg{margin-right:15px!important}.mt-lg,.mv-lg{margin-top:15px!important}.mb-lg,.mv-lg{margin-bottom:15px!important}.m-xl{margin:30px!important}.ml-xl{margin-left:30px!important}.mr-xl{margin-right:30px!important}.mt-xl{margin-top:30px!important}.mb-xl{margin-bottom:30px!important}.p0{padding:0!important}.ph0,.pl0{padding-left:0!important}.ph0,.pr0{padding-right:0!important}.pt0,.pv0{padding-top:0!important}.pb0,.pv0{padding-bottom:0!important}.p{padding:10px!important}.ph,.pl{padding-left:10px!important}.ph,.pr{padding-right:10px!important}.pt,.pv{padding-top:10px!important}.pb,.pv{padding-bottom:10px!important}.p-sm{padding:5px!important}.ph-sm,.pl-sm{padding-left:5px!important}.ph-sm,.pr-sm{padding-right:5px!important}.pt-sm,.pv-sm{padding-top:5px!important}.pb-sm,.pv-sm{padding-bottom:5px!important}.p-lg{padding:15px!important}.ph-lg,.pl-lg{padding-left:15px!important}.ph-lg,.pr-lg{padding-right:15px!important}.pt-lg,.pv-lg{padding-top:15px!important}.pb-lg,.pv-lg{padding-bottom:15px!important}.p-xl{padding:30px!important}.ph-xl,.pl-xl{padding-left:30px!important}.ph-xl,.pr-xl{padding-right:30px!important}.pt-xl,.pv-xl{padding-top:30px!important}.pb-xl,.pv-xl{padding-bottom:30px!important}.b0{border-width:0!important}.bl0{border-left-width:0!important}.br0{border-right-width:0!important}.bt0{border-top-width:0!important}.bb0{border-bottom-width:0!important}.b,.ba,.br{border-right:1px solid rgba(0,0,0,.12)}.b,.ba,.bl{border-left:1px solid rgba(0,0,0,.12)}.b,.ba,.bt{border-top:1px solid rgba(0,0,0,.12)}.b,.ba,.bb{border-bottom:1px solid rgba(0,0,0,.12)}.radius-clear{border-radius:0!important}.shadow-clear{box-shadow:0 0 0 #000!important}.text-white{color:#fff}.text-inverse{color:#131e26}.text-alpha{color:rgba(255,255,255,.5)}.text-pink{color:#f532e5}.text-purple{color:#7266ba}.text-dark{color:#3a3f51}.text-alpha-inverse{color:rgba(0,0,0,.5)}.text-green{color:#37bc9b}.text-yellow{color:#fad732}.text-gray-darker{color:#232735}.text-gray-dark{color:#3a3f51}.text-gray{color:#dde6e9}.text-gray-light{color:#e4eaec}.text-gray-lighter{color:#edf1f2}.text-inherit{color:inherit}.text-sm{font-size:11.9px}.text-md{font-size:26.6px}.text-lg{font-size:42px}.text-nowrap{white-space:nowrap}.text-thin{font-weight:100!important}.text-normal{font-weight:400!important}.text-bold{font-weight:700!important}.inline{display:inline-block!important}.block-center{margin:0 auto}.bg-primary{background-color:#649cb4;color:#fff!important}.bg-primary-light{background-color:#86b2c5;color:#fff!important}.bg-primary-dark{background-color:#4b829a;color:#fff!important}.bg-primary small{color:inherit}.bg-success{background-color:#27c24c;color:#fff!important}.bg-success-light{background-color:#43d967;color:#fff!important}.bg-success-dark{background-color:#1e983b;color:#fff!important}.bg-success small{color:inherit}.bg-info{background-color:#053775;color:#fff!important}.bg-info-light{background-color:#51c6ea;color:#fff!important}.bg-info-dark{background-color:#6aa2b8;color:#fff!important}.bg-info small{color:inherit}.bg-warning{background-color:#ff902b;color:#fff!important}.bg-warning-light{background-color:#ffab5e;color:#fff!important}.bg-warning-dark{background-color:#f77600;color:#fff!important}.bg-warning small{color:inherit}.bg-danger{background-color:#f05050;color:#fff!important}.bg-danger-light{background-color:#f47f7f;color:#fff!important}.bg-danger-dark{background-color:#ec2121;color:#fff!important}.bg-danger small{color:inherit}.bg-green{background-color:#37bc9b;color:#fff!important}.bg-green-light{background-color:#58ceb1;color:#fff!important}.bg-green-dark{background-color:#2b957a;color:#fff!important}.bg-green small{color:inherit}.bg-pink{background-color:#f532e5;color:#fff!important}.bg-pink-light{background-color:#f763eb;color:#fff!important}.bg-pink-dark{background-color:#e90bd6;color:#fff!important}.bg-pink small{color:inherit}.bg-purple{background-color:#7266ba;color:#fff!important}.bg-purple-light{background-color:#9289ca;color:#fff!important}.bg-purple-dark{background-color:#564aa3;color:#fff!important}.bg-purple small{color:inherit}.bg-inverse{background-color:#131e26;color:#fff!important}.bg-inverse-light{background-color:#243948;color:#fff!important}.bg-inverse-dark{background-color:#020304;color:#fff!important}.bg-inverse small{color:inherit}.bg-yellow{background-color:#fad732;color:#fff!important}.bg-yellow-light{background-color:#fbe164;color:#fff!important}.bg-yellow-dark{background-color:#f3ca06;color:#fff!important}.bg-yellow small{color:inherit}.bg-white{background-color:#fff;color:inherit!important}.bg-gray-darker{background-color:#232735;color:#fff!important}.bg-gray-dark{background-color:#3a3f51;color:#fff!important}.bg-gray{background-color:#dde6e9;color:#515253!important}.bg-gray-light{background-color:#e4eaec;color:#515253!important}.bg-gray-lighter{background-color:#edf1f2;color:#515253!important}.bg-transparent{background-color:transparent!important}.bg-cover{background-size:cover}.thumb8{width:8px!important;height:8px!important}.thumb16{width:16px!important;height:16px!important}.thumb24{width:24px!important;height:24px!important}.thumb32{width:32px!important;height:32px!important}.thumb48{width:48px!important;height:48px!important}.thumb64{width:64px!important;height:64px!important}.thumb80{width:80px!important;height:80px!important}.thumb96{width:96px!important;height:96px!important}.thumb128{width:128px!important;height:128px!important}.align-middle{vertical-align:middle}.align-top{vertical-align:top}.align-bottom{vertical-align:bottom}.bg-center{background-position:center center;background-size:cover}.list-icon em{font-size:14px;width:40px;vertical-align:middle;margin:0;display:inline-block;text-align:center;transition:.2s;line-height:30px}.list-icon div:hover em{transform:scale(3,3)}.wd-xxs{width:60px}.wd-xs{width:90px}.wd-sm{width:150px}.wd-sd{width:200px}.wd-md{width:240px}.wd-lg{width:280px}.wd-xl{width:320px}.wd-xxl{width:360px}.wd-wide{width:100%}.wd-auto{width:auto}.wd-zero{width:0}.label-inverse{background-color:#131e26}.label-inverse[href]:focus,.label-inverse[href]:hover{background-color:#020304}.label-green{background-color:#37bc9b}.label-green[href]:focus,.label-green[href]:hover{background-color:#2b957a}.label-pink{background-color:#f532e5}.label-pink[href]:focus,.label-pink[href]:hover{background-color:#e90bd6}.label-purple{background-color:#7266ba}.label-purple[href]:focus,.label-purple[href]:hover{background-color:#564aa3}.alert-purple{background-color:#7266ba;border-color:#7266ba;color:#fff}.alert-purple hr{border-top-color:#6254b2}.alert-purple .alert-link{color:#e6e6e6}.alert-green{background-color:#37bc9b;border-color:#37bc9b;color:#fff}.alert-green hr{border-top-color:#31a88b}.alert-green .alert-link{color:#e6e6e6}.alert-pink{background-color:#f532e5;border-color:#f532e5;color:#fff}.alert-pink hr{border-top-color:#f41ae2}.alert-pink .alert-link{color:#e6e6e6}.alert-inverse{background-color:#131e26;border-color:#131e26;color:#fff}.alert-inverse hr{border-top-color:#0b1115}.alert-inverse .alert-link{color:#e6e6e6}.clickable{cursor:pointer}.abs-center-container{position:relative}.abs-center{height:50%;overflow:auto;margin:auto;position:absolute;top:0;left:0;bottom:0;right:0}.abs-center.abs-fixed{position:fixed;z-index:999}.abs-center.abs-right{left:auto;right:20px;text-align:right}.abs-center.abs-left{right:auto;left:20px;text-align:left}@media (max-height:720px){.abs-center{position:relative}}.link-unstyled{text-decoration:none!important;outline:0!important}.no-resize{resize:none;max-width:100%;min-width:100%}.hover-visible .hover-hidden{display:none}.hover-visible:hover .hover-hidden{display:block}.hover-visible:hover .hover-inline{display:inline-block}.media-box,.media-box-body{overflow:hidden;zoom:1}.media-box,.media-box .media-box{margin-top:15px}.media-box:first-child{margin-top:0}.media-box-object{display:block}.media-box-heading{margin:0 0 5px}.media-box>.pull-left{margin-right:10px}.media-box>.pull-right{margin-left:10px}.media-box-list{padding-left:0;list-style:none}@media print{.btn,.offsidebar,.sidebar,.topnavbar{display:none!important;width:0!important;height:0!important}.content-wrapper,.wrapper,.wrapper>section{margin:0!important;padding:0!important;width:100%!important}.content-wrapper{overflow:hidden!important}}.setting-color{padding:0 5px}.setting-color>label{display:block;position:relative;margin:0 10px;border-radius:3px;overflow:hidden;border:1px solid rgba(0,0,0,.1);cursor:pointer}.setting-color>label:first-child{margin-left:0}.setting-color>label:last-child{margin-right:0}.setting-color>label>.color{display:block;height:18px}.setting-color>label>.split{display:block}.setting-color>label>.split:after,.setting-color>label>.split:before{content:\" \";display:table}.setting-color>label>.split:after{clear:both}.setting-color>label>.split>.color{display:block;height:37.5px}.setting-color>label>.split>.color:first-child{float:left;width:70%}.setting-color>label>.split>.color:last-child{float:right;width:30%}.setting-color>label>.icon-check{position:absolute;display:block;left:50%;top:50%;width:20px;height:20px;margin-top:-20px;margin-left:-10px;text-align:center;font-size:1.33333333em;vertical-align:-15%;color:#fff;opacity:0}.setting-color>label>input[type=radio]{position:absolute;opacity:0;visibility:hidden}.setting-color>label>input[type=radio]:checked+.icon-check{opacity:1!important}@media (min-width:992px){.btn.btn-dynamic{width:initial}}@media (max-height:675px){.content-to-hide-vertical{display:none}}@media (max-width:767px){.hide-white-sxs{display:none}}@media (min-width:767px){.hide-blue-sxs{display:none;width:0;height:0}}.show-logo-when-collapsed{display:none}.hide-logo-when-collapsed{margin-left:28px;bottom:8px}.btn-info{color:#fff;background-color:#649cb4;border-color:#649cb4}.btn-info:hover{color:#fff;background-color:#4b829a;border-color:#4b829a}.text-right{text-align:initial}@media (min-width:1200px){.text-right{text-align:right}}.ng-valid.required,.ng-valid[required]{border-left:5px solid #42a948}.ng-invalid:not(form):not(div){border-left:5px solid #a94442}.alert-grey{background-color:#f5f5f5;border-color:#3a3f51;color:#3a3f51;position:fixed;z-index:1;margin-right:5%}.alert-grey hr{border-top-color:#2f3342}.alert-grey .alert-link{color:#252833}.ngx-datatable.bootstrap{background-color:transparent;box-shadow:0 0 0 #000}.ngx-datatable.scroll-vertical{height:300px}.no-detail-row .datatable-row-detail{display:none!important}.ngx-datatable.bootstrap.multi-click-selection .datatable-body-row.active,.ngx-datatable.bootstrap.multi-click-selection .datatable-body-row.active .datatable-row-group,.ngx-datatable.bootstrap.multi-click-selection .datatable-body-row.active:hover,.ngx-datatable.bootstrap.multi-click-selection .datatable-body-row.active:hover .datatable-row-group,.ngx-datatable.bootstrap.multi-selection .datatable-body-row.active,.ngx-datatable.bootstrap.multi-selection .datatable-body-row.active .datatable-row-group,.ngx-datatable.bootstrap.multi-selection .datatable-body-row.active:hover,.ngx-datatable.bootstrap.multi-selection .datatable-body-row.active:hover .datatable-row-group,.ngx-datatable.bootstrap.single-selection .datatable-body-row.active,.ngx-datatable.bootstrap.single-selection .datatable-body-row.active .datatable-row-group,.ngx-datatable.bootstrap.single-selection .datatable-body-row.active:hover,.ngx-datatable.bootstrap.single-selection .datatable-body-row.active:hover .datatable-row-group{background-color:#649cb4}.ngx-datatable.bootstrap.multi-click-selection .datatable-body-row.active .datatable-body-cell,.ngx-datatable.bootstrap.multi-click-selection .datatable-body-row.active .datatable-row-group .datatable-body-cell,.ngx-datatable.bootstrap.multi-click-selection .datatable-body-row.active:hover .datatable-body-cell,.ngx-datatable.bootstrap.multi-click-selection .datatable-body-row.active:hover .datatable-row-group .datatable-body-cell,.ngx-datatable.bootstrap.multi-selection .datatable-body-row.active .datatable-body-cell,.ngx-datatable.bootstrap.multi-selection .datatable-body-row.active .datatable-row-group .datatable-body-cell,.ngx-datatable.bootstrap.multi-selection .datatable-body-row.active:hover .datatable-body-cell,.ngx-datatable.bootstrap.multi-selection .datatable-body-row.active:hover .datatable-row-group .datatable-body-cell,.ngx-datatable.bootstrap.single-selection .datatable-body-row.active .datatable-body-cell,.ngx-datatable.bootstrap.single-selection .datatable-body-row.active .datatable-row-group .datatable-body-cell,.ngx-datatable.bootstrap.single-selection .datatable-body-row.active:hover .datatable-body-cell,.ngx-datatable.bootstrap.single-selection .datatable-body-row.active:hover .datatable-row-group .datatable-body-cell{color:#fff}.datatable-icon-right{text-decoration:none!important}.ngx-datatable.bootstrap .empty-row{text-align:center;margin-top:20px}.ngx-datatable.bootstrap .datatable-footer{background-color:transparent;color:#515253}.ngx-datatable.bootstrap .datatable-body .datatable-body-row.active{background-color:#649cb4;color:#fff}.ngx-datatable.bootstrap .datatable-footer .datatable-pager a{color:#515253}.pager li>a,.pager li>span{border-color:#eee}.ngx-datatable.bootstrap .datatable-footer .datatable-pager ul li:not(.disabled).active a,.ngx-datatable.bootstrap .datatable-footer .datatable-pager ul li:not(.disabled):hover a{background-color:#649cb4;border-color:#649cb4;color:#fff}.ngx-datatable .datatable-header .datatable-header-cell .datatable-header-cell-template-wrap{font-weight:700;font-size:1.12em;color:#649cb4}.datatable-row-group{cursor:pointer}.datatable-row-group:hover{background-color:#d4d4d4}.datatable-body-cell-label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.wrapper>section,body{background-color:#f5f7fa}.wrapper>.aside{background-color:#3a3f51;z-index:111}.topnavbar{background-color:#fff}.topnavbar .navbar-header{background-color:transparent;background-image:linear-gradient(to right,#00d3ff 0,#053775 100%);background-repeat:repeat-x}@media only screen and (min-width:768px){.summernote+.note-editor.note-frame.fullscreen{top:55px;left:220px;right:0;width:auto!important}.aside-collapsed .summernote+.note-editor.note-frame.fullscreen{left:70px}.aside-collapsed-text .summernote+.note-editor.note-frame.fullscreen{left:90px}.aside-float .summernote+.note-editor.note-frame.fullscreen{margin-left:30px}.topnavbar .navbar-header{background-image:none}}.topnavbar .navbar-nav>.open>a,.topnavbar .navbar-nav>li>.navbar-text,.topnavbar .navbar-nav>li>a{color:#6aa2b8}.topnavbar .navbar-nav>.open>a:focus,.topnavbar .navbar-nav>.open>a:hover,.topnavbar .navbar-nav>li>a:focus,.topnavbar .navbar-nav>li>a:hover{color:#3d6d7f}.topnavbar .navbar-nav>.active>a,.topnavbar .navbar-nav>.active>a:focus,.topnavbar .navbar-nav>.active>a:hover,.topnavbar .navbar-nav>.open>a,.topnavbar .navbar-nav>.open>a:focus,.topnavbar .navbar-nav>.open>a:hover{background-color:transparent}.topnavbar .navbar-nav>li>[data-toggle=navbar-search]{color:#fff}.topnavbar .nav-wrapper{background-color:#6aa2b8;background-image:linear-gradient(to right,#00d3ff 0,#053775 100%);background-repeat:repeat-x}@media only screen and (min-width:768px){.topnavbar{background-color:#6aa2b8;background-image:linear-gradient(to right,#00d3ff 0,#053775 100%);background-repeat:repeat-x}.topnavbar .navbar-nav>.open>a,.topnavbar .navbar-nav>.open>a:focus,.topnavbar .navbar-nav>.open>a:hover{box-shadow:0 -3px 0 rgba(255,255,255,.5) inset}.topnavbar .navbar-nav>.open>a,.topnavbar .navbar-nav>li>.navbar-text,.topnavbar .navbar-nav>li>a{color:#fff}.topnavbar .navbar-nav>.open>a:focus,.topnavbar .navbar-nav>.open>a:hover,.topnavbar .navbar-nav>li>a:focus,.topnavbar .navbar-nav>li>a:hover{color:#3d6d7f}}.sidebar{background-color:#3a3f51}.sidebar .nav-heading,.sidebar .nav>li>.nav-item,.sidebar .nav>li>a{color:#919da8}.sidebar .nav>li>.nav-item:focus,.sidebar .nav>li>.nav-item:hover,.sidebar .nav>li>a:focus,.sidebar .nav>li>a:hover{color:#6aa2b8}.sidebar .nav>li>.nav-item>em,.sidebar .nav>li>a>em{color:inherits}.sidebar .nav>li.active,.sidebar .nav>li.active .nav,.sidebar .nav>li.active>a,.sidebar .nav>li.open,.sidebar .nav>li.open .nav,.sidebar .nav>li.open>a{background-color:#383d4e;color:#6aa2b8}.sidebar .nav>li.active>a>em,.sidebar .nav>li.open>a>em{color:#6aa2b8}.sidebar .nav>li.active{border-left-color:#6aa2b8}.sidebar-subnav{background-color:#3a3f51}.sidebar-subnav>.sidebar-subnav-header,.sidebar-subnav>li>.nav-item,.sidebar-subnav>li>a{color:#919da8}.sidebar-subnav>li.active>.nav-item,.sidebar-subnav>li.active>a,.sidebar-subnav>li>.nav-item:focus,.sidebar-subnav>li>.nav-item:hover,.sidebar-subnav>li>a:focus,.sidebar-subnav>li>a:hover{color:#6aa2b8}.sidebar-subnav>li.active>.nav-item:after,.sidebar-subnav>li.active>a:after{border-color:#6aa2b8;background-color:#6aa2b8}.offsidebar{border-left:1px solid;background-color:#fff;color:#515253}.spirax-external{color:#910048}.spirax-internal{color:#053775}"]
            }] }
];
/** @nocollapse */
SizingSharedLibComponent.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/sizingModuleAccess/sizingModuleAccess.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SizingModuleAccessService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} moduleName
     * @return {?}
     */
    checkModuleAccess(moduleName) {
        return this.http.get(`./Api/Admin/CheckModuleAccess/${moduleName}`).map((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            // A sucessful response (200 OK) is what we're after
            return result;
        }), (/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            // Anything that's not 200, is an error
            return false;
        }));
    }
}
SizingModuleAccessService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
SizingModuleAccessService.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    SizingModuleAccessService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/routes.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RoutesService {
    /**
     * @param {?} messagesService
     */
    constructor(messagesService) {
        this.messagesService = messagesService;
        this.canDeactivatePending = false;
        this.pageLoading = true;
        this.pageLoadProgress = 0;
    }
    /**
     * Shows and hides the progress bar during RouterEvent changes
     * @param {?} event The router event.
     * @return {?}
     */
    navigationInterceptor(event) {
        if (event instanceof NavigationStart) {
            console.info("Navigation started..." + event.url);
            this.pageLoading = true;
            this.pageLoadProgress = 0;
            this.startPageLoadProgress();
        }
        if (event instanceof NavigationEnd) {
            console.info("Navigation ended...");
            this.pageLoading = false;
            // When navigation ends, check if the message queue is empty
            if (!!this.messagesService && !!this.messagesService.messages && this.messagesService.messages.length > 0) {
                // If there are any messages, discard them.
                this.messagesService.addMessage(null);
            }
        }
        // Set loading state to false in both of the below events to hide the progress bar in case a request fails
        if (event instanceof NavigationCancel) {
            console.info("Navigation canceled...");
            this.pageLoading = false;
            this.pageLoadProgress = 100;
        }
        if (event instanceof NavigationError) {
            console.warn("Navigation errored...");
            this.pageLoading = false;
            this.pageLoadProgress = 100;
        }
    }
    /**
     * Shows a progress loader when navigating between routes.
     * @return {?}
     */
    startPageLoadProgress() {
        /** @type {?} */
        const timeout = window.setTimeout((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const interval = window.setInterval((/**
             * @return {?}
             */
            () => {
                //debugger
                try {
                    if (this.pageLoadProgress === 100 || this.pageLoading === false) {
                        window.clearInterval(interval);
                        window.clearTimeout(timeout);
                        return;
                    }
                    //debugger
                    if (this.pageLoadProgress >= 100) {
                        this.pageLoadProgress = 100;
                        this.pageLoading = false;
                    }
                    else {
                        this.pageLoadProgress++;
                    }
                    // If the progress has reached its end or the page has finished loading, cancel the interval.
                }
                catch (err) {
                    console.log(`Progress bar - PageLoad() failed err=${err}`);
                    this.pageLoading = false;
                    //debugger;
                }
            }), 100);
        }), 100);
    }
    /**
     * @param {?} promise
     * @return {?}
     */
    registerUnresolvedPromise(promise) {
        this.unresolvedPromise = promise;
    }
    /**
     * @return {?}
     */
    removeUnresolvedPromise() {
        this.unresolvedPromise = null;
    }
    /**
     * @return {?}
     */
    getUnresolvedPromise() {
        return this.unresolvedPromise;
    }
}
RoutesService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
RoutesService.ctorParameters = () => [
    { type: MessagesService }
];
/** @nocollapse */ RoutesService.ngInjectableDef = ɵɵdefineInjectable({ factory: function RoutesService_Factory() { return new RoutesService(ɵɵinject(MessagesService)); }, token: RoutesService, providedIn: "root" });
if (false) {
    /** @type {?} */
    RoutesService.prototype.canDeactivatePending;
    /** @type {?} */
    RoutesService.prototype.pageLoading;
    /** @type {?} */
    RoutesService.prototype.pageLoadProgress;
    /** @type {?} */
    RoutesService.prototype.unresolvedPromise;
    /**
     * @type {?}
     * @private
     */
    RoutesService.prototype.messagesService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/sizingModuleAccess/sizingModuleAccess.guard.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * An authentication guard that decides if a child route can be activated.
 */
class SizingModuleAccessGuard {
    /**
     * @param {?} router
     * @param {?} sizingModuleAccess
     * @param {?} routesService
     * @param {?} authenticationService
     */
    constructor(router, sizingModuleAccess, routesService, authenticationService) {
        this.router = router;
        this.sizingModuleAccess = sizingModuleAccess;
        this.routesService = routesService;
        this.authenticationService = authenticationService;
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    canActivateChild(route, state) {
        /** @type {?} */
        var moduleName = route.data["moduleName"];
        return this.sizingModuleAccess.checkModuleAccess(moduleName).map((/**
         * @param {?} result
         * @return {?}
         */
        result => {
            /** @type {?} */
            let returnVal = result;
            if (returnVal === false) {
                console.warn(`Unauthorised access to: ${moduleName}`);
                /** @type {?} */
                const unauthorisedAlertPromise = swal__default("Unauthorised", "You are not authorised to access this module.", "error").then((/**
                 * @return {?}
                 */
                () => {
                    // Remove the unresolved promise
                    this.routesService.removeUnresolvedPromise();
                    //  redirect to login page with the return url and return false
                    this.router.navigate(['/home'], { queryParams: { returnUrl: '/home' } }); // not  { returnUrl: state.url } as it will be forbiden after next user login     
                }));
                // Register the alert promise
                this.routesService.registerUnresolvedPromise(unauthorisedAlertPromise);
            }
            return returnVal;
        })).catch((/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            return Observable.of(false);
        }));
    }
}
SizingModuleAccessGuard.decorators = [
    { type: Injectable }
];
/** @nocollapse */
SizingModuleAccessGuard.ctorParameters = () => [
    { type: Router },
    { type: SizingModuleAccessService },
    { type: RoutesService },
    { type: AuthenticationService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    SizingModuleAccessGuard.prototype.router;
    /**
     * @type {?}
     * @private
     */
    SizingModuleAccessGuard.prototype.sizingModuleAccess;
    /**
     * @type {?}
     * @private
     */
    SizingModuleAccessGuard.prototype.routesService;
    /**
     * @type {?}
     * @private
     */
    SizingModuleAccessGuard.prototype.authenticationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/sizingModuleAccess/sizingModuleAccess.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SizingModuleAccessModule {
}
SizingModuleAccessModule.decorators = [
    { type: NgModule, args: [{
                imports: [HttpClientModule],
                declarations: [],
                providers: [SizingModuleAccessService, SizingModuleAccessGuard],
                exports: []
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/module-preference/module-preference.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModulePreferenceService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
        // Exposed field and private subject for when preferences change.
        this.allModulePreferences = null;
        this.allModulePreferencesChange = new Subject();
        // Create a subscriber for when preferences change.
        this.allModulePreferencesChange.subscribe((/**
         * @param {?} modulePreferences
         * @return {?}
         */
        (modulePreferences) => {
            this.allModulePreferences = modulePreferences;
        }));
    }
    /**
     * Gets all Operating Company Module Preferences by Module Id.
     * @param {?} moduleId
     * @return {?}
     */
    getOperatingCompanyModulePreferences(moduleId) {
        return this.http.get(`./Api/Admin/GetOperatingCompanyModulePreferences/${moduleId}`).map((/**
         * @param {?} modulePreferences
         * @return {?}
         */
        (modulePreferences) => {
            if (modulePreferences == null) {
                return null;
            }
            // Publish the next set of changes to the subject.
            this.allModulePreferencesChange.next(modulePreferences);
            return modulePreferences;
        }));
    }
    /**
     * @param {?} preferenceName
     * @return {?}
     */
    getModulePreferenceByName(preferenceName) {
        if (this.allModulePreferences == null) {
            return null;
        }
        /** @type {?} */
        let specifiedPreference = this.allModulePreferences.find((/**
         * @param {?} o
         * @return {?}
         */
        o => o.name === preferenceName));
        return specifiedPreference;
    }
}
ModulePreferenceService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ModulePreferenceService.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /** @type {?} */
    ModulePreferenceService.prototype.allModulePreferences;
    /**
     * @type {?}
     * @private
     */
    ModulePreferenceService.prototype.allModulePreferencesChange;
    /**
     * @type {?}
     * @private
     */
    ModulePreferenceService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/module-preference/module-preference.resolver.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Resolves the route to include any user preferences.
 */
class ModulePreferenceResolver {
    /**
     * @param {?} modulePreferenceService
     */
    constructor(modulePreferenceService) {
        this.modulePreferenceService = modulePreferenceService;
        console.info("Instantiating module preference resolver...");
    }
    /**
     * @param {?} route
     * @return {?}
     */
    resolve(route) {
        // Get all preferences for the user.
        console.info(`Resolving preferences...`);
        // Get the moduleName.
        /** @type {?} */
        const param = this.getModuleId(route);
        /** @type {?} */
        var result = this.modulePreferenceService.getOperatingCompanyModulePreferences(param);
        return result;
    }
    /**
     * Gets the display group value from the current route.
     * @private
     * @param {?} route
     * @return {?}
     */
    getModuleId(route) {
        if (!!route.data && !!route.data['moduleId']) {
            return route.data['moduleId'];
        }
        else {
            for (let i = 0; i < route.children.length; i++) {
                /** @type {?} */
                const moduleId = this.getModuleId(route.children[i]);
                if (!!moduleId) {
                    return moduleId;
                }
            }
        }
    }
}
ModulePreferenceResolver.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ModulePreferenceResolver.ctorParameters = () => [
    { type: ModulePreferenceService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    ModulePreferenceResolver.prototype.modulePreferenceService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/preference/preference.resolver.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Resolves the route to include any user preferences.
 */
class PreferenceResolver {
    /**
     * @param {?} preferenceService
     */
    constructor(preferenceService) {
        this.preferenceService = preferenceService;
        console.info("Instantiating preference resolver...");
    }
    /**
     * @param {?} route
     * @return {?}
     */
    resolve(route) {
        // Get all preferences for the user.
        console.info(`Resolving preferences...`);
        return this.preferenceService.getAllPreferences();
    }
}
PreferenceResolver.decorators = [
    { type: Injectable }
];
/** @nocollapse */
PreferenceResolver.ctorParameters = () => [
    { type: PreferenceService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    PreferenceResolver.prototype.preferenceService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/messages/message.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The class used to display generic messages on a page.
 */
class Message {
}
if (false) {
    /**
     * Gets or sets the messageKey
     * @type {?}
     */
    Message.prototype.messageKey;
    /**
     * Gets or sets the value.
     * @type {?}
     */
    Message.prototype.value;
    /**
     * Gets or sets the unitId.
     * @type {?}
     */
    Message.prototype.unitKey;
    /**
     * Gets or sets the severity.
     * @type {?}
     */
    Message.prototype.severity;
    /** @type {?} */
    Message.prototype.displayValue;
    /** @type {?} */
    Message.prototype.additionalMessage;
    /** @type {?} */
    Message.prototype.filter;
    /** @type {?} */
    Message.prototype.eH_Gen4_Unit;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/http-interceptor/http-interceptor.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HttpInterceptorService {
    /**
     * @param {?} http
     * @param {?} inj
     * @param {?} localeService
     */
    constructor(http, inj, localeService) {
        this.http = http;
        this.inj = inj;
        this.localeService = localeService;
        this.messagesService = this.inj.get(MessagesService);
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    intercept(req, next) {
        console.info("Global HTTP request monitor fired");
        /** @type {?} */
        const userObj = JSON.parse(localStorage.getItem("userObj"));
        if (!!userObj) {
            /** @type {?} */
            const authToken = `${userObj["token_type"]} ${userObj["access_token"]}`;
            /** @type {?} */
            const modified = req.clone({ setHeaders: { 'Authorization': authToken, 'Pragma': 'no-cache' } });
            return next.handle(modified).map((/**
             * @param {?} event
             * @return {?}
             */
            (event) => {
                if (!!this.messagesService) {
                    event = this.handleResponseMap(event);
                }
                return event;
            }));
        }
        return next.handle(req);
    }
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    handleResponseMap(event) {
        if (event instanceof HttpResponse) {
            // Determine if the event contains the sizingResponseMessages object
            /** @type {?} */
            const response = (/** @type {?} */ (event));
            /** @type {?} */
            let isSizingResponseMessage = false;
            /** @type {?} */
            const responseMessages = [];
            if (response.body != null) {
                if (!!response.body["sizingResponseMessages"] && response.body.sizingResponseMessages.length > 0) {
                    isSizingResponseMessage = true;
                    // Enter the response messages into a service
                    for (let message of response.body.sizingResponseMessages) {
                        /** @type {?} */
                        const newMessage = new Message();
                        newMessage.messageKey = message.messageKey;
                        newMessage.severity = message.severity;
                        newMessage.value = message.value;
                        newMessage.unitKey = message.unitKey;
                        newMessage.displayValue = this.localizeValue(message.value);
                        responseMessages.push(newMessage);
                    }
                    // Once done remove the response messages from the body
                    delete response.body.sizingResponseMessages;
                }
                // Add the messages
                if (!!responseMessages && responseMessages.length > 0) {
                    this.messagesService.addMessage(responseMessages);
                }
                // Preserve the original response
                if (!!response.body["response"]) {
                    // If the response signature looks like this, but no processing of sizing response messages have been done,
                    // then the response is within a nested object and is best avoided.
                    if (!isSizingResponseMessage) {
                        console.warn("HTTP response contains a nested response object. It is recommended to remove the outer object for the sake of simplicity.");
                    }
                    return event.clone({
                        body: event.body.response,
                        headers: event.headers,
                        status: event.status,
                        statusText: event.statusText,
                        url: event.url
                    });
                }
            }
        }
        return event;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    localizeValue(value) {
        return this.localeService.formatDecimal(value.toFixed(2));
    }
}
HttpInterceptorService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
HttpInterceptorService.ctorParameters = () => [
    { type: HttpClient },
    { type: Injector },
    { type: LocaleService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    HttpInterceptorService.prototype.messagesService;
    /**
     * @type {?}
     * @private
     */
    HttpInterceptorService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    HttpInterceptorService.prototype.inj;
    /**
     * @type {?}
     * @private
     */
    HttpInterceptorService.prototype.localeService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/http-error.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HttpError {
}
HttpError.BadRequest = 400;
HttpError.Unauthorized = 401;
HttpError.Forbidden = 403;
HttpError.NotFound = 404;
HttpError.TimeOut = 408;
HttpError.Conflict = 409;
HttpError.InternalServerError = 500;
HttpError.BadGateway = 502;
if (false) {
    /** @type {?} */
    HttpError.BadRequest;
    /** @type {?} */
    HttpError.Unauthorized;
    /** @type {?} */
    HttpError.Forbidden;
    /** @type {?} */
    HttpError.NotFound;
    /** @type {?} */
    HttpError.TimeOut;
    /** @type {?} */
    HttpError.Conflict;
    /** @type {?} */
    HttpError.InternalServerError;
    /** @type {?} */
    HttpError.BadGateway;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/http-interceptor/http-interceptor.error.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ErrorInterceptor {
    /**
     * @param {?} _injector
     */
    constructor(_injector) {
        this._injector = _injector;
        this.messagesService = this._injector.get(MessagesService);
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    intercept(req, next) {
        /** @type {?} */
        let handled = false;
        this.request = req;
        return next.handle(req)
            .pipe(retry(0), catchError((/**
         * @param {?} returnedError
         * @return {?}
         */
        (returnedError) => {
            /** @type {?} */
            let errorMessage = null;
            if (returnedError) {
                if (returnedError.error instanceof ErrorEvent) {
                    errorMessage = `Error: ${returnedError.error.message}`;
                }
                else if (returnedError instanceof HttpErrorResponse) {
                    // errorMessage =  `Error Status ${returnedError.status} : ${returnedError.error} - ${returnedError.error.message}`;
                    handled = this.handleServerSideError(returnedError);
                }
            }
            console.log(errorMessage ? errorMessage : returnedError);
            if (!handled) {
                if (errorMessage) {
                    return throwError(errorMessage);
                }
                else {
                    if (returnedError) {
                        return throwError(returnedError);
                    }
                    return throwError(returnedError);
                }
            }
            else {
                return of(returnedError);
            }
        })));
    }
    /**
     * @private
     * @param {?} error
     * @return {?}
     */
    handleServerSideError(error) {
        /** @type {?} */
        let handled = false;
        /** @type {?} */
        const responseMessages = [];
        /** @type {?} */
        const logFormat = 'background: maroon; color: white';
        /** @type {?} */
        const newMessage = new Message();
        // ToDo: Translate messages if trans service data is available.
        // Could be problematic, add all MasterTextKeys to link table for all DisplayGroups
        // or accept "** Hard Coded Message Text **" as untranslated text output.
        /** @type {?} */
        const messageDefault = "Something went wrong. ";
        /** @type {?} */
        const messageSupport = "Please retry or refresh the browser. If the problem persists please contact Spirax Sarco support. ";
        /** @type {?} */
        const messageBadCredentials = "The user authentication credentials are not valid or have expired, please login. ";
        /** @type {?} */
        const messageBadConfiguration = "Software configuration error. ";
        /** @type {?} */
        const messageSoftwareError = "Software in error. ";
        newMessage.messageKey = messageDefault + messageSupport;
        newMessage.severity = 1;
        newMessage.value = 1;
        newMessage.unitKey = "";
        console.log('Error handling started..', logFormat);
        switch (error.status) {
            case HttpError.BadRequest:
                console.log('%c Bad Request 400', logFormat);
                handled = false;
                newMessage.displayValue = "The server responded with a 400 error for request - " + this.request.urlWithParams;
                //newMessage.messageKey = error.error[0];
                newMessage.messageKey = messageSoftwareError + messageSupport;
                break;
            case HttpError.Unauthorized:
                console.log('%c Unauthorized 401', logFormat);
                // window.location.href = '/login' + window.location.hash;
                handled = false;
                newMessage.messageKey = messageBadCredentials;
                break;
            case HttpError.NotFound:
                //show error toast message
                console.error('%c Not Found 404', logFormat);
                // const _toaster = this._injector.get(Toaster),
                //     _router = this._injector.get(Router);
                // _toaster.show({
                //     message: exception.error && exception.error.message ? exception.error.message :
                //         exception.statusText,
                //     typeId: 'error',
                //     isDismissable: true
                // });
                // swal("Not Found", error.error && error.error.message ? error.error.message :error.statusText,"error");
                //_router.navigate(['']);
                newMessage.displayValue = "The server responded with a 404 error for request - " + this.request.urlWithParams;
                handled = true;
                newMessage.messageKey = messageBadConfiguration + messageSupport;
                break;
            case HttpError.TimeOut:
                // Handled in AnalyticsExceptionHandler
                console.error('%c TimeOut 408', logFormat);
                newMessage.displayValue = "The server responded with a 408 error for request - " + this.request.urlWithParams;
                handled = true;
                newMessage.messageKey = messageSoftwareError + messageSupport;
                break;
            case HttpError.Forbidden:
                console.error('%c Forbidden 403', logFormat);
                handled = false;
                break;
            case HttpError.InternalServerError:
                console.error('%c big bad 500', logFormat);
                handled = true;
                newMessage.displayValue = "The server responded with a 500 error for request - " + this.request.urlWithParams;
                if (error.error && error.error.message && error.error.errorCode && error.error.errorCode === 4001) {
                    newMessage.messageKey = error.error.message;
                }
                else {
                    newMessage.messageKey = messageSoftwareError + messageSupport;
                }
                break;
            case HttpError.BadGateway:
                console.error('%c big bad 502', logFormat);
                // swal("Bad Gateway", error.error && error.error.message ? error.error.message :error.statusText,"error");
                newMessage.displayValue = "The server responded with a 502 error for request - " + this.request.urlWithParams;
                handled = true;
                newMessage.messageKey = messageBadConfiguration + messageSupport;
                break;
        }
        responseMessages.push(newMessage);
        this.messagesService.addMessage(responseMessages);
        return handled;
    }
}
ErrorInterceptor.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ErrorInterceptor.ctorParameters = () => [
    { type: Injector }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    ErrorInterceptor.prototype.messagesService;
    /**
     * @type {?}
     * @private
     */
    ErrorInterceptor.prototype.request;
    /**
     * @type {?}
     * @private
     */
    ErrorInterceptor.prototype._injector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/doc-gen/doc-gen.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// Create observable that holds two values
/** @type {?} */
const observable$ = from(['first', 'last']).pipe(publishReplay(1), refCount())
// First time subscribing, we get both values
;
// First time subscribing, we get both values
observable$.subscribe((/**
 * @param {?} data
 * @return {?}
 */
data => console.log(data)));
// Second time subscribing, we get the latest value
observable$.subscribe((/**
 * @param {?} data
 * @return {?}
 */
data => console.log(data)));
observable$.subscribe((/**
 * @param {?} data
 * @return {?}
 */
data => console.log(data)));
observable$.subscribe((/**
 * @param {?} data
 * @return {?}
 */
data => console.log(data)));
class DocGenService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} docGen
     * @return {?}
     */
    getPdf(docGen) {
        /** @type {?} */
        let options = {
            headers: {
                "Content-Type": "application/json", Accept: "application/octet-stream"
            },
            responseType: (/** @type {?} */ ('blob'))
        };
        return this.http.post(`./Api/DocGen/GetPdfSpecSheet`, docGen, options);
    }
    /**
     * @param {?} docGen
     * @return {?}
     */
    getCSGPdf(docGen) {
        /** @type {?} */
        let options = {
            headers: {
                "Content-Type": "application/json", Accept: "application/octet-stream"
            },
            responseType: (/** @type {?} */ ('json'))
        };
        this.http.post('./CSG/DocGen/CacheModel', docGen, options).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            /** @type {?} */
            var sessionId = response.sessionId;
            window.open('./CSG/DocGen/ReportViewer?id=' + sessionId);
        }));
        //return this.http.post(`../CSG/DocGen/CacheModel`, docGen, options);
    }
    /**
     * @param {?} docGen
     * @return {?}
     */
    getCSGFBPdf(docGen) {
        /** @type {?} */
        let options = {
            headers: {
                "Content-Type": "application/json", Accept: "application/octet-stream"
            },
            responseType: (/** @type {?} */ ('json'))
        };
        this.http.post('./CSGFB/DocGen/CacheModel', docGen, options).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            /** @type {?} */
            var sessionId = response.sessionId;
            window.open('./CSGFB/DocGen/ReportViewer?id=' + sessionId);
        }));
        //return this.http.post(`../CSG/DocGen/CacheModel`, docGen, options);
    }
    /**
     * @param {?} docGen
     * @return {?}
     */
    getSafetyValvePdf(docGen) {
        /** @type {?} */
        let options = {
            headers: {
                "Content-Type": "application/json", Accept: "application/octet-stream"
            },
            responseType: (/** @type {?} */ ('json'))
        };
        //this.http.post<any>('../SafetyValves/DocGen/CacheModel', docGen, options).subscribe(response => {
        this.http.post('SVDocGen/CacheModel', docGen, options).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            /** @type {?} */
            var sessionId = response.sessionId;
            window.open('SVDocGen/ReportViewer?id=' + sessionId);
        }));
    }
    /**
     * @param {?} url
     * @param {?} windowoption
     * @param {?} name
     * @param {?} params
     * @return {?}
     */
    OpenWindowWithPost(url, windowoption, name, params) {
        /** @type {?} */
        var form = document.createElement("form");
        form.setAttribute("method", "post");
        form.setAttribute("action", url);
        form.setAttribute("target", name);
        for (var i in params) {
            if (params.hasOwnProperty(i)) {
                /** @type {?} */
                var input = document.createElement('input');
                input.type = 'hidden';
                input.name = i;
                input.value = params[i];
                form.appendChild(input);
            }
        }
        document.body.appendChild(form);
        window.open("./SafetyValves/DocGen/ReportViewer", name, windowoption);
        form.submit();
        document.body.removeChild(form);
    }
    /**
     * @param {?} docGen
     * @return {?}
     */
    NewFile(docGen) {
        /** @type {?} */
        var param = docGen;
        // var param = { 'Guid': '1234' };
        this.OpenWindowWithPost("./SafetyValves/DocGen/ReportViewer", "width=730,height=345,left=100,top=100,resizable=yes,scrollbars=yes", "NewFile", param);
    }
    /**
     * @param {?} docGen
     * @return {?}
     */
    getExcel(docGen) {
        /** @type {?} */
        let options = {
            headers: {
                "Content-Type": "application/json", Accept: "application/octet-stream"
            },
            responseType: (/** @type {?} */ ('blob'))
        };
        return this.http.post(`./Api/DocGen/GetExcelSpecSheet`, docGen, options);
    }
    // ToDo: Awaiting final requirements
    /**
     * @param {?} tiRequest
     * @return {?}
     */
    getTiDocumentInfo(tiRequest) {
        return this.http.post(`./api/reports/TiDocgen/GetTiDocumentInfo`, tiRequest);
    }
    // ToDo: Awaiting final requirements
    /**
     * @param {?} apiPath
     * @return {?}
     */
    downloadFromAnyAPI(apiPath) {
        return this.http.get(apiPath, {
            headers: {
                "Content-Type": "application/json", Accept: "application/octet-stream",
                "Access-Control-Allow-Origin": "https://local-prsapps.spiraxsarco.com/",
                // Probably doesn't work?
                "Access-Control-Allow-Headers": "Content-Type"
            },
            responseType: 'blob'
        });
    }
    // ToDo: Awaiting final requirements
    /**
     * @param {?} tiDocumentInfo
     * @return {?}
     */
    getTiDocumentFile(tiDocumentInfo) {
        /** @type {?} */
        let options = {
            headers: {
                "Content-Type": "application/json", Accept: "application/octet-stream"
            },
            responseType: (/** @type {?} */ ('blob'))
        };
        return this.http.post(`./api/reports/TiDocgen/GetTiDocumentFile`, tiDocumentInfo, options);
    }
}
DocGenService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
DocGenService.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    DocGenService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/syncClient/syncClient.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SyncClientService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * Sync this users data.
     * @return {?}
     */
    syncUserData() {
        this.isSyncingUserData = true;
        /** @type {?} */
        var theResponseData = this.http.get(`./Api/User/SyncUserData`);
        return theResponseData;
    }
    /**
     * Sync Info for Projects And Jobs to transfer
     * @return {?}
     */
    projectsAndJobsSyncInfo() {
        return this.http.get(`./Api/User/SyncGetProjectsAndJobsInfo`);
    }
    /**
     * Sync Project And Job Data
     * @return {?}
     */
    projectsAndJobsSyncData() {
        this.isSyncingGetProjectsAndJobs = true;
        /** @type {?} */
        var theResponseData = this.http.get(`./Api/User/SyncProjectAndJobsData`);
        return (/** @type {?} */ ((theResponseData)));
    }
    /**
     * Sync Technical Information Data (download Tis by module)
     * @return {?}
     */
    technicalInformationSyncData() {
        this.isSyncingTechnicalInformation = true;
        /** @type {?} */
        var theResponseData = this.http.get(`./Api/User/SyncTechnicalInformationData`);
        return (/** @type {?} */ ((theResponseData)));
    }
}
SyncClientService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
SyncClientService.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /** @type {?} */
    SyncClientService.prototype.isSyncingUserData;
    /** @type {?} */
    SyncClientService.prototype.isSyncingGetProjectsAndJobs;
    /** @type {?} */
    SyncClientService.prototype.isSyncingTechnicalInformation;
    /**
     * @type {?}
     * @private
     */
    SyncClientService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/translation/translation.resolver.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TranslationResolver {
    /**
     * @param {?} translationService
     * @param {?} activatedRoute
     * @param {?} router
     */
    constructor(translationService, activatedRoute, router) {
        this.translationService = translationService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        console.info("Instantiating translation resolver...");
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    resolve(route, state) {
        // Get the display group.
        /** @type {?} */
        const param = this.getDisplayGroup(route);
        return this.translationService.getTranslatedDisplayGroup(!!param ? param : null);
    }
    /**
     * Gets the display group value from the current route.
     * @private
     * @param {?} route
     * @return {?}
     */
    getDisplayGroup(route) {
        if (!!route.data && !!route.data['displayGroup']) {
            return route.data['displayGroup'];
        }
        else {
            for (let i = 0; i < route.children.length; i++) {
                /** @type {?} */
                const displayGroup = this.getDisplayGroup(route.children[i]);
                if (!!displayGroup) {
                    return displayGroup;
                }
            }
        }
    }
}
TranslationResolver.decorators = [
    { type: Injectable }
];
/** @nocollapse */
TranslationResolver.ctorParameters = () => [
    { type: TranslationService },
    { type: ActivatedRoute },
    { type: Router }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    TranslationResolver.prototype.translationService;
    /**
     * @type {?}
     * @private
     */
    TranslationResolver.prototype.activatedRoute;
    /**
     * @type {?}
     * @private
     */
    TranslationResolver.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/global-error-handling/global-error-handler.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GlobalErrorHandler {
    /**
     * @param {?} injector
     * @param {?} zone
     * @param {?} authService
     * @param {?} location
     * @param {?} messagesService
     */
    constructor(injector, zone, authService, location, messagesService) {
        this.injector = injector;
        this.zone = zone;
        this.authService = authService;
        this.location = location;
        this.messagesService = messagesService;
        setTimeout((/**
         * @return {?}
         */
        () => this.router = injector.get(Router)));
    }
    /**
     * @param {?} error
     * @return {?}
     */
    handleError(error) {
        console.info("Global error handler hit");
        /** @type {?} */
        let rejection = (/** @type {?} */ (error));
        if (typeof rejection === "undefined") {
            rejection = (/** @type {?} */ (error["rejection"]));
        }
        /** @type {?} */
        let redirectToPage = "/500";
        /** @type {?} */
        let preventRedirection = false;
        if (!!rejection && !!rejection.status) {
            switch (rejection.status) {
                case 500: // Internal error
                    console.error(error);
                    break;
                case 400: // Validation failure
                    console.info("Validation failure");
                    preventRedirection = true;
                    if (!!rejection["error"] && ((/** @type {?} */ (rejection["error"])))) {
                        /** @type {?} */
                        var messages = (/** @type {?} */ (rejection["error"]));
                        // Ensure that this is an actual array of messages and not just a string (which can happen)
                        if (messages.length <= 0 || typeof messages[0] !== "object") {
                            // Regardless of whether or not messages is a string or even empty, error handling has not been processed correctly,
                            // so return a generic error message.
                            /** @type {?} */
                            var rejectionMessage = "";
                            // Get any rejection info
                            if (!!rejection["error"] && !!rejection["error"].message) {
                                rejectionMessage = rejectionMessage + rejection["error"].message;
                                console.info(`rejectionMessage: ${rejectionMessage}`);
                            }
                            if (!!messages) {
                                messages = [];
                            }
                            messages.push({ messageKey: "GENERIC_ERROR_MESSAGE", severity: 2, value: 0, unitKey: "", displayValue: rejectionMessage, additionalMessage: "" });
                        }
                        console.info(`Processing ${messages.length} messages.`);
                        // Ng Zone is mapped in because Angular's Global Error Handler is processed outside of a zone because,
                        // as with routing, Angular's error handling runs outside of change detection, so trigger it here manually
                        this.zone.run((/**
                         * @return {?}
                         */
                        () => {
                            this.messagesService.addMessage(messages);
                        }));
                    }
                    break;
                case 401: // Not authorised
                    this.authService.logoutUser();
                    redirectToPage = "/login";
                    break;
                case 403:
                    preventRedirection = true;
                    this.location.back();
                    swal__default("Forbidden", "Forbidden access", "error");
                    break;
                case 404: // URL not found
                    console.warn(`URL not found: ${rejection.url}`);
                    redirectToPage = "/404";
                    break;
                default:
            }
        }
        else {
            console.error(error);
        }
        // Ng Zone is mapped in because Angular's Global Error Handler is processed outside of a zone, meaning it loses track of any routing.
        if (preventRedirection === false) {
            this.zone.run((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const replaceUrl = redirectToPage === "/login";
                /** @type {?} */
                const skipLocationChange = redirectToPage !== "/login";
                this.router.navigate([redirectToPage], { replaceUrl: replaceUrl, skipLocationChange: skipLocationChange });
            }));
        }
    }
}
GlobalErrorHandler.decorators = [
    { type: Injectable }
];
/** @nocollapse */
GlobalErrorHandler.ctorParameters = () => [
    { type: Injector },
    { type: NgZone },
    { type: AuthenticationService },
    { type: Location },
    { type: MessagesService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    GlobalErrorHandler.prototype.router;
    /**
     * @type {?}
     * @private
     */
    GlobalErrorHandler.prototype.injector;
    /**
     * @type {?}
     * @private
     */
    GlobalErrorHandler.prototype.zone;
    /**
     * @type {?}
     * @private
     */
    GlobalErrorHandler.prototype.authService;
    /**
     * @type {?}
     * @private
     */
    GlobalErrorHandler.prototype.location;
    /**
     * @type {?}
     * @private
     */
    GlobalErrorHandler.prototype.messagesService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizing-shared-lib.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//import { FormsModule, ReactiveFormsModule } from '@angular/forms';
/** @type {?} */
const l10nConfig = {
    logger: {
        level: LogLevel.Warn
    }
};
class SizingSharedLibModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: SizingSharedLibModule,
            providers: [
                HttpInterceptorService,
                TranslationService,
                TranslationResolver,
                PreferenceService,
                PreferenceResolver,
                ModulePreferenceService,
                ModulePreferenceResolver,
                SyncClientService,
                MenuService,
                DocGenService,
                {
                    provide: HTTP_INTERCEPTORS,
                    useExisting: HttpInterceptorService,
                    multi: true
                },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: ErrorInterceptor,
                    multi: true
                },
                {
                    provide: ErrorHandler,
                    useClass: GlobalErrorHandler
                }
            ]
        };
    }
}
SizingSharedLibModule.decorators = [
    { type: NgModule, args: [{
                declarations: [SizingSharedLibComponent],
                imports: [HttpClientModule,
                    // AdminModule,
                    BrowserModule, CoreModule, SharedModule,
                    // RouterModule,
                    // SizingModuleModule,
                    MessagesModule, LocalizationModule.forRoot(l10nConfig),
                    LocaleValidationModule.forRoot(), SizingModuleAccessModule, SizingSuiteModalModule
                ],
                exports: [SizingSharedLibComponent, AuthenticationModule,
                    CoreModule, SharedModule,
                    //SizingModuleModule,
                    //RouterModule,
                    SizingModuleAccessModule, SizingSuiteModalModule],
                bootstrap: [SizingSharedLibComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/projects-jobs/projects-jobs.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProjectsJobsComponent {
    /**
     * @param {?} projectsJobsService
     * @param {?} fb
     * @param {?} translatePipe
     * @param {?} sharedService
     * @param {?} authenticationService
     * @param {?} syncClientService
     * @param {?} cdRef
     */
    constructor(projectsJobsService, fb, translatePipe, sharedService, authenticationService, syncClientService, cdRef) {
        //this.getProjectsAndJobsData();
        this.projectsJobsService = projectsJobsService;
        this.fb = fb;
        this.translatePipe = translatePipe;
        this.sharedService = sharedService;
        this.authenticationService = authenticationService;
        this.syncClientService = syncClientService;
        this.cdRef = cdRef;
        this.cloneDeep = cloneDeep_;
        this.projects = [];
        this.jobs = [];
        this.selectedProject = new Project();
        this.selectedProjectIndex = 0;
        this.industryEnumerationName = "";
        this.areProjectsAndJobsLoaded = false;
        this.isSuccess = false;
        this.alertVisible = false;
        this.formSubmitted = false;
        this.editingProject = false;
        this.editingJob = false;
        this.rowsSel = [];
        this.selected = [];
        this.theFormGroup = this.projectsForm; // to drive GenericChangesGuard
        // Initialise Form controls
        this.projectName = new FormControl('', [Validators.required]);
        this.customerName = new FormControl('');
        this.projectReference = new FormControl('');
        this.customerLocation = new FormControl('');
        this.quoteReference = new FormControl('');
        this.tradeEnum = new FormControl('');
        this.industryEnum = new FormControl('');
        this.created = new FormControl('');
        // Initialise Form Group
        this.projectsForm = this.fb.group({
            projectName: this.projectName,
            customerName: this.customerName,
            projectReference: this.projectReference,
            customerLocation: this.customerLocation,
            quoteReference: this.quoteReference,
            tradeEnum: this.tradeEnum,
            industryEnum: this.industryEnum,
            created: this.created,
        }, { updateOn: "change" });
        this.theFormGroup = this.projectsForm; // to drive GenericChangesGuard
        // Listen to jobsForm isDirty changes to signal parent via event emitter that this component is in 'edit' mode.
        // This is the current mechanism for detecting a user has edited the form, otherwise we need a button to enter edit mode.
        this.projectsForm.valueChanges.subscribe((/**
         * @param {?} value
         * @return {?}
         */
        (value) => {
            if (this.projectsForm.dirty && !this.projectName.disabled && !this.editingProject) {
                console.log('projectsForm dirty - yes: ', value);
                //this.editingProjectDataOnChange.emit(true);
                this.editingProject = true;
            }
        }));
        // subject subscription, update as service data has changed (probably changed in memory)
        this.projectsJobsService.projectJobsChange.subscribe((/**
         * @return {?}
         */
        () => {
            this.getSubjectUpdatedProjectsAndJobsData();
        }));
    }
    /**
     * @return {?}
     */
    get projectsAndJobsBackingData() {
        return this.projectsJobsService.projectsJobs;
    }
    /**
     * @param {?} projectsAndJobs
     * @return {?}
     */
    set projectsAndJobsBackingData(projectsAndJobs) {
        this.projectsJobsService.projectsJobs = projectsAndJobs;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.getProjectsAndJobsData(); // first get data
        if (this.authenticationService.authenticatedUser.clientMode) {
            this.getProjectsAndJobsSyncInfo();
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    editingJobDataOnChange($event) {
        console.log(`editingJobDataOnChange: event:${event}`);
        this.editingJob = $event;
        // editingJob signalled and handle no projects situtation.    
        if (this.editingJob || (!!this.projectsAndJobsBackingData.projects && this.projectsAndJobsBackingData.projects.length <= 0)) {
            this.disableFormInputControls();
            // handle no projects and no jobs situation when loaded
            if (this.editingJob && !!this.projectsAndJobsBackingData.projects && this.projectsAndJobsBackingData.projects.length > 0) {
                this.hasUnsavedDataChanges = true; // to drive GenericChangesGuard    
            }
        }
        else {
            this.enableFormInputControls();
            this.hasUnsavedDataChanges = false; // to drive GenericChangesGuard
        }
    }
    /**
     * @return {?}
     */
    getProjectsAndJobsData() {
        this.areProjectsAndJobsLoaded = false;
        this.projectsJobsService.getProjectsAndJobs().subscribe((/**
         * @return {?}
         */
        () => {
            // Inform the view that areProjectsAndJobs are now loaded.
            this.areProjectsAndJobsLoaded = true;
            this.selectedProjectIndex = 0;
        }));
    }
    /**
     * @return {?}
     */
    getSubjectUpdatedProjectsAndJobsData() {
        if (!this.projectsAndJobsBackingData.projects) {
            this.projectsAndJobsBackingData.projects = [];
        }
        else {
            this.projects = this.cloneDeep(this.projectsAndJobsBackingData.projects);
        }
        if (!this.projects) {
            this.projects = [];
        }
        // Inform the view that areProjectsAndJobs are now loaded.
        this.areProjectsAndJobsLoaded = true;
        this.setupCleanSelectedProject(this.selectedProjectIndex);
    }
    /**
     * Set the form controls for the currently selected project
     * @param {?} projectIndex
     * @return {?}
     */
    setupCleanSelectedProject(projectIndex) {
        if (!this.areProjectsAndJobsLoaded && !this.editingProject && !this.projectsForm.dirty) {
            return;
        }
        this.selectedProjectIndex = projectIndex;
        this.projectsForm.reset();
        // Set requested project on the form control, if it exists.
        if (!!this.projects && !!this.projects[projectIndex] && projectIndex > -1) {
            this.selectedProject = this.projects[projectIndex];
            this.tradeEnum.setValue(this.selectedProject.tradeEnum);
            this.industryEnumerationName = this.sharedService.getIndustryEnumNameForProvidedTrade(this.selectedProject.tradeEnum.toString()); // setup the Industry Enumeration based on selected Trade Enumeration value.
            this.projectName.setValue(this.selectedProject.name);
            this.customerName.setValue(this.selectedProject.customerName);
            this.projectReference.setValue(this.selectedProject.projectReference);
            this.customerLocation.setValue(this.selectedProject.customerLocation);
            this.quoteReference.setValue(this.selectedProject.quoteReference);
            this.created.setValue(this.selectedProject.created);
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.industryEnum.setValue(this.selectedProject.industryEnum.toString());
                this.enableFormInputControls();
                this.projectsForm.markAsPristine();
                this.hasUnsavedDataChanges = false;
                this.editingProject = false;
            }), 100);
        }
        else {
            // Clear and disable UI form controls
            this.selectedProject = new Project();
            this.projectName.setValue("");
            this.customerName.setValue("");
            this.projectReference.setValue("");
            this.customerLocation.setValue("");
            this.quoteReference.setValue("");
            this.tradeEnum.setValue("-1");
            this.industryEnumerationName = this.sharedService.getIndustryEnumNameForProvidedTrade("-1"); // setup the Industry Enumeration based on selected Trade Enumeration value.      
            this.created.setValue(new Date().toLocaleDateString());
            this.disableFormInputControls();
        }
        // Set UI selected item
        this.selected.splice(0, this.selected.length);
        this.selected.push(this.selectedProject);
        this.projectsForm.markAsPristine();
        this.hasUnsavedDataChanges = false; // reset flags
        this.editingProject = false; // Important to set this here!
    }
    /**
     * Disable the Form input Controls
     * @return {?}
     */
    disableFormInputControls() {
        this.projectName.disable();
        this.customerName.disable();
        this.projectReference.disable();
        this.customerLocation.disable();
        this.quoteReference.disable();
        this.tradeEnum.disable();
        this.industryEnum.disable();
        this.created.disable();
    }
    /**
     * Enable the Form input Controls
     * @return {?}
     */
    enableFormInputControls() {
        this.projectName.enable();
        this.customerName.enable();
        this.projectReference.enable();
        this.customerLocation.enable();
        this.quoteReference.enable();
        this.tradeEnum.enable();
        this.industryEnum.enable();
        this.created.enable();
    }
    /**
     * Add New Project Setup
     * @return {?}
     */
    newProject() {
        console.log("newProject()");
        // block new if already have a new project or
        // ToDo: block an edited project
        if (this.editingProject) {
            console.log("blocked, already editingProject...");
            return;
        }
        /** @type {?} */
        let newProject = new Project();
        newProject.jobs = [];
        newProject.id = "";
        newProject.tradeEnum = 8;
        newProject.industryEnum = 8;
        if (!this.projectsAndJobsBackingData.projects) {
            this.projectsAndJobsBackingData.projects = [];
        }
        this.projectsAndJobsBackingData.projects.push(newProject);
        this.projects.push(newProject);
        this.selectedProjectIndex = this.projects.length - 1;
        this.setupCleanSelectedProject(this.selectedProjectIndex); // also sets editingProject = false 
        this.projectNameInput.nativeElement.focus();
        //this.cdRef.detectChanges();
        this.editingProject = true; // Set last for correct editing mode!
        //debugger;
        //this.cdRef.detectChanges();
    }
    /**
     * Cancel data edits for newly added project or revert any UI edits.
     * @return {?}
     */
    cancelEditsForProject() {
        console.log("cancelEditsForProject()");
        //ToDo: Any edits? warn user before data purge.
        //this.editingProject = true;
        this.editingProject = false;
        //debugger;
        ////this.cdRef.detectChanges();
        if (!this.selectedProject.id || this.selectedProject.id.toString() === "") { //this.editingProject) {
            // Remove edited new project
            console.log("Canceled new project edits!");
            this.projectsAndJobsBackingData.projects.pop();
            this.projects.pop();
            this.selectedProjectIndex = 0;
            this.setupCleanSelectedProject(this.selectedProjectIndex);
        }
        else if (this.projectsForm.dirty) {
            // Cancel/revert existing edited Project data
            this.setupCleanSelectedProject(this.selectedProjectIndex);
        }
        //this.editingProject = true; 
        //this.editingProject = false;
    }
    /**
     * Checks and Submits the form for saving to the server.
     * @param {?} projectName
     * @param {?} projectId
     * @return {?}
     */
    checkProjectNameDuplication(projectName, projectId) {
        console.log("checkProjectNameDuplication()");
        if (this.projectsAndJobsBackingData.projects.find((/**
         * @param {?} x
         * @return {?}
         */
        x => x.name === projectName && projectId === ''))) {
            /** @type {?} */
            const title = this.translatePipe.transform('DUPLICATE_PROJECT_NAME', true);
            /** @type {?} */
            const text = this.translatePipe.transform('A_PROJECT_WITH_THE_SAME_NAME_ALREADY_EXISTS_CLICK_YES_TO_SAVE_ANYWAY_OR_NO_TO_CHANGE_THE_NAME_OF_THE_PROJECT_YOU_ARE_SAVING_MESSAGE', true);
            /** @type {?} */
            const saveDuplicateProject = this.translatePipe.transform('YES', true);
            /** @type {?} */
            const noButtonText = this.translatePipe.transform('NO', true);
            return swal({
                title: title,
                text: text,
                icon: "warning",
                dangerMode: true,
                buttons: [saveDuplicateProject, noButtonText]
            }).then((/**
             * @param {?=} discardChanges
             * @return {?}
             */
            (discardChanges) => {
                // The parameter can also enter as null
                /** @type {?} */
                const returnVal = !(discardChanges === null);
                if (!returnVal) {
                    // Go ahead and save anyway
                    console.log("Saving Project with duplicated name.");
                    this.updateInsertProject();
                }
            }));
        }
        else {
            this.updateInsertProject();
        }
    }
    /**
     * @return {?}
     */
    updateInsertProject() {
        console.log(`updateInsertProject`);
        // Mark the form as submitted.
        this.formSubmitted = true;
        this.getProjectFormData();
        // Save project data, Insert or Update?
        if (this.selectedProject.id === "") {
            this.projectsJobsService.insertProject(this.selectedProject).subscribe((/**
             * @param {?} insertedProjectData
             * @return {?}
             */
            insertedProjectData => {
                this.selectedProject = insertedProjectData.project;
                if (!this.selectedProject.jobs) {
                    this.selectedProject.jobs = [];
                }
                this.projectsAndJobsBackingData.projects[this.projectsAndJobsBackingData.projects.length - 1] = this.selectedProject; // update inserted project data
                this.projects[this.selectedProjectIndex] = this.selectedProject; // change UI row data
                // Refresh UI grid
                this.table.rows = this.projects;
                // Select page
                this.table.offset = this.selectedProjectIndex / this.table.limit;
                // The form can be submitted again.
                this.formSubmitted = false;
                // Set the operation based on the response.
                this.isSuccess = insertedProjectData.succeeded;
                this.alertVisible = true;
                this.editingProject = false;
                //debugger;
                ////this.cdRef.detectChanges();
                // Select last/newly added project
                this.setupCleanSelectedProject(this.projects.length - 1);
                this.projectsJobsService.signalProjectsAndJobsDataHasChanged(this.projectsAndJobsBackingData); // send change event to all subject subcribers
            }));
        }
        else {
            this.projectsJobsService.updateProject(this.selectedProject).subscribe((/**
             * @param {?} updatedProjectData
             * @return {?}
             */
            (updatedProjectData) => {
                // Preserve any existing job data
                /** @type {?} */
                let preservedJobs = this.cloneDeep(this.selectedProject.jobs);
                this.selectedProject = updatedProjectData.project;
                this.selectedProject.jobs = preservedJobs;
                this.projectsAndJobsBackingData.projects[this.selectedProjectIndex] = this.selectedProject; // set the changed data to the master projects data
                this.projects[this.selectedProjectIndex] = this.selectedProject; // change UI row data
                // Refresh UI grid
                this.table.rows = this.projects;
                // Select page
                this.table.offset = this.selectedProjectIndex / this.table.limit;
                // The form can be submitted again.
                this.formSubmitted = false;
                // Set the operation based on the response.
                this.isSuccess = updatedProjectData.succeeded;
                this.alertVisible = true;
                this.setupCleanSelectedProject(this.selectedProjectIndex);
                this.projectsJobsService.signalProjectsAndJobsDataHasChanged(this.projectsAndJobsBackingData); // send change event to all subject subcribers
                //this.editingProject = true; // toggle to force change
                this.editingProject = false;
                //debugger;
                ////this.cdRef.detectChanges();
            }));
        }
    }
    /**
     * Delete currently selected project
     * @return {?}
     */
    deleteProject() {
        console.log("deleteProject()");
        //Both of these if statements below prevent the project from being deleted.
        //Commented out in order to fix issue 3838.
        //Confirmation box for when user deletes.
        //if (!this.selectedProject.id) {
        //  console.log("deleteProject() but no project id? Do nothing.");
        //  return;
        //}
        // ToDo: Test jobs exist, delete all jobs or let user delete them first?
        //if (!this.selectedProject.jobs || this.selectedProject.jobs.length > 0) {
        //  console.log("deleteProject() but jobs exist? Do nothing.");
        //  return;
        //}
        this.projectsJobsService.deleteProject(this.selectedProject).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            if (response) {
                /** @type {?} */
                let indexToDelete = this.projects.indexOf(this.selectedProject);
                // ToDo: Delete project from UI, move to first/previous/blank project?
                // Removeproject from list
                this.projectsAndJobsBackingData.projects.splice(indexToDelete, 1);
                // Refresh UI grid
                this.table.rows = this.projects.splice(indexToDelete, 1);
                // Select page
                this.table.offset = this.selectedProjectIndex / this.table.limit;
                if (this.projectsAndJobsBackingData.projects.length > 0 ||
                    this.projectsAndJobsBackingData.projects.length <= this.selectedProjectIndex) {
                    if (this.projectsAndJobsBackingData.projects.length <= this.selectedProjectIndex) { // if we deleted the last project
                        this.selectedProjectIndex = this.projectsAndJobsBackingData.projects.length - 1;
                    }
                }
                else {
                    this.selectedProjectIndex = -1;
                }
                // The form can be submitted again.
                this.formSubmitted = false;
                //this.alertVisible = true;
                this.editingProject = false;
                //debugger;
                ////this.cdRef.detectChanges();        
                this.setupCleanSelectedProject(this.selectedProjectIndex);
                this.projectsJobsService.signalProjectsAndJobsDataHasChanged(this.projectsAndJobsBackingData); // send change event to all subject subcribers
            }
            else {
                //failed!
            }
        }));
    }
    /**
     * Set th Industrial Enumeration Name dependant on the selected Trade Enumeration definition. (switch to new list)
     * @param {?} event
     * @return {?}
     */
    handleTradeEnumChanging(event) {
        console.info(`TradeEnum change notified, event:${event}`);
        // Load the corresponding Industry Enumeration list into the <Enumeration> control
        this.sharedService.getIndustryEnumNameForProvidedTrade(event);
    }
    /**
     * Load next project in the UI project data (respecting sort order)
     * @return {?}
     */
    loadNextProject() {
        console.log("loadNextProject()");
        if (this.selectedProjectIndex < this.projects.length - 1) {
            this.setupCleanSelectedProject(this.projects.indexOf(this.selectedProject) + 1);
            // Refresh UI grid
            this.table.rows = this.projects;
            // Select page
            this.table.offset = this.selectedProjectIndex / this.table.limit;
        }
    }
    /**
     * Load previous project in the UI project data (respecting sort order)
     * @return {?}
     */
    loadPreviousProject() {
        console.log("loadPreviousProject()");
        if (this.selectedProjectIndex > 0) {
            this.setupCleanSelectedProject(this.projects.indexOf(this.selectedProject) - 1);
            // Refresh UI grid
            this.table.rows = this.projects;
            // Select page
            this.table.offset = this.selectedProjectIndex / this.table.limit;
        }
    }
    /**
     * Data table selection changed
     * @param {?} __0
     * @return {?}
     */
    onSelect({ selected }) {
        console.log('Select Event', selected, this.selected);
        // If editingProject/changing data then don't move away from the currently selected project
        if (this.editingProject || this.editingJob || this.projectsForm.dirty) {
            selected = this.selectedProject;
            // Refresh UI grid
            this.table.rows = this.projects;
            // Select page
            this.table.offset = this.selectedProjectIndex / this.table.limit;
            return;
        }
        if (!this.editingProject && !this.editingJob && !this.projectsForm.dirty) {
            this.setupCleanSelectedProject(this.projects.indexOf(selected[0])); // also sets the Selected project array
        }
    }
    /**
     * Data table events
     * @param {?} event
     * @return {?}
     */
    onActivate(event) {
        //console.log('Activate Event', event);
        // If editingProject/changing data then don't move away from the currently selected project
        if (this.editingProject || this.editingJob || this.projectsForm.dirty) {
            // Refresh UI grid
            this.table.rows = this.projects;
            // Select page
            this.table.offset = this.selectedProjectIndex / this.table.limit;
            return;
        }
        // handle arrow key change for selected project
        if (event.type === "keydown" && event.event.code === "ArrowDown") {
            this.loadNextProject();
        }
        if (event.type === "keydown" && event.event.code === "ArrowUp") {
            this.loadPreviousProject();
        }
    }
    /**
     * @param {?} componentRef
     * @return {?}
     */
    onDeactivate(componentRef) {
        console.info(`Deactivating`);
    }
    /**
     * Handle paging
     * @param {?} event
     * @return {?}
     */
    onPage(event) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout((/**
         * @return {?}
         */
        () => {
            console.log('paged!', event);
        }), 100);
        // If editingProject/changing data then don't move away from the currently selected project
        if (this.editingProject || this.editingJob || this.projectsForm.dirty) {
            // Refresh UI grid
            this.table.rows = this.projects;
            // Select page
            this.table.offset = this.selectedProjectIndex / this.table.limit;
            return;
        }
        /** @type {?} */
        var indexOfPageTopProject = event.pageSize * event.offset;
        this.setupCleanSelectedProject(indexOfPageTopProject);
    }
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    onPaginated(event) {
        //this.table.limit = this._limitNumber;
        this.table.recalculate();
    }
    /**
     * Updates the filteed rows on UI data grid.
     * @param {?} event
     * @return {?}
     */
    updateFilter(event) {
        /** @type {?} */
        const val = event.target.value.toLowerCase();
        // filter our data
        /** @type {?} */
        const rowsFiltered = this.projectsAndJobsBackingData.projects.filter((/**
         * @param {?} d
         * @return {?}
         */
        function (d) {
            // Test if the Name  is like the filter text
            if (!!d.name) {
                if (d.name.toLowerCase().indexOf(val) !== -1 || !val) {
                    return true;
                }
            }
            if (!!d.projectReference) {
                if (d.projectReference.toLowerCase().indexOf(val) !== -1 || !val) {
                    return true;
                }
            }
            if (!!d.quoteReference) {
                if (d.quoteReference.toLowerCase().indexOf(val) !== -1 || !val) {
                    return true;
                }
            }
            if (!!d.customerName) {
                if (d.customerName.toLowerCase().indexOf(val) !== -1 || !val) {
                    return true;
                }
            }
            if (!!d.customerLocation) {
                if (d.customerLocation.toLowerCase().indexOf(val) !== -1 || !val) {
                    return true;
                }
            }
        }));
        // update the rows
        this.projects = rowsFiltered;
        // Whenever the filter changes, always go back to the first page
        this.table.offset = 0;
        this.selectedProjectIndex = 0;
        this.setupCleanSelectedProject(this.selectedProjectIndex);
    }
    /**
     * Get the Project data Form the input Controls
     * @return {?}
     */
    getProjectFormData() {
        /** @type {?} */
        const projectName = this.projectsForm.controls["projectName"];
        this.selectedProject.name = projectName.value;
        /** @type {?} */
        const customerName = this.projectsForm.controls["customerName"];
        this.selectedProject.customerName = customerName.value;
        /** @type {?} */
        const projectReference = this.projectsForm.controls["projectReference"];
        this.selectedProject.projectReference = projectReference.value;
        /** @type {?} */
        const customerLocation = this.projectsForm.controls["customerLocation"];
        this.selectedProject.customerLocation = customerLocation.value;
        /** @type {?} */
        const quoteReference = this.projectsForm.controls["quoteReference"];
        this.selectedProject.quoteReference = quoteReference.value;
        /** @type {?} */
        const tradeEnum = this.projectsForm.controls["tradeEnum"];
        this.selectedProject.tradeEnum = tradeEnum.value;
        /** @type {?} */
        const industryEnum = this.projectsForm.controls["industryEnum"];
        this.selectedProject.industryEnum = industryEnum.value;
        if (!!this.selectedProject.tradeEnum) {
            // if TradeEnum = 8 (None) the IndustryEnum must also be 8 (None)
            if (this.selectedProject.tradeEnum.toString() === "8" || this.selectedProject.industryEnum.toString() === "") {
                this.selectedProject.industryEnum = 8;
            }
        }
    }
    /**
     * Event that is called when the selected trade value is changed.
     * @param {?} event
     * @return {?}
     */
    onTradeChange(event) {
        /** @type {?} */
        const industry = this.sharedService.getIndustryEnumNameForProvidedTrade(event.selectedValue);
        if (this.industryEnumerationName !== industry) {
            // Set an initial value for the industry enum form value
            this.projectsForm.controls["industryEnum"].setValue(null);
            this.industryEnumerationName = industry;
        }
    }
    /**
     * @return {?}
     */
    closeAlert() {
        // Reset the flag
        this.alertVisible = false;
    }
    /**
     * @return {?}
     */
    modalCallbackCancel() {
        console.log("Modal cancel button, do nothing!");
    }
    /**
     * @return {?}
     */
    modalCallbackOk() {
        console.log("Oh look, it's OK'd without this function calling anything!!");
    }
    /**
     * @return {?}
     */
    getProjectsAndJobsSyncInfo() {
        // Only get P&J sync info if this is a client implmentation
        if (!this.authenticationService.authenticatedUser.clientMode) {
            return;
        }
        this.syncClientService.projectsAndJobsSyncInfo().subscribe((/**
         * @param {?} projectsAndJobsSyncInfoResponse
         * @return {?}
         */
        (projectsAndJobsSyncInfoResponse) => {
            if (!!projectsAndJobsSyncInfoResponse && projectsAndJobsSyncInfoResponse.isSuccessful) {
                this.projectsAndJobsSyncInfo = projectsAndJobsSyncInfoResponse;
                this.hasUnsavedDataChanges = false; // reset flags
            }
            else {
                // ToDo: sync failed!
                //this.handleSyncFailure();
            }
        }), (
        // Error callback
        /**
         * @param {?} err
         * @return {?}
         */
        err => {
            // ToDo: sync failed!
            console.log(err.error);
            //this.handleSyncFailure();
        }));
    }
}
ProjectsJobsComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-projects-jobs',
                template: "<form [formGroup]=\"projectsForm\" class=\"form-horizontal\" role=\"form\" novalidate>\r\n  <div class='panel panel-primary' *ngIf=\"!!areProjectsAndJobsLoaded\">\r\n    <div class='panel-body'>\r\n      <div class=\"row\">\r\n\r\n        <div class=\"col-xs-12\">\r\n          <h4>{{\"PROJECTS\" | translate}}</h4>\r\n          <hr />\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-3 col-xs-12\">\r\n\r\n          <div class=\"form-group\">\r\n            <p class=\"text-center pv \" style=\"font-weight: bolder; color: red; text-wrap: avoid\" *ngIf=\"!!projectsAndJobsSyncInfo && projectsAndJobsSyncInfo.isSuccessful && (projectsAndJobsSyncInfo.numberOfServerSizingsToDownload > 0 || projectsAndJobsSyncInfo.numberOfClientSizingsToUpload > 0)\">{{'AWAITING_SYNC' | translate}} - {{projectsAndJobsSyncInfo.numberOfServerSizingsToDownload}} {{'JOBS_TO_DOWNLOAD_FROM_SERVER' | translate}}, {{projectsAndJobsSyncInfo.numberOfClientSizingsToUpload}} {{'JOBS_TO_UPLOAD_FROM_CLIENT' | translate}}</p>\r\n            <div class=\"col-xs-3\">\r\n              <label class=\"control-label\">{{\"FILTER\" | translate:true}}</label>\r\n            </div>\r\n            <div class=\"col-xs-6\">\r\n              <input autocomplete=\"off\" [disabled]=\"editingJob\" type='text' title=\"{{'TYPE_TO_FILTER' | translate:true}}\" class=\"form-control\" placeholder=\"{{'TYPE_TO_FILTER' | translate:true}}...\" (keyup)='updateFilter($event)'/>\r\n            </div>\r\n          </div>\r\n          \r\n        </div>\r\n        \r\n        <div class=\"col-md-6 col-xs-12\">\r\n          <button id=\"newProject\" [disabled]=\"editingProject || editingJob || projectsForm.dirty\" class=\"btn btn-projects btn-primary pull-left\" (click)=\"newProject()\" [title]=\"'ADD_NEW_PROJECT' | translate\"><p id=\"noMargins\"><i class=\"fa fa-plus\">  </i> {{'ADD_NEW_PROJECT' | translate}}</p></button>\r\n          <button id=\"saveProject\" [disabled]=\"editingJob || !projectsForm.dirty || !projectsForm.valid || projectsForm.status !== 'VALID' || formSubmitted\" class=\"btn btn-projects btn-primary pull-left\" (click)=\"checkProjectNameDuplication(projectName.value,selectedProject.id)\" [title]=\"'SAVE_PROJECT' | translate\"><p id=\"noMargins\"><i class=\"fa fa-save\"></i> {{'SAVE_PROJECT' | translate}}</p></button>\r\n          <button id=\"cancelEditProject\" [disabled]=\"(!editingProject && !projectsForm.dirty) || editingJob\" class=\"btn btn-projects btn-primary pull-left\" (click)=\"(projectsForm.dirty && projectsForm.valid)? saveChangesModal.open() : cancelEditsForProject()\" [title]=\"'CANCEL' | translate\"><p id=\"noMargins\"><i class=\"fa fa-times\"></i> {{'CANCEL' | translate}}</p></button>\r\n          <button id=\"deleteProject\" [disabled]=\"editingProject || editingJob || projectsForm.dirty || !this.selectedProject.jobs \" class=\"btn btn-projects btn-primary pull-left\" (click)=\"delteConfirmationModal.open()\" [title]=\"'DELETE_PROJECT' | translate\"><p id=\"noMargins\"><i class=\"fa fa-trash\"></i> {{'DELETE_PROJECT' | translate}}</p></button>\r\n          <!-- projectsAndJobsSyncInfo -->\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <!-- Left section -->\r\n        <div class=\"col-md-3 col-xs-12\">\r\n          <!-- If User starts editing the project form, then mark \"projectsForm.dirty\" and load disabled Projects List (code below) other wise load active Projects List from code section that starts at line 54+- ) -->\r\n          <!-- Note that rowIndex is not sort safe, use rows[rows.indexOf(row)] for the real index of the row data. -->\r\n          <ngx-datatable *ngIf=\"projectsForm.dirty\" class=\"bootstrap\" style=\"opacity: 0.4; pointer-events:none; font-size: larger; font-weight: lighter\" [selected]=\"selected\" [selectionType]=\"'singleClick'\" (activate)=\"onActivate($event)\" (select)=\"onSelect($event)\" [headerHeight]=\"40\" [limit]=\"6\" [columnMode]=\"'force'\" [footerHeight]=\"60\" [rowHeight]=\"'auto'\" [rows]=\"projects\" (page)=\"onPage($event)\" [messages]=\"{emptyMessage: translatePipe.transform('NO_DATA_TO_DISPLAY', true), totalMessage: translatePipe.transform('TOTAL', true), selectedMessage: false}\" #projectsTable>\r\n            <ngx-datatable-column class=\"\" headerClass=\"text-bold\" style=\"\" name=\"{{'PROJECT_NAME' | translate}}\" prop=\"name\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\" maxWidth=\"100px\" let->\r\n                <div>\r\n                  <span title=\"{{'PROJECT_NAME' | translate:true}}\">\r\n                    {{value}}\r\n                  </span>\r\n                </div>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n          </ngx-datatable>\r\n\r\n          <!-- If User IS NOT editing the project form, then mark \"!projectsForm.dirty\" and load Projects List (code below) other wise load inactive Projects List from code above -->\r\n          <ngx-datatable *ngIf=\"!projectsForm.dirty\" class=\"bootstrap\" style=\"font-size: larger; font-weight: lighter\" [selected]=\"selected\" [selectionType]=\"'singleClick'\" (activate)=\"onActivate($event)\" (select)=\"onSelect($event)\" [headerHeight]=\"40\" [limit]=\"6\" [columnMode]=\"'force'\" [footerHeight]=\"60\" [rowHeight]=\"'auto'\" [rows]=\"projects\" (page)=\"onPage($event)\" [messages]=\"{emptyMessage: translatePipe.transform('NO_DATA_TO_DISPLAY', true), totalMessage: translatePipe.transform('TOTAL', true), selectedMessage: false}\" #projectsTable>\r\n            <ngx-datatable-column class=\"\" headerClass=\"text-bold\" style=\"\" name=\"{{'PROJECT_NAME' | translate}}\" prop=\"name\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\" maxWidth=\"100px\" let->\r\n                <div>\r\n                  <span title=\"{{'PROJECT_NAME' | translate:true}}\">\r\n                    {{value}}\r\n                  </span>\r\n                </div>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n          </ngx-datatable>\r\n        </div> <!-- end of data table -->\r\n        <!-- fields section -->\r\n        <div class=\"col-md-9 col-xs-12\">\r\n\r\n          <div class=\"row\">\r\n            <!-- Left hand controls -->\r\n            <div class=\"col-xs-12 col-md-6\">\r\n\r\n              <!-- Project Name -->\r\n              <div class=\"form-group\">\r\n                <div class=\"col-xs-3 text-right\">\r\n                  <label class=\"control-label\">{{\"PROJECT_NAME\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-6\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"text\" formControlName=\"projectName\" #projectName value=\"selectedProject.name\" />\r\n                    <span class=\"text-danger\" *ngIf=\"projectsForm.controls['projectName'].hasError('required') && (projectsForm.controls['projectName'].dirty || projectsForm.controls['projectName'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- Project Reference -->\r\n              <div class=\"form-group\">\r\n                <div class=\"col-xs-3 text-right\">\r\n                  <label class=\"control-label\">{{\"PROJECT_REFERENCE\" | translate}}</label>\r\n            </div>\r\n                <div class=\"col-xs-6\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"text\" formControlName=\"projectReference\" value=\"selectedProject.projectReference\" maxlength=\"20\" />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- Quotation Reference -->\r\n              <div class=\"form-group\">\r\n                <div class=\"col-xs-3 text-right\">\r\n                  <label class=\"control-label\">{{\"QUOTATION_REFERENCE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-6\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"text\" formControlName=\"quoteReference\" value=\"selectedProject.quoteReference\" maxlength=\"20\" />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- Project Created -->\r\n              <div class=\"form-group\">\r\n                <div class=\"col-xs-3 text-right\">\r\n                  <label class=\"control-label\">{{\"PROJECT_DATE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-6\">\r\n                  <div class=\"input-group\">\r\n                    <label class=\"control-label\">{{selectedProject.created | date:'fullDate'}} {{selectedProject.created | date:'shortTime'}}</label>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n            </div>\r\n\r\n\r\n            <!-- Right hand controls -->\r\n            <div class=\"col-xs-12 col-md-6\">\r\n\r\n              <!-- Customer -->\r\n              <div class=\"form-group\">\r\n                <div class=\"col-xs-3 text-right\">\r\n                  <label class=\"control-label\">{{\"CUSTOMER\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-6\">\r\n                  <input autocomplete=\"off\" class=\"form-control\" type=\"text\" formControlName=\"customerName\" value=\"selectedProject.customerName\" maxlength=\"50\" />\r\n                </div>\r\n              </div>\r\n\r\n              <!-- Customer Location -->\r\n              <div class=\"form-group\">\r\n                <div class=\"col-xs-3 text-right\">\r\n                  <label class=\"control-label\">{{\"CUSTOMER_LOCATION\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-6\">\r\n                  <input autocomplete=\"off\" class=\"form-control\" type=\"text\" formControlName=\"customerLocation\" value=\"selectedProject.customerLocation\" maxlength=\"30\"/>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- Trade List -->\r\n              <div class=\"form-group\">\r\n                <div class=\"col-xs-3 text-right\">\r\n                  <label class=\"control-label\">{{\"TRADE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-6\">\r\n                  <enumeration formControlName=\"tradeEnum\" (on-change)=\"onTradeChange($event)\" enumeration-name=\"Trade_Platform\"></enumeration>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- Industry List -->\r\n              <div class=\"form-group\">\r\n                <div class=\"col-xs-3 text-right\">\r\n                  <label class=\"control-label\">{{\"INDUSTRY\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-6\">\r\n                  <enumeration formControlName=\"industryEnum\" enumeration-name='{{industryEnumerationName}}'></enumeration>\r\n                </div>\r\n              </div>\r\n\r\n            </div>\r\n          </div>\r\n           \r\n\r\n          <div>\r\n            <!-- Success confirmation message -->\r\n            <alert-block *ngIf=\"!!alertVisible && !!isSuccess\" type=\"success\" [auto-close]=\"true\" [message]=\"'PROJECTS_AND_JOBS_SAVED_SUCCESSFULLY_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n            <!-- Failure confirmation message-->\r\n            <alert-block *ngIf=\"!!alertVisible && !isSuccess\" type=\"danger\" [message]=\"'PROJECTS_AND_JOBS_FAILED_TO_SAVE_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n</form>\r\n\r\n<jobs [selectedProjectId]=\"selectedProject.id\" [editingProject]=\"editingProject\" (editingJobDataOnChange)=\"editingJobDataOnChange($event)\"> </jobs>\r\n\r\n<!-- Generic Modal Component -->\r\n<sizing-suite-modal #delteConfirmationModal\r\n                    (modal-cancel)=\"modalCallbackCancel()\"\r\n                    (modal-ok)=\"deleteProject()\"\r\n                    [modal-title]=\"'PROJECTS_AND_JOBS' | translate\"\r\n                    [modal-ok-text]=\"'DELETE_PROJECT' | translate\"\r\n                    [modal-ok-icon]=\"'fa fa-trash'\"\r\n                    [modal-cancel-text]=\"'CANCEL' | translate:true\"\r\n                    [modal-cancel-icon]=\"'fa fa-times'\">\r\n\r\n  <p class=\"control-label\">{{'DELETE_PROJECT' | translate}}: <b>{{selectedProject.name}}</b>?</p>\r\n  <p class=\"control-label\">{{'ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_PROJECT_PLEASE_NOTE_ALL_JOBS_BELONGING_TO_THIS_PROJECT_WILL_BE_DELETED_MESSAGE' | translate}}</p>\r\n</sizing-suite-modal>\r\n\r\n<!-- Generic Modal Component -->\r\n<sizing-suite-modal #saveChangesModal\r\n                    (modal-cancel)=\"cancelEditsForProject()\"\r\n                    (modal-ok)=\"updateInsertProject()\"\r\n                    [modal-title]=\"'PROJECTS_AND_JOBS' | translate\"\r\n                    [modal-ok-text]=\"'SAVE_PROJECT' | translate\"\r\n                    [modal-ok-icon]=\"'fa fa-save'\"\r\n                    [modal-cancel-text]=\"'DISCARD_CHANGES' | translate\"\r\n                    [modal-cancel-icon]=\"'fa fa-times'\">\r\n\r\n  <label class=\"control-label\">{{'SAVE_PROJECT' | translate}}: <strong>{{this.projectsForm.controls[\"projectName\"].value}}</strong>?</label>\r\n</sizing-suite-modal>\r\n\r\n\r\n<!--ToDo:\r\n<br />\r\n- Tidy up and finalise html markup, make reactive for mobile use.\r\n<br />\r\n- Bug: unable to stop grid selection changing via mouse click when editingProject the project form (although such selection changes are now ignored), unable to fully disable the ngx-datatable control. Use blocking UI techneques?\r\n<br />\r\n- Work required to support Navigating away.\r\n<br />\r\n- Implement Sizing Module \"Projects\" & \"Jobs\" components (eg. 'Save As' support).\r\n<br />\r\n- Trade and Industry are not nullable as in the old system.\r\n<br />-->\r\n\r\n\r\n",
                styles: [".btn-projects{margin:0 2px}"]
            }] }
];
/** @nocollapse */
ProjectsJobsComponent.ctorParameters = () => [
    { type: ProjectsJobsService },
    { type: FormBuilder },
    { type: TranslatePipe },
    { type: SharedService },
    { type: AuthenticationService },
    { type: SyncClientService },
    { type: ChangeDetectorRef }
];
ProjectsJobsComponent.propDecorators = {
    table: [{ type: ViewChild, args: [DatatableComponent, { static: false },] }],
    tableExp: [{ type: ViewChild, args: ['projectsTable', { static: false },] }],
    projectNameInput: [{ type: ViewChild, args: ['projectName', { static: false },] }]
};
if (false) {
    /** @type {?} */
    ProjectsJobsComponent.prototype.table;
    /** @type {?} */
    ProjectsJobsComponent.prototype.tableExp;
    /** @type {?} */
    ProjectsJobsComponent.prototype.projectNameInput;
    /** @type {?} */
    ProjectsJobsComponent.prototype.cloneDeep;
    /** @type {?} */
    ProjectsJobsComponent.prototype.timeout;
    /** @type {?} */
    ProjectsJobsComponent.prototype.projects;
    /** @type {?} */
    ProjectsJobsComponent.prototype.jobs;
    /** @type {?} */
    ProjectsJobsComponent.prototype.selectedProject;
    /** @type {?} */
    ProjectsJobsComponent.prototype.selectedProjectIndex;
    /** @type {?} */
    ProjectsJobsComponent.prototype.industryEnumerationName;
    /** @type {?} */
    ProjectsJobsComponent.prototype.projectsForm;
    /** @type {?} */
    ProjectsJobsComponent.prototype.projectName;
    /** @type {?} */
    ProjectsJobsComponent.prototype.customerName;
    /** @type {?} */
    ProjectsJobsComponent.prototype.projectReference;
    /** @type {?} */
    ProjectsJobsComponent.prototype.customerLocation;
    /** @type {?} */
    ProjectsJobsComponent.prototype.quoteReference;
    /** @type {?} */
    ProjectsJobsComponent.prototype.tradeEnum;
    /** @type {?} */
    ProjectsJobsComponent.prototype.industryEnum;
    /** @type {?} */
    ProjectsJobsComponent.prototype.created;
    /** @type {?} */
    ProjectsJobsComponent.prototype.areProjectsAndJobsLoaded;
    /** @type {?} */
    ProjectsJobsComponent.prototype.isSuccess;
    /** @type {?} */
    ProjectsJobsComponent.prototype.alertVisible;
    /** @type {?} */
    ProjectsJobsComponent.prototype.formSubmitted;
    /** @type {?} */
    ProjectsJobsComponent.prototype.editingProject;
    /** @type {?} */
    ProjectsJobsComponent.prototype.editingJob;
    /** @type {?} */
    ProjectsJobsComponent.prototype.rowsSel;
    /** @type {?} */
    ProjectsJobsComponent.prototype.selected;
    /** @type {?} */
    ProjectsJobsComponent.prototype.theFormGroup;
    /** @type {?} */
    ProjectsJobsComponent.prototype.hasUnsavedDataChanges;
    /** @type {?} */
    ProjectsJobsComponent.prototype.projectsAndJobsSyncInfo;
    /**
     * @type {?}
     * @private
     */
    ProjectsJobsComponent.prototype.projectsJobsService;
    /**
     * @type {?}
     * @private
     */
    ProjectsJobsComponent.prototype.fb;
    /** @type {?} */
    ProjectsJobsComponent.prototype.translatePipe;
    /**
     * @type {?}
     * @private
     */
    ProjectsJobsComponent.prototype.sharedService;
    /**
     * @type {?}
     * @private
     */
    ProjectsJobsComponent.prototype.authenticationService;
    /**
     * @type {?}
     * @private
     */
    ProjectsJobsComponent.prototype.syncClientService;
    /**
     * @type {?}
     * @private
     */
    ProjectsJobsComponent.prototype.cdRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/admin/admin.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AdminComponent {
    /**
     * @param {?} authenticationService
     */
    constructor(authenticationService) {
        this.authenticationService = authenticationService;
    }
    /**
     * @return {?}
     */
    get currentUser() {
        return this.authenticationService.authenticatedUser;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
AdminComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-admin',
                template: "<div class=\"row\">\r\n  <!-- OpCo Preferences -->\r\n  <div class=\"col-lg-3 col-md-4 col-sm-6 col-xs-12\" *ngIf=\"currentUser.permissions['canManageOpCoPreferences']\">\r\n    <a title=\"Preferences\" class=\"btn btn-primary btn-lg btn-block admin-module-button\" routerLink=\"/admin/operatingCompanyPreferences\">\r\n      <em class=\"fa fa-globe\"></em><br />\r\n      <span>{{'PREFERENCES' | translate}}</span>\r\n    </a>\r\n  </div>\r\n\r\n  <!-- Currencies -->\r\n  <div class=\"col-lg-3 col-md-4 col-sm-6 col-xs-12\" *ngIf=\"currentUser.permissions['canViewCurrencyInfo']\">\r\n    <a title=\"Currency\" class=\"btn btn-primary btn-lg btn-block admin-module-button\" routerLink=\"/admin/currency\">\r\n      <em class=\"fa fa-money\"></em><br />\r\n      <span>{{'CURRENCY_INFORMATION' | translate}}</span>\r\n    </a>\r\n  </div>\r\n\r\n  <!-- Module Preferences -->\r\n  <div class=\"col-lg-3 col-md-4 col-sm-6 col-xs-12\" *ngIf=\"currentUser.permissions['canManageModulePreferences']\">\r\n    <a title=\"Module Preferences\" class=\"btn btn-primary btn-lg btn-block admin-module-button\" routerLink=\"/admin/modulePreferences\">\r\n      <em class=\"fa fa-cog\"></em><br />\r\n      <span>{{'MODULE_PREFERENCES' | translate}}</span>\r\n    </a>\r\n  </div>\r\n\r\n  <!-- Module Access -->\r\n  <div class=\"col-lg-3 col-md-4 col-sm-6 col-xs-12\" *ngIf=\"currentUser.permissions['canManageModuleAccess']\">\r\n    <a title=\"Module Access\" class=\"btn btn-primary btn-lg btn-block admin-module-button\" routerLink=\"/admin/moduleAccess\">\r\n      <em class=\"fa fa-exchange\"></em><br />\r\n      <span>{{'MODULE_ACCESS' | translate}}</span>\r\n    </a>\r\n  </div>\r\n\r\n  <!-- Product Selection -->\r\n  <div class=\"col-lg-3 col-md-4 col-sm-6 col-xs-12\" *ngIf=\"currentUser.permissions['canManageProductSelection']\">\r\n    <a title=\"Product Selection\" class=\"btn btn-primary btn-lg btn-block admin-module-button\" routerLink=\"/admin/productSelection\">\r\n      <em class=\"fa fa-check-square-o\"></em><br />\r\n      <span>{{'PRODUCT_SELECTION' | translate}}</span>\r\n    </a>\r\n  </div>\r\n\r\n</div>\r\n",
                styles: [".home-container{margin:0 auto;max-width:970px}.home-container .home-logo{width:240px}@media only screen and (max-width:768px){.home-container .home-text{text-align:center}}.admin-module-button{margin:5px;white-space:normal}.admin-module-button em{font-size:1.6em}@media (min-width:1200px){.admin-module-button{font-size:1.4em}}"]
            }] }
];
/** @nocollapse */
AdminComponent.ctorParameters = () => [
    { type: AuthenticationService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    AdminComponent.prototype.authenticationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/safetyValves/modulePreference/productSelectionAdmin/productSelectionAdmin.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductSelectionAdminService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} moduleGroupId
     * @return {?}
     */
    getAllProductSelectionRanges(moduleGroupId) {
        return this.http.get(`./Api/SafetyValves/GetAllProductSelectionRanges/${moduleGroupId}`);
    }
    /**
     * @param {?} moduleGroupId
     * @return {?}
     */
    getProductExclusionRanges(moduleGroupId) {
        return this.http.get(`./Api/SafetyValves/GetProductExclusionRanges/${moduleGroupId}`);
    }
    /**
     * @param {?} saveSafetyValvesProductSelection
     * @return {?}
     */
    selectedSafetyValves(saveSafetyValvesProductSelection) {
        return this.http.post('./Api/SafetyValves/SaveProductSelection', saveSafetyValvesProductSelection);
    }
}
ProductSelectionAdminService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ProductSelectionAdminService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ ProductSelectionAdminService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ProductSelectionAdminService_Factory() { return new ProductSelectionAdminService(ɵɵinject(HttpClient)); }, token: ProductSelectionAdminService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ProductSelectionAdminService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/flowmeter/modulePreference/flowmeterProductSelectionAdmin/flowmeterProductSelectionAdmin.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FlowmeterProductSelectionAdminService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} moduleGroupId
     * @return {?}
     */
    getAllProductSelectionRanges(moduleGroupId) {
        return this.http.get(`./Api/SafetyValves/GetAllProductSelectionRanges/${moduleGroupId}`);
    }
    /**
     * @param {?} moduleGroupId
     * @return {?}
     */
    getProductExclusionRanges(moduleGroupId) {
        return this.http.get(`./Api/SafetyValves/GetProductExclusionRanges/${moduleGroupId}`);
    }
    /**
     * @param {?} saveFlowmeterProductSelection
     * @return {?}
     */
    selectedFlowmeters(saveFlowmeterProductSelection) {
        return this.http.post('./Api/SafetyValves/SaveProductSelection', saveFlowmeterProductSelection);
    }
}
FlowmeterProductSelectionAdminService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
FlowmeterProductSelectionAdminService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ FlowmeterProductSelectionAdminService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FlowmeterProductSelectionAdminService_Factory() { return new FlowmeterProductSelectionAdminService(ɵɵinject(HttpClient)); }, token: FlowmeterProductSelectionAdminService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    FlowmeterProductSelectionAdminService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/admin/currency/currency.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CurrencyComponent {
    /**
     * @param {?} adminService
     * @param {?} translatePipe
     */
    constructor(adminService, translatePipe) {
        this.adminService = adminService;
        this.translatePipe = translatePipe;
        this.pageTitle = 'Currency Information';
        this.errorMessage = '';
        this.currencyList = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.adminService.getCurrencyData()
            .subscribe((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            this.currencyList = data;
        }));
    }
}
CurrencyComponent.decorators = [
    { type: Component, args: [{
                template: "<div class='panel panel-primary'>\r\n  <div class='panel-body'>\r\n    <div class='table-responsive'>\r\n\r\n      <ngx-datatable #currencyTable\r\n                     class=\"bootstrap\"\r\n                     [headerHeight]=\"40\"\r\n                     [limit]=\"10\"\r\n                     [columnMode]=\"'force'\"\r\n                     [footerHeight]=\"40\"\r\n                     [rowHeight]=\"'auto'\"\r\n                     [rows]=\"currencyList\"\r\n                     [messages]=\"{emptyMessage: translatePipe.transform('NO_DATA_TO_DISPLAY', true), totalMessage: translatePipe.transform('TOTAL', true), selectedMessage: false}\">\r\n\r\n        <ngx-datatable-column [name]=\"'CURRENCY' | translate\" prop=\"translationText\">\r\n          <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n            {{value}}\r\n          </ng-template>\r\n        </ngx-datatable-column>\r\n\r\n        <ngx-datatable-column [name]=\"'SYMBOL' | translate\" prop=\"symbol\">\r\n          <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n            {{value}}\r\n          </ng-template>\r\n        </ngx-datatable-column>\r\n\r\n        <ngx-datatable-column [name]=\"'CURRENCY_CODE' | translate\" prop=\"currencyCode\">\r\n          <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n            {{value}}\r\n          </ng-template>\r\n        </ngx-datatable-column>\r\n\r\n        <ngx-datatable-column [name]=\"'CONVERSION_RATE' | translate\" prop=\"rateToGbp\">\r\n          <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n            {{value}}\r\n          </ng-template>\r\n        </ngx-datatable-column>\r\n\r\n      </ngx-datatable>\r\n\r\n\r\n      <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                styles: ["div.panel-heading{font-size:x-large}table{width:100%}thead{color:#ff6a00}th[sortable-column]{text-align:left;cursor:pointer;width:auto;color:#3fb1e4}"]
            }] }
];
/** @nocollapse */
CurrencyComponent.ctorParameters = () => [
    { type: AdminService },
    { type: TranslatePipe }
];
if (false) {
    /** @type {?} */
    CurrencyComponent.prototype.pageTitle;
    /** @type {?} */
    CurrencyComponent.prototype.errorMessage;
    /** @type {?} */
    CurrencyComponent.prototype.currencyList;
    /**
     * @type {?}
     * @private
     */
    CurrencyComponent.prototype.adminService;
    /** @type {?} */
    CurrencyComponent.prototype.translatePipe;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/admin/operatingCompany-preferences/operatingCompany-preferences.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class OperatingCompanyPreferencesComponent {
    // to drive GenericChangesGuard
    /**
     * @param {?} adminService
     * @param {?} preferenceService
     * @param {?} fb
     */
    constructor(adminService, preferenceService, fb) {
        this.adminService = adminService;
        this.preferenceService = preferenceService;
        this.fb = fb;
        this.arePreferencesLoaded = false;
        this.isSuccess = false;
        this.alertVisible = false;
        this.formSubmitted = false;
        // Units of measure
        this.pressurePrefFormControl = new FormControl('');
        this.areaPrefFormControl = new FormControl('');
        this.temperaturePrefFormControl = new FormControl('');
        this.forcePrefFormControl = new FormControl('');
        this.massFlowPrefFormControl = new FormControl('');
        this.lengthPrefFormControl = new FormControl('');
        this.volumetricFlowPrefFormControl = new FormControl('');
        this.weightPrefFormControl = new FormControl('');
        this.capacityPrefFormControl = new FormControl('');
        this.velocityPrefFormControl = new FormControl('');
        this.loadPrefFormControl = new FormControl('');
        this.energyPrefFormControl = new FormControl('');
        this.gaseousFuelPrefFormControl = new FormControl('');
        this.liquidFuelPrefFormControl = new FormControl('');
        this.solidFuelPrefFormControl = new FormControl('');
        // Boiler house units
        this.boilerHouseVolumePrefFormControl = new FormControl('');
        this.boilerHouseVolumetricFlowPrefFormControl = new FormControl('');
        this.boilerHouseWeightPrefFormControl = new FormControl('');
        this.boilerHouseTdsPrefFormControl = new FormControl('');
        this.boilerHouseMassFlowPrefFormControl = new FormControl('');
        this.boilerHouseEnergyPrefFormControl = new FormControl('');
        this.boilerHouseSpecificEnergyPrefFormControl = new FormControl('');
        this.boilerHouseCo2EmissionsPrefFormControl = new FormControl('');
        this.boilerHouseCurrencyPrefFormControl = new FormControl('');
        this.boilerHouseGaseousFuelPrefFormControl = new FormControl('');
        this.boilerHouseLiquidFuelPrefFormControl = new FormControl('');
        this.boilerHouseSolidFuelPrefFormControl = new FormControl('');
        this.boilerHouseElectricalFuelPrefFormControl = new FormControl('');
        // Others
        this.currencyPrefFormControl = new FormControl('');
        this.reverseOsmosisPrefFormControl = new FormControl('');
        this.taxRatePrefFormControl = new FormControl('', [Validators.required]);
        this.annualInflationPrefFormControl = new FormControl('', [Validators.required]);
        this.capitalAllowancePrefFormControl = new FormControl('', [Validators.required]);
        this.cvDesignStandardPrefFormControl = new FormControl('');
        this.specLanguagePrefFormControl = new FormControl('');
        this.clientDownloadPrefFormControl = new FormControl('');
        // Setup the form group.
        this.preferencesForm = this.fb.group({
            pressurePreference: this.pressurePrefFormControl,
            areaPreference: this.areaPrefFormControl,
            temperaturePreference: this.temperaturePrefFormControl,
            forcePreference: this.forcePrefFormControl,
            massFlowPreference: this.massFlowPrefFormControl,
            lengthPreference: this.lengthPrefFormControl,
            volumetricFlowPreference: this.volumetricFlowPrefFormControl,
            weightPreference: this.weightPrefFormControl,
            capacityPreference: this.capacityPrefFormControl,
            velocityPreference: this.velocityPrefFormControl,
            loadPreference: this.loadPrefFormControl,
            energyPreference: this.energyPrefFormControl,
            gaseousFuelPreference: this.gaseousFuelPrefFormControl,
            liquidFuelPreference: this.liquidFuelPrefFormControl,
            solidFuelPreference: this.solidFuelPrefFormControl,
            // Boiler house units
            boilerHouseVolumePreference: this.boilerHouseVolumePrefFormControl,
            boilerHouseVolumetricFlowPreference: this.boilerHouseVolumetricFlowPrefFormControl,
            boilerHouseWeightPreference: this.boilerHouseWeightPrefFormControl,
            boilerHouseTdsPreference: this.boilerHouseTdsPrefFormControl,
            boilerHouseMassFlowPreference: this.boilerHouseMassFlowPrefFormControl,
            boilerHouseEnergyPreference: this.boilerHouseEnergyPrefFormControl,
            boilerHouseSpecificEnergyPreference: this.boilerHouseSpecificEnergyPrefFormControl,
            boilerHouseCo2EmissionsPreference: this.boilerHouseCo2EmissionsPrefFormControl,
            boilerHouseCurrencyPreference: this.boilerHouseCurrencyPrefFormControl,
            boilerHouseGaseousFuelPreference: this.boilerHouseGaseousFuelPrefFormControl,
            boilerHouseLiquidFuelPreference: this.boilerHouseLiquidFuelPrefFormControl,
            boilerHouseSolidFuelPreference: this.boilerHouseSolidFuelPrefFormControl,
            boilerHouseElectricalFuelPreference: this.boilerHouseElectricalFuelPrefFormControl,
            // Others
            reverseOsmosisPreference: this.reverseOsmosisPrefFormControl,
            taxRatePreference: this.taxRatePrefFormControl,
            annualInflationPreference: this.annualInflationPrefFormControl,
            capitalAllowancePreference: this.capitalAllowancePrefFormControl,
            cvDesignStandardPreference: this.cvDesignStandardPrefFormControl,
            specLanguagePreference: this.specLanguagePrefFormControl,
            clientDownloadPreference: this.clientDownloadPrefFormControl
        }, { updateOn: "blur" });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        // Fire off the service calls and wait for the observables to resolve themselves before subscribing by using the forkJoin function.
        Observable$1.forkJoin(this.preferenceService.getOperatingCompanyPreferences(), this.adminService.getCurrencyData(), this.adminService.getLanguages())
            .subscribe((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            /** @type {?} */
            let prefDetails = result[0];
            // Assign the currencies and sort them alphabetically by translated text.
            this.currencies = result[1].sort((/**
             * @param {?} currentCurrency
             * @param {?} nextCurrency
             * @return {?}
             */
            (currentCurrency, nextCurrency) => {
                if (currentCurrency.translationText > nextCurrency.translationText) {
                    return 1;
                }
                if (currentCurrency.translationText < nextCurrency.translationText) {
                    return -1;
                }
                return 0;
            }));
            // Assign the languages and sort them alphabetically by name.
            this.languages = result[2].sort((/**
             * @param {?} currentLang
             * @param {?} nextLang
             * @return {?}
             */
            (currentLang, nextLang) => {
                if (currentLang.name > nextLang.name) {
                    return 1;
                }
                if (currentLang.name < nextLang.name) {
                    return -1;
                }
                return 0;
            }));
            // Units of measure
            /**
             * Fetch all the various preferences.
             * @type {?}
             */
            const pressurePref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "PressureUnit");
            /** @type {?} */
            const areaPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "AreaUnit");
            /** @type {?} */
            const temperaturePref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "TemperatureUnit");
            /** @type {?} */
            const forcePref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "ForceUnit");
            /** @type {?} */
            const massFlowPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "MassFlowUnit");
            /** @type {?} */
            const lengthPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "LengthUnit");
            /** @type {?} */
            const volumetricFlowPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "VolumetricFlowUnit");
            /** @type {?} */
            const weightPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "WeightUnit");
            /** @type {?} */
            const capacityPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "CapacityUnit");
            /** @type {?} */
            const velocityPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "VelocityUnit");
            /** @type {?} */
            const loadPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "LoadUnit");
            /** @type {?} */
            const energyPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "EnergyUnits");
            /** @type {?} */
            const gaseousFuelPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "GaseousFuelUnits");
            /** @type {?} */
            const liquidFuel = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "LiquidFuelUnits");
            /** @type {?} */
            const solidFuelPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "SolidFuelUnits");
            // Boiler house units
            /** @type {?} */
            const boilerHouseVolume = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseVolumeUnits");
            /** @type {?} */
            const boilerHouseVolumetricFlow = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseVolumetricFlowUnits");
            /** @type {?} */
            const boilerHouseWeight = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseWeightUnits");
            /** @type {?} */
            const boilerHouseTds = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseTDSUnits");
            /** @type {?} */
            const boilerHouseMassFlow = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseMassFlowUnits");
            /** @type {?} */
            const boilerHouseEnergy = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseEnergyUnits");
            /** @type {?} */
            const boilerHouseSpecificEnergy = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseSpecificEnergyUnits");
            /** @type {?} */
            const boilerHouseCo2Emissions = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseEmissionUnits");
            /** @type {?} */
            const boilerHouseGaseousFuel = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseGasFuelUnits");
            /** @type {?} */
            const boilerHouseLiquidFuel = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseLiquidFuelUnits");
            /** @type {?} */
            const boilerHouseSolidFuel = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseSolidFuelUnits");
            /** @type {?} */
            const boilerHouseElectricalFuel = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseElectricalFuelUnits");
            // Others
            this.boilerHouseCurrency = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BHCurrency");
            this.reverseOsmosis = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "ReverseOsmosisAvailable");
            this.taxRate = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "Tax");
            this.annualInflation = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "AnnualInflation");
            this.capitalAllowance = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "CapitalAllowanceRate");
            this.cvDesignStandard = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "CvDesignStandard");
            this.specLanguage = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "SpecLanguage");
            this.clientDownload = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "DownloadAccess");
            /**
             * Set the preferences to the form controls.
             */
            // Units of measure
            this.pressurePrefFormControl.setValue(pressurePref);
            this.areaPrefFormControl.setValue(areaPref);
            this.temperaturePrefFormControl.setValue(temperaturePref);
            this.forcePrefFormControl.setValue(forcePref);
            this.massFlowPrefFormControl.setValue(massFlowPref);
            this.lengthPrefFormControl.setValue(lengthPref);
            this.volumetricFlowPrefFormControl.setValue(volumetricFlowPref);
            this.weightPrefFormControl.setValue(weightPref);
            this.capacityPrefFormControl.setValue(capacityPref);
            this.velocityPrefFormControl.setValue(velocityPref);
            this.loadPrefFormControl.setValue(loadPref);
            this.energyPrefFormControl.setValue(energyPref);
            this.gaseousFuelPrefFormControl.setValue(gaseousFuelPref);
            this.liquidFuelPrefFormControl.setValue(liquidFuel);
            this.solidFuelPrefFormControl.setValue(solidFuelPref);
            // Boiler house units
            this.boilerHouseVolumePrefFormControl.setValue(boilerHouseVolume);
            this.boilerHouseVolumetricFlowPrefFormControl.setValue(boilerHouseVolumetricFlow);
            this.boilerHouseWeightPrefFormControl.setValue(boilerHouseWeight);
            this.boilerHouseTdsPrefFormControl.setValue(boilerHouseTds);
            this.boilerHouseMassFlowPrefFormControl.setValue(boilerHouseMassFlow);
            this.boilerHouseEnergyPrefFormControl.setValue(boilerHouseEnergy);
            this.boilerHouseSpecificEnergyPrefFormControl.setValue(boilerHouseSpecificEnergy);
            this.boilerHouseCo2EmissionsPrefFormControl.setValue(boilerHouseCo2Emissions);
            this.boilerHouseGaseousFuelPrefFormControl.setValue(boilerHouseGaseousFuel);
            this.boilerHouseLiquidFuelPrefFormControl.setValue(boilerHouseLiquidFuel);
            this.boilerHouseSolidFuelPrefFormControl.setValue(boilerHouseSolidFuel);
            this.boilerHouseElectricalFuelPrefFormControl.setValue(boilerHouseElectricalFuel);
            // Others that are a bit more unique
            this.boilerHouseCurrencyPrefFormControl.setValue(this.boilerHouseCurrency.value);
            this.reverseOsmosisPrefFormControl.setValue(this.reverseOsmosis.value);
            this.taxRatePrefFormControl.setValue(this.taxRate.value == null ? "10" : this.taxRate.value);
            this.annualInflationPrefFormControl.setValue(this.annualInflation.value == null ? "2" : this.annualInflation.value);
            this.capitalAllowancePrefFormControl.setValue(this.capitalAllowance.value == null ? "20" : this.capitalAllowance.value);
            this.cvDesignStandardPrefFormControl.setValue(this.cvDesignStandard.value == null ? "EN" : this.cvDesignStandard.value);
            this.cvDesignStandardPrefFormControl.updateValueAndValidity(); // To prevent sticky form validation for no prefs initialisation scenerio.
            this.specLanguagePrefFormControl.setValue(this.specLanguage.value == null ? "en-gb" : this.specLanguage.value);
            this.clientDownloadPrefFormControl.setValue(this.clientDownload.value == null ? "0" : this.clientDownload.value);
            // Inform the view that preferences are now loaded.
            this.arePreferencesLoaded = true;
            this.theFormGroup = this.preferencesForm; // to drive GenericChangesGuard
        }));
    }
    /**
     * Rationalises the value for the reverse osmosis check control.
     * @param {?} control The HTML checkbox.
     * @return {?}
     */
    setReverseOsmosis(control) {
        this.reverseOsmosis.value = control.checked ? "1" : "0";
        this.reverseOsmosisPrefFormControl.setValue(this.reverseOsmosis.value);
    }
    /**
     * Submits the form for saving to the server.
     * @param {?} $ev The submission event.
     * @return {?}
     */
    submitForm($ev) {
        $ev.preventDefault();
        // Mark the form as submitted.
        this.formSubmitted = true;
        /** @type {?} */
        const newPreferences = [];
        // Get the currency
        /** @type {?} */
        const currencyPref = this.preferencesForm.controls["boilerHouseCurrencyPreference"];
        this.boilerHouseCurrency.value = currencyPref.value;
        newPreferences.push(this.boilerHouseCurrency);
        // Reverse osmosis
        /** @type {?} */
        const reverseOsmosisPref = this.preferencesForm.controls["reverseOsmosisPreference"];
        this.reverseOsmosis.value = reverseOsmosisPref.value;
        // if reverseOsmosisPref.value is null then set it false '0'
        if (!!this.reverseOsmosis && this.reverseOsmosis.value === null) {
            this.reverseOsmosis.value = "0";
        }
        newPreferences.push(this.reverseOsmosis);
        // Tax Rate
        /** @type {?} */
        const taxRatePref = this.preferencesForm.controls["taxRatePreference"];
        this.taxRate.value = taxRatePref.value;
        newPreferences.push(this.taxRate);
        // Annual inflation
        /** @type {?} */
        const annualInflationPref = this.preferencesForm.controls["annualInflationPreference"];
        this.annualInflation.value = annualInflationPref.value;
        newPreferences.push(this.annualInflation);
        // Capital allowance
        /** @type {?} */
        const capitalAllowancePref = this.preferencesForm.controls["capitalAllowancePreference"];
        this.capitalAllowance.value = capitalAllowancePref.value;
        newPreferences.push(this.capitalAllowance);
        // CV Design standard
        /** @type {?} */
        const cvDesignStandardPref = this.preferencesForm.controls["cvDesignStandardPreference"];
        this.cvDesignStandard.value = cvDesignStandardPref.value;
        // if cvDesignStandardPref.value is null then set it false '0'
        if (!!this.cvDesignStandard && this.cvDesignStandard.value === null) {
            this.cvDesignStandard.value = "EN";
        }
        newPreferences.push(this.cvDesignStandard);
        // Spec language
        /** @type {?} */
        const specLanguagePref = this.preferencesForm.controls["specLanguagePreference"];
        this.specLanguage.value = specLanguagePref.value;
        // if specLanguagePref.value is null then set it false '0'
        if (!!this.specLanguage && this.specLanguage.value === null) {
            this.specLanguage.value = "en-gb";
        }
        newPreferences.push(this.specLanguage);
        // Client download
        /** @type {?} */
        const clientDownloadPref = this.preferencesForm.controls["clientDownloadPreference"];
        this.clientDownload.value = clientDownloadPref.value;
        newPreferences.push(this.clientDownload);
        // Get all the other preferences
        // Units of measure
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["pressurePreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["areaPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["temperaturePreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["forcePreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["massFlowPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["lengthPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["volumetricFlowPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["weightPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["capacityPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["velocityPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["loadPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["energyPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["gaseousFuelPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["liquidFuelPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["solidFuelPreference"].value)));
        // Boiler house units
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseVolumePreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseVolumetricFlowPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseWeightPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseTdsPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseMassFlowPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseEnergyPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseSpecificEnergyPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseCo2EmissionsPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseGaseousFuelPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseLiquidFuelPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseSolidFuelPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseElectricalFuelPreference"].value)));
        // Save the changed preferences as an array of preferences
        this.preferenceService.manageOperatingCompanyPreferences(newPreferences).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            // The form can be submitted again.
            this.formSubmitted = false;
            // Set the operation based on the response.
            this.isSuccess = response;
            this.alertVisible = true;
            this.preferencesForm.markAsPristine();
        }), (/**
         * @param {?} error
         * @return {?}
         */
        error => {
            // The form can be submitted again.
            this.formSubmitted = false;
            // Set the operation based on the response.
            this.isSuccess = false;
            this.alertVisible = true;
        }));
    }
    /**
     * @return {?}
     */
    closeAlert() {
        // Reset the flag
        this.alertVisible = false;
    }
    /**
     * @param {?} componentRef
     * @return {?}
     */
    onDeactivate(componentRef) {
        console.info(`Deactivating`);
    }
}
OperatingCompanyPreferencesComponent.decorators = [
    { type: Component, args: [{
                template: "<form [formGroup]=\"preferencesForm\" class=\"form-horizontal\" role=\"form\" (submit)=\"submitForm($event)\" novalidate>\r\n  <div class='panel panel-primary' *ngIf=\"!!arePreferencesLoaded\">\r\n    <div class='panel-body'>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n          <h4>{{\"UNITS_OF_MEASURE\" | translate}}</h4>\r\n          <hr />\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n          <button [disabled]=\"!preferencesForm.dirty || !preferencesForm.valid || preferencesForm.status !== 'VALID' || formSubmitted\" type=\"submit\" class=\"btn btn-dynamic btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i></button>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Success confirmation message -->\r\n      <alert-block *ngIf=\"!!alertVisible && !!isSuccess\" type=\"success\" [auto-close]=\"true\" [message]=\"'OPERATING_COMPANY_PREFERENCES_SAVED_SUCCESSFULLY_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n      <!-- Failure confirmation message-->\r\n      <alert-block *ngIf=\"!!alertVisible && !isSuccess\" type=\"danger\" [message]=\"'OPERATING_COMPANY_PREFERENCES_FAILED_TO_SAVE_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n      <!-- Control headings  -->\r\n      <div class=\"row\">\r\n        <!-- Left section -->\r\n        <div class=\"col-md-6 col-xs-12\">\r\n\r\n          <div class=\"row\">\r\n            <div class=\"col-lg-2 col-lg-offset-3 col-xs-4\">\r\n              <h6>{{\"DECIMALS\" | translate}}</h6>\r\n            </div>\r\n            <div class=\"col-lg-4 col-xs-8\">\r\n              <h6>{{\"UNITS\" | translate}}</h6>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- Pressure -->\r\n          <preference formControlName=\"pressurePreference\" requires-decimals=\"true\" unit-type=\"PressureUnits\" unit-label=\"PRESSURE\" default-value=\"50\"></preference>\r\n\r\n          <!-- Temperature -->\r\n          <preference formControlName=\"temperaturePreference\" requires-decimals=\"true\" unit-type=\"TemperatureUnits\" unit-label=\"TEMPERATURE\" default-value=\"146\"></preference>\r\n\r\n          <!-- Mass Flow -->\r\n          <preference formControlName=\"massFlowPreference\" requires-decimals=\"true\" unit-type=\"MassFlowUnits\" unit-label=\"MASS_FLOW\" default-value=\"84\"></preference>\r\n\r\n          <!-- Volumetric Flow -->\r\n          <preference formControlName=\"volumetricFlowPreference\" requires-decimals=\"true\" unit-type=\"VolumetricFlowUnits\" unit-label=\"VOLUMETRIC_FLOW\" default-value=\"75\"></preference>\r\n\r\n          <!-- Capacity -->\r\n          <preference formControlName=\"capacityPreference\" requires-decimals=\"true\" unit-type=\"CapacityUnits\" unit-label=\"CAPACITY\" default-value=\"88\"></preference>\r\n\r\n          <!-- Load -->\r\n          <preference formControlName=\"loadPreference\" requires-decimals=\"true\" unit-type=\"LoadUnits\" unit-label=\"LOAD\" default-value=\"97\"></preference>\r\n\r\n          <!-- Gaseous Fuel -->\r\n          <preference formControlName=\"gaseousFuelPreference\" requires-decimals=\"true\" unit-type=\"GaseousFuelUnits\" unit-label=\"GASEOUS_FUEL\" default-value=\"16\"></preference>\r\n\r\n          <!-- Solid Fuel -->\r\n          <preference formControlName=\"solidFuelPreference\" requires-decimals=\"true\" unit-type=\"SolidFuelUnits\" unit-label=\"SOLID_FUEL\" default-value=\"26\"></preference>\r\n\r\n        </div>\r\n\r\n        <!-- Right section -->\r\n        <div class=\"col-md-6 col-xs-12\">\r\n\r\n          <div class=\"row\">\r\n            <div class=\"col-lg-2 col-lg-offset-3 col-xs-4\">\r\n              <h6>{{\"DECIMALS\" | translate}}</h6>\r\n            </div>\r\n            <div class=\"col-lg-4 col-xs-8\">\r\n              <h6>{{\"UNITS\" | translate}}</h6>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- Area -->\r\n          <preference formControlName=\"areaPreference\" requires-decimals=\"true\" unit-type=\"AreaUnits\" unit-label=\"AREA\" default-value=\"11\"></preference>\r\n\r\n          <!-- Force -->\r\n          <preference formControlName=\"forcePreference\" requires-decimals=\"true\" unit-type=\"ForceUnits\" unit-label=\"FORCE\" default-value=\"93\"></preference>\r\n\r\n          <!-- Length -->\r\n          <preference formControlName=\"lengthPreference\" requires-decimals=\"true\" unit-type=\"LengthUnits\" unit-label=\"LENGTH\" default-value=\"3\"></preference>\r\n\r\n          <!-- Weight -->\r\n          <preference formControlName=\"weightPreference\" requires-decimals=\"true\" unit-type=\"WeightUnits\" unit-label=\"WEIGHT\" default-value=\"26\"></preference>\r\n\r\n          <!-- Velocity -->\r\n          <preference formControlName=\"velocityPreference\" requires-decimals=\"true\" unit-type=\"VelocityUnits\" unit-label=\"VELOCITY\" default-value=\"139\"></preference>\r\n\r\n          <!-- Energy -->\r\n          <preference formControlName=\"energyPreference\" requires-decimals=\"true\" unit-type=\"EnergyUnits\" unit-label=\"ENERGY\" default-value=\"108\"></preference>\r\n\r\n          <!-- Liquid Fuel -->\r\n          <preference formControlName=\"liquidFuelPreference\" requires-decimals=\"true\" unit-type=\"LiquidFuelUnits\" unit-label=\"LIQUID_FUEL\" default-value=\"15\"></preference>\r\n\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Boiler House units of measure -->\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12 \">\r\n          <h4>{{\"BOILER_HOUSE_UNITS_OF_MEASURE\" | translate}}</h4>\r\n          <hr />\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Grid heading -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6 col-xs-12\">\r\n\r\n          <div class=\"row\">\r\n            <div class=\"col-lg-offset-4 col-xs-4\">\r\n              <h6>{{\"UNITS\" | translate}}</h6>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- Boiler house volume -->\r\n          <preference formControlName=\"boilerHouseVolumePreference\" unit-type=\"BoilerHouseVolumeUnits\" unit-label=\"VOLUME\" default-value=\"16\"></preference>\r\n\r\n          <!-- Boiler house weight -->\r\n          <preference formControlName=\"boilerHouseWeightPreference\" unit-type=\"BoilerHouseWeightUnits\" unit-label=\"WEIGHT\" default-value=\"27\"></preference>\r\n\r\n          <!-- Boiler house mass flow -->\r\n          <preference formControlName=\"boilerHouseMassFlowPreference\" unit-type=\"BoilerHouseMassFlowUnits\" unit-label=\"MASS_FLOW\" default-value=\"229\"></preference>\r\n\r\n          <!-- Boiler house specific energy -->\r\n          <preference formControlName=\"boilerHouseSpecificEnergyPreference\" unit-type=\"BoilerHouseSpecificEnergyUnits\" unit-label=\"SPECIFIC_ENERGY\" default-value=\"223\"></preference>\r\n\r\n          <!-- Currencies are unique here -->\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"col-lg-4 col-md-12 col-xs-12 text-right\">\r\n              <label for=\"name\" class=\"control-label\">{{\"CURRENCY\" | translate}}</label>\r\n            </div>\r\n\r\n            <div class=\"col-lg-4 col-md-6 col-xs-12\">\r\n              <select class=\"form-control\" formControlName=\"boilerHouseCurrencyPreference\">\r\n                <option *ngFor=\"let currency of currencies\" [value]=\"currency.currencyCode\">{{currency.translationText}}</option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- Boiler house liquid fuel -->\r\n          <preference formControlName=\"boilerHouseLiquidFuelPreference\" unit-type=\"BoilerHouseLiquidFuelUnits\" unit-label=\"LIQUID_FUEL\" default-value=\"15\"></preference>\r\n\r\n          <!-- Boiler house electrical fuel -->\r\n          <preference formControlName=\"boilerHouseElectricalFuelPreference\" unit-type=\"BoilerHouseElectricalFuelUnits\" unit-label=\"ELECTRICAL_FUEL\" default-value=\"108\"></preference>\r\n\r\n        </div>\r\n        <div class=\"col-md-6 col-xs-12\">\r\n\r\n          <div class=\"row\">\r\n            <div class=\"col-lg-offset-4 col-xs-4\">\r\n              <h6>{{\"UNITS\" | translate}}</h6>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- Boiler house volumetric flow -->\r\n          <preference formControlName=\"boilerHouseVolumetricFlowPreference\" unit-type=\"BoilerHouseVolumetricFlowUnits\" unit-label=\"VOLUMETRIC_FLOW\" default-value=\"227\"></preference>\r\n\r\n          <!-- Boiler house TDS -->\r\n          <preference formControlName=\"boilerHouseTdsPreference\" unit-type=\"BoilerHouseTDSUnits\" unit-label=\"TDS\" default-value=\"228\"></preference>\r\n\r\n          <!-- Boiler house energy -->\r\n          <preference formControlName=\"boilerHouseEnergyPreference\" unit-type=\"BoilerHouseEnergyUnits\" unit-label=\"ENERGY\" default-value=\"108\"></preference>\r\n\r\n          <!-- Boiler house Co2 emissions -->\r\n          <preference formControlName=\"boilerHouseCo2EmissionsPreference\" unit-type=\"BoilerHouseEmissionUnits\" unit-label=\"CO2_EMISSIONS\" default-value=\"27\"></preference>\r\n\r\n          <!-- Boiler house gaseous fuel -->\r\n          <preference formControlName=\"boilerHouseGaseousFuelPreference\" unit-type=\"BoilerHouseGasFuelUnits\" unit-label=\"GASEOUS_FUEL\" default-value=\"108\"></preference>\r\n\r\n          <!-- Boiler house solid fuel -->\r\n          <preference formControlName=\"boilerHouseSolidFuelPreference\" unit-type=\"BoilerHouseSolidFuelUnits\" unit-label=\"SOLID_FUEL\" default-value=\"27\"></preference>\r\n\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n          <h4>{{\"BOILER_HOUSE_OPTIONS\" | translate}}</h4>\r\n          <hr />\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Boiler house reverse osmosis -->\r\n      <div class=\"form-group\">\r\n        <div class=\"col-lg-offset-2 col-md-6 col-xs-12\">\r\n\r\n          <div class=\"checkbox c-checkbox\">\r\n            <label>\r\n              <input autocomplete=\"off\" type=\"checkbox\"\r\n                     class=\"control-check\"\r\n                     formControlName=\"reverseOsmosisPreference\"\r\n                     (change)=\"setReverseOsmosis(reverseOsmosisRef)\"\r\n                     [checked]=\"reverseOsmosis.value === '1'\"\r\n                     #reverseOsmosisRef />\r\n\r\n              <span class=\"fa fa-check\"></span>{{\"REVERSE_OSMOSIS\" | translate}}\r\n            </label>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n          <h4>{{\"FINANCIAL_DETAILS\" | translate}}</h4>\r\n          <hr />\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6 col-xs-12\">\r\n\r\n          <!-- Tax rate -->\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"col-lg-4 col-md-12 col-xs-12 text-right\">\r\n              <label for=\"name\" class=\"control-label\">{{\"TAX\" | translate}}</label>\r\n            </div>\r\n\r\n            <div class=\"col-lg-4\">\r\n              <div class=\"input-group\">\r\n                <input autocomplete=\"off\" type=\"text\" class=\"form-control\" formControlName=\"taxRatePreference\" />\r\n                <span class=\"input-group-addon\">%</span>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"col-lg-4 col-xs-12\">\r\n              <span class=\"text-danger\" *ngIf=\"preferencesForm.controls['taxRatePreference'].hasError('required') && (preferencesForm.controls['taxRatePreference'].dirty || preferencesForm.controls['taxRatePreference'].touched)\">{{ \"TAX_RATE_REQUIRED_MESSAGE\" | translate }}</span>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- Annual allowance -->\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"col-lg-4 col-md-12 col-xs-12 text-right\">\r\n              <label for=\"name\" class=\"control-label\">{{\"ANNUAL_INFLATION\" | translate}}</label>\r\n            </div>\r\n\r\n            <div class=\"col-lg-4\">\r\n              <div class=\"input-group\">\r\n                <input autocomplete=\"off\" type=\"text\" class=\"form-control\" formControlName=\"annualInflationPreference\" />\r\n                <span class=\"input-group-addon\">%</span>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"col-lg-4 col-xs-12\">\r\n              <span class=\"text-danger\" *ngIf=\"preferencesForm.controls['annualInflationPreference'].hasError('required') && (preferencesForm.controls['annualInflationPreference'].dirty || preferencesForm.controls['annualInflationPreference'].touched)\">{{ \"ANNUAL_INFLATION_REQUIRED_MESSAGE\" | translate }}</span>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n\r\n\r\n        <div class=\"col-md-6 col-xs-12\">\r\n\r\n          <!-- Capital allowance -->\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"col-lg-4 col-md-12 col-xs-12 text-right\">\r\n              <label for=\"name\" class=\"control-label\">{{\"CAPITAL_ALLOWANCE_RATE\" | translate}}</label>\r\n            </div>\r\n\r\n\r\n            <div class=\"col-lg-4\">\r\n              <div class=\"input-group\">\r\n                <input autocomplete=\"off\" type=\"text\" class=\"form-control\" formControlName=\"capitalAllowancePreference\" />\r\n                <span class=\"input-group-addon\">%</span>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"col-lg-4 col-xs-12\">\r\n              <span class=\"text-danger\" *ngIf=\"preferencesForm.controls['capitalAllowancePreference'].hasError('required') && (preferencesForm.controls['capitalAllowancePreference'].dirty || preferencesForm.controls['capitalAllowancePreference'].touched)\">{{ \"CAPITAL_ALLOWANCE_REQUIRED_MESSAGE\" | translate }}</span>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n\r\n      </div>\r\n\r\n\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n          <h4>{{\"DESIGN_STANDARDS\" | translate}}</h4>\r\n          <hr />\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6 col-xs-12\">\r\n\r\n          <!-- Desingn Standard -->\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"col-lg-4 col-md-12 col-xs-12 text-right\">\r\n              <label for=\"name\" class=\"control-label\">{{\"CONTROL_VALVE_DESIGN_STANDARD\" | translate}}</label>\r\n            </div>\r\n            <div class=\"col-lg-4 col-md-12 col-xs-12\">\r\n              <!-- Build Enumeration for cvDesignStandardPreference -->\r\n              <enumeration formControlName=\"cvDesignStandardPreference\" enumeration-name=\"DesignStd1_Platform\"></enumeration>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12 \">\r\n          <h4>{{\"DOCUMENTATION\" | translate}}</h4>\r\n          <hr />\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6 col-xs-12\">\r\n\r\n          <!-- Spec sheet language -->\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"col-lg-4 col-md-12 col-xs-12 text-right\">\r\n              <label for=\"name\" class=\"control-label\">{{\"SPECIFICATION_SHEET\" | translate}}</label>\r\n            </div>\r\n\r\n            <div class=\"col-lg-4 col-md-12 col-xs-12\">\r\n              <select class=\"form-control\" formControlName=\"specLanguagePreference\" id=\"specLanguageSelection\" name=\"specLanguageSelection\">\r\n                <option *ngFor=\"let language of languages\" [value]=\"language.isoName\">{{language.masterTextKey | translate}}</option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <!--<div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n          <h4>{{\"DOWNLOADABLE_VERSION\" | translate}}</h4>\r\n          <hr />\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6 col-xs-12\">-->\r\n\r\n          <!-- Offline client download -->\r\n          <!--<div class=\"form-group\">\r\n\r\n            <div class=\"col-lg-4 col-md-12 col-xs-12 text-right\">\r\n              <label for=\"name\" class=\"control-label\">{{\"AVAILABLE_TO\" | translate}}</label>\r\n            </div>\r\n\r\n            <div class=\"col-lg-offset-2 col-lg-8 col-xs-12\">\r\n              <div class=\"radio c-radio c-radio-nofont\">\r\n                <label>\r\n                  <input autocomplete=\"off\" type=\"radio\" value=\"0\" formControlName=\"clientDownloadPreference\" />\r\n                  <span></span>{{\"NONE\" | translate}}\r\n                </label>\r\n              </div>\r\n              <div class=\"radio c-radio c-radio-nofont\">\r\n                <label>\r\n                  <input autocomplete=\"off\" type=\"radio\" value=\"1\" formControlName=\"clientDownloadPreference\" />\r\n                  <span></span>{{\"SPIRAX_EMPLOYEES\" | translate}}\r\n                </label>\r\n              </div>\r\n              <div class=\"radio c-radio c-radio-nofont\">\r\n                <label>\r\n                  <input autocomplete=\"off\" type=\"radio\" value=\"2\" formControlName=\"clientDownloadPreference\" />\r\n                  <span></span>{{\"FREE_TO_ALL\" | translate}}\r\n                </label>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n\r\n        </div>\r\n      </div>-->\r\n\r\n      <!--<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <button [disabled]=\"!preferencesForm.dirty || !preferencesForm.valid || preferencesForm.status !== 'VALID' || formSubmitted\" type=\"submit\" class=\"btn btn-block btn-dynamic btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i></button>\r\n    </div>\r\n  </div>-->\r\n\r\n    </div>\r\n  </div>\r\n</form>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
OperatingCompanyPreferencesComponent.ctorParameters = () => [
    { type: AdminService },
    { type: PreferenceService },
    { type: FormBuilder }
];
if (false) {
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.arePreferencesLoaded;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.isSuccess;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.alertVisible;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.formSubmitted;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.preferencesForm;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.currencies;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.languages;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.boilerHouseCurrency;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.reverseOsmosis;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.taxRate;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.annualInflation;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.capitalAllowance;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.cvDesignStandard;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.specLanguage;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.clientDownload;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.pressurePrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.areaPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.temperaturePrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.forcePrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.massFlowPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.lengthPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.volumetricFlowPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.weightPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.capacityPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.velocityPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.loadPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.energyPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.gaseousFuelPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.liquidFuelPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.solidFuelPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.boilerHouseVolumePrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.boilerHouseVolumetricFlowPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.boilerHouseWeightPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.boilerHouseTdsPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.boilerHouseMassFlowPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.boilerHouseEnergyPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.boilerHouseSpecificEnergyPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.boilerHouseCo2EmissionsPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.boilerHouseCurrencyPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.boilerHouseGaseousFuelPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.boilerHouseLiquidFuelPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.boilerHouseSolidFuelPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.boilerHouseElectricalFuelPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.currencyPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.reverseOsmosisPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.taxRatePrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.annualInflationPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.capitalAllowancePrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.cvDesignStandardPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.specLanguagePrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.clientDownloadPrefFormControl;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.theFormGroup;
    /** @type {?} */
    OperatingCompanyPreferencesComponent.prototype.hasUnsavedDataChanges;
    /**
     * @type {?}
     * @private
     */
    OperatingCompanyPreferencesComponent.prototype.adminService;
    /**
     * @type {?}
     * @private
     */
    OperatingCompanyPreferencesComponent.prototype.preferenceService;
    /**
     * @type {?}
     * @private
     */
    OperatingCompanyPreferencesComponent.prototype.fb;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/admin/user-preferences/user-preferences.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UserPreferencesComponent {
    /**
     * @param {?} adminService
     * @param {?} preferenceService
     * @param {?} fb
     */
    constructor(adminService, preferenceService, fb) {
        this.adminService = adminService;
        this.preferenceService = preferenceService;
        this.fb = fb;
        this.arePreferencesLoaded = false;
        this.isSuccess = false;
        this.alertVisible = false;
        this.formSubmitted = false;
        this.theFormGroup = this.preferencesForm;
        // Units of measure
        this.pressurePrefFormControl = new FormControl('');
        this.areaPrefFormControl = new FormControl('');
        this.temperaturePrefFormControl = new FormControl('');
        this.forcePrefFormControl = new FormControl('');
        this.massFlowPrefFormControl = new FormControl('');
        this.lengthPrefFormControl = new FormControl('');
        this.volumetricFlowPrefFormControl = new FormControl('');
        this.weightPrefFormControl = new FormControl('');
        this.capacityPrefFormControl = new FormControl('');
        this.velocityPrefFormControl = new FormControl('');
        this.loadPrefFormControl = new FormControl('');
        this.energyPrefFormControl = new FormControl('');
        this.gaseousFuelPrefFormControl = new FormControl('');
        this.liquidFuelPrefFormControl = new FormControl('');
        this.solidFuelPrefFormControl = new FormControl('');
        // Boiler house units
        this.boilerHouseVolumePrefFormControl = new FormControl('');
        this.boilerHouseVolumetricFlowPrefFormControl = new FormControl('');
        this.boilerHouseWeightPrefFormControl = new FormControl('');
        this.boilerHouseTdsPrefFormControl = new FormControl('');
        this.boilerHouseMassFlowPrefFormControl = new FormControl('');
        this.boilerHouseEnergyPrefFormControl = new FormControl('');
        this.boilerHouseSpecificEnergyPrefFormControl = new FormControl('');
        this.boilerHouseCo2EmissionsPrefFormControl = new FormControl('');
        this.boilerHouseCurrencyPrefFormControl = new FormControl('');
        this.boilerHouseGaseousFuelPrefFormControl = new FormControl('');
        this.boilerHouseLiquidFuelPrefFormControl = new FormControl('');
        this.boilerHouseSolidFuelPrefFormControl = new FormControl('');
        this.boilerHouseElectricalFuelPrefFormControl = new FormControl('');
        // Others
        this.hideSalesPriceFormControl = new FormControl('');
        this.hideManufactureCostsFormControl = new FormControl('');
        this.cvDesignStandardPrefFormControl = new FormControl('EN');
        this.specLanguagePrefFormControl = new FormControl('');
        // Setup the form group.
        this.preferencesForm = this.fb.group({
            pressurePreference: this.pressurePrefFormControl,
            areaPreference: this.areaPrefFormControl,
            temperaturePreference: this.temperaturePrefFormControl,
            forcePreference: this.forcePrefFormControl,
            massFlowPreference: this.massFlowPrefFormControl,
            lengthPreference: this.lengthPrefFormControl,
            volumetricFlowPreference: this.volumetricFlowPrefFormControl,
            weightPreference: this.weightPrefFormControl,
            capacityPreference: this.capacityPrefFormControl,
            velocityPreference: this.velocityPrefFormControl,
            loadPreference: this.loadPrefFormControl,
            energyPreference: this.energyPrefFormControl,
            gaseousFuelPreference: this.gaseousFuelPrefFormControl,
            liquidFuelPreference: this.liquidFuelPrefFormControl,
            solidFuelPreference: this.solidFuelPrefFormControl,
            // Boiler house units
            boilerHouseVolumePreference: this.boilerHouseVolumePrefFormControl,
            boilerHouseVolumetricFlowPreference: this.boilerHouseVolumetricFlowPrefFormControl,
            boilerHouseWeightPreference: this.boilerHouseWeightPrefFormControl,
            boilerHouseTdsPreference: this.boilerHouseTdsPrefFormControl,
            boilerHouseMassFlowPreference: this.boilerHouseMassFlowPrefFormControl,
            boilerHouseEnergyPreference: this.boilerHouseEnergyPrefFormControl,
            boilerHouseSpecificEnergyPreference: this.boilerHouseSpecificEnergyPrefFormControl,
            boilerHouseCo2EmissionsPreference: this.boilerHouseCo2EmissionsPrefFormControl,
            boilerHouseCurrencyPreference: this.boilerHouseCurrencyPrefFormControl,
            boilerHouseGaseousFuelPreference: this.boilerHouseGaseousFuelPrefFormControl,
            boilerHouseLiquidFuelPreference: this.boilerHouseLiquidFuelPrefFormControl,
            boilerHouseSolidFuelPreference: this.boilerHouseSolidFuelPrefFormControl,
            boilerHouseElectricalFuelPreference: this.boilerHouseElectricalFuelPrefFormControl,
            // Others
            hideSalesPricePreference: this.hideSalesPriceFormControl,
            hideManufactureCostsPreference: this.hideManufactureCostsFormControl,
            cvDesignStandardPreference: this.cvDesignStandardPrefFormControl,
            specLanguagePreference: this.specLanguagePrefFormControl
        });
        this.theFormGroup = this.preferencesForm; // to drive GenericChangesGuard
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        // Fire off the service calls and wait for the observables to resolve themselves before subscribing by using the forkJoin function.
        Observable$1.forkJoin(this.preferenceService.getUserPreferences(), this.adminService.getCurrencyData(), this.adminService.getLanguages())
            .subscribe((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            /** @type {?} */
            let prefDetails = result[0];
            if (!this.currencies) {
                // Assign the currencies and sort them alphabetically by translated text.
                this.currencies = result[1].sort((/**
                 * @param {?} currentCurrency
                 * @param {?} nextCurrency
                 * @return {?}
                 */
                (currentCurrency, nextCurrency) => {
                    if (currentCurrency.translationText > nextCurrency.translationText) {
                        return 1;
                    }
                    if (currentCurrency.translationText < nextCurrency.translationText) {
                        return -1;
                    }
                    return 0;
                }));
            }
            if (!this.languages) {
                // Assign the languages and sort them alphabetically by name.
                this.languages = result[2].sort((/**
                 * @param {?} currentLang
                 * @param {?} nextLang
                 * @return {?}
                 */
                (currentLang, nextLang) => {
                    if (currentLang.name > nextLang.name) {
                        return 1;
                    }
                    if (currentLang.name < nextLang.name) {
                        return -1;
                    }
                    return 0;
                }));
            }
            // Units of measure
            /**
             * Fetch all the various preferences.
             * @type {?}
             */
            const pressurePref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "PressureUnit");
            /** @type {?} */
            const areaPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "AreaUnit");
            /** @type {?} */
            const temperaturePref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "TemperatureUnit");
            /** @type {?} */
            const forcePref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "ForceUnit");
            /** @type {?} */
            const massFlowPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "MassFlowUnit");
            /** @type {?} */
            const lengthPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "LengthUnit");
            /** @type {?} */
            const volumetricFlowPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "VolumetricFlowUnit");
            /** @type {?} */
            const weightPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "WeightUnit");
            /** @type {?} */
            const capacityPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "CapacityUnit");
            /** @type {?} */
            const velocityPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "VelocityUnit");
            /** @type {?} */
            const loadPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "LoadUnit");
            /** @type {?} */
            const energyPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "EnergyUnits");
            /** @type {?} */
            const gaseousFuelPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "GaseousFuelUnits");
            /** @type {?} */
            const liquidFuel = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "LiquidFuelUnits");
            /** @type {?} */
            const solidFuelPref = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "SolidFuelUnits");
            // Boiler house units
            /** @type {?} */
            const boilerHouseVolume = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseVolumeUnits");
            /** @type {?} */
            const boilerHouseVolumetricFlow = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseVolumetricFlowUnits");
            /** @type {?} */
            const boilerHouseWeight = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseWeightUnits");
            /** @type {?} */
            const boilerHouseTds = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseTDSUnits");
            /** @type {?} */
            const boilerHouseMassFlow = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseMassFlowUnits");
            /** @type {?} */
            const boilerHouseEnergy = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseEnergyUnits");
            /** @type {?} */
            const boilerHouseSpecificEnergy = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseSpecificEnergyUnits");
            /** @type {?} */
            const boilerHouseCo2Emissions = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseEmissionUnits");
            /** @type {?} */
            const boilerHouseGaseousFuel = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseGasFuelUnits");
            /** @type {?} */
            const boilerHouseLiquidFuel = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseLiquidFuelUnits");
            /** @type {?} */
            const boilerHouseSolidFuel = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseSolidFuelUnits");
            /** @type {?} */
            const boilerHouseElectricalFuel = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BoilerHouseElectricalFuelUnits");
            // Others
            this.boilerHouseCurrency = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "BHCurrency");
            this.hideSalesPrice = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "EHHideSalesPrice");
            this.hideManufactureCosts = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "EHHideManufactureCosts");
            this.cvDesignStandard = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "CvDesignStandard");
            this.specLanguage = this.preferenceService.rationalisePreferenceObjectByName(prefDetails, "SpecLanguage");
            /**
             * Set the preferences to the form controls.
             */
            // Units of measure
            this.pressurePrefFormControl.setValue(pressurePref);
            this.areaPrefFormControl.setValue(areaPref);
            this.temperaturePrefFormControl.setValue(temperaturePref);
            this.forcePrefFormControl.setValue(forcePref);
            this.massFlowPrefFormControl.setValue(massFlowPref);
            this.lengthPrefFormControl.setValue(lengthPref);
            this.volumetricFlowPrefFormControl.setValue(volumetricFlowPref);
            this.weightPrefFormControl.setValue(weightPref);
            this.capacityPrefFormControl.setValue(capacityPref);
            this.velocityPrefFormControl.setValue(velocityPref);
            this.loadPrefFormControl.setValue(loadPref);
            this.energyPrefFormControl.setValue(energyPref);
            this.gaseousFuelPrefFormControl.setValue(gaseousFuelPref);
            this.liquidFuelPrefFormControl.setValue(liquidFuel);
            this.solidFuelPrefFormControl.setValue(solidFuelPref);
            // Boiler house units
            this.boilerHouseVolumePrefFormControl.setValue(boilerHouseVolume);
            this.boilerHouseVolumetricFlowPrefFormControl.setValue(boilerHouseVolumetricFlow);
            this.boilerHouseWeightPrefFormControl.setValue(boilerHouseWeight);
            this.boilerHouseTdsPrefFormControl.setValue(boilerHouseTds);
            this.boilerHouseMassFlowPrefFormControl.setValue(boilerHouseMassFlow);
            this.boilerHouseEnergyPrefFormControl.setValue(boilerHouseEnergy);
            this.boilerHouseSpecificEnergyPrefFormControl.setValue(boilerHouseSpecificEnergy);
            this.boilerHouseCo2EmissionsPrefFormControl.setValue(boilerHouseCo2Emissions);
            this.boilerHouseGaseousFuelPrefFormControl.setValue(boilerHouseGaseousFuel);
            this.boilerHouseLiquidFuelPrefFormControl.setValue(boilerHouseLiquidFuel);
            this.boilerHouseSolidFuelPrefFormControl.setValue(boilerHouseSolidFuel);
            this.boilerHouseElectricalFuelPrefFormControl.setValue(boilerHouseElectricalFuel);
            // Others that are a bit more unique
            //Sets default currency to United Kingdom Pound if the currency is null.
            if (this.boilerHouseCurrency.value == null) {
                this.boilerHouseCurrency.value = "GBP";
            }
            this.boilerHouseCurrencyPrefFormControl.setValue(this.boilerHouseCurrency.value);
            this.hideSalesPriceFormControl.setValue(this.hideSalesPrice.value);
            this.hideManufactureCostsFormControl.setValue(this.hideManufactureCosts.value);
            this.cvDesignStandardPrefFormControl.setValue(this.cvDesignStandard.value);
            this.specLanguagePrefFormControl.setValue(this.specLanguage.value);
            // Inform the view that preferences are now loaded.
            this.arePreferencesLoaded = true;
        }));
    }
    /**
     * Rationalises the value for the Hide Sales Price check control.
     * @param {?} control The HTML checkbox.
     * @return {?}
     */
    setHideSalesPriceCheck(control) {
        this.hideSalesPrice.value = control.checked ? "1" : "0";
        this.hideSalesPriceFormControl.setValue(this.hideSalesPrice.value);
    }
    /**
     * Rationalises the value for the Hide Manufacturer Costs check control.
     * @param {?} control The HTML checkbox.
     * @return {?}
     */
    setHideManufactureCostsCheck(control) {
        this.hideManufactureCosts.value = control.checked ? "1" : "0";
        this.hideManufactureCostsFormControl.setValue(this.hideManufactureCosts.value);
    }
    /**
     * Submits the form for saving to the server.
     * @param {?} $ev The submission event.
     * @return {?}
     */
    submitForm($ev) {
        $ev.preventDefault();
        // Mark the form as submitted.
        this.formSubmitted = true;
        /** @type {?} */
        const newPreferences = [];
        // Get the currency
        /** @type {?} */
        const currencyPref = this.preferencesForm.controls["boilerHouseCurrencyPreference"];
        this.boilerHouseCurrency.value = currencyPref.value;
        newPreferences.push(this.boilerHouseCurrency);
        // Show/Hide Sales Price
        /** @type {?} */
        const hideSalesPricePref = this.preferencesForm.controls["hideSalesPricePreference"];
        this.hideSalesPrice.value = hideSalesPricePref.value === null ? "0" : hideSalesPricePref.value;
        newPreferences.push(this.hideSalesPrice);
        // Show/Hide Manufacturer Cost
        /** @type {?} */
        const hideManufacturerCost = this.preferencesForm.controls["hideManufactureCostsPreference"];
        this.hideManufactureCosts.value = hideManufacturerCost.value === null ? "0" : hideManufacturerCost.value;
        newPreferences.push(this.hideManufactureCosts);
        // CV Design standard
        /** @type {?} */
        const cvDesignStandardPref = this.preferencesForm.controls["cvDesignStandardPreference"];
        this.cvDesignStandard.value = cvDesignStandardPref.value;
        newPreferences.push(this.cvDesignStandard);
        // Spec language
        /** @type {?} */
        const specLanguagePref = this.preferencesForm.controls["specLanguagePreference"];
        this.specLanguage.value = specLanguagePref.value;
        newPreferences.push(this.specLanguage);
        // Get all the other preferences
        // Units of measure
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["pressurePreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["areaPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["temperaturePreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["forcePreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["massFlowPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["lengthPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["volumetricFlowPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["weightPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["capacityPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["velocityPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["loadPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["energyPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["gaseousFuelPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["liquidFuelPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["solidFuelPreference"].value)));
        // Boiler house units
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseVolumePreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseVolumetricFlowPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseWeightPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseTdsPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseMassFlowPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseEnergyPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseSpecificEnergyPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseCo2EmissionsPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseGaseousFuelPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseLiquidFuelPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseSolidFuelPreference"].value)));
        newPreferences.push((/** @type {?} */ (this.preferencesForm.controls["boilerHouseElectricalFuelPreference"].value)));
        // Save the changed preferences as an array of preferences
        this.preferenceService.manageUserPreferences(newPreferences).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            // Mark the form as submitted
            this.formSubmitted = false;
            // Set the operation based on the response.
            this.isSuccess = response;
            this.alertVisible = true;
            // Set the form back to pristine only if the data has been saved successfully.
            if (this.isSuccess) {
                this.preferenceService.clearUnitPreferences();
                this.preferencesForm.markAsPristine();
            }
        }));
    }
    /**
     * @return {?}
     */
    closeAlert() {
        // Reset the flag
        this.alertVisible = false;
    }
    /**
     * @param {?} componentRef
     * @return {?}
     */
    onDeactivate(componentRef) {
        console.info(`Deactivating`);
    }
}
UserPreferencesComponent.decorators = [
    { type: Component, args: [{
                selector: 'user-preferences',
                template: "<form [formGroup]=\"preferencesForm\" class=\"form-horizontal\" role=\"form\" (submit)=\"submitForm($event)\" novalidate>\r\n  <div class='panel panel-primary' *ngIf=\"!!arePreferencesLoaded\">\r\n    <div class='panel-body'>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n          <h4>{{\"UNITS_OF_MEASURE\" | translate}}</h4>\r\n          <hr />\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n          <button [disabled]=\"!preferencesForm.dirty || !preferencesForm.valid || preferencesForm.status !== 'VALID' || formSubmitted\" type=\"submit\" class=\"btn btn-dynamic btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i></button>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Success confirmation message -->\r\n      <alert-block *ngIf=\"!!alertVisible && !!isSuccess\" type=\"success\" [auto-close]=\"true\" [message]=\"'USER_PREFERENCES_SAVED_SUCCESSFULLY_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n      <!-- Failure confirmation message-->\r\n      <alert-block *ngIf=\"!!alertVisible && !isSuccess\" type=\"danger\" [message]=\"'USER_PREFERENCES_FAILED_TO_SAVE_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n      <!-- Control headings  -->\r\n      <div class=\"row\">\r\n        <!-- Left section -->\r\n        <div class=\"col-md-6 col-xs-12\">\r\n\r\n          <div class=\"row\">\r\n            <div class=\"col-lg-2 col-lg-offset-3 col-xs-4\">\r\n              <h6>{{\"DECIMALS\" | translate}}</h6>\r\n            </div>\r\n            <div class=\"col-lg-4 col-xs-8\">\r\n              <h6>{{\"UNITS\" | translate}}</h6>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- Pressure -->\r\n          <preference formControlName=\"pressurePreference\" requires-decimals=\"true\" unit-type=\"PressureUnits\" unit-label=\"PRESSURE\" default-value=\"50\"></preference>\r\n\r\n          <!-- Temperature -->\r\n          <preference formControlName=\"temperaturePreference\" requires-decimals=\"true\" unit-type=\"TemperatureUnits\" unit-label=\"TEMPERATURE\" default-value=\"146\"></preference>\r\n\r\n          <!-- Mass Flow -->\r\n          <preference formControlName=\"massFlowPreference\" requires-decimals=\"true\" unit-type=\"MassFlowUnits\" unit-label=\"MASS_FLOW\" default-value=\"84\"></preference>\r\n\r\n          <!-- Volumetric Flow -->\r\n          <preference formControlName=\"volumetricFlowPreference\" requires-decimals=\"true\" unit-type=\"VolumetricFlowUnits\" unit-label=\"VOLUMETRIC_FLOW\" default-value=\"75\"></preference>\r\n\r\n          <!-- Capacity -->\r\n          <preference formControlName=\"capacityPreference\" requires-decimals=\"true\" unit-type=\"CapacityUnits\" unit-label=\"CAPACITY\" default-value=\"88\"></preference>\r\n\r\n          <!-- Load -->\r\n          <preference formControlName=\"loadPreference\" requires-decimals=\"true\" unit-type=\"LoadUnits\" unit-label=\"LOAD\" default-value=\"97\"></preference>\r\n\r\n          <!-- Gaseous Fuel -->\r\n          <preference formControlName=\"gaseousFuelPreference\" requires-decimals=\"true\" unit-type=\"GaseousFuelUnits\" unit-label=\"GASEOUS_FUEL\" default-value=\"16\"></preference>\r\n\r\n          <!-- Solid Fuel -->\r\n          <preference formControlName=\"solidFuelPreference\" requires-decimals=\"true\" unit-type=\"SolidFuelUnits\" unit-label=\"SOLID_FUEL\" default-value=\"26\"></preference>\r\n\r\n        </div>\r\n\r\n        <!-- Right section -->\r\n        <div class=\"col-md-6 col-xs-12\">\r\n\r\n          <div class=\"row\">\r\n            <div class=\"col-lg-2 col-lg-offset-3 col-xs-4\">\r\n              <h6>{{\"DECIMALS\" | translate}}</h6>\r\n            </div>\r\n            <div class=\"col-lg-4 col-xs-8\">\r\n              <h6>{{\"UNITS\" | translate}}</h6>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- Area -->\r\n          <preference formControlName=\"areaPreference\" requires-decimals=\"true\" unit-type=\"AreaUnits\" unit-label=\"AREA\" default-value=\"11\"></preference>\r\n\r\n          <!-- Force -->\r\n          <preference formControlName=\"forcePreference\" requires-decimals=\"true\" unit-type=\"ForceUnits\" unit-label=\"FORCE\" default-value=\"93\"></preference>\r\n\r\n          <!-- Length -->\r\n          <preference formControlName=\"lengthPreference\" requires-decimals=\"true\" unit-type=\"LengthUnits\" unit-label=\"LENGTH\" default-value=\"3\"></preference>\r\n\r\n          <!-- Weight -->\r\n          <preference formControlName=\"weightPreference\" requires-decimals=\"true\" unit-type=\"WeightUnits\" unit-label=\"WEIGHT\" default-value=\"26\"></preference>\r\n\r\n          <!-- Velocity -->\r\n          <preference formControlName=\"velocityPreference\" requires-decimals=\"true\" unit-type=\"VelocityUnits\" unit-label=\"VELOCITY\" default-value=\"139\"></preference>\r\n\r\n          <!-- Energy -->\r\n          <preference formControlName=\"energyPreference\" requires-decimals=\"true\" unit-type=\"EnergyUnits\" unit-label=\"ENERGY\" default-value=\"108\"></preference>\r\n\r\n          <!-- Liquid Fuel -->\r\n          <preference formControlName=\"liquidFuelPreference\" requires-decimals=\"true\" unit-type=\"LiquidFuelUnits\" unit-label=\"LIQUID_FUEL\" default-value=\"15\"></preference>\r\n\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Boiler House units of measure -->\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12 \">\r\n          <h4>{{\"BOILER_HOUSE_UNITS_OF_MEASURE\" | translate}}</h4>\r\n          <hr />\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Grid heading -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6 col-xs-12\">\r\n\r\n          <div class=\"row\">\r\n            <div class=\"col-lg-offset-4 col-xs-4\">\r\n              <h6>{{\"UNITS\" | translate}}</h6>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- Boiler house volume -->\r\n          <preference formControlName=\"boilerHouseVolumePreference\" unit-type=\"BoilerHouseVolumeUnits\" unit-label=\"VOLUME\" default-value=\"16\"></preference>\r\n\r\n          <!-- Boiler house weight -->\r\n          <preference formControlName=\"boilerHouseWeightPreference\" unit-type=\"BoilerHouseWeightUnits\" unit-label=\"WEIGHT\" default-value=\"27\"></preference>\r\n\r\n          <!-- Boiler house mass flow -->\r\n          <preference formControlName=\"boilerHouseMassFlowPreference\" unit-type=\"BoilerHouseMassFlowUnits\" unit-label=\"MASS_FLOW\" default-value=\"229\"></preference>\r\n\r\n          <!-- Boiler house specific energy -->\r\n          <preference formControlName=\"boilerHouseSpecificEnergyPreference\" unit-type=\"BoilerHouseSpecificEnergyUnits\" unit-label=\"SPECIFIC_ENERGY\" default-value=\"223\"></preference>\r\n\r\n          <!-- Currencies are unique here -->\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"col-lg-4 col-md-12 col-xs-12 text-right\">\r\n              <label for=\"name\" class=\"control-label\">{{\"CURRENCY\" | translate}}</label>\r\n            </div>\r\n\r\n            <div class=\"col-lg-4 col-md-6 col-xs-12\">\r\n              <select class=\"form-control\" formControlName=\"boilerHouseCurrencyPreference\">\r\n                <option *ngFor=\"let currency of currencies\" [value]=\"currency.currencyCode\">{{currency.translationText}}</option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- Boiler house liquid fuel -->\r\n          <preference formControlName=\"boilerHouseLiquidFuelPreference\" unit-type=\"BoilerHouseLiquidFuelUnits\" unit-label=\"LIQUID_FUEL\" default-value=\"15\"></preference>\r\n\r\n          <!-- Boiler house electrical fuel -->\r\n          <preference formControlName=\"boilerHouseElectricalFuelPreference\" unit-type=\"BoilerHouseElectricalFuelUnits\" unit-label=\"ELECTRICAL_FUEL\" default-value=\"108\"></preference>\r\n\r\n        </div>\r\n        <div class=\"col-md-6 col-xs-12\">\r\n\r\n          <div class=\"row\">\r\n            <div class=\"col-lg-offset-4 col-xs-4\">\r\n              <h6>{{\"UNITS\" | translate}}</h6>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- Boiler house volumetric flow -->\r\n          <preference formControlName=\"boilerHouseVolumetricFlowPreference\" unit-type=\"BoilerHouseVolumetricFlowUnits\" unit-label=\"VOLUMETRIC_FLOW\" default-value=\"227\"></preference>\r\n\r\n          <!-- Boiler house TDS -->\r\n          <preference formControlName=\"boilerHouseTdsPreference\" unit-type=\"BoilerHouseTDSUnits\" unit-label=\"TDS\" default-value=\"228\"></preference>\r\n\r\n          <!-- Boiler house energy -->\r\n          <preference formControlName=\"boilerHouseEnergyPreference\" unit-type=\"BoilerHouseEnergyUnits\" unit-label=\"ENERGY\" default-value=\"108\"></preference>\r\n\r\n          <!-- Boiler house Co2 emissions -->\r\n          <preference formControlName=\"boilerHouseCo2EmissionsPreference\" unit-type=\"BoilerHouseEmissionUnits\" unit-label=\"CO2_EMISSIONS\" default-value=\"27\"></preference>\r\n\r\n          <!-- Boiler house gaseous fuel -->\r\n          <preference formControlName=\"boilerHouseGaseousFuelPreference\" unit-type=\"BoilerHouseGasFuelUnits\" unit-label=\"GASEOUS_FUEL\" default-value=\"108\"></preference>\r\n\r\n          <!-- Boiler house solid fuel -->\r\n          <preference formControlName=\"boilerHouseSolidFuelPreference\" unit-type=\"BoilerHouseSolidFuelUnits\" unit-label=\"SOLID_FUEL\" default-value=\"27\"></preference>\r\n\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <!-- Pricing -->\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12 \">\r\n          <h4>{{\"PRICING_OPTIONS\" | translate}}</h4>\r\n          <hr />\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Show/Hide Preferences for Easiheat pricing -->\r\n      <div class=\"form-group\">\r\n\r\n        <!-- Sales Price -->\r\n        <div class=\"col-lg-offset-2 col-md-6 col-xs-12\">\r\n\r\n          <div class=\"checkbox c-checkbox\">\r\n            <label>\r\n              <input autocomplete=\"off\" type=\"checkbox\"\r\n                     class=\"control-check\"\r\n                     formControlName=\"hideSalesPricePreference\"\r\n                     (change)=\"setHideSalesPriceCheck(hideSalesPriceRef)\"\r\n                     [checked]=\"hideSalesPrice.value === '1'\"\r\n                     #hideSalesPriceRef />\r\n\r\n              <span class=\"fa fa-check\"></span>{{\"HIDE_ALL_PRICING\" | translate}}\r\n            </label>\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <!-- Manufacturer Costs -->\r\n        <div class=\"col-lg-offset-2 col-md-6 col-xs-12\">\r\n\r\n          <div class=\"checkbox c-checkbox\">\r\n            <label>\r\n              <input autocomplete=\"off\" type=\"checkbox\"\r\n                     class=\"control-check\"\r\n                     formControlName=\"hideManufactureCostsPreference\"\r\n                     (change)=\"setHideManufactureCostsCheck(hideManufactureCostsRef)\"\r\n                     [checked]=\"hideManufactureCosts.value === '1'\"\r\n                     #hideManufactureCostsRef />\r\n\r\n              <span class=\"fa fa-check\"></span>{{\"HIDE_MANUFACTURE_COSTS\" | translate}}\r\n            </label>\r\n          </div>\r\n\r\n        </div>\r\n\r\n      </div>\r\n\r\n\r\n\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n          <h4>{{\"DESIGN_STANDARDS\" | translate}}</h4>\r\n          <hr />\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6 col-xs-12\">\r\n\r\n          <!-- Desingn Standard -->\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"col-lg-4 col-md-12 col-xs-12 text-right\">\r\n              <label for=\"name\" class=\"control-label\">{{\"CONTROL_VALVE_DESIGN_STANDARD\" | translate}}</label>\r\n            </div>\r\n            <div class=\"col-lg-4 col-md-12 col-xs-12\">\r\n              <!-- Build Enumeration for cvDesignStandardPreference -->\r\n              <enumeration formControlName=\"cvDesignStandardPreference\" enumeration-name=\"DesignStd1_Platform\"></enumeration>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12 \">\r\n          <h4>{{\"DOCUMENTATION\" | translate}}</h4>\r\n          <hr />\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6 col-xs-12\">\r\n\r\n          <!-- Spec sheet language -->\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"col-lg-4 col-md-12 col-xs-12 text-right\">\r\n              <label for=\"name\" class=\"control-label\">{{\"SPECIFICATION_SHEET\" | translate}}</label>\r\n            </div>\r\n\r\n            <div class=\"col-lg-4 col-md-12 col-xs-12\">\r\n              <select class=\"form-control\" formControlName=\"specLanguagePreference\" id=\"specLanguageSelection\" name=\"specLanguageSelection\">\r\n                <option *ngFor=\"let language of languages\" [value]=\"language.isoName\">{{language.masterTextKey | translate}}</option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n\r\n      <!--<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <button [disabled]=\"!preferencesForm.dirty || !preferencesForm.valid || preferencesForm.status !== 'VALID' || formSubmitted\" type=\"submit\" class=\"btn btn-block btn-dynamic btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i></button>\r\n    </div>\r\n  </div>-->\r\n\r\n    </div>\r\n  </div>\r\n</form>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
UserPreferencesComponent.ctorParameters = () => [
    { type: AdminService },
    { type: PreferenceService },
    { type: FormBuilder }
];
if (false) {
    /** @type {?} */
    UserPreferencesComponent.prototype.arePreferencesLoaded;
    /** @type {?} */
    UserPreferencesComponent.prototype.isSuccess;
    /** @type {?} */
    UserPreferencesComponent.prototype.alertVisible;
    /** @type {?} */
    UserPreferencesComponent.prototype.formSubmitted;
    /** @type {?} */
    UserPreferencesComponent.prototype.currencies;
    /** @type {?} */
    UserPreferencesComponent.prototype.languages;
    /** @type {?} */
    UserPreferencesComponent.prototype.boilerHouseCurrency;
    /** @type {?} */
    UserPreferencesComponent.prototype.hideSalesPrice;
    /** @type {?} */
    UserPreferencesComponent.prototype.hideManufactureCosts;
    /** @type {?} */
    UserPreferencesComponent.prototype.cvDesignStandard;
    /** @type {?} */
    UserPreferencesComponent.prototype.specLanguage;
    /** @type {?} */
    UserPreferencesComponent.prototype.preferencesForm;
    /** @type {?} */
    UserPreferencesComponent.prototype.theFormGroup;
    /** @type {?} */
    UserPreferencesComponent.prototype.hasUnsavedDataChanges;
    /** @type {?} */
    UserPreferencesComponent.prototype.pressurePrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.areaPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.temperaturePrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.forcePrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.massFlowPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.lengthPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.volumetricFlowPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.weightPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.capacityPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.velocityPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.loadPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.energyPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.gaseousFuelPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.liquidFuelPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.solidFuelPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.boilerHouseVolumePrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.boilerHouseVolumetricFlowPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.boilerHouseWeightPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.boilerHouseTdsPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.boilerHouseMassFlowPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.boilerHouseEnergyPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.boilerHouseSpecificEnergyPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.boilerHouseCo2EmissionsPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.boilerHouseCurrencyPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.boilerHouseGaseousFuelPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.boilerHouseLiquidFuelPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.boilerHouseSolidFuelPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.boilerHouseElectricalFuelPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.currencyPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.hideSalesPriceFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.hideManufactureCostsFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.cvDesignStandardPrefFormControl;
    /** @type {?} */
    UserPreferencesComponent.prototype.specLanguagePrefFormControl;
    /**
     * @type {?}
     * @private
     */
    UserPreferencesComponent.prototype.adminService;
    /**
     * @type {?}
     * @private
     */
    UserPreferencesComponent.prototype.preferenceService;
    /**
     * @type {?}
     * @private
     */
    UserPreferencesComponent.prototype.fb;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/admin/module-preferences/module-preferences.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModulePreferencesComponent {
    /**
     * @param {?} adminService
     */
    constructor(adminService) {
        this.adminService = adminService;
        this.requiredModules = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        //this.requiredModules.push({ allowsProductSelection: false, imageSrc: null, isVetted: false, masterTextKey:"delayCheck", moduleGroupId: 12, modules: null, name:"delayCheck", requiresPreferences:false, showPricing: false});
        this.adminService.getModuleRequiredPreferences().subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            //removed EasiHeat for CSG release
            //for (let module of response) {
            //  if (module.name == "EasiHeat") {
            //    response.splice(0, 1);
            //  }
            //}
            this.requiredModules = response;
        }));
    }
}
ModulePreferencesComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-module-preferences',
                template: "<div class=\"row\" *ngIf=\"!!requiredModules && requiredModules.length > 0; else noModules\">\r\n  <div class=\"col-lg-1 col-md-2 col-xs-12\">\r\n    <!-- Show the module ribbon here -->\r\n    <module-ribbon [module-groups]=\"requiredModules\" [module-identifier]=\"'isModulePreference'\"></module-ribbon>\r\n  </div>\r\n\r\n  <div class=\"col-lg-11 col-md-10 col-xs-12\">\r\n    <router-outlet></router-outlet>\r\n  </div>\r\n</div>\r\n\r\n<!-- Shown when there are no modules -->\r\n<ng-template #noModules>\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <alert type=\"info\">{{'NO_ACCESS_TO_MODULES_MESSAGE' | translate:true}}</alert>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
ModulePreferencesComponent.ctorParameters = () => [
    { type: AdminService }
];
if (false) {
    /** @type {?} */
    ModulePreferencesComponent.prototype.requiredModules;
    /**
     * @type {?}
     * @private
     */
    ModulePreferencesComponent.prototype.adminService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/admin/module-access/module-access.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModuleAccessComponent {
    /**
     * @param {?} adminService
     * @param {?} activatedRoute
     * @param {?} menuService
     * @param {?} fb
     * @param {?} translatePipe
     */
    constructor(adminService, activatedRoute, menuService, fb, translatePipe) {
        this.adminService = adminService;
        this.activatedRoute = activatedRoute;
        this.menuService = menuService;
        this.fb = fb;
        this.translatePipe = translatePipe;
        this.selectedVettedUsers = [];
        this.selectedNonVettedUsers = [];
        this.vettedTableSelected = false;
        this.nonVettedTableSelected = false;
        this.userSelected = false;
        this.moduleChangesMade = false;
        this.userSearchFilter = null;
        this.accessibleModules = [];
        // Setup the access level labels.
        this.noPricingLabel = this.translatePipe.transform("NO_PRICING", false);
        this.sellingPricesLabel = this.translatePipe.transform("SELLING_PRICES", false);
        this.allPricesLabel = this.translatePipe.transform("ALL_PRICING", false);
        this.pricesLabel = [this.noPricingLabel, this.sellingPricesLabel, this.allPricesLabel];
    }
    /**
     * @return {?}
     */
    get vettedUsers() {
        return this.adminService.vettedUsers.filter((/**
         * @param {?} vu
         * @return {?}
         */
        vu => vu.isVetted && vu.hideFromDisplay === false && (this.userSearchFilter === null || vu.isInternal === this.userSearchFilter)));
    }
    /**
     * @return {?}
     */
    get nonVettedUsers() {
        return this.adminService.vettedUsers.filter((/**
         * @param {?} vu
         * @return {?}
         */
        vu => !vu.isVetted && vu.hideFromDisplay === false && (this.userSearchFilter === null || vu.isInternal === this.userSearchFilter)));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.adminService.getAccessibleModuleGroups().subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            this.accessibleModules = response;
            console.info("Getting modules");
            this.setSelectedModule();
        }));
        this.activatedRoute.params.subscribe((/**
         * @param {?} params
         * @return {?}
         */
        params => {
            this.sizingModule = params['sizingModule'];
            console.info("Route parameter set");
            this.setSelectedModule();
        }));
    }
    /**
     * Sets the selected module based on the current routing parameter.
     * @return {?}
     */
    setSelectedModule() {
        console.info("Setting users");
        if (!!this.accessibleModules) {
            /** @type {?} */
            const menuItem = this.menuService.menuItems.find((/**
             * @param {?} mu
             * @return {?}
             */
            mu => mu.isModuleAccess &&
                mu.link === `/admin/moduleAccess/${this.sizingModule}`));
            this.currentModule = this.accessibleModules.find((/**
             * @param {?} am
             * @return {?}
             */
            am => am.masterTextKey === menuItem.text));
            if (!!this.currentModule) {
                // Get the users
                this.showVettedAccessDetails();
            }
        }
    }
    /**
     * @return {?}
     */
    showVettedAccessDetails() {
        // Start the busy block
        this.blockUi.start(this.translatePipe.transform("PLEASE_WAIT", true));
        this.adminService.getAllVettedTypeUsersByModuleGroupId(this.currentModule.moduleGroupId).subscribe((/**
         * @return {?}
         */
        () => {
            // Reset the flags
            this.blockUi.stop();
            this.moduleChangesMade = false;
            // Apply the search in case a search was last applied
            this.searchUsers();
        }));
    }
    /**
     * @return {?}
     */
    deleteUser() {
        if (this.vettedTableSelected) {
            swal({
                title: "Delete User",
                text: "Deleting this user will remove them from all modules. Continue with deletion?",
                icon: "warning",
                dangerMode: true,
                buttons: ['Yes', 'Cancel']
            }).then((/**
             * @param {?=} okbuttoncClicked
             * @return {?}
             */
            (okbuttoncClicked) => {
                // The parameter can also enter as null
                /** @type {?} */
                const returnVal = !(okbuttoncClicked === null);
                if (!returnVal) {
                    /** @type {?} */
                    const users = [];
                    for (const selectedUser of this.selectedVettedUsers) {
                        users.push(selectedUser);
                        this.adminService.deleteUser(users).subscribe();
                        /** @type {?} */
                        var vettedUsers = this.vettedUsers.filter((/**
                         * @param {?} item
                         * @return {?}
                         */
                        item => item.userId !== selectedUser.userId));
                        this.vettedUsersTable.rows = vettedUsers;
                        this.showVettedAccessDetails();
                        this.userSelected = false;
                    }
                }
            })); //end of swal
        }
        if (this.nonVettedTableSelected) {
            swal({
                title: "Delete User",
                text: "Deleting this user will remove them from all modules. Continue with deletion?",
                icon: "warning",
                dangerMode: true,
                buttons: ['Yes', 'Cancel']
            }).then((/**
             * @param {?=} okbuttoncClicked
             * @return {?}
             */
            (okbuttoncClicked) => {
                // The parameter can also enter as null
                /** @type {?} */
                const returnVal = !(okbuttoncClicked === null);
                if (!returnVal) {
                    /** @type {?} */
                    const users = [];
                    for (const selectedUser of this.selectedNonVettedUsers) {
                        //const user = this.nonVettedUsers.find(vu => vu.userId === selectedUser.userId);
                        users.push(selectedUser);
                        this.adminService.deleteUser(users).subscribe();
                        /** @type {?} */
                        var nonVettedUsers = this.nonVettedUsers.filter((/**
                         * @param {?} item
                         * @return {?}
                         */
                        item => item.userId !== selectedUser.userId));
                        this.nonVettedUsersTable.rows = nonVettedUsers;
                        this.showVettedAccessDetails();
                        this.userSelected = false;
                    }
                }
            })); //end of swal
        }
    }
    /**
     * @param {?} event
     * @param {?} isFromVettedList
     * @return {?}
     */
    onUserSelect(event, isFromVettedList) {
        // Set the flags appropriately
        this.vettedTableSelected = isFromVettedList;
        this.nonVettedTableSelected = !isFromVettedList;
        this.userSelected = true;
        // Empty out the appropriate users list
        if (isFromVettedList) {
            this.selectedNonVettedUsers = [];
        }
        else {
            this.selectedVettedUsers = [];
        }
        /** @type {?} */
        const users = (/** @type {?} */ (event.selected));
        // If no users are selected, then nothing is selected
        if (users.length === 0) {
            this.vettedTableSelected = false;
            this.nonVettedTableSelected = false;
            this.userSelected = false;
        }
    }
    /**
     * @param {?} isMovingVettedUsers
     * @return {?}
     */
    moveSelectedUsers(isMovingVettedUsers) {
        // Set each scenario up accordingly
        if (isMovingVettedUsers) {
            // Set the selected vetted users back to non-vetted
            for (const selectedUser of this.selectedVettedUsers) {
                /** @type {?} */
                const user = this.vettedUsers.find((/**
                 * @param {?} vu
                 * @return {?}
                 */
                vu => vu.userId === selectedUser.userId));
                this.adminService.updateVettedUser(user, false);
                this.saveButtonActive = true;
                this.saveSuccessful = false;
            }
        }
        else {
            // Set the selected non-vetted users to vetted
            for (const selectedUser of this.selectedNonVettedUsers) {
                /** @type {?} */
                const user = this.nonVettedUsers.find((/**
                 * @param {?} vu
                 * @return {?}
                 */
                vu => vu.userId === selectedUser.userId));
                this.adminService.updateVettedUser(user, true);
                this.saveButtonActive = true;
                this.saveSuccessful = false;
            }
        }
        // Empty out the selected users
        this.selectedVettedUsers = [];
        this.selectedNonVettedUsers = [];
        // Reset the buttons
        this.vettedTableSelected = false;
        this.nonVettedTableSelected = false;
        this.userSelected = false;
        // Reset the rows (to update the view)
        this.vettedUsersTable.rows = this.vettedUsers;
        this.nonVettedUsersTable.rows = this.nonVettedUsers;
        // Changes can be saved
        this.moduleChangesMade = true;
        this.hasUnsavedDataChanges = true; // to drive GenericChangesGuard
    }
    /**
     * @return {?}
     */
    canSaveModuleChanges() {
        /** @type {?} */
        const actualVettedUsers = this.adminService.vettedUsers.filter((/**
         * @param {?} vu
         * @return {?}
         */
        vu => vu.isVetted));
        return !this.moduleChangesMade || (actualVettedUsers.length === 0 && this.currentModule.isVetted);
    }
    /**
     * @return {?}
     */
    saveModuleAccess() {
        /** @type {?} */
        const isVetted = this.currentModule.isVetted;
        this.adminService.manageModuleAccess(isVetted, this.currentModule.moduleGroupId).subscribe((/**
         * @param {?} isSuccessful
         * @return {?}
         */
        isSuccessful => {
            // Reset the save changes flag
            this.moduleChangesMade = isSuccessful;
            if (isSuccessful) {
                // Show a success alert
                this.hasUnsavedDataChanges = false; // to drive GenericChangesGuard
                this.saveSuccessful = true;
                this.saveButtonActive = false;
            }
            else {
                // Show an error alert
                this.saveError = true;
                this.saveButtonActive = false;
            }
        }));
    }
    /**
     * @param {?} row
     * @return {?}
     */
    getVettedUserAccessLevelFromTableRow(row) {
        /** @type {?} */
        const index = this.vettedUsers.indexOf(row);
        if (index > -1) {
            return this.vettedUsers[index].accessLevel;
        }
        return 0;
    }
    /**
     * Searches users based on the search criteria input.
     * @return {?}
     */
    searchUsers() {
        /** @type {?} */
        const val = this.searchFilter.nativeElement.value.toLowerCase();
        // Do the search here.
        console.info(`Searching for: '${val}'; ${!!val ? "Valid Search" : "Invalid Search"}`);
        this.adminService.searchVettedUsers(val);
        console.info(`User Operation: We now have ${this.vettedUsers.length} vetted users and ${this.nonVettedUsers.length} non-vetted users`);
        // Whenever the filter changes, always go back to the first page
        if (!!this.vettedUsersTable && !!this.nonVettedUsersTable) {
            this.vettedUsersTable.offset = 0;
            this.nonVettedUsersTable.offset = 0;
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    filterUsers(event) {
        /** @type {?} */
        const filterCheckBox = (/** @type {?} */ (event.target));
        if (!!filterCheckBox.value) {
            this.userSearchFilter = filterCheckBox.value === "true";
        }
        else {
            this.userSearchFilter = null;
        }
    }
}
ModuleAccessComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-module-access',
                template: "<div class=\"row\" *ngIf=\"!!accessibleModules && accessibleModules.length > 0; else noModules\">\r\n  <div class=\"col-lg-1\" style=\"width:10%\">\r\n    <!-- Show the module ribbon here -->\r\n    <module-ribbon [module-groups]=\"accessibleModules\" [module-identifier]=\"'isModuleAccess'\"></module-ribbon>\r\n  </div>\r\n\r\n\r\n\r\n  <div class=\"col-lg-11 col-md-10 col-xs-12 module-access-container\" *ngIf=\"!!currentModule\" style=\"width:90%\">\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <!-- Alert messages for user profile submissions -->\r\n        <alert type=\"success\" *ngIf=\"saveSuccessful\" dismissible=\"true\" dismissOnTimeout=\"3000\">{{'SAVED_SUCCESSFULLY' | translate}}</alert>\r\n        <alert type=\"danger\" *ngIf=\"saveError\" dismissible=\"true\">{{'SAVE_FAILED' | translate}}</alert>\r\n\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <button [disabled]=\"!saveButtonActive\" (click)=\"saveModuleAccess()\" class=\"btn btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\"> {{'SAVE' | translate:true}}</i></button>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n\r\n      <!-- Vetted / Free Access -->\r\n      <div class=\"col-xs-12\">\r\n        <div class=\"form-group module-access-controls\">\r\n          <label class=\"control-label\">{{'MODULE_ACCESS_TYPE' | translate}}</label>\r\n\r\n          <div class=\"radio c-radio c-radio-nofont\">\r\n            <label>\r\n              <input autocomplete=\"off\" type=\"radio\" [(ngModel)]=\"currentModule.isVetted\" [value]=\"false\" (click)=\"moduleChangesMade = true; saveButtonActive = true\" />\r\n              <span></span>{{'FREE' | translate}}\r\n            </label>\r\n          </div>\r\n          <div class=\"radio c-radio c-radio-nofont\">\r\n            <label>\r\n              <input autocomplete=\"off\" type=\"radio\" [(ngModel)]=\"currentModule.isVetted\" [value]=\"true\" (click)=\"moduleChangesMade = true; saveButtonActive = true\" />\r\n              <span></span>{{'VETTED' | translate}}\r\n            </label>\r\n          </div>\r\n        </div>\r\n        <hr />\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\" [hidden]=\"currentModule.isVetted === false\">\r\n      <div class=\"col-xs-12\">\r\n        <p>{{'THIS_MODULE_IS_SET_TO_VETTED_PLEASE_USE_THE_CONTROLS_BELOW_TO_SET_THE_ACCESS_AND_PERRMISIONS_FOR_THE_DESIRED_USERS' | translate}}</p>\r\n      </div>\r\n\r\n      <!-- Search users box -->\r\n      <div class=\"col-lg-3 col-md-4 col-xs-6\">\r\n        <label class=\"control-label\">{{\"SEARCH\" | translate}}</label>\r\n        <input autocomplete=\"off\" type='text' title=\"{{'TYPE_TO_SEARCH' | translate}}\" class=\"form-control\" placeholder=\"{{'TYPE_TO_SEARCH' | translate}}...\" (keyup)=\"searchUsers()\" #searchFilter />\r\n      </div>\r\n\r\n      <!-- Filter down to specific users -->\r\n      <div class=\"row\">\r\n        <div class=\"col-lg-3\">\r\n          <label class=\"control-label\">{{\"FILTER\" | translate}}</label>\r\n          <div class=\"form-group\">\r\n            <div class=\"radio c-radio c-radio-nofont\">\r\n              <label>\r\n                <input autocomplete=\"off\" type=\"radio\" [value]=\"true\" (click)=\"filterUsers($event)\" name=\"filterCheck\" />\r\n                <span></span> <i class=\"fa fa-user spirax-internal\"></i> {{'SPIRAX_EMPLOYEES' | translate}}\r\n              </label>\r\n            </div>\r\n            <div class=\"radio c-radio c-radio-nofont\">\r\n              <label>\r\n                <input autocomplete=\"off\" type=\"radio\" [value]=\"false\" (click)=\"filterUsers($event)\" name=\"filterCheck\" />\r\n                <span></span> <i class=\"fa fa-user spirax-external\"></i> {{'CUSTOMERS' | translate}}\r\n              </label>\r\n            </div>\r\n            <div class=\"radio c-radio c-radio-nofont\">\r\n              <label>\r\n                <input autocomplete=\"off\" type=\"radio\" [value]=\"null\" (click)=\"filterUsers($event)\" checked=\"checked\" name=\"filterCheck\" />\r\n                <span></span>\r\n\r\n                <i class=\"fa fa-user spirax-internal\" style=\"margin-right: -5px; margin-left: -2.5px;\"></i>\r\n                <i class=\"fa fa-user spirax-external\"></i>\r\n                {{'ALL_USERS' | translate}}\r\n              </label>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n\r\n        <div class=\"col-lg-3\" style=\"margin-left:0px; padding-left:0px\">\r\n          <div class=\"row\" *ngIf=\"currentModule.showPricing\">\r\n            <!--<div class=\"col-lg-7 hidden-md hidden-sm hidden-xs\">Key</div>-->\r\n            <label class=\"control-label\">{{'KEY' | translate}}</label>\r\n            <div class=\"form-group\">\r\n              <div class=\"col-lg-5 col-xs-12\" style=\"width:100%; padding-left:0px\">\r\n                <i class=\"fa fa-star\" style=\"margin-bottom:9px; margin-top:9px; font-size: 1.1em\"></i> - {{noPricingLabel}}<br />\r\n                <i class=\"fa fa-star\" style=\"margin-bottom:9px; font-size: 1.1em\"></i><i class=\"fa fa-star\" style=\"margin-bottom:9px; font-size: 1.1em\"></i> - {{sellingPricesLabel}}<br />\r\n                <i class=\"fa fa-star\" style=\"font-size: 1.1em\"></i><i class=\"fa fa-star\" style=\"font-size: 1.1em\"></i><i class=\"fa fa-star\" style=\"font-size: 1.1em\"></i> - {{allPricesLabel}}\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n\r\n\r\n    </div>\r\n\r\n\r\n\r\n    <!-- This is the Vetted Access block-->\r\n    <div class=\"row\" *ngIf=\"currentModule.isVetted === true; else freeAccess\">\r\n      <div class=\"col-xs-12\" *blockUI=\"'vetted-user-section'\">\r\n\r\n        <!-- Hide this when loading the users -->\r\n        <div class=\"row\">\r\n          <!-- Vetted Users table -->\r\n          <div class=\"col-lg-5 col-xs-12\">\r\n            <h4>{{'UNALLOCATED_USERS' | translate}}</h4>\r\n\r\n            <ngx-datatable #nonVettedUsersTable\r\n                           class=\"bootstrap\"\r\n                           [headerHeight]=\"40\"\r\n                           [limit]=\"10\"\r\n                           [columnMode]=\"'force'\"\r\n                           [footerHeight]=\"40\"\r\n                           [rowHeight]=\"'auto'\"\r\n                           [rows]=\"nonVettedUsers\"\r\n                           [messages]=\"{emptyMessage: translatePipe.transform('NO_DATA_TO_DISPLAY', true), totalMessage: translatePipe.transform('TOTAL', true), selectedMessage: false}\"\r\n                           [selected]=\"selectedNonVettedUsers\"\r\n                           [selectionType]=\"'multi'\"\r\n                           (select)=\"onUserSelect($event, false)\"\r\n                           scrollbarH=\"true\">\r\n\r\n              <ngx-datatable-column [name]=\"'USERNAME' | translate\" prop=\"username\">\r\n                <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                  <i class=\"fa fa-user\" [class.spirax-external]=\"!row.isInternal\" [class.spirax-internal]=\"row.isInternal\"></i>&nbsp;\r\n                  {{value}}\r\n                </ng-template>\r\n              </ngx-datatable-column>\r\n\r\n              <ngx-datatable-column [name]=\"'FIRST_NAME' | translate\" prop=\"firstname\">\r\n                <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                  {{value}}\r\n                </ng-template>\r\n              </ngx-datatable-column>\r\n\r\n              <ngx-datatable-column [name]=\"'LAST_NAME' | translate\" prop=\"lastname\">\r\n                <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                  {{value}}\r\n                </ng-template>\r\n              </ngx-datatable-column>\r\n\r\n              <ngx-datatable-column [name]=\"'EMAIL' | translate\" prop=\"email\" [width]=\"260\">\r\n                <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                  {{value}}\r\n                </ng-template>\r\n              </ngx-datatable-column>\r\n\r\n            </ngx-datatable>\r\n\r\n          </div>\r\n\r\n          <!-- The control buttons -->\r\n          <div class=\"col-sm-2\" style=\"width:7%; padding:0px\">\r\n            <div class=\"vetted-user-button-container\">\r\n              <button (click)=\"deleteUser()\" [disabled]=\"!userSelected\" class=\"btn btn-primary btn-block\" [title]=\"'DELETE' | translate\"> <i class=\"fa fa-trash\"></i> </button>\r\n              <button (click)=\"moveSelectedUsers(true)\" [disabled]=\"!vettedTableSelected\" class=\"btn btn-primary btn-block\" [title]=\"'MOVE_TO_UNALLOCATED_USERS' | translate\"> <i class=\"fa fa-arrow-left\"></i> </button>\r\n              <button (click)=\"moveSelectedUsers(false)\" [disabled]=\"!nonVettedTableSelected\" class=\"btn btn-primary btn-block\" [title]=\"'MOVE_TO_ALLOCATED_USERS' | translate\"> <i class=\"fa fa-arrow-right\"></i> </button>\r\n            </div>\r\n\r\n          </div>\r\n\r\n          <!-- Non-Vetted Users table -->\r\n          <div class=\"col-lg-5 col-xs-12\">\r\n            <h4>{{'ALLOCATED_USERS' | translate}}</h4>\r\n\r\n            <ngx-datatable #vettedUsersTable\r\n                           class=\"bootstrap\"\r\n                           [headerHeight]=\"40\"\r\n                           [limit]=\"10\"\r\n                           [columnMode]=\"'force'\"\r\n                           [footerHeight]=\"40\"\r\n                           [rowHeight]=\"'auto'\"\r\n                           [rows]=\"vettedUsers\"\r\n                           [messages]=\"{emptyMessage: translatePipe.transform('NO_DATA_TO_DISPLAY', true), totalMessage: translatePipe.transform('TOTAL', true), selectedMessage: false}\"\r\n                           [selected]=\"selectedVettedUsers\"\r\n                           [selectionType]=\"'multi'\"\r\n                           (select)=\"onUserSelect($event, true)\"\r\n                           scrollbarH=\"true\">\r\n\r\n              <ngx-datatable-column *ngIf=\"currentModule.showPricing\" [name]=\"'ACCESS' | translate\" prop=\"accessLevel\">\r\n                <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n\r\n                  <rating class=\"module-access-level\" [(ngModel)]=\"row.accessLevel\" (click)=\"moduleChangesMade = true; saveButtonActive = true; saveSuccessful = false\" [max]=\"3\" [titles]=\"pricesLabel\" [readonly]=\"!row.isInternal\"\r\n                          stateOn=\"fa fa-star\" stateOff=\"fa fa-star-o\"></rating>\r\n\r\n                </ng-template>\r\n              </ngx-datatable-column>\r\n\r\n              <ngx-datatable-column [name]=\"'USERNAME' | translate\" prop=\"username\">\r\n                <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                  <i class=\"fa fa-user\" [class.spirax-external]=\"!row.isInternal\" [class.spirax-internal]=\"row.isInternal\"></i>&nbsp;\r\n                  {{value}}\r\n                </ng-template>\r\n              </ngx-datatable-column>\r\n\r\n              <ngx-datatable-column [name]=\"'FIRST_NAME' | translate\" prop=\"firstname\">\r\n                <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                  {{value}}\r\n                </ng-template>\r\n              </ngx-datatable-column>\r\n\r\n              <ngx-datatable-column [name]=\"'LAST_NAME' | translate\" prop=\"lastname\">\r\n                <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                  {{value}}\r\n                </ng-template>\r\n              </ngx-datatable-column>\r\n\r\n              <ngx-datatable-column [name]=\"'EMAIL' | translate\" prop=\"email\" [width]=\"260\">\r\n                <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                  {{value}}\r\n                </ng-template>\r\n              </ngx-datatable-column>\r\n\r\n            </ngx-datatable>\r\n\r\n          </div>\r\n        </div>\r\n\r\n\r\n\r\n      </div>\r\n    </div>\r\n\r\n    <!-- This is the Free Access block-->\r\n    <ng-template #freeAccess>\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n          {{'THIS_MODULE_IS_SET_TO_FREE_ALL_USERS_FOR_YOUR_COUNTRY_WILL_HAVE_ACCESS_TO_THIS_MODULE' | translate}}\r\n        </div>\r\n      </div>\r\n    </ng-template>\r\n\r\n  </div>\r\n</div>\r\n\r\n<!-- Shown when there are no modules -->\r\n<ng-template #noModules>\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <alert type=\"info\">{{'NO_ACCESS_TO_MODULES_MESSAGE' | translate:true}}</alert>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n<!--<div class=\"row\">\r\n  <div class=\"col-xs-12\">\r\n    <button [disabled]=\"canSaveModuleChanges()\" (click)=\"saveModuleAccess()\" class=\"btn btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\"> {{'SAVE' | translate:true}}</i></button>\r\n  </div>\r\n</div>-->\r\n",
                styles: [".vetted-user-button-container button i:first-of-type{transform:rotate(0)}@media (min-width:768px){.vetted-user-button-container button i:first-of-type{transform:rotate(0)}}@media (min-width:992px){.vetted-user-button-container button i:first-of-type{transform:rotate(0)}}@media (min-width:1200px){.vetted-user-button-container{margin-top:230px}.vetted-user-button-container button i:first-of-type{transform:initial}}.vetted-user-button-container button i:last-of-type{transform:rotate(0)}@media (min-width:768px){.vetted-user-button-container button i:last-of-type{transform:rotate(0)}}@media (min-width:992px){.vetted-user-button-container button i:last-of-type{transform:rotate(0)}}@media (min-width:1200px){.vetted-user-button-container button i:last-of-type{transform:initial}}.module-access-container{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.module-access-level{font-size:2em;line-height:16px}.module-access-controls div.radio.c-radio.c-radio-nofont{display:inline-block}.module-access-controls .control-label{margin-right:15px}"]
            }] }
];
/** @nocollapse */
ModuleAccessComponent.ctorParameters = () => [
    { type: AdminService },
    { type: ActivatedRoute },
    { type: MenuService },
    { type: FormBuilder },
    { type: TranslatePipe }
];
ModuleAccessComponent.propDecorators = {
    vettedUsersTable: [{ type: ViewChild, args: ["vettedUsersTable", { static: false },] }],
    nonVettedUsersTable: [{ type: ViewChild, args: ["nonVettedUsersTable", { static: false },] }],
    searchFilter: [{ type: ViewChild, args: ["searchFilter", { static: false },] }]
};
__decorate([
    BlockUI('vetted-user-section'),
    __metadata("design:type", Object)
], ModuleAccessComponent.prototype, "blockUi", void 0);
if (false) {
    /** @type {?} */
    ModuleAccessComponent.prototype.selectedVettedUsers;
    /** @type {?} */
    ModuleAccessComponent.prototype.selectedNonVettedUsers;
    /** @type {?} */
    ModuleAccessComponent.prototype.vettedTableSelected;
    /** @type {?} */
    ModuleAccessComponent.prototype.nonVettedTableSelected;
    /** @type {?} */
    ModuleAccessComponent.prototype.userSelected;
    /** @type {?} */
    ModuleAccessComponent.prototype.moduleChangesMade;
    /** @type {?} */
    ModuleAccessComponent.prototype.noPricingLabel;
    /** @type {?} */
    ModuleAccessComponent.prototype.sellingPricesLabel;
    /** @type {?} */
    ModuleAccessComponent.prototype.allPricesLabel;
    /** @type {?} */
    ModuleAccessComponent.prototype.pricesLabel;
    /** @type {?} */
    ModuleAccessComponent.prototype.userSearchFilter;
    /** @type {?} */
    ModuleAccessComponent.prototype.blockUi;
    /** @type {?} */
    ModuleAccessComponent.prototype.vettedUsersTable;
    /** @type {?} */
    ModuleAccessComponent.prototype.nonVettedUsersTable;
    /** @type {?} */
    ModuleAccessComponent.prototype.searchFilter;
    /** @type {?} */
    ModuleAccessComponent.prototype.accessibleModules;
    /** @type {?} */
    ModuleAccessComponent.prototype.currentModule;
    /**
     * @type {?}
     * @private
     */
    ModuleAccessComponent.prototype.sizingModule;
    /** @type {?} */
    ModuleAccessComponent.prototype.hasUnsavedDataChanges;
    /** @type {?} */
    ModuleAccessComponent.prototype.theFormGroup;
    /** @type {?} */
    ModuleAccessComponent.prototype.saveSuccessful;
    /** @type {?} */
    ModuleAccessComponent.prototype.saveError;
    /** @type {?} */
    ModuleAccessComponent.prototype.saveButtonActive;
    /**
     * @type {?}
     * @private
     */
    ModuleAccessComponent.prototype.adminService;
    /**
     * @type {?}
     * @private
     */
    ModuleAccessComponent.prototype.activatedRoute;
    /**
     * @type {?}
     * @private
     */
    ModuleAccessComponent.prototype.menuService;
    /**
     * @type {?}
     * @private
     */
    ModuleAccessComponent.prototype.fb;
    /** @type {?} */
    ModuleAccessComponent.prototype.translatePipe;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/admin/product-selection/product-selection.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductSelectionComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
ProductSelectionComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-product-selection',
                template: "<div>\r\n  <h2>Safety Valves</h2>\r\n</div>\r\n\r\n<product-selection-admin></product-selection-admin>\r\n\r\n<div>\r\n  <h2>Flowmeter</h2>\r\n</div>\r\n\r\n<flowmeter-product-selection-admin></flowmeter-product-selection-admin>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
ProductSelectionComponent.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/generic.changes.guard.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GenericChangesGuard {
    /**
     * @param {?} translatePipe
     * @param {?} routesService
     * @param {?} authenticationService
     * @param {?} messageService
     */
    constructor(translatePipe, routesService, authenticationService, messageService) {
        this.translatePipe = translatePipe;
        this.routesService = routesService;
        this.authenticationService = authenticationService;
        this.messageService = messageService;
    }
    /**
     * A Guard that decides if a route can be deactivated.
     * @param {?} component
     * @param {?} currentRoute
     * @param {?} currentState
     * @param {?=} nextState
     * @return {?}
     */
    canDeactivate(component, currentRoute, currentState, nextState) {
        if (!!component === false) {
            // If no component has been found throw an error.
            throw "Sizing Module Deactivation Guard requires a component to implement 'IGenericChanges'";
        }
        // Check if the user is logged in before continuing.
        this.authenticationService.authUserChange.next();
        if (!this.authenticationService.authenticatedUser.isLoggedIn) {
            // Let the deactivation continue, because the user needs to login again.
            return Observable$1.of(true).toPromise();
        }
        // Inform the routes service that no page loading has occurred yet because the user needs to make a decision first.
        this.routesService.pageLoading = false;
        this.routesService.canDeactivatePending = true;
        console.info(`Attempting to deactivate GenericChanges component '${component.constructor.name}'`);
        /** @type {?} */
        let defaultReturn = Observable$1.of(true).toPromise();
        if (!!component
            && ((!!component.theFormGroup && (component.theFormGroup.dirty || !component.theFormGroup.pristine)) // The form has changed data
                || // OR               
                    (!!component.hasUnsavedDataChanges && component.hasUnsavedDataChanges) // The flag is set for ChangesMade
            )) {
            /** @type {?} */
            const title = this.translatePipe.transform("GENERIC_CHANGES_TITLE", true);
            /** @type {?} */
            const text = this.translatePipe.transform("GENERIC_CHANGES_TEXT", true);
            /** @type {?} */
            const saveButtonText = this.translatePipe.transform("GO_BACK_AND_KEEP_CHANGES", true);
            /** @type {?} */
            const cancelButtonText = this.translatePipe.transform("DISCARD_CHANGES", true);
            defaultReturn = swal({
                title: title,
                text: text,
                icon: "warning",
                dangerMode: true,
                buttons: [saveButtonText, cancelButtonText]
            }).then((/**
             * @param {?=} discardChanges
             * @return {?}
             */
            (discardChanges) => {
                console.info("Resolving unsaved changes promise");
                // The parameter can also enter as null
                /** @type {?} */
                const returnVal = !(discardChanges === null);
                // When Angular looks at a guard decision, page navigation has already occurred.
                // Reset the page load progress
                this.routesService.pageLoadProgress = 0;
                this.routesService.pageLoading = returnVal;
                // Exit the guard.
                this.routesService.canDeactivatePending = false;
                // Remove the unresolved promise
                this.routesService.removeUnresolvedPromise();
                if (discardChanges) {
                    this.messageService.clearMessages();
                }
                return returnVal;
            }));
            // Register the promise so that other parts of the system are aware.
            this.routesService.registerUnresolvedPromise(defaultReturn);
        }
        return defaultReturn;
    }
}
GenericChangesGuard.decorators = [
    { type: Injectable }
];
/** @nocollapse */
GenericChangesGuard.ctorParameters = () => [
    { type: TranslatePipe },
    { type: RoutesService },
    { type: AuthenticationService },
    { type: MessagesService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    GenericChangesGuard.prototype.translatePipe;
    /**
     * @type {?}
     * @private
     */
    GenericChangesGuard.prototype.routesService;
    /**
     * @type {?}
     * @private
     */
    GenericChangesGuard.prototype.authenticationService;
    /**
     * @type {?}
     * @private
     */
    GenericChangesGuard.prototype.messageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/cleansteamgeneratorfb/modulePreference/cleanSteamGeneratorFB.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * **********************************
 * MODULE PREFERENCES VERSION!
 * ************************************
 */
class CleanSteamGeneratorFBService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} csgPricing
     * @return {?}
     */
    calculateBOMPriceFBMini(csgPricing) {
        return this.http.post(`./Api/CSGFBMini/CalculateBOMPrice`, csgPricing);
    }
    /**
     * @param {?} csgPricing
     * @return {?}
     */
    calculateBOMPriceFBHalfPipe(csgPricing) {
        return this.http.post(`./Api/CSGFBHalfPipe/CalculateBOMPrice`, csgPricing);
    }
}
CleanSteamGeneratorFBService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
CleanSteamGeneratorFBService.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/cleansteamgeneratorfb/modulePreference/cleanSteamGeneratorFB.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CleanSteamGeneratorFBModulePreferencesComponent {
    /**
     * @param {?} routesService
     * @param {?} adminService
     * @param {?} translationService
     * @param {?} fb
     * @param {?} translatePipe
     * @param {?} modulePreferenceService
     * @param {?} cleanSteamGeneratorService
     * @param {?} localeService
     * @param {?} userProfileService
     */
    constructor(routesService, adminService, translationService, fb, translatePipe, modulePreferenceService, cleanSteamGeneratorService, localeService, userProfileService) {
        this.routesService = routesService;
        this.adminService = adminService;
        this.translationService = translationService;
        this.fb = fb;
        this.translatePipe = translatePipe;
        this.modulePreferenceService = modulePreferenceService;
        this.cleanSteamGeneratorService = cleanSteamGeneratorService;
        this.localeService = localeService;
        this.userProfileService = userProfileService;
        this.moduleId = "11";
        this.moduleGroupId = 13;
        this.cloneDeep = cloneDeep_;
        this.moduleName = "Clean Steam Generator FB";
        this.isFBHalfPipeSizingIsActive = false;
        this.isFBMiniSizingIsActive = false;
        this.componentInitialised = false;
        this.componentLoadPromises = [];
        this.componentLoadPromises.push(this.userProfileService.getUserDetails().toPromise().then(((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            this.user = user;
            if (!!this.user) {
                this.operatingCompany = " : " + this.user.operatingCompanyName;
            }
        }))));
        // Setup the form group.
        this.modulePreferencesForm = this.fb.group({}, { updateOn: "blur" });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        console.log("Starting Initializing CSG F&B module prefs Wrapper component");
        // When the ManufacturerId is setup, it enables the Sizing and Mod Prefs support for FBMini and/or FBHalfPipe.
        // First, get all the module preferences.
        this.componentLoadPromises.push(this.modulePreferenceService.getOperatingCompanyModulePreferences(this.moduleId).toPromise().then((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            if (result && result.length > 0) {
                this.checkFBMiniSizingIsActive();
                this.checkFBHalfPipeSizingIsActive();
            }
            if (!this.isFBMiniSizingIsActive && !this.isFBHalfPipeSizingIsActive) {
                // No ManufacturerIds setup for this OpCo! Or no data on this ModuleId.
                console.log("Warning: CSGFB Sizing & Mod Prefs disabled, no active ManufacturerIds FBMini or FBHalfPipe!");
                debugger;
            }
        })));
        Promise.all(this.componentLoadPromises).then((/**
         * @return {?}
         */
        () => {
            console.log("Finishing Initializing CSG F&B module prefs Wrapper component");
            this.componentInitialised = true;
        }));
    }
    /**
     * Submits the form for saving to the server.
     * @param {?} $event
     * @return {?}
     */
    submitForm($event) {
    }
    /**
     * @return {?}
     */
    checkFBHalfPipeSizingIsActive() {
        // CSGFBHalfPipeManufacturer module pref for this OpCo.
        /** @type {?} */
        var manufacturerPref = this.modulePreferenceService.getModulePreferenceByName("CSGFBHalfPipeManufacturer");
        if (manufacturerPref) {
            this.isFBHalfPipeSizingIsActive = true;
        }
        else {
            this.isFBHalfPipeSizingIsActive = false;
        }
    }
    /**
     * @return {?}
     */
    checkFBMiniSizingIsActive() {
        // CSGFBMiniManufacturer module pref for this OpCo.
        /** @type {?} */
        var manufacturerPref = this.modulePreferenceService.getModulePreferenceByName("CSGFBMiniManufacturer");
        if (manufacturerPref) {
            this.isFBMiniSizingIsActive = true;
        }
        else {
            this.isFBMiniSizingIsActive = false;
        }
    }
}
CleanSteamGeneratorFBModulePreferencesComponent.decorators = [
    { type: Component, args: [{
                selector: 'cleansteamgeneratorFB-module-preferences',
                template: "\r\n<div *ngIf=\"!componentInitialised\">\r\n  <div class=\"ball-clip-rotate\">\r\n    <div></div>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"!!componentInitialised\">\r\n  <form [formGroup]=\"modulePreferencesForm\" class=\"form-horizontal\" role=\"form\" (submit)=\"submitForm($event)\" novalidate>\r\n\r\n    <!-- <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <button [disabled]=\"!modulePreferencesForm.dirty || !modulePreferencesForm.valid || modulePreferencesForm.status !== 'VALID' || formSubmitted\" type=\"submit\" class=\"btn btn-dynamic btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i></button>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <br>\r\n      </div>\r\n    </div>\r\n\r\n         Success confirmation message -->\r\n    <!-- <alert-block *ngIf=\"!!alertVisible && !!isSuccess\" type=\"success\" [auto-close]=\"true\" [message]=\"'MODULE_PREFERENCES_SAVED_SUCCESSFULLY_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block> -->\r\n    <!-- Failure confirmation message-->\r\n    <!-- <alert-block *ngIf=\"!!alertVisible && !isSuccess\" type=\"danger\" [message]=\"'MODULE_PREFERENCES_FAILED_TO_SAVE_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block> -->\r\n\r\n    <div class=\"panel\">\r\n      <tabset class=\"bg-white p0\" [justified]=\"true\">\r\n        <tab *ngIf=\"!!isFBMiniSizingIsActive\">\r\n          <ng-template tabHeading>\r\n            <em class=\"fa fa-steam-square fa-fw\" style=\"color:navy\"></em>FB Mini\r\n          </ng-template>\r\n          <div>\r\n            <cleansteamgeneratorFBMini-module-preferences></cleansteamgeneratorFBMini-module-preferences>\r\n          </div>\r\n        </tab>\r\n        <tab *ngIf=\"!!isFBHalfPipeSizingIsActive\">\r\n          <ng-template tabHeading>\r\n            <em class=\"fa fa-adjust fa-fw\" style=\"color:red\"></em>FB Half Pipe\r\n          </ng-template>\r\n          <div>\r\n            <cleansteamgeneratorFBHalfPipe-module-preferences></cleansteamgeneratorFBHalfPipe-module-preferences>\r\n          </div>\r\n        </tab>\r\n      </tabset>\r\n    </div>\r\n    <!-- END panel tab-->\r\n  </form>\r\n</div>\r\n",
                providers: [CleanSteamGeneratorFBService],
                styles: [".cross-validation-error-class{font-size:25px;color:#708090}"]
            }] }
];
/** @nocollapse */
CleanSteamGeneratorFBModulePreferencesComponent.ctorParameters = () => [
    { type: RoutesService },
    { type: AdminService },
    { type: TranslationService },
    { type: FormBuilder },
    { type: TranslatePipe },
    { type: ModulePreferenceService },
    { type: CleanSteamGeneratorFBService },
    { type: LocaleService$1 },
    { type: UserProfileService }
];
if (false) {
    /** @type {?} */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.moduleId;
    /** @type {?} */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.moduleGroupId;
    /** @type {?} */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.cloneDeep;
    /** @type {?} */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.moduleName;
    /** @type {?} */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.theFormGroup;
    /** @type {?} */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.hasUnsavedDataChanges;
    /** @type {?} */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.modulePreferencesForm;
    /** @type {?} */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.user;
    /** @type {?} */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.operatingCompany;
    /** @type {?} */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.isFBHalfPipeSizingIsActive;
    /** @type {?} */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.isFBMiniSizingIsActive;
    /** @type {?} */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.componentInitialised;
    /** @type {?} */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.componentLoadPromises;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.routesService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.adminService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.translationService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.translatePipe;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.modulePreferenceService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.cleanSteamGeneratorService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.localeService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBModulePreferencesComponent.prototype.userProfileService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/module-preference/module-preference-details.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The Operating Company Preferences model.
 */
class ModulePreferenceDetails {
}
if (false) {
    /**
     * Gets or sets the name
     * @type {?}
     */
    ModulePreferenceDetails.prototype.name;
    /**
     * Gets or sets the value.
     * @type {?}
     */
    ModulePreferenceDetails.prototype.value;
    /**
     * Gets or sets the moduleId.
     * @type {?}
     */
    ModulePreferenceDetails.prototype.moduleId;
    /**
     * Gets or sets the isDeleted.
     * @type {?}
     */
    ModulePreferenceDetails.prototype.isDeleted;
    /**
     * Gets or sets the OperatingCompanyId.
     * @type {?}
     */
    ModulePreferenceDetails.prototype.OperatingCompanyId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/cleansteamgeneratorfb/modulePreference/cleanSteamGeneratorFBPricingOptions.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//import { Message } from '../../../core/messages/message.model';
//import { Message } from "sizing-shared-lib";
/*************************************
    MODULE PREFERENCES VERSION!
**************************************/
/**
 * The CleanSteamGeneratorFBPricing model.
 */
class CleanSteamGeneratorFBPricing {
}
if (false) {
    /**
     * Gets or sets the modelId.
     * @type {?}
     */
    CleanSteamGeneratorFBPricing.prototype.modelId;
    /**
     * Gets or sets the manufacturerId.
     * @type {?}
     */
    CleanSteamGeneratorFBPricing.prototype.manufacturerId;
    /**
     * Gets or sets the basePriceOption.
     * @type {?}
     */
    CleanSteamGeneratorFBPricing.prototype.basePriceOption;
    /**
     * Gets or sets the localRecommendedSalesPriceOption.
     * @type {?}
     */
    CleanSteamGeneratorFBPricing.prototype.localRecommendedSalesPriceOption;
    /**
     * Gets or sets the landedCostIncreaseFactor.
     * @type {?}
     */
    CleanSteamGeneratorFBPricing.prototype.landedCostIncreaseFactor;
    /**
     * Gets or sets the pricingOptions.
     * @type {?}
     */
    CleanSteamGeneratorFBPricing.prototype.pricingOptions;
}
class CSGPricingOption {
}
if (false) {
    /**
     * Gets or sets the enumerationName.
     * @type {?}
     */
    CSGPricingOption.prototype.enumerationName;
    /**
     * Gets or sets the selectedValue.
     * @type {?}
     */
    CSGPricingOption.prototype.selectedValue;
}
class CleanSteamGeneratorFBPricingOutput {
}
if (false) {
    /**
     * Gets or sets the totalPrice.
     * @type {?}
     */
    CleanSteamGeneratorFBPricingOutput.prototype.totalSalesPrice;
    /**
     * Gets or sets the totalRecommendedSalesPrice.
     * @type {?}
     */
    CleanSteamGeneratorFBPricingOutput.prototype.totalRecommendedSalesPrice;
}
class CleanSteamGeneratorFBBOMPriceOutput {
}
if (false) {
    /**
     * Gets or sets the BOMItems.
     * @type {?}
     */
    CleanSteamGeneratorFBBOMPriceOutput.prototype.bomItems;
}
class BOMItem {
    constructor() {
        /**
         * Gets or sets the isEnabled.
         */
        this.isEnabled = true;
    }
}
if (false) {
    /**
     * Gets or sets the rowOrder.
     * @type {?}
     */
    BOMItem.prototype.rowOrder;
    /**
     * Gets or sets the itemType.
     * @type {?}
     */
    BOMItem.prototype.itemType;
    /**
     * Gets or sets the modelId.
     * @type {?}
     */
    BOMItem.prototype.modelId;
    /**
     * Gets or sets the parent.
     * @type {?}
     */
    BOMItem.prototype.parent;
    /**
     * Gets or sets the parentMasterTextKey.
     * @type {?}
     */
    BOMItem.prototype.parentMasterTextKey;
    /**
     * Gets or sets the parentTranslation.
     * @type {?}
     */
    BOMItem.prototype.parentTranslation;
    /**
     * Gets or sets the item.
     * @type {?}
     */
    BOMItem.prototype.item;
    /**
     * Gets or sets the itemTranslation.
     * @type {?}
     */
    BOMItem.prototype.itemTranslation;
    /**
     * Gets or sets the itemMasterTextKey.
     * @type {?}
     */
    BOMItem.prototype.itemMasterTextKey;
    /**
     * Gets or sets the sequenceDefault.
     * @type {?}
     */
    BOMItem.prototype.sequenceDefault;
    /**
     * Gets or sets the sequenceOverride.
     * @type {?}
     */
    BOMItem.prototype.sequenceOverride;
    /**
     * Gets or sets the landedAdjusted.
     * @type {?}
     */
    BOMItem.prototype.landedAdjusted;
    /**
     * Gets or sets the ssp.
     * @type {?}
     */
    BOMItem.prototype.ssp;
    /**
     * Gets or sets the ssPtoRSPfactor.
     * @type {?}
     */
    BOMItem.prototype.ssPtoRSPfactor;
    /**
     * Gets or sets the recommendedSalesPrice.
     * @type {?}
     */
    BOMItem.prototype.recommendedSalesPrice;
    /**
     * Gets or sets the rsPtoRSPOfactor.
     * @type {?}
     */
    BOMItem.prototype.rsPtoRSPOfactor;
    /**
     * Gets or sets the recommendedSalesPriceOverride.
     * @type {?}
     */
    BOMItem.prototype.recommendedSalesPriceOverride;
    /**
     * Gets or sets the displayedRSP.
     * @type {?}
     */
    BOMItem.prototype.displayedRSP;
    /**
     * Gets or sets the manCurrency.
     * @type {?}
     */
    BOMItem.prototype.manCurrency;
    /**
     * Gets or sets the displayedRSP.
     * @type {?}
     */
    BOMItem.prototype.manRateToGBP;
    /**
     * Gets or sets the displayedRSP.
     * @type {?}
     */
    BOMItem.prototype.manCurrencyId;
    /**
     * Gets or sets the priceDataUTCDate.
     * @type {?}
     */
    BOMItem.prototype.priceDataUTCDate;
    /**
     * Gets or sets the sLandedAdjusted.
     * @type {?}
     */
    BOMItem.prototype.sLandedAdjusted;
    /**
     * Gets or sets the sSSP.
     * @type {?}
     */
    BOMItem.prototype.sSSP;
    /**
     * Gets or sets the sRecommendedSalesPrice.
     * @type {?}
     */
    BOMItem.prototype.sRecommendedSalesPrice;
    /**
     * Gets or sets the sRecommendedSalesPriceOverride.
     * @type {?}
     */
    BOMItem.prototype.sRecommendedSalesPriceOverride;
    /**
     * Gets or sets the sDisplayedRSP.
     * @type {?}
     */
    BOMItem.prototype.sDisplayedRSP;
    /**
     * Gets or sets the sellingCurrency.
     * @type {?}
     */
    BOMItem.prototype.sellingCurrency;
    /**
     * Gets or sets the sellingRateToGBP.
     * @type {?}
     */
    BOMItem.prototype.sellingRateToGBP;
    /**
     * Gets or sets the sellingCurrencyId.
     * @type {?}
     */
    BOMItem.prototype.sellingCurrencyId;
    /**
     * Gets or sets the isEnabled.
     * @type {?}
     */
    BOMItem.prototype.isEnabled;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/cleansteamgeneratorfb/modulePreference/cleanSteamGeneratorFBMini.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CleanSteamGeneratorFBMiniModulePreferencesComponent {
    /**
     * @param {?} routesService
     * @param {?} adminService
     * @param {?} translationService
     * @param {?} fb
     * @param {?} translatePipe
     * @param {?} modulePreferenceService
     * @param {?} cleanSteamGeneratorService
     * @param {?} localeService
     * @param {?} userProfileService
     */
    constructor(routesService, adminService, translationService, fb, translatePipe, modulePreferenceService, cleanSteamGeneratorService, localeService, userProfileService) {
        this.routesService = routesService;
        this.adminService = adminService;
        this.translationService = translationService;
        this.fb = fb;
        this.translatePipe = translatePipe;
        this.modulePreferenceService = modulePreferenceService;
        this.cleanSteamGeneratorService = cleanSteamGeneratorService;
        this.localeService = localeService;
        this.userProfileService = userProfileService;
        this.moduleId = "11";
        this.moduleGroupId = 13;
        this.cloneDeep = cloneDeep_;
        this.moduleName = "Clean Steam Generator FB";
        // for scroll to view
        this.componentLoadPromises = [];
        this.componentInitialised = false;
        // to drive GenericChangesGuard
        this.isSuccess = false;
        this.alertVisible = false;
        this.formSubmitted = false;
        //*** Regular module prefs ***
        // Currency Options
        this.manufacturerList = [];
        this.currencyList = [];
        this.csgBOMOutputDataRows = [];
        this.showPrices = false;
        this.augmentPriceDataProcessing = true; // disable button whilst page loading
        this.scrollToElement = (/**
         * @param {?} elementRef
         * @param {?=} position
         * @return {?}
         */
        (elementRef, position = "start") => {
            // ToDo: Fix fussy scroll on first sizing bug. Hence the use of timeout delay here.
            setTimeout((/**
             * @return {?}
             */
            () => {
                try {
                    elementRef.nativeElement.scrollIntoView({ block: position, behavior: "smooth" });
                }
                catch (err) {
                    console.log(`scrollToElement err=${err}`);
                }
            }), 200);
        });
        this.userProfileService.getUserDetails().subscribe((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            this.user = user;
            if (!!this.user) {
                this.operatingCompany = " : " + this.user.operatingCompanyName;
            }
        }));
        this.csgBOMOutputData = new CleanSteamGeneratorFBBOMPriceOutput();
        this.csgManufacturerPrefFormControl = new FormControl({ value: '', disabled: true });
        this.csgManufacturerCurrencyPrefFormControl = new FormControl({ value: '', disabled: true });
        this.csgSellingCurrencyPrefFormControl = new FormControl('');
        this.csgLandedCostIncreasePrefFormControl = new FormControl('', [Validators.required, CustomValidators.range([-100, 100])]);
        this.csgDeliveryCostPrefFormControl = new FormControl('', [Validators.required]);
        this.csgCommissionOnlyPricePrefFormControl = new FormControl('', [Validators.required]);
        this.csgWarrantyOneYearPrefFormControl = new FormControl('', [Validators.required]);
        this.csgWarrantyTwoYearsPrefFormControl = new FormControl('', [Validators.required]);
        this.csgWarrantyThreeYearsPrefFormControl = new FormControl('', [Validators.required]);
        this.csgOptionsFormControl = new FormControl('');
        // Design Code
        this.csg200DesignCodePrefFormControl = new FormControl(null);
        this.csg500DesignCodePrefFormControl = new FormControl(null);
        this.csg1100DesignCodePrefFormControl = new FormControl(null);
        this.csg1600DesignCodePrefFormControl = new FormControl(null);
        // Shell Type
        this.csg200ShellTypePrefFormControl = new FormControl(null);
        this.csg500ShellTypePrefFormControl = new FormControl(null);
        this.csg1100ShellTypePrefFormControl = new FormControl(null);
        this.csg1600ShellTypePrefFormControl = new FormControl(null);
        // Control Valve Actuation
        this.csg200ValveActuationPrefFormControl = new FormControl(null);
        this.csg500ValveActuationPrefFormControl = new FormControl(null);
        this.csg1100ValveActuationPrefFormControl = new FormControl(null);
        this.csg1600ValveActuationPrefFormControl = new FormControl(null);
        // FeedwaterPressurisation
        this.csg0200FeedwaterPressurisationPrefFormControl = new FormControl(null);
        this.csg0500FeedwaterPressurisationPrefFormControl = new FormControl(null);
        this.csg1100FeedwaterPressurisationPrefFormControl = new FormControl(null);
        this.csg1600FeedwaterPressurisationPrefFormControl = new FormControl(null);
        // Control
        this.csg200ControlPrefFormControl = new FormControl(null);
        this.csg500ControlPrefFormControl = new FormControl(null);
        this.csg1100ControlPrefFormControl = new FormControl(null);
        this.csg1600ControlPrefFormControl = new FormControl(null);
        // Communication Interface
        this.csg200CommunicationInterfacePrefFormControl = new FormControl(null);
        this.csg500CommunicationInterfacePrefFormControl = new FormControl(null);
        this.csg1100CommunicationInterfacePrefFormControl = new FormControl(null);
        this.csg1600CommunicationInterfacePrefFormControl = new FormControl(null);
        // Frame and Cabinet
        this.csg200FrameAndCabinetPrefFormControl = new FormControl(null);
        this.csg500FrameAndCabinetPrefFormControl = new FormControl(null);
        this.csg1100FrameAndCabinetPrefFormControl = new FormControl(null);
        this.csg1600FrameAndCabinetPrefFormControl = new FormControl(null);
        // Control Panel Location
        this.csg200ControlPanelLocationPrefFormControl = new FormControl(null);
        this.csg500ControlPanelLocationPrefFormControl = new FormControl(null);
        this.csg1100ControlPanelLocationPrefFormControl = new FormControl(null);
        this.csg1600ControlPanelLocationPrefFormControl = new FormControl(null);
        // Insulation
        this.csg200InsulationPrefFormControl = new FormControl(null);
        this.csg500InsulationPrefFormControl = new FormControl(null);
        this.csg1100InsulationPrefFormControl = new FormControl(null);
        this.csg1600InsulationPrefFormControl = new FormControl(null);
        // Wheels And Feet
        this.csg200WheelsAndFeetPrefFormControl = new FormControl(null);
        this.csg500WheelsAndFeetPrefFormControl = new FormControl(null);
        this.csg1100WheelsAndFeetPrefFormControl = new FormControl(null);
        this.csg1600WheelsAndFeetPrefFormControl = new FormControl(null);
        // Plant Steam Inlet Shut Off Valve
        this.csg200PlantSteamInletShutOffValvePrefFormControl = new FormControl(null);
        this.csg500PlantSteamInletShutOffValvePrefFormControl = new FormControl(null);
        this.csg1100PlantSteamInletShutOffValvePrefFormControl = new FormControl(null);
        this.csg1600PlantSteamInletShutOffValvePrefFormControl = new FormControl(null);
        // Plant Steam Line Trapping
        this.csg200PlantSteamLineTrappingPrefFormControl = new FormControl(null);
        this.csg500PlantSteamLineTrappingPrefFormControl = new FormControl(null);
        this.csg1100PlantSteamLineTrappingPrefFormControl = new FormControl(null);
        this.csg1600PlantSteamLineTrappingPrefFormControl = new FormControl(null);
        // TDS control system
        this.csg200TDSControlSystemPrefFormControl = new FormControl(null);
        this.csg500TDSControlSystemPrefFormControl = new FormControl(null);
        this.csg1100TDSControlSystemPrefFormControl = new FormControl(null);
        this.csg1600TDSControlSystemPrefFormControl = new FormControl(null);
        // Sample Coolers
        this.csg200SampleCoolerPrefFormControl = new FormControl(null);
        this.csg500SampleCoolerPrefFormControl = new FormControl(null);
        this.csg1100SampleCoolerPrefFormControl = new FormControl(null);
        this.csg1600SampleCoolerPrefFormControl = new FormControl(null);
        // Independent low level alarm
        this.csg200IndependentLowLevelAlarmPrefFormControl = new FormControl(null);
        this.csg500IndependentLowLevelAlarmPrefFormControl = new FormControl(null);
        this.csg1100IndependentLowLevelAlarmPrefFormControl = new FormControl(null);
        this.csg1600IndependentLowLevelAlarmPrefFormControl = new FormControl(null);
        // Feedwater pre-heating / Degassing
        this.csg200FeedwaterPreHeatingDegassingPrefFormControl = new FormControl(null);
        this.csg500FeedwaterPreHeatingDegassingPrefFormControl = new FormControl(null);
        this.csg1100FeedwaterPreHeatingDegassingPrefFormControl = new FormControl(null);
        this.csg1600FeedwaterPreHeatingDegassingPrefFormControl = new FormControl(null);
        // Intelligent diagnostics
        this.csg200IntelligentDiagnosticsPrefFormControl = new FormControl(null);
        this.csg500IntelligentDiagnosticsPrefFormControl = new FormControl(null);
        this.csg1100IntelligentDiagnosticsPrefFormControl = new FormControl(null);
        this.csg1600IntelligentDiagnosticsPrefFormControl = new FormControl(null);
        // Clean steam outlet shut-off valve
        this.csg200CleanSteamOutletShutOffValvePrefFormControl = new FormControl(null);
        this.csg500CleanSteamOutletShutOffValvePrefFormControl = new FormControl(null);
        this.csg1100CleanSteamOutletShutOffValvePrefFormControl = new FormControl(null);
        this.csg1600CleanSteamOutletShutOffValvePrefFormControl = new FormControl(null);
        // Test and certifications
        this.csg200TestAndCertificationPrefFormControl = new FormControl(null);
        this.csg500TestAndCertificationPrefFormControl = new FormControl(null);
        this.csg1100TestAndCertificationPrefFormControl = new FormControl(null);
        this.csg1600TestAndCertificationPrefFormControl = new FormControl(null);
        // Level_Indicator
        this.csg200Level_IndicatorPrefFormControl = new FormControl(null);
        this.csg500Level_IndicatorPrefFormControl = new FormControl(null);
        this.csg1100Level_IndicatorPrefFormControl = new FormControl(null);
        this.csg1600Level_IndicatorPrefFormControl = new FormControl(null);
        // Setup the form group.
        this.modulePreferencesForm = this.fb.group({
            // Currency Options
            csgManufacturerModulePreference: this.csgManufacturerPrefFormControl,
            csgManufacturerCurrencyModulePreference: this.csgManufacturerCurrencyPrefFormControl,
            csgSellingCurrencyModulePreference: this.csgSellingCurrencyPrefFormControl,
            // Pricing Options
            csgLandedCostIncreaseModulePreference: this.csgLandedCostIncreasePrefFormControl,
            csgDeliveryCostModulePreference: this.csgDeliveryCostPrefFormControl,
            csgCommissionOnlyPriceModulePreference: this.csgCommissionOnlyPricePrefFormControl,
            csgWarrantyOneYearModulePreference: this.csgWarrantyOneYearPrefFormControl,
            csgWarrantyTwoYearsModulePreference: this.csgWarrantyTwoYearsPrefFormControl,
            csgWarrantyThreeYearsModulePreference: this.csgWarrantyThreeYearsPrefFormControl,
            // Option Configuration
            csgOptionsSelection: this.csgOptionsFormControl,
            // Design Code
            csg200DesignCodePreference: this.csg200DesignCodePrefFormControl,
            csg500DesignCodePreference: this.csg500DesignCodePrefFormControl,
            csg1100DesignCodePreference: this.csg1100DesignCodePrefFormControl,
            csg1600DesignCodePreference: this.csg1600DesignCodePrefFormControl,
            // Shell Type
            csg200ShellTypePreference: this.csg200ShellTypePrefFormControl,
            csg500ShellTypePreference: this.csg500ShellTypePrefFormControl,
            csg1100ShellTypePreference: this.csg1100ShellTypePrefFormControl,
            csg1600ShellTypePreference: this.csg1600ShellTypePrefFormControl,
            // Control Valve Actuation
            csg200ValveActuationPreference: this.csg200ValveActuationPrefFormControl,
            csg500ValveActuationPreference: this.csg500ValveActuationPrefFormControl,
            csg1100ValveActuationPreference: this.csg1100ValveActuationPrefFormControl,
            csg1600ValveActuationPreference: this.csg1600ValveActuationPrefFormControl,
            // FeedwaterPressurisation
            csg0200FeedwaterPressurisationPreference: this.csg0200FeedwaterPressurisationPrefFormControl,
            csg0500FeedwaterPressurisationPreference: this.csg0500FeedwaterPressurisationPrefFormControl,
            csg1100FeedwaterPressurisationPreference: this.csg1100FeedwaterPressurisationPrefFormControl,
            csg1600FeedwaterPressurisationPreference: this.csg1600FeedwaterPressurisationPrefFormControl,
            // Control
            csg200ControlPreference: this.csg200ControlPrefFormControl,
            csg500ControlPreference: this.csg500ControlPrefFormControl,
            csg1100ControlPreference: this.csg1100ControlPrefFormControl,
            csg1600ControlPreference: this.csg1600ControlPrefFormControl,
            // Communication Interface
            csg200CommunicationInterfacePreference: this.csg200CommunicationInterfacePrefFormControl,
            csg500CommunicationInterfacePreference: this.csg500CommunicationInterfacePrefFormControl,
            csg1100CommunicationInterfacePreference: this.csg1100CommunicationInterfacePrefFormControl,
            csg1600CommunicationInterfacePreference: this.csg1600CommunicationInterfacePrefFormControl,
            // Frame and Cabinet
            csg200FrameAndCabinetPreference: this.csg200FrameAndCabinetPrefFormControl,
            csg500FrameAndCabinetPreference: this.csg500FrameAndCabinetPrefFormControl,
            csg1100FrameAndCabinetPreference: this.csg1100FrameAndCabinetPrefFormControl,
            csg1600FrameAndCabinetPreference: this.csg1600FrameAndCabinetPrefFormControl,
            // Control Panel Location
            csg200ControlPanelLocationPreference: this.csg200ControlPanelLocationPrefFormControl,
            csg500ControlPanelLocationPreference: this.csg500ControlPanelLocationPrefFormControl,
            csg1100ControlPanelLocationPreference: this.csg1100ControlPanelLocationPrefFormControl,
            csg1600ControlPanelLocationPreference: this.csg1600ControlPanelLocationPrefFormControl,
            // Insulation
            csg200InsulationPreference: this.csg200InsulationPrefFormControl,
            csg500InsulationPreference: this.csg500InsulationPrefFormControl,
            csg1100InsulationPreference: this.csg1100InsulationPrefFormControl,
            csg1600InsulationPreference: this.csg1600InsulationPrefFormControl,
            // Wheels And Feet
            csg200WheelsAndFeetPreference: this.csg200WheelsAndFeetPrefFormControl,
            csg500WheelsAndFeetPreference: this.csg500WheelsAndFeetPrefFormControl,
            csg1100WheelsAndFeetPreference: this.csg1100WheelsAndFeetPrefFormControl,
            csg1600WheelsAndFeetPreference: this.csg1600WheelsAndFeetPrefFormControl,
            // Plant Steam Inlet Shut Off Valve
            csg200PlantSteamInletShutOffValvePreference: this.csg200PlantSteamInletShutOffValvePrefFormControl,
            csg500PlantSteamInletShutOffValvePreference: this.csg500PlantSteamInletShutOffValvePrefFormControl,
            csg1100PlantSteamInletShutOffValvePreference: this.csg1100PlantSteamInletShutOffValvePrefFormControl,
            csg1600PlantSteamInletShutOffValvePreference: this.csg1600PlantSteamInletShutOffValvePrefFormControl,
            // Plant Steam Line Trapping
            csg200PlantSteamLineTrappingPreference: this.csg200PlantSteamLineTrappingPrefFormControl,
            csg500PlantSteamLineTrappingPreference: this.csg500PlantSteamLineTrappingPrefFormControl,
            csg1100PlantSteamLineTrappingPreference: this.csg1100PlantSteamLineTrappingPrefFormControl,
            csg1600PlantSteamLineTrappingPreference: this.csg1600PlantSteamLineTrappingPrefFormControl,
            // TDS control system
            csg200TDSControlSystemPreference: this.csg200TDSControlSystemPrefFormControl,
            csg500TDSControlSystemPreference: this.csg500TDSControlSystemPrefFormControl,
            csg1100TDSControlSystemPreference: this.csg1100TDSControlSystemPrefFormControl,
            csg1600TDSControlSystemPreference: this.csg1600TDSControlSystemPrefFormControl,
            // Sample Coolers
            csg200SampleCoolerPreference: this.csg200SampleCoolerPrefFormControl,
            csg500SampleCoolerPreference: this.csg500SampleCoolerPrefFormControl,
            csg1100SampleCoolerPreference: this.csg1100SampleCoolerPrefFormControl,
            csg1600SampleCoolerPreference: this.csg1600SampleCoolerPrefFormControl,
            // Independent low level alarm
            csg200IndependentLowLevelAlarmPreference: this.csg200IndependentLowLevelAlarmPrefFormControl,
            csg500IndependentLowLevelAlarmPreference: this.csg500IndependentLowLevelAlarmPrefFormControl,
            csg1100IndependentLowLevelAlarmPreference: this.csg1100IndependentLowLevelAlarmPrefFormControl,
            csg1600IndependentLowLevelAlarmPreference: this.csg1600IndependentLowLevelAlarmPrefFormControl,
            // Feedwater pre-heating / Degassing
            csg200FeedwaterPreHeatingDegassingPreference: this.csg200FeedwaterPreHeatingDegassingPrefFormControl,
            csg500FeedwaterPreHeatingDegassingPreference: this.csg500FeedwaterPreHeatingDegassingPrefFormControl,
            csg1100FeedwaterPreHeatingDegassingPreference: this.csg1100FeedwaterPreHeatingDegassingPrefFormControl,
            csg1600FeedwaterPreHeatingDegassingPreference: this.csg1600FeedwaterPreHeatingDegassingPrefFormControl,
            // Intelligent diagnostics
            csg200IntelligentDiagnosticsPreference: this.csg200IntelligentDiagnosticsPrefFormControl,
            csg500IntelligentDiagnosticsPreference: this.csg500IntelligentDiagnosticsPrefFormControl,
            csg1100IntelligentDiagnosticsPreference: this.csg1100IntelligentDiagnosticsPrefFormControl,
            csg1600IntelligentDiagnosticsPreference: this.csg1600IntelligentDiagnosticsPrefFormControl,
            // Clean steam outlet shut-off valve
            csg200CleanSteamOutletShutOffValvePreference: this.csg200CleanSteamOutletShutOffValvePrefFormControl,
            csg500CleanSteamOutletShutOffValvePreference: this.csg500CleanSteamOutletShutOffValvePrefFormControl,
            csg1100CleanSteamOutletShutOffValvePreference: this.csg1100CleanSteamOutletShutOffValvePrefFormControl,
            csg1600CleanSteamOutletShutOffValvePreference: this.csg1600CleanSteamOutletShutOffValvePrefFormControl,
            // Test and certifications
            csg200TestAndCertificationPreference: this.csg200TestAndCertificationPrefFormControl,
            csg500TestAndCertificationPreference: this.csg500TestAndCertificationPrefFormControl,
            csg1100TestAndCertificationPreference: this.csg1100TestAndCertificationPrefFormControl,
            csg1600TestAndCertificationPreference: this.csg1600TestAndCertificationPrefFormControl,
            // Level_Indicator
            csg200Level_IndicatorPreference: this.csg200Level_IndicatorPrefFormControl,
            csg500Level_IndicatorPreference: this.csg500Level_IndicatorPrefFormControl,
            csg1100Level_IndicatorPreference: this.csg1100Level_IndicatorPrefFormControl,
            csg1600Level_IndicatorPreference: this.csg1600Level_IndicatorPrefFormControl,
        }, { updateOn: "blur" });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        console.log("Starting Initializing CSG F&B Mini module prefs component");
        // First, get all the module preferences.
        this.componentLoadPromises.push(this.modulePreferenceService.getOperatingCompanyModulePreferences(this.moduleId).toPromise().then((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            if (result && result.length > 0) {
                // And set their values accordingly.
                this.manufacturerId = +this.getModulePreferenceValue(result, "CSGFBMiniManufacturer");
                this.csgManufacturerPrefFormControl.setValue(this.manufacturerId);
                this.csgManufacturerCurrencyId = +this.getModulePreferenceValue(result, "CSGFBMiniManufacturerCurrency");
                this.csgManufacturerCurrencyPrefFormControl.setValue(this.csgManufacturerCurrencyId);
                this.csgSellingCurrencyId = this.getModulePreferenceValue(result, "CSGFBMiniSellingCurrency");
                this.csgSellingCurrencyPrefFormControl.setValue(this.csgSellingCurrencyId);
                // Calculate the currency conversion rate.
                this.onSellingCurrencyChange(this.csgSellingCurrencyId);
                this.csgLandedCostIncreasePrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGFBMiniLandCostIncrease"));
                this.csgDeliveryCostPrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGFBMiniDeliveryCost"));
                this.csgCommissionOnlyPricePrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGFBMiniCommission"));
                this.csgWarrantyOneYearPrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGFBMiniYearOne"));
                this.csgWarrantyTwoYearsPrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGFBMiniYearTwo"));
                this.csgWarrantyThreeYearsPrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGFBMiniYearThree"));
                // Get the currency data.
                this.componentLoadPromises.push(this.adminService.getCurrencyData().toPromise().then((/**
                 * @param {?} data
                 * @return {?}
                 */
                data => {
                    this.currencyList = data;
                    // Selling currency found, so try to calculate the currency conversion rate.
                    this.onSellingCurrencyChange(this.csgSellingCurrencyId);
                    this.augmentPriceDataProcessing = false; // loaded enable toggle prices button
                })));
            }
        })));
        // Get the list of manufacturers.
        this.componentLoadPromises.push(this.adminService.getManufacturerData(this.moduleGroupId).toPromise().then((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            // Update the subject with the data that's just been retrieved (see the constructor).
            this.manufacturerList = result;
        })));
        // Now, set the "OpCo Selected Options" for the different CSG options.
        // Design Code
        this.setOpCoPreferences("CSG_FB_020_Design_Code", this.csg200DesignCodePrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Design_Code", this.csg500DesignCodePrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Design_Code", this.csg1100DesignCodePrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Design_Code", this.csg1600DesignCodePrefFormControl);
        // Shell Type
        this.setOpCoPreferences("CSG_FB_020_Shell_Type", this.csg200ShellTypePrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Shell_Type", this.csg500ShellTypePrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Shell_Type", this.csg1100ShellTypePrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Shell_Type", this.csg1600ShellTypePrefFormControl);
        // Control Valve Actuation
        this.setOpCoPreferences("CSG_FB_020_Valve_Actuation", this.csg200ValveActuationPrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Valve_Actuation", this.csg500ValveActuationPrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Valve_Actuation", this.csg1100ValveActuationPrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Valve_Actuation", this.csg1600ValveActuationPrefFormControl);
        // FeedwaterPressurisation
        this.setOpCoPreferences("CSG_FB_020_Feedwater_Pressurisation", this.csg0200FeedwaterPressurisationPrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Feedwater_Pressurisation", this.csg0500FeedwaterPressurisationPrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Feedwater_Pressurisation", this.csg1100FeedwaterPressurisationPrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Feedwater_Pressurisation", this.csg1600FeedwaterPressurisationPrefFormControl);
        // Control
        this.setOpCoPreferences("CSG_FB_020_Control", this.csg200ControlPrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Control", this.csg500ControlPrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Control", this.csg1100ControlPrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Control", this.csg1600ControlPrefFormControl);
        // Communication Interface
        this.setOpCoPreferences("CSG_FB_020_Communication_Interface", this.csg200CommunicationInterfacePrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Communication_Interface", this.csg500CommunicationInterfacePrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Communication_Interface", this.csg1100CommunicationInterfacePrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Communication_Interface", this.csg1600CommunicationInterfacePrefFormControl);
        // Frame and Cabinet
        this.setOpCoPreferences("CSG_FB_020_Frame_And_Cabinet", this.csg200FrameAndCabinetPrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Frame_And_Cabinet", this.csg500FrameAndCabinetPrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Frame_And_Cabinet", this.csg1100FrameAndCabinetPrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Frame_And_Cabinet", this.csg1600FrameAndCabinetPrefFormControl);
        // Control Panel Location
        this.setOpCoPreferences("CSG_FB_020_Control_Panel_Location", this.csg200ControlPanelLocationPrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Control_Panel_Location", this.csg500ControlPanelLocationPrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Control_Panel_Location", this.csg1100ControlPanelLocationPrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Control_Panel_Location", this.csg1600ControlPanelLocationPrefFormControl);
        // Insulation
        this.setOpCoPreferences("CSG_FB_020_Insulation", this.csg200InsulationPrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Insulation", this.csg500InsulationPrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Insulation", this.csg1100InsulationPrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Insulation", this.csg1600InsulationPrefFormControl);
        // Wheels And Feet
        this.setOpCoPreferences("CSG_FB_020_Wheels_And_Feet", this.csg200WheelsAndFeetPrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Wheels_And_Feet", this.csg500WheelsAndFeetPrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Wheels_And_Feet", this.csg1100WheelsAndFeetPrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Wheels_And_Feet", this.csg1600WheelsAndFeetPrefFormControl);
        // Plant Steam Inlet Shut Off Valve
        this.setOpCoPreferences("CSG_FB_020_Plant_Steam_Inlet_Shut_Off_Valve", this.csg200PlantSteamInletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Plant_Steam_Inlet_Shut_Off_Valve", this.csg500PlantSteamInletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Plant_Steam_Inlet_Shut_Off_Valve", this.csg1100PlantSteamInletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Plant_Steam_Inlet_Shut_Off_Valve", this.csg1600PlantSteamInletShutOffValvePrefFormControl);
        // Plant steam line trapping
        this.setOpCoPreferences("CSG_FB_020_Plant_Steam_Line_Trapping", this.csg200PlantSteamLineTrappingPrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Plant_Steam_Line_Trapping", this.csg500PlantSteamLineTrappingPrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Plant_Steam_Line_Trapping", this.csg1100PlantSteamLineTrappingPrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Plant_Steam_Line_Trapping", this.csg1600PlantSteamLineTrappingPrefFormControl);
        // TDS control system
        this.setOpCoPreferences("CSG_FB_020_TDS_Control_System", this.csg200TDSControlSystemPrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_TDS_Control_System", this.csg500TDSControlSystemPrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_TDS_Control_System", this.csg1100TDSControlSystemPrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_TDS_Control_System", this.csg1600TDSControlSystemPrefFormControl);
        // Sample Coolers
        this.setOpCoPreferences("CSG_FB_020_Sample_Cooler", this.csg200SampleCoolerPrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Sample_Cooler", this.csg500SampleCoolerPrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Sample_Cooler", this.csg1100SampleCoolerPrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Sample_Cooler", this.csg1600SampleCoolerPrefFormControl);
        // Independent low level alarm
        this.setOpCoPreferences("CSG_FB_020_Independent_Low_Level_Alarm", this.csg200IndependentLowLevelAlarmPrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Independent_Low_Level_Alarm", this.csg500IndependentLowLevelAlarmPrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Independent_Low_Level_Alarm", this.csg1100IndependentLowLevelAlarmPrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Independent_Low_Level_Alarm", this.csg1600IndependentLowLevelAlarmPrefFormControl);
        // Feedwater pre-heating / Degassing
        this.setOpCoPreferences("CSG_FB_020_Feedwater_Pre_Heating_Degassing", this.csg200FeedwaterPreHeatingDegassingPrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Feedwater_Pre_Heating_Degassing", this.csg500FeedwaterPreHeatingDegassingPrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Feedwater_Pre_Heating_Degassing", this.csg1100FeedwaterPreHeatingDegassingPrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Feedwater_Pre_Heating_Degassing", this.csg1600FeedwaterPreHeatingDegassingPrefFormControl);
        // Intelligent diagnostics
        this.setOpCoPreferences("CSG_FB_020_Intelligent_Diagnostics", this.csg200IntelligentDiagnosticsPrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Intelligent_Diagnostics", this.csg500IntelligentDiagnosticsPrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Intelligent_Diagnostics", this.csg1100IntelligentDiagnosticsPrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Intelligent_Diagnostics", this.csg1600IntelligentDiagnosticsPrefFormControl);
        // Clean steam outlet shut-off valve
        this.setOpCoPreferences("CSG_FB_020_Clean_Steam_Outlet_Shut_Off_Valve", this.csg200CleanSteamOutletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Clean_Steam_Outlet_Shut_Off_Valve", this.csg500CleanSteamOutletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Clean_Steam_Outlet_Shut_Off_Valve", this.csg1100CleanSteamOutletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Clean_Steam_Outlet_Shut_Off_Valve", this.csg1600CleanSteamOutletShutOffValvePrefFormControl);
        // Test and certifications
        this.setOpCoPreferences("CSG_FB_020_Test_And_Certification", this.csg200TestAndCertificationPrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Test_And_Certification", this.csg500TestAndCertificationPrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Test_And_Certification", this.csg1100TestAndCertificationPrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Test_And_Certification", this.csg1600TestAndCertificationPrefFormControl);
        // Level_Indicator
        this.setOpCoPreferences("CSG_FB_020_Level_Indicator", this.csg200Level_IndicatorPrefFormControl);
        this.setOpCoPreferences("CSG_FB_050_Level_Indicator", this.csg500Level_IndicatorPrefFormControl);
        this.setOpCoPreferences("CSG_FB_110_Level_Indicator", this.csg1100Level_IndicatorPrefFormControl);
        this.setOpCoPreferences("CSG_FB_160_Level_Indicator", this.csg1600Level_IndicatorPrefFormControl);
        this.csgOptionsSelectedItem = "Design Code";
        this.theFormGroup = this.modulePreferencesForm; // to drive GenericChangesGuard
        // Info ToolTip message translations
        this.serviceOffereingMessage = this.translatePipe.transform('SERVICE_OFFERING_MESSAGE', false);
        this.deliveryCostMessage = this.translatePipe.transform('DELIVERY_COST_MESSAGE', false);
        Promise.all(this.componentLoadPromises).then((/**
         * @return {?}
         */
        () => {
            console.log("Finishing Initializing CSG F&B Mini module prefs component");
            this.componentInitialised = true;
        }));
    }
    /**
     * @return {?}
     */
    togglePrices() {
        this.showPrices = !this.showPrices;
        this.augmentPriceDataProcessing = true;
        this.augmentPricesToOptionsLists(this.showPrices);
    }
    /**
     * @param {?=} showPrices
     * @return {?}
     */
    augmentPricesToOptionsLists(showPrices = true) {
        this.csgPricing = new CleanSteamGeneratorFBPricing();
        this.csgPricing.modelId = -1; // All BOM items    
        this.csgPricing.pricingOptions = [];
        this.csgPricing.basePriceOption = -1;
        this.csgPricing.localRecommendedSalesPriceOption = -1;
        this.csgPricing.landedCostIncreaseFactor = -1;
        this.csgSellingCurrencySymbol = !!this.csgSellingCurrencySymbol ? this.csgSellingCurrencySymbol : "?";
        this.csgPricing.manufacturerId = +(!!this.manufacturerId ? this.manufacturerId : -1);
        this.csgManufacturerCurrency = this.currencyList.find((/**
         * @param {?} c
         * @return {?}
         */
        c => c.id === this.csgManufacturerCurrencyId));
        this.csgManufacturerCurrencySymbol = !!this.csgManufacturerCurrency ? this.csgManufacturerCurrency.symbol : "?";
        if (showPrices) {
            // Get RSP Display price data for List item Augmentation
            this.cleanSteamGeneratorService.calculateBOMPriceFBMini(this.csgPricing).subscribe((/**
             * @param {?} response
             * @return {?}
             */
            (response) => {
                if (response) {
                    this.csgBOMOutputData = response;
                    /** @type {?} */
                    let manPrice = "";
                    /** @type {?} */
                    let localPrices = "";
                    /** @type {?} */
                    let isOverride = "";
                    this.CSG_FB_020_Price = "";
                    this.CSG_FB_050_Price = "";
                    this.CSG_FB_110_Price = "";
                    this.CSG_FB_160_Price = "";
                    this.csgBOMOutputData.bomItems.forEach((/**
                     * @param {?} t
                     * @return {?}
                     */
                    t => {
                        if (showPrices && t.itemType == "Base") {
                            // Price the models
                            if (t.sRecommendedSalesPrice != 0.0 && t.sRecommendedSalesPrice != parseFloat(t.sDisplayedRSP)) {
                                isOverride = 'o';
                            }
                            manPrice = ' SSP=' + this.csgManufacturerCurrencySymbol + ' ' + this.localizeValue(t.ssp, 0);
                            localPrices = ' RSP' + isOverride + '=' + this.csgManufacturerCurrencySymbol + ' ' + this.localizeValue(t.displayedRSP, 0);
                            if (t.ssp != t.sSSP) { // if not the same currency data
                                manPrice = manPrice + ' (' + this.csgSellingCurrencySymbol + ' ' + this.localizeValue(t.sSSP, 0) + ')';
                                localPrices = localPrices + ' (' + this.csgSellingCurrencySymbol + ' ' + this.localizeValue(t.sDisplayedRSP, 0) + ')';
                            }
                            switch (t.parentMasterTextKey) {
                                case "CSG_FB_020":
                                    this.CSG_FB_020_Price = manPrice + localPrices;
                                    break;
                                case "CSG_FB_050":
                                    this.CSG_FB_050_Price = manPrice + localPrices;
                                    break;
                                case "CSG_FB_110":
                                    this.CSG_FB_110_Price = manPrice + localPrices;
                                    break;
                                case "CSG_FB_160":
                                    this.CSG_FB_160_Price = manPrice + localPrices;
                                    break;
                                default:
                                    break;
                            }
                        }
                        // Set option item enabled?
                        /** @type {?} */
                        var newEnumerationModulePreferences = this.GetNewEnumerationModulePreferences();
                        this.csgBOMOutputData.bomItems.forEach((/**
                         * @param {?} p
                         * @return {?}
                         */
                        p => {
                            /** @type {?} */
                            var elist = newEnumerationModulePreferences.find((/**
                             * @param {?} e
                             * @return {?}
                             */
                            e => e.enumerationName == p.parent));
                            if (!!elist) {
                                /** @type {?} */
                                var elistItem = elist.enumerationDefinitions.find((/**
                                 * @param {?} l
                                 * @return {?}
                                 */
                                l => l.value == p.item));
                            }
                            p.isEnabled = !!elistItem ? true : false;
                            // Set enabled if base CSG model item or add on (Commisoining, Voltage, Warranty etc.)
                            if (!p.parentMasterTextKey
                                || (!!p.parentMasterTextKey && p.parentMasterTextKey.indexOf('FEEDWATER_') === 0) // no list override for it
                                || (!!p.parentMasterTextKey && p.parentMasterTextKey.indexOf('CSG_') === 0)) {
                                p.isEnabled = true;
                            }
                        }));
                        // Append prices to list translation on UI
                        this.translationService.displayGroup.enumerations.forEach((/**
                         * @param {?} e
                         * @return {?}
                         */
                        e => {
                            e.enumerationDefinitions.forEach((/**
                             * @param {?} d
                             * @return {?}
                             */
                            d => {
                                if (e.enumerationName == t.parent && d.value == t.item) { // && d.translationText.indexOf(' ' + this.sellingCurrencySymbol + ' ') < 0) {              
                                    if (showPrices) {
                                        if (t.sRecommendedSalesPrice != 0.0 && (t.sRecommendedSalesPrice != parseFloat(t.sDisplayedRSP))) {
                                            isOverride = 'o';
                                        }
                                        /** @type {?} */
                                        var nomCode = '';
                                        if (!!t.item.split('_')[1]) {
                                            nomCode = '(' + t.item.split('_')[1] + ') ';
                                        }
                                        manPrice = ' SSP=' + this.csgManufacturerCurrencySymbol + ' ' + this.localizeValue(t.ssp, 0);
                                        localPrices = ' RSP' + isOverride + '=' + this.csgManufacturerCurrencySymbol + ' ' + this.localizeValue(t.displayedRSP, 0);
                                        if (t.ssp != t.sSSP) { // if not the same currency data
                                            manPrice = manPrice + ' (' + this.csgSellingCurrencySymbol + ' ' + this.localizeValue(t.sSSP, 0) + ')';
                                            localPrices = localPrices + ' (' + this.csgSellingCurrencySymbol + ' ' + this.localizeValue(t.sDisplayedRSP, 0) + ')';
                                        }
                                        // Set the UI text
                                        d.extraPostText = manPrice + localPrices;
                                        d.extraPreText = nomCode;
                                    }
                                    else {
                                        d.extraPostText = ""; // clear augmented data
                                        d.extraPreText = "";
                                    }
                                }
                            }));
                        }));
                    })); // of append prices
                    this.augmentPriceDataProcessing = false; // finished, enable button again
                    //this.scrollToElement(this.collapsePriceDataTop, "start");
                }
            })); // end of service response
        } // end of if showPrices
        else {
            // remove price augmentation
            this.CSG_FB_020_Price = "";
            this.CSG_FB_050_Price = "";
            this.CSG_FB_110_Price = "";
            this.CSG_FB_160_Price = "";
            this.translationService.displayGroup.enumerations.forEach((/**
             * @param {?} e
             * @return {?}
             */
            e => {
                e.enumerationDefinitions.forEach((/**
                 * @param {?} d
                 * @return {?}
                 */
                d => d.extraPostText = "")); // clear augmented data
                //e.enumerationDefinitions.forEach(d => d.extraPreText = "") // leave Nom codes on for easy UI reference.
            }));
            this.augmentPriceDataProcessing = false; // finished, enable button again
        }
    }
    /**
     * Method to localize values.
     * @param {?} value
     * @param {?} decimalPoints
     * @return {?}
     */
    localizeValue(value, decimalPoints) {
        return this.localeService.formatDecimal(value.toFixed(decimalPoints));
    }
    /*
      * Method to get and set the OpCo selected options.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} formControlName
     * @return {?}
     */
    setOpCoPreferences(enumerationPickerName, formControlName) {
        // Get the collection list first.
        /** @type {?} */
        let csgOpCoPref = this.getEnumerationPickerCollection(enumerationPickerName, true);
        // Check if any OpCo Overrides Data found? If NOT then get the base list populated.
        if (!csgOpCoPref) {
            csgOpCoPref = this.cloneDeep(this.getEnumerationPickerCollection(enumerationPickerName, false));
        }
        // Check and set the list.
        if (!!csgOpCoPref && csgOpCoPref.length > 0) {
            formControlName.setValue(csgOpCoPref);
        }
    }
    /*
      * Method to get the Enumeration list by Name.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} opCoOverride
     * @return {?}
     */
    getEnumerationPickerCollection(enumerationPickerName, opCoOverride) {
        /** @type {?} */
        const enumeration = this.translationService.displayGroup.enumerations.filter((/**
         * @param {?} us
         * @return {?}
         */
        us => us.enumerationName === enumerationPickerName && us.opCoOverride === opCoOverride));
        if (!!enumeration && enumeration.length > 0) {
            /** @type {?} */
            let definitions = enumeration[0].enumerationDefinitions.sort((/**
             * @param {?} currentenumeration
             * @param {?} nextenumeration
             * @return {?}
             */
            (currentenumeration, nextenumeration) => {
                if (currentenumeration.sequence > nextenumeration.sequence) {
                    return 1;
                }
                if (currentenumeration.sequence < nextenumeration.sequence) {
                    return -1;
                }
                return 0;
            }));
            //this.onChange(definitions);
            definitions.forEach((/**
             * @param {?} i
             * @return {?}
             */
            i => i.isDeleted = false));
            return definitions;
        }
    }
    /**
     * Submits the form for saving to the server.
     * @param {?} $event
     * @return {?}
     */
    submitForm($event) {
        $event.preventDefault();
        // Mark the form as submitted.
        this.formSubmitted = true;
        // Regular Module Preferences.
        /** @type {?} */
        const newModulePreferences = [];
        newModulePreferences.push(this.getSelectedPreferences("CSGFBMiniSellingCurrency", "csgSellingCurrencyModulePreference"));
        newModulePreferences.push(this.getSelectedPreferences("CSGFBMiniLandCostIncrease", "csgLandedCostIncreaseModulePreference"));
        newModulePreferences.push(this.getSelectedPreferences("CSGFBMiniDeliveryCost", "csgDeliveryCostModulePreference"));
        newModulePreferences.push(this.getSelectedPreferences("CSGFBMiniCommission", "csgCommissionOnlyPriceModulePreference"));
        newModulePreferences.push(this.getSelectedPreferences("CSGFBMiniYearOne", "csgWarrantyOneYearModulePreference"));
        newModulePreferences.push(this.getSelectedPreferences("CSGFBMiniYearTwo", "csgWarrantyTwoYearsModulePreference"));
        newModulePreferences.push(this.getSelectedPreferences("CSGFBMiniYearThree", "csgWarrantyThreeYearsModulePreference"));
        // Save the changed preferences as an array of preferences
        this.adminService.manageModulePreferences(newModulePreferences).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            // The form can be submitted again.
            this.formSubmitted = false;
            // Set the operation based on the response.
            // this.isSuccess = response;
            this.alertVisible = true;
        }));
        /** @type {?} */
        var newEnumerationModulePreferences = this.GetNewEnumerationModulePreferences();
        // Save the changed preferences as an array of preferences
        this.adminService.manageEnumerationModulePreferences(newEnumerationModulePreferences).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            // The form can be submitted again.
            this.formSubmitted = false;
            // Set the operation based on the response.
            this.isSuccess = response;
            this.alertVisible = true;
            this.modulePreferencesForm.markAsPristine(); // to drive GenericChangesGuard
        }));
    }
    /**
     * @return {?}
     */
    GetNewEnumerationModulePreferences() {
        // Enumeration Module Preferences.
        /** @type {?} */
        const newEnumerationModulePreferences = [];
        // Design Code
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Design_Code", "csg200DesignCodePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Design_Code", "csg500DesignCodePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Design_Code", "csg1100DesignCodePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Design_Code", "csg1600DesignCodePreference"));
        // Shell Type
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Shell_Type", "csg200ShellTypePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Shell_Type", "csg500ShellTypePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Shell_Type", "csg1100ShellTypePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Shell_Type", "csg1600ShellTypePreference"));
        // Control Valve Actuation
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Valve_Actuation", "csg200ValveActuationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Valve_Actuation", "csg500ValveActuationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Valve_Actuation", "csg1100ValveActuationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Valve_Actuation", "csg1600ValveActuationPreference"));
        // Feedwater Pressurisation - does the list have AllowOverride set to true or just readOnly?
        if (!!this.getEnumerationPickerCollection('CSG_FB_020_Feedwater_Pressurisation', true)) {
            // The lists AllowOverride == true, so we can save the OpCo's Module Preference for these lists and list items.
            newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Feedwater_Pressurisation", "csg0200FeedwaterPressurisationPreference"));
            newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Feedwater_Pressurisation", "csg0500FeedwaterPressurisationPreference"));
            newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Feedwater_Pressurisation", "csg1100FeedwaterPressurisationPreference"));
            newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Feedwater_Pressurisation", "csg1600FeedwaterPressurisationPreference"));
        }
        // Control
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Control", "csg200ControlPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Control", "csg500ControlPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Control", "csg1100ControlPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Control", "csg1600ControlPreference"));
        // Communication Interface
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Communication_Interface", "csg200CommunicationInterfacePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Communication_Interface", "csg500CommunicationInterfacePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Communication_Interface", "csg1100CommunicationInterfacePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Communication_Interface", "csg1600CommunicationInterfacePreference"));
        // Frame and Cabinet
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Frame_And_Cabinet", "csg200FrameAndCabinetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Frame_And_Cabinet", "csg500FrameAndCabinetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Frame_And_Cabinet", "csg1100FrameAndCabinetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Frame_And_Cabinet", "csg1600FrameAndCabinetPreference"));
        // Control Panel Location
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Control_Panel_Location", "csg200ControlPanelLocationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Control_Panel_Location", "csg500ControlPanelLocationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Control_Panel_Location", "csg1100ControlPanelLocationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Control_Panel_Location", "csg1600ControlPanelLocationPreference"));
        // Insulation
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Insulation", "csg200InsulationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Insulation", "csg500InsulationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Insulation", "csg1100InsulationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Insulation", "csg1600InsulationPreference"));
        // Wheels And Feet
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Wheels_And_Feet", "csg200WheelsAndFeetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Wheels_And_Feet", "csg500WheelsAndFeetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Wheels_And_Feet", "csg1100WheelsAndFeetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Wheels_And_Feet", "csg1600WheelsAndFeetPreference"));
        // Plant Steam Inlet Shut Off Valve
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Plant_Steam_Inlet_Shut_Off_Valve", "csg200PlantSteamInletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Plant_Steam_Inlet_Shut_Off_Valve", "csg500PlantSteamInletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Plant_Steam_Inlet_Shut_Off_Valve", "csg1100PlantSteamInletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Plant_Steam_Inlet_Shut_Off_Valve", "csg1600PlantSteamInletShutOffValvePreference"));
        // Plant steam line trapping
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Plant_Steam_Line_Trapping", "csg200PlantSteamLineTrappingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Plant_Steam_Line_Trapping", "csg500PlantSteamLineTrappingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Plant_Steam_Line_Trapping", "csg1100PlantSteamLineTrappingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Plant_Steam_Line_Trapping", "csg1600PlantSteamLineTrappingPreference"));
        // TDS control system
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_TDS_Control_System", "csg200TDSControlSystemPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_TDS_Control_System", "csg500TDSControlSystemPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_TDS_Control_System", "csg1100TDSControlSystemPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_TDS_Control_System", "csg1600TDSControlSystemPreference"));
        // Sample Coolers
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Sample_Cooler", "csg200SampleCoolerPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Sample_Cooler", "csg500SampleCoolerPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Sample_Cooler", "csg1100SampleCoolerPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Sample_Cooler", "csg1600SampleCoolerPreference"));
        // Independent low level alarm
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Independent_Low_Level_Alarm", "csg200IndependentLowLevelAlarmPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Independent_Low_Level_Alarm", "csg500IndependentLowLevelAlarmPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Independent_Low_Level_Alarm", "csg1100IndependentLowLevelAlarmPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Independent_Low_Level_Alarm", "csg1600IndependentLowLevelAlarmPreference"));
        // Feedwater pre-heating / Degassing
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Feedwater_Pre_Heating_Degassing", "csg200FeedwaterPreHeatingDegassingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Feedwater_Pre_Heating_Degassing", "csg500FeedwaterPreHeatingDegassingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Feedwater_Pre_Heating_Degassing", "csg1100FeedwaterPreHeatingDegassingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Feedwater_Pre_Heating_Degassing", "csg1600FeedwaterPreHeatingDegassingPreference"));
        // Intelligent diagnostics
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Intelligent_Diagnostics", "csg200IntelligentDiagnosticsPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Intelligent_Diagnostics", "csg500IntelligentDiagnosticsPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Intelligent_Diagnostics", "csg1100IntelligentDiagnosticsPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Intelligent_Diagnostics", "csg1600IntelligentDiagnosticsPreference"));
        // Clean steam outlet shut-off valve
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Clean_Steam_Outlet_Shut_Off_Valve", "csg200CleanSteamOutletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Clean_Steam_Outlet_Shut_Off_Valve", "csg500CleanSteamOutletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Clean_Steam_Outlet_Shut_Off_Valve", "csg1100CleanSteamOutletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Clean_Steam_Outlet_Shut_Off_Valve", "csg1600CleanSteamOutletShutOffValvePreference"));
        // Test and certifications
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Test_And_Certification", "csg200TestAndCertificationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Test_And_Certification", "csg500TestAndCertificationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Test_And_Certification", "csg1100TestAndCertificationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Test_And_Certification", "csg1600TestAndCertificationPreference"));
        // Level_Indicator
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_020_Level_Indicator", "csg200Level_IndicatorPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_050_Level_Indicator", "csg500Level_IndicatorPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_110_Level_Indicator", "csg1100Level_IndicatorPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FB_160_Level_Indicator", "csg1600Level_IndicatorPreference"));
        return newEnumerationModulePreferences;
    }
    /*
      * Method to get opco selected enumeration module prefernce details for each options.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} prefsFormKeyName
     * @return {?}
     */
    getSelectedEnumerationPreferences(enumerationPickerName, prefsFormKeyName) {
        /** @type {?} */
        var modPrefs = new Enumeration;
        modPrefs.enumerationName = enumerationPickerName;
        modPrefs.opCoOverride = true;
        modPrefs.enumerationDefinitions = this.modulePreferencesForm.controls[prefsFormKeyName].value;
        return modPrefs;
    }
    /*
      * Method to get opco selected module prefernce details.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} prefsFormKeyName
     * @return {?}
     */
    getSelectedPreferences(enumerationPickerName, prefsFormKeyName) {
        /** @type {?} */
        var modPrefs = new ModulePreferenceDetails;
        modPrefs.name = enumerationPickerName;
        modPrefs.value = "" + this.modulePreferencesForm.controls[prefsFormKeyName].value;
        modPrefs.moduleId = +this.moduleId;
        modPrefs.isDeleted = false;
        return modPrefs;
    }
    /**
     * @return {?}
     */
    closeAlert() {
        // Reset the flag
        this.alertVisible = false;
    }
    /**
     * @return {?}
     */
    onChangeAnyOption() {
        // Any enumeration-picker (on-change) set the form data to dirty.
        this.modulePreferencesForm.markAsDirty();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onCSGOptionsChange(event) {
        this.csgOptionsSelectedItem = event.selectedValue;
        this.csgOptionsFormControl.markAsPristine(); // Options list selector is not a data change item, so ignore changes.
    }
    /*
      * Method to calculate the currency conversion rate.
      */
    /**
     * @param {?} selectedValue
     * @return {?}
     */
    onSellingCurrencyChange(selectedValue) {
        if (selectedValue > 0 && this.csgManufacturerCurrencyId > 0 && this.currencyList.length > 0) {
            /** @type {?} */
            let sellingCurrency = this.currencyList.find((/**
             * @param {?} c
             * @return {?}
             */
            c => c.id === +selectedValue));
            /** @type {?} */
            let manufacturerCurrency = this.currencyList.find((/**
             * @param {?} c
             * @return {?}
             */
            c => c.id === this.csgManufacturerCurrencyId));
            this.csgSellingCurrencySymbol = sellingCurrency.symbol;
            this.csgCurrencyConversion = +((manufacturerCurrency.rateToGbp * (1 / sellingCurrency.rateToGbp)).toFixed(5));
        }
    }
    /*
      * Method to retrieve the module pref value from the list.
      */
    /**
     * @param {?} modulePrefList
     * @param {?} modulePrefName
     * @return {?}
     */
    getModulePreferenceValue(modulePrefList, modulePrefName) {
        /** @type {?} */
        let modPref = modulePrefList.filter((/**
         * @param {?} r
         * @return {?}
         */
        r => r.name === modulePrefName));
        if (modPref && modPref.length > 0) {
            return modPref[0].value;
        }
    }
    /**
     * @param {?} row
     * @return {?}
     */
    getRowClass(row) {
        if (row.isEnabled) {
            return 'row-color-enabled';
        }
        return 'row-color-disabled';
    }
}
CleanSteamGeneratorFBMiniModulePreferencesComponent.decorators = [
    { type: Component, args: [{
                selector: 'cleansteamgeneratorFBMini-module-preferences',
                template: "<!--CleanSteamGenerator module preferences component works!-->\r\n<div *ngIf=\"!componentInitialised\">\r\n  <div class=\"ball-clip-rotate\">\r\n    <div></div>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"!!componentInitialised\">\r\n  <form [formGroup]=\"modulePreferencesForm\" class=\"form-horizontal\" role=\"form\" (submit)=\"submitForm($event)\" novalidate>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <button [disabled]=\"!modulePreferencesForm.dirty || !modulePreferencesForm.valid || modulePreferencesForm.status !== 'VALID' || formSubmitted\" type=\"submit\" class=\"btn btn-dynamic btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i></button>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <br>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Success confirmation message -->\r\n    <alert-block *ngIf=\"!!alertVisible && !!isSuccess\" type=\"success\" [auto-close]=\"true\" [message]=\"'MODULE_PREFERENCES_SAVED_SUCCESSFULLY_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n    <!-- Failure confirmation message-->\r\n    <alert-block *ngIf=\"!!alertVisible && !isSuccess\" type=\"danger\" [message]=\"'MODULE_PREFERENCES_FAILED_TO_SAVE_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"currencyOptionsHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseCurrencyOptions\" aria-expanded=\"true\" aria-controls=\"collapseCurrencyOptions\">\r\n            {{\"CURRENCY_OPTIONS\" | translate}} - <em class=\"fa fa-steam-square fa-fw\" style=\"color:navy\"></em>FB Mini\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapseCurrencyOptions\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"currencyOptionsHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-10px\">\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"row\" style=\"padding-bottom:15px\">\r\n\r\n              <!--Manufacturer-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"MANUFACTURER\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"csgManufacturerModulePreference\">\r\n                  <option *ngFor=\"let manufacturer of manufacturerList\" [value]=\"manufacturer.id\">{{manufacturer.name}}</option>\r\n                </select>\r\n              </div>\r\n\r\n              <!--Selling currency-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"SELLING_CURRENCY\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"csgSellingCurrencyModulePreference\" (ngModelChange)=\"onSellingCurrencyChange($event)\">\r\n                  <option *ngFor=\"let currency of currencyList\" [value]=\"currency.id\">{{currency.currencyCode}} - {{currency.symbol}}</option>\r\n                </select>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n\r\n              <!--Manufacturer currency-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"MANUFACTURER_CURRENCY\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"csgManufacturerCurrencyModulePreference\">\r\n                  <option *ngFor=\"let currency of currencyList\" [value]=\"currency.id\">{{currency.currencyCode}} - {{currency.symbol}}</option>\r\n                </select>\r\n              </div>\r\n\r\n              <!--Currency conversion-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"CURRENCY_CONVERSION\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <label class=\"control-label\">{{csgCurrencyConversion}}</label>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--Pricing Options-->\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"pricingOptionsHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapsePricingOptions\" aria-expanded=\"true\" aria-controls=\"collapsePricingOptions\">\r\n            {{\"PRICING_OPTIONS\" | translate}} - <em class=\"fa fa-steam-square fa-fw\" style=\"color:navy\"></em>FB Mini\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapsePricingOptions\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"pricingOptionsHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-30px\">\r\n          <div class=\"form-group\">\r\n            <!--Column 1-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <!--Landed Cost Increase-->\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"LANDED_COST_INCREASE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"csgLandedCostIncreaseModulePreference\" value=\"csgLandedCostIncrease\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].dirty || modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].hasError('range') && (modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].dirty || modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].touched)\">{{\"LANDED_COST_INCREASE_MUST_BE_BETWEEN_0_AND_100_PERCENT_MESSAGE\" | translate}}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <!--Delivery Cost-->\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"DELIVERY_COST\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-addon\">{{csgSellingCurrencySymbol}}</span>\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"text\" style=\"min-width:55px;\" formControlName=\"csgDeliveryCostModulePreference\" value=\"csgDeliveryCost\" twoDigitDecimalNumber />\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2 cross-validation-error-class\" >\r\n                  <div><i *ngIf=\"deliveryCostMessage\" class=\"fa fa-info-circle cross-validation-error-class\" [tooltip]=\"deliveryCostMessage\" placement=\"top,right\"></i></div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgDeliveryCostModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgDeliveryCostModulePreference'].dirty || modulePreferencesForm.controls['csgDeliveryCostModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Column 2-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"panel panel-primary\" style=\"padding-bottom: 20px;\">\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-4 text-right\">\r\n                    <h4>{{\"SERVICE_OFFERING\" | translate}}</h4>\r\n                  </div>\r\n                  <div class=\"col-xs-3 cross-validation-error-class\">\r\n                    <div><i *ngIf=\"serviceOffereingMessage\" class=\"fa fa-info-circle cross-validation-error-class\" [tooltip]=\"serviceOffereingMessage\" placement=\"top,right\"></i></div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--Commission Only Price-->\r\n                  <div class=\"col-xs-4 text-right\">\r\n                    <label class=\"control-label\">{{\"COMMISSION_ONLY_PRICE\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{csgSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"csgCommissionOnlyPriceModulePreference\" value=\"csgCommissionOnlyPrice\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgCommissionOnlyPriceModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgCommissionOnlyPriceModulePreference'].dirty || modulePreferencesForm.controls['csgCommissionOnlyPriceModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n                <!--</fieldset>-->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--One Year-->\r\n                  <div class=\"col-xs-4 text-right\">\r\n                    <label class=\"control-label\">{{\"ONE_YEAR\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{csgSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"csgWarrantyOneYearModulePreference\" value=\"csgWarrantyOneYear\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgWarrantyOneYearModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgWarrantyOneYearModulePreference'].dirty || modulePreferencesForm.controls['csgWarrantyOneYearModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--Two Years-->\r\n                  <div class=\"col-xs-4 text-right\">\r\n                    <label class=\"control-label\">{{\"TWO_YEARS\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{csgSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"csgWarrantyTwoYearsModulePreference\" value=\"csgWarrantyTwoYears\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgWarrantyTwoYearsModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgWarrantyTwoYearsModulePreference'].dirty || modulePreferencesForm.controls['csgWarrantyTwoYearsModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--Three Years-->\r\n                  <div class=\"col-xs-4 text-right\">\r\n                    <label class=\"control-label\">{{\"THREE_YEARS\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{csgSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"csgWarrantyThreeYearsModulePreference\" value=\"csgWarrantyThreeYears\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgWarrantyThreeYearsModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgWarrantyThreeYearsModulePreference'].dirty || modulePreferencesForm.controls['csgWarrantyThreeYearsModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--Configurartion Options-->\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"optionConfigurartionHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseOptionConfigurartion\" aria-expanded=\"true\" aria-controls=\"collapseOptionConfigurartion\">\r\n            {{\"OPTION_CONFIGURATION\" | translate}} - <em class=\"fa fa-steam-square fa-fw\" style=\"color:navy\"></em>FB Mini\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapseOptionConfigurartion\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"optionConfigurartionHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-20px\">\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-2 text-right\">\r\n                <label class=\"control-label\">{{\"PLEASE_SELECT\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                <enumeration formControlName=\"csgOptionsSelection\" enumeration-name=\"CSG_FB_Options\" (on-change)=\"onCSGOptionsChange($event)\"></enumeration>\r\n              </div>\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                <button [disabled]=\"augmentPriceDataProcessing\" class=\"btn btn-dynamic btn-primary pull-right\" type='button' (click)=\"togglePrices();\" [title]=\"'TOGGLE_PRICES' | translate\"><i class=\"fa fa-exchange\">  {{'TOGGLE_PRICES' | translate}}</i></button>\r\n              </div>\r\n            </div>\r\n            <hr>\r\n            <!--Design Code-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Design Code'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200DesignCodePreference\" enumeration-picker-name=\"CSG_FB_020_Design_Code\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500DesignCodePreference\" enumeration-picker-name=\"CSG_FB_050_Design_Code\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100DesignCodePreference\" enumeration-picker-name=\"CSG_FB_110_Design_Code\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600DesignCodePreference\" enumeration-picker-name=\"CSG_FB_160_Design_Code\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Shell Type-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Shell Type'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200ShellTypePreference\" enumeration-picker-name=\"CSG_FB_020_Shell_Type\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500ShellTypePreference\" enumeration-picker-name=\"CSG_FB_050_Shell_Type\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100ShellTypePreference\" enumeration-picker-name=\"CSG_FB_110_Shell_Type\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600ShellTypePreference\" enumeration-picker-name=\"CSG_FB_160_Shell_Type\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Valve Actuation-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Valve Actuation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200ValveActuationPreference\" enumeration-picker-name=\"CSG_FB_020_Valve_Actuation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500ValveActuationPreference\" enumeration-picker-name=\"CSG_FB_050_Valve_Actuation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100ValveActuationPreference\" enumeration-picker-name=\"CSG_FB_110_Valve_Actuation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600ValveActuationPreference\" enumeration-picker-name=\"CSG_FB_160_Valve_Actuation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Feedwater Pressurisation-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Feedwater pressurisation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg0200FeedwaterPressurisationPreference\" enumeration-picker-name=\"CSG_FB_020_Feedwater_Pressurisation\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg0500FeedwaterPressurisationPreference\" enumeration-picker-name=\"CSG_FB_050_Feedwater_Pressurisation\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100FeedwaterPressurisationPreference\" enumeration-picker-name=\"CSG_FB_110_Feedwater_Pressurisation\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600FeedwaterPressurisationPreference\" enumeration-picker-name=\"CSG_FB_160_Feedwater_Pressurisation\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Control-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Control'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200ControlPreference\" enumeration-picker-name=\"CSG_FB_020_Control\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500ControlPreference\" enumeration-picker-name=\"CSG_FB_050_Control\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100ControlPreference\" enumeration-picker-name=\"CSG_FB_110_Control\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600ControlPreference\" enumeration-picker-name=\"CSG_FB_160_Control\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Communication interface-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Communication interface'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200CommunicationInterfacePreference\" enumeration-picker-name=\"CSG_FB_020_Communication_Interface\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500CommunicationInterfacePreference\" enumeration-picker-name=\"CSG_FB_050_Communication_Interface\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100CommunicationInterfacePreference\" enumeration-picker-name=\"CSG_FB_110_Communication_Interface\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600CommunicationInterfacePreference\" enumeration-picker-name=\"CSG_FB_160_Communication_Interface\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Frame and cabinet-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Frame and Cabinet'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200FrameAndCabinetPreference\" enumeration-picker-name=\"CSG_FB_020_Frame_And_Cabinet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500FrameAndCabinetPreference\" enumeration-picker-name=\"CSG_FB_050_Frame_And_Cabinet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100FrameAndCabinetPreference\" enumeration-picker-name=\"CSG_FB_110_Frame_And_Cabinet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600FrameAndCabinetPreference\" enumeration-picker-name=\"CSG_FB_160_Frame_And_Cabinet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Control Panel Location-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Control panel location'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200ControlPanelLocationPreference\" enumeration-picker-name=\"CSG_FB_020_Control_Panel_Location\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500ControlPanelLocationPreference\" enumeration-picker-name=\"CSG_FB_050_Control_Panel_Location\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100ControlPanelLocationPreference\" enumeration-picker-name=\"CSG_FB_110_Control_Panel_Location\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600ControlPanelLocationPreference\" enumeration-picker-name=\"CSG_FB_160_Control_Panel_Location\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Insulation-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Insulation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200InsulationPreference\" enumeration-picker-name=\"CSG_FB_020_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500InsulationPreference\" enumeration-picker-name=\"CSG_FB_050_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100InsulationPreference\" enumeration-picker-name=\"CSG_FB_110_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600InsulationPreference\" enumeration-picker-name=\"CSG_FB_160_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Handling wheels and feet-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Handling wheels and feet'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200WheelsAndFeetPreference\" enumeration-picker-name=\"CSG_FB_020_Wheels_And_Feet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500WheelsAndFeetPreference\" enumeration-picker-name=\"CSG_FB_050_Wheels_And_Feet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100WheelsAndFeetPreference\" enumeration-picker-name=\"CSG_FB_110_Wheels_And_Feet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600WheelsAndFeetPreference\" enumeration-picker-name=\"CSG_FB_160_Wheels_And_Feet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Plant Steam Inlet Shut Off Valve-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Plant steam inlet shut-off valve'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200PlantSteamInletShutOffValvePreference\" enumeration-picker-name=\"CSG_FB_020_Plant_Steam_Inlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500PlantSteamInletShutOffValvePreference\" enumeration-picker-name=\"CSG_FB_050_Plant_Steam_Inlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100PlantSteamInletShutOffValvePreference\" enumeration-picker-name=\"CSG_FB_110_Plant_Steam_Inlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600PlantSteamInletShutOffValvePreference\" enumeration-picker-name=\"CSG_FB_160_Plant_Steam_Inlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Plant steam line trapping-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Plant steam line trapping'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200PlantSteamLineTrappingPreference\" enumeration-picker-name=\"CSG_FB_020_Plant_Steam_Line_Trapping\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500PlantSteamLineTrappingPreference\" enumeration-picker-name=\"CSG_FB_050_Plant_Steam_Line_Trapping\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100PlantSteamLineTrappingPreference\" enumeration-picker-name=\"CSG_FB_110_Plant_Steam_Line_Trapping\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600PlantSteamLineTrappingPreference\" enumeration-picker-name=\"CSG_FB_160_Plant_Steam_Line_Trapping\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--TDS control system-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'TDS control system'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200TDSControlSystemPreference\" enumeration-picker-name=\"CSG_FB_020_TDS_Control_System\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500TDSControlSystemPreference\" enumeration-picker-name=\"CSG_FB_050_TDS_Control_System\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100TDSControlSystemPreference\" enumeration-picker-name=\"CSG_FB_110_TDS_Control_System\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600TDSControlSystemPreference\" enumeration-picker-name=\"CSG_FB_160_TDS_Control_System\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Sample Coolers-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Sample Coolers'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200SampleCoolerPreference\" enumeration-picker-name=\"CSG_FB_020_Sample_Cooler\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500SampleCoolerPreference\" enumeration-picker-name=\"CSG_FB_050_Sample_Cooler\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100SampleCoolerPreference\" enumeration-picker-name=\"CSG_FB_110_Sample_Cooler\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600SampleCoolerPreference\" enumeration-picker-name=\"CSG_FB_160_Sample_Cooler\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Independent low level alarm-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Independent low level alarm'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200IndependentLowLevelAlarmPreference\" enumeration-picker-name=\"CSG_FB_020_Independent_Low_Level_Alarm\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500IndependentLowLevelAlarmPreference\" enumeration-picker-name=\"CSG_FB_050_Independent_Low_Level_Alarm\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100IndependentLowLevelAlarmPreference\" enumeration-picker-name=\"CSG_FB_110_Independent_Low_Level_Alarm\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600IndependentLowLevelAlarmPreference\" enumeration-picker-name=\"CSG_FB_160_Independent_Low_Level_Alarm\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Feedwater pre-heating / Degassing-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Feedwater pre-heating'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200FeedwaterPreHeatingDegassingPreference\" enumeration-picker-name=\"CSG_FB_020_Feedwater_Pre_Heating_Degassing\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500FeedwaterPreHeatingDegassingPreference\" enumeration-picker-name=\"CSG_FB_050_Feedwater_Pre_Heating_Degassing\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100FeedwaterPreHeatingDegassingPreference\" enumeration-picker-name=\"CSG_FB_110_Feedwater_Pre_Heating_Degassing\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600FeedwaterPreHeatingDegassingPreference\" enumeration-picker-name=\"CSG_FB_160_Feedwater_Pre_Heating_Degassing\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Intelligent diagnostics-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Intelligent diagnostics'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200IntelligentDiagnosticsPreference\" enumeration-picker-name=\"CSG_FB_020_Intelligent_Diagnostics\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500IntelligentDiagnosticsPreference\" enumeration-picker-name=\"CSG_FB_050_Intelligent_Diagnostics\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100IntelligentDiagnosticsPreference\" enumeration-picker-name=\"CSG_FB_110_Intelligent_Diagnostics\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600IntelligentDiagnosticsPreference\" enumeration-picker-name=\"CSG_FB_160_Intelligent_Diagnostics\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Clean steam outlet shut-off valve-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Clean steam outlet shut-off valve'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200CleanSteamOutletShutOffValvePreference\" enumeration-picker-name=\"CSG_FB_020_Clean_Steam_Outlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500CleanSteamOutletShutOffValvePreference\" enumeration-picker-name=\"CSG_FB_050_Clean_Steam_Outlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100CleanSteamOutletShutOffValvePreference\" enumeration-picker-name=\"CSG_FB_110_Clean_Steam_Outlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600CleanSteamOutletShutOffValvePreference\" enumeration-picker-name=\"CSG_FB_160_Clean_Steam_Outlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Test and certifications-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Test and certifications'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200TestAndCertificationPreference\" enumeration-picker-name=\"CSG_FB_020_Test_And_Certification\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500TestAndCertificationPreference\" enumeration-picker-name=\"CSG_FB_050_Test_And_Certification\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100TestAndCertificationPreference\" enumeration-picker-name=\"CSG_FB_110_Test_And_Certification\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600TestAndCertificationPreference\" enumeration-picker-name=\"CSG_FB_160_Test_And_Certification\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Level_Indicator-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Level Indicator'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 020 {{CSG_FB_020_Price}}\">CSG-FB 020</h4><label>{{CSG_FB_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg200Level_IndicatorPreference\" enumeration-picker-name=\"CSG_FB_020_Level_Indicator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 050 {{CSG_FB_050_Price}}\">CSG-FB 050</h4><label>{{CSG_FB_050_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg500Level_IndicatorPreference\" enumeration-picker-name=\"CSG_FB_050_Level_Indicator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 110 {{CSG_FB_110_Price}}\">CSG-FB 110</h4><label>{{CSG_FB_110_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1100Level_IndicatorPreference\" enumeration-picker-name=\"CSG_FB_110_Level_Indicator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FB 160 {{CSG_FB_160_Price}}\">CSG-FB 160</h4><label>{{CSG_FB_160_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1600Level_IndicatorPreference\" enumeration-picker-name=\"CSG_FB_160_Level_Indicator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <a #collapsePriceDataTop href=\"#collapsePriceDataTop\"> </a>\r\n    </div>\r\n\r\n    <!--Price Data Grid -->\r\n    <div *ngIf=\"!!csgBOMOutputData.bomItems && csgBOMOutputData.bomItems.length > 0 && showPrices\" class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"priceDataHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapsePriceData\" aria-expanded=\"true\" aria-controls=\"collapsePriceData\">\r\n            {{\"Price Data\"}} - {{'CLEAN_STEAM_GENERATOR_FB' | translate:true}} - Mini {{operatingCompany}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <!-- Price Data Grid  -->\r\n      <div class=\"panel-body\">\r\n        <div class=\"col-xs-12\">\r\n\r\n          <ngx-datatable #csgBOMOutputDataTable\r\n                         class=\"bootstrap\"\r\n                         [headerHeight]=\"40\"\r\n                         [limit]=\"50\"\r\n                         [columnMode]=\"'force'\"\r\n                         [footerHeight]=\"40\"\r\n                         [rowHeight]=\"'auto'\"\r\n                         [rows]=\"csgBOMOutputData.bomItems\">\r\n\r\n            <!--[rowClass]=\"getRowClass\">-->\r\n            <!--  [selected]=\"selectedOutputData\"\r\n                 [selectionType]=\"'single'\"\r\n                 (select)=\"onSelect($event)\"\r\n            -->\r\n            <!-- Row Detail Template -->\r\n            <!--<ngx-datatable-row-detail [rowHeight]=\"getHeight\" #myDetailRow>\r\n              <ng-template let-row=\"row\" let-expanded=\"expanded\" ngx-datatable-row-detail-template>\r\n                <div *ngFor=\"let m of row.modelSizingMessages\">\r\n                  <div class=\"row col-xs-12\">\r\n                    <div class=\"col-xs-1 text-center\">\r\n                      <i [class]=\"getSeverityIcon(m.severity)\"></i>\r\n                    </div>\r\n                    <div class=\"col-xs-10\">\r\n                      <span>{{m.messageKey | translate}}</span>\r\n                      <span *ngIf=\"m.value !== 0 && m.unitKey\"> ({{m.value}} {{m.unitKey | translate:false}})</span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </ng-template>\r\n            </ngx-datatable-row-detail>-->\r\n            <!-- Column Template -->\r\n            <!--<ngx-datatable-column>\r\n              <ng-template let-row=\"row\" let-expanded=\"expanded\" ngx-datatable-cell-template>\r\n                <i [class]=\"getRowSeverityIcon(row)\"></i>\r\n              </ng-template>\r\n            </ngx-datatable-column>-->\r\n            <!--Columns-->\r\n            <ngx-datatable-column [name]=\"'Number'\" prop=\"rowOrder\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Type'\" prop=\"itemType\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'ModelId'\" prop=\"modelId\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Option Group'\" prop=\"parentMasterTextKey\" [width]=\"200\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"!!value && value.indexOf('CSG_')!==0\">{{value | translate}}</span>\r\n                <span *ngIf=\"!!value && value.indexOf('CSG_')==0\">{{value.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Option'\" prop=\"itemMasterTextKey\" [width]=\"200\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span [style.background]=\"!row.isEnabled ? 'Plum' : ' '\" *ngIf=\"!!value && value.indexOf('CSG_')!==0\">{{value | translate}}</span>\r\n                <span [style.background]=\"!row.isEnabled ? 'Plum' : ' '\" *ngIf=\"!!value && value.indexOf('CSG_')==0\">{{value.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'SSP'\" prop=\"ssp\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol==csgSellingCurrencySymbol\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol!==csgSellingCurrencySymbol || row.modelId==0\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{csgSellingCurrencySymbol}} {{localizeValue(row.sSSP,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'x'\" prop=\"ssPtoRSPfactor\" [width]=\"40\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"value!==0\">x {{value}} =</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'RSP'\" prop=\"recommendedSalesPrice\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol==csgSellingCurrencySymbol\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol!==csgSellingCurrencySymbol || row.modelId==0\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{csgSellingCurrencySymbol}} {{localizeValue(row.sRecommendedSalesPrice,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'RSP override'\" prop=\"recommendedSalesPriceOverride\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol==csgSellingCurrencySymbol\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol!==csgSellingCurrencySymbol || row.modelId==0\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{csgSellingCurrencySymbol}} {{localizeValue(row.sRecommendedSalesPriceOverride,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Display Price'\" prop=\"displayedRSP\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol==csgSellingCurrencySymbol\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol!==csgSellingCurrencySymbol || row.modelId==0\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{csgSellingCurrencySymbol}} {{localizeValue(row.sDisplayedRSP,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Model'\" prop=\"modelId\" [width]=\"30\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('CSG_')!==0\">{{value}}</span>\r\n                <span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('CSG_')==0\">{{value}} {{row.parentMasterTextKey.split('_')[1]}} {{row.parentMasterTextKey.split('_')[2]}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <!--Item Momenclature chop up  EN_E-->\r\n            <ngx-datatable-column [name]=\"'Nomenclature'\" prop=\"item\" [width]=\"50\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"!!value.split('_')[1]\">{{value.split('_')[1]}}</span>\r\n                <!--<span *ngIf=\"!value.split('_')[1]\">{{value}}</span>-->\r\n                <span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('CSG_')==0\">{{row.parentMasterTextKey.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Enabled'\" prop=\"isEnabled\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"value\">+</span>\r\n                <span *ngIf=\"!value\">-</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n          </ngx-datatable>\r\n\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n    <!--<div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        { {modulePreferencesForm.value | json}}\r\n      </div>\r\n    </div>-->\r\n    <!--<div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <button [disabled]=\"!modulePreferencesForm.dirty || !modulePreferencesForm.valid || modulePreferencesForm.status !== 'VALID' || formSubmitted\" type=\"submit\" class=\"btn btn-block btn-dynamic btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i></button>\r\n      </div>\r\n    </div>-->\r\n\r\n  </form>\r\n</div>\r\n",
                providers: [CleanSteamGeneratorFBService],
                styles: [".cross-validation-error-class{font-size:25px;color:#708090}"]
            }] }
];
/** @nocollapse */
CleanSteamGeneratorFBMiniModulePreferencesComponent.ctorParameters = () => [
    { type: RoutesService },
    { type: AdminService },
    { type: TranslationService },
    { type: FormBuilder },
    { type: TranslatePipe },
    { type: ModulePreferenceService },
    { type: CleanSteamGeneratorFBService },
    { type: LocaleService$1 },
    { type: UserProfileService }
];
CleanSteamGeneratorFBMiniModulePreferencesComponent.propDecorators = {
    csgBOMOutputDataTable: [{ type: ViewChild, args: ["csgBOMOutputDataTable", { static: false },] }],
    collapsePriceDataTop: [{ type: ViewChild, args: ['collapsePriceDataTop', { static: false },] }]
};
if (false) {
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.moduleId;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.moduleGroupId;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.cloneDeep;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.moduleName;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgBOMOutputDataTable;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.collapsePriceDataTop;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.componentLoadPromises;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.componentInitialised;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.theFormGroup;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.hasUnsavedDataChanges;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.isSuccess;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.alertVisible;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.formSubmitted;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgOptionsSelectedItem;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.manufacturerList;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.currencyList;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgManufacturerCurrencyId;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgManufacturerCurrency;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgManufacturerCurrencySymbol;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgSellingCurrencyId;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgSellingCurrencySymbol;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgCurrencyConversion;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgLandedCostIncrease;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgDeliveryCost;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgCommissionOnlyPrice;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgWarrantyOneYear;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgWarrantyTwoYears;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgWarrantyThreeYears;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.modulePreferencesForm;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgManufacturerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgManufacturerCurrencyPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgSellingCurrencyPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgLandedCostIncreasePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgDeliveryCostPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgCommissionOnlyPricePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgWarrantyOneYearPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgWarrantyTwoYearsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgWarrantyThreeYearsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgOptionsFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200DesignCodePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500DesignCodePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100DesignCodePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600DesignCodePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200ShellTypePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500ShellTypePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100ShellTypePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600ShellTypePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200ValveActuationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500ValveActuationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100ValveActuationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600ValveActuationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg0200FeedwaterPressurisationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg0500FeedwaterPressurisationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100FeedwaterPressurisationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600FeedwaterPressurisationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200ControlPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500ControlPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100ControlPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600ControlPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200CommunicationInterfacePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500CommunicationInterfacePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100CommunicationInterfacePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600CommunicationInterfacePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200FrameAndCabinetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500FrameAndCabinetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100FrameAndCabinetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600FrameAndCabinetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200ControlPanelLocationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500ControlPanelLocationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100ControlPanelLocationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600ControlPanelLocationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200InsulationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500InsulationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100InsulationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600InsulationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200WheelsAndFeetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500WheelsAndFeetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100WheelsAndFeetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600WheelsAndFeetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200PlantSteamInletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500PlantSteamInletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100PlantSteamInletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600PlantSteamInletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200PlantSteamLineTrappingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500PlantSteamLineTrappingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100PlantSteamLineTrappingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600PlantSteamLineTrappingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200TDSControlSystemPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500TDSControlSystemPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100TDSControlSystemPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600TDSControlSystemPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200SampleCoolerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500SampleCoolerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100SampleCoolerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600SampleCoolerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200IndependentLowLevelAlarmPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500IndependentLowLevelAlarmPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100IndependentLowLevelAlarmPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600IndependentLowLevelAlarmPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200FeedwaterPreHeatingDegassingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500FeedwaterPreHeatingDegassingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100FeedwaterPreHeatingDegassingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600FeedwaterPreHeatingDegassingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200IntelligentDiagnosticsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500IntelligentDiagnosticsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100IntelligentDiagnosticsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600IntelligentDiagnosticsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200CleanSteamOutletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500CleanSteamOutletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100CleanSteamOutletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600CleanSteamOutletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200TestAndCertificationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500TestAndCertificationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100TestAndCertificationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600TestAndCertificationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg200Level_IndicatorPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg500Level_IndicatorPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1100Level_IndicatorPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csg1600Level_IndicatorPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.serviceOffereingMessage;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.deliveryCostMessage;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgPricing;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgBOMOutputData;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.csgBOMOutputDataRows;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.manufacturerId;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.CSG_FB_020_Price;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.CSG_FB_050_Price;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.CSG_FB_110_Price;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.CSG_FB_160_Price;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.showPrices;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.augmentPriceDataProcessing;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.user;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.operatingCompany;
    /** @type {?} */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.scrollToElement;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.routesService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.adminService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.translationService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.translatePipe;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.modulePreferenceService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.cleanSteamGeneratorService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.localeService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBMiniModulePreferencesComponent.prototype.userProfileService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/cleansteamgeneratorfb/modulePreference/cleanSteamGeneratorFBHalfPipe.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CleanSteamGeneratorFBHalfPipeModulePreferencesComponent {
    /**
     * @param {?} routesService
     * @param {?} adminService
     * @param {?} translationService
     * @param {?} fb
     * @param {?} translatePipe
     * @param {?} modulePreferenceService
     * @param {?} cleanSteamGeneratorService
     * @param {?} localeService
     * @param {?} userProfileService
     */
    constructor(routesService, adminService, translationService, fb, translatePipe, modulePreferenceService, cleanSteamGeneratorService, localeService, userProfileService) {
        this.routesService = routesService;
        this.adminService = adminService;
        this.translationService = translationService;
        this.fb = fb;
        this.translatePipe = translatePipe;
        this.modulePreferenceService = modulePreferenceService;
        this.cleanSteamGeneratorService = cleanSteamGeneratorService;
        this.localeService = localeService;
        this.userProfileService = userProfileService;
        this.moduleId = "11";
        this.moduleGroupId = 13;
        this.cloneDeep = cloneDeep_;
        this.moduleName = "Clean Steam Generator FB";
        // for scroll to view
        this.componentLoadPromises = [];
        this.componentInitialised = false;
        // to drive GenericChangesGuard
        this.isSuccess = false;
        this.alertVisible = false;
        this.formSubmitted = false;
        //*** Regular module prefs ***
        // Currency Options
        this.manufacturerList = [];
        this.currencyList = [];
        this.csgBOMOutputDataRows = [];
        this.showPrices = false;
        this.augmentPriceDataProcessing = true; // disable button whilst page loading
        this.scrollToElement = (/**
         * @param {?} elementRef
         * @param {?=} position
         * @return {?}
         */
        (elementRef, position = "start") => {
            // ToDo: Fix fussy scroll on first sizing bug. Hence the use of timeout delay here.
            setTimeout((/**
             * @return {?}
             */
            () => {
                try {
                    elementRef.nativeElement.scrollIntoView({ block: position, behavior: "smooth" });
                }
                catch (err) {
                    console.log(`scrollToElement err=${err}`);
                }
            }), 200);
        });
        this.userProfileService.getUserDetails().subscribe((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            this.user = user;
            if (!!this.user) {
                this.operatingCompany = " : " + this.user.operatingCompanyName;
            }
        }));
        this.csgBOMOutputData = new CleanSteamGeneratorFBBOMPriceOutput();
        this.csgManufacturerPrefFormControl = new FormControl({ value: '', disabled: true });
        this.csgManufacturerCurrencyPrefFormControl = new FormControl({ value: '', disabled: true });
        this.csgSellingCurrencyPrefFormControl = new FormControl('');
        this.csgLandedCostIncreasePrefFormControl = new FormControl('', [Validators.required, CustomValidators.range([-100, 100])]);
        this.csgDeliveryCostPrefFormControl = new FormControl('', [Validators.required]);
        this.csgCommissionOnlyPricePrefFormControl = new FormControl('', [Validators.required]);
        this.csgWarrantyOneYearPrefFormControl = new FormControl('', [Validators.required]);
        this.csgWarrantyTwoYearsPrefFormControl = new FormControl('', [Validators.required]);
        this.csgWarrantyThreeYearsPrefFormControl = new FormControl('', [Validators.required]);
        this.csgOptionsFormControl = new FormControl('');
        // Design Code
        this.csg1300DesignCodePrefFormControl = new FormControl(null);
        this.csg1850DesignCodePrefFormControl = new FormControl(null);
        this.csg2350DesignCodePrefFormControl = new FormControl(null);
        this.csg3000DesignCodePrefFormControl = new FormControl(null);
        this.csg3750DesignCodePrefFormControl = new FormControl(null);
        this.csg4700DesignCodePrefFormControl = new FormControl(null);
        this.csg6000DesignCodePrefFormControl = new FormControl(null);
        // Shell Type
        this.csg1300ShellTypePrefFormControl = new FormControl(null);
        this.csg1850ShellTypePrefFormControl = new FormControl(null);
        this.csg2350ShellTypePrefFormControl = new FormControl(null);
        this.csg3000ShellTypePrefFormControl = new FormControl(null);
        this.csg3750ShellTypePrefFormControl = new FormControl(null);
        this.csg4700ShellTypePrefFormControl = new FormControl(null);
        this.csg6000ShellTypePrefFormControl = new FormControl(null);
        // Control Valve Actuation
        this.csg1300ValveActuationPrefFormControl = new FormControl(null);
        this.csg1850ValveActuationPrefFormControl = new FormControl(null);
        this.csg2350ValveActuationPrefFormControl = new FormControl(null);
        this.csg3000ValveActuationPrefFormControl = new FormControl(null);
        this.csg3750ValveActuationPrefFormControl = new FormControl(null);
        this.csg4700ValveActuationPrefFormControl = new FormControl(null);
        this.csg6000ValveActuationPrefFormControl = new FormControl(null);
        // FeedwaterPressurisation
        this.csg1300FeedwaterPressurisationPrefFormControl = new FormControl(null);
        this.csg1850FeedwaterPressurisationPrefFormControl = new FormControl(null);
        this.csg2350FeedwaterPressurisationPrefFormControl = new FormControl(null);
        this.csg3000FeedwaterPressurisationPrefFormControl = new FormControl(null);
        this.csg3750FeedwaterPressurisationPrefFormControl = new FormControl(null);
        this.csg4700FeedwaterPressurisationPrefFormControl = new FormControl(null);
        this.csg6000FeedwaterPressurisationPrefFormControl = new FormControl(null);
        // Control
        this.csg1300ControlPrefFormControl = new FormControl(null);
        this.csg1850ControlPrefFormControl = new FormControl(null);
        this.csg2350ControlPrefFormControl = new FormControl(null);
        this.csg3000ControlPrefFormControl = new FormControl(null);
        this.csg3750ControlPrefFormControl = new FormControl(null);
        this.csg4700ControlPrefFormControl = new FormControl(null);
        this.csg6000ControlPrefFormControl = new FormControl(null);
        // Communication Interface
        this.csg1300CommunicationInterfacePrefFormControl = new FormControl(null);
        this.csg1850CommunicationInterfacePrefFormControl = new FormControl(null);
        this.csg2350CommunicationInterfacePrefFormControl = new FormControl(null);
        this.csg3000CommunicationInterfacePrefFormControl = new FormControl(null);
        this.csg3750CommunicationInterfacePrefFormControl = new FormControl(null);
        this.csg4700CommunicationInterfacePrefFormControl = new FormControl(null);
        this.csg6000CommunicationInterfacePrefFormControl = new FormControl(null);
        // Frame and Cabinet
        this.csg1300FrameAndCabinetPrefFormControl = new FormControl(null);
        this.csg1850FrameAndCabinetPrefFormControl = new FormControl(null);
        this.csg2350FrameAndCabinetPrefFormControl = new FormControl(null);
        this.csg3000FrameAndCabinetPrefFormControl = new FormControl(null);
        this.csg3750FrameAndCabinetPrefFormControl = new FormControl(null);
        this.csg4700FrameAndCabinetPrefFormControl = new FormControl(null);
        this.csg6000FrameAndCabinetPrefFormControl = new FormControl(null);
        // Control Panel Location
        this.csg1300ControlPanelLocationPrefFormControl = new FormControl(null);
        this.csg1850ControlPanelLocationPrefFormControl = new FormControl(null);
        this.csg2350ControlPanelLocationPrefFormControl = new FormControl(null);
        this.csg3000ControlPanelLocationPrefFormControl = new FormControl(null);
        this.csg3750ControlPanelLocationPrefFormControl = new FormControl(null);
        this.csg4700ControlPanelLocationPrefFormControl = new FormControl(null);
        this.csg6000ControlPanelLocationPrefFormControl = new FormControl(null);
        // Insulation
        this.csg1300InsulationPrefFormControl = new FormControl(null);
        this.csg1850InsulationPrefFormControl = new FormControl(null);
        this.csg2350InsulationPrefFormControl = new FormControl(null);
        this.csg3000InsulationPrefFormControl = new FormControl(null);
        this.csg3750InsulationPrefFormControl = new FormControl(null);
        this.csg4700InsulationPrefFormControl = new FormControl(null);
        this.csg6000InsulationPrefFormControl = new FormControl(null);
        // Wheels And Feet
        this.csg1300WheelsAndFeetPrefFormControl = new FormControl(null);
        this.csg1850WheelsAndFeetPrefFormControl = new FormControl(null);
        this.csg2350WheelsAndFeetPrefFormControl = new FormControl(null);
        this.csg3000WheelsAndFeetPrefFormControl = new FormControl(null);
        this.csg3750WheelsAndFeetPrefFormControl = new FormControl(null);
        this.csg4700WheelsAndFeetPrefFormControl = new FormControl(null);
        this.csg6000WheelsAndFeetPrefFormControl = new FormControl(null);
        // Plant Steam Inlet Shut Off Valve
        this.csg1300PlantSteamInletShutOffValvePrefFormControl = new FormControl(null);
        this.csg1850PlantSteamInletShutOffValvePrefFormControl = new FormControl(null);
        this.csg2350PlantSteamInletShutOffValvePrefFormControl = new FormControl(null);
        this.csg3000PlantSteamInletShutOffValvePrefFormControl = new FormControl(null);
        this.csg3750PlantSteamInletShutOffValvePrefFormControl = new FormControl(null);
        this.csg4700PlantSteamInletShutOffValvePrefFormControl = new FormControl(null);
        this.csg6000PlantSteamInletShutOffValvePrefFormControl = new FormControl(null);
        // Plant Steam Line Trapping
        this.csg1300PlantSteamLineTrappingPrefFormControl = new FormControl(null);
        this.csg1850PlantSteamLineTrappingPrefFormControl = new FormControl(null);
        this.csg2350PlantSteamLineTrappingPrefFormControl = new FormControl(null);
        this.csg3000PlantSteamLineTrappingPrefFormControl = new FormControl(null);
        this.csg3750PlantSteamLineTrappingPrefFormControl = new FormControl(null);
        this.csg4700PlantSteamLineTrappingPrefFormControl = new FormControl(null);
        this.csg6000PlantSteamLineTrappingPrefFormControl = new FormControl(null);
        // TDS control system
        this.csg1300TDSControlSystemPrefFormControl = new FormControl(null);
        this.csg1850TDSControlSystemPrefFormControl = new FormControl(null);
        this.csg2350TDSControlSystemPrefFormControl = new FormControl(null);
        this.csg3000TDSControlSystemPrefFormControl = new FormControl(null);
        this.csg3750TDSControlSystemPrefFormControl = new FormControl(null);
        this.csg4700TDSControlSystemPrefFormControl = new FormControl(null);
        this.csg6000TDSControlSystemPrefFormControl = new FormControl(null);
        // Sample Coolers
        this.csg1300SampleCoolerPrefFormControl = new FormControl(null);
        this.csg1850SampleCoolerPrefFormControl = new FormControl(null);
        this.csg2350SampleCoolerPrefFormControl = new FormControl(null);
        this.csg3000SampleCoolerPrefFormControl = new FormControl(null);
        this.csg3750SampleCoolerPrefFormControl = new FormControl(null);
        this.csg4700SampleCoolerPrefFormControl = new FormControl(null);
        this.csg6000SampleCoolerPrefFormControl = new FormControl(null);
        // Independent low level alarm
        this.csg1300IndependentLowLevelAlarmPrefFormControl = new FormControl(null);
        this.csg1850IndependentLowLevelAlarmPrefFormControl = new FormControl(null);
        this.csg2350IndependentLowLevelAlarmPrefFormControl = new FormControl(null);
        this.csg3000IndependentLowLevelAlarmPrefFormControl = new FormControl(null);
        this.csg3750IndependentLowLevelAlarmPrefFormControl = new FormControl(null);
        this.csg4700IndependentLowLevelAlarmPrefFormControl = new FormControl(null);
        this.csg6000IndependentLowLevelAlarmPrefFormControl = new FormControl(null);
        // Feedwater pre-heating / Degassing
        this.csg1300FeedwaterPreHeatingDegassingPrefFormControl = new FormControl(null);
        this.csg1850FeedwaterPreHeatingDegassingPrefFormControl = new FormControl(null);
        this.csg2350FeedwaterPreHeatingDegassingPrefFormControl = new FormControl(null);
        this.csg3000FeedwaterPreHeatingDegassingPrefFormControl = new FormControl(null);
        this.csg3750FeedwaterPreHeatingDegassingPrefFormControl = new FormControl(null);
        this.csg4700FeedwaterPreHeatingDegassingPrefFormControl = new FormControl(null);
        this.csg6000FeedwaterPreHeatingDegassingPrefFormControl = new FormControl(null);
        // Intelligent diagnostics
        this.csg1300IntelligentDiagnosticsPrefFormControl = new FormControl(null);
        this.csg1850IntelligentDiagnosticsPrefFormControl = new FormControl(null);
        this.csg2350IntelligentDiagnosticsPrefFormControl = new FormControl(null);
        this.csg3000IntelligentDiagnosticsPrefFormControl = new FormControl(null);
        this.csg3750IntelligentDiagnosticsPrefFormControl = new FormControl(null);
        this.csg4700IntelligentDiagnosticsPrefFormControl = new FormControl(null);
        this.csg6000IntelligentDiagnosticsPrefFormControl = new FormControl(null);
        // Clean steam outlet shut-off valve
        this.csg1300CleanSteamOutletShutOffValvePrefFormControl = new FormControl(null);
        this.csg1850CleanSteamOutletShutOffValvePrefFormControl = new FormControl(null);
        this.csg2350CleanSteamOutletShutOffValvePrefFormControl = new FormControl(null);
        this.csg3000CleanSteamOutletShutOffValvePrefFormControl = new FormControl(null);
        this.csg3750CleanSteamOutletShutOffValvePrefFormControl = new FormControl(null);
        this.csg4700CleanSteamOutletShutOffValvePrefFormControl = new FormControl(null);
        this.csg6000CleanSteamOutletShutOffValvePrefFormControl = new FormControl(null);
        // Test and certifications
        this.csg1300TestAndCertificationPrefFormControl = new FormControl(null);
        this.csg1850TestAndCertificationPrefFormControl = new FormControl(null);
        this.csg2350TestAndCertificationPrefFormControl = new FormControl(null);
        this.csg3000TestAndCertificationPrefFormControl = new FormControl(null);
        this.csg3750TestAndCertificationPrefFormControl = new FormControl(null);
        this.csg4700TestAndCertificationPrefFormControl = new FormControl(null);
        this.csg6000TestAndCertificationPrefFormControl = new FormControl(null);
        // Level_Indicator
        this.csg1300Level_IndicatorPrefFormControl = new FormControl(null);
        this.csg1850Level_IndicatorPrefFormControl = new FormControl(null);
        this.csg2350Level_IndicatorPrefFormControl = new FormControl(null);
        this.csg3000Level_IndicatorPrefFormControl = new FormControl(null);
        this.csg3750Level_IndicatorPrefFormControl = new FormControl(null);
        this.csg4700Level_IndicatorPrefFormControl = new FormControl(null);
        this.csg6000Level_IndicatorPrefFormControl = new FormControl(null);
        // Setup the form group.
        this.modulePreferencesForm = this.fb.group({
            // Currency Options
            csgManufacturerModulePreference: this.csgManufacturerPrefFormControl,
            csgManufacturerCurrencyModulePreference: this.csgManufacturerCurrencyPrefFormControl,
            csgSellingCurrencyModulePreference: this.csgSellingCurrencyPrefFormControl,
            // Pricing Options
            csgLandedCostIncreaseModulePreference: this.csgLandedCostIncreasePrefFormControl,
            csgDeliveryCostModulePreference: this.csgDeliveryCostPrefFormControl,
            csgCommissionOnlyPriceModulePreference: this.csgCommissionOnlyPricePrefFormControl,
            csgWarrantyOneYearModulePreference: this.csgWarrantyOneYearPrefFormControl,
            csgWarrantyTwoYearsModulePreference: this.csgWarrantyTwoYearsPrefFormControl,
            csgWarrantyThreeYearsModulePreference: this.csgWarrantyThreeYearsPrefFormControl,
            // Option Configuration
            csgOptionsSelection: this.csgOptionsFormControl,
            // Design Code
            csg1300DesignCodePreference: this.csg1300DesignCodePrefFormControl,
            csg1850DesignCodePreference: this.csg1850DesignCodePrefFormControl,
            csg2350DesignCodePreference: this.csg2350DesignCodePrefFormControl,
            csg3000DesignCodePreference: this.csg3000DesignCodePrefFormControl,
            csg3750DesignCodePreference: this.csg3750DesignCodePrefFormControl,
            csg4700DesignCodePreference: this.csg4700DesignCodePrefFormControl,
            csg6000DesignCodePreference: this.csg6000DesignCodePrefFormControl,
            // Shell Type
            csg1300ShellTypePreference: this.csg1300ShellTypePrefFormControl,
            csg1850ShellTypePreference: this.csg1850ShellTypePrefFormControl,
            csg2350ShellTypePreference: this.csg2350ShellTypePrefFormControl,
            csg3000ShellTypePreference: this.csg3000ShellTypePrefFormControl,
            csg3750ShellTypePreference: this.csg3750ShellTypePrefFormControl,
            csg4700ShellTypePreference: this.csg4700ShellTypePrefFormControl,
            csg6000ShellTypePreference: this.csg6000ShellTypePrefFormControl,
            // Control Valve Actuation
            csg1300ValveActuationPreference: this.csg1300ValveActuationPrefFormControl,
            csg1850ValveActuationPreference: this.csg1850ValveActuationPrefFormControl,
            csg2350ValveActuationPreference: this.csg2350ValveActuationPrefFormControl,
            csg3000ValveActuationPreference: this.csg3000ValveActuationPrefFormControl,
            csg3750ValveActuationPreference: this.csg3750ValveActuationPrefFormControl,
            csg4700ValveActuationPreference: this.csg4700ValveActuationPrefFormControl,
            csg6000ValveActuationPreference: this.csg6000ValveActuationPrefFormControl,
            // FeedwaterPressurisation
            csg1300FeedwaterPressurisationPreference: this.csg1300FeedwaterPressurisationPrefFormControl,
            csg1850FeedwaterPressurisationPreference: this.csg1850FeedwaterPressurisationPrefFormControl,
            csg2350FeedwaterPressurisationPreference: this.csg2350FeedwaterPressurisationPrefFormControl,
            csg3000FeedwaterPressurisationPreference: this.csg3000FeedwaterPressurisationPrefFormControl,
            csg3750FeedwaterPressurisationPreference: this.csg3750FeedwaterPressurisationPrefFormControl,
            csg4700FeedwaterPressurisationPreference: this.csg4700FeedwaterPressurisationPrefFormControl,
            csg6000FeedwaterPressurisationPreference: this.csg6000FeedwaterPressurisationPrefFormControl,
            // Control
            csg1300ControlPreference: this.csg1300ControlPrefFormControl,
            csg1850ControlPreference: this.csg1850ControlPrefFormControl,
            csg2350ControlPreference: this.csg2350ControlPrefFormControl,
            csg3000ControlPreference: this.csg3000ControlPrefFormControl,
            csg3750ControlPreference: this.csg3750ControlPrefFormControl,
            csg4700ControlPreference: this.csg4700ControlPrefFormControl,
            csg6000ControlPreference: this.csg6000ControlPrefFormControl,
            // Communication Interface
            csg1300CommunicationInterfacePreference: this.csg1300CommunicationInterfacePrefFormControl,
            csg1850CommunicationInterfacePreference: this.csg1850CommunicationInterfacePrefFormControl,
            csg2350CommunicationInterfacePreference: this.csg2350CommunicationInterfacePrefFormControl,
            csg3000CommunicationInterfacePreference: this.csg3000CommunicationInterfacePrefFormControl,
            csg3750CommunicationInterfacePreference: this.csg3750CommunicationInterfacePrefFormControl,
            csg4700CommunicationInterfacePreference: this.csg4700CommunicationInterfacePrefFormControl,
            csg6000CommunicationInterfacePreference: this.csg6000CommunicationInterfacePrefFormControl,
            // Frame and Cabinet
            csg1300FrameAndCabinetPreference: this.csg1300FrameAndCabinetPrefFormControl,
            csg1850FrameAndCabinetPreference: this.csg1850FrameAndCabinetPrefFormControl,
            csg2350FrameAndCabinetPreference: this.csg2350FrameAndCabinetPrefFormControl,
            csg3000FrameAndCabinetPreference: this.csg3000FrameAndCabinetPrefFormControl,
            csg3750FrameAndCabinetPreference: this.csg3750FrameAndCabinetPrefFormControl,
            csg4700FrameAndCabinetPreference: this.csg4700FrameAndCabinetPrefFormControl,
            csg6000FrameAndCabinetPreference: this.csg6000FrameAndCabinetPrefFormControl,
            // Control Panel Location
            csg1300ControlPanelLocationPreference: this.csg1300ControlPanelLocationPrefFormControl,
            csg1850ControlPanelLocationPreference: this.csg1850ControlPanelLocationPrefFormControl,
            csg2350ControlPanelLocationPreference: this.csg2350ControlPanelLocationPrefFormControl,
            csg3000ControlPanelLocationPreference: this.csg3000ControlPanelLocationPrefFormControl,
            csg3750ControlPanelLocationPreference: this.csg3750ControlPanelLocationPrefFormControl,
            csg4700ControlPanelLocationPreference: this.csg4700ControlPanelLocationPrefFormControl,
            csg6000ControlPanelLocationPreference: this.csg6000ControlPanelLocationPrefFormControl,
            // Insulation
            csg1300InsulationPreference: this.csg1300InsulationPrefFormControl,
            csg1850InsulationPreference: this.csg1850InsulationPrefFormControl,
            csg2350InsulationPreference: this.csg2350InsulationPrefFormControl,
            csg3000InsulationPreference: this.csg3000InsulationPrefFormControl,
            csg3750InsulationPreference: this.csg3750InsulationPrefFormControl,
            csg4700InsulationPreference: this.csg4700InsulationPrefFormControl,
            csg6000InsulationPreference: this.csg6000InsulationPrefFormControl,
            // Wheels And Feet
            csg1300WheelsAndFeetPreference: this.csg1300WheelsAndFeetPrefFormControl,
            csg1850WheelsAndFeetPreference: this.csg1850WheelsAndFeetPrefFormControl,
            csg2350WheelsAndFeetPreference: this.csg2350WheelsAndFeetPrefFormControl,
            csg3000WheelsAndFeetPreference: this.csg3000WheelsAndFeetPrefFormControl,
            csg3750WheelsAndFeetPreference: this.csg3750WheelsAndFeetPrefFormControl,
            csg4700WheelsAndFeetPreference: this.csg4700WheelsAndFeetPrefFormControl,
            csg6000WheelsAndFeetPreference: this.csg6000WheelsAndFeetPrefFormControl,
            // Plant Steam Inlet Shut Off Valve
            csg1300PlantSteamInletShutOffValvePreference: this.csg1300PlantSteamInletShutOffValvePrefFormControl,
            csg1850PlantSteamInletShutOffValvePreference: this.csg1850PlantSteamInletShutOffValvePrefFormControl,
            csg2350PlantSteamInletShutOffValvePreference: this.csg2350PlantSteamInletShutOffValvePrefFormControl,
            csg3000PlantSteamInletShutOffValvePreference: this.csg3000PlantSteamInletShutOffValvePrefFormControl,
            csg3750PlantSteamInletShutOffValvePreference: this.csg3750PlantSteamInletShutOffValvePrefFormControl,
            csg4700PlantSteamInletShutOffValvePreference: this.csg4700PlantSteamInletShutOffValvePrefFormControl,
            csg6000PlantSteamInletShutOffValvePreference: this.csg6000PlantSteamInletShutOffValvePrefFormControl,
            // Plant Steam Line Trapping
            csg1300PlantSteamLineTrappingPreference: this.csg1300PlantSteamLineTrappingPrefFormControl,
            csg1850PlantSteamLineTrappingPreference: this.csg1850PlantSteamLineTrappingPrefFormControl,
            csg2350PlantSteamLineTrappingPreference: this.csg2350PlantSteamLineTrappingPrefFormControl,
            csg3000PlantSteamLineTrappingPreference: this.csg3000PlantSteamLineTrappingPrefFormControl,
            csg3750PlantSteamLineTrappingPreference: this.csg3750PlantSteamLineTrappingPrefFormControl,
            csg4700PlantSteamLineTrappingPreference: this.csg4700PlantSteamLineTrappingPrefFormControl,
            csg6000PlantSteamLineTrappingPreference: this.csg6000PlantSteamLineTrappingPrefFormControl,
            // TDS control system
            csg1300TDSControlSystemPreference: this.csg1300TDSControlSystemPrefFormControl,
            csg1850TDSControlSystemPreference: this.csg1850TDSControlSystemPrefFormControl,
            csg2350TDSControlSystemPreference: this.csg2350TDSControlSystemPrefFormControl,
            csg3000TDSControlSystemPreference: this.csg3000TDSControlSystemPrefFormControl,
            csg3750TDSControlSystemPreference: this.csg3750TDSControlSystemPrefFormControl,
            csg4700TDSControlSystemPreference: this.csg4700TDSControlSystemPrefFormControl,
            csg6000TDSControlSystemPreference: this.csg6000TDSControlSystemPrefFormControl,
            // Sample Coolers
            csg1300SampleCoolerPreference: this.csg1300SampleCoolerPrefFormControl,
            csg1850SampleCoolerPreference: this.csg1850SampleCoolerPrefFormControl,
            csg2350SampleCoolerPreference: this.csg2350SampleCoolerPrefFormControl,
            csg3000SampleCoolerPreference: this.csg3000SampleCoolerPrefFormControl,
            csg3750SampleCoolerPreference: this.csg3750SampleCoolerPrefFormControl,
            csg4700SampleCoolerPreference: this.csg4700SampleCoolerPrefFormControl,
            csg6000SampleCoolerPreference: this.csg6000SampleCoolerPrefFormControl,
            // Independent low level alarm
            csg1300IndependentLowLevelAlarmPreference: this.csg1300IndependentLowLevelAlarmPrefFormControl,
            csg1850IndependentLowLevelAlarmPreference: this.csg1850IndependentLowLevelAlarmPrefFormControl,
            csg2350IndependentLowLevelAlarmPreference: this.csg2350IndependentLowLevelAlarmPrefFormControl,
            csg3000IndependentLowLevelAlarmPreference: this.csg3000IndependentLowLevelAlarmPrefFormControl,
            csg3750IndependentLowLevelAlarmPreference: this.csg3750IndependentLowLevelAlarmPrefFormControl,
            csg4700IndependentLowLevelAlarmPreference: this.csg4700IndependentLowLevelAlarmPrefFormControl,
            csg6000IndependentLowLevelAlarmPreference: this.csg6000IndependentLowLevelAlarmPrefFormControl,
            // Feedwater pre-heating / Degassing
            csg1300FeedwaterPreHeatingDegassingPreference: this.csg1300FeedwaterPreHeatingDegassingPrefFormControl,
            csg1850FeedwaterPreHeatingDegassingPreference: this.csg1850FeedwaterPreHeatingDegassingPrefFormControl,
            csg2350FeedwaterPreHeatingDegassingPreference: this.csg2350FeedwaterPreHeatingDegassingPrefFormControl,
            csg3000FeedwaterPreHeatingDegassingPreference: this.csg3000FeedwaterPreHeatingDegassingPrefFormControl,
            csg3750FeedwaterPreHeatingDegassingPreference: this.csg3750FeedwaterPreHeatingDegassingPrefFormControl,
            csg4700FeedwaterPreHeatingDegassingPreference: this.csg4700FeedwaterPreHeatingDegassingPrefFormControl,
            csg6000FeedwaterPreHeatingDegassingPreference: this.csg6000FeedwaterPreHeatingDegassingPrefFormControl,
            // Intelligent diagnostics
            csg1300IntelligentDiagnosticsPreference: this.csg1300IntelligentDiagnosticsPrefFormControl,
            csg1850IntelligentDiagnosticsPreference: this.csg1850IntelligentDiagnosticsPrefFormControl,
            csg2350IntelligentDiagnosticsPreference: this.csg2350IntelligentDiagnosticsPrefFormControl,
            csg3000IntelligentDiagnosticsPreference: this.csg3000IntelligentDiagnosticsPrefFormControl,
            csg3750IntelligentDiagnosticsPreference: this.csg3750IntelligentDiagnosticsPrefFormControl,
            csg4700IntelligentDiagnosticsPreference: this.csg4700IntelligentDiagnosticsPrefFormControl,
            csg6000IntelligentDiagnosticsPreference: this.csg6000IntelligentDiagnosticsPrefFormControl,
            // Clean steam outlet shut-off valve
            csg1300CleanSteamOutletShutOffValvePreference: this.csg1300CleanSteamOutletShutOffValvePrefFormControl,
            csg1850CleanSteamOutletShutOffValvePreference: this.csg1850CleanSteamOutletShutOffValvePrefFormControl,
            csg2350CleanSteamOutletShutOffValvePreference: this.csg2350CleanSteamOutletShutOffValvePrefFormControl,
            csg3000CleanSteamOutletShutOffValvePreference: this.csg3000CleanSteamOutletShutOffValvePrefFormControl,
            csg3750CleanSteamOutletShutOffValvePreference: this.csg3750CleanSteamOutletShutOffValvePrefFormControl,
            csg4700CleanSteamOutletShutOffValvePreference: this.csg4700CleanSteamOutletShutOffValvePrefFormControl,
            csg6000CleanSteamOutletShutOffValvePreference: this.csg6000CleanSteamOutletShutOffValvePrefFormControl,
            // Test and certifications
            csg1300TestAndCertificationPreference: this.csg1300TestAndCertificationPrefFormControl,
            csg1850TestAndCertificationPreference: this.csg1850TestAndCertificationPrefFormControl,
            csg2350TestAndCertificationPreference: this.csg2350TestAndCertificationPrefFormControl,
            csg3000TestAndCertificationPreference: this.csg3000TestAndCertificationPrefFormControl,
            csg3750TestAndCertificationPreference: this.csg3750TestAndCertificationPrefFormControl,
            csg4700TestAndCertificationPreference: this.csg4700TestAndCertificationPrefFormControl,
            csg6000TestAndCertificationPreference: this.csg6000TestAndCertificationPrefFormControl,
            // Level_Indicator
            csg1300Level_IndicatorPreference: this.csg1300Level_IndicatorPrefFormControl,
            csg1850Level_IndicatorPreference: this.csg1850Level_IndicatorPrefFormControl,
            csg2350Level_IndicatorPreference: this.csg2350Level_IndicatorPrefFormControl,
            csg3000Level_IndicatorPreference: this.csg3000Level_IndicatorPrefFormControl,
            csg3750Level_IndicatorPreference: this.csg3750Level_IndicatorPrefFormControl,
            csg4700Level_IndicatorPreference: this.csg4700Level_IndicatorPrefFormControl,
            csg6000Level_IndicatorPreference: this.csg6000Level_IndicatorPrefFormControl,
        }, { updateOn: "blur" });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        console.log("Starting Initializing CSG F&B Halfpipe module prefs component");
        // When Angular looks at a guard decision, page navigation has already occurred.
        // Reset the page load progress
        //this.routesService.pageLoadProgress = 0;
        //this.routesService.pageLoading = true;
        //this.routesService.startPageLoadProgress();
        // First, get all the module preferences.
        this.componentLoadPromises.push(this.modulePreferenceService.getOperatingCompanyModulePreferences(this.moduleId).toPromise().then((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            if (result && result.length > 0) {
                // And set their values accordingly.
                this.manufacturerId = +this.getModulePreferenceValue(result, "CSGFBHalfPipeManufacturer");
                this.csgManufacturerPrefFormControl.setValue(this.manufacturerId);
                this.csgManufacturerCurrencyId = +this.getModulePreferenceValue(result, "CSGFBHalfPipeManufacturerCurrency");
                this.csgManufacturerCurrencyPrefFormControl.setValue(this.csgManufacturerCurrencyId);
                this.csgSellingCurrencyId = this.getModulePreferenceValue(result, "CSGFBHalfPipeSellingCurrency");
                this.csgSellingCurrencyPrefFormControl.setValue(this.csgSellingCurrencyId);
                // Calculate the currency conversion rate.
                this.onSellingCurrencyChange(this.csgSellingCurrencyId);
                this.csgLandedCostIncreasePrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGFBHalfPipeLandCostIncrease"));
                this.csgDeliveryCostPrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGFBHalfPipeDeliveryCost"));
                this.csgCommissionOnlyPricePrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGFBHalfPipeCommission"));
                this.csgWarrantyOneYearPrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGFBHalfPipeYearOne"));
                this.csgWarrantyTwoYearsPrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGFBHalfPipeYearTwo"));
                this.csgWarrantyThreeYearsPrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGFBHalfPipeYearThree"));
                // Get the currency data.
                this.componentLoadPromises.push(this.adminService.getCurrencyData().toPromise().then((/**
                 * @param {?} data
                 * @return {?}
                 */
                data => {
                    this.currencyList = data;
                    // Selling currency found, so try to calculate the currency conversion rate.
                    this.onSellingCurrencyChange(this.csgSellingCurrencyId);
                    this.augmentPriceDataProcessing = false; // loaded enable toggle prices button
                })));
            }
        })));
        // Get the list of manufacturers.
        this.componentLoadPromises.push(this.adminService.getManufacturerData(this.moduleGroupId).toPromise().then((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            // Update the subject with the data that's just been retrieved (see the constructor).
            this.manufacturerList = result;
        })));
        // Now, set the "OpCo Selected Options" for the different CSG options.
        // Design Code
        this.setOpCoPreferences("CSG_FBHP_130_Design_Code", this.csg1300DesignCodePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Design_Code", this.csg1850DesignCodePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Design_Code", this.csg2350DesignCodePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Design_Code", this.csg3000DesignCodePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Design_Code", this.csg3750DesignCodePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Design_Code", this.csg4700DesignCodePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Design_Code", this.csg6000DesignCodePrefFormControl);
        // Shell Type
        this.setOpCoPreferences("CSG_FBHP_130_Shell_Type", this.csg1300ShellTypePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Shell_Type", this.csg1850ShellTypePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Shell_Type", this.csg2350ShellTypePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Shell_Type", this.csg3000ShellTypePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Shell_Type", this.csg3750ShellTypePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Shell_Type", this.csg4700ShellTypePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Shell_Type", this.csg6000ShellTypePrefFormControl);
        // Control Valve Actuation
        this.setOpCoPreferences("CSG_FBHP_130_Valve_Actuation", this.csg1300ValveActuationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Valve_Actuation", this.csg1850ValveActuationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Valve_Actuation", this.csg2350ValveActuationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Valve_Actuation", this.csg3000ValveActuationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Valve_Actuation", this.csg3750ValveActuationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Valve_Actuation", this.csg4700ValveActuationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Valve_Actuation", this.csg6000ValveActuationPrefFormControl);
        // FeedwaterPressurisation
        this.setOpCoPreferences("CSG_FBHP_130_Feedwater_Pressurisation", this.csg1300FeedwaterPressurisationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Feedwater_Pressurisation", this.csg1850FeedwaterPressurisationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Feedwater_Pressurisation", this.csg2350FeedwaterPressurisationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Feedwater_Pressurisation", this.csg3000FeedwaterPressurisationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Feedwater_Pressurisation", this.csg3750FeedwaterPressurisationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Feedwater_Pressurisation", this.csg4700FeedwaterPressurisationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Feedwater_Pressurisation", this.csg6000FeedwaterPressurisationPrefFormControl);
        // Control
        this.setOpCoPreferences("CSG_FBHP_130_Control", this.csg1300ControlPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Control", this.csg1850ControlPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Control", this.csg2350ControlPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Control", this.csg3000ControlPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Control", this.csg3750ControlPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Control", this.csg4700ControlPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Control", this.csg6000ControlPrefFormControl);
        // Communication Interface
        this.setOpCoPreferences("CSG_FBHP_130_Communication_Interface", this.csg1300CommunicationInterfacePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Communication_Interface", this.csg1850CommunicationInterfacePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Communication_Interface", this.csg2350CommunicationInterfacePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Communication_Interface", this.csg3000CommunicationInterfacePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Communication_Interface", this.csg3750CommunicationInterfacePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Communication_Interface", this.csg4700CommunicationInterfacePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Communication_Interface", this.csg6000CommunicationInterfacePrefFormControl);
        // Frame and Cabinet
        this.setOpCoPreferences("CSG_FBHP_130_Frame_And_Cabinet", this.csg1300FrameAndCabinetPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Frame_And_Cabinet", this.csg1850FrameAndCabinetPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Frame_And_Cabinet", this.csg2350FrameAndCabinetPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Frame_And_Cabinet", this.csg3000FrameAndCabinetPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Frame_And_Cabinet", this.csg3750FrameAndCabinetPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Frame_And_Cabinet", this.csg4700FrameAndCabinetPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Frame_And_Cabinet", this.csg6000FrameAndCabinetPrefFormControl);
        // Control Panel Location
        this.setOpCoPreferences("CSG_FBHP_130_Control_Panel_Location", this.csg1300ControlPanelLocationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Control_Panel_Location", this.csg1850ControlPanelLocationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Control_Panel_Location", this.csg2350ControlPanelLocationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Control_Panel_Location", this.csg3000ControlPanelLocationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Control_Panel_Location", this.csg3750ControlPanelLocationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Control_Panel_Location", this.csg4700ControlPanelLocationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Control_Panel_Location", this.csg6000ControlPanelLocationPrefFormControl);
        // Insulation
        this.setOpCoPreferences("CSG_FBHP_130_Insulation", this.csg1300InsulationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Insulation", this.csg1850InsulationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Insulation", this.csg2350InsulationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Insulation", this.csg3000InsulationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Insulation", this.csg3750InsulationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Insulation", this.csg4700InsulationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Insulation", this.csg6000InsulationPrefFormControl);
        // Wheels And Feet
        this.setOpCoPreferences("CSG_FBHP_130_Wheels_And_Feet", this.csg1300WheelsAndFeetPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Wheels_And_Feet", this.csg1850WheelsAndFeetPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Wheels_And_Feet", this.csg2350WheelsAndFeetPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Wheels_And_Feet", this.csg3000WheelsAndFeetPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Wheels_And_Feet", this.csg3750WheelsAndFeetPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Wheels_And_Feet", this.csg4700WheelsAndFeetPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Wheels_And_Feet", this.csg6000WheelsAndFeetPrefFormControl);
        // Plant Steam Inlet Shut Off Valve
        this.setOpCoPreferences("CSG_FBHP_130_Plant_Steam_Inlet_Shut_Off_Valve", this.csg1300PlantSteamInletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Plant_Steam_Inlet_Shut_Off_Valve", this.csg1850PlantSteamInletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Plant_Steam_Inlet_Shut_Off_Valve", this.csg2350PlantSteamInletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Plant_Steam_Inlet_Shut_Off_Valve", this.csg3000PlantSteamInletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Plant_Steam_Inlet_Shut_Off_Valve", this.csg3750PlantSteamInletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Plant_Steam_Inlet_Shut_Off_Valve", this.csg4700PlantSteamInletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Plant_Steam_Inlet_Shut_Off_Valve", this.csg6000PlantSteamInletShutOffValvePrefFormControl);
        // Plant steam line trapping
        this.setOpCoPreferences("CSG_FBHP_130_Plant_Steam_Line_Trapping", this.csg1300PlantSteamLineTrappingPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Plant_Steam_Line_Trapping", this.csg1850PlantSteamLineTrappingPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Plant_Steam_Line_Trapping", this.csg2350PlantSteamLineTrappingPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Plant_Steam_Line_Trapping", this.csg3000PlantSteamLineTrappingPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Plant_Steam_Line_Trapping", this.csg3750PlantSteamLineTrappingPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Plant_Steam_Line_Trapping", this.csg4700PlantSteamLineTrappingPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Plant_Steam_Line_Trapping", this.csg6000PlantSteamLineTrappingPrefFormControl);
        // TDS control system
        this.setOpCoPreferences("CSG_FBHP_130_TDS_Control_System", this.csg1300TDSControlSystemPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_TDS_Control_System", this.csg1850TDSControlSystemPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_TDS_Control_System", this.csg2350TDSControlSystemPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_TDS_Control_System", this.csg3000TDSControlSystemPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_TDS_Control_System", this.csg3750TDSControlSystemPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_TDS_Control_System", this.csg4700TDSControlSystemPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_TDS_Control_System", this.csg6000TDSControlSystemPrefFormControl);
        // Sample Coolers
        this.setOpCoPreferences("CSG_FBHP_130_Sample_Cooler", this.csg1300SampleCoolerPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Sample_Cooler", this.csg1850SampleCoolerPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Sample_Cooler", this.csg2350SampleCoolerPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Sample_Cooler", this.csg3000SampleCoolerPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Sample_Cooler", this.csg3750SampleCoolerPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Sample_Cooler", this.csg4700SampleCoolerPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Sample_Cooler", this.csg6000SampleCoolerPrefFormControl);
        // Independent low level alarm
        this.setOpCoPreferences("CSG_FBHP_130_Independent_Low_Level_Alarm", this.csg1300IndependentLowLevelAlarmPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Independent_Low_Level_Alarm", this.csg1850IndependentLowLevelAlarmPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Independent_Low_Level_Alarm", this.csg2350IndependentLowLevelAlarmPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Independent_Low_Level_Alarm", this.csg3000IndependentLowLevelAlarmPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Independent_Low_Level_Alarm", this.csg3750IndependentLowLevelAlarmPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Independent_Low_Level_Alarm", this.csg4700IndependentLowLevelAlarmPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Independent_Low_Level_Alarm", this.csg6000IndependentLowLevelAlarmPrefFormControl);
        // Feedwater pre-heating / Degassing
        this.setOpCoPreferences("CSG_FBHP_130_Feedwater_Pre_Heating_Degassing", this.csg1300FeedwaterPreHeatingDegassingPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Feedwater_Pre_Heating_Degassing", this.csg1850FeedwaterPreHeatingDegassingPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Feedwater_Pre_Heating_Degassing", this.csg2350FeedwaterPreHeatingDegassingPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Feedwater_Pre_Heating_Degassing", this.csg3000FeedwaterPreHeatingDegassingPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Feedwater_Pre_Heating_Degassing", this.csg3750FeedwaterPreHeatingDegassingPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Feedwater_Pre_Heating_Degassing", this.csg4700FeedwaterPreHeatingDegassingPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Feedwater_Pre_Heating_Degassing", this.csg6000FeedwaterPreHeatingDegassingPrefFormControl);
        // Intelligent diagnostics
        this.setOpCoPreferences("CSG_FBHP_130_Intelligent_Diagnostics", this.csg1300IntelligentDiagnosticsPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Intelligent_Diagnostics", this.csg1850IntelligentDiagnosticsPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Intelligent_Diagnostics", this.csg2350IntelligentDiagnosticsPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Intelligent_Diagnostics", this.csg3000IntelligentDiagnosticsPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Intelligent_Diagnostics", this.csg3750IntelligentDiagnosticsPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Intelligent_Diagnostics", this.csg4700IntelligentDiagnosticsPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Intelligent_Diagnostics", this.csg6000IntelligentDiagnosticsPrefFormControl);
        // Clean steam outlet shut-off valve
        this.setOpCoPreferences("CSG_FBHP_130_Clean_Steam_Outlet_Shut_Off_Valve", this.csg1300CleanSteamOutletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Clean_Steam_Outlet_Shut_Off_Valve", this.csg1850CleanSteamOutletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Clean_Steam_Outlet_Shut_Off_Valve", this.csg2350CleanSteamOutletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Clean_Steam_Outlet_Shut_Off_Valve", this.csg3000CleanSteamOutletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Clean_Steam_Outlet_Shut_Off_Valve", this.csg3750CleanSteamOutletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Clean_Steam_Outlet_Shut_Off_Valve", this.csg4700CleanSteamOutletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Clean_Steam_Outlet_Shut_Off_Valve", this.csg6000CleanSteamOutletShutOffValvePrefFormControl);
        // Test and certifications
        this.setOpCoPreferences("CSG_FBHP_130_Test_And_Certification", this.csg1300TestAndCertificationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Test_And_Certification", this.csg1850TestAndCertificationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Test_And_Certification", this.csg2350TestAndCertificationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Test_And_Certification", this.csg3000TestAndCertificationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Test_And_Certification", this.csg3750TestAndCertificationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Test_And_Certification", this.csg4700TestAndCertificationPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Test_And_Certification", this.csg6000TestAndCertificationPrefFormControl);
        // Level_Indicator
        this.setOpCoPreferences("CSG_FBHP_130_Level_Indicator", this.csg1300Level_IndicatorPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_185_Level_Indicator", this.csg1850Level_IndicatorPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_235_Level_Indicator", this.csg2350Level_IndicatorPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_300_Level_Indicator", this.csg3000Level_IndicatorPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_375_Level_Indicator", this.csg3750Level_IndicatorPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_470_Level_Indicator", this.csg4700Level_IndicatorPrefFormControl);
        this.setOpCoPreferences("CSG_FBHP_600_Level_Indicator", this.csg6000Level_IndicatorPrefFormControl);
        this.csgOptionsSelectedItem = "Design Code";
        this.theFormGroup = this.modulePreferencesForm; // to drive GenericChangesGuard
        // Info ToolTip message translations
        this.serviceOffereingMessage = this.translatePipe.transform('SERVICE_OFFERING_MESSAGE', false);
        this.deliveryCostMessage = this.translatePipe.transform('DELIVERY_COST_MESSAGE', false);
        Promise.all(this.componentLoadPromises).then((/**
         * @return {?}
         */
        () => {
            console.log("Finishing Initializing CSG F&B Halfpipe module prefs component");
            this.componentInitialised = true;
        }));
    }
    /**
     * @return {?}
     */
    togglePrices() {
        this.showPrices = !this.showPrices;
        this.augmentPriceDataProcessing = true;
        this.augmentPricesToOptionsLists(this.showPrices);
    }
    /**
     * @param {?=} showPrices
     * @return {?}
     */
    augmentPricesToOptionsLists(showPrices = true) {
        this.csgPricing = new CleanSteamGeneratorFBPricing();
        this.csgPricing.modelId = -1; // All BOM items    
        this.csgPricing.pricingOptions = [];
        this.csgPricing.basePriceOption = -1;
        this.csgPricing.localRecommendedSalesPriceOption = -1;
        this.csgPricing.landedCostIncreaseFactor = -1;
        this.csgSellingCurrencySymbol = !!this.csgSellingCurrencySymbol ? this.csgSellingCurrencySymbol : "?";
        this.csgPricing.manufacturerId = +(!!this.manufacturerId ? this.manufacturerId : -1);
        this.csgManufacturerCurrency = this.currencyList.find((/**
         * @param {?} c
         * @return {?}
         */
        c => c.id === this.csgManufacturerCurrencyId));
        this.csgManufacturerCurrencySymbol = !!this.csgManufacturerCurrency ? this.csgManufacturerCurrency.symbol : "?";
        if (showPrices) {
            // Get RSP Display price data for List item Augmentation
            this.cleanSteamGeneratorService.calculateBOMPriceFBHalfPipe(this.csgPricing).subscribe((/**
             * @param {?} response
             * @return {?}
             */
            (response) => {
                if (response) {
                    this.csgBOMOutputData = response;
                    /** @type {?} */
                    let manPrice = "";
                    /** @type {?} */
                    let localPrices = "";
                    /** @type {?} */
                    let isOverride = "";
                    this.CSG_FBHP_130_Price = "";
                    this.CSG_FBHP_185_Price = "";
                    this.CSG_FBHP_235_Price = "";
                    this.CSG_FBHP_300_Price = "";
                    this.CSG_FBHP_375_Price = "";
                    this.CSG_FBHP_470_Price = "";
                    this.CSG_FBHP_600_Price = "";
                    this.csgBOMOutputData.bomItems.forEach((/**
                     * @param {?} t
                     * @return {?}
                     */
                    t => {
                        if (showPrices && t.itemType == "Base") {
                            // Price the models
                            if (t.sRecommendedSalesPrice != 0.0 && t.sRecommendedSalesPrice != parseFloat(t.sDisplayedRSP)) {
                                isOverride = 'o';
                            }
                            manPrice = ' SSP=' + this.csgManufacturerCurrencySymbol + ' ' + this.localizeValue(t.ssp, 0);
                            localPrices = ' RSP' + isOverride + '=' + this.csgManufacturerCurrencySymbol + ' ' + this.localizeValue(t.displayedRSP, 0);
                            if (t.ssp != t.sSSP) { // if not the same currency data
                                manPrice = manPrice + ' (' + this.csgSellingCurrencySymbol + ' ' + this.localizeValue(t.sSSP, 0) + ')';
                                localPrices = localPrices + ' (' + this.csgSellingCurrencySymbol + ' ' + this.localizeValue(t.sDisplayedRSP, 0) + ')';
                            }
                            switch (t.parentMasterTextKey) {
                                case "CSG_FBHP_130":
                                    this.CSG_FBHP_130_Price = manPrice + localPrices;
                                    break;
                                case "CSG_FBHP_185":
                                    this.CSG_FBHP_185_Price = manPrice + localPrices;
                                    break;
                                case "CSG_FBHP_235":
                                    this.CSG_FBHP_235_Price = manPrice + localPrices;
                                    break;
                                case "CSG_FBHP_300":
                                    this.CSG_FBHP_300_Price = manPrice + localPrices;
                                    break;
                                case "CSG_FBHP_375":
                                    this.CSG_FBHP_375_Price = manPrice + localPrices;
                                    break;
                                case "CSG_FBHP_470":
                                    this.CSG_FBHP_470_Price = manPrice + localPrices;
                                    break;
                                case "CSG_FBHP_600":
                                    this.CSG_FBHP_600_Price = manPrice + localPrices;
                                    break;
                                default:
                                    break;
                            }
                        }
                        // Set option item enabled?
                        /** @type {?} */
                        var newEnumerationModulePreferences = this.GetNewEnumerationModulePreferences();
                        this.csgBOMOutputData.bomItems.forEach((/**
                         * @param {?} p
                         * @return {?}
                         */
                        p => {
                            /** @type {?} */
                            var elist = newEnumerationModulePreferences.find((/**
                             * @param {?} e
                             * @return {?}
                             */
                            e => e.enumerationName == p.parent));
                            if (!!elist) {
                                /** @type {?} */
                                var elistItem = elist.enumerationDefinitions.find((/**
                                 * @param {?} l
                                 * @return {?}
                                 */
                                l => l.value == p.item));
                            }
                            p.isEnabled = !!elistItem ? true : false;
                            // Set enabled if base CSG model item or add on (Commisoining, Voltage, Warranty etc.)
                            if (!p.parentMasterTextKey
                                || (!!p.parentMasterTextKey && p.parentMasterTextKey.indexOf('FEEDWATER_') === 0) // no list override for it
                                || (!!p.parentMasterTextKey && p.parentMasterTextKey.indexOf('CSG_') === 0)) {
                                p.isEnabled = true;
                            }
                        }));
                        // Append prices to list translation on UI
                        this.translationService.displayGroup.enumerations.forEach((/**
                         * @param {?} e
                         * @return {?}
                         */
                        e => {
                            e.enumerationDefinitions.forEach((/**
                             * @param {?} d
                             * @return {?}
                             */
                            d => {
                                if (e.enumerationName == t.parent && d.value == t.item) { // && d.translationText.indexOf(' ' + this.sellingCurrencySymbol + ' ') < 0) {              
                                    if (showPrices) {
                                        if (t.sRecommendedSalesPrice != 0.0 && (t.sRecommendedSalesPrice != parseFloat(t.sDisplayedRSP))) {
                                            isOverride = 'o';
                                        }
                                        /** @type {?} */
                                        var nomCode = '';
                                        if (!!t.item.split('_')[1]) {
                                            nomCode = '(' + t.item.split('_')[1] + ') ';
                                        }
                                        manPrice = ' SSP=' + this.csgManufacturerCurrencySymbol + ' ' + this.localizeValue(t.ssp, 0);
                                        localPrices = ' RSP' + isOverride + '=' + this.csgManufacturerCurrencySymbol + ' ' + this.localizeValue(t.displayedRSP, 0);
                                        if (t.ssp != t.sSSP) { // if not the same currency data
                                            manPrice = manPrice + ' (' + this.csgSellingCurrencySymbol + ' ' + this.localizeValue(t.sSSP, 0) + ')';
                                            localPrices = localPrices + ' (' + this.csgSellingCurrencySymbol + ' ' + this.localizeValue(t.sDisplayedRSP, 0) + ')';
                                        }
                                        // Set the UI text
                                        d.extraPostText = manPrice + localPrices;
                                        d.extraPreText = nomCode;
                                    }
                                    else {
                                        d.extraPostText = ""; // clear augmented data
                                        d.extraPreText = "";
                                    }
                                }
                            }));
                        }));
                    })); // of append prices
                    this.augmentPriceDataProcessing = false; // finished, enable button again
                    //this.scrollToElement(this.collapsePriceDataTop, "start");
                }
            })); // end of service response
        } // end of if showPrices
        else {
            // remove price augmentation
            this.CSG_FBHP_130_Price = "";
            this.CSG_FBHP_185_Price = "";
            this.CSG_FBHP_235_Price = "";
            this.CSG_FBHP_300_Price = "";
            this.CSG_FBHP_375_Price = "";
            this.CSG_FBHP_470_Price = "";
            this.CSG_FBHP_600_Price = "";
            this.translationService.displayGroup.enumerations.forEach((/**
             * @param {?} e
             * @return {?}
             */
            e => {
                e.enumerationDefinitions.forEach((/**
                 * @param {?} d
                 * @return {?}
                 */
                d => d.extraPostText = "")); // clear augmented data
                //e.enumerationDefinitions.forEach(d => d.extraPreText = "") // leave Nom codes on for easy UI reference.
            }));
            this.augmentPriceDataProcessing = false; // finished, enable button again
        }
    }
    /**
     * Method to localize values.
     * @param {?} value
     * @param {?} decimalPoints
     * @return {?}
     */
    localizeValue(value, decimalPoints) {
        return this.localeService.formatDecimal(value.toFixed(decimalPoints));
    }
    /*
      * Method to get and set the OpCo selected options.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} formControlName
     * @return {?}
     */
    setOpCoPreferences(enumerationPickerName, formControlName) {
        // Get the collection list first.
        /** @type {?} */
        let csgOpCoPref = this.getEnumerationPickerCollection(enumerationPickerName, true);
        // Check if any OpCo Overrides Data found? If NOT then get the base list populated.
        if (!csgOpCoPref) {
            csgOpCoPref = this.cloneDeep(this.getEnumerationPickerCollection(enumerationPickerName, false));
        }
        // Check and set the list.
        if (!!csgOpCoPref && csgOpCoPref.length > 0) {
            formControlName.setValue(csgOpCoPref);
        }
    }
    /*
      * Method to get the Enumeration list by Name.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} opCoOverride
     * @return {?}
     */
    getEnumerationPickerCollection(enumerationPickerName, opCoOverride) {
        /** @type {?} */
        const enumeration = this.translationService.displayGroup.enumerations.filter((/**
         * @param {?} us
         * @return {?}
         */
        us => us.enumerationName === enumerationPickerName && us.opCoOverride === opCoOverride));
        if (!!enumeration && enumeration.length > 0) {
            /** @type {?} */
            let definitions = enumeration[0].enumerationDefinitions.sort((/**
             * @param {?} currentenumeration
             * @param {?} nextenumeration
             * @return {?}
             */
            (currentenumeration, nextenumeration) => {
                if (currentenumeration.sequence > nextenumeration.sequence) {
                    return 1;
                }
                if (currentenumeration.sequence < nextenumeration.sequence) {
                    return -1;
                }
                return 0;
            }));
            //this.onChange(definitions);
            definitions.forEach((/**
             * @param {?} i
             * @return {?}
             */
            i => i.isDeleted = false));
            return definitions;
        }
    }
    /**
     * Submits the form for saving to the server.
     * @param {?} $event
     * @return {?}
     */
    submitForm($event) {
        $event.preventDefault();
        // Mark the form as submitted.
        this.formSubmitted = true;
        // Regular Module Preferences.
        /** @type {?} */
        const newModulePreferences = [];
        newModulePreferences.push(this.getSelectedPreferences("CSGFBHalfPipeSellingCurrency", "csgSellingCurrencyModulePreference"));
        newModulePreferences.push(this.getSelectedPreferences("CSGFBHalfPipeLandCostIncrease", "csgLandedCostIncreaseModulePreference"));
        newModulePreferences.push(this.getSelectedPreferences("CSGFBHalfPipeDeliveryCost", "csgDeliveryCostModulePreference"));
        newModulePreferences.push(this.getSelectedPreferences("CSGFBHalfPipeCommission", "csgCommissionOnlyPriceModulePreference"));
        newModulePreferences.push(this.getSelectedPreferences("CSGFBHalfPipeYearOne", "csgWarrantyOneYearModulePreference"));
        newModulePreferences.push(this.getSelectedPreferences("CSGFBHalfPipeYearTwo", "csgWarrantyTwoYearsModulePreference"));
        newModulePreferences.push(this.getSelectedPreferences("CSGFBHalfPipeYearThree", "csgWarrantyThreeYearsModulePreference"));
        // Save the changed preferences as an array of preferences
        this.adminService.manageModulePreferences(newModulePreferences).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            // The form can be submitted again.
            this.formSubmitted = false;
            // Set the operation based on the response.
            // this.isSuccess = response;
            this.alertVisible = true;
        }));
        /** @type {?} */
        var newEnumerationModulePreferences = this.GetNewEnumerationModulePreferences();
        // Save the changed preferences as an array of preferences
        this.adminService.manageEnumerationModulePreferences(newEnumerationModulePreferences).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            // The form can be submitted again.
            this.formSubmitted = false;
            // Set the operation based on the response.
            this.isSuccess = response;
            this.alertVisible = true;
            this.modulePreferencesForm.markAsPristine(); // to drive GenericChangesGuard
        }));
    }
    /**
     * @return {?}
     */
    GetNewEnumerationModulePreferences() {
        // Enumeration Module Preferences.
        /** @type {?} */
        const newEnumerationModulePreferences = [];
        // Design Code
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Design_Code", "csg1300DesignCodePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Design_Code", "csg1850DesignCodePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Design_Code", "csg2350DesignCodePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Design_Code", "csg3000DesignCodePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Design_Code", "csg3750DesignCodePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Design_Code", "csg4700DesignCodePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Design_Code", "csg6000DesignCodePreference"));
        // Shell Type
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Shell_Type", "csg1300ShellTypePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Shell_Type", "csg1850ShellTypePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Shell_Type", "csg2350ShellTypePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Shell_Type", "csg3000ShellTypePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Shell_Type", "csg3750ShellTypePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Shell_Type", "csg4700ShellTypePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Shell_Type", "csg6000ShellTypePreference"));
        // Control Valve Actuation
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Valve_Actuation", "csg1300ValveActuationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Valve_Actuation", "csg1850ValveActuationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Valve_Actuation", "csg2350ValveActuationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Valve_Actuation", "csg3000ValveActuationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Valve_Actuation", "csg3750ValveActuationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Valve_Actuation", "csg4700ValveActuationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Valve_Actuation", "csg6000ValveActuationPreference"));
        // Feedwater Pressurisation - does the list have AllowOverride set to true or just readOnly?
        if (!!this.getEnumerationPickerCollection('CSG_FBHP_130_Feedwater_Pressurisation', true)) {
            // The lists AllowOverride == true, so we can save the OpCo's Module Preference for these lists and list items.
            newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Feedwater_Pressurisation", "csg1300FeedwaterPressurisationPreference"));
            newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Feedwater_Pressurisation", "csg1850FeedwaterPressurisationPreference"));
            newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Feedwater_Pressurisation", "csg2350FeedwaterPressurisationPreference"));
            newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Feedwater_Pressurisation", "csg3000FeedwaterPressurisationPreference"));
            newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Feedwater_Pressurisation", "csg3750FeedwaterPressurisationPreference"));
            newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Feedwater_Pressurisation", "csg4700FeedwaterPressurisationPreference"));
            newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Feedwater_Pressurisation", "csg6000FeedwaterPressurisationPreference"));
        }
        // Control
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Control", "csg1300ControlPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Control", "csg1850ControlPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Control", "csg2350ControlPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Control", "csg3000ControlPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Control", "csg3750ControlPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Control", "csg4700ControlPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Control", "csg6000ControlPreference"));
        // Communication Interface
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Communication_Interface", "csg1300CommunicationInterfacePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Communication_Interface", "csg1850CommunicationInterfacePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Communication_Interface", "csg2350CommunicationInterfacePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Communication_Interface", "csg3000CommunicationInterfacePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Communication_Interface", "csg3750CommunicationInterfacePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Communication_Interface", "csg4700CommunicationInterfacePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Communication_Interface", "csg6000CommunicationInterfacePreference"));
        // Frame and Cabinet
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Frame_And_Cabinet", "csg1300FrameAndCabinetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Frame_And_Cabinet", "csg1850FrameAndCabinetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Frame_And_Cabinet", "csg2350FrameAndCabinetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Frame_And_Cabinet", "csg3000FrameAndCabinetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Frame_And_Cabinet", "csg3750FrameAndCabinetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Frame_And_Cabinet", "csg4700FrameAndCabinetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Frame_And_Cabinet", "csg6000FrameAndCabinetPreference"));
        // Control Panel Location
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Control_Panel_Location", "csg1300ControlPanelLocationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Control_Panel_Location", "csg1850ControlPanelLocationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Control_Panel_Location", "csg2350ControlPanelLocationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Control_Panel_Location", "csg3000ControlPanelLocationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Control_Panel_Location", "csg3750ControlPanelLocationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Control_Panel_Location", "csg4700ControlPanelLocationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Control_Panel_Location", "csg6000ControlPanelLocationPreference"));
        // Insulation
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Insulation", "csg1300InsulationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Insulation", "csg1850InsulationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Insulation", "csg2350InsulationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Insulation", "csg3000InsulationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Insulation", "csg3750InsulationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Insulation", "csg4700InsulationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Insulation", "csg6000InsulationPreference"));
        // Wheels And Feet
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Wheels_And_Feet", "csg1300WheelsAndFeetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Wheels_And_Feet", "csg1850WheelsAndFeetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Wheels_And_Feet", "csg2350WheelsAndFeetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Wheels_And_Feet", "csg3000WheelsAndFeetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Wheels_And_Feet", "csg3750WheelsAndFeetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Wheels_And_Feet", "csg4700WheelsAndFeetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Wheels_And_Feet", "csg6000WheelsAndFeetPreference"));
        // Plant Steam Inlet Shut Off Valve
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Plant_Steam_Inlet_Shut_Off_Valve", "csg1300PlantSteamInletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Plant_Steam_Inlet_Shut_Off_Valve", "csg1850PlantSteamInletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Plant_Steam_Inlet_Shut_Off_Valve", "csg2350PlantSteamInletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Plant_Steam_Inlet_Shut_Off_Valve", "csg3000PlantSteamInletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Plant_Steam_Inlet_Shut_Off_Valve", "csg3750PlantSteamInletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Plant_Steam_Inlet_Shut_Off_Valve", "csg4700PlantSteamInletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Plant_Steam_Inlet_Shut_Off_Valve", "csg6000PlantSteamInletShutOffValvePreference"));
        // Plant steam line trapping
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Plant_Steam_Line_Trapping", "csg1300PlantSteamLineTrappingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Plant_Steam_Line_Trapping", "csg1850PlantSteamLineTrappingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Plant_Steam_Line_Trapping", "csg2350PlantSteamLineTrappingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Plant_Steam_Line_Trapping", "csg3000PlantSteamLineTrappingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Plant_Steam_Line_Trapping", "csg3750PlantSteamLineTrappingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Plant_Steam_Line_Trapping", "csg4700PlantSteamLineTrappingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Plant_Steam_Line_Trapping", "csg6000PlantSteamLineTrappingPreference"));
        // TDS control system
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_TDS_Control_System", "csg1300TDSControlSystemPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_TDS_Control_System", "csg1850TDSControlSystemPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_TDS_Control_System", "csg2350TDSControlSystemPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_TDS_Control_System", "csg3000TDSControlSystemPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_TDS_Control_System", "csg3750TDSControlSystemPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_TDS_Control_System", "csg4700TDSControlSystemPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_TDS_Control_System", "csg6000TDSControlSystemPreference"));
        // Sample Coolers
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Sample_Cooler", "csg1300SampleCoolerPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Sample_Cooler", "csg1850SampleCoolerPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Sample_Cooler", "csg2350SampleCoolerPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Sample_Cooler", "csg3000SampleCoolerPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Sample_Cooler", "csg3750SampleCoolerPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Sample_Cooler", "csg4700SampleCoolerPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Sample_Cooler", "csg6000SampleCoolerPreference"));
        // Independent low level alarm
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Independent_Low_Level_Alarm", "csg1300IndependentLowLevelAlarmPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Independent_Low_Level_Alarm", "csg1850IndependentLowLevelAlarmPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Independent_Low_Level_Alarm", "csg2350IndependentLowLevelAlarmPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Independent_Low_Level_Alarm", "csg3000IndependentLowLevelAlarmPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Independent_Low_Level_Alarm", "csg3750IndependentLowLevelAlarmPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Independent_Low_Level_Alarm", "csg4700IndependentLowLevelAlarmPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Independent_Low_Level_Alarm", "csg6000IndependentLowLevelAlarmPreference"));
        // Feedwater pre-heating / Degassing
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Feedwater_Pre_Heating_Degassing", "csg1300FeedwaterPreHeatingDegassingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Feedwater_Pre_Heating_Degassing", "csg1850FeedwaterPreHeatingDegassingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Feedwater_Pre_Heating_Degassing", "csg2350FeedwaterPreHeatingDegassingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Feedwater_Pre_Heating_Degassing", "csg3000FeedwaterPreHeatingDegassingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Feedwater_Pre_Heating_Degassing", "csg3750FeedwaterPreHeatingDegassingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Feedwater_Pre_Heating_Degassing", "csg4700FeedwaterPreHeatingDegassingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Feedwater_Pre_Heating_Degassing", "csg6000FeedwaterPreHeatingDegassingPreference"));
        // Intelligent diagnostics
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Intelligent_Diagnostics", "csg1300IntelligentDiagnosticsPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Intelligent_Diagnostics", "csg1850IntelligentDiagnosticsPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Intelligent_Diagnostics", "csg2350IntelligentDiagnosticsPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Intelligent_Diagnostics", "csg3000IntelligentDiagnosticsPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Intelligent_Diagnostics", "csg3750IntelligentDiagnosticsPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Intelligent_Diagnostics", "csg4700IntelligentDiagnosticsPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Intelligent_Diagnostics", "csg6000IntelligentDiagnosticsPreference"));
        // Clean steam outlet shut-off valve
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Clean_Steam_Outlet_Shut_Off_Valve", "csg1300CleanSteamOutletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Clean_Steam_Outlet_Shut_Off_Valve", "csg1850CleanSteamOutletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Clean_Steam_Outlet_Shut_Off_Valve", "csg2350CleanSteamOutletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Clean_Steam_Outlet_Shut_Off_Valve", "csg3000CleanSteamOutletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Clean_Steam_Outlet_Shut_Off_Valve", "csg3750CleanSteamOutletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Clean_Steam_Outlet_Shut_Off_Valve", "csg4700CleanSteamOutletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Clean_Steam_Outlet_Shut_Off_Valve", "csg6000CleanSteamOutletShutOffValvePreference"));
        // Test and certifications
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Test_And_Certification", "csg1300TestAndCertificationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Test_And_Certification", "csg1850TestAndCertificationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Test_And_Certification", "csg2350TestAndCertificationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Test_And_Certification", "csg3000TestAndCertificationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Test_And_Certification", "csg3750TestAndCertificationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Test_And_Certification", "csg4700TestAndCertificationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Test_And_Certification", "csg6000TestAndCertificationPreference"));
        // Level_Indicator
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_130_Level_Indicator", "csg1300Level_IndicatorPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_185_Level_Indicator", "csg1850Level_IndicatorPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_235_Level_Indicator", "csg2350Level_IndicatorPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_300_Level_Indicator", "csg3000Level_IndicatorPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_375_Level_Indicator", "csg3750Level_IndicatorPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_470_Level_Indicator", "csg4700Level_IndicatorPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_FBHP_600_Level_Indicator", "csg6000Level_IndicatorPreference"));
        return newEnumerationModulePreferences;
    }
    /*
      * Method to get opco selected enumeration module prefernce details for each options.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} prefsFormKeyName
     * @return {?}
     */
    getSelectedEnumerationPreferences(enumerationPickerName, prefsFormKeyName) {
        /** @type {?} */
        var modPrefs = new Enumeration;
        modPrefs.enumerationName = enumerationPickerName;
        modPrefs.opCoOverride = true;
        modPrefs.enumerationDefinitions = this.modulePreferencesForm.controls[prefsFormKeyName].value;
        return modPrefs;
    }
    /*
      * Method to get opco selected module prefernce details.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} prefsFormKeyName
     * @return {?}
     */
    getSelectedPreferences(enumerationPickerName, prefsFormKeyName) {
        /** @type {?} */
        var modPrefs = new ModulePreferenceDetails;
        modPrefs.name = enumerationPickerName;
        modPrefs.value = "" + this.modulePreferencesForm.controls[prefsFormKeyName].value;
        modPrefs.moduleId = +this.moduleId;
        modPrefs.isDeleted = false;
        return modPrefs;
    }
    /**
     * @return {?}
     */
    closeAlert() {
        // Reset the flag
        this.alertVisible = false;
    }
    /**
     * @return {?}
     */
    onChangeAnyOption() {
        // Any enumeration-picker (on-change) set the form data to dirty.
        this.modulePreferencesForm.markAsDirty();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onCSGOptionsChange(event) {
        this.csgOptionsSelectedItem = event.selectedValue;
        this.csgOptionsFormControl.markAsPristine(); // Options list selector is not a data change item, so ignore changes.
    }
    /*
      * Method to calculate the currency conversion rate.
      */
    /**
     * @param {?} selectedValue
     * @return {?}
     */
    onSellingCurrencyChange(selectedValue) {
        if (selectedValue > 0 && this.csgManufacturerCurrencyId > 0 && this.currencyList.length > 0) {
            /** @type {?} */
            let sellingCurrency = this.currencyList.find((/**
             * @param {?} c
             * @return {?}
             */
            c => c.id === +selectedValue));
            /** @type {?} */
            let manufacturerCurrency = this.currencyList.find((/**
             * @param {?} c
             * @return {?}
             */
            c => c.id === this.csgManufacturerCurrencyId));
            this.csgSellingCurrencySymbol = sellingCurrency.symbol;
            this.csgCurrencyConversion = +((manufacturerCurrency.rateToGbp * (1 / sellingCurrency.rateToGbp)).toFixed(5));
        }
    }
    /*
      * Method to retrieve the module pref value from the list.
      */
    /**
     * @param {?} modulePrefList
     * @param {?} modulePrefName
     * @return {?}
     */
    getModulePreferenceValue(modulePrefList, modulePrefName) {
        /** @type {?} */
        let modPref = modulePrefList.filter((/**
         * @param {?} r
         * @return {?}
         */
        r => r.name === modulePrefName));
        if (modPref && modPref.length > 0) {
            return modPref[0].value;
        }
    }
    /**
     * @param {?} row
     * @return {?}
     */
    getRowClass(row) {
        if (row.isEnabled) {
            return 'row-color-enabled';
        }
        return 'row-color-disabled';
    }
}
CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.decorators = [
    { type: Component, args: [{
                selector: 'cleansteamgeneratorFBHalfPipe-module-preferences',
                template: "<!--CleanSteamGenerator module preferences component works!-->\r\n\r\n<div *ngIf=\"!componentInitialised\">\r\n  <div class=\"ball-clip-rotate\">\r\n    <div></div>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"!!componentInitialised\">\r\n  <form [formGroup]=\"modulePreferencesForm\" class=\"form-horizontal\" role=\"form\" (submit)=\"submitForm($event)\" novalidate>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <button [disabled]=\"!modulePreferencesForm.dirty || !modulePreferencesForm.valid || modulePreferencesForm.status !== 'VALID' || formSubmitted\" type=\"submit\" class=\"btn btn-dynamic btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i></button>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <br>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Success confirmation message -->\r\n    <alert-block *ngIf=\"!!alertVisible && !!isSuccess\" type=\"success\" [auto-close]=\"true\" [message]=\"'MODULE_PREFERENCES_SAVED_SUCCESSFULLY_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n    <!-- Failure confirmation message-->\r\n    <alert-block *ngIf=\"!!alertVisible && !isSuccess\" type=\"danger\" [message]=\"'MODULE_PREFERENCES_FAILED_TO_SAVE_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"currencyOptionsHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseCurrencyOptions\" aria-expanded=\"true\" aria-controls=\"collapseCurrencyOptions\">\r\n            {{\"CURRENCY_OPTIONS\" | translate}} - <em class=\"fa fa-adjust fa-fw\" style=\"color:red\"></em>FB Half Pipe\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapseCurrencyOptions\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"currencyOptionsHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-10px\">\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"row\" style=\"padding-bottom:15px\">\r\n\r\n              <!--Manufacturer-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"MANUFACTURER\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"csgManufacturerModulePreference\">\r\n                  <option *ngFor=\"let manufacturer of manufacturerList\" [value]=\"manufacturer.id\">{{manufacturer.name}}</option>\r\n                </select>\r\n              </div>\r\n\r\n              <!--Selling currency-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"SELLING_CURRENCY\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"csgSellingCurrencyModulePreference\" (ngModelChange)=\"onSellingCurrencyChange($event)\">\r\n                  <option *ngFor=\"let currency of currencyList\" [value]=\"currency.id\">{{currency.currencyCode}} - {{currency.symbol}}</option>\r\n                </select>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n\r\n              <!--Manufacturer currency-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"MANUFACTURER_CURRENCY\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"csgManufacturerCurrencyModulePreference\">\r\n                  <option *ngFor=\"let currency of currencyList\" [value]=\"currency.id\">{{currency.currencyCode}} - {{currency.symbol}}</option>\r\n                </select>\r\n              </div>\r\n\r\n              <!--Currency conversion-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"CURRENCY_CONVERSION\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <label class=\"control-label\">{{csgCurrencyConversion}}</label>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--Pricing Options-->\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"pricingOptionsHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapsePricingOptions\" aria-expanded=\"true\" aria-controls=\"collapsePricingOptions\">\r\n            {{\"PRICING_OPTIONS\" | translate}} - <em class=\"fa fa-adjust fa-fw\" style=\"color:red\"></em>FB Half Pipe\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapsePricingOptions\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"pricingOptionsHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-30px\">\r\n          <div class=\"form-group\">\r\n            <!--Column 1-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <!--Landed Cost Increase-->\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"LANDED_COST_INCREASE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"csgLandedCostIncreaseModulePreference\" value=\"csgLandedCostIncrease\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].dirty || modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].hasError('range') && (modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].dirty || modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].touched)\">{{\"LANDED_COST_INCREASE_MUST_BE_BETWEEN_0_AND_100_PERCENT_MESSAGE\" | translate}}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <!--Delivery Cost-->\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"DELIVERY_COST\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-addon\">{{csgSellingCurrencySymbol}}</span>\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"text\" style=\"min-width:55px;\" formControlName=\"csgDeliveryCostModulePreference\" value=\"csgDeliveryCost\" twoDigitDecimalNumber />\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2 cross-validation-error-class\">\r\n                  <div><i *ngIf=\"deliveryCostMessage\"class=\"fa fa-info-circle cross-validation-error-class\" [tooltip]=\"deliveryCostMessage\" placement=\"top,right\"></i></div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgDeliveryCostModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgDeliveryCostModulePreference'].dirty || modulePreferencesForm.controls['csgDeliveryCostModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Column 2-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"panel panel-primary\" style=\"padding-bottom: 20px;\">\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-4 text-right\">\r\n                    <h4>{{\"SERVICE_OFFERING\" | translate}}</h4>\r\n                  </div>\r\n                  <div class=\"col-xs-3 cross-validation-error-class\">\r\n                    <div><i *ngIf=\"serviceOffereingMessage\" class=\"fa fa-info-circle cross-validation-error-class\" [tooltip]=\"serviceOffereingMessage\" placement=\"top,right\"></i></div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--Commission Only Price-->\r\n                  <div class=\"col-xs-4 text-right\">\r\n                    <label class=\"control-label\">{{\"COMMISSION_ONLY_PRICE\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{csgSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"csgCommissionOnlyPriceModulePreference\" value=\"csgCommissionOnlyPrice\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgCommissionOnlyPriceModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgCommissionOnlyPriceModulePreference'].dirty || modulePreferencesForm.controls['csgCommissionOnlyPriceModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n                <!--</fieldset>-->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--One Year-->\r\n                  <div class=\"col-xs-4 text-right\">\r\n                    <label class=\"control-label\">{{\"ONE_YEAR\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{csgSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"csgWarrantyOneYearModulePreference\" value=\"csgWarrantyOneYear\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgWarrantyOneYearModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgWarrantyOneYearModulePreference'].dirty || modulePreferencesForm.controls['csgWarrantyOneYearModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--Two Years-->\r\n                  <div class=\"col-xs-4 text-right\">\r\n                    <label class=\"control-label\">{{\"TWO_YEARS\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{csgSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"csgWarrantyTwoYearsModulePreference\" value=\"csgWarrantyTwoYears\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgWarrantyTwoYearsModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgWarrantyTwoYearsModulePreference'].dirty || modulePreferencesForm.controls['csgWarrantyTwoYearsModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--Three Years-->\r\n                  <div class=\"col-xs-4 text-right\">\r\n                    <label class=\"control-label\">{{\"THREE_YEARS\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{csgSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"csgWarrantyThreeYearsModulePreference\" value=\"csgWarrantyThreeYears\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgWarrantyThreeYearsModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgWarrantyThreeYearsModulePreference'].dirty || modulePreferencesForm.controls['csgWarrantyThreeYearsModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--Configurartion Options-->\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"optionConfigurartionHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseOptionConfigurartion\" aria-expanded=\"true\" aria-controls=\"collapseOptionConfigurartion\">\r\n            {{\"OPTION_CONFIGURATION\" | translate}} - <em class=\"fa fa-adjust fa-fw\" style=\"color:red\"></em>FB Half Pipe\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapseOptionConfigurartion\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"optionConfigurartionHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-20px\">\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-2 text-right\">\r\n                <label class=\"control-label\">{{\"PLEASE_SELECT\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                <enumeration formControlName=\"csgOptionsSelection\" enumeration-name=\"CSG_FB_Options\" (on-change)=\"onCSGOptionsChange($event)\"></enumeration>\r\n              </div>\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                <button [disabled]=\"augmentPriceDataProcessing\" class=\"btn btn-dynamic btn-primary pull-right\" type='button' (click)=\"togglePrices();\" [title]=\"'TOGGLE_PRICES' | translate\"><i class=\"fa fa-exchange\">  {{'TOGGLE_PRICES' | translate}}</i></button>\r\n              </div>\r\n            </div>\r\n            <hr>\r\n            <!--Design Code-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Design Code'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300DesignCodePreference\" enumeration-picker-name=\"CSG_FBHP_130_Design_Code\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850DesignCodePreference\" enumeration-picker-name=\"CSG_FBHP_185_Design_Code\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350DesignCodePreference\" enumeration-picker-name=\"CSG_FBHP_235_Design_Code\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000DesignCodePreference\" enumeration-picker-name=\"CSG_FBHP_300_Design_Code\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Design Code'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750DesignCodePreference\" enumeration-picker-name=\"CSG_FBHP_375_Design_Code\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700DesignCodePreference\" enumeration-picker-name=\"CSG_FBHP_470_Design_Code\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000DesignCodePreference\" enumeration-picker-name=\"CSG_FBHP_600_Design_Code\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Shell Type-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Shell Type'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300ShellTypePreference\" enumeration-picker-name=\"CSG_FBHP_130_Shell_Type\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850ShellTypePreference\" enumeration-picker-name=\"CSG_FBHP_185_Shell_Type\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350ShellTypePreference\" enumeration-picker-name=\"CSG_FBHP_235_Shell_Type\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000ShellTypePreference\" enumeration-picker-name=\"CSG_FBHP_300_Shell_Type\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Shell Type'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750ShellTypePreference\" enumeration-picker-name=\"CSG_FBHP_375_Shell_Type\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700ShellTypePreference\" enumeration-picker-name=\"CSG_FBHP_470_Shell_Type\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000ShellTypePreference\" enumeration-picker-name=\"CSG_FBHP_600_Shell_Type\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Valve Actuation-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Valve Actuation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300ValveActuationPreference\" enumeration-picker-name=\"CSG_FBHP_130_Valve_Actuation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850ValveActuationPreference\" enumeration-picker-name=\"CSG_FBHP_185_Valve_Actuation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350ValveActuationPreference\" enumeration-picker-name=\"CSG_FBHP_235_Valve_Actuation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000ValveActuationPreference\" enumeration-picker-name=\"CSG_FBHP_300_Valve_Actuation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Valve Actuation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750ValveActuationPreference\" enumeration-picker-name=\"CSG_FBHP_375_Valve_Actuation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700ValveActuationPreference\" enumeration-picker-name=\"CSG_FBHP_470_Valve_Actuation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000ValveActuationPreference\" enumeration-picker-name=\"CSG_FBHP_600_Valve_Actuation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Feedwater Pressurisation-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Feedwater pressurisation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300FeedwaterPressurisationPreference\" enumeration-picker-name=\"CSG_FBHP_130_Feedwater_Pressurisation\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850FeedwaterPressurisationPreference\" enumeration-picker-name=\"CSG_FBHP_185_Feedwater_Pressurisation\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350FeedwaterPressurisationPreference\" enumeration-picker-name=\"CSG_FBHP_235_Feedwater_Pressurisation\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000FeedwaterPressurisationPreference\" enumeration-picker-name=\"CSG_FBHP_300_Feedwater_Pressurisation\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Feedwater pressurisation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750FeedwaterPressurisationPreference\" enumeration-picker-name=\"CSG_FBHP_375_Feedwater_Pressurisation\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700FeedwaterPressurisationPreference\" enumeration-picker-name=\"CSG_FBHP_470_Feedwater_Pressurisation\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000FeedwaterPressurisationPreference\" enumeration-picker-name=\"CSG_FBHP_600_Feedwater_Pressurisation\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Control-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Control'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300ControlPreference\" enumeration-picker-name=\"CSG_FBHP_130_Control\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850ControlPreference\" enumeration-picker-name=\"CSG_FBHP_185_Control\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350ControlPreference\" enumeration-picker-name=\"CSG_FBHP_235_Control\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000ControlPreference\" enumeration-picker-name=\"CSG_FBHP_300_Control\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Control'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750ControlPreference\" enumeration-picker-name=\"CSG_FBHP_375_Control\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700ControlPreference\" enumeration-picker-name=\"CSG_FBHP_470_Control\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000ControlPreference\" enumeration-picker-name=\"CSG_FBHP_600_Control\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Communication interface-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Communication interface'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300CommunicationInterfacePreference\" enumeration-picker-name=\"CSG_FBHP_130_Communication_Interface\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850CommunicationInterfacePreference\" enumeration-picker-name=\"CSG_FBHP_185_Communication_Interface\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350CommunicationInterfacePreference\" enumeration-picker-name=\"CSG_FBHP_235_Communication_Interface\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000CommunicationInterfacePreference\" enumeration-picker-name=\"CSG_FBHP_300_Communication_Interface\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Communication interface'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750CommunicationInterfacePreference\" enumeration-picker-name=\"CSG_FBHP_375_Communication_Interface\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700CommunicationInterfacePreference\" enumeration-picker-name=\"CSG_FBHP_470_Communication_Interface\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000CommunicationInterfacePreference\" enumeration-picker-name=\"CSG_FBHP_600_Communication_Interface\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Frame and cabinet-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Frame and Cabinet'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300FrameAndCabinetPreference\" enumeration-picker-name=\"CSG_FBHP_130_Frame_And_Cabinet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850FrameAndCabinetPreference\" enumeration-picker-name=\"CSG_FBHP_185_Frame_And_Cabinet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350FrameAndCabinetPreference\" enumeration-picker-name=\"CSG_FBHP_235_Frame_And_Cabinet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000FrameAndCabinetPreference\" enumeration-picker-name=\"CSG_FBHP_300_Frame_And_Cabinet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Frame and Cabinet'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750FrameAndCabinetPreference\" enumeration-picker-name=\"CSG_FBHP_375_Frame_And_Cabinet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700FrameAndCabinetPreference\" enumeration-picker-name=\"CSG_FBHP_470_Frame_And_Cabinet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000FrameAndCabinetPreference\" enumeration-picker-name=\"CSG_FBHP_600_Frame_And_Cabinet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Control Panel Location-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Control panel location'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300ControlPanelLocationPreference\" enumeration-picker-name=\"CSG_FBHP_130_Control_Panel_Location\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850ControlPanelLocationPreference\" enumeration-picker-name=\"CSG_FBHP_185_Control_Panel_Location\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350ControlPanelLocationPreference\" enumeration-picker-name=\"CSG_FBHP_235_Control_Panel_Location\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000ControlPanelLocationPreference\" enumeration-picker-name=\"CSG_FBHP_300_Control_Panel_Location\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Control panel location'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750ControlPanelLocationPreference\" enumeration-picker-name=\"CSG_FBHP_375_Control_Panel_Location\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700ControlPanelLocationPreference\" enumeration-picker-name=\"CSG_FBHP_470_Control_Panel_Location\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000ControlPanelLocationPreference\" enumeration-picker-name=\"CSG_FBHP_600_Control_Panel_Location\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Insulation-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Insulation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300InsulationPreference\" enumeration-picker-name=\"CSG_FBHP_130_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850InsulationPreference\" enumeration-picker-name=\"CSG_FBHP_185_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350InsulationPreference\" enumeration-picker-name=\"CSG_FBHP_235_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000InsulationPreference\" enumeration-picker-name=\"CSG_FBHP_300_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Insulation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750InsulationPreference\" enumeration-picker-name=\"CSG_FBHP_375_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700InsulationPreference\" enumeration-picker-name=\"CSG_FBHP_470_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000InsulationPreference\" enumeration-picker-name=\"CSG_FBHP_600_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Handling wheels and feet-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Handling wheels and feet'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300WheelsAndFeetPreference\" enumeration-picker-name=\"CSG_FBHP_130_Wheels_And_Feet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850WheelsAndFeetPreference\" enumeration-picker-name=\"CSG_FBHP_185_Wheels_And_Feet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350WheelsAndFeetPreference\" enumeration-picker-name=\"CSG_FBHP_235_Wheels_And_Feet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000WheelsAndFeetPreference\" enumeration-picker-name=\"CSG_FBHP_300_Wheels_And_Feet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Handling wheels and feet'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750WheelsAndFeetPreference\" enumeration-picker-name=\"CSG_FBHP_375_Wheels_And_Feet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700WheelsAndFeetPreference\" enumeration-picker-name=\"CSG_FBHP_470_Wheels_And_Feet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000WheelsAndFeetPreference\" enumeration-picker-name=\"CSG_FBHP_600_Wheels_And_Feet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Plant Steam Inlet Shut Off Valve-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Plant steam inlet shut-off valve'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300PlantSteamInletShutOffValvePreference\" enumeration-picker-name=\"CSG_FBHP_130_Plant_Steam_Inlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850PlantSteamInletShutOffValvePreference\" enumeration-picker-name=\"CSG_FBHP_185_Plant_Steam_Inlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350PlantSteamInletShutOffValvePreference\" enumeration-picker-name=\"CSG_FBHP_235_Plant_Steam_Inlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000PlantSteamInletShutOffValvePreference\" enumeration-picker-name=\"CSG_FBHP_300_Plant_Steam_Inlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Plant steam inlet shut-off valve'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750PlantSteamInletShutOffValvePreference\" enumeration-picker-name=\"CSG_FBHP_375_Plant_Steam_Inlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700PlantSteamInletShutOffValvePreference\" enumeration-picker-name=\"CSG_FBHP_470_Plant_Steam_Inlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000PlantSteamInletShutOffValvePreference\" enumeration-picker-name=\"CSG_FBHP_600_Plant_Steam_Inlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Plant steam line trapping-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Plant steam line trapping'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300PlantSteamLineTrappingPreference\" enumeration-picker-name=\"CSG_FBHP_130_Plant_Steam_Line_Trapping\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850PlantSteamLineTrappingPreference\" enumeration-picker-name=\"CSG_FBHP_185_Plant_Steam_Line_Trapping\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350PlantSteamLineTrappingPreference\" enumeration-picker-name=\"CSG_FBHP_235_Plant_Steam_Line_Trapping\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000PlantSteamLineTrappingPreference\" enumeration-picker-name=\"CSG_FBHP_300_Plant_Steam_Line_Trapping\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Plant steam line trapping'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750PlantSteamLineTrappingPreference\" enumeration-picker-name=\"CSG_FBHP_375_Plant_Steam_Line_Trapping\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700PlantSteamLineTrappingPreference\" enumeration-picker-name=\"CSG_FBHP_470_Plant_Steam_Line_Trapping\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000PlantSteamLineTrappingPreference\" enumeration-picker-name=\"CSG_FBHP_600_Plant_Steam_Line_Trapping\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--TDS control system-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'TDS control system'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300TDSControlSystemPreference\" enumeration-picker-name=\"CSG_FBHP_130_TDS_Control_System\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850TDSControlSystemPreference\" enumeration-picker-name=\"CSG_FBHP_185_TDS_Control_System\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350TDSControlSystemPreference\" enumeration-picker-name=\"CSG_FBHP_235_TDS_Control_System\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000TDSControlSystemPreference\" enumeration-picker-name=\"CSG_FBHP_300_TDS_Control_System\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'TDS control system'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750TDSControlSystemPreference\" enumeration-picker-name=\"CSG_FBHP_375_TDS_Control_System\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700TDSControlSystemPreference\" enumeration-picker-name=\"CSG_FBHP_470_TDS_Control_System\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000TDSControlSystemPreference\" enumeration-picker-name=\"CSG_FBHP_600_TDS_Control_System\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Sample Coolers-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Sample Coolers'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300SampleCoolerPreference\" enumeration-picker-name=\"CSG_FBHP_130_Sample_Cooler\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850SampleCoolerPreference\" enumeration-picker-name=\"CSG_FBHP_185_Sample_Cooler\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350SampleCoolerPreference\" enumeration-picker-name=\"CSG_FBHP_235_Sample_Cooler\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000SampleCoolerPreference\" enumeration-picker-name=\"CSG_FBHP_300_Sample_Cooler\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Sample Coolers'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750SampleCoolerPreference\" enumeration-picker-name=\"CSG_FBHP_375_Sample_Cooler\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700SampleCoolerPreference\" enumeration-picker-name=\"CSG_FBHP_470_Sample_Cooler\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000SampleCoolerPreference\" enumeration-picker-name=\"CSG_FBHP_600_Sample_Cooler\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Independent low level alarm-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Independent low level alarm'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300IndependentLowLevelAlarmPreference\" enumeration-picker-name=\"CSG_FBHP_130_Independent_Low_Level_Alarm\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850IndependentLowLevelAlarmPreference\" enumeration-picker-name=\"CSG_FBHP_185_Independent_Low_Level_Alarm\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350IndependentLowLevelAlarmPreference\" enumeration-picker-name=\"CSG_FBHP_235_Independent_Low_Level_Alarm\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000IndependentLowLevelAlarmPreference\" enumeration-picker-name=\"CSG_FBHP_300_Independent_Low_Level_Alarm\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Independent low level alarm'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750IndependentLowLevelAlarmPreference\" enumeration-picker-name=\"CSG_FBHP_375_Independent_Low_Level_Alarm\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700IndependentLowLevelAlarmPreference\" enumeration-picker-name=\"CSG_FBHP_470_Independent_Low_Level_Alarm\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000IndependentLowLevelAlarmPreference\" enumeration-picker-name=\"CSG_FBHP_600_Independent_Low_Level_Alarm\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Feedwater pre-heating / Degassing-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Feedwater pre-heating'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300FeedwaterPreHeatingDegassingPreference\" enumeration-picker-name=\"CSG_FBHP_130_Feedwater_Pre_Heating_Degassing\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850FeedwaterPreHeatingDegassingPreference\" enumeration-picker-name=\"CSG_FBHP_185_Feedwater_Pre_Heating_Degassing\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350FeedwaterPreHeatingDegassingPreference\" enumeration-picker-name=\"CSG_FBHP_235_Feedwater_Pre_Heating_Degassing\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000FeedwaterPreHeatingDegassingPreference\" enumeration-picker-name=\"CSG_FBHP_300_Feedwater_Pre_Heating_Degassing\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Feedwater pre-heating'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750FeedwaterPreHeatingDegassingPreference\" enumeration-picker-name=\"CSG_FBHP_375_Feedwater_Pre_Heating_Degassing\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700FeedwaterPreHeatingDegassingPreference\" enumeration-picker-name=\"CSG_FBHP_470_Feedwater_Pre_Heating_Degassing\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000FeedwaterPreHeatingDegassingPreference\" enumeration-picker-name=\"CSG_FBHP_600_Feedwater_Pre_Heating_Degassing\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Intelligent diagnostics-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Intelligent diagnostics'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300IntelligentDiagnosticsPreference\" enumeration-picker-name=\"CSG_FBHP_130_Intelligent_Diagnostics\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850IntelligentDiagnosticsPreference\" enumeration-picker-name=\"CSG_FBHP_185_Intelligent_Diagnostics\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350IntelligentDiagnosticsPreference\" enumeration-picker-name=\"CSG_FBHP_235_Intelligent_Diagnostics\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000IntelligentDiagnosticsPreference\" enumeration-picker-name=\"CSG_FBHP_300_Intelligent_Diagnostics\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Intelligent diagnostics'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750IntelligentDiagnosticsPreference\" enumeration-picker-name=\"CSG_FBHP_375_Intelligent_Diagnostics\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700IntelligentDiagnosticsPreference\" enumeration-picker-name=\"CSG_FBHP_470_Intelligent_Diagnostics\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000IntelligentDiagnosticsPreference\" enumeration-picker-name=\"CSG_FBHP_600_Intelligent_Diagnostics\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Clean steam outlet shut-off valve-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Clean steam outlet shut-off valve'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300CleanSteamOutletShutOffValvePreference\" enumeration-picker-name=\"CSG_FBHP_130_Clean_Steam_Outlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850CleanSteamOutletShutOffValvePreference\" enumeration-picker-name=\"CSG_FBHP_185_Clean_Steam_Outlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350CleanSteamOutletShutOffValvePreference\" enumeration-picker-name=\"CSG_FBHP_235_Clean_Steam_Outlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000CleanSteamOutletShutOffValvePreference\" enumeration-picker-name=\"CSG_FBHP_300_Clean_Steam_Outlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Clean steam outlet shut-off valve'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750CleanSteamOutletShutOffValvePreference\" enumeration-picker-name=\"CSG_FBHP_375_Clean_Steam_Outlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700CleanSteamOutletShutOffValvePreference\" enumeration-picker-name=\"CSG_FBHP_470_Clean_Steam_Outlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000CleanSteamOutletShutOffValvePreference\" enumeration-picker-name=\"CSG_FBHP_600_Clean_Steam_Outlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Test and certifications-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Test and certifications'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300TestAndCertificationPreference\" enumeration-picker-name=\"CSG_FBHP_130_Test_And_Certification\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850TestAndCertificationPreference\" enumeration-picker-name=\"CSG_FBHP_185_Test_And_Certification\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350TestAndCertificationPreference\" enumeration-picker-name=\"CSG_FBHP_235_Test_And_Certification\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000TestAndCertificationPreference\" enumeration-picker-name=\"CSG_FBHP_300_Test_And_Certification\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Test and certifications'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750TestAndCertificationPreference\" enumeration-picker-name=\"CSG_FBHP_375_Test_And_Certification\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700TestAndCertificationPreference\" enumeration-picker-name=\"CSG_FBHP_470_Test_And_Certification\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000TestAndCertificationPreference\" enumeration-picker-name=\"CSG_FBHP_600_Test_And_Certification\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Level_Indicator-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Level Indicator'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 130 {{CSG_FBHP_130_Price}}\">CSG-FBHP 130</h4><label>{{CSG_FBHP_130_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1300Level_IndicatorPreference\" enumeration-picker-name=\"CSG_FBHP_130_Level_Indicator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 185 {{CSG_FBHP_185_Price}}\">CSG-FBHP 185</h4><label>{{CSG_FBHP_185_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg1850Level_IndicatorPreference\" enumeration-picker-name=\"CSG_FBHP_185_Level_Indicator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 235 {{CSG_FBHP_235_Price}}\">CSG-FBHP 235</h4><label>{{CSG_FBHP_235_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg2350Level_IndicatorPreference\" enumeration-picker-name=\"CSG_FBHP_235_Level_Indicator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 300 {{CSG_FBHP_300_Price}}\">CSG-FBHP 300</h4><label>{{CSG_FBHP_300_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3000Level_IndicatorPreference\" enumeration-picker-name=\"CSG_FBHP_300_Level_Indicator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>\r\n            </div>\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Level Indicator'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 375 {{CSG_FBHP_375_Price}}\">CSG-FBHP 375</h4><label>{{CSG_FBHP_375_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg3750Level_IndicatorPreference\" enumeration-picker-name=\"CSG_FBHP_375_Level_Indicator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 470 {{CSG_FBHP_470_Price}}\">CSG-FBHP 470</h4><label>{{CSG_FBHP_470_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg4700Level_IndicatorPreference\" enumeration-picker-name=\"CSG_FBHP_470_Level_Indicator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-FBHP 600 {{CSG_FBHP_600_Price}}\">CSG-FBHP 600</h4><label>{{CSG_FBHP_600_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg6000Level_IndicatorPreference\" enumeration-picker-name=\"CSG_FBHP_600_Level_Indicator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <a #collapsePriceDataTop href=\"#collapsePriceDataTop\"> </a>\r\n    </div>\r\n\r\n    <!--Price Data Grid -->\r\n    <div *ngIf=\"!!csgBOMOutputData.bomItems && csgBOMOutputData.bomItems.length > 0 && showPrices\" class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"priceDataHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapsePriceData\" aria-expanded=\"true\" aria-controls=\"collapsePriceData\">\r\n            {{\"Price Data\"}} - {{'CLEAN_STEAM_GENERATOR_FB' | translate:true}} - Half Pipe {{operatingCompany}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <!-- Price Data Grid  -->\r\n      <div class=\"panel-body\">\r\n        <div class=\"col-xs-12\">\r\n\r\n          <ngx-datatable #csgBOMOutputDataTable\r\n                         class=\"bootstrap\"\r\n                         [headerHeight]=\"40\"\r\n                         [limit]=\"50\"\r\n                         [columnMode]=\"'force'\"\r\n                         [footerHeight]=\"40\"\r\n                         [rowHeight]=\"'auto'\"\r\n                         [rows]=\"csgBOMOutputData.bomItems\">\r\n\r\n            <!--[rowClass]=\"getRowClass\">-->\r\n            <!--  [selected]=\"selectedOutputData\"\r\n                 [selectionType]=\"'single'\"\r\n                 (select)=\"onSelect($event)\"\r\n            -->\r\n            <!-- Row Detail Template -->\r\n            <!--<ngx-datatable-row-detail [rowHeight]=\"getHeight\" #myDetailRow>\r\n              <ng-template let-row=\"row\" let-expanded=\"expanded\" ngx-datatable-row-detail-template>\r\n                <div *ngFor=\"let m of row.modelSizingMessages\">\r\n                  <div class=\"row col-xs-12\">\r\n                    <div class=\"col-xs-1 text-center\">\r\n                      <i [class]=\"getSeverityIcon(m.severity)\"></i>\r\n                    </div>\r\n                    <div class=\"col-xs-10\">\r\n                      <span>{{m.messageKey | translate}}</span>\r\n                      <span *ngIf=\"m.value !== 0 && m.unitKey\"> ({{m.value}} {{m.unitKey | translate:false}})</span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </ng-template>\r\n            </ngx-datatable-row-detail>-->\r\n            <!-- Column Template -->\r\n            <!--<ngx-datatable-column>\r\n              <ng-template let-row=\"row\" let-expanded=\"expanded\" ngx-datatable-cell-template>\r\n                <i [class]=\"getRowSeverityIcon(row)\"></i>\r\n              </ng-template>\r\n            </ngx-datatable-column>-->\r\n            <!--Columns-->\r\n            <ngx-datatable-column [name]=\"'Number'\" prop=\"rowOrder\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Type'\" prop=\"itemType\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'ModelId'\" prop=\"modelId\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Option Group'\" prop=\"parentMasterTextKey\" [width]=\"200\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"!!value && value.indexOf('CSG_')!==0\">{{value | translate}}</span>\r\n                <span *ngIf=\"!!value && value.indexOf('CSG_')==0\">{{value.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Option'\" prop=\"itemMasterTextKey\" [width]=\"200\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span [style.background]=\"!row.isEnabled ? 'Plum' : ' '\" *ngIf=\"!!value && value.indexOf('CSG_')!==0\">{{value | translate}}</span>\r\n                <span [style.background]=\"!row.isEnabled ? 'Plum' : ' '\" *ngIf=\"!!value && value.indexOf('CSG_')==0\">{{value.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'SSP'\" prop=\"ssp\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol==csgSellingCurrencySymbol\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol!==csgSellingCurrencySymbol || row.modelId==0\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{csgSellingCurrencySymbol}} {{localizeValue(row.sSSP,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'x'\" prop=\"ssPtoRSPfactor\" [width]=\"40\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"value!==0\">x {{value}} =</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'RSP'\" prop=\"recommendedSalesPrice\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol==csgSellingCurrencySymbol\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol!==csgSellingCurrencySymbol || row.modelId==0\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{csgSellingCurrencySymbol}} {{localizeValue(row.sRecommendedSalesPrice,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'RSP override'\" prop=\"recommendedSalesPriceOverride\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol==csgSellingCurrencySymbol\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol!==csgSellingCurrencySymbol || row.modelId==0\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{csgSellingCurrencySymbol}} {{localizeValue(row.sRecommendedSalesPriceOverride,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Display Price'\" prop=\"displayedRSP\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol==csgSellingCurrencySymbol\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol!==csgSellingCurrencySymbol || row.modelId==0\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{csgSellingCurrencySymbol}} {{localizeValue(row.sDisplayedRSP,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Model'\" prop=\"modelId\" [width]=\"30\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('CSG_')!==0\">{{value}}</span>\r\n                <span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('CSG_')==0\">{{value}} {{row.parentMasterTextKey.split('_')[1]}} {{row.parentMasterTextKey.split('_')[2]}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <!--Item Momenclature chop up  EN_E-->\r\n            <ngx-datatable-column [name]=\"'Nomenclature'\" prop=\"item\" [width]=\"50\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"!!value.split('_')[1]\">{{value.split('_')[1]}}</span>\r\n                <!--<span *ngIf=\"!value.split('_')[1]\">{{value}}</span>-->\r\n                <span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('CSG_')==0\">{{row.parentMasterTextKey.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Enabled'\" prop=\"isEnabled\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"value\">+</span>\r\n                <span *ngIf=\"!value\">-</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n          </ngx-datatable>\r\n\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n    <!--<div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        { {modulePreferencesForm.value | json}}\r\n      </div>\r\n    </div>-->\r\n    <!--<div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <button [disabled]=\"!modulePreferencesForm.dirty || !modulePreferencesForm.valid || modulePreferencesForm.status !== 'VALID' || formSubmitted\" type=\"submit\" class=\"btn btn-block btn-dynamic btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i></button>\r\n      </div>\r\n    </div>-->\r\n\r\n  </form>\r\n</div>\r\n",
                providers: [CleanSteamGeneratorFBService],
                styles: [".cross-validation-error-class{font-size:25px;color:#708090}"]
            }] }
];
/** @nocollapse */
CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.ctorParameters = () => [
    { type: RoutesService },
    { type: AdminService },
    { type: TranslationService },
    { type: FormBuilder },
    { type: TranslatePipe },
    { type: ModulePreferenceService },
    { type: CleanSteamGeneratorFBService },
    { type: LocaleService$1 },
    { type: UserProfileService }
];
CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.propDecorators = {
    csgBOMOutputDataTable: [{ type: ViewChild, args: ["csgBOMOutputDataTable", { static: false },] }],
    collapsePriceDataTop: [{ type: ViewChild, args: ['collapsePriceDataTop', { static: false },] }]
};
if (false) {
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.moduleId;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.moduleGroupId;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.cloneDeep;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.moduleName;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgBOMOutputDataTable;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.collapsePriceDataTop;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.componentLoadPromises;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.componentInitialised;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.theFormGroup;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.hasUnsavedDataChanges;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.isSuccess;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.alertVisible;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.formSubmitted;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgOptionsSelectedItem;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.manufacturerList;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.currencyList;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgManufacturerCurrencyId;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgManufacturerCurrency;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgManufacturerCurrencySymbol;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgSellingCurrencyId;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgSellingCurrencySymbol;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgCurrencyConversion;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgLandedCostIncrease;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgDeliveryCost;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgCommissionOnlyPrice;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgWarrantyOneYear;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgWarrantyTwoYears;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgWarrantyThreeYears;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.modulePreferencesForm;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgManufacturerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgManufacturerCurrencyPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgSellingCurrencyPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgLandedCostIncreasePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgDeliveryCostPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgCommissionOnlyPricePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgWarrantyOneYearPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgWarrantyTwoYearsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgWarrantyThreeYearsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgOptionsFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300DesignCodePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850DesignCodePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350DesignCodePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000DesignCodePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750DesignCodePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700DesignCodePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000DesignCodePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300ShellTypePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850ShellTypePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350ShellTypePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000ShellTypePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750ShellTypePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700ShellTypePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000ShellTypePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300ValveActuationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850ValveActuationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350ValveActuationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000ValveActuationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750ValveActuationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700ValveActuationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000ValveActuationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300FeedwaterPressurisationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850FeedwaterPressurisationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350FeedwaterPressurisationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000FeedwaterPressurisationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750FeedwaterPressurisationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700FeedwaterPressurisationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000FeedwaterPressurisationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300ControlPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850ControlPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350ControlPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000ControlPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750ControlPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700ControlPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000ControlPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300CommunicationInterfacePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850CommunicationInterfacePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350CommunicationInterfacePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000CommunicationInterfacePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750CommunicationInterfacePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700CommunicationInterfacePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000CommunicationInterfacePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300FrameAndCabinetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850FrameAndCabinetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350FrameAndCabinetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000FrameAndCabinetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750FrameAndCabinetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700FrameAndCabinetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000FrameAndCabinetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300ControlPanelLocationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850ControlPanelLocationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350ControlPanelLocationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000ControlPanelLocationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750ControlPanelLocationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700ControlPanelLocationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000ControlPanelLocationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300InsulationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850InsulationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350InsulationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000InsulationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750InsulationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700InsulationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000InsulationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300WheelsAndFeetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850WheelsAndFeetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350WheelsAndFeetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000WheelsAndFeetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750WheelsAndFeetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700WheelsAndFeetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000WheelsAndFeetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300PlantSteamInletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850PlantSteamInletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350PlantSteamInletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000PlantSteamInletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750PlantSteamInletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700PlantSteamInletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000PlantSteamInletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300PlantSteamLineTrappingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850PlantSteamLineTrappingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350PlantSteamLineTrappingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000PlantSteamLineTrappingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750PlantSteamLineTrappingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700PlantSteamLineTrappingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000PlantSteamLineTrappingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300TDSControlSystemPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850TDSControlSystemPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350TDSControlSystemPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000TDSControlSystemPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750TDSControlSystemPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700TDSControlSystemPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000TDSControlSystemPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300SampleCoolerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850SampleCoolerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350SampleCoolerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000SampleCoolerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750SampleCoolerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700SampleCoolerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000SampleCoolerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300IndependentLowLevelAlarmPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850IndependentLowLevelAlarmPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350IndependentLowLevelAlarmPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000IndependentLowLevelAlarmPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750IndependentLowLevelAlarmPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700IndependentLowLevelAlarmPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000IndependentLowLevelAlarmPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300FeedwaterPreHeatingDegassingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850FeedwaterPreHeatingDegassingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350FeedwaterPreHeatingDegassingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000FeedwaterPreHeatingDegassingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750FeedwaterPreHeatingDegassingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700FeedwaterPreHeatingDegassingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000FeedwaterPreHeatingDegassingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300IntelligentDiagnosticsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850IntelligentDiagnosticsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350IntelligentDiagnosticsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000IntelligentDiagnosticsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750IntelligentDiagnosticsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700IntelligentDiagnosticsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000IntelligentDiagnosticsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300CleanSteamOutletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850CleanSteamOutletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350CleanSteamOutletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000CleanSteamOutletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750CleanSteamOutletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700CleanSteamOutletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000CleanSteamOutletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300TestAndCertificationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850TestAndCertificationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350TestAndCertificationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000TestAndCertificationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750TestAndCertificationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700TestAndCertificationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000TestAndCertificationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1300Level_IndicatorPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg1850Level_IndicatorPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg2350Level_IndicatorPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3000Level_IndicatorPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg3750Level_IndicatorPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg4700Level_IndicatorPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csg6000Level_IndicatorPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.serviceOffereingMessage;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.deliveryCostMessage;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgPricing;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgBOMOutputData;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.csgBOMOutputDataRows;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.manufacturerId;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.CSG_FBHP_130_Price;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.CSG_FBHP_185_Price;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.CSG_FBHP_235_Price;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.CSG_FBHP_300_Price;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.CSG_FBHP_375_Price;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.CSG_FBHP_470_Price;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.CSG_FBHP_600_Price;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.showPrices;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.augmentPriceDataProcessing;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.user;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.operatingCompany;
    /** @type {?} */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.scrollToElement;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.routesService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.adminService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.translationService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.translatePipe;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.modulePreferenceService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.cleanSteamGeneratorService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.localeService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent.prototype.userProfileService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/cleansteamgenerator/modulePreference/cleanSteamGeneratorPricingOptions.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//import { Message } from '../../../core/messages/message.model';
//import { Message } from "sizing-shared-lib";
/*************************************
    MODULE PREFERENCES VERSION!
**************************************/
/**
 * The CleanSteamGeneratorPricing model.
 */
class CleanSteamGeneratorPricing {
}
if (false) {
    /**
     * Gets or sets the modelId.
     * @type {?}
     */
    CleanSteamGeneratorPricing.prototype.modelId;
    /**
     * Gets or sets the manufacturerId.
     * @type {?}
     */
    CleanSteamGeneratorPricing.prototype.manufacturerId;
    /**
     * Gets or sets the basePriceOption.
     * @type {?}
     */
    CleanSteamGeneratorPricing.prototype.basePriceOption;
    /**
     * Gets or sets the localRecommendedSalesPriceOption.
     * @type {?}
     */
    CleanSteamGeneratorPricing.prototype.localRecommendedSalesPriceOption;
    /**
     * Gets or sets the landedCostIncreaseFactor.
     * @type {?}
     */
    CleanSteamGeneratorPricing.prototype.landedCostIncreaseFactor;
    /**
     * Gets or sets the pricingOptions.
     * @type {?}
     */
    CleanSteamGeneratorPricing.prototype.pricingOptions;
}
class CSGPricingOption$1 {
}
if (false) {
    /**
     * Gets or sets the enumerationName.
     * @type {?}
     */
    CSGPricingOption$1.prototype.enumerationName;
    /**
     * Gets or sets the selectedValue.
     * @type {?}
     */
    CSGPricingOption$1.prototype.selectedValue;
}
class CleanSteamGeneratorPricingOutput {
}
if (false) {
    /**
     * Gets or sets the totalPrice.
     * @type {?}
     */
    CleanSteamGeneratorPricingOutput.prototype.totalSalesPrice;
    /**
     * Gets or sets the totalRecommendedSalesPrice.
     * @type {?}
     */
    CleanSteamGeneratorPricingOutput.prototype.totalRecommendedSalesPrice;
}
class CleanSteamGeneratorBOMPriceOutput {
}
if (false) {
    /**
     * Gets or sets the BOMItems.
     * @type {?}
     */
    CleanSteamGeneratorBOMPriceOutput.prototype.bomItems;
}
class BOMItem$1 {
    constructor() {
        /**
         * Gets or sets the isEnabled.
         */
        this.isEnabled = true;
    }
}
if (false) {
    /**
     * Gets or sets the rowOrder.
     * @type {?}
     */
    BOMItem$1.prototype.rowOrder;
    /**
     * Gets or sets the itemType.
     * @type {?}
     */
    BOMItem$1.prototype.itemType;
    /**
     * Gets or sets the modelId.
     * @type {?}
     */
    BOMItem$1.prototype.modelId;
    /**
     * Gets or sets the parent.
     * @type {?}
     */
    BOMItem$1.prototype.parent;
    /**
     * Gets or sets the parentMasterTextKey.
     * @type {?}
     */
    BOMItem$1.prototype.parentMasterTextKey;
    /**
     * Gets or sets the parentTranslation.
     * @type {?}
     */
    BOMItem$1.prototype.parentTranslation;
    /**
     * Gets or sets the item.
     * @type {?}
     */
    BOMItem$1.prototype.item;
    /**
     * Gets or sets the itemTranslation.
     * @type {?}
     */
    BOMItem$1.prototype.itemTranslation;
    /**
     * Gets or sets the itemMasterTextKey.
     * @type {?}
     */
    BOMItem$1.prototype.itemMasterTextKey;
    /**
     * Gets or sets the sequenceDefault.
     * @type {?}
     */
    BOMItem$1.prototype.sequenceDefault;
    /**
     * Gets or sets the sequenceOverride.
     * @type {?}
     */
    BOMItem$1.prototype.sequenceOverride;
    /**
     * Gets or sets the landedAdjusted.
     * @type {?}
     */
    BOMItem$1.prototype.landedAdjusted;
    /**
     * Gets or sets the ssp.
     * @type {?}
     */
    BOMItem$1.prototype.ssp;
    /**
     * Gets or sets the ssPtoRSPfactor.
     * @type {?}
     */
    BOMItem$1.prototype.ssPtoRSPfactor;
    /**
     * Gets or sets the recommendedSalesPrice.
     * @type {?}
     */
    BOMItem$1.prototype.recommendedSalesPrice;
    /**
     * Gets or sets the rsPtoRSPOfactor.
     * @type {?}
     */
    BOMItem$1.prototype.rsPtoRSPOfactor;
    /**
     * Gets or sets the recommendedSalesPriceOverride.
     * @type {?}
     */
    BOMItem$1.prototype.recommendedSalesPriceOverride;
    /**
     * Gets or sets the displayedRSP.
     * @type {?}
     */
    BOMItem$1.prototype.displayedRSP;
    /**
     * Gets or sets the manCurrency.
     * @type {?}
     */
    BOMItem$1.prototype.manCurrency;
    /**
     * Gets or sets the displayedRSP.
     * @type {?}
     */
    BOMItem$1.prototype.manRateToGBP;
    /**
     * Gets or sets the displayedRSP.
     * @type {?}
     */
    BOMItem$1.prototype.manCurrencyId;
    /**
     * Gets or sets the priceDataUTCDate.
     * @type {?}
     */
    BOMItem$1.prototype.priceDataUTCDate;
    /**
     * Gets or sets the sLandedAdjusted.
     * @type {?}
     */
    BOMItem$1.prototype.sLandedAdjusted;
    /**
     * Gets or sets the sSSP.
     * @type {?}
     */
    BOMItem$1.prototype.sSSP;
    /**
     * Gets or sets the sRecommendedSalesPrice.
     * @type {?}
     */
    BOMItem$1.prototype.sRecommendedSalesPrice;
    /**
     * Gets or sets the sRecommendedSalesPriceOverride.
     * @type {?}
     */
    BOMItem$1.prototype.sRecommendedSalesPriceOverride;
    /**
     * Gets or sets the sDisplayedRSP.
     * @type {?}
     */
    BOMItem$1.prototype.sDisplayedRSP;
    /**
     * Gets or sets the sellingCurrency.
     * @type {?}
     */
    BOMItem$1.prototype.sellingCurrency;
    /**
     * Gets or sets the sellingRateToGBP.
     * @type {?}
     */
    BOMItem$1.prototype.sellingRateToGBP;
    /**
     * Gets or sets the sellingCurrencyId.
     * @type {?}
     */
    BOMItem$1.prototype.sellingCurrencyId;
    /**
     * Gets or sets the isEnabled.
     * @type {?}
     */
    BOMItem$1.prototype.isEnabled;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/cleansteamgenerator/modulePreference/cleanSteamGenerator.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * **********************************
 * MODULE PREFERENCES VERSION!
 * ************************************
 */
class CleanSteamGeneratorService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} csgPricing
     * @return {?}
     */
    calculateBOMPrice(csgPricing) {
        return this.http.post(`./Api/CSG/CalculateBOMPrice`, csgPricing);
    }
}
CleanSteamGeneratorService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
CleanSteamGeneratorService.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/cleansteamgenerator/modulePreference/cleanSteamGenerator.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CleanSteamGeneratorModulePreferencesComponent {
    /**
     * @param {?} routesService
     * @param {?} adminService
     * @param {?} translationService
     * @param {?} fb
     * @param {?} translatePipe
     * @param {?} modulePreferenceService
     * @param {?} cleanSteamGeneratorService
     * @param {?} localeService
     * @param {?} userProfileService
     */
    constructor(routesService, adminService, translationService, fb, translatePipe, modulePreferenceService, cleanSteamGeneratorService, localeService, userProfileService) {
        this.routesService = routesService;
        this.adminService = adminService;
        this.translationService = translationService;
        this.fb = fb;
        this.translatePipe = translatePipe;
        this.modulePreferenceService = modulePreferenceService;
        this.cleanSteamGeneratorService = cleanSteamGeneratorService;
        this.localeService = localeService;
        this.userProfileService = userProfileService;
        this.moduleId = "8";
        this.moduleGroupId = 12;
        this.cloneDeep = cloneDeep_;
        this.moduleName = "Clean Steam Generator";
        // for scroll to view
        this.componentInitialised = false;
        this.componentLoadPromises = [];
        // to drive GenericChangesGuard
        this.isSuccess = false;
        this.alertVisible = false;
        this.formSubmitted = false;
        //*** Regular module prefs ***
        // Currency Options
        this.manufacturerList = [];
        this.currencyList = [];
        this.csgBOMOutputDataRows = [];
        this.showPrices = false;
        this.augmentPriceDataProcessing = true; // disable button whilst page loading
        this.scrollToElement = (/**
         * @param {?} elementRef
         * @param {?=} position
         * @return {?}
         */
        (elementRef, position = "start") => {
            // ToDo: Fix fussy scroll on first sizing bug. Hence the use of timeout delay here.
            setTimeout((/**
             * @return {?}
             */
            () => {
                try {
                    elementRef.nativeElement.scrollIntoView({ block: position, behavior: "smooth" });
                }
                catch (err) {
                    console.log(`scrollToElement err=${err}`);
                }
            }), 200);
        });
        this.userProfileService.getUserDetails().subscribe((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            this.user = user;
            if (!!this.user) {
                this.operatingCompany = " : " + this.user.operatingCompanyName;
            }
        }));
        this.csgBOMOutputData = new CleanSteamGeneratorBOMPriceOutput();
        this.csgManufacturerPrefFormControl = new FormControl({ value: '', disabled: true });
        this.csgManufacturerCurrencyPrefFormControl = new FormControl({ value: '', disabled: true });
        this.csgSellingCurrencyPrefFormControl = new FormControl('');
        this.csgLandedCostIncreasePrefFormControl = new FormControl('', [Validators.required, CustomValidators.range([-100, 100])]);
        this.csgDeliveryCostPrefFormControl = new FormControl('', [Validators.required]);
        this.csgCommissionOnlyPricePrefFormControl = new FormControl('', [Validators.required]);
        this.csgWarrantyOneYearPrefFormControl = new FormControl('', [Validators.required]);
        this.csgWarrantyTwoYearsPrefFormControl = new FormControl('', [Validators.required]);
        this.csgWarrantyThreeYearsPrefFormControl = new FormControl('', [Validators.required]);
        this.csgOptionsFormControl = new FormControl('');
        // Design Code
        this.csg020DesignCodePrefFormControl = new FormControl(null);
        this.csg055DesignCodePrefFormControl = new FormControl(null);
        this.csg125DesignCodePrefFormControl = new FormControl(null);
        this.csg180DesignCodePrefFormControl = new FormControl(null);
        // Shell Type
        this.csg020ShellTypePrefFormControl = new FormControl(null);
        this.csg055ShellTypePrefFormControl = new FormControl(null);
        this.csg125ShellTypePrefFormControl = new FormControl(null);
        this.csg180ShellTypePrefFormControl = new FormControl(null);
        // Control Valve Actuation
        this.csg020ValveActuationPrefFormControl = new FormControl(null);
        this.csg055ValveActuationPrefFormControl = new FormControl(null);
        this.csg125ValveActuationPrefFormControl = new FormControl(null);
        this.csg180ValveActuationPrefFormControl = new FormControl(null);
        // FeedwaterPressurisation
        this.csg020FeedwaterPressurisationPrefFormControl = new FormControl(null);
        this.csg055FeedwaterPressurisationPrefFormControl = new FormControl(null);
        this.csg125FeedwaterPressurisationPrefFormControl = new FormControl(null);
        this.csg180FeedwaterPressurisationPrefFormControl = new FormControl(null);
        // Control
        this.csg020ControlPrefFormControl = new FormControl(null);
        this.csg055ControlPrefFormControl = new FormControl(null);
        this.csg125ControlPrefFormControl = new FormControl(null);
        this.csg180ControlPrefFormControl = new FormControl(null);
        // Communication Interface
        this.csg020CommunicationInterfacePrefFormControl = new FormControl(null);
        this.csg055CommunicationInterfacePrefFormControl = new FormControl(null);
        this.csg125CommunicationInterfacePrefFormControl = new FormControl(null);
        this.csg180CommunicationInterfacePrefFormControl = new FormControl(null);
        // Frame and Cabinet
        this.csg020FrameAndCabinetPrefFormControl = new FormControl(null);
        this.csg055FrameAndCabinetPrefFormControl = new FormControl(null);
        this.csg125FrameAndCabinetPrefFormControl = new FormControl(null);
        this.csg180FrameAndCabinetPrefFormControl = new FormControl(null);
        // Control Panel Location
        this.csg020ControlPanelLocationPrefFormControl = new FormControl(null);
        this.csg055ControlPanelLocationPrefFormControl = new FormControl(null);
        this.csg125ControlPanelLocationPrefFormControl = new FormControl(null);
        this.csg180ControlPanelLocationPrefFormControl = new FormControl(null);
        // Insulation
        this.csg020InsulationPrefFormControl = new FormControl(null);
        this.csg055InsulationPrefFormControl = new FormControl(null);
        this.csg125InsulationPrefFormControl = new FormControl(null);
        this.csg180InsulationPrefFormControl = new FormControl(null);
        // Wheels And Feet
        this.csg020WheelsAndFeetPrefFormControl = new FormControl(null);
        this.csg055WheelsAndFeetPrefFormControl = new FormControl(null);
        this.csg125WheelsAndFeetPrefFormControl = new FormControl(null);
        this.csg180WheelsAndFeetPrefFormControl = new FormControl(null);
        // Plant Steam Inlet Shut Off Valve
        this.csg020PlantSteamInletShutOffValvePrefFormControl = new FormControl(null);
        this.csg055PlantSteamInletShutOffValvePrefFormControl = new FormControl(null);
        this.csg125PlantSteamInletShutOffValvePrefFormControl = new FormControl(null);
        this.csg180PlantSteamInletShutOffValvePrefFormControl = new FormControl(null);
        // Plant Steam Line Trapping
        this.csg020PlantSteamLineTrappingPrefFormControl = new FormControl(null);
        this.csg055PlantSteamLineTrappingPrefFormControl = new FormControl(null);
        this.csg125PlantSteamLineTrappingPrefFormControl = new FormControl(null);
        this.csg180PlantSteamLineTrappingPrefFormControl = new FormControl(null);
        // TDS control system
        this.csg020TDSControlSystemPrefFormControl = new FormControl(null);
        this.csg055TDSControlSystemPrefFormControl = new FormControl(null);
        this.csg125TDSControlSystemPrefFormControl = new FormControl(null);
        this.csg180TDSControlSystemPrefFormControl = new FormControl(null);
        // Sample Coolers
        this.csg020SampleCoolerPrefFormControl = new FormControl(null);
        this.csg055SampleCoolerPrefFormControl = new FormControl(null);
        this.csg125SampleCoolerPrefFormControl = new FormControl(null);
        this.csg180SampleCoolerPrefFormControl = new FormControl(null);
        // Independent low level alarm
        this.csg020IndependentLowLevelAlarmPrefFormControl = new FormControl(null);
        this.csg055IndependentLowLevelAlarmPrefFormControl = new FormControl(null);
        this.csg125IndependentLowLevelAlarmPrefFormControl = new FormControl(null);
        this.csg180IndependentLowLevelAlarmPrefFormControl = new FormControl(null);
        // Feedwater pre-heating / Degassing
        this.csg020FeedwaterPreHeatingDegassingPrefFormControl = new FormControl(null);
        this.csg055FeedwaterPreHeatingDegassingPrefFormControl = new FormControl(null);
        this.csg125FeedwaterPreHeatingDegassingPrefFormControl = new FormControl(null);
        this.csg180FeedwaterPreHeatingDegassingPrefFormControl = new FormControl(null);
        // Intelligent diagnostics
        this.csg020IntelligentDiagnosticsPrefFormControl = new FormControl(null);
        this.csg055IntelligentDiagnosticsPrefFormControl = new FormControl(null);
        this.csg125IntelligentDiagnosticsPrefFormControl = new FormControl(null);
        this.csg180IntelligentDiagnosticsPrefFormControl = new FormControl(null);
        // Clean steam outlet shut-off valve
        this.csg020CleanSteamOutletShutOffValvePrefFormControl = new FormControl(null);
        this.csg055CleanSteamOutletShutOffValvePrefFormControl = new FormControl(null);
        this.csg125CleanSteamOutletShutOffValvePrefFormControl = new FormControl(null);
        this.csg180CleanSteamOutletShutOffValvePrefFormControl = new FormControl(null);
        // Test and certifications
        this.csg020TestAndCertificationPrefFormControl = new FormControl(null);
        this.csg055TestAndCertificationPrefFormControl = new FormControl(null);
        this.csg125TestAndCertificationPrefFormControl = new FormControl(null);
        this.csg180TestAndCertificationPrefFormControl = new FormControl(null);
        // Level_Indicator
        this.csg020Level_IndicatorPrefFormControl = new FormControl(null);
        this.csg055Level_IndicatorPrefFormControl = new FormControl(null);
        this.csg125Level_IndicatorPrefFormControl = new FormControl(null);
        this.csg180Level_IndicatorPrefFormControl = new FormControl(null);
        // Setup the form group.
        this.modulePreferencesForm = this.fb.group({
            // Currency Options
            csgManufacturerModulePreference: this.csgManufacturerPrefFormControl,
            csgManufacturerCurrencyModulePreference: this.csgManufacturerCurrencyPrefFormControl,
            csgSellingCurrencyModulePreference: this.csgSellingCurrencyPrefFormControl,
            // Pricing Options
            csgLandedCostIncreaseModulePreference: this.csgLandedCostIncreasePrefFormControl,
            csgDeliveryCostModulePreference: this.csgDeliveryCostPrefFormControl,
            csgCommissionOnlyPriceModulePreference: this.csgCommissionOnlyPricePrefFormControl,
            csgWarrantyOneYearModulePreference: this.csgWarrantyOneYearPrefFormControl,
            csgWarrantyTwoYearsModulePreference: this.csgWarrantyTwoYearsPrefFormControl,
            csgWarrantyThreeYearsModulePreference: this.csgWarrantyThreeYearsPrefFormControl,
            // Option Configuration
            csgOptionsSelection: this.csgOptionsFormControl,
            // Design Code
            csg020DesignCodePreference: this.csg020DesignCodePrefFormControl,
            csg055DesignCodePreference: this.csg055DesignCodePrefFormControl,
            csg125DesignCodePreference: this.csg125DesignCodePrefFormControl,
            csg180DesignCodePreference: this.csg180DesignCodePrefFormControl,
            // Shell Type
            csg020ShellTypePreference: this.csg020ShellTypePrefFormControl,
            csg055ShellTypePreference: this.csg055ShellTypePrefFormControl,
            csg125ShellTypePreference: this.csg125ShellTypePrefFormControl,
            csg180ShellTypePreference: this.csg180ShellTypePrefFormControl,
            // Control Valve Actuation
            csg020ValveActuationPreference: this.csg020ValveActuationPrefFormControl,
            csg055ValveActuationPreference: this.csg055ValveActuationPrefFormControl,
            csg125ValveActuationPreference: this.csg125ValveActuationPrefFormControl,
            csg180ValveActuationPreference: this.csg180ValveActuationPrefFormControl,
            // FeedwaterPressurisation
            csg020FeedwaterPressurisationPreference: this.csg020FeedwaterPressurisationPrefFormControl,
            csg055FeedwaterPressurisationPreference: this.csg055FeedwaterPressurisationPrefFormControl,
            csg125FeedwaterPressurisationPreference: this.csg125FeedwaterPressurisationPrefFormControl,
            csg180FeedwaterPressurisationPreference: this.csg180FeedwaterPressurisationPrefFormControl,
            // Control
            csg020ControlPreference: this.csg020ControlPrefFormControl,
            csg055ControlPreference: this.csg055ControlPrefFormControl,
            csg125ControlPreference: this.csg125ControlPrefFormControl,
            csg180ControlPreference: this.csg180ControlPrefFormControl,
            // Communication Interface
            csg020CommunicationInterfacePreference: this.csg020CommunicationInterfacePrefFormControl,
            csg055CommunicationInterfacePreference: this.csg055CommunicationInterfacePrefFormControl,
            csg125CommunicationInterfacePreference: this.csg125CommunicationInterfacePrefFormControl,
            csg180CommunicationInterfacePreference: this.csg180CommunicationInterfacePrefFormControl,
            // Frame and Cabinet
            csg020FrameAndCabinetPreference: this.csg020FrameAndCabinetPrefFormControl,
            csg055FrameAndCabinetPreference: this.csg055FrameAndCabinetPrefFormControl,
            csg125FrameAndCabinetPreference: this.csg125FrameAndCabinetPrefFormControl,
            csg180FrameAndCabinetPreference: this.csg180FrameAndCabinetPrefFormControl,
            // Control Panel Location
            csg020ControlPanelLocationPreference: this.csg020ControlPanelLocationPrefFormControl,
            csg055ControlPanelLocationPreference: this.csg055ControlPanelLocationPrefFormControl,
            csg125ControlPanelLocationPreference: this.csg125ControlPanelLocationPrefFormControl,
            csg180ControlPanelLocationPreference: this.csg180ControlPanelLocationPrefFormControl,
            // Insulation
            csg020InsulationPreference: this.csg020InsulationPrefFormControl,
            csg055InsulationPreference: this.csg055InsulationPrefFormControl,
            csg125InsulationPreference: this.csg125InsulationPrefFormControl,
            csg180InsulationPreference: this.csg180InsulationPrefFormControl,
            // Wheels And Feet
            csg020WheelsAndFeetPreference: this.csg020WheelsAndFeetPrefFormControl,
            csg055WheelsAndFeetPreference: this.csg055WheelsAndFeetPrefFormControl,
            csg125WheelsAndFeetPreference: this.csg125WheelsAndFeetPrefFormControl,
            csg180WheelsAndFeetPreference: this.csg180WheelsAndFeetPrefFormControl,
            // Plant Steam Inlet Shut Off Valve
            csg020PlantSteamInletShutOffValvePreference: this.csg020PlantSteamInletShutOffValvePrefFormControl,
            csg055PlantSteamInletShutOffValvePreference: this.csg055PlantSteamInletShutOffValvePrefFormControl,
            csg125PlantSteamInletShutOffValvePreference: this.csg125PlantSteamInletShutOffValvePrefFormControl,
            csg180PlantSteamInletShutOffValvePreference: this.csg180PlantSteamInletShutOffValvePrefFormControl,
            // Plant Steam Line Trapping
            csg020PlantSteamLineTrappingPreference: this.csg020PlantSteamLineTrappingPrefFormControl,
            csg055PlantSteamLineTrappingPreference: this.csg055PlantSteamLineTrappingPrefFormControl,
            csg125PlantSteamLineTrappingPreference: this.csg125PlantSteamLineTrappingPrefFormControl,
            csg180PlantSteamLineTrappingPreference: this.csg180PlantSteamLineTrappingPrefFormControl,
            // TDS control system
            csg020TDSControlSystemPreference: this.csg020TDSControlSystemPrefFormControl,
            csg055TDSControlSystemPreference: this.csg055TDSControlSystemPrefFormControl,
            csg125TDSControlSystemPreference: this.csg125TDSControlSystemPrefFormControl,
            csg180TDSControlSystemPreference: this.csg180TDSControlSystemPrefFormControl,
            // Sample Coolers
            csg020SampleCoolerPreference: this.csg020SampleCoolerPrefFormControl,
            csg055SampleCoolerPreference: this.csg055SampleCoolerPrefFormControl,
            csg125SampleCoolerPreference: this.csg125SampleCoolerPrefFormControl,
            csg180SampleCoolerPreference: this.csg180SampleCoolerPrefFormControl,
            // Independent low level alarm
            csg020IndependentLowLevelAlarmPreference: this.csg020IndependentLowLevelAlarmPrefFormControl,
            csg055IndependentLowLevelAlarmPreference: this.csg055IndependentLowLevelAlarmPrefFormControl,
            csg125IndependentLowLevelAlarmPreference: this.csg125IndependentLowLevelAlarmPrefFormControl,
            csg180IndependentLowLevelAlarmPreference: this.csg180IndependentLowLevelAlarmPrefFormControl,
            // Feedwater pre-heating / Degassing
            csg020FeedwaterPreHeatingDegassingPreference: this.csg020FeedwaterPreHeatingDegassingPrefFormControl,
            csg055FeedwaterPreHeatingDegassingPreference: this.csg055FeedwaterPreHeatingDegassingPrefFormControl,
            csg125FeedwaterPreHeatingDegassingPreference: this.csg125FeedwaterPreHeatingDegassingPrefFormControl,
            csg180FeedwaterPreHeatingDegassingPreference: this.csg180FeedwaterPreHeatingDegassingPrefFormControl,
            // Intelligent diagnostics
            csg020IntelligentDiagnosticsPreference: this.csg020IntelligentDiagnosticsPrefFormControl,
            csg055IntelligentDiagnosticsPreference: this.csg055IntelligentDiagnosticsPrefFormControl,
            csg125IntelligentDiagnosticsPreference: this.csg125IntelligentDiagnosticsPrefFormControl,
            csg180IntelligentDiagnosticsPreference: this.csg180IntelligentDiagnosticsPrefFormControl,
            // Clean steam outlet shut-off valve
            csg020CleanSteamOutletShutOffValvePreference: this.csg020CleanSteamOutletShutOffValvePrefFormControl,
            csg055CleanSteamOutletShutOffValvePreference: this.csg055CleanSteamOutletShutOffValvePrefFormControl,
            csg125CleanSteamOutletShutOffValvePreference: this.csg125CleanSteamOutletShutOffValvePrefFormControl,
            csg180CleanSteamOutletShutOffValvePreference: this.csg180CleanSteamOutletShutOffValvePrefFormControl,
            // Test and certifications
            csg020TestAndCertificationPreference: this.csg020TestAndCertificationPrefFormControl,
            csg055TestAndCertificationPreference: this.csg055TestAndCertificationPrefFormControl,
            csg125TestAndCertificationPreference: this.csg125TestAndCertificationPrefFormControl,
            csg180TestAndCertificationPreference: this.csg180TestAndCertificationPrefFormControl,
            // Level_Indicator
            csg020Level_IndicatorPreference: this.csg020Level_IndicatorPrefFormControl,
            csg055Level_IndicatorPreference: this.csg055Level_IndicatorPrefFormControl,
            csg125Level_IndicatorPreference: this.csg125Level_IndicatorPrefFormControl,
            csg180Level_IndicatorPreference: this.csg180Level_IndicatorPrefFormControl,
        }, { updateOn: "blur" });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        console.log("Starting Initializing CSG HC module prefs component");
        // When Angular looks at a guard decision, page navigation has already occurred.
        //// Reset the page load progress
        //this.routesService.pageLoadProgress = 0;
        //this.routesService.pageLoading = true;
        //this.routesService.startPageLoadProgress();
        // First, get all the module preferences.
        this.componentLoadPromises.push(this.modulePreferenceService.getOperatingCompanyModulePreferences(this.moduleId).toPromise().then((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            if (result && result.length > 0) {
                // And set their values accordingly.
                this.manufacturerId = +this.getModulePreferenceValue(result, "CSGManufacturer");
                this.csgManufacturerPrefFormControl.setValue(this.manufacturerId);
                this.csgManufacturerCurrencyId = +this.getModulePreferenceValue(result, "CSGManufacturerCurrency");
                this.csgManufacturerCurrencyPrefFormControl.setValue(this.csgManufacturerCurrencyId);
                this.csgSellingCurrencyId = this.getModulePreferenceValue(result, "CSGSellingCurrency");
                this.csgSellingCurrencyPrefFormControl.setValue(this.csgSellingCurrencyId);
                // Calculate the currency conversion rate.
                this.onSellingCurrencyChange(this.csgSellingCurrencyId);
                this.csgLandedCostIncrease = this.getModulePreferenceValue(result, "CSGLandCostIncrease");
                this.csgLandedCostIncreasePrefFormControl.setValue(this.csgLandedCostIncrease);
                this.csgDeliveryCostPrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGDeliveryCost"));
                this.csgCommissionOnlyPricePrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGCommission"));
                this.csgWarrantyOneYearPrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGYearOne"));
                this.csgWarrantyTwoYearsPrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGYearTwo"));
                this.csgWarrantyThreeYearsPrefFormControl.setValue(this.getModulePreferenceValue(result, "CSGYearThree"));
                // Get the currency data.
            }
            this.componentLoadPromises.push(this.adminService.getCurrencyData().toPromise().then((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                this.currencyList = data;
                // Selling currency found, so try to calculate the currency conversion rate.
                this.onSellingCurrencyChange(this.csgSellingCurrencyId);
                this.augmentPriceDataProcessing = false; // loaded enable toggle prices button
            })));
        })));
        // Get the list of manufacturers.
        this.componentLoadPromises.push(this.adminService.getManufacturerData(this.moduleGroupId).toPromise().then((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            // Update the subject with the data that's just been retrieved (see the constructor).
            this.manufacturerList = result;
        })));
        // Now, set the "OpCo Selected Options" for the different CSG options.
        // Design Code
        this.setOpCoPreferences("CSG_HS_020_Design_Code", this.csg020DesignCodePrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Design_Code", this.csg055DesignCodePrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Design_Code", this.csg125DesignCodePrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Design_Code", this.csg180DesignCodePrefFormControl);
        // Shell Type
        this.setOpCoPreferences("CSG_HS_020_Shell_Type", this.csg020ShellTypePrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Shell_Type", this.csg055ShellTypePrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Shell_Type", this.csg125ShellTypePrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Shell_Type", this.csg180ShellTypePrefFormControl);
        // Control Valve Actuation
        this.setOpCoPreferences("CSG_HS_020_Valve_Actuation", this.csg020ValveActuationPrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Valve_Actuation", this.csg055ValveActuationPrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Valve_Actuation", this.csg125ValveActuationPrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Valve_Actuation", this.csg180ValveActuationPrefFormControl);
        // FeedwaterPressurisation
        this.setOpCoPreferences("CSG_HS_020_Feedwater_Pressurisation", this.csg020FeedwaterPressurisationPrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Feedwater_Pressurisation", this.csg055FeedwaterPressurisationPrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Feedwater_Pressurisation", this.csg125FeedwaterPressurisationPrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Feedwater_Pressurisation", this.csg180FeedwaterPressurisationPrefFormControl);
        // Control
        this.setOpCoPreferences("CSG_HS_020_Control", this.csg020ControlPrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Control", this.csg055ControlPrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Control", this.csg125ControlPrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Control", this.csg180ControlPrefFormControl);
        // Communication Interface
        this.setOpCoPreferences("CSG_HS_020_Communication_Interface", this.csg020CommunicationInterfacePrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Communication_Interface", this.csg055CommunicationInterfacePrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Communication_Interface", this.csg125CommunicationInterfacePrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Communication_Interface", this.csg180CommunicationInterfacePrefFormControl);
        // Frame and Cabinet
        this.setOpCoPreferences("CSG_HS_020_Frame_And_Cabinet", this.csg020FrameAndCabinetPrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Frame_And_Cabinet", this.csg055FrameAndCabinetPrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Frame_And_Cabinet", this.csg125FrameAndCabinetPrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Frame_And_Cabinet", this.csg180FrameAndCabinetPrefFormControl);
        // Control Panel Location
        this.setOpCoPreferences("CSG_HS_020_Control_Panel_Location", this.csg020ControlPanelLocationPrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Control_Panel_Location", this.csg055ControlPanelLocationPrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Control_Panel_Location", this.csg125ControlPanelLocationPrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Control_Panel_Location", this.csg180ControlPanelLocationPrefFormControl);
        // Insulation
        this.setOpCoPreferences("CSG_HS_020_Insulation", this.csg020InsulationPrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Insulation", this.csg055InsulationPrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Insulation", this.csg125InsulationPrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Insulation", this.csg180InsulationPrefFormControl);
        // Wheels And Feet
        this.setOpCoPreferences("CSG_HS_020_Wheels_And_Feet", this.csg020WheelsAndFeetPrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Wheels_And_Feet", this.csg055WheelsAndFeetPrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Wheels_And_Feet", this.csg125WheelsAndFeetPrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Wheels_And_Feet", this.csg180WheelsAndFeetPrefFormControl);
        // Plant Steam Inlet Shut Off Valve
        this.setOpCoPreferences("CSG_HS_020_Plant_Steam_Inlet_Shut_Off_Valve", this.csg020PlantSteamInletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Plant_Steam_Inlet_Shut_Off_Valve", this.csg055PlantSteamInletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Plant_Steam_Inlet_Shut_Off_Valve", this.csg125PlantSteamInletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Plant_Steam_Inlet_Shut_Off_Valve", this.csg180PlantSteamInletShutOffValvePrefFormControl);
        // Plant steam line trapping
        this.setOpCoPreferences("CSG_HS_020_Plant_Steam_Line_Trapping", this.csg020PlantSteamLineTrappingPrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Plant_Steam_Line_Trapping", this.csg055PlantSteamLineTrappingPrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Plant_Steam_Line_Trapping", this.csg125PlantSteamLineTrappingPrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Plant_Steam_Line_Trapping", this.csg180PlantSteamLineTrappingPrefFormControl);
        // TDS control system
        this.setOpCoPreferences("CSG_HS_020_TDS_Control_System", this.csg020TDSControlSystemPrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_TDS_Control_System", this.csg055TDSControlSystemPrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_TDS_Control_System", this.csg125TDSControlSystemPrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_TDS_Control_System", this.csg180TDSControlSystemPrefFormControl);
        // Sample Coolers
        this.setOpCoPreferences("CSG_HS_020_Sample_Cooler", this.csg020SampleCoolerPrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Sample_Cooler", this.csg055SampleCoolerPrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Sample_Cooler", this.csg125SampleCoolerPrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Sample_Cooler", this.csg180SampleCoolerPrefFormControl);
        // Independent low level alarm
        this.setOpCoPreferences("CSG_HS_020_Independent_Low_Level_Alarm", this.csg020IndependentLowLevelAlarmPrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Independent_Low_Level_Alarm", this.csg055IndependentLowLevelAlarmPrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Independent_Low_Level_Alarm", this.csg125IndependentLowLevelAlarmPrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Independent_Low_Level_Alarm", this.csg180IndependentLowLevelAlarmPrefFormControl);
        // Feedwater pre-heating / Degassing
        this.setOpCoPreferences("CSG_HS_020_Feedwater_Pre_Heating_Degassing", this.csg020FeedwaterPreHeatingDegassingPrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Feedwater_Pre_Heating_Degassing", this.csg055FeedwaterPreHeatingDegassingPrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Feedwater_Pre_Heating_Degassing", this.csg125FeedwaterPreHeatingDegassingPrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Feedwater_Pre_Heating_Degassing", this.csg180FeedwaterPreHeatingDegassingPrefFormControl);
        // Intelligent diagnostics
        this.setOpCoPreferences("CSG_HS_020_Intelligent_Diagnostics", this.csg020IntelligentDiagnosticsPrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Intelligent_Diagnostics", this.csg055IntelligentDiagnosticsPrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Intelligent_Diagnostics", this.csg125IntelligentDiagnosticsPrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Intelligent_Diagnostics", this.csg180IntelligentDiagnosticsPrefFormControl);
        // Clean steam outlet shut-off valve
        this.setOpCoPreferences("CSG_HS_020_Clean_Steam_Outlet_Shut_Off_Valve", this.csg020CleanSteamOutletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Clean_Steam_Outlet_Shut_Off_Valve", this.csg055CleanSteamOutletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Clean_Steam_Outlet_Shut_Off_Valve", this.csg125CleanSteamOutletShutOffValvePrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Clean_Steam_Outlet_Shut_Off_Valve", this.csg180CleanSteamOutletShutOffValvePrefFormControl);
        // Test and certifications
        this.setOpCoPreferences("CSG_HS_020_Test_And_Certification", this.csg020TestAndCertificationPrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Test_And_Certification", this.csg055TestAndCertificationPrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Test_And_Certification", this.csg125TestAndCertificationPrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Test_And_Certification", this.csg180TestAndCertificationPrefFormControl);
        // Level_Indicator
        this.setOpCoPreferences("CSG_HS_020_Level_Indicator", this.csg020Level_IndicatorPrefFormControl);
        this.setOpCoPreferences("CSG_HS_055_Level_Indicator", this.csg055Level_IndicatorPrefFormControl);
        this.setOpCoPreferences("CSG_HS_125_Level_Indicator", this.csg125Level_IndicatorPrefFormControl);
        this.setOpCoPreferences("CSG_HS_180_Level_Indicator", this.csg180Level_IndicatorPrefFormControl);
        this.csgOptionsSelectedItem = "Design Code";
        this.theFormGroup = this.modulePreferencesForm; // to drive GenericChangesGuard
        // Info ToolTip message translations
        this.serviceOffereingMessage = this.translatePipe.transform('SERVICE_OFFERING_MESSAGE', false);
        this.deliveryCostMessage = this.translatePipe.transform('DELIVERY_COST_MESSAGE', false);
        console.log("Finishing Initializing CSG HC module prefs component");
        Promise.all(this.componentLoadPromises).then((/**
         * @return {?}
         */
        () => {
            console.log("Initialization promises complete for CSG HC Component");
            this.componentInitialised = true;
        }));
    }
    /**
     * @return {?}
     */
    togglePrices() {
        this.showPrices = !this.showPrices;
        this.augmentPriceDataProcessing = true;
        this.augmentPricesToOptionsLists(this.showPrices);
    }
    /**
     * @param {?=} showPrices
     * @return {?}
     */
    augmentPricesToOptionsLists(showPrices = true) {
        this.csgPricing = new CleanSteamGeneratorPricing();
        this.csgPricing.modelId = -1; // All BOM items    
        this.csgPricing.pricingOptions = [];
        this.csgPricing.basePriceOption = -1;
        this.csgPricing.localRecommendedSalesPriceOption = -1;
        this.csgPricing.landedCostIncreaseFactor = -1;
        this.csgSellingCurrencySymbol = !!this.csgSellingCurrencySymbol ? this.csgSellingCurrencySymbol : "?";
        this.csgPricing.manufacturerId = +(!!this.manufacturerId ? this.manufacturerId : -1);
        this.csgManufacturerCurrency = this.currencyList.find((/**
         * @param {?} c
         * @return {?}
         */
        c => c.id === this.csgManufacturerCurrencyId));
        this.csgManufacturerCurrencySymbol = !!this.csgManufacturerCurrency ? this.csgManufacturerCurrency.symbol : "?";
        if (showPrices) {
            // Get RSP Display price data for List item Augmentation
            this.cleanSteamGeneratorService.calculateBOMPrice(this.csgPricing).subscribe((/**
             * @param {?} response
             * @return {?}
             */
            (response) => {
                if (response) {
                    this.csgBOMOutputData = response;
                    /** @type {?} */
                    let manPrice = "";
                    /** @type {?} */
                    let localPrices = "";
                    /** @type {?} */
                    let isOverride = "";
                    this.CSG_HS_020_Price = "";
                    this.CSG_HS_055_Price = "";
                    this.CSG_HS_125_Price = "";
                    this.CSG_HS_180_Price = "";
                    this.csgBOMOutputData.bomItems.forEach((/**
                     * @param {?} t
                     * @return {?}
                     */
                    t => {
                        if (showPrices && t.itemType == "Base") {
                            // Price the models
                            if (t.sRecommendedSalesPrice != 0.0 && t.sRecommendedSalesPrice != parseFloat(t.sDisplayedRSP)) {
                                isOverride = 'o';
                            }
                            manPrice = ' SSP=' + this.csgManufacturerCurrencySymbol + ' ' + this.localizeValue(t.ssp, 0);
                            localPrices = ' RSP' + isOverride + '=' + this.csgManufacturerCurrencySymbol + ' ' + this.localizeValue(t.displayedRSP, 0);
                            if (t.ssp != t.sSSP) { // if not the same currency data
                                manPrice = manPrice + ' (' + this.csgSellingCurrencySymbol + ' ' + this.localizeValue(t.sSSP, 0) + ')';
                                localPrices = localPrices + ' (' + this.csgSellingCurrencySymbol + ' ' + this.localizeValue(t.sDisplayedRSP, 0) + ')';
                            }
                            switch (t.parentMasterTextKey) {
                                case "CSG_HS_020":
                                    this.CSG_HS_020_Price = manPrice + localPrices;
                                    break;
                                case "CSG_HS_055":
                                    this.CSG_HS_055_Price = manPrice + localPrices;
                                    break;
                                case "CSG_HS_125":
                                    this.CSG_HS_125_Price = manPrice + localPrices;
                                    break;
                                case "CSG_HS_180":
                                    this.CSG_HS_180_Price = manPrice + localPrices;
                                    break;
                                default:
                                    break;
                            }
                        }
                        // Set option item enabled?
                        /** @type {?} */
                        var newEnumerationModulePreferences = this.GetNewEnumerationModulePreferences();
                        this.csgBOMOutputData.bomItems.forEach((/**
                         * @param {?} p
                         * @return {?}
                         */
                        p => {
                            /** @type {?} */
                            var elist = newEnumerationModulePreferences.find((/**
                             * @param {?} e
                             * @return {?}
                             */
                            e => e.enumerationName == p.parent));
                            if (!!elist) {
                                /** @type {?} */
                                var elistItem = elist.enumerationDefinitions.find((/**
                                 * @param {?} l
                                 * @return {?}
                                 */
                                l => l.value == p.item));
                            }
                            p.isEnabled = !!elistItem ? true : false;
                            // Set enabled if base CSG model item or add on (Commisoining, Voltage, Warranty etc.)
                            if (!p.parentMasterTextKey
                                || (!!p.parentMasterTextKey && p.parentMasterTextKey.indexOf('FEEDWATER_') === 0) // no list override for it
                                || (!!p.parentMasterTextKey && p.parentMasterTextKey.indexOf('CSG_') === 0)) {
                                p.isEnabled = true;
                            }
                        }));
                        // Append prices to list translation on UI
                        this.translationService.displayGroup.enumerations.forEach((/**
                         * @param {?} e
                         * @return {?}
                         */
                        e => {
                            e.enumerationDefinitions.forEach((/**
                             * @param {?} d
                             * @return {?}
                             */
                            d => {
                                if (e.enumerationName == t.parent && d.value == t.item) { // && d.translationText.indexOf(' ' + this.sellingCurrencySymbol + ' ') < 0) {              
                                    if (showPrices) {
                                        if (t.sRecommendedSalesPrice != 0.0 && (t.sRecommendedSalesPrice != parseFloat(t.sDisplayedRSP))) {
                                            isOverride = 'o';
                                        }
                                        /** @type {?} */
                                        var nomCode = '';
                                        if (!!t.item.split('_')[1]) {
                                            nomCode = '(' + t.item.split('_')[1] + ') ';
                                        }
                                        manPrice = ' SSP=' + this.csgManufacturerCurrencySymbol + ' ' + this.localizeValue(t.ssp, 0);
                                        localPrices = ' RSP' + isOverride + '=' + this.csgManufacturerCurrencySymbol + ' ' + this.localizeValue(t.displayedRSP, 0);
                                        if (t.ssp != t.sSSP) { // if not the same currency data
                                            manPrice = manPrice + ' (' + this.csgSellingCurrencySymbol + ' ' + this.localizeValue(t.sSSP, 0) + ')';
                                            localPrices = localPrices + ' (' + this.csgSellingCurrencySymbol + ' ' + this.localizeValue(t.sDisplayedRSP, 0) + ')';
                                        }
                                        // Set the UI text
                                        d.extraPostText = manPrice + localPrices;
                                        d.extraPreText = nomCode;
                                    }
                                    else {
                                        d.extraPostText = ""; // clear augmented data
                                        d.extraPreText = "";
                                    }
                                }
                            }));
                        }));
                    })); // of append prices
                    this.augmentPriceDataProcessing = false; // finished, enable button again
                    //this.scrollToElement(this.collapsePriceDataTop, "start");
                }
            })); // end of service response
        } // end of if showPrices
        else {
            // remove price augmentation
            this.CSG_HS_020_Price = "";
            this.CSG_HS_055_Price = "";
            this.CSG_HS_125_Price = "";
            this.CSG_HS_180_Price = "";
            this.translationService.displayGroup.enumerations.forEach((/**
             * @param {?} e
             * @return {?}
             */
            e => {
                e.enumerationDefinitions.forEach((/**
                 * @param {?} d
                 * @return {?}
                 */
                d => d.extraPostText = "")); // clear augmented data
                //e.enumerationDefinitions.forEach(d => d.extraPreText = "") // leave Nom codes on for easy UI reference.
            }));
            this.augmentPriceDataProcessing = false; // finished, enable button again
        }
    }
    /**
     * Method to localize values.
     * @param {?} value
     * @param {?} decimalPoints
     * @return {?}
     */
    localizeValue(value, decimalPoints) {
        return this.localeService.formatDecimal(value.toFixed(decimalPoints));
    }
    /*
      * Method to get and set the OpCo selected options.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} formControlName
     * @return {?}
     */
    setOpCoPreferences(enumerationPickerName, formControlName) {
        // Get the collection list first.
        /** @type {?} */
        let csgOpCoPref = this.getEnumerationPickerCollection(enumerationPickerName, true);
        // Check if any OpCo Overrides Data found? If NOT then get the base list populated.
        if (!csgOpCoPref) {
            csgOpCoPref = this.cloneDeep(this.getEnumerationPickerCollection(enumerationPickerName, false));
        }
        // Check and set the list.
        if (!!csgOpCoPref && csgOpCoPref.length > 0) {
            formControlName.setValue(csgOpCoPref);
        }
    }
    /*
      * Method to get the Enumeration list by Name.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} opCoOverride
     * @return {?}
     */
    getEnumerationPickerCollection(enumerationPickerName, opCoOverride) {
        /** @type {?} */
        const enumeration = this.translationService.displayGroup.enumerations.filter((/**
         * @param {?} us
         * @return {?}
         */
        us => us.enumerationName === enumerationPickerName && us.opCoOverride === opCoOverride));
        if (!!enumeration && enumeration.length > 0) {
            /** @type {?} */
            let definitions = enumeration[0].enumerationDefinitions.sort((/**
             * @param {?} currentenumeration
             * @param {?} nextenumeration
             * @return {?}
             */
            (currentenumeration, nextenumeration) => {
                if (currentenumeration.sequence > nextenumeration.sequence) {
                    return 1;
                }
                if (currentenumeration.sequence < nextenumeration.sequence) {
                    return -1;
                }
                return 0;
            }));
            //this.onChange(definitions);
            definitions.forEach((/**
             * @param {?} i
             * @return {?}
             */
            i => i.isDeleted = false));
            return definitions;
        }
    }
    /**
     * Submits the form for saving to the server.
     * @param {?} $event
     * @return {?}
     */
    submitForm($event) {
        $event.preventDefault();
        // Mark the form as submitted.
        this.formSubmitted = true;
        // Regular Module Preferences.
        /** @type {?} */
        const newModulePreferences = [];
        /** @type {?} */
        var csgSellingCurrency = this.getSelectedPreferences("CSGSellingCurrency", "csgSellingCurrencyModulePreference");
        /** @type {?} */
        var CSGLandCostIncrease = this.getSelectedPreferences("CSGLandCostIncrease", "csgLandedCostIncreaseModulePreference");
        /** @type {?} */
        var CSGDeliveryCost = this.getSelectedPreferences("CSGDeliveryCost", "csgDeliveryCostModulePreference");
        /** @type {?} */
        var CSGCommission = this.getSelectedPreferences("CSGCommission", "csgCommissionOnlyPriceModulePreference");
        /** @type {?} */
        var CSGYearOne = this.getSelectedPreferences("CSGYearOne", "csgWarrantyOneYearModulePreference");
        /** @type {?} */
        var CSGYearTwo = this.getSelectedPreferences("CSGYearTwo", "csgWarrantyTwoYearsModulePreference");
        /** @type {?} */
        var CSGYearThree = this.getSelectedPreferences("CSGYearThree", "csgWarrantyThreeYearsModulePreference");
        newModulePreferences.push(csgSellingCurrency);
        newModulePreferences.push(CSGLandCostIncrease);
        newModulePreferences.push(CSGDeliveryCost);
        newModulePreferences.push(CSGCommission);
        newModulePreferences.push(CSGYearOne);
        newModulePreferences.push(CSGYearTwo);
        newModulePreferences.push(CSGYearThree);
        // Save the changed preferences as an array of preferences
        this.adminService.manageModulePreferences(newModulePreferences).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            // The form can be submitted again.
            this.formSubmitted = false;
            // Set the operation based on the response.
            //this.isSuccess = response;
            this.alertVisible = true;
        }));
        /** @type {?} */
        var newEnumerationModulePreferences = this.GetNewEnumerationModulePreferences();
        // Save the changed preferences as an array of preferences
        this.adminService.manageEnumerationModulePreferences(newEnumerationModulePreferences).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            // The form can be submitted again.
            this.formSubmitted = false;
            // Set the operation based on the response.
            this.isSuccess = response;
            this.alertVisible = true;
            this.modulePreferencesForm.markAsPristine(); // to drive GenericChangesGuard
        }));
    }
    /**
     * @return {?}
     */
    GetNewEnumerationModulePreferences() {
        // Enumeration Module Preferences.
        /** @type {?} */
        const newEnumerationModulePreferences = [];
        // Design Code
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Design_Code", "csg020DesignCodePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Design_Code", "csg055DesignCodePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Design_Code", "csg125DesignCodePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Design_Code", "csg180DesignCodePreference"));
        // Shell Type
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Shell_Type", "csg020ShellTypePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Shell_Type", "csg055ShellTypePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Shell_Type", "csg125ShellTypePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Shell_Type", "csg180ShellTypePreference"));
        // Control Valve Actuation
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Valve_Actuation", "csg020ValveActuationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Valve_Actuation", "csg055ValveActuationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Valve_Actuation", "csg125ValveActuationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Valve_Actuation", "csg180ValveActuationPreference"));
        // Feedwater Pressurisation - does the list have AllowOverride set to true or just readOnly?
        if (!!this.getEnumerationPickerCollection('CSG_HS_020_Feedwater_Pressurisation', true)) {
            // The lists AllowOverride == true, so we can save the OpCo's Module Preference for these lists and list items.
            newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Feedwater_Pressurisation", "csg020FeedwaterPressurisationPreference"));
            newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Feedwater_Pressurisation", "csg055FeedwaterPressurisationPreference"));
            newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Feedwater_Pressurisation", "csg125FeedwaterPressurisationPreference"));
            newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Feedwater_Pressurisation", "csg180FeedwaterPressurisationPreference"));
        }
        // Control
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Control", "csg020ControlPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Control", "csg055ControlPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Control", "csg125ControlPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Control", "csg180ControlPreference"));
        // Communication Interface
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Communication_Interface", "csg020CommunicationInterfacePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Communication_Interface", "csg055CommunicationInterfacePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Communication_Interface", "csg125CommunicationInterfacePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Communication_Interface", "csg180CommunicationInterfacePreference"));
        // Frame and Cabinet
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Frame_And_Cabinet", "csg020FrameAndCabinetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Frame_And_Cabinet", "csg055FrameAndCabinetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Frame_And_Cabinet", "csg125FrameAndCabinetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Frame_And_Cabinet", "csg180FrameAndCabinetPreference"));
        // Control Panel Location
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Control_Panel_Location", "csg020ControlPanelLocationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Control_Panel_Location", "csg055ControlPanelLocationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Control_Panel_Location", "csg125ControlPanelLocationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Control_Panel_Location", "csg180ControlPanelLocationPreference"));
        // Insulation
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Insulation", "csg020InsulationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Insulation", "csg055InsulationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Insulation", "csg125InsulationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Insulation", "csg180InsulationPreference"));
        // Wheels And Feet
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Wheels_And_Feet", "csg020WheelsAndFeetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Wheels_And_Feet", "csg055WheelsAndFeetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Wheels_And_Feet", "csg125WheelsAndFeetPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Wheels_And_Feet", "csg180WheelsAndFeetPreference"));
        // Plant Steam Inlet Shut Off Valve
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Plant_Steam_Inlet_Shut_Off_Valve", "csg020PlantSteamInletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Plant_Steam_Inlet_Shut_Off_Valve", "csg055PlantSteamInletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Plant_Steam_Inlet_Shut_Off_Valve", "csg125PlantSteamInletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Plant_Steam_Inlet_Shut_Off_Valve", "csg180PlantSteamInletShutOffValvePreference"));
        // Plant steam line trapping
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Plant_Steam_Line_Trapping", "csg020PlantSteamLineTrappingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Plant_Steam_Line_Trapping", "csg055PlantSteamLineTrappingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Plant_Steam_Line_Trapping", "csg125PlantSteamLineTrappingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Plant_Steam_Line_Trapping", "csg180PlantSteamLineTrappingPreference"));
        // TDS control system
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_TDS_Control_System", "csg020TDSControlSystemPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_TDS_Control_System", "csg055TDSControlSystemPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_TDS_Control_System", "csg125TDSControlSystemPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_TDS_Control_System", "csg180TDSControlSystemPreference"));
        // Sample Coolers
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Sample_Cooler", "csg020SampleCoolerPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Sample_Cooler", "csg055SampleCoolerPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Sample_Cooler", "csg125SampleCoolerPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Sample_Cooler", "csg180SampleCoolerPreference"));
        // Independent low level alarm
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Independent_Low_Level_Alarm", "csg020IndependentLowLevelAlarmPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Independent_Low_Level_Alarm", "csg055IndependentLowLevelAlarmPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Independent_Low_Level_Alarm", "csg125IndependentLowLevelAlarmPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Independent_Low_Level_Alarm", "csg180IndependentLowLevelAlarmPreference"));
        // Feedwater pre-heating / Degassing
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Feedwater_Pre_Heating_Degassing", "csg020FeedwaterPreHeatingDegassingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Feedwater_Pre_Heating_Degassing", "csg055FeedwaterPreHeatingDegassingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Feedwater_Pre_Heating_Degassing", "csg125FeedwaterPreHeatingDegassingPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Feedwater_Pre_Heating_Degassing", "csg180FeedwaterPreHeatingDegassingPreference"));
        // Intelligent diagnostics
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Intelligent_Diagnostics", "csg020IntelligentDiagnosticsPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Intelligent_Diagnostics", "csg055IntelligentDiagnosticsPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Intelligent_Diagnostics", "csg125IntelligentDiagnosticsPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Intelligent_Diagnostics", "csg180IntelligentDiagnosticsPreference"));
        // Clean steam outlet shut-off valve
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Clean_Steam_Outlet_Shut_Off_Valve", "csg020CleanSteamOutletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Clean_Steam_Outlet_Shut_Off_Valve", "csg055CleanSteamOutletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Clean_Steam_Outlet_Shut_Off_Valve", "csg125CleanSteamOutletShutOffValvePreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Clean_Steam_Outlet_Shut_Off_Valve", "csg180CleanSteamOutletShutOffValvePreference"));
        // Test and certifications
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Test_And_Certification", "csg020TestAndCertificationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Test_And_Certification", "csg055TestAndCertificationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Test_And_Certification", "csg125TestAndCertificationPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Test_And_Certification", "csg180TestAndCertificationPreference"));
        // Level_Indicator
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_020_Level_Indicator", "csg020Level_IndicatorPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_055_Level_Indicator", "csg055Level_IndicatorPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_125_Level_Indicator", "csg125Level_IndicatorPreference"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("CSG_HS_180_Level_Indicator", "csg180Level_IndicatorPreference"));
        return newEnumerationModulePreferences;
    }
    /*
      * Method to get opco selected enumeration module prefernce details for each options.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} prefsFormKeyName
     * @return {?}
     */
    getSelectedEnumerationPreferences(enumerationPickerName, prefsFormKeyName) {
        /** @type {?} */
        var modPrefs = new Enumeration;
        modPrefs.enumerationName = enumerationPickerName;
        modPrefs.opCoOverride = true;
        modPrefs.enumerationDefinitions = this.modulePreferencesForm.controls[prefsFormKeyName].value;
        return modPrefs;
    }
    /*
      * Method to get opco selected module prefernce details.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} prefsFormKeyName
     * @return {?}
     */
    getSelectedPreferences(enumerationPickerName, prefsFormKeyName) {
        /** @type {?} */
        var modPrefs = new ModulePreferenceDetails;
        modPrefs.name = enumerationPickerName;
        modPrefs.value = "" + this.modulePreferencesForm.controls[prefsFormKeyName].value;
        modPrefs.moduleId = +this.moduleId;
        modPrefs.isDeleted = false;
        return modPrefs;
    }
    /**
     * @return {?}
     */
    closeAlert() {
        // Reset the flag
        this.alertVisible = false;
    }
    /**
     * @return {?}
     */
    onChangeAnyOption() {
        // Any enumeration-picker (on-change) set the form data to dirty.
        this.modulePreferencesForm.markAsDirty();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onCSGOptionsChange(event) {
        this.csgOptionsSelectedItem = event.selectedValue;
        this.csgOptionsFormControl.markAsPristine(); // Options list selector is not a data change item, so ignore changes.
    }
    /*
      * Method to calculate the currency conversion rate.
      */
    /**
     * @param {?} selectedValue
     * @return {?}
     */
    onSellingCurrencyChange(selectedValue) {
        this.csgManufacturerCurrencyId = +this.csgManufacturerCurrencyPrefFormControl.value;
        if (selectedValue > 0 && this.csgManufacturerCurrencyId > 0 && this.currencyList.length > 0) {
            /** @type {?} */
            let sellingCurrency = this.currencyList.find((/**
             * @param {?} c
             * @return {?}
             */
            c => c.id === +selectedValue));
            /** @type {?} */
            let manufacturerCurrency = this.currencyList.find((/**
             * @param {?} c
             * @return {?}
             */
            c => c.id === this.csgManufacturerCurrencyId));
            this.csgSellingCurrencySymbol = sellingCurrency.symbol;
            this.csgCurrencyConversion = +((manufacturerCurrency.rateToGbp * (1 / sellingCurrency.rateToGbp)).toFixed(5));
        }
    }
    /*
      * Method to retrieve the module pref value from the list.
      */
    /**
     * @param {?} modulePrefList
     * @param {?} modulePrefName
     * @return {?}
     */
    getModulePreferenceValue(modulePrefList, modulePrefName) {
        /** @type {?} */
        let modPref = modulePrefList.filter((/**
         * @param {?} r
         * @return {?}
         */
        r => r.name === modulePrefName));
        if (modPref && modPref.length > 0) {
            return modPref[0].value;
        }
    }
    /**
     * @param {?} row
     * @return {?}
     */
    getRowClass(row) {
        if (row.isEnabled) {
            return 'row-color-enabled';
        }
        return 'row-color-disabled';
    }
}
CleanSteamGeneratorModulePreferencesComponent.decorators = [
    { type: Component, args: [{
                selector: 'cleansteamgenerator-module-preferences',
                template: "<!--CleanSteamGenerator module preferences component works!-->\r\n<div *ngIf=\"!componentInitialised\">\r\n  <div class=\"ball-clip-rotate\">\r\n    <div></div>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"componentInitialised\">\r\n  <form [formGroup]=\"modulePreferencesForm\" class=\"form-horizontal\" role=\"form\" (submit)=\"submitForm($event)\" novalidate>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <button [disabled]=\"!modulePreferencesForm.dirty || !modulePreferencesForm.valid || modulePreferencesForm.status !== 'VALID' || formSubmitted\" type=\"submit\" class=\"btn btn-dynamic btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i></button>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <br>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Success confirmation message -->\r\n    <alert-block *ngIf=\"!!alertVisible && !!isSuccess\" type=\"success\" [auto-close]=\"true\" [message]=\"'MODULE_PREFERENCES_SAVED_SUCCESSFULLY_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n    <!-- Failure confirmation message-->\r\n    <alert-block *ngIf=\"!!alertVisible && !isSuccess\" type=\"danger\" [message]=\"'MODULE_PREFERENCES_FAILED_TO_SAVE_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"currencyOptionsHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseCurrencyOptions\" aria-expanded=\"true\" aria-controls=\"collapseCurrencyOptions\">\r\n            {{\"CURRENCY_OPTIONS\" | translate}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapseCurrencyOptions\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"currencyOptionsHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-10px\">\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"row\" style=\"padding-bottom:15px\">\r\n\r\n              <!--Manufacturer-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"MANUFACTURER\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"csgManufacturerModulePreference\">\r\n                  <option *ngFor=\"let manufacturer of manufacturerList\" [value]=\"manufacturer.id\">{{manufacturer.name}}</option>\r\n                </select>\r\n              </div>\r\n\r\n              <!--Selling currency-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"SELLING_CURRENCY\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"csgSellingCurrencyModulePreference\" (ngModelChange)=\"onSellingCurrencyChange($event)\">\r\n                  <option *ngFor=\"let currency of currencyList\" [value]=\"currency.id\">{{currency.currencyCode}} - {{currency.symbol}}</option>\r\n                </select>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n\r\n              <!--Manufacturer currency-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"MANUFACTURER_CURRENCY\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"csgManufacturerCurrencyModulePreference\">\r\n                  <option *ngFor=\"let currency of currencyList\" [value]=\"currency.id\">{{currency.currencyCode}} - {{currency.symbol}}</option>\r\n                </select>\r\n              </div>\r\n\r\n              <!--Currency conversion-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"CURRENCY_CONVERSION\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <label class=\"control-label\">{{csgCurrencyConversion}}</label>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--Pricing Options-->\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"pricingOptionsHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapsePricingOptions\" aria-expanded=\"true\" aria-controls=\"collapsePricingOptions\">\r\n            {{\"PRICING_OPTIONS\" | translate}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapsePricingOptions\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"pricingOptionsHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-30px\">\r\n          <div class=\"form-group\">\r\n            <!--Column 1-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <!--Landed Cost Increase-->\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"LANDED_COST_INCREASE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"csgLandedCostIncreaseModulePreference\" value=\"csgLandedCostIncrease\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].dirty || modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].hasError('range') && (modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].dirty || modulePreferencesForm.controls['csgLandedCostIncreaseModulePreference'].touched)\">{{\"LANDED_COST_INCREASE_MUST_BE_BETWEEN_0_AND_100_PERCENT_MESSAGE\" | translate}}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <!--Delivery Cost-->\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"DELIVERY_COST\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-addon\">{{csgSellingCurrencySymbol}}</span>\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"text\" style=\"min-width:55px;\" formControlName=\"csgDeliveryCostModulePreference\" value=\"csgDeliveryCost\" twoDigitDecimalNumber />\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2 cross-validation-error-class\" *ngIf=\"deliveryCostMessage\">\r\n                  <div><i class=\"fa fa-info-circle cross-validation-error-class\" [tooltip]=\"deliveryCostMessage\" placement=\"top,right\"></i></div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgDeliveryCostModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgDeliveryCostModulePreference'].dirty || modulePreferencesForm.controls['csgDeliveryCostModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Column 2-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"panel panel-primary\" style=\"padding-bottom: 20px;\">\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-4 text-right\">\r\n                    <h4>{{\"SERVICE_OFFERING\" | translate}}</h4>\r\n                  </div>\r\n                  <div class=\"col-xs-3 cross-validation-error-class\" *ngIf=\"serviceOffereingMessage\">\r\n                    <div><i class=\"fa fa-info-circle cross-validation-error-class\" [tooltip]=\"serviceOffereingMessage\" placement=\"top,right\"></i></div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--Commission Only Price-->\r\n                  <div class=\"col-xs-4 text-right\">\r\n                    <label class=\"control-label\">{{\"COMMISSION_ONLY_PRICE\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{csgSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"csgCommissionOnlyPriceModulePreference\" value=\"csgCommissionOnlyPrice\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgCommissionOnlyPriceModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgCommissionOnlyPriceModulePreference'].dirty || modulePreferencesForm.controls['csgCommissionOnlyPriceModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n                <!--</fieldset>-->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--One Year-->\r\n                  <div class=\"col-xs-4 text-right\">\r\n                    <label class=\"control-label\">{{\"ONE_YEAR\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{csgSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"csgWarrantyOneYearModulePreference\" value=\"csgWarrantyOneYear\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgWarrantyOneYearModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgWarrantyOneYearModulePreference'].dirty || modulePreferencesForm.controls['csgWarrantyOneYearModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--Two Years-->\r\n                  <div class=\"col-xs-4 text-right\">\r\n                    <label class=\"control-label\">{{\"TWO_YEARS\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{csgSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"csgWarrantyTwoYearsModulePreference\" value=\"csgWarrantyTwoYears\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgWarrantyTwoYearsModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgWarrantyTwoYearsModulePreference'].dirty || modulePreferencesForm.controls['csgWarrantyTwoYearsModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--Three Years-->\r\n                  <div class=\"col-xs-4 text-right\">\r\n                    <label class=\"control-label\">{{\"THREE_YEARS\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{csgSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"csgWarrantyThreeYearsModulePreference\" value=\"csgWarrantyThreeYears\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['csgWarrantyThreeYearsModulePreference'].hasError('required') && (modulePreferencesForm.controls['csgWarrantyThreeYearsModulePreference'].dirty || modulePreferencesForm.controls['csgWarrantyThreeYearsModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--Configurartion Options-->\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"optionConfigurartionHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseOptionConfigurartion\" aria-expanded=\"true\" aria-controls=\"collapseOptionConfigurartion\">\r\n            {{\"OPTION_CONFIGURATION\" | translate}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapseOptionConfigurartion\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"optionConfigurartionHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-20px\">\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-2 text-right\">\r\n                <label class=\"control-label\">{{\"PLEASE_SELECT\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                <enumeration formControlName=\"csgOptionsSelection\" enumeration-name=\"CSG_Options\" (on-change)=\"onCSGOptionsChange($event)\"></enumeration>\r\n              </div>\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                <button [disabled]=\"augmentPriceDataProcessing\" class=\"btn btn-dynamic btn-primary pull-right\" type='button' (click)=\"togglePrices();\" [title]=\"'TOGGLE_PRICES' | translate\"><i class=\"fa fa-exchange\">  {{'TOGGLE_PRICES' | translate}}</i></button>\r\n              </div>\r\n            </div>\r\n            <hr>\r\n            <!--Design Code-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Design Code'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020DesignCodePreference\" enumeration-picker-name=\"CSG_HS_020_Design_Code\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055DesignCodePreference\" enumeration-picker-name=\"CSG_HS_055_Design_Code\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125DesignCodePreference\" enumeration-picker-name=\"CSG_HS_125_Design_Code\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180DesignCodePreference\" enumeration-picker-name=\"CSG_HS_180_Design_Code\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Shell Type-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Shell Type'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020ShellTypePreference\" enumeration-picker-name=\"CSG_HS_020_Shell_Type\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055ShellTypePreference\" enumeration-picker-name=\"CSG_HS_055_Shell_Type\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125ShellTypePreference\" enumeration-picker-name=\"CSG_HS_125_Shell_Type\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180ShellTypePreference\" enumeration-picker-name=\"CSG_HS_180_Shell_Type\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Valve Actuation-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Valve Actuation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020ValveActuationPreference\" enumeration-picker-name=\"CSG_HS_020_Valve_Actuation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055ValveActuationPreference\" enumeration-picker-name=\"CSG_HS_055_Valve_Actuation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125ValveActuationPreference\" enumeration-picker-name=\"CSG_HS_125_Valve_Actuation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180ValveActuationPreference\" enumeration-picker-name=\"CSG_HS_180_Valve_Actuation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Feedwater Pressurisation-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Feedwater pressurisation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020FeedwaterPressurisationPreference\" enumeration-picker-name=\"CSG_HS_020_Feedwater_Pressurisation\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055FeedwaterPressurisationPreference\" enumeration-picker-name=\"CSG_HS_055_Feedwater_Pressurisation\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125FeedwaterPressurisationPreference\" enumeration-picker-name=\"CSG_HS_125_Feedwater_Pressurisation\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180FeedwaterPressurisationPreference\" enumeration-picker-name=\"CSG_HS_180_Feedwater_Pressurisation\" readOnly=\"true\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Control-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Control'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020ControlPreference\" enumeration-picker-name=\"CSG_HS_020_Control\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055ControlPreference\" enumeration-picker-name=\"CSG_HS_055_Control\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125ControlPreference\" enumeration-picker-name=\"CSG_HS_125_Control\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180ControlPreference\" enumeration-picker-name=\"CSG_HS_180_Control\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Communication interface-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Communication interface'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020CommunicationInterfacePreference\" enumeration-picker-name=\"CSG_HS_020_Communication_Interface\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055CommunicationInterfacePreference\" enumeration-picker-name=\"CSG_HS_055_Communication_Interface\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125CommunicationInterfacePreference\" enumeration-picker-name=\"CSG_HS_125_Communication_Interface\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180CommunicationInterfacePreference\" enumeration-picker-name=\"CSG_HS_180_Communication_Interface\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Frame and cabinet-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Frame and Cabinet'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020FrameAndCabinetPreference\" enumeration-picker-name=\"CSG_HS_020_Frame_And_Cabinet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055FrameAndCabinetPreference\" enumeration-picker-name=\"CSG_HS_055_Frame_And_Cabinet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125FrameAndCabinetPreference\" enumeration-picker-name=\"CSG_HS_125_Frame_And_Cabinet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180FrameAndCabinetPreference\" enumeration-picker-name=\"CSG_HS_180_Frame_And_Cabinet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Control Panel Location-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Control panel location'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020ControlPanelLocationPreference\" enumeration-picker-name=\"CSG_HS_020_Control_Panel_Location\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055ControlPanelLocationPreference\" enumeration-picker-name=\"CSG_HS_055_Control_Panel_Location\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125ControlPanelLocationPreference\" enumeration-picker-name=\"CSG_HS_125_Control_Panel_Location\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180ControlPanelLocationPreference\" enumeration-picker-name=\"CSG_HS_180_Control_Panel_Location\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Insulation-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Insulation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020InsulationPreference\" enumeration-picker-name=\"CSG_HS_020_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055InsulationPreference\" enumeration-picker-name=\"CSG_HS_055_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125InsulationPreference\" enumeration-picker-name=\"CSG_HS_125_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180InsulationPreference\" enumeration-picker-name=\"CSG_HS_180_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Handling wheels and feet-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Handling wheels and feet'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020WheelsAndFeetPreference\" enumeration-picker-name=\"CSG_HS_020_Wheels_And_Feet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055WheelsAndFeetPreference\" enumeration-picker-name=\"CSG_HS_055_Wheels_And_Feet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125WheelsAndFeetPreference\" enumeration-picker-name=\"CSG_HS_125_Wheels_And_Feet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180WheelsAndFeetPreference\" enumeration-picker-name=\"CSG_HS_180_Wheels_And_Feet\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Plant Steam Inlet Shut Off Valve-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Plant steam inlet shut-off valve'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020PlantSteamInletShutOffValvePreference\" enumeration-picker-name=\"CSG_HS_020_Plant_Steam_Inlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055PlantSteamInletShutOffValvePreference\" enumeration-picker-name=\"CSG_HS_055_Plant_Steam_Inlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125PlantSteamInletShutOffValvePreference\" enumeration-picker-name=\"CSG_HS_125_Plant_Steam_Inlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180PlantSteamInletShutOffValvePreference\" enumeration-picker-name=\"CSG_HS_180_Plant_Steam_Inlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Plant steam line trapping-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Plant steam line trapping'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020PlantSteamLineTrappingPreference\" enumeration-picker-name=\"CSG_HS_020_Plant_Steam_Line_Trapping\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055PlantSteamLineTrappingPreference\" enumeration-picker-name=\"CSG_HS_055_Plant_Steam_Line_Trapping\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125PlantSteamLineTrappingPreference\" enumeration-picker-name=\"CSG_HS_125_Plant_Steam_Line_Trapping\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180PlantSteamLineTrappingPreference\" enumeration-picker-name=\"CSG_HS_180_Plant_Steam_Line_Trapping\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--TDS control system-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'TDS control system'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020TDSControlSystemPreference\" enumeration-picker-name=\"CSG_HS_020_TDS_Control_System\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055TDSControlSystemPreference\" enumeration-picker-name=\"CSG_HS_055_TDS_Control_System\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125TDSControlSystemPreference\" enumeration-picker-name=\"CSG_HS_125_TDS_Control_System\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180TDSControlSystemPreference\" enumeration-picker-name=\"CSG_HS_180_TDS_Control_System\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Sample Coolers-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Sample Coolers'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020SampleCoolerPreference\" enumeration-picker-name=\"CSG_HS_020_Sample_Cooler\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055SampleCoolerPreference\" enumeration-picker-name=\"CSG_HS_055_Sample_Cooler\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125SampleCoolerPreference\" enumeration-picker-name=\"CSG_HS_125_Sample_Cooler\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180SampleCoolerPreference\" enumeration-picker-name=\"CSG_HS_180_Sample_Cooler\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Independent low level alarm-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Independent low level alarm'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020IndependentLowLevelAlarmPreference\" enumeration-picker-name=\"CSG_HS_020_Independent_Low_Level_Alarm\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055IndependentLowLevelAlarmPreference\" enumeration-picker-name=\"CSG_HS_055_Independent_Low_Level_Alarm\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125IndependentLowLevelAlarmPreference\" enumeration-picker-name=\"CSG_HS_125_Independent_Low_Level_Alarm\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180IndependentLowLevelAlarmPreference\" enumeration-picker-name=\"CSG_HS_180_Independent_Low_Level_Alarm\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Feedwater pre-heating / Degassing-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Feedwater pre-heating'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020FeedwaterPreHeatingDegassingPreference\" enumeration-picker-name=\"CSG_HS_020_Feedwater_Pre_Heating_Degassing\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055FeedwaterPreHeatingDegassingPreference\" enumeration-picker-name=\"CSG_HS_055_Feedwater_Pre_Heating_Degassing\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125FeedwaterPreHeatingDegassingPreference\" enumeration-picker-name=\"CSG_HS_125_Feedwater_Pre_Heating_Degassing\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180FeedwaterPreHeatingDegassingPreference\" enumeration-picker-name=\"CSG_HS_180_Feedwater_Pre_Heating_Degassing\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Intelligent diagnostics-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Intelligent diagnostics'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020IntelligentDiagnosticsPreference\" enumeration-picker-name=\"CSG_HS_020_Intelligent_Diagnostics\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055IntelligentDiagnosticsPreference\" enumeration-picker-name=\"CSG_HS_055_Intelligent_Diagnostics\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125IntelligentDiagnosticsPreference\" enumeration-picker-name=\"CSG_HS_125_Intelligent_Diagnostics\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180IntelligentDiagnosticsPreference\" enumeration-picker-name=\"CSG_HS_180_Intelligent_Diagnostics\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Clean steam outlet shut-off valve-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Clean steam outlet shut-off valve'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020CleanSteamOutletShutOffValvePreference\" enumeration-picker-name=\"CSG_HS_020_Clean_Steam_Outlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055CleanSteamOutletShutOffValvePreference\" enumeration-picker-name=\"CSG_HS_055_Clean_Steam_Outlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125CleanSteamOutletShutOffValvePreference\" enumeration-picker-name=\"CSG_HS_125_Clean_Steam_Outlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180CleanSteamOutletShutOffValvePreference\" enumeration-picker-name=\"CSG_HS_180_Clean_Steam_Outlet_Shut_Off_Valve\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Test and certifications-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Test and certifications'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020TestAndCertificationPreference\" enumeration-picker-name=\"CSG_HS_020_Test_And_Certification\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055TestAndCertificationPreference\" enumeration-picker-name=\"CSG_HS_055_Test_And_Certification\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125TestAndCertificationPreference\" enumeration-picker-name=\"CSG_HS_125_Test_And_Certification\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180TestAndCertificationPreference\" enumeration-picker-name=\"CSG_HS_180_Test_And_Certification\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Level_Indicator-->\r\n            <div class=\"panel-body\" [hidden]=\"csgOptionsSelectedItem !== 'Level Indicator'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 020 {{CSG_HS_020_Price}}\">CSG-HS 020</h4><label>{{CSG_HS_020_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg020Level_IndicatorPreference\" enumeration-picker-name=\"CSG_HS_020_Level_Indicator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 055 {{CSG_HS_055_Price}}\">CSG-HS 055</h4><label>{{CSG_HS_055_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg055Level_IndicatorPreference\" enumeration-picker-name=\"CSG_HS_055_Level_Indicator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 125 {{CSG_HS_125_Price}}\">CSG-HS 125</h4><label>{{CSG_HS_125_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg125Level_IndicatorPreference\" enumeration-picker-name=\"CSG_HS_125_Level_Indicator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"CSG-HS 180 {{CSG_HS_180_Price}}\">CSG-HS 180</h4><label>{{CSG_HS_180_Price}}</label>\r\n                  <enumeration-picker formControlName=\"csg180Level_IndicatorPreference\" enumeration-picker-name=\"CSG_HS_180_Level_Indicator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <a #collapsePriceDataTop href=\"#collapsePriceDataTop\"> </a>\r\n    </div>\r\n\r\n    <!--Price Data Grid -->\r\n    <div *ngIf=\"!!csgBOMOutputData.bomItems && csgBOMOutputData.bomItems.length > 0 && showPrices\" class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"priceDataHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapsePriceData\" aria-expanded=\"true\" aria-controls=\"collapsePriceData\">\r\n            {{\"Price Data\"}} - {{'CLEAN_STEAM_GENERATOR' | translate:true}}{{operatingCompany}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <!-- Price Data Grid  -->\r\n      <div class=\"panel-body\">\r\n        <div class=\"col-xs-12\">\r\n\r\n          <ngx-datatable #csgBOMOutputDataTable\r\n                         class=\"bootstrap\"\r\n                         [headerHeight]=\"40\"\r\n                         [limit]=\"50\"\r\n                         [columnMode]=\"'force'\"\r\n                         [footerHeight]=\"40\"\r\n                         [rowHeight]=\"'auto'\"\r\n                         [rows]=\"csgBOMOutputData.bomItems\">\r\n\r\n\r\n\r\n            <!--[rowClass]=\"getRowClass\">-->\r\n            <!--  [selected]=\"selectedOutputData\"\r\n                 [selectionType]=\"'single'\"\r\n                 (select)=\"onSelect($event)\"\r\n            -->\r\n            <!-- Row Detail Template -->\r\n            <!--<ngx-datatable-row-detail [rowHeight]=\"getHeight\" #myDetailRow>\r\n              <ng-template let-row=\"row\" let-expanded=\"expanded\" ngx-datatable-row-detail-template>\r\n                <div *ngFor=\"let m of row.modelSizingMessages\">\r\n                  <div class=\"row col-xs-12\">\r\n                    <div class=\"col-xs-1 text-center\">\r\n                      <i [class]=\"getSeverityIcon(m.severity)\"></i>\r\n                    </div>\r\n                    <div class=\"col-xs-10\">\r\n                      <span>{{m.messageKey | translate}}</span>\r\n                      <span *ngIf=\"m.value !== 0 && m.unitKey\"> ({{m.value}} {{m.unitKey | translate:false}})</span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </ng-template>\r\n            </ngx-datatable-row-detail>-->\r\n            <!-- Column Template -->\r\n            <!--<ngx-datatable-column>\r\n              <ng-template let-row=\"row\" let-expanded=\"expanded\" ngx-datatable-cell-template>\r\n                <i [class]=\"getRowSeverityIcon(row)\"></i>\r\n              </ng-template>\r\n            </ngx-datatable-column>-->\r\n            <!--Columns-->\r\n            <ngx-datatable-column [name]=\"'Number'\" prop=\"rowOrder\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Type'\" prop=\"itemType\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'ModelId'\" prop=\"modelId\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Option Group'\" prop=\"parentMasterTextKey\" [width]=\"200\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"!!value && value.indexOf('CSG_')!==0\">{{value | translate}}</span>\r\n                <span *ngIf=\"!!value && value.indexOf('CSG_')==0\">{{value.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Option'\" prop=\"itemMasterTextKey\" [width]=\"200\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span [style.background]=\"!row.isEnabled ? 'Plum' : ' '\" *ngIf=\"!!value && value.indexOf('CSG_')!==0\">{{value | translate}}</span>\r\n                <span [style.background]=\"!row.isEnabled ? 'Plum' : ' '\" *ngIf=\"!!value && value.indexOf('CSG_')==0\">{{value.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'SSP'\" prop=\"ssp\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol==csgSellingCurrencySymbol\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol!==csgSellingCurrencySymbol || row.modelId==0\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{csgSellingCurrencySymbol}} {{localizeValue(row.sSSP,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'x'\" prop=\"ssPtoRSPfactor\" [width]=\"40\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"value!==0\">x {{value}} =</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'RSP'\" prop=\"recommendedSalesPrice\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol==csgSellingCurrencySymbol\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol!==csgSellingCurrencySymbol || row.modelId==0\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{csgSellingCurrencySymbol}} {{localizeValue(row.sRecommendedSalesPrice,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'RSP override'\" prop=\"recommendedSalesPriceOverride\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol==csgSellingCurrencySymbol\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol!==csgSellingCurrencySymbol || row.modelId==0\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{csgSellingCurrencySymbol}} {{localizeValue(row.sRecommendedSalesPriceOverride,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Display Price'\" prop=\"displayedRSP\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol==csgSellingCurrencySymbol\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"csgManufacturerCurrencySymbol!==csgSellingCurrencySymbol || row.modelId==0\">{{csgManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{csgSellingCurrencySymbol}} {{localizeValue(row.sDisplayedRSP,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Model'\" prop=\"modelId\" [width]=\"30\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('CSG_')!==0\">{{value}}</span>\r\n                <span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('CSG_')==0\">{{value}} {{row.parentMasterTextKey.split('_')[1]}} {{row.parentMasterTextKey.split('_')[2]}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Nomenclature'\" prop=\"item\" [width]=\"50\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"!!value.split('_')[1]\">{{value.split('_')[1]}}</span>\r\n                <!--<span *ngIf=\"!value.split('_')[1]\">{{value}}</span>-->\r\n                <span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('CSG_')==0\">{{row.parentMasterTextKey.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <!--[style.background]=\"row.isEnabled ? 'White' : 'SlateGray'\"-->\r\n            <ngx-datatable-column [name]=\"'Enabled'\" prop=\"isEnabled\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"value\">+</span>\r\n                <span *ngIf=\"!value\">-</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n          </ngx-datatable>\r\n\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n    <!--<div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        { {modulePreferencesForm.value | json}}\r\n      </div>\r\n    </div>-->\r\n    <!--<div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <button [disabled]=\"!modulePreferencesForm.dirty || !modulePreferencesForm.valid || modulePreferencesForm.status !== 'VALID' || formSubmitted\" type=\"submit\" class=\"btn btn-block btn-dynamic btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i></button>\r\n      </div>\r\n    </div>-->\r\n\r\n  </form>\r\n</div>\r\n",
                providers: [CleanSteamGeneratorService],
                styles: [".cross-validation-error-class{font-size:25px;color:#708090}"]
            }] }
];
/** @nocollapse */
CleanSteamGeneratorModulePreferencesComponent.ctorParameters = () => [
    { type: RoutesService },
    { type: AdminService },
    { type: TranslationService },
    { type: FormBuilder },
    { type: TranslatePipe },
    { type: ModulePreferenceService },
    { type: CleanSteamGeneratorService },
    { type: LocaleService$1 },
    { type: UserProfileService }
];
CleanSteamGeneratorModulePreferencesComponent.propDecorators = {
    csgBOMOutputDataTable: [{ type: ViewChild, args: ["csgBOMOutputDataTable", { static: false },] }],
    collapsePriceDataTop: [{ type: ViewChild, args: ['collapsePriceDataTop', { static: false },] }]
};
if (false) {
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.moduleId;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.moduleGroupId;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.cloneDeep;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.moduleName;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgBOMOutputDataTable;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.collapsePriceDataTop;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.componentInitialised;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.componentLoadPromises;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.theFormGroup;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.hasUnsavedDataChanges;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.isSuccess;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.alertVisible;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.formSubmitted;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgOptionsSelectedItem;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.manufacturerList;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.currencyList;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgManufacturerCurrencyId;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgManufacturerCurrency;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgManufacturerCurrencySymbol;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgSellingCurrencyId;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgSellingCurrencySymbol;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgCurrencyConversion;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgLandedCostIncrease;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgCommissionOnlyPrice;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgWarrantyOneYear;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgWarrantyTwoYears;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgWarrantyThreeYears;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.modulePreferencesForm;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgManufacturerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgManufacturerCurrencyPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgSellingCurrencyPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgLandedCostIncreasePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgDeliveryCostPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgCommissionOnlyPricePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgWarrantyOneYearPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgWarrantyTwoYearsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgWarrantyThreeYearsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgOptionsFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020DesignCodePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055DesignCodePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125DesignCodePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180DesignCodePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020ShellTypePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055ShellTypePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125ShellTypePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180ShellTypePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020ValveActuationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055ValveActuationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125ValveActuationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180ValveActuationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020FeedwaterPressurisationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055FeedwaterPressurisationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125FeedwaterPressurisationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180FeedwaterPressurisationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020ControlPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055ControlPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125ControlPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180ControlPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020CommunicationInterfacePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055CommunicationInterfacePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125CommunicationInterfacePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180CommunicationInterfacePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020FrameAndCabinetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055FrameAndCabinetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125FrameAndCabinetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180FrameAndCabinetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020ControlPanelLocationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055ControlPanelLocationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125ControlPanelLocationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180ControlPanelLocationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020InsulationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055InsulationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125InsulationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180InsulationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020WheelsAndFeetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055WheelsAndFeetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125WheelsAndFeetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180WheelsAndFeetPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020PlantSteamInletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055PlantSteamInletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125PlantSteamInletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180PlantSteamInletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020PlantSteamLineTrappingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055PlantSteamLineTrappingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125PlantSteamLineTrappingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180PlantSteamLineTrappingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020TDSControlSystemPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055TDSControlSystemPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125TDSControlSystemPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180TDSControlSystemPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020SampleCoolerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055SampleCoolerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125SampleCoolerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180SampleCoolerPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020IndependentLowLevelAlarmPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055IndependentLowLevelAlarmPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125IndependentLowLevelAlarmPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180IndependentLowLevelAlarmPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020FeedwaterPreHeatingDegassingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055FeedwaterPreHeatingDegassingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125FeedwaterPreHeatingDegassingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180FeedwaterPreHeatingDegassingPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020IntelligentDiagnosticsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055IntelligentDiagnosticsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125IntelligentDiagnosticsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180IntelligentDiagnosticsPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020CleanSteamOutletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055CleanSteamOutletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125CleanSteamOutletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180CleanSteamOutletShutOffValvePrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020TestAndCertificationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055TestAndCertificationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125TestAndCertificationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180TestAndCertificationPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg020Level_IndicatorPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg055Level_IndicatorPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg125Level_IndicatorPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csg180Level_IndicatorPrefFormControl;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.serviceOffereingMessage;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.deliveryCostMessage;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgPricing;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgBOMOutputData;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.csgBOMOutputDataRows;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.manufacturerId;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.CSG_HS_020_Price;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.CSG_HS_055_Price;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.CSG_HS_125_Price;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.CSG_HS_180_Price;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.showPrices;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.augmentPriceDataProcessing;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.user;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.operatingCompany;
    /** @type {?} */
    CleanSteamGeneratorModulePreferencesComponent.prototype.scrollToElement;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorModulePreferencesComponent.prototype.routesService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorModulePreferencesComponent.prototype.adminService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorModulePreferencesComponent.prototype.translationService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorModulePreferencesComponent.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorModulePreferencesComponent.prototype.translatePipe;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorModulePreferencesComponent.prototype.modulePreferenceService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorModulePreferencesComponent.prototype.cleanSteamGeneratorService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorModulePreferencesComponent.prototype.localeService;
    /**
     * @type {?}
     * @private
     */
    CleanSteamGeneratorModulePreferencesComponent.prototype.userProfileService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/safetyValves/modulePreference/productSelectionAdmin/productSelectionAdminModel.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SaveSafetyValvesProductSelection {
}
if (false) {
    /** @type {?} */
    SaveSafetyValvesProductSelection.prototype.selectedValvesIds;
    /** @type {?} */
    SaveSafetyValvesProductSelection.prototype.safetyValvesModuleId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/safetyValves/modulePreference/productSelectionAdmin/safetyValvesProductSelection.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SafetyValvesProductSelection {
}
if (false) {
    /**
     * Gets or sets the product names for the product range.
     * @type {?}
     */
    SafetyValvesProductSelection.prototype.productNames;
    /**
     * Gets or sets the product range Id.
     * @type {?}
     */
    SafetyValvesProductSelection.prototype.productRangeId;
    /**
     * Gets or sets the product range name.
     * @type {?}
     */
    SafetyValvesProductSelection.prototype.productRangeName;
    /**
     * Gets or sets the module group Id.
     * @type {?}
     */
    SafetyValvesProductSelection.prototype.moduleGroupId;
    /**
     * Gets or sets the product type Id.
     * @type {?}
     */
    SafetyValvesProductSelection.prototype.productTypeId;
    /**
     * Gets or sets a value indicating whether or not the current product range is selected.
     * @type {?}
     */
    SafetyValvesProductSelection.prototype.isSelected;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/safetyValves/modulePreference/productSelectionAdmin/productSelectionAdmin.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductSelectionAdminService$1 {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} moduleGroupId
     * @return {?}
     */
    getAllProductSelectionRanges(moduleGroupId) {
        return this.http.get(`./Api/SafetyValves/GetAllProductSelectionRanges/${moduleGroupId}`);
    }
    /**
     * @param {?} moduleGroupId
     * @return {?}
     */
    getProductExclusionRanges(moduleGroupId) {
        return this.http.get(`./Api/SafetyValves/GetProductExclusionRanges/${moduleGroupId}`);
    }
    /**
     * @param {?} saveSafetyValvesProductSelection
     * @return {?}
     */
    selectedSafetyValves(saveSafetyValvesProductSelection) {
        return this.http.post('./Api/SafetyValves/SaveProductSelection', saveSafetyValvesProductSelection);
    }
}
ProductSelectionAdminService$1.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ProductSelectionAdminService$1.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ ProductSelectionAdminService$1.ngInjectableDef = ɵɵdefineInjectable({ factory: function ProductSelectionAdminService_Factory() { return new ProductSelectionAdminService$1(ɵɵinject(HttpClient)); }, token: ProductSelectionAdminService$1, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ProductSelectionAdminService$1.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/safetyValves/modulePreference/productSelectionAdmin/productSelectionAdmin.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductSelectionAdminComponent {
    /**
     * @param {?} productSelectionAdminService
     * @param {?} fb
     * @param {?} cdr
     */
    constructor(productSelectionAdminService, fb, cdr) {
        this.productSelectionAdminService = productSelectionAdminService;
        this.fb = fb;
        this.cdr = cdr;
        this.isSuccess = false;
        this.isError = false;
        this.saveButtonFade = true;
        this.moduleGroupId = 1;
        this.moduleName = "Safety Valves";
        this.productSelectorOnChange = new EventEmitter();
        //@Input("module-name") moduleName: string;
        //@Input("module-group-id") moduleGroupId: number = 0;
        this.saveNewSafetyValvesSelection = new SaveSafetyValvesProductSelection();
        this.products = [];
        /* Boilerplate directive component code */
        this.internalValue = null;
        //@Input('productId') internalIdValue: number[] = null;
        this.onChange = (/**
         * @return {?}
         */
        () => { });
        this.onTouched = (/**
         * @return {?}
         */
        () => { });
    }
    /**
     * @return {?}
     */
    get selectedProducts() {
        return this.internalValue;
    }
    /**
     * @param {?} products
     * @return {?}
     */
    set selectedProducts(products) {
        this.internalValue = products;
        this.onChange(this.internalValue);
        this.onTouched();
    }
    /**
     * @param {?} __0
     * @return {?}
     */
    validate({ value }) {
        /** @type {?} */
        const isNotValid = this.selectedProducts.length === 0;
        return isNotValid && {
            invalid: true
        };
    }
    /**
     * Registers any changes to the directive and applies the provided callback function.
     * @param {?} fn The callback function.
     * @return {?}
     */
    registerOnChange(fn) {
        /** @type {?} */
        const bespokeChange = (/**
         * @param {?} newValue
         * @return {?}
         */
        (newValue) => {
            fn(newValue);
        });
        this.onChange = bespokeChange;
    }
    /**
     * Registers the touched event to the directive and applies the provided callback function.
     * @param {?} fn The callback function.
     * @return {?}
     */
    registerOnTouched(fn) {
        /** @type {?} */
        const bespokeTouched = (/**
         * @return {?}
         */
        () => {
            fn();
        });
        this.onTouched = bespokeTouched;
    }
    /**
     * Registers a final change to the provided directive's value and provides a space to apply it.
     * @param {?} value The directive's implicit value.
     * @return {?}
     */
    writeValue(value) {
        if (!!value) {
            this.selectedProducts = value;
            // Enable selected products!
            this.products.forEach((/**
             * @param {?} p
             * @return {?}
             */
            p => p.productNames.some((/**
             * @param {?} r
             * @return {?}
             */
            r => this.selectedProducts.indexOf(r) >= 0)) ? p.isSelected = true : p.isSelected = false));
        }
        else {
            // If no value is specified, use a default and set it to an empty array.
            this.selectedProducts = [];
            // Set the products to be no longer selected
            this.products.forEach((/**
             * @param {?} p
             * @return {?}
             */
            p => p.isSelected = false));
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.selectedProducts = [];
        this.valvesToSave = [];
        this.userForm = new FormGroup({
            formSelectedProducts: new FormControl(this.selectedProducts),
            formValvesToSave: new FormControl(this.valvesToSave)
        });
        // Call the service that gets the product ranges for the given module group Id.
        this.productSelectionAdminService.getProductExclusionRanges(this.moduleGroupId).toPromise().then((/**
         * @param {?} excludedProducts
         * @return {?}
         */
        excludedProducts => {
            if (!isNullOrUndefined(excludedProducts)) {
                excludedProducts.forEach((/**
                 * @param {?} valve
                 * @return {?}
                 */
                valve => this.selectedProducts.push(valve)));
            }
        }));
        if (this.moduleGroupId > 0) {
            //this.productSelectionAdminService.getAllProductRanges(this.moduleGroupId, this.productTypeId).subscribe(products => {
            this.productSelectionAdminService.getAllProductSelectionRanges(this.moduleGroupId).toPromise().then((/**
             * @param {?} products
             * @return {?}
             */
            products => {
                // The returned array of products is for every single iteration of a product for a given product range.
                // This should be condensed into product ranges only, with each product listed as an array item of that product range.
                for (const product of products) {
                    /** @type {?} */
                    const index = this.products.findIndex((/**
                     * @param {?} p
                     * @return {?}
                     */
                    p => p.productRangeId === product.productRangeId));
                    if (index > -1) {
                        // It already exists in the array, so push the product name
                        this.products[index].productNames.push(product.productName);
                    }
                    else {
                        // No item found, so create a new product selection item
                        /** @type {?} */
                        const productSelectionItem = new SafetyValvesProductSelection();
                        productSelectionItem.productRangeId = product.productRangeId;
                        productSelectionItem.productRangeName = product.productRangeName;
                        productSelectionItem.productNames = [];
                        productSelectionItem.productNames.push(product.productName);
                        productSelectionItem.moduleGroupId = product.moduleGroupId;
                        productSelectionItem.productTypeId = product.productTypeId;
                        // Determine the selected status depending on whether or not it is contained in the selected products property.
                        productSelectionItem.isSelected =
                            this.selectedProducts.findIndex((/**
                             * @param {?} sp
                             * @return {?}
                             */
                            sp => sp === product.productName)) > -1;
                        // Push the new item into the global products array
                        if (productSelectionItem.isSelected) {
                            this.valvesToSave.push(product.productRangeId);
                        }
                        this.products.push(productSelectionItem);
                    }
                }
            }));
        }
        ;
        this.internalModuleName = this.moduleName.toLowerCase().replace(/\s/g, '');
    }
    /**
     * Clicking on a product range should either add all the products in the range
     * or remove all the products from the range that has been de-selected.
     * @param {?} product
     * @return {?}
     */
    productRangeClick(product) {
        product.isSelected = !product.isSelected;
        // If the product range is now selected, add the products of the range to the array of selected products.
        if (product.isSelected) {
            this.selectedProducts = this.selectedProducts.concat(product.productNames);
            this.valvesToSave = this.valvesToSave.concat(product.productRangeId);
        }
        else {
            // Otherwise remove all the products from the list of products for that range.
            for (const productName of product.productNames) {
                /** @type {?} */
                const index = this.selectedProducts.findIndex((/**
                 * @param {?} sp
                 * @return {?}
                 */
                sp => sp === productName));
                this.selectedProducts.splice(index, 1);
            }
            /** @type {?} */
            const index = this.valvesToSave.findIndex((/**
             * @param {?} vts
             * @return {?}
             */
            vts => vts === product.productRangeId));
            this.valvesToSave.splice(index, 1);
        }
        this.onChange(this.selectedProducts);
        this.productSelectorOnChange.emit(this.selectedProducts);
        this.saveButtonFade = false;
        this.isSuccess = false;
    }
    /**
     * @return {?}
     */
    onSave() {
        //console.log('new Selected Safety Valves IDs: ' + this.valvesToSave.toString());
        this.saveNewSafetyValvesSelection.selectedValvesIds = this.valvesToSave;
        this.saveNewSafetyValvesSelection.safetyValvesModuleId = this.moduleGroupId;
        this.productSelectionAdminService.selectedSafetyValves(this.saveNewSafetyValvesSelection).subscribe((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            if (!isNullOrUndefined(result.selectedValvesIds)) {
                console.log('save isNullOrUndefined');
                this.saveButtonFade = true;
                this.isError = true;
            }
            else {
                console.log('save completed');
                this.isSuccess = true;
                this.saveButtonFade = true;
            }
        }));
    }
}
ProductSelectionAdminComponent.decorators = [
    { type: Component, args: [{
                selector: 'product-selection-admin',
                exportAs: 'product-selection-admin',
                template: "<form [formGroup]=\"userForm\">\r\n  <!-- Notification ribbons should go here -->\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <!-- Alert messages for user profile submissions -->\r\n      <alert type=\"success\" *ngIf=\"isSuccess\" dismissible=\"true\" dismissOnTimeout=\"3000\">{{'PRODUCT_SELECTION_SAVED_SUCCESSFULLY' | translate}}</alert>\r\n      <alert type=\"danger\" *ngIf=\"isError\" dismissible=\"true\">{{'PRODUCT_SELECTION_SAVE_FAILED' | translate}}</alert>\r\n\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12 text-center product-selector-container\">\r\n      <button #productSelectionButton\r\n              class=\"btn product-selection-item\"\r\n              [class.btn-default]=\"product.isSelected\"\r\n              [class.btn-primary]=\"!product.isSelected\"\r\n              *ngFor=\"let product of products\"\r\n              (click)=\"productRangeClick(product)\">\r\n\r\n        <img [src]=\"'assets/img/' + internalModuleName + '/' + product.productRangeName + '.png'\" /> <br />\r\n        {{product.productRangeName}}\r\n      </button>\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <div class=\"col-xs-12\">\r\n    <button (click)=\"onSave()\"\r\n            [disabled]=\"saveButtonFade\"\r\n            class=\"btn btn-primary pull-right\"\r\n            [title]=\"'SAVE' | translate:true\">\r\n\r\n      <i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i>\r\n\r\n    </button>\r\n  </div>\r\n\r\n</form>\r\n\r\n",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => ProductSelectionAdminComponent)),
                    }, {
                        provide: NG_VALIDATORS,
                        useExisting: ProductSelectionAdminComponent,
                        multi: true
                    }
                ],
                styles: [".home-container{margin:0 auto;max-width:970px}.home-container .home-logo{width:240px}@media only screen and (max-width:768px){.home-container .home-text{text-align:center}}.admin-module-button{margin:5px;white-space:normal}.admin-module-button em{font-size:1.6em}@media (min-width:1200px){.admin-module-button{font-size:1.4em}}.product-selector-container{background-color:#edf1f2;border-radius:8px;padding:5px}.btn-default.product-selection-item{background-color:#e4eaec}.btn-default.product-selection-item img{background-color:#fff;opacity:.5}.btn-primary.product-selection-item img{background-color:#edf1f2}.product-selection-item{margin:0 10px 10px 0;width:120px}.product-selection-item img{width:60px;height:112px;border-radius:8px;padding:5px}"]
            }] }
];
/** @nocollapse */
ProductSelectionAdminComponent.ctorParameters = () => [
    { type: ProductSelectionAdminService$1 },
    { type: FormBuilder },
    { type: ChangeDetectorRef }
];
ProductSelectionAdminComponent.propDecorators = {
    productSelectorOnChange: [{ type: Output, args: ['productSelectorOnChange',] }],
    internalValue: [{ type: Input, args: ['value',] }]
};
if (false) {
    /** @type {?} */
    ProductSelectionAdminComponent.prototype.userForm;
    /** @type {?} */
    ProductSelectionAdminComponent.prototype.isSuccess;
    /** @type {?} */
    ProductSelectionAdminComponent.prototype.isError;
    /** @type {?} */
    ProductSelectionAdminComponent.prototype.saveButtonFade;
    /** @type {?} */
    ProductSelectionAdminComponent.prototype.moduleGroupId;
    /** @type {?} */
    ProductSelectionAdminComponent.prototype.moduleName;
    /** @type {?} */
    ProductSelectionAdminComponent.prototype.productSelectorOnChange;
    /** @type {?} */
    ProductSelectionAdminComponent.prototype.saveNewSafetyValvesSelection;
    /** @type {?} */
    ProductSelectionAdminComponent.prototype.products;
    /** @type {?} */
    ProductSelectionAdminComponent.prototype.internalModuleName;
    /** @type {?} */
    ProductSelectionAdminComponent.prototype.internalValue;
    /** @type {?} */
    ProductSelectionAdminComponent.prototype.onChange;
    /** @type {?} */
    ProductSelectionAdminComponent.prototype.onTouched;
    /** @type {?} */
    ProductSelectionAdminComponent.prototype.valvesToSave;
    /**
     * @type {?}
     * @private
     */
    ProductSelectionAdminComponent.prototype.productSelectionAdminService;
    /**
     * @type {?}
     * @private
     */
    ProductSelectionAdminComponent.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    ProductSelectionAdminComponent.prototype.cdr;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/flowmeter/modulePreference/flowmeterProductSelectionAdmin/flowmeterProductSelectionAdminModel.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SaveFlowmeterProductSelection {
}
if (false) {
    /** @type {?} */
    SaveFlowmeterProductSelection.prototype.selectedValvesIds;
    /** @type {?} */
    SaveFlowmeterProductSelection.prototype.safetyValvesModuleId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/flowmeter/modulePreference/flowmeterProductSelectionAdmin/flowmeterProductSelection.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FlowmeterProductSelection {
}
if (false) {
    /**
     * Gets or sets the product names for the product range.
     * @type {?}
     */
    FlowmeterProductSelection.prototype.productNames;
    /**
     * Gets or sets the product range Id.
     * @type {?}
     */
    FlowmeterProductSelection.prototype.productRangeId;
    /**
     * Gets or sets the product range name.
     * @type {?}
     */
    FlowmeterProductSelection.prototype.productRangeName;
    /**
     * Gets or sets the module group Id.
     * @type {?}
     */
    FlowmeterProductSelection.prototype.moduleGroupId;
    /**
     * Gets or sets the product type Id.
     * @type {?}
     */
    FlowmeterProductSelection.prototype.productTypeId;
    /**
     * Gets or sets a value indicating whether or not the current product range is selected.
     * @type {?}
     */
    FlowmeterProductSelection.prototype.isSelected;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/flowmeter/modulePreference/flowmeterProductSelectionAdmin/flowmeterProductSelectionAdmin.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FlowmeterProductSelectionAdminService$1 {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} moduleGroupId
     * @return {?}
     */
    getAllProductSelectionRanges(moduleGroupId) {
        return this.http.get(`./Api/SafetyValves/GetAllProductSelectionRanges/${moduleGroupId}`);
    }
    /**
     * @param {?} moduleGroupId
     * @return {?}
     */
    getProductExclusionRanges(moduleGroupId) {
        return this.http.get(`./Api/SafetyValves/GetProductExclusionRanges/${moduleGroupId}`);
    }
    /**
     * @param {?} saveFlowmeterProductSelection
     * @return {?}
     */
    selectedFlowmeters(saveFlowmeterProductSelection) {
        return this.http.post('./Api/SafetyValves/SaveProductSelection', saveFlowmeterProductSelection);
    }
}
FlowmeterProductSelectionAdminService$1.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
FlowmeterProductSelectionAdminService$1.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ FlowmeterProductSelectionAdminService$1.ngInjectableDef = ɵɵdefineInjectable({ factory: function FlowmeterProductSelectionAdminService_Factory() { return new FlowmeterProductSelectionAdminService$1(ɵɵinject(HttpClient)); }, token: FlowmeterProductSelectionAdminService$1, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    FlowmeterProductSelectionAdminService$1.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/flowmeter/modulePreference/flowmeterProductSelectionAdmin/flowmeterProductSelectionAdmin.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FlowmeterProductSelectionAdminComponent {
    /**
     * @param {?} productSelectionAdminService
     * @param {?} fb
     * @param {?} cdr
     */
    constructor(productSelectionAdminService, fb, cdr) {
        this.productSelectionAdminService = productSelectionAdminService;
        this.fb = fb;
        this.cdr = cdr;
        this.isSuccess = false;
        this.isError = false;
        this.saveButtonFade = true;
        this.moduleGroupId = 4;
        this.moduleName = "Flow Meter";
        this.productSelectorOnChange = new EventEmitter();
        //@Input("module-name") moduleName: string;
        //@Input("module-group-id") moduleGroupId: number = 0;
        this.saveNewFlowmeterSelection = new SaveFlowmeterProductSelection();
        this.products = [];
        /* Boilerplate directive component code */
        this.internalValue = null;
        //@Input('productId') internalIdValue: number[] = null;
        this.onChange = (/**
         * @return {?}
         */
        () => { });
        this.onTouched = (/**
         * @return {?}
         */
        () => { });
    }
    /**
     * @return {?}
     */
    get selectedProducts() {
        return this.internalValue;
    }
    /**
     * @param {?} products
     * @return {?}
     */
    set selectedProducts(products) {
        this.internalValue = products;
        this.onChange(this.internalValue);
        this.onTouched();
    }
    /**
     * @param {?} __0
     * @return {?}
     */
    validate({ value }) {
        /** @type {?} */
        const isNotValid = this.selectedProducts.length === 0;
        return isNotValid && {
            invalid: true
        };
    }
    /**
     * Registers any changes to the directive and applies the provided callback function.
     * @param {?} fn The callback function.
     * @return {?}
     */
    registerOnChange(fn) {
        /** @type {?} */
        const bespokeChange = (/**
         * @param {?} newValue
         * @return {?}
         */
        (newValue) => {
            fn(newValue);
        });
        this.onChange = bespokeChange;
    }
    /**
     * Registers the touched event to the directive and applies the provided callback function.
     * @param {?} fn The callback function.
     * @return {?}
     */
    registerOnTouched(fn) {
        /** @type {?} */
        const bespokeTouched = (/**
         * @return {?}
         */
        () => {
            fn();
        });
        this.onTouched = bespokeTouched;
    }
    /**
     * Registers a final change to the provided directive's value and provides a space to apply it.
     * @param {?} value The directive's implicit value.
     * @return {?}
     */
    writeValue(value) {
        if (!!value) {
            this.selectedProducts = value;
            // Enable selected products!
            this.products.forEach((/**
             * @param {?} p
             * @return {?}
             */
            p => p.productNames.some((/**
             * @param {?} r
             * @return {?}
             */
            r => this.selectedProducts.indexOf(r) >= 0)) ? p.isSelected = true : p.isSelected = false));
        }
        else {
            // If no value is specified, use a default and set it to an empty array.
            this.selectedProducts = [];
            // Set the products to be no longer selected
            this.products.forEach((/**
             * @param {?} p
             * @return {?}
             */
            p => p.isSelected = false));
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.selectedProducts = [];
        this.metersToSave = [];
        this.userForm = new FormGroup({
            formSelectedProducts: new FormControl(this.selectedProducts),
            formValvesToSave: new FormControl(this.metersToSave)
        });
        // Call the service that gets the product ranges for the given module group Id.
        this.productSelectionAdminService.getProductExclusionRanges(this.moduleGroupId).toPromise().then((/**
         * @param {?} excludedProducts
         * @return {?}
         */
        excludedProducts => {
            if (!isNullOrUndefined(excludedProducts)) {
                excludedProducts.forEach((/**
                 * @param {?} valve
                 * @return {?}
                 */
                valve => this.selectedProducts.push(valve)));
            }
        }));
        if (this.moduleGroupId > 0) {
            //this.productSelectionAdminService.getAllProductRanges(this.moduleGroupId, this.productTypeId).subscribe(products => {
            this.productSelectionAdminService.getAllProductSelectionRanges(this.moduleGroupId).toPromise().then((/**
             * @param {?} products
             * @return {?}
             */
            products => {
                // The returned array of products is for every single iteration of a product for a given product range.
                // This should be condensed into product ranges only, with each product listed as an array item of that product range.
                for (const product of products) {
                    /** @type {?} */
                    const index = this.products.findIndex((/**
                     * @param {?} p
                     * @return {?}
                     */
                    p => p.productRangeId === product.productRangeId));
                    if (index > -1) {
                        // It already exists in the array, so push the product name
                        this.products[index].productNames.push(product.productName);
                    }
                    else {
                        // No item found, so create a new product selection item
                        /** @type {?} */
                        const productSelectionItem = new FlowmeterProductSelection();
                        productSelectionItem.productRangeId = product.productRangeId;
                        productSelectionItem.productRangeName = product.productRangeName;
                        productSelectionItem.productNames = [];
                        productSelectionItem.productNames.push(product.productName);
                        productSelectionItem.moduleGroupId = product.moduleGroupId;
                        productSelectionItem.productTypeId = product.productTypeId;
                        // Determine the selected status depending on whether or not it is contained in the selected products property.
                        productSelectionItem.isSelected =
                            this.selectedProducts.findIndex((/**
                             * @param {?} sp
                             * @return {?}
                             */
                            sp => sp === product.productName)) > -1;
                        // Push the new item into the global products array
                        if (productSelectionItem.isSelected) {
                            this.metersToSave.push(product.productRangeId);
                        }
                        this.products.push(productSelectionItem);
                    }
                }
            }));
        }
        ;
        this.internalModuleName = this.moduleName.toLowerCase().replace(/\s/g, '');
    }
    /**
     * Clicking on a product range should either add all the products in the range
     * or remove all the products from the range that has been de-selected.
     * @param {?} product
     * @return {?}
     */
    productRangeClick(product) {
        product.isSelected = !product.isSelected;
        // If the product range is now selected, add the products of the range to the array of selected products.
        if (product.isSelected) {
            this.selectedProducts = this.selectedProducts.concat(product.productNames);
            this.metersToSave = this.metersToSave.concat(product.productRangeId);
        }
        else {
            // Otherwise remove all the products from the list of products for that range.
            for (const productName of product.productNames) {
                /** @type {?} */
                const index = this.selectedProducts.findIndex((/**
                 * @param {?} sp
                 * @return {?}
                 */
                sp => sp === productName));
                this.selectedProducts.splice(index, 1);
            }
            /** @type {?} */
            const index = this.metersToSave.findIndex((/**
             * @param {?} vts
             * @return {?}
             */
            vts => vts === product.productRangeId));
            this.metersToSave.splice(index, 1);
        }
        this.onChange(this.selectedProducts);
        this.productSelectorOnChange.emit(this.selectedProducts);
        this.saveButtonFade = false;
        this.isSuccess = false;
    }
    /**
     * @return {?}
     */
    onSave() {
        //console.log('new Selected Flow Meters IDs: ' + this.metersToSave.toString());
        this.saveNewFlowmeterSelection.selectedValvesIds = this.metersToSave;
        this.saveNewFlowmeterSelection.safetyValvesModuleId = this.moduleGroupId;
        this.productSelectionAdminService.selectedFlowmeters(this.saveNewFlowmeterSelection).subscribe((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            if (!isNullOrUndefined(result.selectedValvesIds)) {
                console.log('save isNullOrUndefined');
                this.saveButtonFade = true;
                this.isError = true;
            }
            else {
                console.log('save completed');
                this.isSuccess = true;
                this.saveButtonFade = true;
            }
        }));
    }
}
FlowmeterProductSelectionAdminComponent.decorators = [
    { type: Component, args: [{
                selector: 'flowmeter-product-selection-admin',
                exportAs: 'flowmeter-product-selection-admin',
                template: "<form [formGroup]=\"userForm\">\r\n  <!-- Notification ribbons should go here -->\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <!-- Alert messages for user profile submissions -->\r\n      <alert type=\"success\" *ngIf=\"isSuccess\" dismissible=\"true\" dismissOnTimeout=\"3000\">{{'PRODUCT_SELECTION_SAVED_SUCCESSFULLY' | translate}}</alert>\r\n      <alert type=\"danger\" *ngIf=\"isError\" dismissible=\"true\">{{'PRODUCT_SELECTION_SAVE_FAILED' | translate}}</alert>\r\n\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12 text-center product-selector-container\">\r\n      <button #productSelectionButton\r\n              class=\"btn product-selection-item\"\r\n              [class.btn-default]=\"product.isSelected\"\r\n              [class.btn-primary]=\"!product.isSelected\"\r\n              *ngFor=\"let product of products\"\r\n              (click)=\"productRangeClick(product)\">\r\n\r\n        <img [src]=\"'assets/img/' + internalModuleName + '/' + product.productRangeName + '.png'\" /> <br />\r\n        {{product.productRangeName}}\r\n      </button>\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <div class=\"col-xs-12\">\r\n    <button (click)=\"onSave()\"\r\n            [disabled]=\"saveButtonFade\"\r\n            class=\"btn btn-primary pull-right\"\r\n            [title]=\"'SAVE' | translate:true\">\r\n\r\n      <i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i>\r\n\r\n    </button>\r\n  </div>\r\n\r\n</form>\r\n\r\n",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => FlowmeterProductSelectionAdminComponent)),
                    }, {
                        provide: NG_VALIDATORS,
                        useExisting: FlowmeterProductSelectionAdminComponent,
                        multi: true
                    }
                ],
                styles: [".home-container{margin:0 auto;max-width:970px}.home-container .home-logo{width:240px}@media only screen and (max-width:768px){.home-container .home-text{text-align:center}}.admin-module-button{margin:5px;white-space:normal}.admin-module-button em{font-size:1.6em}@media (min-width:1200px){.admin-module-button{font-size:1.4em}}.product-selector-container{background-color:#edf1f2;border-radius:8px;padding:5px}.btn-default.product-selection-item{background-color:#e4eaec}.btn-default.product-selection-item img{background-color:#fff;opacity:.5}.btn-primary.product-selection-item img{background-color:#edf1f2}.product-selection-item{margin:0 10px 10px 0;width:120px}.product-selection-item img{width:60px;height:112px;border-radius:8px;padding:5px}"]
            }] }
];
/** @nocollapse */
FlowmeterProductSelectionAdminComponent.ctorParameters = () => [
    { type: FlowmeterProductSelectionAdminService$1 },
    { type: FormBuilder },
    { type: ChangeDetectorRef }
];
FlowmeterProductSelectionAdminComponent.propDecorators = {
    productSelectorOnChange: [{ type: Output, args: ['productSelectorOnChange',] }],
    internalValue: [{ type: Input, args: ['value',] }]
};
if (false) {
    /** @type {?} */
    FlowmeterProductSelectionAdminComponent.prototype.userForm;
    /** @type {?} */
    FlowmeterProductSelectionAdminComponent.prototype.isSuccess;
    /** @type {?} */
    FlowmeterProductSelectionAdminComponent.prototype.isError;
    /** @type {?} */
    FlowmeterProductSelectionAdminComponent.prototype.saveButtonFade;
    /** @type {?} */
    FlowmeterProductSelectionAdminComponent.prototype.moduleGroupId;
    /** @type {?} */
    FlowmeterProductSelectionAdminComponent.prototype.moduleName;
    /** @type {?} */
    FlowmeterProductSelectionAdminComponent.prototype.productSelectorOnChange;
    /** @type {?} */
    FlowmeterProductSelectionAdminComponent.prototype.saveNewFlowmeterSelection;
    /** @type {?} */
    FlowmeterProductSelectionAdminComponent.prototype.products;
    /** @type {?} */
    FlowmeterProductSelectionAdminComponent.prototype.internalModuleName;
    /** @type {?} */
    FlowmeterProductSelectionAdminComponent.prototype.internalValue;
    /** @type {?} */
    FlowmeterProductSelectionAdminComponent.prototype.onChange;
    /** @type {?} */
    FlowmeterProductSelectionAdminComponent.prototype.onTouched;
    /** @type {?} */
    FlowmeterProductSelectionAdminComponent.prototype.metersToSave;
    /**
     * @type {?}
     * @private
     */
    FlowmeterProductSelectionAdminComponent.prototype.productSelectionAdminService;
    /**
     * @type {?}
     * @private
     */
    FlowmeterProductSelectionAdminComponent.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    FlowmeterProductSelectionAdminComponent.prototype.cdr;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/easiHeat/modulePreference/easiHeatPricingOptions.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//import { Message } from '../../../core/messages/message.model';
//import { Message } from "sizing-shared-lib";
/*************************************
    MODULE PREFERENCES VERSION!
**************************************/
/**
 * The CleanSteamGeneratorPricing model.
 */
class EasiHeatPricing {
}
if (false) {
    /**
     * Gets or sets the modelId.
     * @type {?}
     */
    EasiHeatPricing.prototype.modelId;
    /**
     * Gets or sets the manufacturerId.
     * @type {?}
     */
    EasiHeatPricing.prototype.manufacturerId;
    /**
     * Gets or sets the basePriceOption.
     * @type {?}
     */
    EasiHeatPricing.prototype.basePriceOption;
    /**
     * Gets or sets the localRecommendedSalesPriceOption.
     * @type {?}
     */
    EasiHeatPricing.prototype.localRecommendedSalesPriceOption;
    /**
     * Gets or sets the landedCostIncreaseFactor.
     * @type {?}
     */
    EasiHeatPricing.prototype.landedCostIncreaseFactor;
    /**
     * Gets or sets the pricingOptions.
     * @type {?}
     */
    EasiHeatPricing.prototype.pricingOptions;
}
class EasiHeatPricingOption {
}
if (false) {
    /**
     * Gets or sets the enumerationName.
     * @type {?}
     */
    EasiHeatPricingOption.prototype.enumerationName;
    /**
     * Gets or sets the selectedValue.
     * @type {?}
     */
    EasiHeatPricingOption.prototype.selectedValue;
}
class EasiHeatPricingOutput {
}
if (false) {
    /**
     * Gets or sets the totalPrice.
     * @type {?}
     */
    EasiHeatPricingOutput.prototype.totalSalesPrice;
    /**
     * Gets or sets the totalRecommendedSalesPrice.
     * @type {?}
     */
    EasiHeatPricingOutput.prototype.totalRecommendedSalesPrice;
}
class EasiHeatBOMPriceOutput {
}
if (false) {
    /**
     * Gets or sets the BOMItems.
     * @type {?}
     */
    EasiHeatBOMPriceOutput.prototype.bomItems;
}
class BOMItem$2 {
    constructor() {
        /**
         * Gets or sets the isEnabled.
         */
        this.isEnabled = true;
    }
}
if (false) {
    /**
     * Gets or sets the rowOrder.
     * @type {?}
     */
    BOMItem$2.prototype.rowOrder;
    /**
     * Gets or sets the itemType.
     * @type {?}
     */
    BOMItem$2.prototype.itemType;
    /**
     * Gets or sets the modelId.
     * @type {?}
     */
    BOMItem$2.prototype.modelId;
    /**
     * Gets or sets the parent.
     * @type {?}
     */
    BOMItem$2.prototype.parent;
    /**
     * Gets or sets the parentMasterTextKey.
     * @type {?}
     */
    BOMItem$2.prototype.parentMasterTextKey;
    /**
     * Gets or sets the parentTranslation.
     * @type {?}
     */
    BOMItem$2.prototype.parentTranslation;
    /**
     * Gets or sets the item.
     * @type {?}
     */
    BOMItem$2.prototype.item;
    /**
     * Gets or sets the itemTranslation.
     * @type {?}
     */
    BOMItem$2.prototype.itemTranslation;
    /**
     * Gets or sets the itemMasterTextKey.
     * @type {?}
     */
    BOMItem$2.prototype.itemMasterTextKey;
    /**
     * Gets or sets the sequenceDefault.
     * @type {?}
     */
    BOMItem$2.prototype.sequenceDefault;
    /**
     * Gets or sets the sequenceOverride.
     * @type {?}
     */
    BOMItem$2.prototype.sequenceOverride;
    /**
     * Gets or sets the landedAdjusted.
     * @type {?}
     */
    BOMItem$2.prototype.landedAdjusted;
    /**
     * Gets or sets the ssp.
     * @type {?}
     */
    BOMItem$2.prototype.ssp;
    /**
     * Gets or sets the ssPtoRSPfactor.
     * @type {?}
     */
    BOMItem$2.prototype.ssPtoRSPfactor;
    /**
     * Gets or sets the recommendedSalesPrice.
     * @type {?}
     */
    BOMItem$2.prototype.recommendedSalesPrice;
    /**
     * Gets or sets the rsPtoRSPOfactor.
     * @type {?}
     */
    BOMItem$2.prototype.rsPtoRSPOfactor;
    /**
     * Gets or sets the recommendedSalesPriceOverride.
     * @type {?}
     */
    BOMItem$2.prototype.recommendedSalesPriceOverride;
    /**
     * Gets or sets the displayedRSP.
     * @type {?}
     */
    BOMItem$2.prototype.displayedRSP;
    /**
     * Gets or sets the manCurrency.
     * @type {?}
     */
    BOMItem$2.prototype.manCurrency;
    /**
     * Gets or sets the displayedRSP.
     * @type {?}
     */
    BOMItem$2.prototype.manRateToGBP;
    /**
     * Gets or sets the displayedRSP.
     * @type {?}
     */
    BOMItem$2.prototype.manCurrencyId;
    /**
     * Gets or sets the priceDataUTCDate.
     * @type {?}
     */
    BOMItem$2.prototype.priceDataUTCDate;
    /**
     * Gets or sets the sLandedAdjusted.
     * @type {?}
     */
    BOMItem$2.prototype.sLandedAdjusted;
    /**
     * Gets or sets the sSSP.
     * @type {?}
     */
    BOMItem$2.prototype.sSSP;
    /**
     * Gets or sets the sRecommendedSalesPrice.
     * @type {?}
     */
    BOMItem$2.prototype.sRecommendedSalesPrice;
    /**
     * Gets or sets the sRecommendedSalesPriceOverride.
     * @type {?}
     */
    BOMItem$2.prototype.sRecommendedSalesPriceOverride;
    /**
     * Gets or sets the sDisplayedRSP.
     * @type {?}
     */
    BOMItem$2.prototype.sDisplayedRSP;
    /**
     * Gets or sets the sellingCurrency.
     * @type {?}
     */
    BOMItem$2.prototype.sellingCurrency;
    /**
     * Gets or sets the sellingRateToGBP.
     * @type {?}
     */
    BOMItem$2.prototype.sellingRateToGBP;
    /**
     * Gets or sets the sellingCurrencyId.
     * @type {?}
     */
    BOMItem$2.prototype.sellingCurrencyId;
    /**
     * Gets or sets the isEnabled.
     * @type {?}
     */
    BOMItem$2.prototype.isEnabled;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/easiHeat/modulePreference/easiHeat.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * **********************************
 * MODULE PREFERENCES VERSION!
 * ************************************
 */
class EasiHeatService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} ehPricing
     * @return {?}
     */
    calculateBOMPrice(ehPricing) {
        return this.http.post(`./Api/EasiHeat/CalculateBOMPrice`, ehPricing);
    }
}
EasiHeatService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
EasiHeatService.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    EasiHeatService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/user-profile/user.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class User {
    constructor() {
        this.userId = 0;
        this.username = "";
        this.password = "";
        this.confirmPassword = "";
        this.firstname = "";
        this.lastname = "";
        this.email = "";
        this.memorableWord = "";
        this.company = "";
        this.address = "";
        this.telephone = "";
        this.companyPosition = "";
        this.industryEnum = "";
        this.tradeEnum = "";
        this.hasAgreedDpa = false;
        this.languageId = 0;
        this.languageIsoName = "";
        this.roleId = 0;
        this.operatingCompanyId = 0;
        this.operatingCompanyName = "";
        this.countryId = 0;
        this.countryCode = "";
        this.isDeleted = false;
    }
}
if (false) {
    /** @type {?} */
    User.prototype.userId;
    /** @type {?} */
    User.prototype.username;
    /** @type {?} */
    User.prototype.password;
    /** @type {?} */
    User.prototype.confirmPassword;
    /** @type {?} */
    User.prototype.firstname;
    /** @type {?} */
    User.prototype.lastname;
    /** @type {?} */
    User.prototype.email;
    /** @type {?} */
    User.prototype.memorableWord;
    /** @type {?} */
    User.prototype.company;
    /** @type {?} */
    User.prototype.address;
    /** @type {?} */
    User.prototype.telephone;
    /** @type {?} */
    User.prototype.companyPosition;
    /** @type {?} */
    User.prototype.industryEnum;
    /** @type {?} */
    User.prototype.tradeEnum;
    /** @type {?} */
    User.prototype.isAccountLocked;
    /** @type {?} */
    User.prototype.hasAgreedDpa;
    /** @type {?} */
    User.prototype.languageId;
    /** @type {?} */
    User.prototype.languageIsoName;
    /** @type {?} */
    User.prototype.roleId;
    /** @type {?} */
    User.prototype.operatingCompanyId;
    /** @type {?} */
    User.prototype.operatingCompanyName;
    /** @type {?} */
    User.prototype.countryId;
    /** @type {?} */
    User.prototype.countryCode;
    /** @type {?} */
    User.prototype.isDeleted;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/easiHeat/modulePreference/easiHeat.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EasiHeatPreferencesComponent {
    /**
     * @param {?} routesService
     * @param {?} adminService
     * @param {?} translationService
     * @param {?} fb
     * @param {?} translatePipe
     * @param {?} modulePreferenceService
     * @param {?} easiHeatService
     * @param {?} localeService
     * @param {?} userProfileService
     * @param {?} user
     */
    constructor(routesService, adminService, translationService, fb, translatePipe, modulePreferenceService, easiHeatService, localeService, userProfileService, user) {
        this.routesService = routesService;
        this.adminService = adminService;
        this.translationService = translationService;
        this.fb = fb;
        this.translatePipe = translatePipe;
        this.modulePreferenceService = modulePreferenceService;
        this.easiHeatService = easiHeatService;
        this.localeService = localeService;
        this.userProfileService = userProfileService;
        this.user = user;
        this.moduleId = "5";
        this.moduleGroupId = 3;
        this.cloneDeep = cloneDeep_;
        this.moduleName = "EasiHeat";
        // for scroll to view
        this.componentInitialised = false;
        this.componentLoadPromises = [];
        // to drive GenericChangesGuard
        this.isSuccess = false;
        this.alertVisible = false;
        this.formSubmitted = false;
        //*** Regular module prefs ***
        // Currency Options
        this.manufacturerList = [];
        this.currencyList = [];
        this.easiHeatBOMOutputDataRows = [];
        this.showPrices = false;
        this.augmentPriceDataProcessing = true; // disable button whilst page loading
        // disable button whilst page loading
        this.overrideMarkupActive = false;
        this.cvSplitRange = false;
        this.SellSteamControl = false;
        this.MotiveInletPressureAvailable = false;
        this.YearOne = false;
        this.YearTwo = false;
        this.YearThree = false;
        this.PrvAllowed = false;
        this.HideHEmodelFromSizing = false;
        this.scrollToElement = (/**
         * @param {?} elementRef
         * @param {?=} position
         * @return {?}
         */
        (elementRef, position = "start") => {
            // ToDo: Fix fussy scroll on first sizing bug. Hence the use of timeout delay here.
            setTimeout((/**
             * @return {?}
             */
            () => {
                try {
                    elementRef.nativeElement.scrollIntoView({ block: position, behavior: "smooth" });
                }
                catch (err) {
                    console.log(`scrollToElement err=${err}`);
                }
            }), 200);
        });
        this.userProfileService.getUserDetails().subscribe((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            this.user = user;
            if (!!this.user) {
                this.operatingCompany = " : " + this.user.operatingCompanyName;
            }
        }));
        this.easiHeatBOMOutputData = new EasiHeatBOMPriceOutput();
        //var userType = this.
        this.easiHeatManufacturerPrefFormControl = new FormControl({ value: '' });
        this.easiHeatManufacturerCurrencyModulePreference = new FormControl({ value: '' });
        this.easiHeatSellingCurrencyPrefFormControl = new FormControl('');
        this.easiHeatLandedCostIncreasePrefFormControl = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatDeliveryCostPrefFormControl = new FormControl('', [Validators.required]);
        this.easiHeatCommissionOnlyPricePrefFormControl = new FormControl('', [Validators.required]);
        this.easiHeatWarrantyOneYearPrefFormControl = new FormControl('', [Validators.required]);
        this.easiHeatWarrantyTwoYearsPrefFormControl = new FormControl('', [Validators.required]);
        this.easiHeatWarrantyThreeYearsPrefFormControl = new FormControl('', [Validators.required]);
        this.easiHeatOptionsFormControl = new FormControl({ value: '', disabled: false });
        //Heat Exchanger
        this.easiHeatHeatExchangerTS6 = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatHeatExchangerT6 = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatHeatExchangerT8 = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatHeatExchangerT10 = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatPricingCurrency = new FormControl({ value: '', disabled: false });
        this.easiHeatOverrideMarkup = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatOverrideMarkupActive = new FormControl(false); //checkbox  
        this.easiHeatSellingMarkup = new FormControl({ value: '', disabled: false });
        this.easiHeatLandedCostIncreaseModPref = new FormControl('', [Validators.required]);
        this.easiHeatDeliveryCostModPref = new FormControl('', [Validators.required]);
        this.easiHeatCommissionOnly = new FormControl('', [Validators.required]);
        this.easiHeatCvSplitRange = new FormControl(false); //checkbox
        this.easiHeatSteamSideControlOnHTG = new FormControl(false); //checkbox
        this.easiHeatMotiveInletPressureAvailable = new FormControl(false); //checkbox
        this.easiHeatPRVAvailableOnEHHCC = new FormControl(false); //checkbox 
        this.easiHeatHideHEModelFromSizing = new FormControl(false); //checkbox
        this.easi_Heat_DHW_And_HTG_Sc_Options_Actuator = new FormControl(null);
        this.easi_HTG_CC_Options_Actuator = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_DesignCode = new FormControl(null);
        this.easi_HTG_CC_Options_DesignCode = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_HighLimit = new FormControl(null);
        this.easi_HTG_CC_Options_HighLimit = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_HighLimitActuation = new FormControl(null);
        this.easi_HTG_CC_Options_HighLimitActuation = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_Isolation = new FormControl(null);
        this.easi_HTG_CC_Options_Isolation = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_ControlPanel = new FormControl(null);
        this.easi_HTG_CC_Options_ControlPanel = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_ServiceOffering = new FormControl(null);
        this.easi_HTG_CC_Options_ServiceOffering = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_Gasket = new FormControl(null);
        this.easi_HTG_CC_Options_Gasket = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_RemoteAccess = new FormControl(null);
        this.easi_HTG_CC_Options_RemoteAccess = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_Communications = new FormControl(null);
        this.easi_HTG_CC_Options_Communications = new FormControl(null);
        this.easiHeat_DHW_AdditionalOptions = new FormControl(null);
        this.easiHeat_HTG_AdditionalOptions = new FormControl(null);
        this.easiHeatDHWAvailable = new FormControl({ value: false, disabled: false });
        this.easiHeatDHWOn = new FormControl({ value: false, disabled: false });
        this.easiHeatDHWOff = new FormControl({ value: false, disabled: false });
        this.easiHeatHTGAvailable = new FormControl({ value: false, disabled: false });
        this.easiHeatHTGOn = new FormControl({ value: false, disabled: false });
        this.easiHeatHTGOff = new FormControl({ value: false, disabled: false });
        this.easiHeatEnergyMonitoring_Available_DHW = new FormControl(false); //Checkbox
        this.easiHeatEnergyMonitoring_Default_DHW = new FormControl(false); //Checkbox
        this.easiHeatJackingWheels_Available_DHW = new FormControl(false); //Checkbox
        this.easiHeatJackingWheels_Default_DHW = new FormControl(false); //Checkbox
        this.easiHeatENCompliant_Available_DHW = new FormControl(false); //Checkbox
        this.easiHeatENCompliant_Default_DHW = new FormControl(false); //Checkbox
        this.easiHeatEnergyMonitoring_Available_HTG = new FormControl(false); //Checkbox
        this.easiHeatEnergyMonitoring_Default_HTG = new FormControl(false); //Checkbox
        this.easiHeatJackingWheels_Available_HTG = new FormControl(false); //Checkbox
        this.easiHeatJackingWheels_Default_HTG = new FormControl(false); //Checkbox
        this.easiHeatENCompliant_Available_HTG = new FormControl(false); //Checkbox
        this.easiHeatENCompliant_Default_HTG = new FormControl(false); //Checkbox
        // Setup the form group.
        this.modulePreferencesForm = this.fb.group({
            // Currency Options
            easiHeatManufacturerModulePreference: this.easiHeatManufacturerPrefFormControl,
            easiHeatManufacturerCurrencyModulePreference: this.easiHeatManufacturerCurrencyModulePreference,
            easiHeatSellingCurrencyModulePreference: this.easiHeatSellingCurrencyPrefFormControl,
            //Heat Exchanger
            easiHeatHeatExchangerTS6: this.easiHeatHeatExchangerTS6,
            easiHeatHeatExchangerT6: this.easiHeatHeatExchangerT6,
            easiHeatHeatExchangerT8: this.easiHeatHeatExchangerT8,
            easiHeatHeatExchangerT10: this.easiHeatHeatExchangerT10,
            easiHeatPricingCurrency: this.easiHeatPricingCurrency,
            easiHeatOverrideMarkup: this.easiHeatOverrideMarkup,
            easiHeatOverrideMarkupActive: this.easiHeatOverrideMarkupActive,
            easiHeatSellingMarkup: this.easiHeatSellingMarkup,
            easiHeatLandedCostIncreaseModPref: this.easiHeatLandedCostIncreaseModPref,
            easiHeatDeliveryCostModPref: this.easiHeatDeliveryCostModPref,
            easiHeatCommissionOnly: this.easiHeatCommissionOnly,
            easiHeatCvSplitRange: this.easiHeatCvSplitRange,
            easiHeatSteamSideControlOnHTG: this.easiHeatSteamSideControlOnHTG,
            easiHeatMotiveInletPressureAvailable: this.easiHeatMotiveInletPressureAvailable,
            easiHeatPRVAvailableOnEHHCC: this.easiHeatPRVAvailableOnEHHCC,
            easiHeatHideHEModelFromSizing: this.easiHeatHideHEModelFromSizing,
            easi_Heat_DHW_And_HTG_Sc_Options_Actuator: this.easi_Heat_DHW_And_HTG_Sc_Options_Actuator,
            easi_HTG_CC_Options_Actuator: this.easi_HTG_CC_Options_Actuator,
            easiHeatDHWandHTGScOptions_DesignCode: this.easiHeatDHWandHTGScOptions_DesignCode,
            easi_HTG_CC_Options_DesignCode: this.easi_HTG_CC_Options_DesignCode,
            easiHeatDHWandHTGScOptions_HighLimit: this.easiHeatDHWandHTGScOptions_HighLimit,
            easi_HTG_CC_Options_HighLimit: this.easi_HTG_CC_Options_HighLimit,
            easiHeatDHWandHTGScOptions_HighLimitActuation: this.easiHeatDHWandHTGScOptions_HighLimitActuation,
            easi_HTG_CC_Options_HighLimitActuation: this.easi_HTG_CC_Options_HighLimitActuation,
            easiHeatDHWandHTGScOptions_Isolation: this.easiHeatDHWandHTGScOptions_Isolation,
            easi_HTG_CC_Options_Isolation: this.easi_HTG_CC_Options_Isolation,
            easiHeatDHWandHTGScOptions_ControlPanel: this.easiHeatDHWandHTGScOptions_ControlPanel,
            easi_HTG_CC_Options_ControlPanel: this.easi_HTG_CC_Options_ControlPanel,
            easiHeatDHWandHTGScOptions_ServiceOffering: this.easiHeatDHWandHTGScOptions_ServiceOffering,
            easi_HTG_CC_Options_ServiceOffering: this.easi_HTG_CC_Options_ServiceOffering,
            easiHeatDHWandHTGScOptions_Gasket: this.easiHeatDHWandHTGScOptions_Gasket,
            easi_HTG_CC_Options_Gasket: this.easi_HTG_CC_Options_Gasket,
            easiHeatDHWandHTGScOptions_RemoteAccess: this.easiHeatDHWandHTGScOptions_RemoteAccess,
            easi_HTG_CC_Options_RemoteAccess: this.easi_HTG_CC_Options_RemoteAccess,
            easiHeatDHWandHTGScOptions_Communications: this.easiHeatDHWandHTGScOptions_Communications,
            easi_HTG_CC_Options_Communications: this.easi_HTG_CC_Options_Communications,
            easiHeat_DHW_AdditionalOptions: this.easiHeat_DHW_AdditionalOptions,
            easiHeat_HTG_AdditionalOptions: this.easiHeat_HTG_AdditionalOptions,
            easiHeatDHWAvailable: this.easiHeatDHWAvailable,
            easiHeatDHWOn: this.easiHeatDHWOn,
            easiHeatDHWOff: this.easiHeatDHWOff,
            easiHeatHTGAvailable: this.easiHeatHTGAvailable,
            easiHeatHTGOn: this.easiHeatHTGOn,
            easiHeatHTGOff: this.easiHeatHTGOff,
            easiHeatEnergyMonitoring_Available_DHW: this.easiHeatEnergyMonitoring_Available_DHW,
            easiHeatEnergyMonitoring_Default_DHW: this.easiHeatEnergyMonitoring_Default_DHW,
            easiHeatJackingWheels_Available_DHW: this.easiHeatJackingWheels_Available_DHW,
            easiHeatJackingWheels_Default_DHW: this.easiHeatJackingWheels_Default_DHW,
            easiHeatENCompliant_Available_DHW: this.easiHeatENCompliant_Available_DHW,
            easiHeatENCompliant_Default_DHW: this.easiHeatENCompliant_Default_DHW,
            easiHeatEnergyMonitoring_Available_HTG: this.easiHeatEnergyMonitoring_Available_HTG,
            easiHeatEnergyMonitoring_Default_HTG: this.easiHeatEnergyMonitoring_Default_HTG,
            easiHeatJackingWheels_Available_HTG: this.easiHeatJackingWheels_Available_HTG,
            easiHeatJackingWheels_Default_HTG: this.easiHeatJackingWheels_Default_HTG,
            easiHeatENCompliant_Available_HTG: this.easiHeatENCompliant_Available_HTG,
            easiHeatENCompliant_Default_HTG: this.easiHeatENCompliant_Default_HTG,
            // Pricing Options
            easiHeatLandedCostIncreaseModulePreference: this.easiHeatLandedCostIncreasePrefFormControl,
            easiHeatDeliveryCostModulePreference: this.easiHeatDeliveryCostPrefFormControl,
            easiHeatCommissionOnlyPriceModulePreference: this.easiHeatCommissionOnlyPricePrefFormControl,
            easiHeatWarrantyOneYearModulePreference: this.easiHeatWarrantyOneYearPrefFormControl,
            easiHeatWarrantyTwoYearsModulePreference: this.easiHeatWarrantyTwoYearsPrefFormControl,
            easiHeatWarrantyThreeYearsModulePreference: this.easiHeatWarrantyThreeYearsPrefFormControl,
            // Option Configuration
            easiHeatOptionsSelection: this.easiHeatOptionsFormControl,
        }, { updateOn: "change" });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        console.log("Initializing EasiHeat module prefs component");
        // First, get all the module preferences.
        //this.modulePreferencesForm.markAsPristine();
        // this.easiHeatCvSplitRange.markAsDirty();
        this.componentLoadPromises.push(this.userProfileService.getUserDetails().toPromise().then((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            this.user = user;
            //3 = sales admin
            //4 = super admin
            if (this.user.roleId == 3 || this.user.roleId == 4) {
            }
            else {
                this.easiHeatManufacturerPrefFormControl.disable();
                this.easiHeatManufacturerCurrencyModulePreference.disable();
            }
        })));
        //    this.easiHeatManufacturerPrefFormControl = new FormControl({ value: '', disabled: true });
        //    this.easiHeatManufacturerCurrencyModulePreference = new FormControl({ value: '', disabled: true });
        this.componentLoadPromises.push(this.modulePreferenceService.getOperatingCompanyModulePreferences(this.moduleId).toPromise().then((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            if (result && result.length > 0) {
                // And set their values accordingly.
                this.manufacturerId = +this.getModulePreferenceValue(result, "Manufacturer");
                this.easiHeatManufacturerPrefFormControl.setValue(this.manufacturerId);
                this.easiHeatManufacturerCurrencyId = +this.getModulePreferenceValue(result, "ManufacturerCurrency");
                this.easiHeatManufacturerCurrencyModulePreference.setValue(this.easiHeatManufacturerCurrencyId);
                this.easiHeatSellingCurrencyId = +this.getModulePreferenceValue(result, "SellingCurrency");
                this.easiHeatSellingCurrencyPrefFormControl.setValue(this.easiHeatSellingCurrencyId);
                // Calculate the currency conversion rate.
                this.onSellingCurrencyChange(this.easiHeatSellingCurrencyId);
                //this.easiHeatManufacturerCurrencyModulePreference.setValue(this.getModulePreferenceValue(result, "CurrencyConversion"));
                this.easiHeatHeatExchangerTS6.setValue(this.getModulePreferenceValue(result, "HETS6Discount")); //ts6
                this.easiHeatHeatExchangerT6.setValue(this.getModulePreferenceValue(result, "HEM6Discount")); //t6
                this.easiHeatHeatExchangerT8.setValue(this.getModulePreferenceValue(result, "HEM10Discount")); //t8
                this.easiHeatHeatExchangerT10.setValue(this.getModulePreferenceValue(result, "HET10")); //t10 
                this.easiHeatPricingCurrency.setValue(this.getModulePreferenceValue(result, "HEPricingCurrency"));
                this.easiHeatOverrideMarkup.setValue(this.getModulePreferenceValue(result, "HEOverridenP251MarkupValue"));
                this.easiHeatSellingMarkup.setValue(this.getModulePreferenceValue(result, "SellingMarkup"));
                this.easiHeatLandedCostIncrease = this.getModulePreferenceValue(result, "LandCostIncrease");
                this.easiHeatLandedCostIncreaseModPref.setValue(this.easiHeatLandedCostIncrease);
                this.easiHeatDeliveryCostModPref.setValue(this.getModulePreferenceValue(result, "DeliveryCost"));
                this.easiHeatCommissionOnly.setValue(this.getModulePreferenceValue(result, "Commission"));
                //Below is a temporary fix as to ensure that a boolean is passed through for the checkboxes.
                //Fix is necessary as the data reads as a string and not a boolean. The data types needs changing/fixing in the database.
                //Table:  OperatingCompanyModulePreferences
                if (this.getModulePreferenceValue(result, "HEOverridenP251Markup") == "True" || this.getModulePreferenceValue(result, "HEOverridenP251Markup") == "true") {
                    this.overrideMarkupActive = true;
                }
                else {
                    this.overrideMarkupActive = false;
                }
                if (this.getModulePreferenceValue(result, "CVSplitRange") == "True" || this.getModulePreferenceValue(result, "CVSplitRange") == "true") {
                    this.cvSplitRange = true;
                }
                else {
                    this.cvSplitRange = false;
                }
                if (this.getModulePreferenceValue(result, "SellSteamControl") == "True" || this.getModulePreferenceValue(result, "SellSteamControl") == "true") {
                    this.SellSteamControl = true;
                }
                else {
                    this.SellSteamControl = false;
                }
                if (this.getModulePreferenceValue(result, "MotiveInletPressureAvailable") == "True" || this.getModulePreferenceValue(result, "MotiveInletPressureAvailable") == "true") {
                    this.MotiveInletPressureAvailable = true;
                }
                else {
                    this.MotiveInletPressureAvailable = false;
                }
                if (this.getModulePreferenceValue(result, "PrvAllowed") == "True" || this.getModulePreferenceValue(result, "PrvAllowed") == "true") {
                    this.PrvAllowed = true;
                }
                else {
                    this.PrvAllowed = false;
                }
                if (this.getModulePreferenceValue(result, "HideHEmodelFromSizing") == "True" || this.getModulePreferenceValue(result, "HideHEmodelFromSizing") == "true") {
                    this.HideHEmodelFromSizing = true;
                }
                else {
                    this.HideHEmodelFromSizing = false;
                }
                this.easiHeatOverrideMarkupActive.setValue(this.overrideMarkupActive);
                this.easiHeatCvSplitRange.setValue(this.cvSplitRange);
                this.easiHeatSteamSideControlOnHTG.setValue(this.SellSteamControl);
                this.easiHeatMotiveInletPressureAvailable.setValue(this.MotiveInletPressureAvailable);
                this.easiHeatPRVAvailableOnEHHCC.setValue(this.PrvAllowed);
                this.easiHeatHideHEModelFromSizing.setValue(this.HideHEmodelFromSizing);
                this.easiHeatWarrantyOneYearPrefFormControl.setValue(this.getModulePreferenceValue(result, "YearOne"));
                this.easiHeatWarrantyTwoYearsPrefFormControl.setValue(this.getModulePreferenceValue(result, "YearTwo"));
                this.easiHeatWarrantyThreeYearsPrefFormControl.setValue(this.getModulePreferenceValue(result, "YearThree"));
                if (this.getModulePreferenceValue(result, "EnergyMonitoringAvailableDHW") == "True" || this.getModulePreferenceValue(result, "EnergyMonitoringAvailableDHW") == "true") {
                    this.easiHeatEnergyMonitoring_Available_DHW.setValue(true);
                }
                else {
                    this.easiHeatEnergyMonitoring_Available_DHW.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "EnergyMonitoringDefaultDHW") == "True" || this.getModulePreferenceValue(result, "EnergyMonitoringDefaultDHW") == "true") {
                    this.easiHeatEnergyMonitoring_Default_DHW.setValue(true);
                }
                else {
                    this.easiHeatEnergyMonitoring_Default_DHW.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "JackingWheelsAvailableDHW") == "True" || this.getModulePreferenceValue(result, "JackingWheelsAvailableDHW") == "true") {
                    this.easiHeatJackingWheels_Available_DHW.setValue(true);
                }
                else {
                    this.easiHeatJackingWheels_Available_DHW.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "JackingWheelsDefaultDHW") == "True" || this.getModulePreferenceValue(result, "JackingWheelsDefaultDHW") == "true") {
                    this.easiHeatJackingWheels_Default_DHW.setValue(true);
                }
                else {
                    this.easiHeatJackingWheels_Default_DHW.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "ENCompliantAvailableDHW") == "True" || this.getModulePreferenceValue(result, "ENCompliantAvailableDHW") == "true") {
                    this.easiHeatENCompliant_Available_DHW.setValue(true);
                }
                else {
                    this.easiHeatENCompliant_Available_DHW.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "ENCompliantDefaultDHW") == "True" || this.getModulePreferenceValue(result, "ENCompliantDefaultDHW") == "true") {
                    this.easiHeatENCompliant_Default_DHW.setValue(true);
                }
                else {
                    this.easiHeatENCompliant_Default_DHW.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "EnergyMonitoringAvailableHTG") == "True" || this.getModulePreferenceValue(result, "EnergyMonitoringAvailableHTG") == "true") {
                    this.easiHeatEnergyMonitoring_Available_HTG.setValue(true);
                }
                else {
                    this.easiHeatEnergyMonitoring_Available_HTG.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "EnergyMonitoringDefaultHTG") == "True" || this.getModulePreferenceValue(result, "EnergyMonitoringDefaultHTG") == "true") {
                    this.easiHeatEnergyMonitoring_Default_HTG.setValue(true);
                }
                else {
                    this.easiHeatEnergyMonitoring_Default_HTG.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "JackingWheelsAvailableHTG") == "True" || this.getModulePreferenceValue(result, "JackingWheelsAvailableHTG") == "true") {
                    this.easiHeatJackingWheels_Available_HTG.setValue(true);
                }
                else {
                    this.easiHeatJackingWheels_Available_HTG.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "JackingWheelsDefaultHTG") == "True" || this.getModulePreferenceValue(result, "JackingWheelsDefaultHTG") == "true") {
                    this.easiHeatJackingWheels_Default_HTG.setValue(true);
                }
                else {
                    this.easiHeatJackingWheels_Default_HTG.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "ENCompliantAvailableHTG") == "True" || this.getModulePreferenceValue(result, "ENCompliantAvailableHTG") == "true") {
                    this.easiHeatENCompliant_Available_HTG.setValue(true);
                }
                else {
                    this.easiHeatENCompliant_Available_HTG.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "ENCompliantDefaultHTG") == "True" || this.getModulePreferenceValue(result, "ENCompliantDefaultHTG") == "true") {
                    this.easiHeatENCompliant_Default_HTG.setValue(true);
                }
                else {
                    this.easiHeatENCompliant_Default_HTG.setValue(false);
                }
                // Get the currency data.
                this.adminService.getCurrencyData().subscribe((/**
                 * @param {?} data
                 * @return {?}
                 */
                data => {
                    this.currencyList = data;
                    //this.easiHeatManufacturerCurrencyId = data.find(c => c.id === this.easiHeatManufacturerCurrencyId)
                    // Selling currency found, so try to calculate the currency conversion rate.
                    this.onSellingCurrencyChange(this.easiHeatSellingCurrencyId);
                    this.augmentPriceDataProcessing = false; // loaded enable toggle prices button
                }));
            }
            // Get the currency data.
            this.adminService.getCurrencyData().subscribe((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                this.currencyList = data;
                //this.easiHeatManufacturerCurrencyId = data.find(c => c.id === this.easiHeatManufacturerCurrencyId)
                // Selling currency found, so try to calculate the currency conversion rate.
                this.onSellingCurrencyChange(this.easiHeatSellingCurrencyId);
                this.augmentPriceDataProcessing = false; // loaded enable toggle prices button
            }));
        })));
        // Get the list of manufacturers.
        this.componentLoadPromises.push(this.adminService.getManufacturerData(this.moduleGroupId).toPromise().then((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            // Update the subject with the data that's just been retrieved (see the constructor).  
            this.manufacturerList = result;
        })));
        // Now, set the "OpCo Selected Options" for the different EasiHeat options.
        // Actuator
        this.setOpCoPreferences("NomActuatorDHW_EasiHeat", this.easi_Heat_DHW_And_HTG_Sc_Options_Actuator);
        this.setOpCoPreferences("NomActuatorHTG_EasiHeat", this.easi_HTG_CC_Options_Actuator);
        // Design Code
        this.setOpCoPreferences("NomDesignCodeDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_DesignCode);
        this.setOpCoPreferences("NomDesignCodeHTG_EasiHeat", this.easi_HTG_CC_Options_DesignCode);
        // High Limit
        this.setOpCoPreferences("NomHighLimitDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_HighLimit);
        this.setOpCoPreferences("NomHighLimitHTG_EasiHeat", this.easi_HTG_CC_Options_HighLimit);
        // High Limit Actuation
        this.setOpCoPreferences("NomHighLimitActuationDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_HighLimitActuation);
        this.setOpCoPreferences("NomHighLimitActuationHTG_EasiHeat", this.easi_HTG_CC_Options_HighLimitActuation);
        // Isolation
        this.setOpCoPreferences("NomIsolationDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_Isolation);
        this.setOpCoPreferences("NomIsolationHTG_EasiHeat", this.easi_HTG_CC_Options_Isolation);
        // Control Panel
        this.setOpCoPreferences("NomPanelTypeDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_ControlPanel);
        this.setOpCoPreferences("NomPanelTypeHTG_EasiHeat", this.easi_HTG_CC_Options_ControlPanel);
        // Service Offering
        this.setOpCoPreferences("WarrantyDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_ServiceOffering);
        this.setOpCoPreferences("WarrantyHTG_EasiHeat", this.easi_HTG_CC_Options_ServiceOffering);
        // Gasket
        this.setOpCoPreferences("NomGasketDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_Gasket);
        this.setOpCoPreferences("NomGasketHTG_EasiHeat", this.easi_HTG_CC_Options_Gasket);
        // Remote Access
        this.setOpCoPreferences("NomRemoteAccessDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_RemoteAccess);
        this.setOpCoPreferences("NomRemoteAccessHTG_EasiHeat", this.easi_HTG_CC_Options_RemoteAccess);
        // Communications
        this.setOpCoPreferences("NomCommunicationsDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_Communications);
        this.setOpCoPreferences("NomCommunicationsHTG_EasiHeat", this.easi_HTG_CC_Options_Communications);
        //Additional Options
        this.setOpCoPreferences("NomAdditionalOptionsDHW_EasiHeat", this.easiHeat_DHW_AdditionalOptions);
        this.setOpCoPreferences("NomAdditionalOptionsHTG_EasiHeat", this.easiHeat_HTG_AdditionalOptions);
        this.easiHeatOptionsSelectedItem = "Actuator";
        this.theFormGroup = this.modulePreferencesForm; // to drive GenericChangesGuard
        // Info ToolTip message translations
        this.serviceOffereingMessage = this.translatePipe.transform('SERVICE_OFFERING_MESSAGE', false);
        this.deliveryCostMessage = this.translatePipe.transform('DELIVERY_COST_MESSAGE', false);
        Promise.all(this.componentLoadPromises).then((/**
         * @return {?}
         */
        () => {
            console.log("Initialization promises complete for Easiheat Component");
            this.componentInitialised = true;
        }));
    }
    /**
     * @return {?}
     */
    togglePrices() {
        this.showPrices = !this.showPrices;
        this.augmentPriceDataProcessing = true;
        this.augmentPricesToOptionsLists(this.showPrices);
    }
    /**
     * @return {?}
     */
    onChangeData() {
        //debugger;
        //this.modulePreferencesForm.markAsPristine(); 
    }
    /**
     * @return {?}
     */
    toggleSave() {
        if (this.easiHeatHeatExchangerTS6.valid == false || this.easiHeatHeatExchangerT6.valid == false || this.easiHeatHeatExchangerT8.valid == false ||
            this.easiHeatHeatExchangerT10.valid == false || this.easiHeatOverrideMarkup.valid == false || this.easiHeatSellingMarkup.valid == false ||
            this.easiHeatLandedCostIncreaseModPref.valid == false || this.easiHeatDeliveryCostModPref.valid == false || this.easiHeatCommissionOnly.valid == false ||
            this.easiHeatWarrantyOneYearPrefFormControl.valid == false || this.easiHeatWarrantyTwoYearsPrefFormControl.valid == false || this.easiHeatWarrantyThreeYearsPrefFormControl.valid == false) {
            this.modulePreferencesForm.markAsPristine();
        }
    }
    /**
     * @param {?=} showPrices
     * @return {?}
     */
    augmentPricesToOptionsLists(showPrices = true) {
        this.easiHeatPricing = new EasiHeatPricing();
        this.easiHeatPricing.modelId = -1; // All BOM items    
        this.easiHeatPricing.pricingOptions = [];
        this.easiHeatPricing.basePriceOption = -1;
        this.easiHeatPricing.localRecommendedSalesPriceOption = -1;
        this.easiHeatPricing.landedCostIncreaseFactor = -1;
        this.easiHeatSellingCurrencySymbol = !!this.easiHeatSellingCurrencySymbol ? this.easiHeatSellingCurrencySymbol : "?";
        this.easiHeatPricing.manufacturerId = +(!!this.manufacturerId ? this.manufacturerId : -1);
        this.easiHeatManufacturerCurrency = this.currencyList.find((/**
         * @param {?} c
         * @return {?}
         */
        c => c.id === this.easiHeatManufacturerCurrencyId));
        this.easiHeatManufacturerCurrencySymbol = !!this.easiHeatManufacturerCurrency ? this.easiHeatManufacturerCurrency.symbol : "?";
        if (showPrices) {
            // Get RSP Display price data for List item Augmentation
            this.easiHeatService.calculateBOMPrice(this.easiHeatPricing).subscribe((/**
             * @param {?} response
             * @return {?}
             */
            (response) => {
                if (response) {
                    this.easiHeatBOMOutputData = response;
                    /** @type {?} */
                    let manPrice = "";
                    /** @type {?} */
                    let localPrices = "";
                    /** @type {?} */
                    let isOverride = "";
                    this.easiHeatBOMOutputData.bomItems.forEach((/**
                     * @param {?} t
                     * @return {?}
                     */
                    t => {
                        if (showPrices && t.itemType == "Base") {
                            // Price the models
                            if (t.sRecommendedSalesPrice != 0.0 && t.sRecommendedSalesPrice != parseFloat(t.sDisplayedRSP)) {
                                isOverride = 'o';
                            }
                            manPrice = ' SSP=' + this.easiHeatManufacturerCurrencySymbol + ' ' + this.localizeValue(t.ssp, 0);
                            localPrices = ' RSP' + isOverride + '=' + this.easiHeatManufacturerCurrencySymbol + ' ' + this.localizeValue(t.displayedRSP, 0);
                            if (t.ssp != t.sSSP) { // if not the same currency data
                                manPrice = manPrice + ' (' + this.easiHeatSellingCurrencySymbol + ' ' + this.localizeValue(t.sSSP, 0) + ')';
                                localPrices = localPrices + ' (' + this.easiHeatSellingCurrencySymbol + ' ' + this.localizeValue(t.sDisplayedRSP, 0) + ')';
                            }
                        }
                        // Set option item enabled?
                        /** @type {?} */
                        var newEnumerationModulePreferences = this.GetNewEnumerationModulePreferences();
                        this.easiHeatBOMOutputData.bomItems.forEach((/**
                         * @param {?} p
                         * @return {?}
                         */
                        p => {
                            /** @type {?} */
                            var elist = newEnumerationModulePreferences.find((/**
                             * @param {?} e
                             * @return {?}
                             */
                            e => e.enumerationName == p.parent));
                            //if (!!elist) { can't support on EH gen3 data
                            //  var elistItem = elist.enumerationDefinitions.find(l => l.value == p.item);
                            //}
                            p.isEnabled = true;
                            //p.isEnabled = !!elistItem ? true : false;
                            //// Set enabled if base CSG model item or add on (Commisoining, Voltage, Warranty etc.)
                            //if (!p.parentMasterTextKey
                            //  || (!!p.parentMasterTextKey && p.parentMasterTextKey.indexOf('xxxlegacy_') === 0) // no list override for it
                            //  || (!!p.parentMasterTextKey && p.parentMasterTextKey.indexOf('xxxlegacy_') === 0)) {
                            //  p.isEnabled = true;
                            //}
                        }));
                        // Append prices to list translation on UI
                        this.translationService.displayGroup.enumerations.forEach((/**
                         * @param {?} e
                         * @return {?}
                         */
                        e => {
                            e.enumerationDefinitions.forEach((/**
                             * @param {?} d
                             * @return {?}
                             */
                            d => {
                                if ((e.enumerationName == t.parent && d.value == t.item)
                                    || (t.parentMasterTextKey.indexOf(e.enumerationName) > -1 && d.value == t.item.split('_')[1])) { // && d.translationText.indexOf(' ' + this.sellingCurrencySymbol + ' ') < 0) {
                                    if (showPrices) {
                                        if (t.sRecommendedSalesPrice != 0.0 && (t.sRecommendedSalesPrice != parseFloat(t.sDisplayedRSP))) {
                                            isOverride = 'o';
                                        }
                                        /** @type {?} */
                                        var nomCode = '';
                                        if (!!t.item.split('_')[1]) {
                                            nomCode = '(' + t.item.split('_')[1] + ') ';
                                        }
                                        manPrice = ' SSP=' + this.easiHeatManufacturerCurrencySymbol + ' ' + this.localizeValue(t.ssp, 0);
                                        localPrices = ' RSP' + isOverride + '=' + this.easiHeatManufacturerCurrencySymbol + ' ' + this.localizeValue(t.displayedRSP, 0);
                                        if (t.ssp != t.sSSP) { // if not the same currency data
                                            manPrice = manPrice + ' (' + this.easiHeatSellingCurrencySymbol + ' ' + this.localizeValue(t.sSSP, 0) + ')';
                                            localPrices = localPrices + ' (' + this.easiHeatSellingCurrencySymbol + ' ' + this.localizeValue(t.sDisplayedRSP, 0) + ')';
                                        }
                                        t.itemMasterTextKey = d.masterTextKey;
                                        t.parentMasterTextKey = e.enumerationName.split('_')[0].replace('Nom', '');
                                        // Set the UI text
                                        //d.extraPostText = manPrice + localPrices; RSPs for 15 models on 2 list sets not representative!
                                        //if (!d.extraPreText) {                       
                                        //    d.extraPreText = nomCode;
                                        //}
                                    }
                                    else {
                                        //d.extraPostText = ""; // clear augmented data
                                        //d.extraPreText = "";
                                    }
                                } // end of e.enumerationDefinitions.forEach...
                                if (!d.extraPreText && d.defaultText !== d.value) {
                                    d.extraPreText = '(' + d.value + ') ';
                                }
                            }));
                        }));
                    })); // of append prices
                    this.augmentPriceDataProcessing = false; // finished, enable button again
                    this.scrollToElement(this.collapsePriceDataTop, "start");
                }
            })); // end of service response
        } // end of if showPrices
        else {
            // remove price augmentation
            //this.CSG_HS_020_Price = "";
            //this.CSG_HS_055_Price = "";
            //this.CSG_HS_125_Price = "";
            //this.CSG_HS_180_Price = "";
            this.translationService.displayGroup.enumerations.forEach((/**
             * @param {?} e
             * @return {?}
             */
            e => {
                e.enumerationDefinitions.forEach((/**
                 * @param {?} d
                 * @return {?}
                 */
                d => d.extraPostText = "")); // clear augmented data                              
            }));
            this.augmentPriceDataProcessing = false; // finished, enable button again
        }
    }
    /**
     * Method to localize values.
     * @param {?} value
     * @param {?} decimalPoints
     * @return {?}
     */
    localizeValue(value, decimalPoints) {
        return this.localeService.formatDecimal(value.toFixed(decimalPoints));
    }
    /*
      * Method to get and set the OpCo selected options.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} formControlName
     * @return {?}
     */
    setOpCoPreferences(enumerationPickerName, formControlName) {
        // Get the collection list first.
        /** @type {?} */
        let easiHeatOpCoPref = this.getEnumerationPickerCollection(enumerationPickerName, true);
        // Check if any OpCo Overrides Data found? If NOT then get the base list populated.
        if (!easiHeatOpCoPref) {
            easiHeatOpCoPref = this.cloneDeep(this.getEnumerationPickerCollection(enumerationPickerName, false));
        }
        // Check and set the list.
        if (!!easiHeatOpCoPref && easiHeatOpCoPref.length > 0) {
            formControlName.setValue(easiHeatOpCoPref);
        }
    }
    /*
      * Method to get the Enumeration list by Name.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} opCoOverride
     * @return {?}
     */
    getEnumerationPickerCollection(enumerationPickerName, opCoOverride) {
        /** @type {?} */
        const enumeration = this.translationService.displayGroup.enumerations.filter((/**
         * @param {?} us
         * @return {?}
         */
        us => us.enumerationName === enumerationPickerName && us.opCoOverride === opCoOverride));
        if (!!enumeration && enumeration.length > 0) {
            /** @type {?} */
            let definitions = enumeration[0].enumerationDefinitions.sort((/**
             * @param {?} currentenumeration
             * @param {?} nextenumeration
             * @return {?}
             */
            (currentenumeration, nextenumeration) => {
                if (currentenumeration.sequence > nextenumeration.sequence) {
                    return 1;
                }
                if (currentenumeration.sequence < nextenumeration.sequence) {
                    return -1;
                }
                return 0;
            }));
            //this.onChange(definitions);
            definitions.forEach((/**
             * @param {?} i
             * @return {?}
             */
            i => i.isDeleted = false));
            return definitions;
        }
    }
    /**
     * Submits the form for saving to the server.
     * @param {?} $event
     * @return {?}
     */
    submitForm($event) {
        $event.preventDefault();
        // Mark the form as submitted.
        this.formSubmitted = true;
        // Regular Module Preferences.
        /** @type {?} */
        const newModulePreferences = [];
        /** @type {?} */
        var sellingCurrency = this.getSelectedPreferences("SellingCurrency", "easiHeatSellingCurrencyModulePreference");
        /** @type {?} */
        var manufacturer = this.getSelectedPreferences("Manufacturer", "easiHeatManufacturerModulePreference");
        /** @type {?} */
        var manufacturerCurrency = this.getSelectedPreferences("ManufacturerCurrency", "easiHeatManufacturerCurrencyModulePreference");
        //Heat exchanger options
        /** @type {?} */
        var HETS6Discount = this.getSelectedPreferences("HETS6Discount", "easiHeatHeatExchangerTS6");
        //TS6
        /** @type {?} */
        var HEM6Discount = this.getSelectedPreferences("HEM6Discount", "easiHeatHeatExchangerT6");
        //T6
        /** @type {?} */
        var HEM8Discount = this.getSelectedPreferences("HEM10Discount", "easiHeatHeatExchangerT8");
        //T8
        /** @type {?} */
        var HEM10Discount = this.getSelectedPreferences("HET10", "easiHeatHeatExchangerT10");
        //T10  
        /** @type {?} */
        var HEPricingCurrency = this.getSelectedPreferences("HEPricingCurrency", "easiHeatPricingCurrency");
        /** @type {?} */
        var HEOverridenP251MarkupValue = this.getSelectedPreferences("HEOverridenP251MarkupValue", "easiHeatOverrideMarkup");
        /** @type {?} */
        var HEOverridenP251Markup = this.getSelectedPreferences("HEOverridenP251Markup", "easiHeatOverrideMarkupActive");
        //Pricing Options
        /** @type {?} */
        var SellingMarkup = this.getSelectedPreferences("SellingMarkup", "easiHeatSellingMarkup");
        /** @type {?} */
        var LandedCostIncrease = this.getSelectedPreferences("LandCostIncrease", "easiHeatLandedCostIncreaseModPref") //easiHeatLandedCostIncreaseModPref
        ;
        //easiHeatLandedCostIncreaseModPref
        /** @type {?} */
        var DeliveryCost = this.getSelectedPreferences("DeliveryCost", "easiHeatDeliveryCostModPref");
        /** @type {?} */
        var Commission = this.getSelectedPreferences("Commission", "easiHeatCommissionOnly");
        /** @type {?} */
        var CVSplitRange = this.getSelectedPreferences("CVSplitRange", "easiHeatCvSplitRange");
        /** @type {?} */
        var SellSteamControl = this.getSelectedPreferences("SellSteamControl", "easiHeatSteamSideControlOnHTG");
        /** @type {?} */
        var MotiveInletPressureAvailable = this.getSelectedPreferences("MotiveInletPressureAvailable", "easiHeatMotiveInletPressureAvailable");
        /** @type {?} */
        var YearOne = this.getSelectedPreferences("YearOne", "easiHeatWarrantyOneYearModulePreference");
        /** @type {?} */
        var YearTwo = this.getSelectedPreferences("YearTwo", "easiHeatWarrantyTwoYearsModulePreference");
        /** @type {?} */
        var YearThree = this.getSelectedPreferences("YearThree", "easiHeatWarrantyThreeYearsModulePreference");
        /** @type {?} */
        var PrvAllowed = this.getSelectedPreferences("PrvAllowed", "easiHeatPRVAvailableOnEHHCC");
        /** @type {?} */
        var HideHEmodelFromSizing = this.getSelectedPreferences("HideHEmodelFromSizing", "easiHeatHideHEModelFromSizing");
        /** @type {?} */
        var EnergyMonitoringAvailableDHW = this.getSelectedPreferences("EnergyMonitoringAvailableDHW", "easiHeatEnergyMonitoring_Available_DHW");
        /** @type {?} */
        var EnergyMonitoringDefaultDHW = this.getSelectedPreferences("EnergyMonitoringDefaultDHW", "easiHeatEnergyMonitoring_Default_DHW");
        /** @type {?} */
        var JackingWheelsAvailableDHW = this.getSelectedPreferences("JackingWheelsAvailableDHW", "easiHeatJackingWheels_Available_DHW");
        /** @type {?} */
        var JackingWheelsDefaultDHW = this.getSelectedPreferences("JackingWheelsDefaultDHW", "easiHeatJackingWheels_Default_DHW");
        /** @type {?} */
        var ENCompliantAvailableDHW = this.getSelectedPreferences("ENCompliantAvailableDHW", "easiHeatENCompliant_Available_DHW");
        /** @type {?} */
        var ENCompliantDefaultDHW = this.getSelectedPreferences("ENCompliantDefaultDHW", "easiHeatENCompliant_Default_DHW");
        /** @type {?} */
        var EnergyMonitoringAvailableHTG = this.getSelectedPreferences("EnergyMonitoringAvailableHTG", "easiHeatEnergyMonitoring_Available_HTG");
        /** @type {?} */
        var EnergyMonitoringDefaultHTG = this.getSelectedPreferences("EnergyMonitoringDefaultHTG", "easiHeatEnergyMonitoring_Default_HTG");
        /** @type {?} */
        var JackingWheelsAvailableHTG = this.getSelectedPreferences("JackingWheelsAvailableHTG", "easiHeatJackingWheels_Available_HTG");
        /** @type {?} */
        var JackingWheelsDefaultHTG = this.getSelectedPreferences("JackingWheelsDefaultHTG", "easiHeatJackingWheels_Default_HTG");
        /** @type {?} */
        var ENCompliantAvailableHTG = this.getSelectedPreferences("ENCompliantAvailableHTG", "easiHeatENCompliant_Available_HTG");
        /** @type {?} */
        var ENCompliantDefaultHTG = this.getSelectedPreferences("ENCompliantDefaultHTG", "easiHeatENCompliant_Default_HTG");
        newModulePreferences.push(sellingCurrency);
        newModulePreferences.push(manufacturer);
        newModulePreferences.push(manufacturerCurrency);
        newModulePreferences.push(HETS6Discount);
        newModulePreferences.push(HEM6Discount);
        newModulePreferences.push(HEM8Discount);
        newModulePreferences.push(HEM10Discount);
        newModulePreferences.push(HEPricingCurrency);
        newModulePreferences.push(HEOverridenP251MarkupValue);
        newModulePreferences.push(HEOverridenP251Markup);
        newModulePreferences.push(SellingMarkup);
        newModulePreferences.push(LandedCostIncrease);
        newModulePreferences.push(DeliveryCost);
        newModulePreferences.push(Commission);
        newModulePreferences.push(CVSplitRange);
        newModulePreferences.push(SellSteamControl);
        newModulePreferences.push(MotiveInletPressureAvailable);
        newModulePreferences.push(YearOne);
        newModulePreferences.push(YearTwo);
        newModulePreferences.push(YearThree);
        newModulePreferences.push(PrvAllowed);
        newModulePreferences.push(HideHEmodelFromSizing);
        newModulePreferences.push(EnergyMonitoringAvailableDHW);
        newModulePreferences.push(EnergyMonitoringDefaultDHW);
        newModulePreferences.push(JackingWheelsAvailableDHW);
        newModulePreferences.push(JackingWheelsDefaultDHW);
        newModulePreferences.push(ENCompliantAvailableDHW);
        newModulePreferences.push(ENCompliantDefaultDHW);
        newModulePreferences.push(EnergyMonitoringAvailableHTG);
        newModulePreferences.push(EnergyMonitoringDefaultHTG);
        newModulePreferences.push(JackingWheelsAvailableHTG);
        newModulePreferences.push(JackingWheelsDefaultHTG);
        newModulePreferences.push(ENCompliantAvailableHTG);
        newModulePreferences.push(ENCompliantDefaultHTG);
        // Save the changed preferences as an array of preferences
        this.adminService.manageModulePreferences(newModulePreferences).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            // The form can be submitted again.
            this.formSubmitted = false;
            // Set the operation based on the response.
            this.isSuccess = response;
            this.alertVisible = true;
        }));
        /** @type {?} */
        var newEnumerationModulePreferences = this.GetNewEnumerationModulePreferences();
        // Save the changed preferences as an array of preferences
        this.adminService.manageEnumerationModulePreferences(newEnumerationModulePreferences).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            // The form can be submitted again.
            this.formSubmitted = false;
            // Set the operation based on the response.
            this.isSuccess = response;
            this.alertVisible = true;
            this.modulePreferencesForm.markAsPristine(); // to drive GenericChangesGuard
        }));
    }
    /**
     * @return {?}
     */
    GetNewEnumerationModulePreferences() {
        // Enumeration Module Preferences.
        /** @type {?} */
        const newEnumerationModulePreferences = [];
        // Actuator
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomActuatorDHW_EasiHeat", "easi_Heat_DHW_And_HTG_Sc_Options_Actuator"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomActuatorHTG_EasiHeat", "easi_HTG_CC_Options_Actuator"));
        // Design Code
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomDesignCodeDHW_EasiHeat", "easiHeatDHWandHTGScOptions_DesignCode"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomDesignCodeHTG_EasiHeat", "easi_HTG_CC_Options_DesignCode"));
        // High Limit
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomHighLimitDHW_EasiHeat", "easiHeatDHWandHTGScOptions_HighLimit"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomHighLimitHTG_EasiHeat", "easi_HTG_CC_Options_HighLimit"));
        // High Limit Actuation
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomHighLimitActuationDHW_EasiHeat", "easiHeatDHWandHTGScOptions_HighLimitActuation"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomHighLimitActuationHTG_EasiHeat", "easi_HTG_CC_Options_HighLimitActuation"));
        // Isolation
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomIsolationDHW_EasiHeat", "easiHeatDHWandHTGScOptions_Isolation"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomIsolationHTG_EasiHeat", "easi_HTG_CC_Options_Isolation"));
        // Control Panel
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomPanelTypeDHW_EasiHeat", "easiHeatDHWandHTGScOptions_ControlPanel"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomPanelTypeHTG_EasiHeat", "easi_HTG_CC_Options_ControlPanel"));
        // Service Offering
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("WarrantyDHW_EasiHeat", "easiHeatDHWandHTGScOptions_ServiceOffering"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("WarrantyHTG_EasiHeat", "easi_HTG_CC_Options_ServiceOffering"));
        // Gasket
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomGasketDHW_EasiHeat", "easiHeatDHWandHTGScOptions_Gasket"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomGasketHTG_EasiHeat", "easi_HTG_CC_Options_Gasket"));
        // Remote Access
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomRemoteAccessDHW_EasiHeat", "easiHeatDHWandHTGScOptions_RemoteAccess"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomRemoteAccessHTG_EasiHeat", "easi_HTG_CC_Options_RemoteAccess"));
        // Communications
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomCommunicationsDHW_EasiHeat", "easiHeatDHWandHTGScOptions_Communications"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomCommunicationsHTG_EasiHeat", "easi_HTG_CC_Options_Communications"));
        // Additional Options
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("easiHeat_DHW_AdditionalOptions", "easiHeat_DHW_AdditionalOptions"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("easiHeat_HTG_AdditionalOptions", "easiHeat_HTG_AdditionalOptions"));
        return newEnumerationModulePreferences;
    }
    /*
      * Method to get opco selected enumeration module prefernce details for each options.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} prefsFormKeyName
     * @return {?}
     */
    getSelectedEnumerationPreferences(enumerationPickerName, prefsFormKeyName) {
        /** @type {?} */
        var modPrefs = new Enumeration;
        modPrefs.enumerationName = enumerationPickerName;
        modPrefs.opCoOverride = true;
        modPrefs.enumerationDefinitions = this.modulePreferencesForm.controls[prefsFormKeyName].value;
        //modPrefs.enumerationDefinitions.find(e => e.value == prefsFormKeyName);
        //this.modulePreferencesForm.controls[prefsFormKeyName].value;
        return modPrefs;
    }
    /*
      * Method to get opco selected module prefernce details.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} prefsFormKeyName
     * @return {?}
     */
    getSelectedPreferences(enumerationPickerName, prefsFormKeyName) {
        /** @type {?} */
        var modPrefs = new ModulePreferenceDetails;
        modPrefs.name = enumerationPickerName;
        modPrefs.value = "" + this.modulePreferencesForm.controls[prefsFormKeyName].value;
        modPrefs.moduleId = +this.moduleId;
        modPrefs.isDeleted = false;
        modPrefs.OperatingCompanyId = 42;
        return modPrefs;
    }
    /**
     * @return {?}
     */
    closeAlert() {
        // Reset the flag
        this.alertVisible = false;
    }
    /**
     * @return {?}
     */
    onChange() {
        this.modulePreferencesForm.markAsDirty();
        // this.modulePreferencesForm.disabled == false;
    }
    /**
     * @return {?}
     */
    onChangeAnyOption() {
        // Any enumeration-picker (on-change) set the form data to dirty.
        this.modulePreferencesForm.markAsDirty();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onEasiHeatOptionsChange(event) {
        this.easiHeatOptionsSelectedItem = event.selectedValue;
        this.easiHeatOptionsFormControl.markAsPristine(); // Options list selector is not a data change item, so ignore changes.
    }
    /*
      * Method to calculate the currency conversion rate.
      */
    /**
     * @param {?} selectedValue
     * @return {?}
     */
    onSellingCurrencyChange(selectedValue) {
        this.easiHeatManufacturerCurrencyId = +this.easiHeatManufacturerCurrencyModulePreference.value;
        if (selectedValue > 0 && this.easiHeatManufacturerCurrencyId > 0 && this.currencyList.length > 0) {
            /** @type {?} */
            let sellingCurrency = this.currencyList.find((/**
             * @param {?} c
             * @return {?}
             */
            c => c.id === +selectedValue));
            /** @type {?} */
            let manufacturerCurrency = this.currencyList.find((/**
             * @param {?} c
             * @return {?}
             */
            c => c.id === this.easiHeatManufacturerCurrencyId));
            this.easiHeatSellingCurrencySymbol = sellingCurrency.symbol;
            this.easiHeatCurrencyConversion = +((manufacturerCurrency.rateToGbp * (1 / sellingCurrency.rateToGbp)).toFixed(5));
        }
    }
    /*
      * Method to retrieve the module pref value from the list.
      */
    /**
     * @param {?} modulePrefList
     * @param {?} modulePrefName
     * @return {?}
     */
    getModulePreferenceValue(modulePrefList, modulePrefName) {
        /** @type {?} */
        let modPref = modulePrefList.filter((/**
         * @param {?} r
         * @return {?}
         */
        r => r.name === modulePrefName));
        if (modPref && modPref.length > 0) {
            return modPref[0].value;
        }
    }
    /**
     * @param {?} row
     * @return {?}
     */
    getRowClass(row) {
        if (row.isEnabled) {
            return 'row-color-enabled';
        }
        return 'row-color-disabled';
    }
    /**
     * @return {?}
     */
    setOverrideMarkup() {
        this.overrideMarkupActive = !this.overrideMarkupActive;
        this.easiHeatOverrideMarkupActive.setValue(this.overrideMarkupActive);
        if (this.overrideMarkupActive == false) {
            this.easiHeatOverrideMarkup.setValue("0");
        }
        this.toggleSave();
    }
}
EasiHeatPreferencesComponent.decorators = [
    { type: Component, args: [{
                selector: 'easiHeat-module-preferences',
                template: "<!--Easiheat module preferences component works!-->\r\n<div *ngIf=\"!componentInitialised\">\r\n  <div class=\"ball-clip-rotate\">\r\n    <div></div>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"componentInitialised\">\r\n  <form [formGroup]=\"modulePreferencesForm\" class=\"form-horizontal\" role=\"form\" (click)=\"toggleSave();\" (submit)=\"submitForm($event)\" novalidate>\r\n    <!--[disabled]=\"!modulePreferencesForm.dirty || !modulePreferencesForm.valid || modulePreferencesForm.status !== 'VALID' || formSubmitted\"-->\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <button [disabled]=\"!modulePreferencesForm.dirty || formSubmitted\" type=\"submit\" class=\"btn btn-dynamic btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i></button>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <br>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Success confirmation message -->\r\n    <alert-block *ngIf=\"!!alertVisible && !!isSuccess\" type=\"success\" [auto-close]=\"true\" [message]=\"'MODULE_PREFERENCES_SAVED_SUCCESSFULLY_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n    <!-- Failure confirmation message-->\r\n    <alert-block *ngIf=\"!!alertVisible && !isSuccess\" type=\"danger\" [message]=\"'MODULE_PREFERENCES_FAILED_TO_SAVE_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"currencyOptionsHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseCurrencyOptions\" aria-expanded=\"true\" aria-controls=\"collapseCurrencyOptions\">\r\n            {{\"CURRENCY_OPTIONS\" | translate}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapseCurrencyOptions\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"currencyOptionsHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-10px\">\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"row\" style=\"padding-bottom:15px\">\r\n\r\n              <!--Manufacturer-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"MANUFACTURER\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"easiHeatManufacturerModulePreference\">\r\n                  <option *ngFor=\"let manufacturer of manufacturerList\" [value]=\"manufacturer.id\">{{manufacturer.name}}</option>\r\n                </select>\r\n              </div>\r\n\r\n              <!--Selling currency-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"SELLING_CURRENCY\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"easiHeatSellingCurrencyModulePreference\" (ngModelChange)=\"onSellingCurrencyChange($event)\">\r\n                  <option *ngFor=\"let currency of currencyList\" [value]=\"currency.id\">{{currency.currencyCode}} - {{currency.symbol}}</option>\r\n                </select>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n              <!--Manufacturer currency-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"MANUFACTURER_CURRENCY\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"easiHeatManufacturerCurrencyModulePreference\">\r\n                  <option *ngFor=\"let currency of currencyList\" [value]=\"currency.id\">{{currency.currencyCode}} - {{currency.symbol}}</option>\r\n                </select>\r\n              </div>\r\n\r\n              <!--Currency conversion-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"CURRENCY_CONVERSION\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <label class=\"control-label\">{{easiHeatCurrencyConversion}}</label>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Heat Exchanger Options -->\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"pricingOptionsHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseHeatExchangerOptions\" aria-expanded=\"true\" aria-controls=\"collapsePricingOptions\">\r\n            {{\"HEAT_EXCHANGER_OPTIONS\" | translate}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapseHeatExchangerOptions\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"heatExchangerOptionsHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-30px\">\r\n          <div class=\"form-group\">\r\n            <!--Column 1-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-8 text-right\">\r\n                  <label class=\"control-label\">{{\"DISCOUNT_RATE\" | translate}}</label>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <!--TS6-->\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"TS6\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatHeatExchangerTS6\" value=\"easiHeatTS6\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatHeatExchangerTS6'].hasError('required') && (modulePreferencesForm.controls['easiHeatHeatExchangerTS6'].dirty || modulePreferencesForm.controls['easiHeatHeatExchangerTS6'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!--T6-->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"T6\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatHeatExchangerT6\" value=\"easiHeatT6\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatHeatExchangerT6'].hasError('required') && (modulePreferencesForm.controls['easiHeatHeatExchangerT6'].dirty || modulePreferencesForm.controls['easiHeatHeatExchangerT6'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!--T8-->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"T8\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatHeatExchangerT8\" value=\"easiHeatT8\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatHeatExchangerT8'].hasError('required') && (modulePreferencesForm.controls['easiHeatHeatExchangerT8'].dirty || modulePreferencesForm.controls['easiHeatHeatExchangerT8'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!--T10-->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"T10\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatHeatExchangerT10\" value=\"easiHeatT10\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatHeatExchangerT10'].hasError('required') && (modulePreferencesForm.controls['easiHeatHeatExchangerT10'].dirty || modulePreferencesForm.controls['easiHeatHeatExchangerT10'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Column 2-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"row\" style=\"padding-bottom: 20px;\">\r\n                <!-- Pricing Currency -->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"PRICING_CURRENCY\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <select class=\"form-control\" formControlName=\"easiHeatPricingCurrency\" (ngModelChange)=\"onSellingCurrencyChange($event)\">\r\n                      <option *ngFor=\"let currency of currencyList\" [value]=\"currency.id\">{{currency.currencyCode}} - {{currency.symbol}}</option>\r\n                    </select>\r\n                  </div>\r\n                </div>\r\n\r\n                <!-- Override Markup Active available -->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"OVERRIDE_GROUP_MARKUP\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <input autocomplete=\"off\"\r\n                             class=\"control-check\"\r\n                             type=\"checkbox\"\r\n                             style=\"width:15px; height:15px;\"\r\n                             formControlName=\"easiHeatOverrideMarkupActive\"\r\n                             value=\"easiHeatOverrideMarkupActive\"\r\n                             (change)=\"setOverrideMarkup()\" />\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n                <!--Override Markup-->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"OVERRIDE_MARKUP\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <input *ngIf=\"overrideMarkupActive\" autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatOverrideMarkup\" value=\"easiHeatOverrideMarkup\" twoDigitDecimalNumber />\r\n                      <input *ngIf=\"!overrideMarkupActive\" disabled=\"disabled\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" />\r\n                      <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatOverrideMarkup'].hasError('required') && (modulePreferencesForm.controls['easiHeatOverrideMarkup'].dirty || modulePreferencesForm.controls['easiHeatOverrideMarkup'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n\r\n\r\n    <!--Pricing Options-->\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"pricingOptionsHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapsePricingOptions\" aria-expanded=\"true\" aria-controls=\"collapsePricingOptions\">\r\n            {{\"PRICING_OPTIONS\" | translate}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapsePricingOptions\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"pricingOptionsHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-30px\">\r\n          <div class=\"form-group\">\r\n            <!--Column 1-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <!--Selling Markup-->\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"SELLING_MARKUP\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" (input)=\"onChange();\" formControlName=\"easiHeatSellingMarkup\" value=\"easiHeatSellingMarkup\" twoDigitDecimalNumber />\r\n\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatSellingMarkup'].hasError('required') && (modulePreferencesForm.controls['easiHeatSellingMarkup'].dirty || modulePreferencesForm.controls['easiHeatSellingMarkup'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <!--Landed Cost-->\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"LANDED_COST_INCREASE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatLandedCostIncreaseModPref\" value=\"easiHeatLandedCostIncreaseModPref\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatLandedCostIncreaseModPref'].hasError('required') && (modulePreferencesForm.controls['easiHeatLandedCostIncreaseModPref'].dirty || modulePreferencesForm.controls['easiHeatLandedCostIncreaseModPref'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!--Delivery Cost-->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"DELIVERY_COST\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-addon\">{{easiHeatSellingCurrencySymbol}}</span>\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatDeliveryCostModPref\" value=\"easiHeatDeliveryCost\" (input)=\"onChange();\" twoDigitDecimalNumber />\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatDeliveryCostModPref'].hasError('required') && (modulePreferencesForm.controls['easiHeatDeliveryCostModPref'].dirty || modulePreferencesForm.controls['easiHeatDeliveryCostModPref'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!-- Commission only price -->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"COMMISSION_ONLY_PRICE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-addon\">{{easiHeatSellingCurrencySymbol}}</span>\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatCommissionOnly\" value=\"easiHeatCommissionOnly\" twoDigitDecimalNumber />\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatCommissionOnly'].hasError('required') && (modulePreferencesForm.controls['easiHeatCommissionOnly'].dirty || modulePreferencesForm.controls['easiHeatCommissionOnly'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!-- CV Split Range available -->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"CV_SPLIT_RANGE_AVAILABLE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\"\r\n                           class=\"control-check\"\r\n                           type=\"checkbox\"\r\n                           style=\"width:15px; height:15px;\"\r\n                           formControlName=\"easiHeatCvSplitRange\"\r\n                           value=\"easiHeatCvSplitRange\"\r\n                           (change)=\"toggleSave()\" />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <!-- Steam side control on HTG -->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"STEAM_SIDE_CONTROL_ON_HTG\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"checkbox\" style=\"width:15px; height:15px;\" formControlName=\"easiHeatSteamSideControlOnHTG\" value=\"easiHeatSteamSideControlOnHTG\" (change)=\"toggleSave()\" />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <!-- Motive Inlet Pressure Available -->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"MOTIVE_INLET_PRESSURE_AVAILABLE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"checkbox\" style=\"width:15px; height:15px;\" formControlName=\"easiHeatMotiveInletPressureAvailable\" value=\"easiHeatMotiveInletPressureAvailable\" (change)=\"toggleSave()\" />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Column 2-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"panel-body\" style=\"margin-bottom:-30px\">\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-8 text-right\">\r\n                    <h4>{{\"EXTENDED_WARRANTY_PRICE\" | translate}}</h4>\r\n                  </div>\r\n                  <!--<div class=\"col-xs-3 cross-validation-error-class\" *ngIf=\"serviceOffereingMessage\">\r\n                    <div><i class=\"fa fa-info-circle cross-validation-error-class\" [tooltip]=\"serviceOffereingMessage\" placement=\"top,right\"></i></div>\r\n                  </div>-->\r\n                </div>\r\n                <!--</fieldset>-->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--One Year-->\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"ONE_YEAR\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{easiHeatSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatWarrantyOneYearModulePreference\" value=\"easiHeatWarrantyOneYearModulePreference\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatWarrantyOneYearModulePreference'].hasError('required') && (modulePreferencesForm.controls['easiHeatWarrantyOneYearModulePreference'].dirty || modulePreferencesForm.controls['easiHeatWarrantyOneYearModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--Two Years-->\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"TWO_YEARS\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{easiHeatSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatWarrantyTwoYearsModulePreference\" value=\"easiHeatWarrantyTwoYearsModulePreference\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatWarrantyTwoYearsModulePreference'].hasError('required') && (modulePreferencesForm.controls['easiHeatWarrantyTwoYearsModulePreference'].dirty || modulePreferencesForm.controls['easiHeatWarrantyTwoYearsModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--Three Years-->\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"THREE_YEARS\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{easiHeatSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatWarrantyThreeYearsModulePreference\" value=\"easiHeatWarrantyTwoYearsModulePreference\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatWarrantyThreeYearsModulePreference'].hasError('required') && (modulePreferencesForm.controls['easiHeatWarrantyThreeYearsModulePreference'].dirty || modulePreferencesForm.controls['easiHeatWarrantyThreeYearsModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n\r\n                <!-- PRV available on EHHCC -->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"PRV_AVAILABLE_ON_EHHCC\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"checkbox\" style=\"width:15px; height:15px;\" formControlName=\"easiHeatPRVAvailableOnEHHCC\" value=\"easiHeatPRVAvailableOnEHHCC\" (change)=\"toggleSave()\" />\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n                <!-- Hide HE model from sizing -->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"HIDE_HE_MODEL_FROM_SIZING\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"checkbox\" style=\"width:15px; height:15px;\" formControlName=\"easiHeatHideHEModelFromSizing\" value=\"easiHeatHideHEModelFromSizing\" (change)=\"toggleSave()\" />\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--Configurartion Options-->\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"optionConfigurartionHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseOptionConfigurartion\" aria-expanded=\"true\" aria-controls=\"collapseOptionConfigurartion\">\r\n            {{\"OPTION_CONFIGURATION\" | translate}}{{operatingCompany}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapseOptionConfigurartion\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"optionConfigurartionHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-20px\">\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-2 text-right\">\r\n                <label class=\"control-label\">{{\"PLEASE_SELECT\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                <enumeration formControlName=\"easiHeatOptionsSelection\" enumeration-name=\"EasiHeat_Options\" (on-change)=\"onEasiHeatOptionsChange($event)\"></enumeration>\r\n              </div>\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                <button [disabled]=\"augmentPriceDataProcessing\" class=\"btn btn-dynamic btn-primary pull-right\" type='button' (click)=\"togglePrices();\" [title]=\"'TOGGLE_PRICES' | translate\"><i class=\"fa fa-exchange\">  {{'TOGGLE_PRICES' | translate}}</i></button>\r\n              </div>\r\n            </div>\r\n            <hr>\r\n            <!--Actuator-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Actuator'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_Heat_DHW_And_HTG_Sc_Options_Actuator\" enumeration-picker-name=\"NomActuatorDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_Actuator\" enumeration-picker-name=\"NomActuatorHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Design Code-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Design Code'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_DesignCode\" enumeration-picker-name=\"NomDesignCodeDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_DesignCode\" enumeration-picker-name=\"NomDesignCodeHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--High Limit-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'High Limit'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_HighLimit\" enumeration-picker-name=\"NomHighLimitDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_HighLimit\" enumeration-picker-name=\"NomHighLimitHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--High Limit Actuation-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'High Limit Actuation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_HighLimitActuation\" enumeration-picker-name=\"NomHighLimitActuationDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_HighLimitActuation\" enumeration-picker-name=\"NomHighLimitActuationHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Isolation-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Isolation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_Isolation\" enumeration-picker-name=\"NomIsolationDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_Isolation\" enumeration-picker-name=\"NomIsolationHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Control Panel-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Control Panel'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_ControlPanel\" enumeration-picker-name=\"NomPanelTypeDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_ControlPanel\" enumeration-picker-name=\"NomPanelTypeHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Service Offering-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Service Offering'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_ServiceOffering\" enumeration-picker-name=\"WarrantyDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_ServiceOffering\" enumeration-picker-name=\"WarrantyHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Gasket-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Gasket'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_OPTIONS}}\">DHW Options</h4><label>{{DHW_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_Gasket\" enumeration-picker-name=\"NomGasketDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_AND_SC_OPTIONS}}\">HTG CC & SC Options</h4><label>{{HTG_CC_AND_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_Gasket\" enumeration-picker-name=\"NomGasketHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Remote Access-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Remote Access'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_RemoteAccess\" enumeration-picker-name=\"NomRemoteAccessDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_RemoteAccess\" enumeration-picker-name=\"NomRemoteAccessHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Communications-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Communications'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_Communications\" enumeration-picker-name=\"NomCommunicationsDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_Communications\" enumeration-picker-name=\"NomCommunicationsHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Additonal Options-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Additional Options'\">\r\n              <div class=\"form-group\">\r\n                <!--Column 1-->\r\n                <div class=\"col-lg-6\">\r\n                  <div class=\"row\" style=\"padding-bottom:15px; \">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"DHW\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4 \" style=\"display:inline-block; border:thick; border-color:red;\">\r\n                      <label class=\"control-label\" style=\"display:inline-block; padding-right:10px;\">\r\n                        {{\"AVAILABLE\" | translate}}\r\n                      </label>\r\n                      <label class=\"control-label\" style=\"display:inline-block; border:thick; border-color:red;\">\r\n                        {{\"DEFAULT\" | translate}}\r\n                      </label>\r\n                    </div>\r\n                  </div>\r\n\r\n                  <!-- Energy Monitoring -->\r\n                  <div class=\"row\" style=\"padding-bottom:15px; \">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"ENERGY_MONITORING\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4\">\r\n                      <div class=\"input-group\" style=\"display:inline-block; padding-right: 60px;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatEnergyMonitoring_Available_DHW\"\r\n                               value=\"easiHeatEM_Available_DHW\" />\r\n                      </div>\r\n                      <div class=\"input-group\" style=\"display:inline-block;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatEnergyMonitoring_Default_DHW\"\r\n                               value=\"easiHeatEM_Default_DHW\" />\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <!--<div class=\"row\" style=\"padding-bottom:15px\">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"ENERGY_MONITORING\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4\">\r\n                      <div class=\"input-group\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatCvSplitRange\"\r\n                               value=\"easiHeatCvSplitRange\" />\r\n                      </div>\r\n\r\n                    </div>\r\n                  </div>-->\r\n                  <!-- Jacking Wheels -->\r\n                  <div class=\"row\" style=\"padding-bottom:15px\">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"JACKING_WHEELS\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4\">\r\n                      <div class=\"input-group\" style=\"display:inline-block; padding-right: 60px;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatJackingWheels_Available_DHW\"\r\n                               value=\"easiHeatJW_Available_DHW\" />\r\n                      </div>\r\n                      <div class=\"input-group\" style=\"display:inline-block;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatJackingWheels_Default_DHW\"\r\n                               value=\"easiHeatJW_Default_DHW\" />\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <!-- EN12828 Compliant -->\r\n                  <div class=\"row\" style=\"padding-bottom:15px\">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"EN12828_COMPLIANT\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4\">\r\n                      <div class=\"input-group\" style=\"display:inline-block; padding-right: 60px;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatENCompliant_Available_DHW\"\r\n                               value=\"easiHeatENC_Available_DHW\" />\r\n                      </div>\r\n                      <div class=\"input-group\" style=\"display:inline-block;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatENCompliant_Default_DHW\"\r\n                               value=\"easiHeatENC_Default_DHW\" />\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <!--Column 2-->\r\n                <div class=\"col-lg-6\">\r\n                  <div class=\"row\" style=\"padding-bottom:15px; \">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"HTG\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4 \" style=\"display:inline-block;\">\r\n                      <label class=\"control-label\" style=\"display:inline-block; padding-right:10px; border:thick; border-color:red;\">\r\n                        {{\"AVAILABLE\" | translate}}\r\n                      </label>\r\n                      <label class=\"control-label\" style=\"display:inline-block; border:thick; border-color:red;\">\r\n                        {{\"DEFAULT\" | translate}}\r\n                      </label>\r\n                    </div>\r\n                  </div>\r\n\r\n                  <!-- Energy Monitoring -->\r\n                  <div class=\"row\" style=\"padding-bottom:15px; \">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"ENERGY_MONITORING\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4\">\r\n                      <div class=\"input-group\" style=\"display:inline-block; padding-right: 60px;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatEnergyMonitoring_Available_HTG\"\r\n                               value=\"easiHeatEM_Available_HTG\" />\r\n                      </div>\r\n                      <div class=\"input-group\" style=\"display:inline-block;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatEnergyMonitoring_Default_HTG\"\r\n                               value=\"easiHeatEM_Default_HTG\" />\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <!--<div class=\"row\" style=\"padding-bottom:15px\">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"ENERGY_MONITORING\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4\">\r\n                      <div class=\"input-group\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatCvSplitRange\"\r\n                               value=\"easiHeatCvSplitRange\" />\r\n                      </div>\r\n\r\n                    </div>\r\n                  </div>-->\r\n                  <!-- Jacking Wheels -->\r\n                  <div class=\"row\" style=\"padding-bottom:15px\">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"JACKING_WHEELS\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4\">\r\n                      <div class=\"input-group\" style=\"display:inline-block; padding-right: 60px;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatJackingWheels_Available_HTG\"\r\n                               value=\"easiHeatJW_Available_HTG\" />\r\n                      </div>\r\n                      <div class=\"input-group\" style=\"display:inline-block;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatJackingWheels_Default_HTG\"\r\n                               value=\"easiHeatJW_Default_HTG\" />\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <!-- EN12828 Compliant -->\r\n                  <div class=\"row\" style=\"padding-bottom:15px\">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"EN12828_COMPLIANT\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4\">\r\n                      <div class=\"input-group\" style=\"display:inline-block; padding-right: 60px;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatENCompliant_Available_HTG\"\r\n                               value=\"easiHeatENC_Available_HTG\" />\r\n                      </div>\r\n                      <div class=\"input-group\" style=\"display:inline-block;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatENCompliant_Default_HTG\"\r\n                               value=\"easiHeatENC_Default_HTG\" />\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!--<div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW {{DHW}}\">DHW</h4><label>{{DHW}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeat_DHW_AdditionalOptions\" enumeration-picker-name=\"NomAdditionalOptionsDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG {{HTG}}\">HTG</h4><label>{{HTG}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeat_HTG_AdditionalOptions\" enumeration-picker-name=\"NomAdditionalOptionsHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>-->\r\n\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n\r\n    <a #collapsePriceDataTop href=\"#collapsePriceDataTop\"> </a>\r\n\r\n\r\n<!--Price Data Grid -->\r\n    <div *ngIf=\"!!easiHeatBOMOutputData.bomItems && easiHeatBOMOutputData.bomItems.length > 0 && showPrices\" class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"priceDataHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapsePriceData\" aria-expanded=\"true\" aria-controls=\"collapsePriceData\">\r\n            {{\"Price Data\"}} - {{'EASIHEAT' | translate:true}}{{operatingCompany}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <!-- Price Data Grid  -->\r\n      <div class=\"panel-body\">\r\n        <div class=\"col-xs-12\">\r\n\r\n          <ngx-datatable #easiHeatBOMOutputDataTable\r\n                         class=\"bootstrap\"\r\n                         [headerHeight]=\"40\"\r\n                         [limit]=\"50\"\r\n                         [columnMode]=\"'force'\"\r\n                         [footerHeight]=\"40\"\r\n                         [rowHeight]=\"'auto'\"\r\n                         [rows]=\"easiHeatBOMOutputData.bomItems\">\r\n\r\n\r\n\r\n            <!--[rowClass]=\"getRowClass\">-->\r\n            <!--  [selected]=\"selectedOutputData\"\r\n             [selectionType]=\"'single'\"\r\n             (select)=\"onSelect($event)\"\r\n        -->\r\n            <!-- Row Detail Template -->\r\n            <!--<ngx-datatable-row-detail [rowHeight]=\"getHeight\" #myDetailRow>\r\n          <ng-template let-row=\"row\" let-expanded=\"expanded\" ngx-datatable-row-detail-template>\r\n            <div *ngFor=\"let m of row.modelSizingMessages\">\r\n              <div class=\"row col-xs-12\">\r\n                <div class=\"col-xs-1 text-center\">\r\n                  <i [class]=\"getSeverityIcon(m.severity)\"></i>\r\n                </div>\r\n                <div class=\"col-xs-10\">\r\n                  <span>{{m.messageKey | translate}}</span>\r\n                  <span *ngIf=\"m.value !== 0 && m.unitKey\"> ({{m.value}} {{m.unitKey | translate:false}})</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </ng-template>\r\n        </ngx-datatable-row-detail>-->\r\n            <!-- Column Template -->\r\n            <!--<ngx-datatable-column>\r\n          <ng-template let-row=\"row\" let-expanded=\"expanded\" ngx-datatable-cell-template>\r\n            <i [class]=\"getRowSeverityIcon(row)\"></i>\r\n          </ng-template>\r\n        </ngx-datatable-column>-->\r\n            <!--Columns-->\r\n            <ngx-datatable-column [name]=\"'Number'\" prop=\"rowOrder\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Type'\" prop=\"itemType\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'ModelId'\" prop=\"modelId\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Option Group'\" prop=\"parentMasterTextKey\" [width]=\"200\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <!--<span *ngIf=\"!!value && value.indexOf('easiHeat_')!==0\">{{value | translate}}</span>\r\n                <span *ngIf=\"!!value && value.indexOf('easiHeat_')==0\">{{value.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>-->\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Option'\" prop=\"itemMasterTextKey\" [width]=\"200\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span [style.background]=\"!row.isEnabled ? 'Plum' : ' '\" *ngIf=\"!!value && value.indexOf('EH')!==0 && value.indexOf('Easiheat_')!==0 && value.indexOf('Nom')!==0\">{{value | translate}}</span>\r\n                <span [style.background]=\"!row.isEnabled ? 'Plum' : ' '\" *ngIf=\"!!value && value.indexOf('EH')==0\">{{value.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'SSP'\" prop=\"ssp\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol==easiHeatSellingCurrencySymbol\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol!==easiHeatSellingCurrencySymbol || row.modelId==0\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{easiHeatSellingCurrencySymbol}} {{localizeValue(row.sSSP,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Updated (yyyy-mm-dd)'\" prop=\"priceDataUTCDate\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">                \r\n                <span *ngIf=\"!!value\">{{value.split('T')[0]}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <!--<ngx-datatable-column [name]=\"'x'\" prop=\"ssPtoRSPfactor\" [width]=\"40\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"value!==0\">x {{value}} =</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>-->\r\n\r\n            <ngx-datatable-column [name]=\"'RSP'\" prop=\"recommendedSalesPrice\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <!--<span *ngIf=\"easiHeatManufacturerCurrencySymbol==easiHeatSellingCurrencySymbol\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol!==easiHeatSellingCurrencySymbol || row.modelId==0\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{easiHeatSellingCurrencySymbol}} {{localizeValue(row.sRecommendedSalesPrice,0)}})</span>-->\r\n                Unsupported\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <!--<ngx-datatable-column [name]=\"'RSP override'\" prop=\"recommendedSalesPriceOverride\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol==easiHeatSellingCurrencySymbol\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol!==easiHeatSellingCurrencySymbol || row.modelId==0\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{easiHeatSellingCurrencySymbol}} {{localizeValue(row.sRecommendedSalesPriceOverride,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>-->\r\n\r\n            <!--<ngx-datatable-column [name]=\"'Display Price'\" prop=\"displayedRSP\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol==easiHeatSellingCurrencySymbol\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol!==easiHeatSellingCurrencySymbol || row.modelId==0\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{easiHeatSellingCurrencySymbol}} {{localizeValue(row.sDisplayedRSP,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>-->\r\n\r\n            <ngx-datatable-column [name]=\"'Model'\" prop=\"parent\" [width]=\"30\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <!--<span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('easiHeat_')!==0\">{{value}}</span>\r\n  <span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('easiHeat_')==0\">{{value}} {{row.parentMasterTextKey.split('_')[1]}} {{row.parentMasterTextKey.split('_')[2]}}</span>-->\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Nomenclature'\" prop=\"item\" [width]=\"50\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"!!value.split('_')[1]\">{{value.split('_')[1]}}</span>\r\n                <!--<span *ngIf=\"!value.split('_')[1]\">{{value}}</span>-->\r\n                <span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('easiHeat_')==0\">{{row.parentMasterTextKey.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <!--[style.background]=\"row.isEnabled ? 'White' : 'SlateGray'\"-->\r\n            <!--<ngx-datatable-column [name]=\"'Enabled'\" prop=\"isEnabled\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"value\">+</span>\r\n                <span *ngIf=\"!value\">-</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>-->\r\n\r\n          </ngx-datatable>\r\n\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n</form>\r\n  </div>\r\n",
                providers: [EasiHeatService],
                styles: [".cross-validation-error-class{font-size:25px;color:#708090}"]
            }] }
];
/** @nocollapse */
EasiHeatPreferencesComponent.ctorParameters = () => [
    { type: RoutesService },
    { type: AdminService },
    { type: TranslationService },
    { type: FormBuilder },
    { type: TranslatePipe },
    { type: ModulePreferenceService },
    { type: EasiHeatService },
    { type: LocaleService$1 },
    { type: UserProfileService },
    { type: User }
];
EasiHeatPreferencesComponent.propDecorators = {
    easiHeatBOMOutputDataTable: [{ type: ViewChild, args: ["easiHeatBOMOutputDataTable", { static: false },] }],
    collapsePriceDataTop: [{ type: ViewChild, args: ['collapsePriceDataTop', { static: false },] }]
};
if (false) {
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.moduleId;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.moduleGroupId;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.cloneDeep;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.moduleName;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatBOMOutputDataTable;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.collapsePriceDataTop;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.componentInitialised;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.componentLoadPromises;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.theFormGroup;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.hasUnsavedDataChanges;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.isSuccess;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.alertVisible;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.formSubmitted;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatOptionsSelectedItem;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.manufacturerList;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.currencyList;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatManufacturerCurrencyId;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatManufacturerCurrency;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatManufacturerCurrencySymbol;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatSellingCurrencyId;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatSellingCurrencySymbol;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatCurrencyConversion;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatLandedCostIncrease;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatDeliveryCost;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatCommissionOnlyPrice;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatWarrantyOneYear;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatWarrantyTwoYears;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatWarrantyThreeYears;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatHeatExchangerTS6;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatHeatExchangerT6;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatHeatExchangerT8;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatHeatExchangerT10;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatPricingCurrency;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatOverrideMarkup;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatOverrideMarkupActive;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatSellingMarkup;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatLandedCostIncreaseModPref;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatDeliveryCostModPref;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatCommissionOnly;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatCvSplitRange;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatSteamSideControlOnHTG;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatMotiveInletPressureAvailable;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatPRVAvailableOnEHHCC;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatHideHEModelFromSizing;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easi_Heat_DHW_And_HTG_Sc_Options_Actuator;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easi_HTG_CC_Options_Actuator;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatDHWandHTGScOptions_DesignCode;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easi_HTG_CC_Options_DesignCode;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatDHWandHTGScOptions_HighLimit;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easi_HTG_CC_Options_HighLimit;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatDHWandHTGScOptions_HighLimitActuation;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easi_HTG_CC_Options_HighLimitActuation;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatDHWandHTGScOptions_Isolation;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easi_HTG_CC_Options_Isolation;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatDHWandHTGScOptions_ControlPanel;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easi_HTG_CC_Options_ControlPanel;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatDHWandHTGScOptions_ServiceOffering;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easi_HTG_CC_Options_ServiceOffering;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatDHWandHTGScOptions_Gasket;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easi_HTG_CC_Options_Gasket;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatDHWandHTGScOptions_RemoteAccess;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easi_HTG_CC_Options_RemoteAccess;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatDHWandHTGScOptions_Communications;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easi_HTG_CC_Options_Communications;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeat_DHW_AdditionalOptions;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeat_HTG_AdditionalOptions;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatDHWAvailable;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatDHWOn;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatDHWOff;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatHTGAvailable;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatHTGOn;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatHTGOff;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatEnergyMonitoring_Available_DHW;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatEnergyMonitoring_Default_DHW;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatJackingWheels_Available_DHW;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatJackingWheels_Default_DHW;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatENCompliant_Available_DHW;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatENCompliant_Default_DHW;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatEnergyMonitoring_Available_HTG;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatEnergyMonitoring_Default_HTG;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatJackingWheels_Available_HTG;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatJackingWheels_Default_HTG;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatENCompliant_Available_HTG;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatENCompliant_Default_HTG;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.modulePreferencesForm;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatManufacturerPrefFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatManufacturerCurrencyModulePreference;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatSellingCurrencyPrefFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatLandedCostIncreasePrefFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatDeliveryCostPrefFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatCommissionOnlyPricePrefFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatWarrantyOneYearPrefFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatWarrantyTwoYearsPrefFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatWarrantyThreeYearsPrefFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatOptionsFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.serviceOffereingMessage;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.deliveryCostMessage;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatPricing;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatBOMOutputData;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.easiHeatBOMOutputDataRows;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.manufacturerId;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.DHW_OPTIONS;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.HTG_CC_AND_SC_OPTIONS;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.DHW_AND_HTG_SC_OPTIONS;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.HTG_CC_OPTIONS;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.DHW;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.HTG;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.showPrices;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.augmentPriceDataProcessing;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.overrideMarkupActive;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.cvSplitRange;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.SellSteamControl;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.MotiveInletPressureAvailable;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.YearOne;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.YearTwo;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.YearThree;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.PrvAllowed;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.HideHEmodelFromSizing;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.operatingCompany;
    /** @type {?} */
    EasiHeatPreferencesComponent.prototype.scrollToElement;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent.prototype.routesService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent.prototype.adminService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent.prototype.translationService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent.prototype.translatePipe;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent.prototype.modulePreferenceService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent.prototype.easiHeatService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent.prototype.localeService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent.prototype.userProfileService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent.prototype.user;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/easiheatgen4/modulePreference/easiheatgen4PricingOptions.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//import { Message } from '../../../core/messages/message.model';
//import { Message } from "sizing-shared-lib";
/*************************************
    MODULE PREFERENCES VERSION!
**************************************/
/**
 * The CleanSteamGeneratorPricing model.
 */
class EasiHeatPricing$1 {
}
if (false) {
    /**
     * Gets or sets the modelId.
     * @type {?}
     */
    EasiHeatPricing$1.prototype.modelId;
    /**
     * Gets or sets the manufacturerId.
     * @type {?}
     */
    EasiHeatPricing$1.prototype.manufacturerId;
    /**
     * Gets or sets the basePriceOption.
     * @type {?}
     */
    EasiHeatPricing$1.prototype.basePriceOption;
    /**
     * Gets or sets the localRecommendedSalesPriceOption.
     * @type {?}
     */
    EasiHeatPricing$1.prototype.localRecommendedSalesPriceOption;
    /**
     * Gets or sets the landedCostIncreaseFactor.
     * @type {?}
     */
    EasiHeatPricing$1.prototype.landedCostIncreaseFactor;
    /**
     * Gets or sets the pricingOptions.
     * @type {?}
     */
    EasiHeatPricing$1.prototype.pricingOptions;
}
class EasiHeatPricingOption$1 {
}
if (false) {
    /**
     * Gets or sets the enumerationName.
     * @type {?}
     */
    EasiHeatPricingOption$1.prototype.enumerationName;
    /**
     * Gets or sets the selectedValue.
     * @type {?}
     */
    EasiHeatPricingOption$1.prototype.selectedValue;
}
class EasiHeatPricingOutput$1 {
}
if (false) {
    /**
     * Gets or sets the totalPrice.
     * @type {?}
     */
    EasiHeatPricingOutput$1.prototype.totalSalesPrice;
    /**
     * Gets or sets the totalRecommendedSalesPrice.
     * @type {?}
     */
    EasiHeatPricingOutput$1.prototype.totalRecommendedSalesPrice;
}
class EasiHeatBOMPriceOutput$1 {
}
if (false) {
    /**
     * Gets or sets the BOMItems.
     * @type {?}
     */
    EasiHeatBOMPriceOutput$1.prototype.bomItems;
}
class BOMItem$3 {
    constructor() {
        /**
         * Gets or sets the isEnabled.
         */
        this.isEnabled = true;
    }
}
if (false) {
    /**
     * Gets or sets the rowOrder.
     * @type {?}
     */
    BOMItem$3.prototype.rowOrder;
    /**
     * Gets or sets the itemType.
     * @type {?}
     */
    BOMItem$3.prototype.itemType;
    /**
     * Gets or sets the modelId.
     * @type {?}
     */
    BOMItem$3.prototype.modelId;
    /**
     * Gets or sets the parent.
     * @type {?}
     */
    BOMItem$3.prototype.parent;
    /**
     * Gets or sets the parentMasterTextKey.
     * @type {?}
     */
    BOMItem$3.prototype.parentMasterTextKey;
    /**
     * Gets or sets the parentTranslation.
     * @type {?}
     */
    BOMItem$3.prototype.parentTranslation;
    /**
     * Gets or sets the item.
     * @type {?}
     */
    BOMItem$3.prototype.item;
    /**
     * Gets or sets the itemTranslation.
     * @type {?}
     */
    BOMItem$3.prototype.itemTranslation;
    /**
     * Gets or sets the itemMasterTextKey.
     * @type {?}
     */
    BOMItem$3.prototype.itemMasterTextKey;
    /**
     * Gets or sets the sequenceDefault.
     * @type {?}
     */
    BOMItem$3.prototype.sequenceDefault;
    /**
     * Gets or sets the sequenceOverride.
     * @type {?}
     */
    BOMItem$3.prototype.sequenceOverride;
    /**
     * Gets or sets the landedAdjusted.
     * @type {?}
     */
    BOMItem$3.prototype.landedAdjusted;
    /**
     * Gets or sets the ssp.
     * @type {?}
     */
    BOMItem$3.prototype.ssp;
    /**
     * Gets or sets the ssPtoRSPfactor.
     * @type {?}
     */
    BOMItem$3.prototype.ssPtoRSPfactor;
    /**
     * Gets or sets the recommendedSalesPrice.
     * @type {?}
     */
    BOMItem$3.prototype.recommendedSalesPrice;
    /**
     * Gets or sets the rsPtoRSPOfactor.
     * @type {?}
     */
    BOMItem$3.prototype.rsPtoRSPOfactor;
    /**
     * Gets or sets the recommendedSalesPriceOverride.
     * @type {?}
     */
    BOMItem$3.prototype.recommendedSalesPriceOverride;
    /**
     * Gets or sets the displayedRSP.
     * @type {?}
     */
    BOMItem$3.prototype.displayedRSP;
    /**
     * Gets or sets the manCurrency.
     * @type {?}
     */
    BOMItem$3.prototype.manCurrency;
    /**
     * Gets or sets the displayedRSP.
     * @type {?}
     */
    BOMItem$3.prototype.manRateToGBP;
    /**
     * Gets or sets the displayedRSP.
     * @type {?}
     */
    BOMItem$3.prototype.manCurrencyId;
    /**
     * Gets or sets the priceDataUTCDate.
     * @type {?}
     */
    BOMItem$3.prototype.priceDataUTCDate;
    /**
     * Gets or sets the sLandedAdjusted.
     * @type {?}
     */
    BOMItem$3.prototype.sLandedAdjusted;
    /**
     * Gets or sets the sSSP.
     * @type {?}
     */
    BOMItem$3.prototype.sSSP;
    /**
     * Gets or sets the sRecommendedSalesPrice.
     * @type {?}
     */
    BOMItem$3.prototype.sRecommendedSalesPrice;
    /**
     * Gets or sets the sRecommendedSalesPriceOverride.
     * @type {?}
     */
    BOMItem$3.prototype.sRecommendedSalesPriceOverride;
    /**
     * Gets or sets the sDisplayedRSP.
     * @type {?}
     */
    BOMItem$3.prototype.sDisplayedRSP;
    /**
     * Gets or sets the sellingCurrency.
     * @type {?}
     */
    BOMItem$3.prototype.sellingCurrency;
    /**
     * Gets or sets the sellingRateToGBP.
     * @type {?}
     */
    BOMItem$3.prototype.sellingRateToGBP;
    /**
     * Gets or sets the sellingCurrencyId.
     * @type {?}
     */
    BOMItem$3.prototype.sellingCurrencyId;
    /**
     * Gets or sets the isEnabled.
     * @type {?}
     */
    BOMItem$3.prototype.isEnabled;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/easiheatgen4/modulePreference/easiheatgen4.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * **********************************
 * MODULE PREFERENCES VERSION!
 * ************************************
 */
class EasiHeatGen4Service {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} ehPricing
     * @return {?}
     */
    calculateBOMPrice(ehPricing) {
        return this.http.post(`./Api/EasiHeatGen4/CalculateBOMPrice`, ehPricing);
    }
}
EasiHeatGen4Service.decorators = [
    { type: Injectable }
];
/** @nocollapse */
EasiHeatGen4Service.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    EasiHeatGen4Service.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/easiheatgen4/modulePreference/easiheatgen4.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EasiHeatGen4PreferencesComponent {
    /**
     * @param {?} routesService
     * @param {?} adminService
     * @param {?} translationService
     * @param {?} fb
     * @param {?} translatePipe
     * @param {?} modulePreferenceService
     * @param {?} easiHeatService
     * @param {?} localeService
     * @param {?} userProfileService
     * @param {?} user
     */
    constructor(routesService, adminService, translationService, fb, translatePipe, modulePreferenceService, easiHeatService, localeService, userProfileService, user) {
        this.routesService = routesService;
        this.adminService = adminService;
        this.translationService = translationService;
        this.fb = fb;
        this.translatePipe = translatePipe;
        this.modulePreferenceService = modulePreferenceService;
        this.easiHeatService = easiHeatService;
        this.localeService = localeService;
        this.userProfileService = userProfileService;
        this.user = user;
        this.moduleId = "13";
        this.moduleGroupId = 16;
        this.cloneDeep = cloneDeep_;
        this.moduleName = "EasiHeatGen4";
        // for scroll to view
        this.componentInitialised = false;
        this.componentLoadPromises = [];
        // to drive GenericChangesGuard
        this.isSuccess = false;
        this.alertVisible = false;
        this.formSubmitted = false;
        //*** Regular module prefs ***
        // Currency Options
        this.manufacturerList = [];
        this.currencyList = [];
        this.EH_DHW_SC_Price = "";
        this.EH_DHW_DC_Price = "";
        this.EH_HTG_CC_Price = "";
        this.EH_HTG_SC_Price = "";
        this.EH_HTG_DC_Price = "";
        this.easiHeatBOMOutputDataRows = [];
        this.showPrices = false;
        this.augmentPriceDataProcessing = true; // disable button whilst page loading
        // disable button whilst page loading
        this.overrideMarkupActive = false;
        this.cvSplitRange = false;
        this.allowHighDesignPressure = false;
        this.SellSteamControl = false;
        this.MotiveInletPressureAvailable = false;
        this.YearOne = false;
        this.YearTwo = false;
        this.YearThree = false;
        this.PrvAllowed = false;
        this.HideHEmodelFromSizing = false;
        this.scrollToElement = (/**
         * @param {?} elementRef
         * @param {?=} position
         * @return {?}
         */
        (elementRef, position = "start") => {
            // ToDo: Fix fussy scroll on first sizing bug. Hence the use of timeout delay here.
            setTimeout((/**
             * @return {?}
             */
            () => {
                try {
                    elementRef.nativeElement.scrollIntoView({ block: position, behavior: "smooth" });
                }
                catch (err) {
                    console.log(`scrollToElement err=${err}`);
                }
            }), 200);
        });
        this.userProfileService.getUserDetails().subscribe((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            this.user = user;
            if (!!this.user) {
                this.operatingCompany = " : " + this.user.operatingCompanyName;
            }
        }));
        this.easiHeatBOMOutputData = new EasiHeatBOMPriceOutput$1();
        //var userType = this.
        this.easiHeatManufacturerPrefFormControl = new FormControl({ value: '', disabled: true });
        this.easiHeatManufacturerCurrencyModulePreference = new FormControl({ value: '', disabled: true });
        this.easiHeatSellingCurrencyPrefFormControl = new FormControl('');
        this.easiHeatLandedCostIncreasePrefFormControl = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatDeliveryCostPrefFormControl = new FormControl('', [Validators.required]);
        this.easiHeatCommissionOnlyPricePrefFormControl = new FormControl('', [Validators.required]);
        this.easiHeatWarrantyOneYearPrefFormControl = new FormControl('', [Validators.required]);
        this.easiHeatWarrantyTwoYearsPrefFormControl = new FormControl('', [Validators.required]);
        this.easiHeatWarrantyThreeYearsPrefFormControl = new FormControl('', [Validators.required]);
        this.easiHeatOptionsFormControl = new FormControl({ value: '', disabled: false });
        //Heat Exchanger
        this.easiHeatHeatExchangerTS6 = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatHeatExchangerT6 = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatHeatExchangerT8 = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatHeatExchangerT10 = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatPricingCurrency = new FormControl({ value: '', disabled: false });
        this.easiHeatOverrideMarkup = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatOverrideMarkupActive = new FormControl(false); //checkbox
        this.easiHeatAllowHighDesignPressure = new FormControl(false); //checkbox
        this.easiHeatSellingMarkup = new FormControl({ value: '', disabled: false });
        this.easiHeatLandedCostIncreaseModPref = new FormControl('', [Validators.required]);
        this.easiHeatDeliveryCostModPref = new FormControl('', [Validators.required]);
        this.easiHeatCommissionOnly = new FormControl('', [Validators.required]);
        this.easiHeatCvSplitRange = new FormControl(false); //checkbox
        this.easiHeatSteamSideControlOnHTG = new FormControl(false); //checkbox
        this.easiHeatMotiveInletPressureAvailable = new FormControl(false); //checkbox
        this.easiHeatPRVAvailableOnEHHCC = new FormControl(false); //checkbox 
        this.easiHeatHideHEModelFromSizing = new FormControl(false); //checkbox
        this.EH_GEN4_GlobalVariance_Control = new FormControl(null);
        this.EH_DHW_SC_Actuator_Control = new FormControl(null);
        this.EH_DHW_DC_Actuator_Control = new FormControl(null);
        this.EH_HTG_CC_Actuator_Control = new FormControl(null);
        this.EH_HTG_SC_Actuator_Control = new FormControl(null);
        this.EH_HTG_DC_Actuator_Control = new FormControl(null);
        this.EH_DHW_SC_Communications_Control = new FormControl(null);
        this.EH_DHW_DC_Communications_Control = new FormControl(null);
        this.EH_HTG_CC_Communications_Control = new FormControl(null);
        this.EH_HTG_SC_Communications_Control = new FormControl(null);
        this.EH_HTG_DC_Communications_Control = new FormControl(null);
        this.EH_DHW_SC_CondensateRemoval_Control = new FormControl(null);
        this.EH_DHW_DC_CondensateRemoval_Control = new FormControl(null);
        this.EH_HTG_CC_CondensateRemoval_Control = new FormControl(null);
        this.EH_HTG_SC_CondensateRemoval_Control = new FormControl(null);
        this.EH_HTG_DC_CondensateRemoval_Control = new FormControl(null);
        this.EH_DHW_SC_ControlSystem_Control = new FormControl(null);
        this.EH_DHW_DC_ControlSystem_Control = new FormControl(null);
        this.EH_HTG_CC_ControlSystem_Control = new FormControl(null);
        this.EH_HTG_SC_ControlSystem_Control = new FormControl(null);
        this.EH_HTG_DC_ControlSystem_Control = new FormControl(null);
        this.EH_DHW_SC_PanelLocation_Control = new FormControl(null);
        this.EH_DHW_DC_PanelLocation_Control = new FormControl(null);
        this.EH_HTG_CC_PanelLocation_Control = new FormControl(null);
        this.EH_HTG_SC_PanelLocation_Control = new FormControl(null);
        this.EH_HTG_DC_PanelLocation_Control = new FormControl(null);
        this.EH_DHW_SC_DataCollection_Control = new FormControl(null);
        this.EH_DHW_DC_DataCollection_Control = new FormControl(null);
        this.EH_HTG_CC_DataCollection_Control = new FormControl(null);
        this.EH_HTG_SC_DataCollection_Control = new FormControl(null);
        this.EH_HTG_DC_DataCollection_Control = new FormControl(null);
        this.EH_DHW_SC_FrameType_Control = new FormControl(null);
        this.EH_DHW_DC_FrameType_Control = new FormControl(null);
        this.EH_HTG_CC_FrameType_Control = new FormControl(null);
        this.EH_HTG_SC_FrameType_Control = new FormControl(null);
        this.EH_HTG_DC_FrameType_Control = new FormControl(null);
        this.EH_DHW_SC_PackageSupports_Control = new FormControl(null);
        this.EH_DHW_DC_PackageSupports_Control = new FormControl(null);
        this.EH_HTG_CC_PackageSupports_Control = new FormControl(null);
        this.EH_HTG_SC_PackageSupports_Control = new FormControl(null);
        this.EH_HTG_DC_PackageSupports_Control = new FormControl(null);
        this.EH_DHW_SC_HighLimit_Control = new FormControl(null);
        this.EH_DHW_DC_HighLimit_Control = new FormControl(null);
        this.EH_HTG_CC_HighLimit_Control = new FormControl(null);
        this.EH_HTG_SC_HighLimit_Control = new FormControl(null);
        this.EH_HTG_DC_HighLimit_Control = new FormControl(null);
        this.EH_DHW_SC_ManualIsolation_Control = new FormControl(null);
        this.EH_DHW_DC_ManualIsolation_Control = new FormControl(null);
        this.EH_HTG_CC_ManualIsolation_Control = new FormControl(null);
        this.EH_HTG_SC_ManualIsolation_Control = new FormControl(null);
        this.EH_HTG_DC_ManualIsolation_Control = new FormControl(null);
        this.EH_DHW_SC_GasketMaterial_Control = new FormControl(null);
        this.EH_DHW_DC_GasketMaterial_Control = new FormControl(null);
        this.EH_HTG_CC_GasketMaterial_Control = new FormControl(null);
        this.EH_HTG_SC_GasketMaterial_Control = new FormControl(null);
        this.EH_HTG_DC_GasketMaterial_Control = new FormControl(null);
        this.EH_DHW_SC_Extras_Control = new FormControl(null);
        this.EH_DHW_DC_Extras_Control = new FormControl(null);
        this.EH_HTG_CC_Extras_Control = new FormControl(null);
        this.EH_HTG_SC_Extras_Control = new FormControl(null);
        this.EH_HTG_DC_Extras_Control = new FormControl(null);
        this.EH_DHW_SC_ServiceOffering_Control = new FormControl(null);
        this.EH_DHW_DC_ServiceOffering_Control = new FormControl(null);
        this.EH_HTG_CC_ServiceOffering_Control = new FormControl(null);
        this.EH_HTG_SC_ServiceOffering_Control = new FormControl(null);
        this.EH_HTG_DC_ServiceOffering_Control = new FormControl(null);
        this.EH_DHW_SC_SystemRecirculation_Control = new FormControl(null);
        this.EH_DHW_DC_SystemRecirculation_Control = new FormControl(null);
        this.EH_HTG_CC_SystemRecirculation_Control = new FormControl(null);
        this.EH_HTG_SC_SystemRecirculation_Control = new FormControl(null);
        this.EH_HTG_DC_SystemRecirculation_Control = new FormControl(null);
        this.EH_DHW_SC_ControlValveFeedback_Control = new FormControl(null);
        this.EH_DHW_DC_ControlValveFeedback_Control = new FormControl(null);
        this.EH_HTG_CC_ControlValveFeedback_Control = new FormControl(null);
        this.EH_HTG_SC_ControlValveFeedback_Control = new FormControl(null);
        this.EH_HTG_DC_ControlValveFeedback_Control = new FormControl(null);
        this.EH_DHW_SC_UPS_Control = new FormControl(null);
        this.EH_DHW_DC_UPS_Control = new FormControl(null);
        this.EH_HTG_CC_UPS_Control = new FormControl(null);
        this.EH_HTG_SC_UPS_Control = new FormControl(null);
        this.EH_HTG_DC_UPS_Control = new FormControl(null);
        this.EH_DHW_SC_Insulation_Control = new FormControl(null);
        this.EH_DHW_DC_Insulation_Control = new FormControl(null);
        this.EH_HTG_CC_Insulation_Control = new FormControl(null);
        this.EH_HTG_SC_Insulation_Control = new FormControl(null);
        this.EH_HTG_DC_Insulation_Control = new FormControl(null);
        this.easiHeatDHWAvailable = new FormControl({ value: false, disabled: false });
        this.easiHeatDHWOn = new FormControl({ value: false, disabled: false });
        this.easiHeatDHWOff = new FormControl({ value: false, disabled: false });
        this.easiHeatHTGAvailable = new FormControl({ value: false, disabled: false });
        this.easiHeatHTGOn = new FormControl({ value: false, disabled: false });
        this.easiHeatHTGOff = new FormControl({ value: false, disabled: false });
        // Setup the form group.
        this.modulePreferencesForm = this.fb.group({
            // Currency Options
            easiHeatManufacturerModulePreference: this.easiHeatManufacturerPrefFormControl,
            easiHeatManufacturerCurrencyModulePreference: this.easiHeatManufacturerCurrencyModulePreference,
            easiHeatSellingCurrencyModulePreference: this.easiHeatSellingCurrencyPrefFormControl,
            //Heat Exchanger
            easiHeatHeatExchangerTS6: this.easiHeatHeatExchangerTS6,
            easiHeatHeatExchangerT6: this.easiHeatHeatExchangerT6,
            easiHeatHeatExchangerT8: this.easiHeatHeatExchangerT8,
            easiHeatHeatExchangerT10: this.easiHeatHeatExchangerT10,
            easiHeatPricingCurrency: this.easiHeatPricingCurrency,
            easiHeatOverrideMarkup: this.easiHeatOverrideMarkup,
            easiHeatOverrideMarkupActive: this.easiHeatOverrideMarkupActive,
            easiHeatAllowHighDesignPressure: this.easiHeatAllowHighDesignPressure,
            easiHeatSellingMarkup: this.easiHeatSellingMarkup,
            easiHeatLandedCostIncreaseModPref: this.easiHeatLandedCostIncreaseModPref,
            easiHeatDeliveryCostModPref: this.easiHeatDeliveryCostModPref,
            easiHeatCommissionOnly: this.easiHeatCommissionOnly,
            easiHeatCvSplitRange: this.easiHeatCvSplitRange,
            easiHeatSteamSideControlOnHTG: this.easiHeatSteamSideControlOnHTG,
            easiHeatMotiveInletPressureAvailable: this.easiHeatMotiveInletPressureAvailable,
            easiHeatPRVAvailableOnEHHCC: this.easiHeatPRVAvailableOnEHHCC,
            easiHeatHideHEModelFromSizing: this.easiHeatHideHEModelFromSizing,
            EH_GEN4_GlobalVariance_Control: this.EH_GEN4_GlobalVariance_Control,
            EH_DHW_SC_Actuator_Control: this.EH_DHW_SC_Actuator_Control,
            EH_DHW_DC_Actuator_Control: this.EH_DHW_DC_Actuator_Control,
            EH_HTG_CC_Actuator_Control: this.EH_HTG_CC_Actuator_Control,
            EH_HTG_SC_Actuator_Control: this.EH_HTG_SC_Actuator_Control,
            EH_HTG_DC_Actuator_Control: this.EH_HTG_DC_Actuator_Control,
            EH_DHW_SC_Communications_Control: this.EH_DHW_SC_Communications_Control,
            EH_DHW_DC_Communications_Control: this.EH_DHW_DC_Communications_Control,
            EH_HTG_CC_Communications_Control: this.EH_HTG_CC_Communications_Control,
            EH_HTG_SC_Communications_Control: this.EH_HTG_SC_Communications_Control,
            EH_HTG_DC_Communications_Control: this.EH_HTG_DC_Communications_Control,
            EH_DHW_SC_CondensateRemoval_Control: this.EH_DHW_SC_CondensateRemoval_Control,
            EH_DHW_DC_CondensateRemoval_Control: this.EH_DHW_DC_CondensateRemoval_Control,
            EH_HTG_CC_CondensateRemoval_Control: this.EH_HTG_CC_CondensateRemoval_Control,
            EH_HTG_SC_CondensateRemoval_Control: this.EH_HTG_SC_CondensateRemoval_Control,
            EH_HTG_DC_CondensateRemoval_Control: this.EH_HTG_DC_CondensateRemoval_Control,
            EH_DHW_SC_ControlSystem_Control: this.EH_DHW_SC_ControlSystem_Control,
            EH_DHW_DC_ControlSystem_Control: this.EH_DHW_DC_ControlSystem_Control,
            EH_HTG_CC_ControlSystem_Control: this.EH_HTG_CC_ControlSystem_Control,
            EH_HTG_SC_ControlSystem_Control: this.EH_HTG_SC_ControlSystem_Control,
            EH_HTG_DC_ControlSystem_Control: this.EH_HTG_DC_ControlSystem_Control,
            EH_DHW_SC_PanelLocation_Control: this.EH_DHW_SC_PanelLocation_Control,
            EH_DHW_DC_PanelLocation_Control: this.EH_DHW_DC_PanelLocation_Control,
            EH_HTG_CC_PanelLocation_Control: this.EH_HTG_CC_PanelLocation_Control,
            EH_HTG_SC_PanelLocation_Control: this.EH_HTG_SC_PanelLocation_Control,
            EH_HTG_DC_PanelLocation_Control: this.EH_HTG_DC_PanelLocation_Control,
            EH_DHW_SC_DataCollection_Control: this.EH_DHW_SC_DataCollection_Control,
            EH_DHW_DC_DataCollection_Control: this.EH_DHW_DC_DataCollection_Control,
            EH_HTG_CC_DataCollection_Control: this.EH_HTG_CC_DataCollection_Control,
            EH_HTG_SC_DataCollection_Control: this.EH_HTG_SC_DataCollection_Control,
            EH_HTG_DC_DataCollection_Control: this.EH_HTG_DC_DataCollection_Control,
            EH_DHW_SC_FrameType_Control: this.EH_DHW_SC_FrameType_Control,
            EH_DHW_DC_FrameType_Control: this.EH_DHW_DC_FrameType_Control,
            EH_HTG_CC_FrameType_Control: this.EH_HTG_CC_FrameType_Control,
            EH_HTG_SC_FrameType_Control: this.EH_HTG_SC_FrameType_Control,
            EH_HTG_DC_FrameType_Control: this.EH_HTG_DC_FrameType_Control,
            EH_DHW_SC_PackageSupports_Control: this.EH_DHW_SC_PackageSupports_Control,
            EH_DHW_DC_PackageSupports_Control: this.EH_DHW_DC_PackageSupports_Control,
            EH_HTG_CC_PackageSupports_Control: this.EH_HTG_CC_PackageSupports_Control,
            EH_HTG_SC_PackageSupports_Control: this.EH_HTG_SC_PackageSupports_Control,
            EH_HTG_DC_PackageSupports_Control: this.EH_HTG_DC_PackageSupports_Control,
            EH_DHW_SC_HighLimit_Control: this.EH_DHW_SC_HighLimit_Control,
            EH_DHW_DC_HighLimit_Control: this.EH_DHW_DC_HighLimit_Control,
            EH_HTG_CC_HighLimit_Control: this.EH_HTG_CC_HighLimit_Control,
            EH_HTG_SC_HighLimit_Control: this.EH_HTG_SC_HighLimit_Control,
            EH_HTG_DC_HighLimit_Control: this.EH_HTG_DC_HighLimit_Control,
            EH_DHW_SC_ManualIsolation_Control: this.EH_DHW_SC_ManualIsolation_Control,
            EH_DHW_DC_ManualIsolation_Control: this.EH_DHW_DC_ManualIsolation_Control,
            EH_HTG_CC_ManualIsolation_Control: this.EH_HTG_CC_ManualIsolation_Control,
            EH_HTG_SC_ManualIsolation_Control: this.EH_HTG_SC_ManualIsolation_Control,
            EH_HTG_DC_ManualIsolation_Control: this.EH_HTG_DC_ManualIsolation_Control,
            EH_DHW_SC_GasketMaterial_Control: this.EH_DHW_SC_GasketMaterial_Control,
            EH_DHW_DC_GasketMaterial_Control: this.EH_DHW_DC_GasketMaterial_Control,
            EH_HTG_CC_GasketMaterial_Control: this.EH_HTG_CC_GasketMaterial_Control,
            EH_HTG_SC_GasketMaterial_Control: this.EH_HTG_SC_GasketMaterial_Control,
            EH_HTG_DC_GasketMaterial_Control: this.EH_HTG_DC_GasketMaterial_Control,
            EH_DHW_SC_Extras_Control: this.EH_DHW_SC_Extras_Control,
            EH_DHW_DC_Extras_Control: this.EH_DHW_DC_Extras_Control,
            EH_HTG_CC_Extras_Control: this.EH_HTG_CC_Extras_Control,
            EH_HTG_SC_Extras_Control: this.EH_HTG_SC_Extras_Control,
            EH_HTG_DC_Extras_Control: this.EH_HTG_DC_Extras_Control,
            EH_DHW_SC_ServiceOffering_Control: this.EH_DHW_SC_ServiceOffering_Control,
            EH_DHW_DC_ServiceOffering_Control: this.EH_DHW_DC_ServiceOffering_Control,
            EH_HTG_CC_ServiceOffering_Control: this.EH_HTG_CC_ServiceOffering_Control,
            EH_HTG_SC_ServiceOffering_Control: this.EH_HTG_SC_ServiceOffering_Control,
            EH_HTG_DC_ServiceOffering_Control: this.EH_HTG_DC_ServiceOffering_Control,
            EH_DHW_SC_SystemRecirculation_Control: this.EH_DHW_SC_SystemRecirculation_Control,
            EH_DHW_DC_SystemRecirculation_Control: this.EH_DHW_DC_SystemRecirculation_Control,
            EH_HTG_CC_SystemRecirculation_Control: this.EH_HTG_CC_SystemRecirculation_Control,
            EH_HTG_SC_SystemRecirculation_Control: this.EH_HTG_SC_SystemRecirculation_Control,
            EH_HTG_DC_SystemRecirculation_Control: this.EH_HTG_DC_SystemRecirculation_Control,
            EH_DHW_SC_ControlValveFeedback_Control: this.EH_DHW_SC_ControlValveFeedback_Control,
            EH_DHW_DC_ControlValveFeedback_Control: this.EH_DHW_DC_ControlValveFeedback_Control,
            EH_HTG_CC_ControlValveFeedback_Control: this.EH_HTG_CC_ControlValveFeedback_Control,
            EH_HTG_SC_ControlValveFeedback_Control: this.EH_HTG_SC_ControlValveFeedback_Control,
            EH_HTG_DC_ControlValveFeedback_Control: this.EH_HTG_DC_ControlValveFeedback_Control,
            EH_DHW_SC_UPS_Control: this.EH_DHW_SC_UPS_Control,
            EH_DHW_DC_UPS_Control: this.EH_DHW_DC_UPS_Control,
            EH_HTG_CC_UPS_Control: this.EH_HTG_CC_UPS_Control,
            EH_HTG_SC_UPS_Control: this.EH_HTG_SC_UPS_Control,
            EH_HTG_DC_UPS_Control: this.EH_HTG_DC_UPS_Control,
            EH_DHW_SC_Insulation_Control: this.EH_DHW_SC_Insulation_Control,
            EH_DHW_DC_Insulation_Control: this.EH_DHW_DC_Insulation_Control,
            EH_HTG_CC_Insulation_Control: this.EH_HTG_CC_Insulation_Control,
            EH_HTG_SC_Insulation_Control: this.EH_HTG_SC_Insulation_Control,
            EH_HTG_DC_Insulation_Control: this.EH_HTG_DC_Insulation_Control,
            easiHeatDHWAvailable: this.easiHeatDHWAvailable,
            easiHeatDHWOn: this.easiHeatDHWOn,
            easiHeatDHWOff: this.easiHeatDHWOff,
            easiHeatHTGAvailable: this.easiHeatHTGAvailable,
            easiHeatHTGOn: this.easiHeatHTGOn,
            easiHeatHTGOff: this.easiHeatHTGOff,
            // Pricing Options
            easiHeatLandedCostIncreaseModulePreference: this.easiHeatLandedCostIncreasePrefFormControl,
            easiHeatDeliveryCostModulePreference: this.easiHeatDeliveryCostPrefFormControl,
            easiHeatCommissionOnlyPriceModulePreference: this.easiHeatCommissionOnlyPricePrefFormControl,
            easiHeatWarrantyOneYearModulePreference: this.easiHeatWarrantyOneYearPrefFormControl,
            easiHeatWarrantyTwoYearsModulePreference: this.easiHeatWarrantyTwoYearsPrefFormControl,
            easiHeatWarrantyThreeYearsModulePreference: this.easiHeatWarrantyThreeYearsPrefFormControl,
            // Option Configuration
            easiHeatOptionsSelection: this.easiHeatOptionsFormControl,
        }, { updateOn: "change" });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        console.log("Initializing EasiHeat module prefs component");
        // First, get all the module preferences.
        //this.modulePreferencesForm.markAsPristine();
        // this.easiHeatCvSplitRange.markAsDirty();
        this.componentLoadPromises.push(this.userProfileService.getUserDetails().toPromise().then((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            this.user = user;
            //3 = sales admin
            //4 = super admin
            if (this.user.roleId == 3 || this.user.roleId == 4) {
            }
            else {
                this.easiHeatManufacturerPrefFormControl.disable();
                this.easiHeatManufacturerCurrencyModulePreference.disable();
            }
        })));
        //    this.easiHeatManufacturerPrefFormControl = new FormControl({ value: '', disabled: true });
        //    this.easiHeatManufacturerCurrencyModulePreference = new FormControl({ value: '', disabled: true });
        this.componentLoadPromises.push(this.modulePreferenceService.getOperatingCompanyModulePreferences(this.moduleId).toPromise().then((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            if (result && result.length > 0) {
                // And set their values accordingly.
                this.manufacturerId = +this.getModulePreferenceValue(result, "EHgen4_Manufacturer");
                this.easiHeatManufacturerPrefFormControl.setValue(this.manufacturerId);
                this.easiHeatManufacturerCurrencyId = +this.getModulePreferenceValue(result, "EHgen4_ManufacturerCurrency");
                this.easiHeatManufacturerCurrencyModulePreference.setValue(this.easiHeatManufacturerCurrencyId);
                this.easiHeatSellingCurrencyId = +this.getModulePreferenceValue(result, "EHgen4_SellingCurrency");
                this.easiHeatSellingCurrencyPrefFormControl.setValue(this.easiHeatSellingCurrencyId);
                // Calculate the currency conversion rate.
                this.onSellingCurrencyChange(this.easiHeatSellingCurrencyId);
                //this.easiHeatManufacturerCurrencyModulePreference.setValue(this.getModulePreferenceValue(result, "EHgen4_CurrencyConversion"));
                this.easiHeatHeatExchangerTS6.setValue(this.getModulePreferenceValue(result, "EHgen4_HETS6Discount")); //ts6
                this.easiHeatHeatExchangerT6.setValue(this.getModulePreferenceValue(result, "EHgen4_HEM6Discount")); //t6
                this.easiHeatHeatExchangerT8.setValue(this.getModulePreferenceValue(result, "EHgen4_HEM10Discount")); //t8
                this.easiHeatHeatExchangerT10.setValue(this.getModulePreferenceValue(result, "EHgen4_HET10Discount")); //t10 
                this.easiHeatPricingCurrency.setValue(this.getModulePreferenceValue(result, "EHgen4_HEPricingCurrency"));
                this.easiHeatOverrideMarkup.setValue(this.getModulePreferenceValue(result, "EHgen4_HEOverridenP251MarkupValue"));
                this.easiHeatSellingMarkup.setValue(this.getModulePreferenceValue(result, "EHgen4_SellingMarkup"));
                this.easiHeatLandedCostIncrease = this.getModulePreferenceValue(result, "EHgen4_LandCostIncrease");
                this.easiHeatLandedCostIncreaseModPref.setValue(this.easiHeatLandedCostIncrease);
                this.easiHeatDeliveryCostModPref.setValue(this.getModulePreferenceValue(result, "EHgen4_DeliveryCost"));
                this.easiHeatCommissionOnly.setValue(this.getModulePreferenceValue(result, "EHgen4_Commission"));
                //Below is a temporary fix as to ensure that a boolean is passed through for the checkboxes.
                //Fix is necessary as the data reads as a string and not a boolean. The data types needs changing/fixing in the database.
                //Table:  OperatingCompanyModulePreferences
                if (this.getModulePreferenceValue(result, "EHgen4_HEOverridenP251Markup") == "EHgen4_True" || this.getModulePreferenceValue(result, "EHgen4_HEOverridenP251Markup") == "EHgen4_true") {
                    this.overrideMarkupActive = true;
                }
                else {
                    this.overrideMarkupActive = false;
                }
                if (this.getModulePreferenceValue(result, "EHgen4_HEAllowHighDesignPressure") == "EHgen4_True" || this.getModulePreferenceValue(result, "EHgen4_HEAllowHighDesignPressure") == "true") {
                    this.allowHighDesignPressure = true;
                }
                else {
                    this.allowHighDesignPressure = false;
                }
                if (this.getModulePreferenceValue(result, "EHgen4_CVSplitRange") == "EHgen4_True" || this.getModulePreferenceValue(result, "EHgen4_CVSplitRange") == "true") {
                    this.cvSplitRange = true;
                }
                else {
                    this.cvSplitRange = false;
                }
                if (this.getModulePreferenceValue(result, "EHgen4_SellSteamControl") == "EHgen4_True" || this.getModulePreferenceValue(result, "EHgen4_SellSteamControl") == "EHgen4_true") {
                    this.SellSteamControl = true;
                }
                else {
                    this.SellSteamControl = false;
                }
                if (this.getModulePreferenceValue(result, "EHgen4_MotiveInletPressureAvailable") == "EHgen4_True" || this.getModulePreferenceValue(result, "EHgen4_MotiveInletPressureAvailable") == "true") {
                    this.MotiveInletPressureAvailable = true;
                }
                else {
                    this.MotiveInletPressureAvailable = false;
                }
                if (this.getModulePreferenceValue(result, "EHgen4_PrvAllowed") == "EHgen4_True" || this.getModulePreferenceValue(result, "EHgen4_PrvAllowed") == "EHgen4_true") {
                    this.PrvAllowed = true;
                }
                else {
                    this.PrvAllowed = false;
                }
                if (this.getModulePreferenceValue(result, "EHgen4_HideHEmodelFromSizing") == "EHgen4_True" || this.getModulePreferenceValue(result, "EHgen4_HideHEmodelFromSizing") == "true") {
                    this.HideHEmodelFromSizing = true;
                }
                else {
                    this.HideHEmodelFromSizing = false;
                }
                this.easiHeatOverrideMarkupActive.setValue(this.overrideMarkupActive);
                this.easiHeatAllowHighDesignPressure.setValue(this.allowHighDesignPressure);
                this.easiHeatCvSplitRange.setValue(this.cvSplitRange);
                this.easiHeatSteamSideControlOnHTG.setValue(this.SellSteamControl);
                this.easiHeatMotiveInletPressureAvailable.setValue(this.MotiveInletPressureAvailable);
                this.easiHeatPRVAvailableOnEHHCC.setValue(this.PrvAllowed);
                this.easiHeatHideHEModelFromSizing.setValue(this.HideHEmodelFromSizing);
                this.easiHeatWarrantyOneYearPrefFormControl.setValue(this.getModulePreferenceValue(result, "EHgen4_YearOne"));
                this.easiHeatWarrantyTwoYearsPrefFormControl.setValue(this.getModulePreferenceValue(result, "EHgen4_YearTwo"));
                this.easiHeatWarrantyThreeYearsPrefFormControl.setValue(this.getModulePreferenceValue(result, "EHgen4_YearThree"));
                // Get the currency data.
                this.adminService.getCurrencyData().subscribe((/**
                 * @param {?} data
                 * @return {?}
                 */
                data => {
                    this.currencyList = data;
                    //this.easiHeatManufacturerCurrencyId = data.find(c => c.id === this.easiHeatManufacturerCurrencyId)
                    // Selling currency found, so try to calculate the currency conversion rate.
                    this.onSellingCurrencyChange(this.easiHeatSellingCurrencyId);
                    this.augmentPriceDataProcessing = false; // loaded enable toggle prices button
                }));
            }
            // Get the currency data.
            this.adminService.getCurrencyData().subscribe((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                this.currencyList = data;
                //this.easiHeatManufacturerCurrencyId = data.find(c => c.id === this.easiHeatManufacturerCurrencyId)
                // Selling currency found, so try to calculate the currency conversion rate.
                this.onSellingCurrencyChange(this.easiHeatSellingCurrencyId);
                this.augmentPriceDataProcessing = false; // loaded enable toggle prices button
            }));
        })));
        // Get the list of manufacturers.
        this.componentLoadPromises.push(this.adminService.getManufacturerData(this.moduleGroupId).toPromise().then((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            // Update the subject with the data that's just been retrieved (see the constructor).  
            this.manufacturerList = result;
        })));
        // Now, set the "OpCo Selected Options" for the different EasiHeat options.
        this.setOpCoPreferences("EH_GEN4_GlobalVariance", this.EH_GEN4_GlobalVariance_Control);
        this.setOpCoPreferences("EH_DHW_SC_Actuator", this.EH_DHW_SC_Actuator_Control);
        this.setOpCoPreferences("EH_DHW_DC_Actuator", this.EH_DHW_DC_Actuator_Control);
        this.setOpCoPreferences("EH_HTG_CC_Actuator", this.EH_HTG_CC_Actuator_Control);
        this.setOpCoPreferences("EH_HTG_SC_Actuator", this.EH_HTG_SC_Actuator_Control);
        this.setOpCoPreferences("EH_HTG_DC_Actuator", this.EH_HTG_DC_Actuator_Control);
        this.setOpCoPreferences("EH_DHW_SC_Communications", this.EH_DHW_SC_Communications_Control);
        this.setOpCoPreferences("EH_DHW_DC_Communications", this.EH_DHW_DC_Communications_Control);
        this.setOpCoPreferences("EH_HTG_CC_Communications", this.EH_HTG_CC_Communications_Control);
        this.setOpCoPreferences("EH_HTG_SC_Communications", this.EH_HTG_SC_Communications_Control);
        this.setOpCoPreferences("EH_HTG_DC_Communications", this.EH_HTG_DC_Communications_Control);
        this.setOpCoPreferences("EH_DHW_SC_CondensateRemoval", this.EH_DHW_SC_CondensateRemoval_Control);
        this.setOpCoPreferences("EH_DHW_DC_CondensateRemoval", this.EH_DHW_DC_CondensateRemoval_Control);
        this.setOpCoPreferences("EH_HTG_CC_CondensateRemoval", this.EH_HTG_CC_CondensateRemoval_Control);
        this.setOpCoPreferences("EH_HTG_SC_CondensateRemoval", this.EH_HTG_SC_CondensateRemoval_Control);
        this.setOpCoPreferences("EH_HTG_DC_CondensateRemoval", this.EH_HTG_DC_CondensateRemoval_Control);
        this.setOpCoPreferences("EH_DHW_SC_ControlSystem", this.EH_DHW_SC_ControlSystem_Control);
        this.setOpCoPreferences("EH_DHW_DC_ControlSystem", this.EH_DHW_DC_ControlSystem_Control);
        this.setOpCoPreferences("EH_HTG_CC_ControlSystem", this.EH_HTG_CC_ControlSystem_Control);
        this.setOpCoPreferences("EH_HTG_SC_ControlSystem", this.EH_HTG_SC_ControlSystem_Control);
        this.setOpCoPreferences("EH_HTG_DC_ControlSystem", this.EH_HTG_DC_ControlSystem_Control);
        this.setOpCoPreferences("EH_DHW_SC_PanelLocation", this.EH_DHW_SC_PanelLocation_Control);
        this.setOpCoPreferences("EH_DHW_DC_PanelLocation", this.EH_DHW_DC_PanelLocation_Control);
        this.setOpCoPreferences("EH_HTG_CC_PanelLocation", this.EH_HTG_CC_PanelLocation_Control);
        this.setOpCoPreferences("EH_HTG_SC_PanelLocation", this.EH_HTG_SC_PanelLocation_Control);
        this.setOpCoPreferences("EH_HTG_DC_PanelLocation", this.EH_HTG_DC_PanelLocation_Control);
        this.setOpCoPreferences("EH_DHW_SC_DataCollection", this.EH_DHW_SC_DataCollection_Control);
        this.setOpCoPreferences("EH_DHW_DC_DataCollection", this.EH_DHW_DC_DataCollection_Control);
        this.setOpCoPreferences("EH_HTG_CC_DataCollection", this.EH_HTG_CC_DataCollection_Control);
        this.setOpCoPreferences("EH_HTG_SC_DataCollection", this.EH_HTG_SC_DataCollection_Control);
        this.setOpCoPreferences("EH_HTG_DC_DataCollection", this.EH_HTG_DC_DataCollection_Control);
        this.setOpCoPreferences("EH_DHW_SC_FrameType", this.EH_DHW_SC_FrameType_Control);
        this.setOpCoPreferences("EH_DHW_DC_FrameType", this.EH_DHW_DC_FrameType_Control);
        this.setOpCoPreferences("EH_HTG_CC_FrameType", this.EH_HTG_CC_FrameType_Control);
        this.setOpCoPreferences("EH_HTG_SC_FrameType", this.EH_HTG_SC_FrameType_Control);
        this.setOpCoPreferences("EH_HTG_DC_FrameType", this.EH_HTG_DC_FrameType_Control);
        this.setOpCoPreferences("EH_DHW_SC_PackageSupports", this.EH_DHW_SC_PackageSupports_Control);
        this.setOpCoPreferences("EH_DHW_DC_PackageSupports", this.EH_DHW_DC_PackageSupports_Control);
        this.setOpCoPreferences("EH_HTG_CC_PackageSupports", this.EH_HTG_CC_PackageSupports_Control);
        this.setOpCoPreferences("EH_HTG_SC_PackageSupports", this.EH_HTG_SC_PackageSupports_Control);
        this.setOpCoPreferences("EH_HTG_DC_PackageSupports", this.EH_HTG_DC_PackageSupports_Control);
        this.setOpCoPreferences("EH_DHW_SC_HighLimit", this.EH_DHW_SC_HighLimit_Control);
        this.setOpCoPreferences("EH_DHW_DC_HighLimit", this.EH_DHW_DC_HighLimit_Control);
        this.setOpCoPreferences("EH_HTG_CC_HighLimit", this.EH_HTG_CC_HighLimit_Control);
        this.setOpCoPreferences("EH_HTG_SC_HighLimit", this.EH_HTG_SC_HighLimit_Control);
        this.setOpCoPreferences("EH_HTG_DC_HighLimit", this.EH_HTG_DC_HighLimit_Control);
        this.setOpCoPreferences("EH_DHW_SC_ManualIsolation", this.EH_DHW_SC_ManualIsolation_Control);
        this.setOpCoPreferences("EH_DHW_DC_ManualIsolation", this.EH_DHW_DC_ManualIsolation_Control);
        this.setOpCoPreferences("EH_HTG_CC_ManualIsolation", this.EH_HTG_CC_ManualIsolation_Control);
        this.setOpCoPreferences("EH_HTG_SC_ManualIsolation", this.EH_HTG_SC_ManualIsolation_Control);
        this.setOpCoPreferences("EH_HTG_DC_ManualIsolation", this.EH_HTG_DC_ManualIsolation_Control);
        this.setOpCoPreferences("EH_DHW_SC_GasketMaterial", this.EH_DHW_SC_GasketMaterial_Control);
        this.setOpCoPreferences("EH_DHW_DC_GasketMaterial", this.EH_DHW_DC_GasketMaterial_Control);
        this.setOpCoPreferences("EH_HTG_CC_GasketMaterial", this.EH_HTG_SC_GasketMaterial_Control);
        this.setOpCoPreferences("EH_HTG_SC_GasketMaterial", this.EH_HTG_SC_GasketMaterial_Control);
        this.setOpCoPreferences("EH_HTG_DC_GasketMaterial", this.EH_HTG_SC_GasketMaterial_Control);
        this.setOpCoPreferences("EH_DHW_SC_Extras", this.EH_DHW_SC_Extras_Control);
        this.setOpCoPreferences("EH_DHW_DC_Extras", this.EH_DHW_DC_Extras_Control);
        this.setOpCoPreferences("EH_HTG_CC_Extras", this.EH_HTG_CC_Extras_Control);
        this.setOpCoPreferences("EH_HTG_SC_Extras", this.EH_HTG_SC_Extras_Control);
        this.setOpCoPreferences("EH_HTG_DC_Extras", this.EH_HTG_DC_Extras_Control);
        this.setOpCoPreferences("EH_DHW_SC_ServiceOffering", this.EH_DHW_SC_ServiceOffering_Control);
        this.setOpCoPreferences("EH_DHW_DC_ServiceOffering", this.EH_DHW_DC_ServiceOffering_Control);
        this.setOpCoPreferences("EH_HTG_CC_ServiceOffering", this.EH_HTG_CC_ServiceOffering_Control);
        this.setOpCoPreferences("EH_HTG_SC_ServiceOffering", this.EH_HTG_SC_ServiceOffering_Control);
        this.setOpCoPreferences("EH_HTG_DC_ServiceOffering", this.EH_HTG_DC_ServiceOffering_Control);
        this.setOpCoPreferences("EH_DHW_SC_SystemRecirculation", this.EH_DHW_SC_SystemRecirculation_Control);
        this.setOpCoPreferences("EH_DHW_DC_SystemRecirculation", this.EH_DHW_DC_SystemRecirculation_Control);
        this.setOpCoPreferences("EH_HTG_CC_SystemRecirculation", this.EH_HTG_CC_SystemRecirculation_Control);
        this.setOpCoPreferences("EH_HTG_SC_SystemRecirculation", this.EH_HTG_SC_SystemRecirculation_Control);
        this.setOpCoPreferences("EH_HTG_DC_SystemRecirculation", this.EH_HTG_DC_SystemRecirculation_Control);
        this.setOpCoPreferences("EH_DHW_SC_ControlValveFeedback", this.EH_DHW_SC_ControlValveFeedback_Control);
        this.setOpCoPreferences("EH_DHW_DC_ControlValveFeedback", this.EH_DHW_DC_ControlValveFeedback_Control);
        this.setOpCoPreferences("EH_HTG_CC_ControlValveFeedback", this.EH_HTG_CC_ControlValveFeedback_Control);
        this.setOpCoPreferences("EH_HTG_SC_ControlValveFeedback", this.EH_HTG_SC_ControlValveFeedback_Control);
        this.setOpCoPreferences("EH_HTG_DC_ControlValveFeedback", this.EH_HTG_DC_ControlValveFeedback_Control);
        this.setOpCoPreferences("EH_DHW_SC_UPS", this.EH_DHW_SC_UPS_Control);
        this.setOpCoPreferences("EH_DHW_DC_UPS", this.EH_DHW_DC_UPS_Control);
        this.setOpCoPreferences("EH_HTG_CC_UPS", this.EH_HTG_CC_UPS_Control);
        this.setOpCoPreferences("EH_HTG_SC_UPS", this.EH_HTG_SC_UPS_Control);
        this.setOpCoPreferences("EH_HTG_DC_UPS", this.EH_HTG_DC_UPS_Control);
        this.setOpCoPreferences("EH_DHW_SC_Insulation", this.EH_DHW_SC_Insulation_Control);
        this.setOpCoPreferences("EH_DHW_DC_Insulation", this.EH_DHW_DC_Insulation_Control);
        this.setOpCoPreferences("EH_HTG_CC_Insulation", this.EH_HTG_CC_Insulation_Control);
        this.setOpCoPreferences("EH_HTG_SC_Insulation", this.EH_HTG_SC_Insulation_Control);
        this.setOpCoPreferences("EH_HTG_DC_Insulation", this.EH_HTG_DC_Insulation_Control);
        this.easiHeatOptionsSelectedItem = "Global Variance";
        this.theFormGroup = this.modulePreferencesForm; // to drive GenericChangesGuard
        // Info ToolTip message translations
        this.serviceOffereingMessage = this.translatePipe.transform('SERVICE_OFFERING_MESSAGE', false);
        this.deliveryCostMessage = this.translatePipe.transform('DELIVERY_COST_MESSAGE', false);
        Promise.all(this.componentLoadPromises).then((/**
         * @return {?}
         */
        () => {
            console.log("Initialization promises complete for Easiheat Component");
            this.componentInitialised = true;
        }));
    }
    /**
     * @return {?}
     */
    togglePrices() {
        this.showPrices = !this.showPrices;
        this.augmentPriceDataProcessing = true;
        this.augmentPricesToOptionsLists(this.showPrices);
    }
    /**
     * @return {?}
     */
    onChangeData() {
        //debugger;
        //this.modulePreferencesForm.markAsPristine(); 
    }
    /**
     * @return {?}
     */
    toggleSave() {
        if (this.easiHeatHeatExchangerTS6.valid == false || this.easiHeatHeatExchangerT6.valid == false || this.easiHeatHeatExchangerT8.valid == false ||
            this.easiHeatHeatExchangerT10.valid == false || this.easiHeatOverrideMarkup.valid == false || this.easiHeatSellingMarkup.valid == false ||
            this.easiHeatLandedCostIncreaseModPref.valid == false || this.easiHeatDeliveryCostModPref.valid == false || this.easiHeatCommissionOnly.valid == false ||
            this.easiHeatWarrantyOneYearPrefFormControl.valid == false || this.easiHeatWarrantyTwoYearsPrefFormControl.valid == false || this.easiHeatWarrantyThreeYearsPrefFormControl.valid == false) {
            this.modulePreferencesForm.markAsPristine();
        }
    }
    /**
     * @param {?=} showPrices
     * @return {?}
     */
    augmentPricesToOptionsLists(showPrices = true) {
        this.easiHeatPricing = new EasiHeatPricing$1();
        this.easiHeatPricing.modelId = -1; // All BOM items    
        this.easiHeatPricing.pricingOptions = [];
        this.easiHeatPricing.basePriceOption = -1;
        this.easiHeatPricing.localRecommendedSalesPriceOption = -1;
        this.easiHeatPricing.landedCostIncreaseFactor = -1;
        this.easiHeatSellingCurrencySymbol = !!this.easiHeatSellingCurrencySymbol ? this.easiHeatSellingCurrencySymbol : "?";
        this.easiHeatPricing.manufacturerId = +(!!this.manufacturerId ? this.manufacturerId : -1);
        this.easiHeatManufacturerCurrency = this.currencyList.find((/**
         * @param {?} c
         * @return {?}
         */
        c => c.id === this.easiHeatManufacturerCurrencyId));
        this.easiHeatManufacturerCurrencySymbol = !!this.easiHeatManufacturerCurrency ? this.easiHeatManufacturerCurrency.symbol : "?";
        if (showPrices) {
            // Get RSP Display price data for List item Augmentation
            this.easiHeatService.calculateBOMPrice(this.easiHeatPricing).subscribe((/**
             * @param {?} response
             * @return {?}
             */
            (response) => {
                if (response) {
                    this.easiHeatBOMOutputData = response;
                    /** @type {?} */
                    let manPrice = "";
                    /** @type {?} */
                    let localPrices = "";
                    /** @type {?} */
                    let isOverride = "";
                    this.easiHeatBOMOutputData.bomItems.forEach((/**
                     * @param {?} t
                     * @return {?}
                     */
                    t => {
                        if (showPrices && t.itemType == "Base") {
                            // Price the models
                            if (t.sRecommendedSalesPrice != 0.0 && t.sRecommendedSalesPrice != parseFloat(t.sDisplayedRSP)) {
                                isOverride = 'o';
                            }
                            manPrice = ' SSP=' + this.easiHeatManufacturerCurrencySymbol + ' ' + this.localizeValue(t.ssp, 0);
                            localPrices = ' RSP' + isOverride + '=' + this.easiHeatManufacturerCurrencySymbol + ' ' + this.localizeValue(t.displayedRSP, 0);
                            if (t.ssp != t.sSSP) { // if not the same currency data
                                manPrice = manPrice + ' (' + this.easiHeatSellingCurrencySymbol + ' ' + this.localizeValue(t.sSSP, 0) + ')';
                                localPrices = localPrices + ' (' + this.easiHeatSellingCurrencySymbol + ' ' + this.localizeValue(t.sDisplayedRSP, 0) + ')';
                            }
                        }
                        // Set option item enabled?
                        /** @type {?} */
                        var newEnumerationModulePreferences = this.GetNewEnumerationModulePreferences();
                        this.easiHeatBOMOutputData.bomItems.forEach((/**
                         * @param {?} p
                         * @return {?}
                         */
                        p => {
                            /** @type {?} */
                            var elist = newEnumerationModulePreferences.find((/**
                             * @param {?} e
                             * @return {?}
                             */
                            e => e.enumerationName == p.parent));
                            //if (!!elist) { can't support on EH gen3 data
                            //  var elistItem = elist.enumerationDefinitions.find(l => l.value == p.item);
                            //}
                            p.isEnabled = true;
                            //p.isEnabled = !!elistItem ? true : false;
                            //// Set enabled if base CSG model item or add on (Commisoining, Voltage, Warranty etc.)
                            //if (!p.parentMasterTextKey
                            //  || (!!p.parentMasterTextKey && p.parentMasterTextKey.indexOf('xxxlegacy_') === 0) // no list override for it
                            //  || (!!p.parentMasterTextKey && p.parentMasterTextKey.indexOf('xxxlegacy_') === 0)) {
                            //  p.isEnabled = true;
                            //}
                        }));
                        // Append prices to list translation on UI
                        this.translationService.displayGroup.enumerations.forEach((/**
                         * @param {?} e
                         * @return {?}
                         */
                        e => {
                            e.enumerationDefinitions.forEach((/**
                             * @param {?} d
                             * @return {?}
                             */
                            d => {
                                if ((e.enumerationName == t.parent && d.value == t.item)
                                    || (t.parentMasterTextKey.indexOf(e.enumerationName) > -1 && d.value == t.item.split('_')[1])) { // && d.translationText.indexOf(' ' + this.sellingCurrencySymbol + ' ') < 0) {
                                    if (showPrices) {
                                        if (t.sRecommendedSalesPrice != 0.0 && (t.sRecommendedSalesPrice != parseFloat(t.sDisplayedRSP))) {
                                            isOverride = 'o';
                                        }
                                        /** @type {?} */
                                        var nomCode = '';
                                        if (!!t.item.split('_')[1]) {
                                            nomCode = '(' + t.item.split('_')[1] + ') ';
                                        }
                                        manPrice = ' SSP=' + this.easiHeatManufacturerCurrencySymbol + ' ' + this.localizeValue(t.ssp, 0);
                                        localPrices = ' RSP' + isOverride + '=' + this.easiHeatManufacturerCurrencySymbol + ' ' + this.localizeValue(t.displayedRSP, 0);
                                        if (t.ssp != t.sSSP) { // if not the same currency data
                                            manPrice = manPrice + ' (' + this.easiHeatSellingCurrencySymbol + ' ' + this.localizeValue(t.sSSP, 0) + ')';
                                            localPrices = localPrices + ' (' + this.easiHeatSellingCurrencySymbol + ' ' + this.localizeValue(t.sDisplayedRSP, 0) + ')';
                                        }
                                        t.itemMasterTextKey = d.masterTextKey;
                                        t.parentMasterTextKey = e.enumerationName.split('_')[0].replace('Nom', '');
                                        // Set the UI text
                                        //d.extraPostText = manPrice + localPrices; RSPs for 15 models on 2 list sets not representative!
                                        //if (!d.extraPreText) {                       
                                        //    d.extraPreText = nomCode;
                                        //}
                                    }
                                    else {
                                        //d.extraPostText = ""; // clear augmented data
                                        //d.extraPreText = "";
                                    }
                                } // end of e.enumerationDefinitions.forEach...
                                if (!d.extraPreText && d.defaultText !== d.value) {
                                    d.extraPreText = '(' + d.value + ') ';
                                }
                            }));
                        }));
                    })); // of append prices
                    this.augmentPriceDataProcessing = false; // finished, enable button again
                    this.scrollToElement(this.collapsePriceDataTop, "start");
                }
            })); // end of service response
        } // end of if showPrices
        else {
            // remove price augmentation
            //this.CSG_HS_020_Price = "";
            //this.CSG_HS_055_Price = "";
            //this.CSG_HS_125_Price = "";
            //this.CSG_HS_180_Price = "";
            this.translationService.displayGroup.enumerations.forEach((/**
             * @param {?} e
             * @return {?}
             */
            e => {
                e.enumerationDefinitions.forEach((/**
                 * @param {?} d
                 * @return {?}
                 */
                d => d.extraPostText = "")); // clear augmented data                              
            }));
            this.augmentPriceDataProcessing = false; // finished, enable button again
        }
    }
    /**
     * Method to localize values.
     * @param {?} value
     * @param {?} decimalPoints
     * @return {?}
     */
    localizeValue(value, decimalPoints) {
        return this.localeService.formatDecimal(value.toFixed(decimalPoints));
    }
    /*
      * Method to get and set the OpCo selected options.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} formControlName
     * @return {?}
     */
    setOpCoPreferences(enumerationPickerName, formControlName) {
        // Get the collection list first.
        /** @type {?} */
        let easiHeatOpCoPref = this.getEnumerationPickerCollection(enumerationPickerName, true);
        // Check if any OpCo Overrides Data found? If NOT then get the base list populated.
        if (!easiHeatOpCoPref) {
            easiHeatOpCoPref = this.cloneDeep(this.getEnumerationPickerCollection(enumerationPickerName, false));
        }
        // Check and set the list.
        if (!!easiHeatOpCoPref && easiHeatOpCoPref.length > 0) {
            formControlName.setValue(easiHeatOpCoPref);
        }
    }
    /*
      * Method to get the Enumeration list by Name.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} opCoOverride
     * @return {?}
     */
    getEnumerationPickerCollection(enumerationPickerName, opCoOverride) {
        /** @type {?} */
        const enumeration = this.translationService.displayGroup.enumerations.filter((/**
         * @param {?} us
         * @return {?}
         */
        us => us.enumerationName === enumerationPickerName && us.opCoOverride === opCoOverride));
        if (!!enumeration && enumeration.length > 0) {
            /** @type {?} */
            let definitions = enumeration[0].enumerationDefinitions.sort((/**
             * @param {?} currentenumeration
             * @param {?} nextenumeration
             * @return {?}
             */
            (currentenumeration, nextenumeration) => {
                if (currentenumeration.sequence > nextenumeration.sequence) {
                    return 1;
                }
                if (currentenumeration.sequence < nextenumeration.sequence) {
                    return -1;
                }
                return 0;
            }));
            //this.onChange(definitions);
            definitions.forEach((/**
             * @param {?} i
             * @return {?}
             */
            i => i.isDeleted = false));
            return definitions;
        }
    }
    /**
     * Submits the form for saving to the server.
     * @param {?} $event
     * @return {?}
     */
    submitForm($event) {
        $event.preventDefault();
        // Mark the form as submitted.
        this.formSubmitted = true;
        // Regular Module Preferences.
        /** @type {?} */
        const newModulePreferences = [];
        /** @type {?} */
        var sellingCurrency = this.getSelectedPreferences("EHgen4_SellingCurrency", "easiHeatSellingCurrencyModulePreference");
        /** @type {?} */
        var manufacturer = this.getSelectedPreferences("EHgen4_Manufacturer", "easiHeatManufacturerModulePreference");
        /** @type {?} */
        var manufacturerCurrency = this.getSelectedPreferences("EHgen4_ManufacturerCurrency", "easiHeatManufacturerCurrencyModulePreference");
        //Heat exchanger options
        /** @type {?} */
        var HETS6Discount = this.getSelectedPreferences("EHgen4_HETS6Discount", "easiHeatHeatExchangerTS6");
        //TS6
        /** @type {?} */
        var HEM6Discount = this.getSelectedPreferences("EHgen4_HEM6Discount", "easiHeatHeatExchangerT6");
        //T6
        /** @type {?} */
        var HEM8Discount = this.getSelectedPreferences("EHgen4_HEM10Discount", "easiHeatHeatExchangerT8");
        //T8
        /** @type {?} */
        var HEM10Discount = this.getSelectedPreferences("EHgen4_HET10Discount", "easiHeatHeatExchangerT10");
        //T10  
        /** @type {?} */
        var HEPricingCurrency = this.getSelectedPreferences("EHgen4_HEPricingCurrency", "easiHeatPricingCurrency");
        /** @type {?} */
        var HEOverridenP251MarkupValue = this.getSelectedPreferences("EHgen4_HEOverridenP251MarkupValue", "easiHeatOverrideMarkup");
        /** @type {?} */
        var HEOverridenP251Markup = this.getSelectedPreferences("EHgen4_HEOverridenP251Markup", "easiHeatOverrideMarkupActive");
        /** @type {?} */
        var HEAllowHighDesignPressure = this.getSelectedPreferences("EHgen4_HEAllowHighDesignPressure", "easiHeatAllowHighDesignPressure");
        //Pricing Options
        /** @type {?} */
        var SellingMarkup = this.getSelectedPreferences("EHgen4_SellingMarkup", "easiHeatSellingMarkup");
        /** @type {?} */
        var LandedCostIncrease = this.getSelectedPreferences("EHgen4_LandCostIncrease", "easiHeatLandedCostIncreaseModPref") //easiHeatLandedCostIncreaseModPref
        ;
        //easiHeatLandedCostIncreaseModPref
        /** @type {?} */
        var DeliveryCost = this.getSelectedPreferences("EHgen4_DeliveryCost", "easiHeatDeliveryCostModPref");
        /** @type {?} */
        var Commission = this.getSelectedPreferences("EHgen4_Commission", "easiHeatCommissionOnly");
        /** @type {?} */
        var CVSplitRange = this.getSelectedPreferences("EHgen4_CVSplitRange", "easiHeatCvSplitRange");
        /** @type {?} */
        var SellSteamControl = this.getSelectedPreferences("EHgen4_SellSteamControl", "easiHeatSteamSideControlOnHTG");
        /** @type {?} */
        var MotiveInletPressureAvailable = this.getSelectedPreferences("EHgen4_MotiveInletPressureAvailable", "easiHeatMotiveInletPressureAvailable");
        /** @type {?} */
        var YearOne = this.getSelectedPreferences("EHgen4_YearOne", "easiHeatWarrantyOneYearModulePreference");
        /** @type {?} */
        var YearTwo = this.getSelectedPreferences("EHgen4_YearTwo", "easiHeatWarrantyTwoYearsModulePreference");
        /** @type {?} */
        var YearThree = this.getSelectedPreferences("EHgen4_YearThree", "easiHeatWarrantyThreeYearsModulePreference");
        /** @type {?} */
        var PrvAllowed = this.getSelectedPreferences("EHgen4_PrvAllowed", "easiHeatPRVAvailableOnEHHCC");
        /** @type {?} */
        var HideHEmodelFromSizing = this.getSelectedPreferences("EHgen4_HideHEmodelFromSizing", "easiHeatHideHEModelFromSizing");
        newModulePreferences.push(sellingCurrency);
        newModulePreferences.push(manufacturer);
        newModulePreferences.push(manufacturerCurrency);
        newModulePreferences.push(HETS6Discount);
        newModulePreferences.push(HEM6Discount);
        newModulePreferences.push(HEM8Discount);
        newModulePreferences.push(HEM10Discount);
        newModulePreferences.push(HEPricingCurrency);
        newModulePreferences.push(HEOverridenP251MarkupValue);
        newModulePreferences.push(HEOverridenP251Markup);
        newModulePreferences.push(HEAllowHighDesignPressure);
        newModulePreferences.push(SellingMarkup);
        newModulePreferences.push(LandedCostIncrease);
        newModulePreferences.push(DeliveryCost);
        newModulePreferences.push(Commission);
        newModulePreferences.push(CVSplitRange);
        newModulePreferences.push(SellSteamControl);
        newModulePreferences.push(MotiveInletPressureAvailable);
        newModulePreferences.push(YearOne);
        newModulePreferences.push(YearTwo);
        newModulePreferences.push(YearThree);
        newModulePreferences.push(PrvAllowed);
        newModulePreferences.push(HideHEmodelFromSizing);
        // Save the changed preferences as an array of preferences
        this.adminService.manageModulePreferences(newModulePreferences).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            // The form can be submitted again.
            this.formSubmitted = false;
            // Set the operation based on the response.
            this.isSuccess = response;
            this.alertVisible = true;
        }));
        /** @type {?} */
        var newEnumerationModulePreferences = this.GetNewEnumerationModulePreferences();
        // Save the changed preferences as an array of preferences
        this.adminService.manageEnumerationModulePreferences(newEnumerationModulePreferences).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            // The form can be submitted again.
            this.formSubmitted = false;
            // Set the operation based on the response.
            this.isSuccess = response;
            this.alertVisible = true;
            this.modulePreferencesForm.markAsPristine(); // to drive GenericChangesGuard
        }));
    }
    /**
     * @return {?}
     */
    GetNewEnumerationModulePreferences() {
        // Enumeration Module Preferences.
        /** @type {?} */
        const newEnumerationModulePreferences = [];
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_GEN4_GlobalVariance", "EH_GEN4_GlobalVariance_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_Actuator", "EH_DHW_SC_Actuator_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_Actuator", "EH_DHW_DC_Actuator_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_Actuator", "EH_HTG_CC_Actuator_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_Actuator", "EH_HTG_SC_Actuator_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_Actuator", "EH_HTG_DC_Actuator_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_Communications", "EH_DHW_SC_Communications_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_Communications", "EH_DHW_DC_Communications_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_Communications", "EH_HTG_CC_Communications_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_Communications", "EH_HTG_SC_Communications_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_Communications", "EH_HTG_DC_Communications_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_CondensateRemoval", "EH_DHW_SC_CondensateRemoval_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_CondensateRemoval", "EH_DHW_DC_CondensateRemoval_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_CondensateRemoval", "EH_HTG_CC_CondensateRemoval_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_CondensateRemoval", "EH_HTG_SC_CondensateRemoval_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_CondensateRemoval", "EH_HTG_DC_CondensateRemoval_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_ControlSystem", "EH_DHW_SC_ControlSystem_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_ControlSystem", "EH_DHW_DC_ControlSystem_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_ControlSystem", "EH_HTG_CC_ControlSystem_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_ControlSystem", "EH_HTG_SC_ControlSystem_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_ControlSystem", "EH_HTG_DC_ControlSystem_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_PanelLocation", "EH_DHW_SC_PanelLocation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_PanelLocation", "EH_DHW_DC_PanelLocation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_PanelLocation", "EH_HTG_CC_PanelLocation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_PanelLocation", "EH_HTG_SC_PanelLocation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_PanelLocation", "EH_HTG_DC_PanelLocation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_DataCollection", "EH_DHW_SC_DataCollection_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_DataCollection", "EH_DHW_DC_DataCollection_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_DataCollection", "EH_HTG_CC_DataCollection_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_DataCollection", "EH_HTG_SC_DataCollection_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_DataCollection", "EH_HTG_DC_DataCollection_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_FrameType", "EH_DHW_SC_FrameType_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_FrameType", "EH_DHW_DC_FrameType_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_FrameType", "EH_HTG_CC_FrameType_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_FrameType", "EH_HTG_SC_FrameType_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_FrameType", "EH_HTG_DC_FrameType_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_PackageSupports", "EH_DHW_SC_PackageSupports_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_PackageSupports", "EH_DHW_DC_PackageSupports_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_PackageSupports", "EH_HTG_CC_PackageSupports_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_PackageSupports", "EH_HTG_SC_PackageSupports_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_PackageSupports", "EH_HTG_DC_PackageSupports_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_HighLimit", "EH_DHW_SC_HighLimit_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_HighLimit", "EH_DHW_DC_HighLimit_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_HighLimit", "EH_HTG_CC_HighLimit_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_HighLimit", "EH_HTG_SC_HighLimit_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_HighLimit", "EH_HTG_DC_HighLimit_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_ManualIsolation", "EH_DHW_SC_ManualIsolation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_ManualIsolation", "EH_DHW_DC_ManualIsolation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_ManualIsolation", "EH_HTG_CC_ManualIsolation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_ManualIsolation", "EH_HTG_SC_ManualIsolation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_ManualIsolation", "EH_HTG_DC_ManualIsolation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_GasketMaterial", "EH_DHW_SC_GasketMaterial_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_GasketMaterial", "EH_DHW_SC_GasketMaterial_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_GasketMaterial", "EH_HTG_SC_GasketMaterial_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_GasketMaterial", "EH_HTG_SC_GasketMaterial_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_GasketMaterial", "EH_HTG_SC_GasketMaterial_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_Extras", "EH_DHW_SC_Extras_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_Extras", "EH_DHW_DC_Extras_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_Extras", "EH_HTG_CC_Extras_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_Extras", "EH_HTG_SC_Extras_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_Extras", "EH_HTG_DC_Extras_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_ServiceOffering", "EH_DHW_SC_ServiceOffering_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_ServiceOffering", "EH_DHW_DC_ServiceOffering_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_ServiceOffering", "EH_HTG_CC_ServiceOffering_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_ServiceOffering", "EH_HTG_SC_ServiceOffering_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_ServiceOffering", "EH_HTG_DC_ServiceOffering_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_SystemRecirculation", "EH_DHW_SC_SystemRecirculation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_SystemRecirculation", "EH_DHW_DC_SystemRecirculation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_SystemRecirculation", "EH_HTG_CC_SystemRecirculation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_SystemRecirculation", "EH_HTG_SC_SystemRecirculation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_SystemRecirculation", "EH_HTG_DC_SystemRecirculation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_ControlValveFeedback", "EH_DHW_SC_ControlValveFeedback_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_ControlValveFeedback", "EH_DHW_DC_ControlValveFeedback_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_ControlValveFeedback", "EH_HTG_CC_ControlValveFeedback_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_ControlValveFeedback", "EH_HTG_SC_ControlValveFeedback_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_ControlValveFeedback", "EH_HTG_DC_ControlValveFeedback_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_UPS", "EH_DHW_SC_UPS_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_UPS", "EH_DHW_DC_UPS_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_UPS", "EH_HTG_CC_UPS_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_UPS", "EH_HTG_SC_UPS_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_UPS", "EH_HTG_DC_UPS_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_SC_Insulation", "EH_DHW_SC_Insulation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_DHW_DC_Insulation", "EH_DHW_DC_Insulation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_CC_Insulation", "EH_HTG_CC_Insulation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_SC_Insulation", "EH_HTG_SC_Insulation_Control"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("EH_HTG_DC_Insulation", "EH_HTG_DC_Insulation_Control"));
        return newEnumerationModulePreferences;
    }
    /*
      * Method to get opco selected enumeration module prefernce details for each options.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} prefsFormKeyName
     * @return {?}
     */
    getSelectedEnumerationPreferences(enumerationPickerName, prefsFormKeyName) {
        /** @type {?} */
        var modPrefs = new Enumeration;
        modPrefs.enumerationName = enumerationPickerName;
        modPrefs.opCoOverride = true;
        modPrefs.enumerationDefinitions = this.modulePreferencesForm.controls[prefsFormKeyName].value;
        //modPrefs.enumerationDefinitions.find(e => e.value == prefsFormKeyName);
        //this.modulePreferencesForm.controls[prefsFormKeyName].value;
        return modPrefs;
    }
    /*
      * Method to get opco selected module prefernce details.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} prefsFormKeyName
     * @return {?}
     */
    getSelectedPreferences(enumerationPickerName, prefsFormKeyName) {
        /** @type {?} */
        var modPrefs = new ModulePreferenceDetails;
        modPrefs.name = enumerationPickerName;
        modPrefs.value = "" + this.modulePreferencesForm.controls[prefsFormKeyName].value;
        modPrefs.moduleId = +this.moduleId;
        modPrefs.isDeleted = false;
        modPrefs.OperatingCompanyId = 42;
        return modPrefs;
    }
    /**
     * @return {?}
     */
    closeAlert() {
        // Reset the flag
        this.alertVisible = false;
    }
    /**
     * @return {?}
     */
    onChange() {
        this.modulePreferencesForm.markAsDirty();
        // this.modulePreferencesForm.disabled == false;
    }
    /**
     * @return {?}
     */
    onChangeAnyOption() {
        // Any enumeration-picker (on-change) set the form data to dirty.
        this.modulePreferencesForm.markAsDirty();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onEasiHeatOptionsChange(event) {
        this.easiHeatOptionsSelectedItem = event.selectedValue;
        this.easiHeatOptionsFormControl.markAsPristine(); // Options list selector is not a data change item, so ignore changes.
    }
    /*
      * Method to calculate the currency conversion rate.
      */
    /**
     * @param {?} selectedValue
     * @return {?}
     */
    onSellingCurrencyChange(selectedValue) {
        this.easiHeatManufacturerCurrencyId = +this.easiHeatManufacturerCurrencyModulePreference.value;
        if (selectedValue > 0 && this.easiHeatManufacturerCurrencyId > 0 && this.currencyList.length > 0) {
            /** @type {?} */
            let sellingCurrency = this.currencyList.find((/**
             * @param {?} c
             * @return {?}
             */
            c => c.id === +selectedValue));
            /** @type {?} */
            let manufacturerCurrency = this.currencyList.find((/**
             * @param {?} c
             * @return {?}
             */
            c => c.id === this.easiHeatManufacturerCurrencyId));
            this.easiHeatSellingCurrencySymbol = sellingCurrency.symbol;
            this.easiHeatCurrencyConversion = +((manufacturerCurrency.rateToGbp * (1 / sellingCurrency.rateToGbp)).toFixed(5));
        }
    }
    /*
      * Method to retrieve the module pref value from the list.
      */
    /**
     * @param {?} modulePrefList
     * @param {?} modulePrefName
     * @return {?}
     */
    getModulePreferenceValue(modulePrefList, modulePrefName) {
        /** @type {?} */
        let modPref = modulePrefList.filter((/**
         * @param {?} r
         * @return {?}
         */
        r => r.name === modulePrefName));
        if (modPref && modPref.length > 0) {
            return modPref[0].value;
        }
    }
    /**
     * @param {?} row
     * @return {?}
     */
    getRowClass(row) {
        if (row.isEnabled) {
            return 'row-color-enabled';
        }
        return 'row-color-disabled';
    }
    /**
     * @return {?}
     */
    setOverrideMarkup() {
        this.overrideMarkupActive = !this.overrideMarkupActive;
        this.easiHeatOverrideMarkupActive.setValue(this.overrideMarkupActive);
        if (this.overrideMarkupActive == false) {
            this.easiHeatOverrideMarkup.setValue("0");
        }
        this.toggleSave();
    }
}
EasiHeatGen4PreferencesComponent.decorators = [
    { type: Component, args: [{
                selector: 'easiHeatgen4-module-preferences',
                template: "<!--Easiheat module preferences component works!-->\r\n<div *ngIf=\"!componentInitialised\">\r\n  <div class=\"ball-clip-rotate\">\r\n    <div></div>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"componentInitialised\">\r\n  <form [formGroup]=\"modulePreferencesForm\" class=\"form-horizontal\" role=\"form\" (click)=\"toggleSave();\" (submit)=\"submitForm($event)\" novalidate>\r\n    <!--[disabled]=\"!modulePreferencesForm.dirty || !modulePreferencesForm.valid || modulePreferencesForm.status !== 'VALID' || formSubmitted\"-->\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <button [disabled]=\"!modulePreferencesForm.dirty || formSubmitted\" type=\"submit\" class=\"btn btn-dynamic btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i></button>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <br>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Success confirmation message -->\r\n    <alert-block *ngIf=\"!!alertVisible && !!isSuccess\" type=\"success\" [auto-close]=\"true\" [message]=\"'MODULE_PREFERENCES_SAVED_SUCCESSFULLY_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n    <!-- Failure confirmation message-->\r\n    <alert-block *ngIf=\"!!alertVisible && !isSuccess\" type=\"danger\" [message]=\"'MODULE_PREFERENCES_FAILED_TO_SAVE_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"currencyOptionsHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseCurrencyOptions\" aria-expanded=\"true\" aria-controls=\"collapseCurrencyOptions\">\r\n            {{\"CURRENCY_OPTIONS\" | translate}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapseCurrencyOptions\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"currencyOptionsHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-10px\">\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"row\" style=\"padding-bottom:15px\">\r\n\r\n              <!--Manufacturer-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"MANUFACTURER\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"easiHeatManufacturerModulePreference\">\r\n                  <option *ngFor=\"let manufacturer of manufacturerList\" [value]=\"manufacturer.id\">{{manufacturer.name}}</option>\r\n                </select>\r\n              </div>\r\n\r\n              <!--Selling currency-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"SELLING_CURRENCY\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"easiHeatSellingCurrencyModulePreference\" (ngModelChange)=\"onSellingCurrencyChange($event)\">\r\n                  <option *ngFor=\"let currency of currencyList\" [value]=\"currency.id\">{{currency.currencyCode}} - {{currency.symbol}}</option>\r\n                </select>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n              <!--Manufacturer currency-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"MANUFACTURER_CURRENCY\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"easiHeatManufacturerCurrencyModulePreference\">\r\n                  <option *ngFor=\"let currency of currencyList\" [value]=\"currency.id\">{{currency.currencyCode}} - {{currency.symbol}}</option>\r\n                </select>\r\n              </div>\r\n\r\n              <!--Currency conversion-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"CURRENCY_CONVERSION\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <label class=\"control-label\">{{easiHeatCurrencyConversion}}</label>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Heat Exchanger Options -->\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"pricingOptionsHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseHeatExchangerOptions\" aria-expanded=\"true\" aria-controls=\"collapsePricingOptions\">\r\n            {{\"HEAT_EXCHANGER_OPTIONS\" | translate}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapseHeatExchangerOptions\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"heatExchangerOptionsHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-30px\">\r\n          <div class=\"form-group\">\r\n            <!--Column 1-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-8 text-right\">\r\n                  <label class=\"control-label\">{{\"DISCOUNT_RATE\" | translate}}</label>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <!--TS6-->\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"TS6\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatHeatExchangerTS6\" value=\"easiHeatTS6\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatHeatExchangerTS6'].hasError('required') && (modulePreferencesForm.controls['easiHeatHeatExchangerTS6'].dirty || modulePreferencesForm.controls['easiHeatHeatExchangerTS6'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!--T6-->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"T6\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatHeatExchangerT6\" value=\"easiHeatT6\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatHeatExchangerT6'].hasError('required') && (modulePreferencesForm.controls['easiHeatHeatExchangerT6'].dirty || modulePreferencesForm.controls['easiHeatHeatExchangerT6'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!--T8-->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"T8\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatHeatExchangerT8\" value=\"easiHeatT8\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatHeatExchangerT8'].hasError('required') && (modulePreferencesForm.controls['easiHeatHeatExchangerT8'].dirty || modulePreferencesForm.controls['easiHeatHeatExchangerT8'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!--T10-->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"T10\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatHeatExchangerT10\" value=\"easiHeatT10\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatHeatExchangerT10'].hasError('required') && (modulePreferencesForm.controls['easiHeatHeatExchangerT10'].dirty || modulePreferencesForm.controls['easiHeatHeatExchangerT10'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Column 2-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"row\" style=\"padding-bottom: 20px;\">\r\n                <!-- Pricing Currency -->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"PRICING_CURRENCY\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <select class=\"form-control\" formControlName=\"easiHeatPricingCurrency\" (ngModelChange)=\"onSellingCurrencyChange($event)\">\r\n                      <option *ngFor=\"let currency of currencyList\" [value]=\"currency.id\">{{currency.currencyCode}} - {{currency.symbol}}</option>\r\n                    </select>\r\n                  </div>\r\n                </div>\r\n\r\n                <!-- Override Markup Active available -->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"OVERRIDE_GROUP_MARKUP\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <input autocomplete=\"off\"\r\n                             class=\"control-check\"\r\n                             type=\"checkbox\"\r\n                             style=\"width:15px; height:15px;\"\r\n                             formControlName=\"easiHeatOverrideMarkupActive\"\r\n                             value=\"easiHeatOverrideMarkupActive\"\r\n                             (change)=\"setOverrideMarkup()\" />\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n                <!--Override Markup-->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"OVERRIDE_MARKUP\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <input *ngIf=\"overrideMarkupActive\" autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatOverrideMarkup\" value=\"easiHeatOverrideMarkup\" twoDigitDecimalNumber />\r\n                      <input *ngIf=\"!overrideMarkupActive\" disabled=\"disabled\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" />\r\n                      <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatOverrideMarkup'].hasError('required') && (modulePreferencesForm.controls['easiHeatOverrideMarkup'].dirty || modulePreferencesForm.controls['easiHeatOverrideMarkup'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n\r\n                <!-- Allow High Design Pressure available -->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"ALLOW_HIGH_DESIGN_PRESSURE\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <input autocomplete=\"off\"\r\n                             class=\"control-check\"\r\n                             type=\"checkbox\"\r\n                             style=\"width:25px; height:25px;\"\r\n                             formControlName=\"easiHeatAllowHighDesignPressure\"\r\n                             value=\"easiHeatAllowHighDesignPressure\"\r\n                             (change)=\"toggleSave()\" />\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n\r\n\r\n    <!--Pricing Options-->\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"pricingOptionsHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapsePricingOptions\" aria-expanded=\"true\" aria-controls=\"collapsePricingOptions\">\r\n            {{\"PRICING_OPTIONS\" | translate}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapsePricingOptions\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"pricingOptionsHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-30px\">\r\n          <div class=\"form-group\">\r\n            <!--Column 1-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <!--Selling Markup-->\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"SELLING_MARKUP\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" (input)=\"onChange();\" formControlName=\"easiHeatSellingMarkup\" value=\"easiHeatSellingMarkup\" twoDigitDecimalNumber />\r\n\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatSellingMarkup'].hasError('required') && (modulePreferencesForm.controls['easiHeatSellingMarkup'].dirty || modulePreferencesForm.controls['easiHeatSellingMarkup'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <!--Landed Cost-->\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"LANDED_COST_INCREASE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatLandedCostIncreaseModPref\" value=\"easiHeatLandedCostIncreaseModPref\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatLandedCostIncreaseModPref'].hasError('required') && (modulePreferencesForm.controls['easiHeatLandedCostIncreaseModPref'].dirty || modulePreferencesForm.controls['easiHeatLandedCostIncreaseModPref'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!--Delivery Cost-->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"DELIVERY_COST\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-addon\">{{easiHeatSellingCurrencySymbol}}</span>\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatDeliveryCostModPref\" value=\"easiHeatDeliveryCost\" (input)=\"onChange();\" twoDigitDecimalNumber />\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatDeliveryCostModPref'].hasError('required') && (modulePreferencesForm.controls['easiHeatDeliveryCostModPref'].dirty || modulePreferencesForm.controls['easiHeatDeliveryCostModPref'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!-- Commission only price -->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"COMMISSION_ONLY_PRICE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-addon\">{{easiHeatSellingCurrencySymbol}}</span>\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatCommissionOnly\" value=\"easiHeatCommissionOnly\" twoDigitDecimalNumber />\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatCommissionOnly'].hasError('required') && (modulePreferencesForm.controls['easiHeatCommissionOnly'].dirty || modulePreferencesForm.controls['easiHeatCommissionOnly'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!-- CV Split Range available -->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"CV_SPLIT_RANGE_AVAILABLE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\"\r\n                           class=\"control-check\"\r\n                           type=\"checkbox\"\r\n                           style=\"width:25px; height:25px;\"\r\n                           formControlName=\"easiHeatCvSplitRange\"\r\n                           value=\"easiHeatCvSplitRange\"\r\n                           (change)=\"toggleSave()\" />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <!-- Steam side control on HTG -->\r\n              <!--<div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"STEAM_SIDE_CONTROL_ON_HTG\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"checkbox\" style=\"width:15px; height:15px;\" formControlName=\"easiHeatSteamSideControlOnHTG\" value=\"easiHeatSteamSideControlOnHTG\" (change)=\"toggleSave()\" />\r\n                  </div>\r\n                </div>\r\n              </div>-->\r\n              <!-- Motive Inlet Pressure Available -->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"MOTIVE_INLET_PRESSURE_AVAILABLE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"checkbox\" style=\"width:25px; height:25px;\" formControlName=\"easiHeatMotiveInletPressureAvailable\" value=\"easiHeatMotiveInletPressureAvailable\" (change)=\"toggleSave()\" />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Column 2-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"panel-body\" style=\"margin-bottom:-30px\">\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-8 text-right\">\r\n                    <h4>{{\"EXTENDED_WARRANTY_PRICE\" | translate}}</h4>\r\n                  </div>\r\n                  <!--<div class=\"col-xs-3 cross-validation-error-class\" *ngIf=\"serviceOffereingMessage\">\r\n                    <div><i class=\"fa fa-info-circle cross-validation-error-class\" [tooltip]=\"serviceOffereingMessage\" placement=\"top,right\"></i></div>\r\n                  </div>-->\r\n                </div>\r\n                <!--</fieldset>-->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--One Year-->\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"ONE_YEAR\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{easiHeatSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatWarrantyOneYearModulePreference\" value=\"easiHeatWarrantyOneYearModulePreference\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatWarrantyOneYearModulePreference'].hasError('required') && (modulePreferencesForm.controls['easiHeatWarrantyOneYearModulePreference'].dirty || modulePreferencesForm.controls['easiHeatWarrantyOneYearModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--Two Years-->\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"TWO_YEARS\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{easiHeatSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatWarrantyTwoYearsModulePreference\" value=\"easiHeatWarrantyTwoYearsModulePreference\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatWarrantyTwoYearsModulePreference'].hasError('required') && (modulePreferencesForm.controls['easiHeatWarrantyTwoYearsModulePreference'].dirty || modulePreferencesForm.controls['easiHeatWarrantyTwoYearsModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--Three Years-->\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"THREE_YEARS\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{easiHeatSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatWarrantyThreeYearsModulePreference\" value=\"easiHeatWarrantyTwoYearsModulePreference\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatWarrantyThreeYearsModulePreference'].hasError('required') && (modulePreferencesForm.controls['easiHeatWarrantyThreeYearsModulePreference'].dirty || modulePreferencesForm.controls['easiHeatWarrantyThreeYearsModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n\r\n                <!-- PRV available on EHHCC -->\r\n                <!--<div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"PRV_AVAILABLE_ON_EHHCC\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"checkbox\" style=\"width:15px; height:15px;\" formControlName=\"easiHeatPRVAvailableOnEHHCC\" value=\"easiHeatPRVAvailableOnEHHCC\" (change)=\"toggleSave()\" />\r\n                    </div>\r\n                  </div>\r\n                </div>-->\r\n\r\n                <!-- Hide HE model from sizing -->\r\n                <!--<div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"HIDE_HE_MODEL_FROM_SIZING\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"checkbox\" style=\"width:25px; height:25px;\" formControlName=\"easiHeatHideHEModelFromSizing\" value=\"easiHeatHideHEModelFromSizing\" (change)=\"toggleSave()\" />\r\n                    </div>\r\n                  </div>\r\n                </div>--> \r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--Configurartion Options-->\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"optionConfigurartionHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseOptionConfigurartion\" aria-expanded=\"true\" aria-controls=\"collapseOptionConfigurartion\">\r\n            {{\"OPTION_CONFIGURATION\" | translate}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapseOptionConfigurartion\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"optionConfigurartionHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-20px\">\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-2 text-right\">\r\n                <label class=\"control-label\">{{\"PLEASE_SELECT\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                <enumeration formControlName=\"easiHeatOptionsSelection\" enumeration-name=\"EasiHeat_Gen4_Options\" (on-change)=\"onEasiHeatOptionsChange($event)\"></enumeration>\r\n              </div>\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                <!--<button [disabled]=\"augmentPriceDataProcessing\" class=\"btn btn-dynamic btn-primary pull-right\" type='button' (click)=\"togglePrices();\" [title]=\"'TOGGLE_PRICES' | translate\"><i class=\"fa fa-exchange\">  {{'TOGGLE_PRICES' | translate}}</i></button>-->\r\n              </div>\r\n            </div>\r\n            <hr>\r\n\r\n            <!--Global Variance-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Global Variance'\">\r\n              <div class=\"row\">\r\n                 <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH GEN4 GV\">GLOBAL VARIANCE</h4>\r\n                  <enumeration-picker formControlName=\"EH_GEN4_GlobalVariance_Control\" enumeration-picker-name=\"EH_GEN4_GlobalVariance\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <!--<div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_GlobalVariance_Control\" enumeration-picker-name=\"EH_DHW_SC_GlobalVariance\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>-->\r\n                <!--<div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_GlobalVariance_Control\" enumeration-picker-name=\"EH_DHW_DC_GlobalVariance\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>-->\r\n              </div>\r\n              <!--<hr>--> <!-- line -->\r\n              <!--<div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_GlobalVariance_Control\" enumeration-picker-name=\"EH_HTG_CC_GlobalVariance\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_GlobalVariance_Control\" enumeration-picker-name=\"EH_HTG_SC_GlobalVariance\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_GlobalVariance_Control\" enumeration-picker-name=\"EH_HTG_DC_GlobalVariance\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>-->\r\n            </div>\r\n\r\n\r\n            <!--Actuator-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Actuator'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_Actuator_Control\" enumeration-picker-name=\"EH_DHW_SC_Actuator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_Actuator_Control\" enumeration-picker-name=\"EH_DHW_DC_Actuator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr> <!-- line -->\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_Actuator_Control\" enumeration-picker-name=\"EH_HTG_CC_Actuator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_Actuator_Control\" enumeration-picker-name=\"EH_HTG_SC_Actuator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_Actuator_Control\" enumeration-picker-name=\"EH_HTG_DC_Actuator\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Communications-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Communications'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_Communications_Control\" enumeration-picker-name=\"EH_DHW_SC_Communications\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_Communications_Control\" enumeration-picker-name=\"EH_DHW_DC_Communications\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr> <!-- line -->\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_Communications_Control\" enumeration-picker-name=\"EH_HTG_CC_Communications\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_Communications_Control\" enumeration-picker-name=\"EH_HTG_SC_Communications\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_Communications_Control\" enumeration-picker-name=\"EH_HTG_DC_Communications\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--CondensateRemoval-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Condensate Removal'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_CondensateRemoval_Control\" enumeration-picker-name=\"EH_DHW_SC_CondensateRemoval\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_CondensateRemoval_Control\" enumeration-picker-name=\"EH_DHW_DC_CondensateRemoval\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr> <!-- line -->\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_CondensateRemoval_Control\" enumeration-picker-name=\"EH_HTG_CC_CondensateRemoval\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_CondensateRemoval_Control\" enumeration-picker-name=\"EH_HTG_SC_CondensateRemoval\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_CondensateRemoval_Control\" enumeration-picker-name=\"EH_HTG_DC_CondensateRemoval\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--ControlSystem-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Control System'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_ControlSystem_Control\" enumeration-picker-name=\"EH_DHW_SC_ControlSystem\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_ControlSystem_Control\" enumeration-picker-name=\"EH_DHW_DC_ControlSystem\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr> <!-- line -->\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_ControlSystem_Control\" enumeration-picker-name=\"EH_HTG_CC_ControlSystem\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_ControlSystem_Control\" enumeration-picker-name=\"EH_HTG_SC_ControlSystem\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_ControlSystem_Control\" enumeration-picker-name=\"EH_HTG_DC_ControlSystem\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n\r\n            <!--Control Panel Location-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Control Panel Location'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_PanelLocation_Control\" enumeration-picker-name=\"EH_DHW_SC_PanelLocation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_PanelLocation_Control\" enumeration-picker-name=\"EH_DHW_DC_PanelLocation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr> <!-- line -->\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_PanelLocation_Control\" enumeration-picker-name=\"EH_HTG_CC_PanelLocation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_PanelLocation_Control\" enumeration-picker-name=\"EH_HTG_SC_PanelLocation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_PanelLocation_Control\" enumeration-picker-name=\"EH_HTG_DC_PanelLocation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--DataCollection-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Data Collection'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_DataCollection_Control\" enumeration-picker-name=\"EH_DHW_SC_DataCollection\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_DataCollection_Control\" enumeration-picker-name=\"EH_DHW_DC_DataCollection\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr> <!-- line -->\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_DataCollection_Control\" enumeration-picker-name=\"EH_HTG_CC_DataCollection\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_DataCollection_Control\" enumeration-picker-name=\"EH_HTG_SC_DataCollection\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_DataCollection_Control\" enumeration-picker-name=\"EH_HTG_DC_DataCollection\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--FrameType-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Frame Type'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_FrameType_Control\" enumeration-picker-name=\"EH_DHW_SC_FrameType\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_FrameType_Control\" enumeration-picker-name=\"EH_DHW_DC_FrameType\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr> <!-- line -->\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_FrameType_Control\" enumeration-picker-name=\"EH_HTG_CC_FrameType\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_FrameType_Control\" enumeration-picker-name=\"EH_HTG_SC_FrameType\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_FrameType_Control\" enumeration-picker-name=\"EH_HTG_DC_FrameType\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--PackageSupports-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Package Supports'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_PackageSupports_Control\" enumeration-picker-name=\"EH_DHW_SC_PackageSupports\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_PackageSupports_Control\" enumeration-picker-name=\"EH_DHW_DC_PackageSupports\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr> <!-- line -->\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_PackageSupports_Control\" enumeration-picker-name=\"EH_HTG_CC_PackageSupports\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_PackageSupports_Control\" enumeration-picker-name=\"EH_HTG_SC_PackageSupports\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_PackageSupports_Control\" enumeration-picker-name=\"EH_HTG_DC_PackageSupports\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--HighLimit-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'High Limit'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_HighLimit_Control\" enumeration-picker-name=\"EH_DHW_SC_HighLimit\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_HighLimit_Control\" enumeration-picker-name=\"EH_DHW_DC_HighLimit\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr> <!-- line -->\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_HighLimit_Control\" enumeration-picker-name=\"EH_HTG_CC_HighLimit\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_HighLimit_Control\" enumeration-picker-name=\"EH_HTG_SC_HighLimit\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_HighLimit_Control\" enumeration-picker-name=\"EH_HTG_DC_HighLimit\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--ManualIsolation-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Manual Isolation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_ManualIsolation_Control\" enumeration-picker-name=\"EH_DHW_SC_ManualIsolation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_ManualIsolation_Control\" enumeration-picker-name=\"EH_DHW_DC_ManualIsolation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr> <!-- line -->\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_ManualIsolation_Control\" enumeration-picker-name=\"EH_HTG_CC_ManualIsolation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_ManualIsolation_Control\" enumeration-picker-name=\"EH_HTG_SC_ManualIsolation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_ManualIsolation_Control\" enumeration-picker-name=\"EH_HTG_DC_ManualIsolation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--GasketMaterial-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Gasket Material'\">\r\n              <div class=\"row\">\r\n                <!--Domestic Hot Water-->\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4>EH DHW</h4>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_GasketMaterial_Control\" enumeration-picker-name=\"EH_DHW_SC_GasketMaterial\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <!--Heating-->\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4>EH HTG</h4>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_GasketMaterial_Control\" enumeration-picker-name=\"EH_HTG_SC_GasketMaterial\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <!--<div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_GasketMaterial_Control\" enumeration-picker-name=\"EH_DHW_SC_GasketMaterial\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_GasketMaterial_Control\" enumeration-picker-name=\"EH_DHW_DC_GasketMaterial\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr>--> <!-- line -->\r\n              <!--<div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_GasketMaterial_Control\" enumeration-picker-name=\"EH_HTG_CC_GasketMaterial\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_GasketMaterial_Control\" enumeration-picker-name=\"EH_HTG_SC_GasketMaterial\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_GasketMaterial_Control\" enumeration-picker-name=\"EH_HTG_DC_GasketMaterial\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>-->\r\n            </div>\r\n\r\n            <!--Extras-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Extras'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_Extras_Control\" enumeration-picker-name=\"EH_DHW_SC_Extras\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_Extras_Control\" enumeration-picker-name=\"EH_DHW_DC_Extras\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr> <!-- line -->\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_Extras_Control\" enumeration-picker-name=\"EH_HTG_CC_Extras\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_Extras_Control\" enumeration-picker-name=\"EH_HTG_SC_Extras\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_Extras_Control\" enumeration-picker-name=\"EH_HTG_DC_Extras\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--ServiceOffering-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Service Offering'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_ServiceOffering_Control\" enumeration-picker-name=\"EH_DHW_SC_ServiceOffering\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_ServiceOffering_Control\" enumeration-picker-name=\"EH_DHW_DC_ServiceOffering\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr> <!-- line -->\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_ServiceOffering_Control\" enumeration-picker-name=\"EH_HTG_CC_ServiceOffering\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_ServiceOffering_Control\" enumeration-picker-name=\"EH_HTG_SC_ServiceOffering\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_ServiceOffering_Control\" enumeration-picker-name=\"EH_HTG_DC_ServiceOffering\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n\r\n            <!--SystemRecirculation-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'System Recirculation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_SystemRecirculation_Control\" enumeration-picker-name=\"EH_DHW_SC_SystemRecirculation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_SystemRecirculation_Control\" enumeration-picker-name=\"EH_DHW_DC_SystemRecirculation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr> <!-- line -->\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_SystemRecirculation_Control\" enumeration-picker-name=\"EH_HTG_CC_SystemRecirculation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_SystemRecirculation_Control\" enumeration-picker-name=\"EH_HTG_SC_SystemRecirculation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_SystemRecirculation_Control\" enumeration-picker-name=\"EH_HTG_DC_SystemRecirculation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Control Valve Feedback-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Control Valve Feedback'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_ControlValveFeedback_Control\" enumeration-picker-name=\"EH_DHW_SC_ControlValveFeedback\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_ControlValveFeedback_Control\" enumeration-picker-name=\"EH_DHW_DC_ControlValveFeedback\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr> <!-- line -->\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_ControlValveFeedback_Control\" enumeration-picker-name=\"EH_HTG_CC_ControlValveFeedback\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_ControlValveFeedback_Control\" enumeration-picker-name=\"EH_HTG_SC_ControlValveFeedback\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_ControlValveFeedback_Control\" enumeration-picker-name=\"EH_HTG_DC_ControlValveFeedback\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--UPS-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'UPS'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_UPS_Control\" enumeration-picker-name=\"EH_DHW_SC_UPS\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_UPS_Control\" enumeration-picker-name=\"EH_DHW_DC_UPS\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr> <!-- line -->\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_UPS_Control\" enumeration-picker-name=\"EH_HTG_CC_UPS\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_UPS_Control\" enumeration-picker-name=\"EH_HTG_SC_UPS\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_UPS_Control\" enumeration-picker-name=\"EH_HTG_DC_UPS\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Insulation-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Insulation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW SC {{EH_DHW_SC_Price}}\">EH DHW SC</h4>\r\n                  <label>{{EH_DHW_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_SC_Insulation_Control\" enumeration-picker-name=\"EH_DHW_SC_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH DHW DC {{EH_DHW_DC_Price}}\">EH DHW DC</h4>\r\n                  <label>{{EH_DHW_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"DOMESTIC_HOT_WATER_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_DHW_DC_Insulation_Control\" enumeration-picker-name=\"EH_DHW_DC_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n              <hr> <!-- line -->\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG CC {{EH_HTG_CC_Price}}\">EH HTG CC</h4>\r\n                  <label>{{EH_HTG_CC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_CONDENSATE_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_CC_Insulation_Control\" enumeration-picker-name=\"EH_HTG_CC_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG SC {{EH_HTG_SC_Price}}\">EH HTG SC</h4>\r\n                  <label>{{EH_HTG_SC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_STEAM_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_SC_Insulation_Control\" enumeration-picker-name=\"EH_HTG_SC_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"EH HTG DC {{EH_HTG_DC_Price}}\">EH HTG DC</h4>\r\n                  <label>{{EH_HTG_DC_Price}}</label>\r\n                  <label style=\"flex-wrap:nowrap\">{{\"HEATING_DUAL_CONTROL\" | translate}}</label>\r\n                  <enumeration-picker formControlName=\"EH_HTG_DC_Insulation_Control\" enumeration-picker-name=\"EH_HTG_DC_Insulation\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n\r\n    <a #collapsePriceDataTop href=\"#collapsePriceDataTop\"> </a>\r\n\r\n\r\n    <!--Price Data Grid -->\r\n    <div *ngIf=\"!!easiHeatBOMOutputData.bomItems && easiHeatBOMOutputData.bomItems.length > 0 && showPrices\" class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"priceDataHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapsePriceData\" aria-expanded=\"true\" aria-controls=\"collapsePriceData\">\r\n            {{\"Price Data\"}} - {{'CLEAN_STEAM_GENERATOR' | translate:true}}{{operatingCompany}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <!-- Price Data Grid  -->\r\n      <div class=\"panel-body\">\r\n        <div class=\"col-xs-12\">\r\n\r\n          <ngx-datatable #easiHeatBOMOutputDataTable\r\n                         class=\"bootstrap\"\r\n                         [headerHeight]=\"40\"\r\n                         [limit]=\"50\"\r\n                         [columnMode]=\"'force'\"\r\n                         [footerHeight]=\"40\"\r\n                         [rowHeight]=\"'auto'\"\r\n                         [rows]=\"easiHeatBOMOutputData.bomItems\">\r\n\r\n\r\n\r\n            <!--[rowClass]=\"getRowClass\">-->\r\n            <!--  [selected]=\"selectedOutputData\"\r\n                 [selectionType]=\"'single'\"\r\n                 (select)=\"onSelect($event)\"\r\n            -->\r\n            <!-- Row Detail Template -->\r\n            <!--<ngx-datatable-row-detail [rowHeight]=\"getHeight\" #myDetailRow>\r\n              <ng-template let-row=\"row\" let-expanded=\"expanded\" ngx-datatable-row-detail-template>\r\n                <div *ngFor=\"let m of row.modelSizingMessages\">\r\n                  <div class=\"row col-xs-12\">\r\n                    <div class=\"col-xs-1 text-center\">\r\n                      <i [class]=\"getSeverityIcon(m.severity)\"></i>\r\n                    </div>\r\n                    <div class=\"col-xs-10\">\r\n                      <span>{{m.messageKey | translate}}</span>\r\n                      <span *ngIf=\"m.value !== 0 && m.unitKey\"> ({{m.value}} {{m.unitKey | translate:false}})</span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </ng-template>\r\n            </ngx-datatable-row-detail>-->\r\n            <!-- Column Template -->\r\n            <!--<ngx-datatable-column>\r\n              <ng-template let-row=\"row\" let-expanded=\"expanded\" ngx-datatable-cell-template>\r\n                <i [class]=\"getRowSeverityIcon(row)\"></i>\r\n              </ng-template>\r\n            </ngx-datatable-column>-->\r\n            <!--Columns-->\r\n            <ngx-datatable-column [name]=\"'Number'\" prop=\"rowOrder\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Type'\" prop=\"itemType\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'ModelId'\" prop=\"modelId\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Option Group'\" prop=\"parentMasterTextKey\" [width]=\"200\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <!--<span *ngIf=\"!!value && value.indexOf('easiHeat_')!==0\">{{value | translate}}</span>\r\n                <span *ngIf=\"!!value && value.indexOf('easiHeat_')==0\">{{value.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>-->\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Option'\" prop=\"itemMasterTextKey\" [width]=\"200\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span [style.background]=\"!row.isEnabled ? 'Plum' : ' '\" *ngIf=\"!!value && value.indexOf('EH')!==0 && value.indexOf('Easiheat_')!==0 && value.indexOf('Nom')!==0\">{{value | translate}}</span>\r\n                <span [style.background]=\"!row.isEnabled ? 'Plum' : ' '\" *ngIf=\"!!value && value.indexOf('EH')==0\">{{value.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'SSP'\" prop=\"ssp\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol==easiHeatSellingCurrencySymbol\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol!==easiHeatSellingCurrencySymbol || row.modelId==0\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{easiHeatSellingCurrencySymbol}} {{localizeValue(row.sSSP,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Updated (yyyy-mm-dd)'\" prop=\"priceDataUTCDate\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"!!value\">{{value.split('T')[0]}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <!--<ngx-datatable-column [name]=\"'x'\" prop=\"ssPtoRSPfactor\" [width]=\"40\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"value!==0\">x {{value}} =</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>-->\r\n\r\n            <ngx-datatable-column [name]=\"'RSP'\" prop=\"recommendedSalesPrice\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <!--<span *ngIf=\"easiHeatManufacturerCurrencySymbol==easiHeatSellingCurrencySymbol\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol!==easiHeatSellingCurrencySymbol || row.modelId==0\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{easiHeatSellingCurrencySymbol}} {{localizeValue(row.sRecommendedSalesPrice,0)}})</span>-->\r\n                Unsupported\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <!--<ngx-datatable-column [name]=\"'RSP override'\" prop=\"recommendedSalesPriceOverride\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol==easiHeatSellingCurrencySymbol\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol!==easiHeatSellingCurrencySymbol || row.modelId==0\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{easiHeatSellingCurrencySymbol}} {{localizeValue(row.sRecommendedSalesPriceOverride,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>-->\r\n            <!--<ngx-datatable-column [name]=\"'Display Price'\" prop=\"displayedRSP\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol==easiHeatSellingCurrencySymbol\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol!==easiHeatSellingCurrencySymbol || row.modelId==0\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{easiHeatSellingCurrencySymbol}} {{localizeValue(row.sDisplayedRSP,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>-->\r\n\r\n            <ngx-datatable-column [name]=\"'Model'\" prop=\"parent\" [width]=\"30\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <!--<span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('easiHeat_')!==0\">{{value}}</span>\r\n                <span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('easiHeat_')==0\">{{value}} {{row.parentMasterTextKey.split('_')[1]}} {{row.parentMasterTextKey.split('_')[2]}}</span>-->\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Nomenclature'\" prop=\"item\" [width]=\"50\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"!!value.split('_')[1]\">{{value.split('_')[1]}}</span>\r\n                <!--<span *ngIf=\"!value.split('_')[1]\">{{value}}</span>-->\r\n                <span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('easiHeat_')==0\">{{row.parentMasterTextKey.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <!--[style.background]=\"row.isEnabled ? 'White' : 'SlateGray'\"-->\r\n            <!--<ngx-datatable-column [name]=\"'Enabled'\" prop=\"isEnabled\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"value\">+</span>\r\n                <span *ngIf=\"!value\">-</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>-->\r\n\r\n          </ngx-datatable>\r\n\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n  </form>\r\n</div>\r\n",
                providers: [EasiHeatGen4Service],
                styles: [".cross-validation-error-class{font-size:25px;color:#708090}"]
            }] }
];
/** @nocollapse */
EasiHeatGen4PreferencesComponent.ctorParameters = () => [
    { type: RoutesService },
    { type: AdminService },
    { type: TranslationService },
    { type: FormBuilder },
    { type: TranslatePipe },
    { type: ModulePreferenceService },
    { type: EasiHeatGen4Service },
    { type: LocaleService$1 },
    { type: UserProfileService },
    { type: User }
];
EasiHeatGen4PreferencesComponent.propDecorators = {
    easiHeatBOMOutputDataTable: [{ type: ViewChild, args: ["easiHeatBOMOutputDataTable", { static: false },] }],
    collapsePriceDataTop: [{ type: ViewChild, args: ['collapsePriceDataTop', { static: false },] }]
};
if (false) {
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.moduleId;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.moduleGroupId;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.cloneDeep;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.moduleName;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatBOMOutputDataTable;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.collapsePriceDataTop;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.componentInitialised;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.componentLoadPromises;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.theFormGroup;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.hasUnsavedDataChanges;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.isSuccess;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.alertVisible;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.formSubmitted;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatOptionsSelectedItem;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.manufacturerList;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.currencyList;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatManufacturerCurrencyId;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatManufacturerCurrency;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatManufacturerCurrencySymbol;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatSellingCurrencyId;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatSellingCurrencySymbol;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatCurrencyConversion;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatLandedCostIncrease;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatDeliveryCost;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatCommissionOnlyPrice;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatWarrantyOneYear;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatWarrantyTwoYears;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatWarrantyThreeYears;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatHeatExchangerTS6;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatHeatExchangerT6;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatHeatExchangerT8;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatHeatExchangerT10;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatPricingCurrency;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatOverrideMarkup;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatOverrideMarkupActive;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatAllowHighDesignPressure;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatSellingMarkup;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatLandedCostIncreaseModPref;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatDeliveryCostModPref;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatCommissionOnly;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatCvSplitRange;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatSteamSideControlOnHTG;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatMotiveInletPressureAvailable;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatPRVAvailableOnEHHCC;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatHideHEModelFromSizing;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_Price;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_Price;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_Price;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_Price;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_Price;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_GEN4_GlobalVariance_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_Actuator_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_Actuator_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_Actuator_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_Actuator_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_Actuator_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_Communications_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_Communications_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_Communications_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_Communications_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_Communications_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_CondensateRemoval_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_CondensateRemoval_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_CondensateRemoval_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_CondensateRemoval_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_CondensateRemoval_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_ControlSystem_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_ControlSystem_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_ControlSystem_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_ControlSystem_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_ControlSystem_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_PanelLocation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_PanelLocation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_PanelLocation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_PanelLocation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_PanelLocation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_DataCollection_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_DataCollection_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_DataCollection_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_DataCollection_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_DataCollection_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_FrameType_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_FrameType_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_FrameType_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_FrameType_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_FrameType_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_PackageSupports_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_PackageSupports_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_PackageSupports_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_PackageSupports_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_PackageSupports_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_HighLimit_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_HighLimit_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_HighLimit_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_HighLimit_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_HighLimit_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_ManualIsolation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_ManualIsolation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_ManualIsolation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_ManualIsolation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_ManualIsolation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_GasketMaterial_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_GasketMaterial_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_GasketMaterial_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_GasketMaterial_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_GasketMaterial_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_Extras_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_Extras_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_Extras_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_Extras_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_Extras_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_ServiceOffering_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_ServiceOffering_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_ServiceOffering_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_ServiceOffering_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_ServiceOffering_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_SystemRecirculation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_SystemRecirculation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_SystemRecirculation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_SystemRecirculation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_SystemRecirculation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_ControlValveFeedback_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_ControlValveFeedback_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_ControlValveFeedback_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_ControlValveFeedback_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_ControlValveFeedback_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_UPS_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_UPS_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_UPS_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_UPS_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_UPS_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_SC_Insulation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_DHW_DC_Insulation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_CC_Insulation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_SC_Insulation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.EH_HTG_DC_Insulation_Control;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatDHWAvailable;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatDHWOn;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatDHWOff;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatHTGAvailable;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatHTGOn;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatHTGOff;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.modulePreferencesForm;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatManufacturerPrefFormControl;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatManufacturerCurrencyModulePreference;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatSellingCurrencyPrefFormControl;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatLandedCostIncreasePrefFormControl;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatDeliveryCostPrefFormControl;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatCommissionOnlyPricePrefFormControl;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatWarrantyOneYearPrefFormControl;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatWarrantyTwoYearsPrefFormControl;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatWarrantyThreeYearsPrefFormControl;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatOptionsFormControl;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.serviceOffereingMessage;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.deliveryCostMessage;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatPricing;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatBOMOutputData;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatBOMOutputDataRows;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.manufacturerId;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.DHW_OPTIONS;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.HTG_CC_AND_SC_OPTIONS;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.DHW_AND_HTG_SC_OPTIONS;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.HTG_CC_OPTIONS;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.DHW;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.HTG;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.showPrices;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.augmentPriceDataProcessing;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.overrideMarkupActive;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.cvSplitRange;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.allowHighDesignPressure;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.SellSteamControl;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.MotiveInletPressureAvailable;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.YearOne;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.YearTwo;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.YearThree;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.PrvAllowed;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.HideHEmodelFromSizing;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.operatingCompany;
    /** @type {?} */
    EasiHeatGen4PreferencesComponent.prototype.scrollToElement;
    /**
     * @type {?}
     * @private
     */
    EasiHeatGen4PreferencesComponent.prototype.routesService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatGen4PreferencesComponent.prototype.adminService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatGen4PreferencesComponent.prototype.translationService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatGen4PreferencesComponent.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    EasiHeatGen4PreferencesComponent.prototype.translatePipe;
    /**
     * @type {?}
     * @private
     */
    EasiHeatGen4PreferencesComponent.prototype.modulePreferenceService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatGen4PreferencesComponent.prototype.easiHeatService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatGen4PreferencesComponent.prototype.localeService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatGen4PreferencesComponent.prototype.userProfileService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatGen4PreferencesComponent.prototype.user;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/seamGenerationAssessment/modulePreference/steamGenerationAssessment.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function SgaSettingsForm() { }
if (false) {
    /** @type {?} */
    SgaSettingsForm.prototype.SteamGenerationFuelType;
    /** @type {?} */
    SgaSettingsForm.prototype.SteamGenerationFuelCost;
    /** @type {?} */
    SgaSettingsForm.prototype.SteamGenerationFuelUnit;
    /** @type {?} */
    SgaSettingsForm.prototype.SteamGenerationWaterCost;
    /** @type {?} */
    SgaSettingsForm.prototype.SteamGenerationWaterCostUnit;
    /** @type {?} */
    SgaSettingsForm.prototype.SteamGenerationEffluentCost;
    /** @type {?} */
    SgaSettingsForm.prototype.SteamGenerationEffluentCostUnit;
    /** @type {?} */
    SgaSettingsForm.prototype.SteamGenerationWaterTreatmentCost;
    /** @type {?} */
    SgaSettingsForm.prototype.SteamGenerationWaterTreatmentCostUnit;
    /** @type {?} */
    SgaSettingsForm.prototype.SteamGenerationCO2Cost;
    /** @type {?} */
    SgaSettingsForm.prototype.SteamGenerationCO2CostUnit;
    /** @type {?} */
    SgaSettingsForm.prototype.FeedwaterInFeedtankTDS;
    /** @type {?} */
    SgaSettingsForm.prototype.AverageBoilerTDS;
    /** @type {?} */
    SgaSettingsForm.prototype.MaxAllowableBoilerTDS;
    /** @type {?} */
    SgaSettingsForm.prototype.MakeupWaterTDS;
    /** @type {?} */
    SgaSettingsForm.prototype.CondensateReturnTDS;
}
class SteamGenerationAssessmentModulePreferencesComponent {
    /**
     * @param {?} fb
     * @param {?} adminService
     * @param {?} translationService
     * @param {?} translatePipe
     * @param {?} localeService
     * @param {?} preferenceService
     * @param {?} unitsService
     * @param {?} modulePreferenceService
     * @param {?} userProfileService
     * @param {?} user
     */
    constructor(fb, adminService, translationService, translatePipe, localeService, preferenceService, unitsService, modulePreferenceService, userProfileService, user) {
        this.fb = fb;
        this.adminService = adminService;
        this.translationService = translationService;
        this.translatePipe = translatePipe;
        this.localeService = localeService;
        this.preferenceService = preferenceService;
        this.unitsService = unitsService;
        this.modulePreferenceService = modulePreferenceService;
        this.userProfileService = userProfileService;
        this.user = user;
        this.moduleId = "2";
        this.moduleGroupId = 9;
        this.moduleName = "Steam Generation Assessment";
        this.ngUnsubscribe = new Subject$1();
        this.theFormGroup = this.fb.group({
            SteamGenerationFuelType: [null, Validators.required],
            // Fuel type
            SteamGenerationFuelCost: [null, Validators.required],
            // COST_OF_FUEL_PER_UNIT
            SteamGenerationFuelUnit: [null, Validators.required],
            // COST_OF_FUEL_PER_UNIT (unit)
            SteamGenerationWaterCost: [null, Validators.required],
            // COST_OF_WATER_FSLASH_UNIT
            SteamGenerationWaterCostUnit: [null, Validators.required],
            // COST_OF_WATER_FSLASH_UNIT (unit)
            SteamGenerationEffluentCost: [null, Validators.required],
            // COST_OF_EFFLUENT_FSLASH_UNIT
            SteamGenerationEffluentCostUnit: [null, Validators.required],
            // COST_OF_EFFLUENT_FSLASH_UNIT (unit)
            SteamGenerationWaterTreatmentCost: [null, Validators.required],
            // COST_OF_CHEMICALS_FSLASH_UNIT_OF_WATER
            SteamGenerationWaterTreatmentCostUnit: [null, Validators.required],
            // COST_OF_CHEMICALS_FSLASH_UNIT_OF_WATER (unit)
            SteamGenerationCO2Cost: [null, Validators.required],
            // COST_OF_CO2_PER_UNIT_MASS
            SteamGenerationCO2CostUnit: [null, Validators.required],
            // COST_OF_CO2_PER_UNIT_MASS (unit)
            FeedwaterInFeedtankTDS: [null, Validators.required],
            // TDS_OF_FEEDWATER_IN_FEEDTANK
            AverageBoilerTDS: [null, Validators.required],
            // AVERAGE_BOILER_TDS
            MaxAllowableBoilerTDS: [null, Validators.required],
            // MAXIMUM_ALLOWABLE_BOILER_TDS
            MakeupWaterTDS: [null, Validators.required],
            // TDS_OF_MAKEUP_WATER
            CondensateReturnTDS: [null, Validators.required],
        });
        this.fuelTypes$ = this.translationService.displayGroupChange
            .pipe(map(SteamGenerationAssessmentModulePreferencesComponent.getEnumerationDefinitions));
        this.alertData = {
            type: 'success',
            visible: false,
            message: 'MODULE_PREFERENCES_SAVED_SUCCESSFULLY_MESSAGE'
        };
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.userProfileService
            .getUserDetails()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((/**
         * @param {?} v
         * @return {?}
         */
        v => this.setUser(v)));
        this.modulePreferenceService
            .getOperatingCompanyModulePreferences(this.moduleId)
            .pipe(takeUntil(this.ngUnsubscribe), map((/**
         * @param {?} v
         * @return {?}
         */
        (v) => this.setFormValues(v))), switchMap((/**
         * @param {?} v
         * @return {?}
         */
        (v) => this.unitsService.getAllUnitsByAllTypes())))
            .subscribe((/**
         * @param {?} units
         * @return {?}
         */
        (units) => {
            this.allFuelUnitsByTypes = {
                G: units.filter((/**
                 * @param {?} u
                 * @return {?}
                 */
                u => u.unitType === 'BoilerHouseGasFuelUnits')),
                L: units.filter((/**
                 * @param {?} u
                 * @return {?}
                 */
                u => u.unitType === 'BoilerHouseLiquidFuelUnits')),
                E: units.filter((/**
                 * @param {?} u
                 * @return {?}
                 */
                u => u.unitType === 'BoilerHouseElectricalFuelUnits')),
                S: units.filter((/**
                 * @param {?} u
                 * @return {?}
                 */
                u => u.unitType === 'BoilerHouseSolidFuelUnits')),
            };
            this.fuelUnits = this.getFuelUnitByValue(this.allFuelUnitsByTypes);
            this.volumeUnits = this.getUnitsByType('BoilerHouseVolumeUnits', units);
            this.emissionUnits = this.getUnitsByType('BoilerHouseEmissionUnits', units);
        }));
        this.preferenceService.getOperatingCompanyPreferences().subscribe((/**
         * @param {?} prefs
         * @return {?}
         */
        prefs => {
            if (prefs && prefs.length > 0) {
                this.currencyName = prefs.find((/**
                 * @param {?} p
                 * @return {?}
                 */
                p => p.name === 'BHCurrency')).value;
                this.boilerHouseTDSUnitId = prefs.find((/**
                 * @param {?} p
                 * @return {?}
                 */
                p => p.name === 'BoilerHouseTDSUnits')).value;
            }
        }), (/**
         * @param {?} error
         * @return {?}
         */
        error => null), (/**
         * @return {?}
         */
        () => this.runAdminService(this.currencyName)));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    /**
     * @param {?} currencyName
     * @return {?}
     */
    runAdminService(currencyName) {
        this.adminService.getCurrencyData().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            if (data && data.length > 0) {
                this.currencySymbol = data.find((/**
                 * @param {?} p
                 * @return {?}
                 */
                p => p.currencyCode === currencyName)).symbol;
            }
        }), (/**
         * @param {?} error
         * @return {?}
         */
        error => null), (/**
         * @return {?}
         */
        () => this.runUnitsService(this.boilerHouseTDSUnitId)));
    }
    /**
     * @param {?} tdsUnitId
     * @return {?}
     */
    runUnitsService(tdsUnitId) {
        this.tdsUnit = this.unitsService.units.find((/**
         * @param {?} unit
         * @return {?}
         */
        unit => unit.id === +tdsUnitId)).units;
    }
    /**
     * @return {?}
     */
    onSubmit() {
        if (this.theFormGroup.pristine || this.theFormGroup.invalid) {
            this.alertData.visible = true;
            this.alertData.type = 'warning';
            this.alertData.message = 'NO_DATA_TO_SAVE';
            return;
        }
        /** @type {?} */
        const data = Object.entries(this.theFormGroup.getRawValue()).map((/**
         * @param {?} __0
         * @return {?}
         */
        ([name, value]) => ({
            isDeleted: false,
            moduleId: Number(this.moduleId),
            OperatingCompanyId: this.user.operatingCompanyId,
            value: value && value.toString(),
            name
        })));
        this.theFormGroup.disable();
        this.adminService.manageModulePreferences(data)
            .pipe(takeUntil(this.ngUnsubscribe), tap((/**
         * @return {?}
         */
        () => { }), (/**
         * @return {?}
         */
        () => {
            this.alertData.visible = true;
            this.alertData.type = 'danger';
            this.alertData.message = 'MODULE_PREFERENCES_FAILED_TO_SAVE_MESSAGE';
        }), (/**
         * @return {?}
         */
        () => this.theFormGroup.enable())))
            .subscribe((/**
         * @param {?} done
         * @return {?}
         */
        (done) => {
            this.alertData.visible = true;
            this.alertData.type = done ? 'success' : 'danger';
            this.alertData.message = done ?
                'MODULE_PREFERENCES_SAVED_SUCCESSFULLY_MESSAGE' :
                'MODULE_PREFERENCES_FAILED_TO_SAVE_MESSAGE';
            if (done) {
                this.theFormGroup.markAsPristine();
            }
        }));
    }
    /**
     * @param {?} fuelTypeValue
     * @return {?}
     */
    changeFuelType(fuelTypeValue) {
        if (!fuelTypeValue || !this.fuelUnits) {
            return;
        }
        this.fuelUnits = this.getFuelUnitByValue(this.allFuelUnitsByTypes, fuelTypeValue);
        if (!this.fuelUnits || !this.fuelUnits[0]) {
            return;
        }
        this.theFormGroup.get('SteamGenerationFuelUnit')
            .setValue(this.fuelUnits[0].id, { onlySelf: true, emitEvent: false });
    }
    /**
     * @private
     * @param {?} user
     * @return {?}
     */
    setUser(user) {
        this.user = user || null;
        console.log(user, '---getUserDetails');
    }
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    setFormValues(data) {
        console.log(data, '----getOperatingCompanyModulePreferences');
        if (!data || !data.length) {
            return null;
        }
        for (const { name, value } of data) {
            /** @type {?} */
            const ctrl = this.theFormGroup.get(name);
            if (ctrl) {
                ctrl.setValue(value);
            }
        }
        return (/** @type {?} */ (this.theFormGroup.getRawValue()));
    }
    /**
     * @private
     * @param {?} type
     * @param {?=} units
     * @return {?}
     */
    getUnitsByType(type, units) {
        if (!type) {
            return null;
        }
        if (!units) {
            units = this.unitsService.units;
        }
        return units.filter((/**
         * @param {?} u
         * @return {?}
         */
        u => u.unitType === type));
    }
    /**
     * @private
     * @param {?} allFuelUnitsByTypes
     * @param {?=} val
     * @return {?}
     */
    getFuelUnitByValue(allFuelUnitsByTypes, val) {
        /** @type {?} */
        const value = val || this.theFormGroup.get('SteamGenerationFuelType').value;
        if (!allFuelUnitsByTypes) {
            allFuelUnitsByTypes = this.allFuelUnitsByTypes;
        }
        if (!value || !allFuelUnitsByTypes) {
            return;
        }
        return allFuelUnitsByTypes[value.charAt(0).toUpperCase()] || allFuelUnitsByTypes['G'];
    }
    /**
     * @private
     * @param {?} displayGroup
     * @return {?}
     */
    static getEnumerationDefinitions(displayGroup) {
        if (!displayGroup || !displayGroup.enumerations) {
            return null;
        }
        /** @type {?} */
        const enumeration = displayGroup.enumerations
            .find((/**
         * @param {?} __0
         * @return {?}
         */
        ({ enumerationName }) => enumerationName === 'FuelTypeList_BoilerHouseInput'));
        return enumeration && enumeration.enumerationDefinitions;
    }
}
SteamGenerationAssessmentModulePreferencesComponent.decorators = [
    { type: Component, args: [{
                selector: 'steamGenerationAssessment-module-preferences',
                template: "<form class=\"form-horizontal\" role=\"form\" [formGroup]=\"theFormGroup\" (ngSubmit)=\"onSubmit()\">\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <button type=\"submit\"\r\n              class=\"btn btn-dynamic btn-primary pull-right\"\r\n              [disabled]=\"theFormGroup.invalid || theFormGroup.pending || theFormGroup.disabled\"\r\n              [title]=\"'SAVE' | translate:true\">\r\n        <i class=\"fa fa-save\">  {{(theFormGroup.disabled ? 'LOADING' : 'SAVE') | translate:true}}</i>\r\n      </button>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row\"><div class=\"col-xs-12\"><br></div></div>\r\n\r\n  <alert-block *ngIf=\"alertData.visible\"\r\n               (close-callback)=\"alertData.visible = false\"\r\n               [type]=\"alertData.type\"\r\n               [auto-close]=\"true\"\r\n               [message]=\"alertData.message | translate\"></alert-block>\r\n\r\n  <div class=\"panel panel-primary\">\r\n    <div class=\"panel-heading\" role=\"tab\" id=\"fuelTypeOptionsHeading\">\r\n      <h4 class=\"panel-title\">\r\n        <a role=\"button\"\r\n           data-toggle=\"collapse\"\r\n           data-parent=\"#accordion\"\r\n           href=\"#collapseFuelTypeOptions\"\r\n           aria-expanded=\"true\"\r\n           aria-controls=\"collapseFuelTypeOptions\">{{\"FUEL_TYPE\" | translate}}</a>\r\n      </h4>\r\n    </div>\r\n\r\n    <div id=\"collapseFuelTypeOptions\"\r\n         class=\"panel-collapse collapse show\"\r\n         role=\"tabpanel\"\r\n         aria-labelledby=\"fuelTypeOptionsHeading\">\r\n      <div class=\"panel-body\">\r\n        <div class=\"form-group\">\r\n          <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n            <label class=\"control-label\">{{\"FUEL_TYPE\" | translate}}</label>\r\n          </div>\r\n          <div class=\"col-lg-2 col-md-6 col-xs-12\" *ngIf=\"fuelTypes$ | async as fuelTypes\">\r\n            <select class=\"form-control\" formControlName=\"SteamGenerationFuelType\" (ngModelChange)=\"changeFuelType($event)\">\r\n              <option *ngFor=\"let fuelType of fuelTypes\" [value]=\"fuelType?.value\">\r\n                {{fuelType?.translationText}}\r\n              </option>\r\n            </select>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"panel panel-primary\">\r\n    <div class=\"panel-heading\" role=\"tab\" id=\"defaultOptionsHeading\">\r\n      <h4 class=\"panel-title\">\r\n        <a role=\"button\"\r\n           data-toggle=\"collapse\"\r\n           data-parent=\"#accordion\"\r\n           href=\"#collapseDefaultOptions\"\r\n           aria-expanded=\"true\"\r\n           aria-controls=\"collapseDefaultOptions\">{{\"DEFAULT_OPTIONS\" | translate}}</a>\r\n      </h4>\r\n    </div>\r\n\r\n    <div id=\"collapseDefaultOptions\"\r\n         class=\"panel-collapse collapse show\"\r\n         role=\"tabpanel\"\r\n         aria-labelledby=\"defaultOptionsHeading\">\r\n      <div class=\"panel-body\">\r\n        <div class=\"form-group\">\r\n          <div class=\"col-lg-4 col-md-4 col-xs-12 text-right\">\r\n            <label class=\"control-label\">{{'COST_OF_FUEL_PER_UNIT' | translate}}</label>\r\n          </div>\r\n          <div class=\"col-lg-2 col-md-4 col-xs-12\">\r\n            <div class=\"input-group\">\r\n              <input class=\"form-control\" type=\"number\" formControlName=\"SteamGenerationFuelCost\" />\r\n              <span class=\"input-group-addon\">{{currencySymbol}}</span>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-lg-2 col-md-4 col-xs-12\">\r\n            <select class=\"form-control\" formControlName=\"SteamGenerationFuelUnit\">\r\n              <option *ngFor=\"let unit of fuelUnits\"\r\n                      [label]=\"unit?.units\"\r\n                      [value]=\"unit?.id\">\r\n                {{unit?.units}}\r\n              </option>\r\n            </select>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <div class=\"col-lg-4 col-md-4 col-xs-12 text-right\">\r\n            <label class=\"control-label\">{{'COST_OF_WATER_FSLASH_UNIT' | translate}}</label>\r\n          </div>\r\n          <div class=\"col-lg-2 col-md-4 col-xs-12\">\r\n            <div class=\"input-group\">\r\n              <input class=\"form-control\" type=\"number\" formControlName=\"SteamGenerationWaterCost\" />\r\n              <span class=\"input-group-addon\">{{currencySymbol}}</span>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-lg-2 col-md-4 col-xs-12\">\r\n            <select class=\"form-control\" formControlName=\"SteamGenerationWaterCostUnit\">\r\n              <option *ngFor=\"let unit of volumeUnits\"\r\n                      [label]=\"unit.units\"\r\n                      [value]=\"unit.id\">\r\n                {{unit.units}}\r\n              </option>\r\n            </select>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <div class=\"col-lg-4 col-md-4 col-xs-12 text-right\">\r\n            <label class=\"control-label\">{{'COST_OF_EFFLUENT_FSLASH_UNIT' | translate}}</label>\r\n          </div>\r\n          <div class=\"col-lg-2 col-md-4 col-xs-12\">\r\n            <div class=\"input-group\">\r\n              <input class=\"form-control\" type=\"number\" formControlName=\"SteamGenerationEffluentCost\" />\r\n              <span class=\"input-group-addon\">{{currencySymbol}}</span>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-lg-2 col-md-4 col-xs-12\">\r\n            <select class=\"form-control\" formControlName=\"SteamGenerationEffluentCostUnit\">\r\n              <option *ngFor=\"let unit of volumeUnits\"\r\n                      [label]=\"unit.units\"\r\n                      [value]=\"unit.id\">\r\n                {{unit.units}}\r\n              </option>\r\n            </select>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <div class=\"col-lg-4 col-md-4 col-xs-12 text-right\">\r\n            <label class=\"control-label\">{{'COST_OF_CHEMICALS_FSLASH_UNIT_OF_WATER' | translate}}</label>\r\n          </div>\r\n          <div class=\"col-lg-2 col-md-4 col-xs-12\">\r\n            <div class=\"input-group\">\r\n              <input class=\"form-control\" type=\"number\" formControlName=\"SteamGenerationWaterTreatmentCost\" />\r\n              <span class=\"input-group-addon\">{{currencySymbol}}</span>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-lg-2 col-md-4 col-xs-12\">\r\n            <select class=\"form-control\" formControlName=\"SteamGenerationWaterTreatmentCostUnit\">\r\n              <option *ngFor=\"let unit of volumeUnits\"\r\n                      [label]=\"unit.units\"\r\n                      [value]=\"unit.id\">\r\n                {{unit.units}}\r\n              </option>\r\n            </select>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <div class=\"col-lg-4 col-md-4 col-xs-12 text-right\">\r\n            <label class=\"control-label\">{{'COST_OF_CO2_PER_UNIT_MASS' | translate}}</label>\r\n          </div>\r\n          <div class=\"col-lg-2 col-md-4 col-xs-12\">\r\n            <div class=\"input-group\">\r\n              <input class=\"form-control\" type=\"number\" formControlName=\"SteamGenerationCO2Cost\" />\r\n              <span class=\"input-group-addon\">{{currencySymbol}}</span>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-lg-2 col-md-4 col-xs-12\">\r\n            <select class=\"form-control\" formControlName=\"SteamGenerationCO2CostUnit\">\r\n              <option *ngFor=\"let unit of emissionUnits\"\r\n                      [label]=\"unit.units\"\r\n                      [value]=\"unit.id\">\r\n                {{unit.units}}\r\n              </option>\r\n            </select>\r\n          </div>\r\n        </div>\r\n\r\n        <hr />\r\n\r\n        <div class=\"form-group\">\r\n          <div class=\"col-lg-4 col-md-4 col-xs-12 text-right\">\r\n            <label class=\"control-label\">{{'TDS_OF_FEEDWATER_IN_FEEDTANK' | translate}}</label>\r\n          </div>\r\n          <div class=\"col-lg-2 col-md-4 col-xs-12\">\r\n            <div class=\"input-group\">\r\n              <input class=\"form-control\" type=\"number\" formControlName=\"FeedwaterInFeedtankTDS\" />\r\n              <span class=\"input-group-addon\">{{tdsUnit}}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <div class=\"col-lg-4 col-md-4 col-xs-12 text-right\">\r\n            <label class=\"control-label\">{{'AVERAGE_BOILER_TDS' | translate}}</label>\r\n          </div>\r\n          <div class=\"col-lg-2 col-md-4 col-xs-12\">\r\n            <div class=\"input-group\">\r\n              <input class=\"form-control\" type=\"number\" formControlName=\"AverageBoilerTDS\" />\r\n              <span class=\"input-group-addon\">{{tdsUnit}}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <div class=\"col-lg-4 col-md-4 col-xs-12 text-right\">\r\n            <label class=\"control-label\">{{'MAXIMUM_ALLOWABLE_BOILER_TDS' | translate}}</label>\r\n          </div>\r\n          <div class=\"col-lg-2 col-md-4 col-xs-12\">\r\n            <div class=\"input-group\">\r\n              <input class=\"form-control\" type=\"number\" formControlName=\"MaxAllowableBoilerTDS\" />\r\n              <span class=\"input-group-addon\">{{tdsUnit}}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <div class=\"col-lg-4 col-md-4 col-xs-12 text-right\">\r\n            <label class=\"control-label\">{{'TDS_OF_MAKEUP_WATER' | translate}}</label>\r\n          </div>\r\n          <div class=\"col-lg-2 col-md-4 col-xs-12\">\r\n            <div class=\"input-group\">\r\n              <input class=\"form-control\" type=\"number\" formControlName=\"MakeupWaterTDS\" />\r\n              <span class=\"input-group-addon\">{{tdsUnit}}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <div class=\"col-lg-4 col-md-4 col-xs-12 text-right\">\r\n            <label class=\"control-label\">{{'TDS_OF_CONDENSATE_RETURN' | translate}}</label>\r\n          </div>\r\n          <div class=\"col-lg-2 col-md-4 col-xs-12\">\r\n            <div class=\"input-group\">\r\n              <input class=\"form-control\" type=\"number\" formControlName=\"CondensateReturnTDS\" />\r\n              <span class=\"input-group-addon\">{{tdsUnit}}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</form>\r\n",
                styles: ["label{word-break:break-all}"]
            }] }
];
/** @nocollapse */
SteamGenerationAssessmentModulePreferencesComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: AdminService },
    { type: TranslationService },
    { type: TranslatePipe },
    { type: LocaleService },
    { type: PreferenceService },
    { type: UnitsService },
    { type: ModulePreferenceService },
    { type: UserProfileService },
    { type: User }
];
if (false) {
    /** @type {?} */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.moduleId;
    /** @type {?} */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.moduleGroupId;
    /** @type {?} */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.moduleName;
    /**
     * @type {?}
     * @private
     */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.ngUnsubscribe;
    /** @type {?} */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.hasUnsavedDataChanges;
    /** @type {?} */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.theFormGroup;
    /** @type {?} */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.fuelTypes$;
    /** @type {?} */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.volumeUnits;
    /** @type {?} */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.emissionUnits;
    /** @type {?} */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.fuelUnits;
    /** @type {?} */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.allFuelUnitsByTypes;
    /** @type {?} */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.alertData;
    /** @type {?} */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.isLoading;
    /** @type {?} */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.currencyName;
    /** @type {?} */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.currencySymbol;
    /** @type {?} */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.boilerHouseTDSUnitId;
    /** @type {?} */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.tdsUnit;
    /**
     * @type {?}
     * @private
     */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.adminService;
    /**
     * @type {?}
     * @private
     */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.translationService;
    /**
     * @type {?}
     * @private
     */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.translatePipe;
    /**
     * @type {?}
     * @private
     */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.localeService;
    /**
     * @type {?}
     * @private
     */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.preferenceService;
    /**
     * @type {?}
     * @private
     */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.unitsService;
    /**
     * @type {?}
     * @private
     */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.modulePreferenceService;
    /**
     * @type {?}
     * @private
     */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.userProfileService;
    /**
     * @type {?}
     * @private
     */
    SteamGenerationAssessmentModulePreferencesComponent.prototype.user;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/admin/admin.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//import { EasiheatModulePreferencesComponent } from 'src/app/sizingModules/easiheat/modulePreference/easiheat.component';
//import { SteamGenerationAssessmentModulePreferencesComponent } from 'src/app/sizingModules/steamGenerationAssessment/modulePreference/steamGenerationAssessment.component';
// Route definitions for module preferences.
const ɵ0 = { moduleName: "Clean Steam Generator", displayGroup: "CLEAN_STEAM_GENERATOR_MODULE_PREFERENCES" }, ɵ1 = { moduleName: "Clean Steam Generator FB", displayGroup: "CLEAN_STEAM_GENERATOR_FB_MODULE_PREFERENCES" }, ɵ2 = { moduleName: "EasiHeat", displayGroup: "EASIHEAT_MODULE_PREFERENCES" }, ɵ3 = { moduleName: "EasiHeatGen4", displayGroup: "EASIHEAT_GEN4_MODULE_PREFERENCES" }, ɵ4 = { moduleName: "Steam Generation Assessment", displayGroup: "STEAM_GENERATION_ASSESSMENT_MODULE_PREFERENCES" };
/** @type {?} */
const modulePreferencesRoutes = [
    { path: '', canActivateChild: [SizingModuleAccessGuard], canDeactivate: [GenericChangesGuard], redirectTo: '/admin/modulePreferences', pathMatch: 'full' },
    // The resolver in csg has been removed as the translations are in the admin module pref display group
    { path: 'cleanSteamGenerator', canDeactivate: [GenericChangesGuard], component: CleanSteamGeneratorModulePreferencesComponent, data: ɵ0 },
    { path: 'cleanSteamGeneratorFB', canDeactivate: [GenericChangesGuard], component: CleanSteamGeneratorFBModulePreferencesComponent, resolve: { resolver: TranslationResolver }, data: ɵ1 },
    { path: 'easiHeat', canDeactivate: [GenericChangesGuard], component: EasiHeatPreferencesComponent, resolve: { resolver: TranslationResolver }, data: ɵ2 },
    { path: 'easiheatgen4', canDeactivate: [GenericChangesGuard], component: EasiHeatGen4PreferencesComponent, resolve: { resolver: TranslationResolver }, data: ɵ3 },
    {
        path: 'steamGenerationAssessment',
        canDeactivate: [GenericChangesGuard],
        component: SteamGenerationAssessmentModulePreferencesComponent,
        resolve: { resolver: TranslationResolver },
        data: ɵ4
    }
];
// Route definitions for the Angular Admin Module
const ɵ5 = { displayGroup: "ADMIN_LANDING" }, ɵ6 = { displayGroup: "ADMIN_CURRENCY" }, ɵ7 = { displayGroup: "ADMIN_OPERATING_COMPANY_PREFERENCES" }, ɵ8 = { displayGroup: "ADMIN_USER_PREFERENCES" }, ɵ9 = { displayGroup: "ADMIN_MODULE_PREFERENCES" }, ɵ10 = { displayGroup: "ADMIN_MODULE_ACCESS" }, ɵ11 = { displayGroup: "ADMIN_PRODUCT_SELECTION" }, ɵ12 = { displayGroup: "ADMIN_PRODUCT_SELECTION" }, ɵ13 = { displayGroup: "ADMIN_PRODUCT_SELECTION" };
/** @type {?} */
const routes = [
    { path: '', pathMatch: 'full', component: AdminComponent, data: ɵ5 },
    { path: 'currency', component: CurrencyComponent, data: ɵ6 },
    { path: 'operatingCompanyPreferences', component: OperatingCompanyPreferencesComponent, canDeactivate: [GenericChangesGuard], data: ɵ7 },
    { path: 'preferences', component: UserPreferencesComponent, canDeactivate: [GenericChangesGuard], data: ɵ8 },
    { path: 'modulePreferences', canActivateChild: [SizingModuleAccessGuard], component: ModulePreferencesComponent, canDeactivate: [GenericChangesGuard], data: ɵ9, children: modulePreferencesRoutes },
    { path: 'moduleAccess', canDeactivate: [GenericChangesGuard], redirectTo: '/admin/moduleAccess/cleanSteamGenerator', pathMatch: 'full' },
    { path: 'moduleAccess/:sizingModule', component: ModuleAccessComponent, canDeactivate: [GenericChangesGuard], data: ɵ10 },
    { path: 'productSelection', component: ProductSelectionComponent, data: ɵ11 },
    { path: 'productSelectionAdmin', component: ProductSelectionAdminComponent, data: ɵ12 },
    { path: 'flowmeterProductSelectionAdmin', component: FlowmeterProductSelectionAdminComponent, data: ɵ13 }
];
class AdminModule {
}
AdminModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    TranslationModule,
                    PreferenceModule,
                    SharedModule,
                    BlockUIModule,
                    RouterModule.forChild(routes),
                ],
                exports: [RouterModule, CurrencyComponent, ProductSelectionAdminComponent, FlowmeterProductSelectionAdminComponent],
                providers: [AdminService, ProductSelectionAdminService, FlowmeterProductSelectionAdminService, PreferenceModule, GenericChangesGuard],
                declarations: [
                    AdminComponent,
                    CurrencyComponent,
                    OperatingCompanyPreferencesComponent,
                    UserPreferencesComponent,
                    // List of module preference components
                    ModulePreferencesComponent,
                    // List of module access components
                    ModuleAccessComponent,
                    ProductSelectionComponent,
                    ProductSelectionAdminComponent,
                    FlowmeterProductSelectionAdminComponent,
                    CleanSteamGeneratorModulePreferencesComponent,
                    CleanSteamGeneratorFBModulePreferencesComponent,
                    CleanSteamGeneratorFBMiniModulePreferencesComponent,
                    CleanSteamGeneratorFBHalfPipeModulePreferencesComponent,
                    EasiHeatPreferencesComponent,
                    EasiHeatGen4PreferencesComponent,
                    SteamGenerationAssessmentModulePreferencesComponent,
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/admin/module-group.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The Module Group model.
 */
class ModuleGroup {
}
if (false) {
    /**
     * Gets or sets the Module Group Id.
     * @type {?}
     */
    ModuleGroup.prototype.moduleGroupId;
    /**
     * Gets or sets the name of the Module Group.
     * @type {?}
     */
    ModuleGroup.prototype.name;
    /**
     * Gets or sets the master text key for translation.
     * @type {?}
     */
    ModuleGroup.prototype.masterTextKey;
    /**
     * Gets or sets a value indicating whether or not this Module has vetted access.
     * @type {?}
     */
    ModuleGroup.prototype.isVetted;
    /**
     * Gets or sets a value indicating whether or not this Module has a requirement for preferences.
     * @type {?}
     */
    ModuleGroup.prototype.requiresPreferences;
    /**
     * Gets or sets a value indicating whether or not this Module needs to show pricing.
     * @type {?}
     */
    ModuleGroup.prototype.showPricing;
    /**
     * Gets or sets a value indicating whether or not this Module allows selection of products.
     * @type {?}
     */
    ModuleGroup.prototype.allowsProductSelection;
    /**
     * Gets or sets the image source.
     * @type {?}
     */
    ModuleGroup.prototype.imageSrc;
    /**
     * Gets or sets the image source.
     * @type {?}
     */
    ModuleGroup.prototype.modules;
}
/**
 * The Module model.
 */
class Module {
}
if (false) {
    /**
     * Gets or sets the Module Group Id.
     * @type {?}
     */
    Module.prototype.id;
    /**
     * Gets or sets the name of the Module Group.
     * @type {?}
     */
    Module.prototype.name;
    /**
     * Gets or sets the master text key for translation.
     * @type {?}
     */
    Module.prototype.masterTextKey;
    /**
     * Gets or sets the Module Group Id.
     * @type {?}
     */
    Module.prototype.moduleGroupId;
    /**
     * Gets or sets a value indicating whether or not this Module IsDeleted.
     * @type {?}
     */
    Module.prototype.isDeleted;
}
/**
 * The ModuleList model, normally uses for UI binding.
 */
class ModuleListItem {
}
if (false) {
    /**
     * Gets or sets the Module Group Id.
     * @type {?}
     */
    ModuleListItem.prototype.moduleGroupId;
    /**
     * Gets or sets the master text key for translation.
     * @type {?}
     */
    ModuleListItem.prototype.moduleGroupMasterTextKey;
    /**
     * Gets or sets the Module Group Id.
     * @type {?}
     */
    ModuleListItem.prototype.moduleId;
    /**
     * Gets or sets the master text key for translation.
     * @type {?}
     */
    ModuleListItem.prototype.moduleMasterTextKey;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/admin/currency/currency.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The currency model class.
 */
class Currency {
}
if (false) {
    /**
     * Gets or sets the currency Id.
     * @type {?}
     */
    Currency.prototype.id;
    /**
     * Gets or sets the currency code.
     * @type {?}
     */
    Currency.prototype.currencyCode;
    /**
     * Gets or sets the currency translation text.
     * @type {?}
     */
    Currency.prototype.translationText;
    /**
     * Gets or sets the currency master text key.
     * @type {?}
     */
    Currency.prototype.masterTextKey;
    /**
     * Gets or sets the currency symbol.
     * @type {?}
     */
    Currency.prototype.symbol;
    /**
     * Gets or sets the currency's rate to GBP.
     * @type {?}
     */
    Currency.prototype.rateToGbp;
    /**
     * Gets or sets the currency updated timestamp.
     * @type {?}
     */
    Currency.prototype.updated;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/admin/country.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The country model class.
 */
class Country {
}
if (false) {
    /**
     * Gets or sets the country's code.
     * @type {?}
     */
    Country.prototype.countryCode;
    /**
     * Gets or sets the country's name.
     * @type {?}
     */
    Country.prototype.name;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/admin/language.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The language model class.
 */
class Language {
}
if (false) {
    /**
     * Gets or sets the ISO Name of the language.
     * @type {?}
     */
    Language.prototype.isoName;
    /**
     * Gets or sets the name of the language.
     * @type {?}
     */
    Language.prototype.name;
    /**
     * Gets or sets the masterTextKey of the language.
     * @type {?}
     */
    Language.prototype.masterTextKey;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/routingState.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RoutingState {
    /**
     * @param {?} router
     */
    constructor(router) {
        this.router = router;
        this.history = [];
    }
    /**
     * @return {?}
     */
    loadRouting() {
        this.router.events
            .pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        event => event instanceof NavigationEnd)))
            .subscribe((/**
         * @param {?} __0
         * @return {?}
         */
        ({ urlAfterRedirects }) => {
            this.history = [...this.history, urlAfterRedirects];
        }));
    }
    /**
     * @return {?}
     */
    getHistory() {
        return this.history;
    }
    /**
     * @return {?}
     */
    getPreviousUrl() {
        return this.history[this.history.length - 2] || '/index';
    }
}
RoutingState.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
RoutingState.ctorParameters = () => [
    { type: Router }
];
/** @nocollapse */ RoutingState.ngInjectableDef = ɵɵdefineInjectable({ factory: function RoutingState_Factory() { return new RoutingState(ɵɵinject(Router)); }, token: RoutingState, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    RoutingState.prototype.history;
    /**
     * @type {?}
     * @private
     */
    RoutingState.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/syncClient/syncClient.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SyncClientComponent {
    /**
     * @param {?} settingsService
     * @param {?} authenticationService
     * @param {?} route
     * @param {?} routesService
     * @param {?} routingState
     * @param {?} syncClientService
     * @param {?} router
     * @param {?} titleService
     */
    constructor(settingsService, authenticationService, route, routesService, routingState, syncClientService, router, titleService) {
        this.settingsService = settingsService;
        this.authenticationService = authenticationService;
        this.route = route;
        this.routesService = routesService;
        this.routingState = routingState;
        this.syncClientService = syncClientService;
        this.router = router;
        this.titleService = titleService;
        this.loading = false;
        this.syncing = false;
        this.errorMessage = '';
        this.isSuccess = false;
        this.alertVisible = false;
        this.pageLoadProgress = 0;
        this.interval = 0;
        this.timeout = 0;
        this.newClientUserRequiresSyncFinishButton = false;
        this.title = "sync";
        this.loading = false;
        this.language = navigator.language;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.titleService.setTitle(`${this.settingsService.app.name} - ${this.title}`);
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
        if (this.returnUrl.search('sync') >= 0) {
            this.returnUrl = '/home';
        }
        if (!this.authenticationService.authenticatedUser.clientMode) {
            // Navigate onward... (only allow component in Client mode)
            this.finished();
            return;
        }
        this.previousRoute = this.routingState.getPreviousUrl();
        /** @type {?} */
        var newClientUser = this.authenticationService.authenticatedUser.newClientUser;
        // ************ Post login page New User Sync only! **************************
        // Come from login page (a new User requires local data) then perform sync automatically then continue onward...
        if (newClientUser && (this.previousRoute.search('/login') >= 0)) {
            this.setupUIforSync();
            this.newClientUserRequiresSyncFinishButton = true;
            this.syncClientService.syncUserData().subscribe((/**
             * @param {?} syncResponse
             * @return {?}
             */
            (syncResponse) => {
                if (syncResponse) {
                    this.handleSyncSuccess();
                    // Fire P&J sync then leave in background
                    this.syncProjectsAndJobsData();
                    // *******************
                    // Navigate onward... (only when component is stand alone after new Client user login)
                    this.finished();
                    // *******************
                }
                else {
                    // Sync failed!
                    this.handleSyncFailure();
                }
            }), (
            // Error callback
            /**
             * @param {?} err
             * @return {?}
             */
            err => {
                // Sync failed!
                console.log(err.error);
                this.handleSyncFailure();
            }));
        }
        else {
            this.newClientUserRequiresSyncFinishButton = false;
        }
        // ************ End of Post login page New User Sync only! **************************
        // Gives the UI some initial feedback of the P&Js to transfer
        this.getProjectsAndJobsSyncInfo();
        // If sync allready running, set UI and start progress bar
        if (this.syncClientService.isSyncingUserData || this.syncClientService.isSyncingGetProjectsAndJobs || this.syncClientService.isSyncingTechnicalInformation) {
            this.setupUIforSync();
        }
    }
    /**
     * @return {?}
     */
    getProjectsAndJobsSyncInfo() {
        // Gves the UI some initial feedback of the P&Js to transfer
        this.syncClientService.projectsAndJobsSyncInfo().subscribe((/**
         * @param {?} projectsAndJobsSyncInfoResponse
         * @return {?}
         */
        (projectsAndJobsSyncInfoResponse) => {
            if (!!projectsAndJobsSyncInfoResponse && projectsAndJobsSyncInfoResponse.isSuccessful) {
                this.projectsAndJobsSyncInfo = projectsAndJobsSyncInfoResponse;
            }
            else {
                // Sync info for P&J failed, don't bother the UI          
            }
        }), (
        // Error callback
        /**
         * @param {?} err
         * @return {?}
         */
        err => {
            // Sync info for P&J failed, don't bother the UI
            console.log(err.error);
        }));
    }
    /**
     * @return {?}
     */
    syncProjectsAndJobsData() {
        this.syncClientService.projectsAndJobsSyncData().subscribe((/**
         * @param {?} syncResponse
         * @return {?}
         */
        (syncResponse) => {
            if (syncResponse) {
                setTimeout((/**
                 * @return {?}
                 */
                () => {
                    this.projectsAndJobsSyncInfo.numberOfClientSizingsToUpload = 0;
                    this.projectsAndJobsSyncInfo.numberOfServerSizingsToDownload = 0;
                    // Turn off info alert
                    this.syncClientService.isSyncingGetProjectsAndJobs = false;
                    // Do Ti Sync
                    this.syncTechnicalInformationSyncData();
                }), 1000); // delay for UI alerts
            }
            else {
                // Sync failed!
                this.handleSyncFailure();
            }
        }), (
        // Error callback
        /**
         * @param {?} err
         * @return {?}
         */
        err => {
            // Sync failed!
            console.log(err.error);
            this.handleSyncFailure();
        }));
    }
    /**
     * @return {?}
     */
    syncTechnicalInformationSyncData() {
        this.syncClientService.technicalInformationSyncData().subscribe((/**
         * @param {?} syncResponse
         * @return {?}
         */
        (syncResponse) => {
            if (syncResponse) {
                setTimeout((/**
                 * @return {?}
                 */
                () => {
                    // Turn off info alert
                    this.syncClientService.isSyncingTechnicalInformation = false;
                    // All manual sync chain done!
                    this.handleSyncSuccess();
                }), 1000); // delay for UI alerts
            }
            else {
                // Sync failed!
                this.handleSyncFailure();
            }
        }), (
        // Error callback 
        /**
         * @param {?} err
         * @return {?}
         */
        err => {
            // Sync failed!
            console.log(err.error);
            this.handleSyncFailure();
        }));
    }
    /**
     * @return {?}
     */
    manualSync() {
        this.setupUIforSync();
        this.syncClientService.syncUserData().subscribe((/**
         * @param {?} syncResponse
         * @return {?}
         */
        (syncResponse) => {
            if (syncResponse) {
                setTimeout((/**
                 * @return {?}
                 */
                () => {
                    // Turn off info alert
                    this.syncClientService.isSyncingUserData = false;
                    // Now Fire P&J sync data
                    this.syncProjectsAndJobsData();
                }), 1000); // delay for UI alerts
            }
            else {
                // Sync failed!
                this.handleSyncFailure();
            }
        }), (
        // Error callback
        /**
         * @param {?} err
         * @return {?}
         */
        err => {
            // Sync failed!
            console.log(err.error);
            this.handleSyncFailure();
        }));
        // Gives the UI some initial feedback of the P&Js to transfer
        this.getProjectsAndJobsSyncInfo();
    }
    /**
     * @return {?}
     */
    finished() {
        // Navigate onward...
        this.router.navigate([this.returnUrl]);
    }
    /**
     * @return {?}
     */
    setupUIforSync() {
        // Clear info alerts
        this.syncClientService.isSyncingUserData = false;
        this.syncClientService.isSyncingGetProjectsAndJobs = false;
        this.syncClientService.isSyncingTechnicalInformation = false;
        this.syncing = true;
        this.stopProgress(0);
        this.startpageLoadProgress();
        this.closeAlert();
    }
    /**
     * @return {?}
     */
    handleSyncFailure() {
        console.log("Sync failed!");
        this.syncing = false;
        this.stopProgress(0);
        this.isSuccess = false;
        this.alertVisible = true;
    }
    /**
     * @return {?}
     */
    handleSyncSuccess() {
        console.log("Sync succeded!");
        this.syncing = false;
        this.stopProgress();
        this.isSuccess = true;
        this.alertVisible = true;
    }
    /**
     * @return {?}
     */
    closeAlert() {
        // Reset the flag
        this.alertVisible = false;
    }
    /**
     * Shows a progress loader when navigating between routes.
     * @return {?}
     */
    startpageLoadProgress() {
        this.pageLoadProgress = 0;
        this.timeout = window.setTimeout((/**
         * @return {?}
         */
        () => {
            this.interval = window.setInterval((/**
             * @return {?}
             */
            () => {
                if (this.pageLoadProgress >= 100) {
                    this.pageLoadProgress = 0;
                }
                else {
                    this.pageLoadProgress++;
                }
                // If the progress has reached its end or the page has finished loading, cancel the interval.
                if (this.pageLoadProgress === 100) {
                    this.pageLoadProgress = 0;
                    // window.clearInterval(this.interval);
                    // window.clearTimeout(this.timeout);
                }
            }), 100);
        }), 100);
    }
    /**
     * @param {?=} progress
     * @return {?}
     */
    stopProgress(progress = 100) {
        this.pageLoadProgress = progress;
        window.clearInterval(this.interval);
        window.clearTimeout(this.timeout);
    }
}
SyncClientComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-sync',
                template: "<div class=\"wrapper\">\r\n    <div class=\"block-center mt-xl wd-xxl\">\r\n\r\n      <!-- START panel-->\r\n        <div class=\"panel panel-dark panel-flat\">\r\n            <div class=\"panel-heading text-center\">\r\n                <a href=\"#\">\r\n                    <img class=\"block-center img-rounded\" src=\"assets/img/sizing-logo.png\" alt=\"Image\" />\r\n                </a>\r\n            </div>\r\n            <div class=\"panel-body\">\r\n              <p class=\"text-center pv\">{{'DATA_SYNCHRONISATION' | translate}}</p>\r\n\r\n              <form name=\"form\" #syncForm=\"ngForm\" novalidate=\"\">\r\n                <div class=\"form-group has-feedback\" [ngClass]=\"{ 'has-error': syncForm.submitted && !syncing }\">\r\n\r\n                </div>\r\n\r\n                <!-- Error block -->\r\n                <alert-block *ngIf=\"!!errorMessage\" type=\"danger\" [message]=\"errorMessage\" [auto-close]=\"true\"></alert-block>\r\n\r\n                <div class=\"clearfix\">\r\n                </div>\r\n                <!-- Simulates data sync progress -->\r\n                <div class=\"loading-overlay\">\r\n                  <progressbar class=\"progress-striped active\" [value]=\"pageLoadProgress\" type=\"info\"></progressbar>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                  <button [disabled]=\"syncing\" class=\"btn btn-block btn-primary mt-lg\" (click)=\"manualSync()\">{{'PERFORM_DATA_SYNC' | translate}}</button>\r\n                  <button *ngIf=\"newClientUserRequiresSyncFinishButton\" class=\"btn btn-block btn-primary mt-lg\" (click)=\"finished()\">{{'FINISH_AND_CONTINUE' | translate}}</button>\r\n                </div>\r\n\r\n\r\n                <alert-block *ngIf=\"syncClientService.isSyncingUserData\" type=\"info\" [auto-close]=\"false\" [message]=\"'USER_DATA_SYNC_IN_PROGRESS_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n                <alert-block *ngIf=\"syncClientService.isSyncingGetProjectsAndJobs\" type=\"info\" [auto-close]=\"false\" [message]=\"'PROJECTS_AND_JOBS_SYNC_IN_PROGRESS_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n                <alert-block *ngIf=\"syncClientService.isSyncingTechnicalInformation\" type=\"info\" [auto-close]=\"false\" [message]=\"'TI_DOCUMENTS_SYNC_IN_PROGRESS_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n                <alert-block *ngIf=\"!!alertVisible && !!isSuccess\" type=\"success\" [auto-close]=\"false\" [message]=\"'DATA_SYNC_SUCCESSFULLY_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n                <!-- Failure confirmation message-->\r\n                <alert-block *ngIf=\"!!alertVisible && !isSuccess\" type=\"danger\" [message]=\"'DATA_SYNC_FAILED_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n                <div *ngIf=\"!newClientUserRequiresSyncFinishButton && !!projectsAndJobsSyncInfo && projectsAndJobsSyncInfo.isSuccessful && (projectsAndJobsSyncInfo.numberOfServerSizingsToDownload > 0 || projectsAndJobsSyncInfo.numberOfClientSizingsToUpload > 0)\">\r\n                  <!-- projectsAndJobsSyncInfo -->\r\n                  <p class=\"text-center pv\" style=\"font-weight: bolder; color: red; text-wrap: avoid\">{{projectsAndJobsSyncInfo.numberOfServerSizingsToDownload}} {{'JOBS_TO_DOWNLOAD_FROM_SERVER' | translate}}, {{projectsAndJobsSyncInfo.numberOfClientSizingsToUpload}} {{'JOBS_TO_UPLOAD_FROM_CLIENT' | translate}}</p>\r\n                </div>\r\n\r\n\r\n              </form>\r\n\r\n              </div>\r\n        </div>\r\n        <!-- END panel-->\r\n        <footer app-footer></footer>\r\n    </div>\r\n</div>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
SyncClientComponent.ctorParameters = () => [
    { type: SettingsService },
    { type: AuthenticationService },
    { type: ActivatedRoute },
    { type: RoutesService },
    { type: RoutingState },
    { type: SyncClientService },
    { type: Router },
    { type: Title }
];
SyncClientComponent.propDecorators = {
    syncForm: [{ type: ViewChild, args: ["syncForm", { static: false },] }]
};
if (false) {
    /** @type {?} */
    SyncClientComponent.prototype.loading;
    /** @type {?} */
    SyncClientComponent.prototype.syncing;
    /** @type {?} */
    SyncClientComponent.prototype.returnUrl;
    /** @type {?} */
    SyncClientComponent.prototype.language;
    /** @type {?} */
    SyncClientComponent.prototype.errorMessage;
    /** @type {?} */
    SyncClientComponent.prototype.isSuccess;
    /** @type {?} */
    SyncClientComponent.prototype.alertVisible;
    /** @type {?} */
    SyncClientComponent.prototype.pageLoadProgress;
    /** @type {?} */
    SyncClientComponent.prototype.interval;
    /** @type {?} */
    SyncClientComponent.prototype.timeout;
    /** @type {?} */
    SyncClientComponent.prototype.previousRoute;
    /** @type {?} */
    SyncClientComponent.prototype.newClientUserRequiresSyncFinishButton;
    /** @type {?} */
    SyncClientComponent.prototype.projectsAndJobsSyncInfo;
    /**
     * @type {?}
     * @private
     */
    SyncClientComponent.prototype.title;
    /** @type {?} */
    SyncClientComponent.prototype.syncForm;
    /** @type {?} */
    SyncClientComponent.prototype.settingsService;
    /**
     * @type {?}
     * @private
     */
    SyncClientComponent.prototype.authenticationService;
    /**
     * @type {?}
     * @private
     */
    SyncClientComponent.prototype.route;
    /**
     * @type {?}
     * @private
     */
    SyncClientComponent.prototype.routesService;
    /**
     * @type {?}
     * @private
     */
    SyncClientComponent.prototype.routingState;
    /** @type {?} */
    SyncClientComponent.prototype.syncClientService;
    /**
     * @type {?}
     * @private
     */
    SyncClientComponent.prototype.router;
    /**
     * @type {?}
     * @private
     */
    SyncClientComponent.prototype.titleService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/user-profile/user-profile.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UserProfileComponent {
    /**
     * @param {?} fb
     * @param {?} userProfileService
     * @param {?} adminService
     * @param {?} sharedService
     * @param {?} userValidator
     * @param {?} router
     */
    constructor(fb, userProfileService, adminService, sharedService, userValidator, router) {
        this.fb = fb;
        this.userProfileService = userProfileService;
        this.adminService = adminService;
        this.sharedService = sharedService;
        this.userValidator = userValidator;
        this.router = router;
        this.languages = [];
        this.countries = [];
        this.operatingCompanies = [];
        this.selectedIndustry = "";
        this.superUserRoleId = 4;
        this.isSuccess = false;
        this.userProfileFormSubmitted = false;
        this.changePasswordFormSubmitted = false;
        this.parentSubmitIsDisabled = true; // Modal parent container component submit button state (enabled/disabled)
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.userProfileService.getUserDetails().subscribe((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            this.user = user;
            this.industryEnumFormControl = new FormControl(this.user.industryEnum);
            /** @type {?} */
            const userRoleIsNotSuperUser = this.user.roleId !== 4;
            // The user form
            this.userForm = this.fb.group({
                username: new FormControl(this.user.username, { validators: [Validators.required, Validators.minLength(6)], asyncValidators: [this.userValidator.usernameValidator.bind(this)], updateOn: 'blur' }),
                firstname: new FormControl(this.user.firstname, Validators.compose([Validators.required])),
                lastname: new FormControl(this.user.lastname, Validators.compose([Validators.required])),
                email: new FormControl(this.user.email, { validators: [Validators.required, Validators.email], asyncValidators: [this.userValidator.emailValidator.bind(this)], updateOn: 'blur' }),
                memorableWord: new FormControl(this.user.memorableWord, Validators.compose([Validators.required])),
                operatingCompanyId: new FormControl({ value: this.user.operatingCompanyId, disabled: userRoleIsNotSuperUser }),
                //only allow super-users to update their operating company
                company: new FormControl(this.user.company),
                address: new FormControl(this.user.address),
                telephone: new FormControl(this.user.telephone),
                companyPosition: new FormControl(this.user.companyPosition),
                industryEnum: this.industryEnumFormControl,
                tradeEnum: new FormControl(this.user.tradeEnum),
                hasAgreedDpa: new FormControl(this.user.hasAgreedDpa),
                languageIsoName: new FormControl(this.user.languageIsoName),
                countryCode: new FormControl({ value: this.user.countryCode, disabled: true })
            }, { validator: [this.unsupportedUserNameCharacters] });
            // The password reset form
            this.passwordResetForm = this.fb.group({
                password: new FormControl('', Validators.compose([Validators.required])),
                newPassword: new FormControl('', Validators.compose([Validators.required])),
                confirmNewPassword: new FormControl('', Validators.compose([Validators.required]))
            }, { validator: [this.passwordMatchValidator, this.unsupportedCharacters] });
            // Do an initial load of the industry enum, based on the selected trade enum.
            this.onTradeChange(this.user.tradeEnum);
            this.theFormGroup = this.userForm; // to drive GenericChangesGuard
        }));
        // Get the languages
        this.adminService.getLanguages().subscribe((/**
         * @param {?} languages
         * @return {?}
         */
        (languages) => this.languages = languages));
        // Get the countries
        this.adminService.getCountries().subscribe((/**
         * @param {?} countries
         * @return {?}
         */
        (countries) => this.countries = countries));
        // Get the Operating Companies
        this.adminService.getOperatingCompanies().subscribe((/**
         * @param {?} operatingCompanies
         * @return {?}
         */
        (operatingCompanies) => this.operatingCompanies = operatingCompanies));
    }
    /**
     * @param {?} event
     * @return {?}
     */
    submitForm(event) {
        event.preventDefault();
        // Before starting, reset the form submission flag
        this.userProfileFormSubmitted = false;
        /** @type {?} */
        const updatedUser = (/** @type {?} */ (this.userForm.value));
        // Append the values that the form does not have.
        updatedUser.countryCode = this.user.countryCode;
        updatedUser.operatingCompanyId = +updatedUser.operatingCompanyId;
        // Reset the flags
        this.isSuccess = false;
        this.userProfileFormSubmitted = false;
        console.log(updatedUser);
        if (this.userForm.valid) {
            this.userProfileService.updateUserDetails(updatedUser).subscribe((/**
             * @param {?} response
             * @return {?}
             */
            (response) => {
                // Show / hide the success flag.
                this.isSuccess = response;
                this.userProfileFormSubmitted = true;
                // Set the form back to pristine only if the data has been saved successfully.
                if (this.isSuccess) {
                    this.userForm.markAsPristine();
                }
            }), (
            // Error callback
            /**
             * @return {?}
             */
            () => {
                this.isSuccess = false;
                this.userProfileFormSubmitted = true;
            }));
        }
    }
    /**
     * @param {?} valForm
     * @return {?}
     */
    passwordMatchValidator(valForm) {
        return valForm.controls['newPassword'].value === valForm.controls['confirmNewPassword'].value ? null : { 'mismatch': true };
    }
    /**
     * @param {?} valForm
     * @return {?}
     */
    unsupportedCharacters(valForm) {
        /** @type {?} */
        let unsupportedcharacters = false;
        if (!unsupportedcharacters && !!valForm.controls['password'].value && !!valForm.controls['password'].value != null) {
            /** @type {?} */
            var theValue = valForm.controls['password'].value;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('&') > -1) ? true : false;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('+') > -1) ? true : false;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('%') > -1) ? true : false;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('"') > -1) ? true : false;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('\\') > -1) ? true : false;
        }
        if (!unsupportedcharacters && !!valForm.controls['newPassword'].value && !!valForm.controls['newPassword'].value != null) {
            /** @type {?} */
            var theValue = valForm.controls['newPassword'].value;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('&') > -1) ? true : false;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('+') > -1) ? true : false;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('%') > -1) ? true : false;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('"') > -1) ? true : false;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('\\') > -1) ? true : false;
        }
        if (!unsupportedcharacters && !!valForm.controls['confirmNewPassword'].value && !!valForm.controls['confirmNewPassword'].value != null) {
            /** @type {?} */
            var theValue = valForm.controls['confirmNewPassword'].value;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('&') > -1) ? true : false;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('+') > -1) ? true : false;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('%') > -1) ? true : false;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('"') > -1) ? true : false;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('\\') > -1) ? true : false;
        }
        // set/clear the error
        return unsupportedcharacters ? { 'unsupportedcharacters': true } : null;
    }
    /**
     * @param {?} valForm
     * @return {?}
     */
    unsupportedUserNameCharacters(valForm) {
        /** @type {?} */
        let unsupportedcharacters = false;
        if (!unsupportedcharacters && !!valForm.controls['username'].value && !!valForm.controls['username'].value != null) {
            /** @type {?} */
            var theValue = valForm.controls['username'].value;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('&') > -1) ? true : false;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('+') > -1) ? true : false;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('%') > -1) ? true : false;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('"') > -1) ? true : false;
            unsupportedcharacters = (unsupportedcharacters || theValue.indexOf('\\') > -1) ? true : false;
        }
        // set/clear the error
        return unsupportedcharacters ? { 'unsupportedUserNameCharacters': true } : null;
    }
    /**
     * Support this method is you require Modal Submit button state handling. ie. disable the submit button if any validation errors exist.
     * @return {?}
     */
    checkIfSubmitIsDisabled() {
        return this.parentSubmitIsDisabled;
    }
    /**
     * @return {?}
     */
    submitPasswordChangeForm() {
        /** @type {?} */
        const password = this.passwordResetForm.controls.password.value;
        /** @type {?} */
        const newPassword = this.passwordResetForm.controls.newPassword.value;
        /** @type {?} */
        const confirmNewPassword = this.passwordResetForm.controls.confirmNewPassword.value;
        // Reset the flags
        this.isSuccess = false;
        this.changePasswordFormSubmitted = false;
        this.userProfileService.resetPassword(this.user.username, password, newPassword, confirmNewPassword).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            this.passwordResetResponse = response;
            this.isSuccess = this.passwordResetResponse.verificationSucceeded;
            this.changePasswordFormSubmitted = true;
            this.passwordResetForm.reset();
        }), (
        // Error callback
        /**
         * @return {?}
         */
        () => {
            this.isSuccess = false;
            this.changePasswordFormSubmitted = true;
            this.passwordResetForm.reset();
        }));
    }
    /**
     * @return {?}
     */
    modalCallbackCancel() {
        console.log("Closing change password modal popup");
        this.passwordResetForm.reset();
    }
    /**
     * Event that is called when the selected trade value is changed.
     * @param {?} event
     * @return {?}
     */
    onTradeChange(event) {
        /** @type {?} */
        const industry = this.sharedService.getIndustryEnumNameForProvidedTrade(event ? event.selectedValue : '');
        // Set the global industry item
        this.selectedIndustry = industry;
    }
    /**
     * @param {?} componentRef
     * @return {?}
     */
    onDeactivate(componentRef) {
        console.info(`Deactivating`);
    }
}
UserProfileComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-user-profile',
                template: "<form *ngIf=\"!!user\" [formGroup]=\"userForm\" class=\"form-horizontal\" role=\"form\" (submit)=\"submitForm($event)\" novalidate>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <button [disabled]=\"!userForm.valid\" class=\"btn btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i></button>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Notification ribbons should go here -->\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <!-- Alert messages for user profile submissions -->\r\n      <alert type=\"success\" *ngIf=\"userProfileFormSubmitted && isSuccess\" dismissible=\"true\" dismissOnTimeout=\"10000\">{{'USER_PROFILE_SUCCESS_MESSAGE' | translate}}</alert>\r\n      <alert type=\"danger\" *ngIf=\"userProfileFormSubmitted && !isSuccess\" dismissible=\"true\">{{'USER_PROFILE_FAILURE_MESSAGE' | translate}}</alert>\r\n\r\n      <!-- Alert messages for change password -->\r\n      <alert type=\"success\" *ngIf=\"changePasswordFormSubmitted && isSuccess\" dismissible=\"true\" dismissOnTimeout=\"10000\">{{'CHANGE_PASSW0RD_SUCCESS_MESSAGE' | translate}}</alert>\r\n      <alert type=\"danger\" *ngIf=\"changePasswordFormSubmitted && !isSuccess\" dismissible=\"true\">{{passwordResetResponse.message | translate}}</alert>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-lg-6 col-md-6 col-xs-12\">\r\n\r\n      <!--Username-->\r\n      <div class=\"form-group\">\r\n        <label for=\"username\" class=\"col-sm-2 control-label\">{{'USERNAME' | translate}}</label>\r\n        <div class=\"col-sm-7\">\r\n          <input autocomplete=\"off\" type=\"text\" id=\"username\" name=\"username\" formControlName=\"username\" class=\"form-control\" required autocomplete=\"off\" />\r\n        </div>\r\n\r\n        <div class=\"col-sm-3\">\r\n          <span class=\"text-danger\" *ngIf=\"userForm.controls['username'].hasError('required') && (userForm.controls['username'].dirty || userForm.controls['username'].touched)\">{{'USERNAME_IS_REQUIRED' | translate}}</span>\r\n          <span class=\"text-danger\" *ngIf=\"userForm.controls['username'].hasError('minlength')\">{{'MINUMUM_SIX_CHARACTERS' | translate}}</span>\r\n          <span class=\"text-danger\" *ngIf=\"userForm.controls['username'].hasError('existingUserByUsername')\">{{'USERNAME_ALREADY_EXISTS' | translate}}</span>\r\n          <span class=\"text-danger\" *ngIf=\"userForm.errors?.unsupportedUserNameCharacters && (userForm.controls['username'].dirty || userForm.controls['username'].touched)\">{{'SPECIAL_CHARACTERS_ARE_NOT_SUPPORTED' | translate}}</span>\r\n\r\n        </div>\r\n\r\n      </div>\r\n\r\n      <!-- Reset password -->\r\n      <div class=\"form-group\">\r\n        <label class=\"col-sm-2 control-label\">{{'RESET_PASSWORD' | translate}}</label>\r\n        <div class=\"col-sm-7\">\r\n          <button class=\"btn btn-primary\" type=\"button\" (click)=\"changePasswordModal.open()\">\r\n            <i class=\"fa fa-key\"></i>\r\n          </button>\r\n        </div>\r\n      </div>\r\n\r\n      <!--Firstname-->\r\n      <div class=\"form-group\">\r\n        <label for=\"firstname\" class=\"col-sm-2 control-label\">{{'FIRST_NAME' | translate}}</label>\r\n        <div class=\"col-sm-7\">\r\n          <input autocomplete=\"off\" type=\"text\" id=\"firstname\" name=\"firstname\" formControlName=\"firstname\" class=\"form-control\" required />\r\n        </div>\r\n        <div class=\"col-md-3\">\r\n          <span class=\"text-danger\" *ngIf=\"userForm.controls['firstname'].hasError('required') && (userForm.controls['firstname'].dirty || userForm.controls['firstname'].touched)\">{{'FIRST_NAME_IS_REQUIRED' | translate}}</span>\r\n        </div>\r\n      </div>\r\n\r\n      <!--Lastname-->\r\n      <div class=\"form-group\">\r\n        <label for=\"lastname\" class=\"col-sm-2 control-label\">{{'LAST_NAME' | translate}}</label>\r\n        <div class=\"col-sm-7\">\r\n          <input autocomplete=\"off\" type=\"text\" id=\"lastname\" name=\"lastname\" formControlName=\"lastname\" class=\"form-control\" required />\r\n        </div>\r\n        <div class=\"col-md-3\">\r\n          <span class=\"text-danger\" *ngIf=\"userForm.controls['lastname'].hasError('required') && (userForm.controls['lastname'].dirty || userForm.controls['lastname'].touched)\">{{'LAST_NAME_IS_REQUIRED' | translate}}</span>\r\n        </div>\r\n      </div>\r\n\r\n      <!--Email-->\r\n      <div class=\"form-group\">\r\n        <label for=\"email\" class=\"col-sm-2 control-label\">{{'EMAIL' | translate}}</label>\r\n        <div class=\"col-sm-7\">\r\n          <input autocomplete=\"off\" type=\"text\" id=\"email\" name=\"email\" formControlName=\"email\" class=\"form-control\" required />\r\n        </div>\r\n        <div class=\"col-md-3\">\r\n          <span class=\"text-danger\" *ngIf=\"userForm.controls['email'].hasError('required') && (userForm.controls['email'].dirty || userForm.controls['email'].touched)\">{{'EMAIL_ADDRESS_IS_REQUIRED' | translate}}</span>\r\n          <span class=\"text-danger\" *ngIf=\"userForm.controls['email'].hasError('email') && (userForm.controls['email'].dirty || userForm.controls['email'].touched)\">{{'EMAIL_ADDRESS_IS_NOT_VALID' | translate}}</span>\r\n          <span class=\"text-danger\" *ngIf=\"userForm.controls['email'].hasError('existingUserByEmail')\">Email already exists</span>\r\n        </div>\r\n      </div>\r\n\r\n      <!--Memorable word-->\r\n      <div class=\"form-group\">\r\n        <label for=\"memorableWord\" class=\"col-sm-2 control-label\">{{'MEMORABLE_WORD' | translate}}</label>\r\n        <div class=\"col-sm-7\">\r\n          <input autocomplete=\"off\" type=\"text\" id=\"memorableWord\" name=\"memorableWord\" formControlName=\"memorableWord\" class=\"form-control\" required />\r\n        </div>\r\n        <div class=\"col-md-3\">\r\n          <span class=\"text-danger\" *ngIf=\"userForm.controls['memorableWord'].hasError('required') && (userForm.controls['memorableWord'].dirty || userForm.controls['memorableWord'].touched)\">{{'MEMORABLE_WORD_IS_REQUIRED' | translate}}</span>\r\n        </div>\r\n      </div>\r\n\r\n      <!--Language-->\r\n      <div class=\"form-group\">\r\n        <label for=\"languageIsoName\" class=\"col-sm-2 control-label\">{{'LANGUAGE' | translate}}</label>\r\n        <div class=\"col-sm-7\">\r\n          <select class=\"form-control\" formControlName=\"languageIsoName\" required>\r\n            <option [value]=\"language.isoName\" *ngFor=\"let language of languages\">\r\n              {{language.name}}\r\n            </option>\r\n          </select>\r\n        </div>\r\n        <div class=\"col-md-3\">\r\n          <span class=\"text-danger\" *ngIf=\"userForm.controls['languageIsoName'].hasError('required') && (userForm.controls['languageIsoName'].dirty || userForm.controls['languageIsoName'].touched)\">{{'LANGUAGE_IS_REQUIRED' | translate}}</span>\r\n        </div>\r\n      </div>\r\n\r\n      <!--Trade-->\r\n      <div class=\"form-group\">\r\n        <label for=\"tradeEnum\" class=\"col-sm-2 control-label\">{{'TRADE' | translate}}</label>\r\n        <div class=\"col-sm-7\">\r\n          <enumeration formControlName=\"tradeEnum\" enumeration-name=\"Trade_Platform\" (on-change)=\"onTradeChange($event)\"></enumeration>\r\n        </div>\r\n      </div>\r\n\r\n      <!--Industry-->\r\n      <div class=\"form-group\">\r\n        <label for=\"industryEnum\" class=\"col-sm-2 control-label\">{{'INDUSTRY' | translate}}</label>\r\n        <div class=\"col-sm-7\">\r\n          <enumeration formControlName=\"industryEnum\" [enumeration-name]=\"selectedIndustry\"></enumeration>\r\n        </div>\r\n      </div>\r\n\r\n      <!--DPA-->\r\n      <div clas=\"form-group\">\r\n        <label for=\"hasAgreedDpa\" class=\"col-sm-2 control-label\">{{'HAS_AGREED_DPA' | translate}}</label>\r\n        <div class=\"col-sm-7\" style=\"padding-left:7.5px\">\r\n          <div for=\"hasAgreedDpa\" class=\"checkbox c-checkbox\">\r\n            <label>\r\n              <input autocomplete=\"off\" id=\"hasAgreedDpa\" name=\"hasAgreedDpa\" formControlName=\"hasAgreedDpa\" type=\"checkbox\">\r\n              <span class=\"fa fa-check\"></span>\r\n            </label>\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n\r\n    </div>\r\n\r\n\r\n    <div class=\"col-lg-6 col-md-6 col-xs-12\">\r\n\r\n      <!--Address-->\r\n      <div class=\"form-group\">\r\n        <label for=\"address\" class=\"col-sm-2 control-label\">{{\"ADDRESS\" | translate}}</label>\r\n        <div class=\"col-sm-7\">\r\n          <textarea class=\"form-control\" id=\"address\" name=\"address\" formControlName=\"address\" rows=\"3\"></textarea>\r\n        </div>\r\n      </div>\r\n\r\n      <!--Country-->\r\n      <div class=\"form-group\">\r\n        <label for=\"countryCode\" class=\"col-sm-2 control-label\">{{'COUNTRY' | translate}}</label>\r\n        <div class=\"col-sm-7\">\r\n          <select class=\"form-control\" formControlName=\"countryCode\">\r\n            <option [value]=\"country.countryCode\" *ngFor=\"let country of countries\">\r\n              {{country.name}}\r\n            </option>\r\n          </select>\r\n        </div>\r\n      </div>\r\n\r\n      <!--Operating Company-->\r\n      <div class=\"form-group\">\r\n        <label for=\"operatingCompany\" class=\"col-sm-2 control-label\">{{'SPIRAX_OPERATING_COMPANY' | translate}}</label>\r\n        <div class=\"col-sm-7\">\r\n\r\n          <select class=\"form-control\" formControlName=\"operatingCompanyId\" required>\r\n            <option [value]=\"operatingCompany.id\" *ngFor=\"let operatingCompany of operatingCompanies\" >\r\n              {{operatingCompany.name}}\r\n            </option>\r\n          </select>\r\n\r\n          \r\n        </div>\r\n\r\n      </div>\r\n\r\n      <!--Telephone-->\r\n      <div class=\"form-group\">\r\n        <label for=\"telephone\" class=\"col-sm-2 control-label\">{{'TELEPHONE' | translate}}</label>\r\n        <div class=\"col-sm-7\">\r\n          <input autocomplete=\"off\" type=\"tel\" id=\"telephone\" name=\"telephone\" formControlName=\"telephone\" class=\"form-control\" numberOnly autocomplete=\"off\" />\r\n        </div>\r\n      </div>\r\n\r\n      <!--Company-->\r\n      <div class=\"form-group\">\r\n        <label for=\"company\" class=\"col-sm-2 control-label\">{{'COMPANY' | translate}}</label>\r\n        <div class=\"col-sm-7\">\r\n          <input autocomplete=\"off\" type=\"text\" id=\"company\" name=\"company\" formControlName=\"company\" class=\"form-control\" />\r\n        </div>\r\n      </div>\r\n\r\n      <!--Position-->\r\n      <div class=\"form-group\">\r\n        <label for=\"companyPosition\" class=\"col-sm-2 control-label\">{{'COMPANY_POSITION' | translate}}</label>\r\n        <div class=\"col-sm-7\">\r\n          <input autocomplete=\"off\" type=\"text\" id=\"companyPosition\" name=\"companyPosition\" formControlName=\"companyPosition\" class=\"form-control\" />\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n\r\n</form>\r\n\r\n\r\n\r\n<sizing-suite-modal *ngIf=\"!!user\"\r\n                    #changePasswordModal\r\n                    (modal-cancel)=\"modalCallbackCancel()\"\r\n                    (modal-ok)=\"submitPasswordChangeForm()\"\r\n                    [modal-title]=\"'CHANGE_USER_PASSWORD' | translate\"\r\n                    [modal-ok-text]=\"'SUBMIT' | translate:true\"\r\n                    [modal-ok-icon]=\"'fa fa-save'\"\r\n                    [modal-cancel-text]=\"'CANCEL' | translate:true\"\r\n                    [modal-cancel-icon]=\"'fa fa-times'\"\r\n                    loaded-child-component-submit-is-disabled-function=\"checkIfSubmitIsDisabled\"\r\n>\r\n\r\n  <form [formGroup]=\"passwordResetForm\" class=\"form-validate; form-horizontal\"  role=\"form\" >\r\n\r\n    <!-- Current password -->\r\n    <div class=\"form-group\">\r\n      <label class=\"col-sm-3 control-label\">{{'CURRENT_PASSWORD' | translate}}</label>\r\n      <div class=\"col-sm-4\">\r\n        <input autocomplete=\"off\" type=\"password\" class=\"form-control\" formControlName=\"password\" required />\r\n      </div>\r\n    </div>\r\n\r\n    <!-- New password -->\r\n    <div class=\"form-group\">\r\n      <label class=\"col-sm-3 control-label\">{{'NEW_PASSWORD' | translate}}</label>\r\n      <div class=\"col-sm-4\">\r\n        <input autocomplete=\"off\" type=\"password\" class=\"form-control\" formControlName=\"newPassword\" required />\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Confirm new password -->\r\n    <div class=\"form-group\">\r\n      <label class=\"col-sm-3 control-label\">{{'CONFIRM_NEW_PASSWORD' | translate}}</label>\r\n      <div class=\"col-sm-4\">\r\n        <input autocomplete=\"off\" type=\"password\" class=\"form-control\" formControlName=\"confirmNewPassword\" required />\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group has-feedback\">\r\n      <label class=\"col-sm-3 control-label\"> </label>\r\n      <div class=\"col-sm-4\">\r\n        <span class=\"text-danger\" *ngIf=\"passwordResetForm.errors?.mismatch && (passwordResetForm.controls['confirmNewPassword'].dirty || passwordResetForm.controls['confirmNewPassword'].touched)\">\r\n          {{'PASSWORDS_MUST_MATCH' | translate}}\r\n        </span>\r\n        <span class=\"text-danger\" *ngIf=\"passwordResetForm.errors?.unsupportedcharacters\r\n                                      && (passwordResetForm.controls['confirmNewPassword'].dirty || passwordResetForm.controls['confirmNewPassword'].touched\r\n                                            || passwordResetForm.controls['newPassword'].dirty   || passwordResetForm.controls['newPassword'].touched\r\n                                          )\">\r\n            {{'SPECIAL_CHARACTERS_ARE_NOT_SUPPORTED' | translate}}\r\n        </span>\r\n\r\n      </div>\r\n    </div>\r\n\r\n\r\n  </form>\r\n\r\n</sizing-suite-modal>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
UserProfileComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: UserProfileService },
    { type: AdminService },
    { type: SharedService },
    { type: UserValidator },
    { type: Router }
];
UserProfileComponent.propDecorators = {
    changePasswordModal: [{ type: ViewChild, args: ["changePasswordModal", { static: false },] }]
};
if (false) {
    /** @type {?} */
    UserProfileComponent.prototype.user;
    /** @type {?} */
    UserProfileComponent.prototype.languages;
    /** @type {?} */
    UserProfileComponent.prototype.countries;
    /** @type {?} */
    UserProfileComponent.prototype.operatingCompanies;
    /** @type {?} */
    UserProfileComponent.prototype.selectedIndustry;
    /**
     * @type {?}
     * @private
     */
    UserProfileComponent.prototype.industryEnumFormControl;
    /**
     * @type {?}
     * @private
     */
    UserProfileComponent.prototype.superUserRoleId;
    /** @type {?} */
    UserProfileComponent.prototype.userForm;
    /** @type {?} */
    UserProfileComponent.prototype.passwordResetForm;
    /** @type {?} */
    UserProfileComponent.prototype.passwordResetResponse;
    /** @type {?} */
    UserProfileComponent.prototype.isSuccess;
    /** @type {?} */
    UserProfileComponent.prototype.userProfileFormSubmitted;
    /** @type {?} */
    UserProfileComponent.prototype.changePasswordFormSubmitted;
    /** @type {?} */
    UserProfileComponent.prototype.parentSubmitIsDisabled;
    /** @type {?} */
    UserProfileComponent.prototype.theFormGroup;
    /** @type {?} */
    UserProfileComponent.prototype.hasUnsavedDataChanges;
    /** @type {?} */
    UserProfileComponent.prototype.changePasswordModal;
    /**
     * @type {?}
     * @private
     */
    UserProfileComponent.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    UserProfileComponent.prototype.userProfileService;
    /**
     * @type {?}
     * @private
     */
    UserProfileComponent.prototype.adminService;
    /**
     * @type {?}
     * @private
     */
    UserProfileComponent.prototype.sharedService;
    /**
     * @type {?}
     * @private
     */
    UserProfileComponent.prototype.userValidator;
    /**
     * @type {?}
     * @private
     */
    UserProfileComponent.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/layout/layout.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LayoutService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
        // Exposed field and private subject for when module groups change.
        this.userModuleGroups = null;
        this.userModuleGroupsChange = new Subject$1();
        // Create a subscriber for when preferences change.
        this.userModuleGroupsChange.subscribe((/**
         * @param {?} moduleGroups
         * @return {?}
         */
        (moduleGroups) => {
            this.userModuleGroups = moduleGroups;
        }));
    }
    /**
     * Gets all module groups for the current user.
     * @return {?}
     */
    getModuleGroupsForUser() {
        return this.http.get(`./Api/Admin/GetModuleGroupsForUser/`).map((/**
         * @param {?} moduleGroups
         * @return {?}
         */
        moduleGroups => {
            // Notify the subject that the module groups have changed.
            this.userModuleGroupsChange.next(moduleGroups);
        }));
    }
}
LayoutService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
LayoutService.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /** @type {?} */
    LayoutService.prototype.userModuleGroups;
    /**
     * @type {?}
     * @private
     */
    LayoutService.prototype.userModuleGroupsChange;
    /**
     * @type {?}
     * @private
     */
    LayoutService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/projects-jobs/jobs/jobs.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class JobsComponent {
    /**
     * @param {?} layoutService
     * @param {?} menuService
     * @param {?} router
     * @param {?} projectsJobsService
     * @param {?} fb
     * @param {?} translatePipe
     * @param {?} cdRef
     */
    constructor(layoutService, menuService, router, projectsJobsService, fb, translatePipe, cdRef) {
        this.layoutService = layoutService;
        this.menuService = menuService;
        this.router = router;
        this.projectsJobsService = projectsJobsService;
        this.fb = fb;
        this.translatePipe = translatePipe;
        this.cdRef = cdRef;
        this.editingJobDataOnChange = new EventEmitter();
        this.cloneDeep = cloneDeep_;
        this._editingJob = false;
        this.projects = [];
        this.jobs = [];
        this.selectedJob = new Job();
        this.selectedJobIndex = 0;
        this.accessibleModules = [];
        this.jobStatuses = [];
        this.jobStatus = new JobStatus();
        this.areJobsLoaded = false;
        this.isSuccess = false;
        this.alertVisible = false;
        this.formSubmitted = false;
        this.rowsSel = [];
        this.selected = [];
        this.moduleGroupsForUser = [];
        this.availableModuleListItems = [];
        this.jobHasModuleAccess = false;
        // Initialise Form controls
        this.jobName = new FormControl('', [Validators.required]);
        this.customerName = new FormControl('');
        this.plantOwner = new FormControl('');
        this.moduleId = new FormControl('', [Validators.required]);
        this.jobStatusId = new FormControl('');
        this.productName = new FormControl('');
        this.created = new FormControl('');
        // Initialise Form Group
        this.jobsForm = this.fb.group({
            jobName: this.jobName,
            customerName: this.customerName,
            plantOwner: this.plantOwner,
            moduleId: this.moduleId,
            jobStatusId: this.jobStatusId,
            productName: this.productName,
            created: this.created,
        }, { updateOn: "change" });
        // Listen to jobsForm isDirty changes to signal parent via event emitter that this component is in 'edit' mode.
        // This is the current mechanism for detecting a user has edited the form, otherwise we need a button to enter edit mode.
        this.jobsForm.valueChanges.subscribe((/**
         * @param {?} value
         * @return {?}
         */
        (value) => {
            if (this.jobsForm.dirty && !this.jobName.disabled && !this.editingJob) {
                console.log('jobsForm dirty - yes: ', value);
                this.editingJobDataOnChange.emit(true);
            }
        }));
    }
    /**
     * @return {?}
     */
    get selectedProjectId() {
        return this._selectedProjectId;
    }
    /**
     * @param {?} selectedProjectId
     * @return {?}
     */
    set selectedProjectId(selectedProjectId) {
        console.log('JobsComponent set selectedProjectId() prev value: ', this._selectedProjectId);
        // Set selectedProjectId and use subjects job data:
        // If(not editing a Job) or(not editing a project) or(editing a job AND editing a project),
        // which seems odd but is a required condition for empty projects.
        if ((!this.editingJob || !this.editingProject) || (this.editingJob && this.editingProject)) {
            console.log('JobsComponent set selectedProjectId() got selectedProjectId: ', selectedProjectId);
            this._selectedProjectId = selectedProjectId;
            this.selectedJobIndex = 0;
            this.getSubjectUpdatedJobsData();
        }
    }
    /**
     * @return {?}
     */
    get editingProject() {
        return this._editingProject;
    }
    /**
     * @param {?} editingProject
     * @return {?}
     */
    set editingProject(editingProject) {
        console.log('JobsComponent set editingProject() prev value: ', this._editingProject);
        console.log('JobsComponent set editingProject() got editingProject: ', editingProject);
        this._editingProject = editingProject;
        ////this.cdRef.detectChanges();
        if (this.editingProject || this.editingJob || this.jobsForm.dirty || (!this.selectedProjectId)
            || (!!this.jobs && this.jobs.length < 1)) {
            this.disableFormInputControls();
        }
        else {
            this.enableFormInputControls();
        }
    }
    /**
     * @return {?}
     */
    get editingJob() { return this._editingJob || this._editingProject; }
    /**
     * @param {?} editingJob
     * @return {?}
     */
    set editingJob(editingJob) {
        this._editingJob = editingJob;
        this.editingJobDataOnChange.emit(editingJob);
    }
    /**
     * @return {?}
     */
    get jobsBackingData() {
        if (!!this.selectedProjectId) {
            /** @type {?} */
            let project = this.projectsJobsService.projectsJobs.projects.find((/**
             * @param {?} p
             * @return {?}
             */
            p => p.id === this.selectedProjectId));
            if (!!project && !!project.jobs) {
                return this.projectsJobsService.projectsJobs.projects.find((/**
                 * @param {?} p
                 * @return {?}
                 */
                p => p.id === this.selectedProjectId)).jobs;
            }
            else { // couldn't find the project, no jobs defined        
                return [];
            }
        }
        else {
            this.jobs = []; // project does not exist, create empty jobs array
            return this.jobs;
        }
    }
    /**
     * @param {?} jobs
     * @return {?}
     */
    set jobsBackingData(jobs) {
        this.projectsJobsService.projectsJobs.projects.find((/**
         * @param {?} p
         * @return {?}
         */
        p => p.id === this.selectedProjectId)).jobs = jobs;
        // Assign the new users to the subject.
        this.projectsJobsService.projectJobsChange.next(this.projectsJobsService.projectsJobs);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.getJobsData(); // first get data
        // Call the service for module groups and module
        this.layoutService.getModuleGroupsForUser().subscribe((/**
         * @return {?}
         */
        () => {
            // Filter the menu items so that only the assigned modules are shown.
            //const sizingModuleMenuItems = menu.getMenu().filter(mu => mu.isSidebarNav === true && this.userModuleGroups.findIndex(moduleGroup => moduleGroup.masterTextKey === mu.text) > -1);
            this.moduleGroupsForUser = this.cloneDeep(this.layoutService.userModuleGroups);
            // User Data Sync not happened or the user is not setup correctly
            if (!!this.moduleGroupsForUser) {
                // Build internal moduleGroup combined with modules for the UI list binding
                this.moduleGroupsForUser.forEach((/**
                 * @param {?} mg
                 * @return {?}
                 */
                mg => {
                    mg.modules.forEach((/**
                     * @param {?} m
                     * @return {?}
                     */
                    m => {
                        /** @type {?} */
                        let moduleListItem = {
                            moduleGroupId: m.moduleGroupId,
                            moduleGroupMasterTextKey: mg.masterTextKey,
                            moduleId: m.id,
                            moduleMasterTextKey: m.masterTextKey
                        };
                        this.availableModuleListItems.push(moduleListItem);
                    }));
                }));
            }
            // Is this moduleId for this Job accessible?
            if (!!this.selectedJob && !!this.selectedJob.moduleId) {
                this.jobHasModuleAccess = (!!this.availableModuleListItems.find((/**
                 * @param {?} m
                 * @return {?}
                 */
                m => m.moduleId === this.selectedJob.moduleId)) || !this.selectedJob.moduleId) ? true : false;
            }
        })); // end of getModuleGroupsForUser().subscribe
        this.projectsJobsService.getAllJobStatuses().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            this.jobStatuses = data.jobStatuses;
        }));
        // subject subscription, update as service data has changed (probably changed in memory)
        this.projectsJobsService.projectJobsChange.subscribe((/**
         * @return {?}
         */
        () => {
            this.getSubjectUpdatedJobsData();
        }));
    }
    /**
     * @return {?}
     */
    getJobsData() {
        // Avoid double call for P&J data. The parent component has already called for the data.
        this.areJobsLoaded = true;
        //this.areJobsLoaded = false;
        //this.projectsJobsService.getProjectsAndJobs().subscribe(() => {
        //  // Inform the view that areProjectsAndJobs are now loaded.
        //  this.areJobsLoaded = true;
        //  this.selectedJobIndex = 0;
        //});
    }
    /**
     * @return {?}
     */
    getSubjectUpdatedJobsData() {
        this.jobs = this.cloneDeep(this.jobsBackingData);
        if (!this.jobsBackingData) {
            this.jobsBackingData = [];
        }
        if (!this.jobs) {
            this.jobs = [];
        }
        // Inform the view that areProjectsAndJobs are now loaded.
        this.areJobsLoaded = true;
        this.setupCleanSelectedJob(this.selectedJobIndex);
    }
    /**
     * Set the form controls for the currently selected job
     * @param {?} jobIndex
     * @return {?}
     */
    setupCleanSelectedJob(jobIndex) {
        if (!this.areJobsLoaded && !this.editingJob && !this.jobsForm.dirty) {
            return;
        }
        this.selectedJobIndex = jobIndex;
        this.jobsForm.reset();
        // Set requested job on the form control, if it exists.
        if (!!this.jobs && !!this.jobs[jobIndex] && jobIndex > -1) {
            this.enableFormInputControls();
            this.selectedJob = this.jobs[jobIndex];
            this.jobName.setValue(this.selectedJob.name);
            this.plantOwner.setValue(this.selectedJob.plantOwner);
            this.moduleId.setValue(this.selectedJob.moduleId);
            this.jobStatusId.setValue(this.selectedJob.jobStatusId);
            this.productName.setValue(this.selectedJob.productName);
            this.created.setValue(this.selectedJob.created);
            if (!!this.jobStatuses && this.jobStatuses.length > 0 && this.selectedJob.jobStatusId > 0) {
                //Setup Job Status
                this.jobStatus = this.jobStatuses.find((/**
                 * @param {?} s
                 * @return {?}
                 */
                s => s.id === this.selectedJob.jobStatusId));
            }
        }
        else {
            this.disableFormInputControls();
            // Clear and disable UI form controls
            this.selectedJob = new Job();
            this.jobName.setValue("");
            this.customerName.setValue("");
            this.plantOwner.setValue("");
            this.moduleId.setValue("");
            this.jobStatusId.setValue("");
            this.productName.setValue("");
            this.created.setValue(new Date().toLocaleDateString());
        }
        // Is this moduleId for this Job accessible?
        this.jobHasModuleAccess = (!!this.availableModuleListItems.find((/**
         * @param {?} m
         * @return {?}
         */
        m => m.moduleId === this.selectedJob.moduleId)) || !this.selectedJob.moduleId) ? true : false;
        // Set UI selected item  //if (!!this.selected && this.selected.length > 0) {
        this.selected.splice(0, this.selected.length);
        this.selected.push(this.selectedJob);
        this.jobsForm.markAsPristine();
        this.editingJob = false; // Important to set this here!
    }
    /**
     * Disable the Form input Controls
     * @return {?}
     */
    disableFormInputControls() {
        this.jobName.disable();
        this.customerName.disable();
        this.plantOwner.disable();
        this.productName.disable();
        this.created.disable();
        this.moduleId.disable(); // normally not editable unless creating a new job 
        this.jobStatusId.disable(); // always readonly
    }
    /**
     * Enable the Form input Controls
     * @return {?}
     */
    enableFormInputControls() {
        this.jobName.enable();
        this.customerName.enable();
        this.plantOwner.enable();
        this.productName.enable();
        this.created.enable();
        this.moduleId.disable();
        this.jobStatusId.disable();
    }
    /**
     * Add New job Setup
     * @return {?}
     */
    newJob() {
        console.log("newJob()");
        // block new if already have a new job or
        // ToDo: block an edited job
        if (this.editingJob) { //!this.selectedJob.id || this.selectedJob.id.toString() === "") {
            console.log("blocked, already editingJob...");
            return;
        }
        /** @type {?} */
        let newJob = new Job();
        newJob.id = "";
        newJob.projectId = this.selectedProjectId;
        newJob.jobStatusId = 1;
        if (!this.jobsBackingData) {
            this.jobsBackingData = [];
        }
        if (!this.jobs) {
            this.jobs = [];
        }
        this.jobsBackingData.push(newJob);
        this.jobs.push(newJob);
        this.selectedJobIndex = this.jobs.length - 1;
        this.setupCleanSelectedJob(this.selectedJobIndex); // also sets editingJob = false 
        this.jobNameInput.nativeElement.focus();
        this.editingJob = true;
        // enable module selection list change
        this.moduleId.enable();
    }
    /**
     * Cancel data edits for newly added job or revert any UI edits.
     * @return {?}
     */
    cancelEditsForJob() {
        console.log("cancelEditsForJob()");
        //ToDo: Any edits? warn user before data purge.
        if (this.editingJob) {
            // Remove edited new job
            console.log("Canceled new job edits!");
            this.jobsBackingData.pop();
            this.jobs.pop();
            this.selectedJobIndex = 0;
            this.setupCleanSelectedJob(this.selectedJobIndex);
        }
        else if (this.jobsForm.dirty) {
            // Cancel/revert Edited Job data
            this.setupCleanSelectedJob(this.selectedJobIndex);
        }
        // set page
        this.table.offset = this.selectedJobIndex / this.table.limit;
        this.editingJob = false;
    }
    /**
     * Checks and Submits the form for saving to the server.
     * @param {?} newJobName
     * @param {?} jobId
     * @return {?}
     */
    checkJobNameDuplication(newJobName, jobId) {
        console.log("checkJobNameDuplication()");
        if (this.jobsBackingData.find((/**
         * @param {?} x
         * @return {?}
         */
        x => x.name === newJobName && jobId === ''))) {
            /** @type {?} */
            const title = this.translatePipe.transform('DUPLICATE_JOB_NAME', true);
            /** @type {?} */
            const text = this.translatePipe.transform('A_JOB_WITH_THE_SAME_NAME_EXISTS_IN_THIS_PROJECT_CLICK_YES_TO_SAVE_ANYWAY_OR_NO_TO_CHANGE_THE_NAME_OF_THE_JOB_YOU_ARE_SAVING_MESSAGE', true);
            /** @type {?} */
            const saveDuplicateProject = this.translatePipe.transform("YES", true);
            /** @type {?} */
            const cancelButtonText = this.translatePipe.transform("NO", true);
            return swal({
                title: title,
                text: text,
                icon: "warning",
                dangerMode: true,
                buttons: [saveDuplicateProject, cancelButtonText]
            }).then((/**
             * @param {?=} discardChanges
             * @return {?}
             */
            (discardChanges) => {
                // The parameter can also enter as null
                /** @type {?} */
                const returnVal = !(discardChanges === null);
                if (!returnVal) {
                    // Go ahead and save anyway
                    console.log("Saving Job with duplicated name.");
                    this.updateInsertJob();
                }
            }));
        }
        else {
            this.updateInsertJob();
        }
    }
    /**
     * @return {?}
     */
    updateInsertJob() {
        console.log(`updateInsertJob`);
        // Mark the form as submitted.
        this.formSubmitted = true;
        this.getProjectFormData();
        // Save job data, Insert or Update?
        if (this.selectedJob.id === "") {
            this.projectsJobsService.insertJob(this.selectedJob).subscribe((/**
             * @param {?} insertedJobData
             * @return {?}
             */
            insertedJobData => {
                this.selectedJob = insertedJobData.job;
                this.jobsBackingData[this.jobsBackingData.length - 1] = this.selectedJob; // update inserted job data  
                this.jobs[this.selectedJobIndex] = this.selectedJob; // change UI row data
                // Refresh UI grid
                this.table.rows = this.jobs;
                // set page
                this.table.offset = this.selectedJobIndex / this.table.limit;
                // The form can be submitted again.
                this.formSubmitted = false;
                // Set the operation based on the response.
                this.isSuccess = insertedJobData.succeeded;
                this.alertVisible = true;
                this.editingJob = false;
                // Select last/newly added job
                this.setupCleanSelectedJob(this.jobs.length - 1);
                this.projectsJobsService.signalProjectsAndJobsDataHasChanged(this.projectsJobsService.projectsJobs); // send change event to all subject subcribers
            }));
        }
        else {
            this.projectsJobsService.updateJob(this.selectedJob).subscribe((/**
             * @param {?} updatedJobData
             * @return {?}
             */
            (updatedJobData) => {
                this.selectedJob = updatedJobData.job;
                this.jobsBackingData[this.selectedJobIndex] = this.selectedJob; // send change event to all subject subcribers
                this.jobs[this.selectedJobIndex] = this.selectedJob; // change UI row data
                // Refresh UI grid
                this.table.rows = this.jobs;
                // set page
                this.table.offset = this.selectedJobIndex / this.table.limit;
                // The form can be submitted again.
                this.formSubmitted = false;
                // Set the operation based on the response.
                this.isSuccess = updatedJobData.succeeded;
                this.alertVisible = true;
                this.setupCleanSelectedJob(this.selectedJobIndex);
                this.projectsJobsService.signalProjectsAndJobsDataHasChanged(this.projectsJobsService.projectsJobs); // send change event to all subject subcribers
                //this.editingJob = true; // toggle to force change
                this.editingJob = false;
            }));
        }
    }
    /**
     * Delete currently selected job
     * @return {?}
     */
    deleteJob() {
        console.log("deleteJob()");
        if (!this.selectedJob.id) {
            console.log("deleteJob() but no job id? Do nothing.");
            return;
        }
        this.projectsJobsService.deleteJob(this.selectedJob).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            if (response) {
                /** @type {?} */
                let indexToDelete = this.jobs.indexOf(this.selectedJob);
                // ToDo: Delete job from UI, move to first/previous/blank job?
                // Removeproject from list
                this.jobsBackingData.splice(indexToDelete, 1);
                this.projects.splice(indexToDelete, 1);
                // Refresh UI grid
                this.table.rows = this.projects;
                // Select page
                this.table.offset = this.selectedJobIndex / this.table.limit;
                if (this.jobsBackingData.length > 0 ||
                    this.jobsBackingData.length <= this.selectedJobIndex) {
                    if (this.jobsBackingData.length <= this.selectedJobIndex) { // if we deleted the last project
                        this.selectedJobIndex = this.jobsBackingData.length - 1;
                    }
                }
                else {
                    this.selectedJobIndex = -1;
                }
                this.setupCleanSelectedJob(this.selectedJobIndex);
                // The form can be submitted again.
                this.formSubmitted = false;
                this.editingJob = false;
                //this.alertVisible = true;
                this.projectsJobsService.signalProjectsAndJobsDataHasChanged(this.projectsJobsService.projectsJobs); // send change event to all subject subcribers
            }
            else {
                //failed!
            }
        }));
    }
    /**
     * Open currently selected job
     * @return {?}
     */
    openJob() {
        console.log("openJob()");
        if (!this.selectedJob.id) {
            console.log("openJob() but no job id? Do nothing.");
            return;
        }
        /** @type {?} */
        let moduleGroupNameMasterKeyText;
        if (!!this.availableModuleListItems.find((/**
         * @param {?} m
         * @return {?}
         */
        m => m.moduleId === this.selectedJob.moduleId))) {
            moduleGroupNameMasterKeyText = this.availableModuleListItems.find((/**
             * @param {?} m
             * @return {?}
             */
            m => m.moduleId === this.selectedJob.moduleId)).moduleGroupMasterTextKey;
            /** @type {?} */
            const url = this.menuService.menuItems.find((/**
             * @param {?} mu
             * @return {?}
             */
            mu => mu.text === moduleGroupNameMasterKeyText)).link;
            // ToDo: note that when navigating like this, we loose the Title layout translation of the sizing module.
            // Plus params are lost and undefine in the sizing module for the ActiveRoute.
            //this.router.navigate([url], { queryParams: { projectId: this.selectedJob.projectId, jobId: this.selectedJob.id } });
            this.router.navigate([url, this.selectedJob.projectId, this.selectedJob.id]);
        }
        else {
            // Please select a module ofr this job!
            // or User doesn't have module access.
            //Todo: Raise UI error.
        }
    }
    /**
     * Load next job in the UI job data (respecting sort order)
     * @return {?}
     */
    loadNextJob() {
        console.log("loadNextJob()");
        if (this.selectedJobIndex < this.jobs.length - 1) {
            this.setupCleanSelectedJob(this.jobs.indexOf(this.selectedJob) + 1);
            // Refresh UI grid
            this.table.rows = this.jobs;
            // set page
            this.table.offset = this.selectedJobIndex / this.table.limit;
        }
    }
    /**
     * Load previous job in the UI job data (respecting sort order)
     * @return {?}
     */
    loadPreviousJob() {
        console.log("loadPreviousJob()");
        if (this.selectedJobIndex > 0) {
            this.setupCleanSelectedJob(this.jobs.indexOf(this.selectedJob) - 1);
            // Refresh UI grid
            this.table.rows = this.jobs;
            // set page
            this.table.offset = this.selectedJobIndex / this.table.limit;
        }
    }
    /**
     * Data table selection changed
     * @param {?} __0
     * @return {?}
     */
    onSelect({ selected }) {
        console.log('Select Event', selected, this.selected);
        // If editingJob/changing data then don't move away from the currently selected job
        if (this.editingJob || this.jobsForm.dirty) {
            selected = this.selectedJob;
            // Refresh UI grid
            this.table.rows = this.jobs;
            // set page
            this.table.offset = this.selectedJobIndex / this.table.limit;
            return;
        }
        if (!this.editingJob && !this.jobsForm.dirty) {
            this.setupCleanSelectedJob(this.jobs.indexOf(selected[0])); // also sets the Slected job array
        }
    }
    /**
     * Data table events
     * @param {?} event
     * @return {?}
     */
    onActivate(event) {
        //console.log('Activate Event', event);
        // If editingJob/changing data then don't move away from the currently selected job
        if (this.editingJob || this.jobsForm.dirty) {
            // Refresh UI grid
            this.table.rows = this.jobs;
            // set page
            this.table.offset = this.selectedJobIndex / this.table.limit;
            return;
        }
        // handle arrow key change for selected job
        if (event.type === "keydown" && event.event.code === "ArrowDown") {
            this.loadNextJob();
        }
        if (event.type === "keydown" && event.event.code === "ArrowUp") {
            this.loadPreviousJob();
        }
    }
    /**
     * Handle paging
     * @param {?} event
     * @return {?}
     */
    onPage(event) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout((/**
         * @return {?}
         */
        () => {
            console.log('paged!', event);
        }), 100);
        // If editingJob/changing data then don't move away from the currently selected job
        if (this.editingJob || this.jobsForm.dirty) {
            // Refresh UI grid
            this.table.rows = this.jobs;
            // set page
            this.table.offset = this.selectedJobIndex / this.table.limit;
            return;
        }
        /** @type {?} */
        var indexOfPageTopJob = event.pageSize * event.offset;
        this.setupCleanSelectedJob(indexOfPageTopJob);
    }
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    onPaginated(event) {
        //this.table.limit = this._limitNumber;
        this.table.recalculate();
    }
    /**
     * Updates the filteed rows on UI data grid.
     * @param {?} event
     * @return {?}
     */
    updateFilter(event) {
        /** @type {?} */
        const val = event.target.value.toLowerCase();
        // filter our data
        /** @type {?} */
        const rowsFiltered = this.jobsBackingData.filter((/**
         * @param {?} d
         * @return {?}
         */
        function (d) {
            // Test if the Name  is like the filter text
            if (!!d.name) {
                if (d.name.toLowerCase().indexOf(val) !== -1 || !val) {
                    return true;
                }
            }
            if (!!d.plantOwner) {
                if (d.plantOwner.toLowerCase().indexOf(val) !== -1 || !val) {
                    return true;
                }
            }
            if (!!d.productName) {
                if (d.productName.toLowerCase().indexOf(val) !== -1 || !val) {
                    return true;
                }
            }
        }));
        // update the rows
        this.jobs = rowsFiltered;
        // Whenever the filter changes, always go back to the first page
        this.table.offset = 0;
        this.selectedJobIndex = 0;
        this.setupCleanSelectedJob(this.selectedJobIndex);
    }
    /**
     * Get the job data Form the input Controls
     * @return {?}
     */
    getProjectFormData() {
        /** @type {?} */
        const jobName = this.jobsForm.controls["jobName"];
        this.selectedJob.name = jobName.value;
        /** @type {?} */
        const plantOwner = this.jobsForm.controls["plantOwner"];
        this.selectedJob.plantOwner = plantOwner.value;
        /** @type {?} */
        const jobStatusId = this.jobsForm.controls["jobStatusId"];
        this.selectedJob.jobStatusId = jobStatusId.value;
        /** @type {?} */
        const moduleId = this.jobsForm.controls["moduleId"];
        this.selectedJob.moduleId = moduleId.value;
    }
    /**
     * @return {?}
     */
    closeAlert() {
        // Reset the flag
        this.alertVisible = false;
    }
    /**
     * @return {?}
     */
    debugToggleEnableModuleId() {
        if (isDevMode) {
            //This was causing irregular behaviour in ddev and test environment. 
            // if (this.moduleId.enabled) { this.moduleId.disable(); } else { this.jobHasModuleAccess = true; this.moduleId.enable();}
        }
    }
    /**
     * @return {?}
     */
    modalCallbackCancel() {
        console.log("Modal cancel button, do nothing!");
    }
    /**
     * @return {?}
     */
    modalCallbackOk() {
        console.log("Oh look, it's OK'd without this function calling anything!!");
    }
    /**
     * @return {?}
     */
    showLastExported() {
        // If the date is valid and not default for new Date (ie. was null on the Job header record) then display the date on the UI.
        if (this.selectedJob && this.selectedJob.lastExported && this.selectedJob.lastExported !== null) {
            return true;
        }
        return false;
    }
}
JobsComponent.decorators = [
    { type: Component, args: [{
                selector: 'jobs',
                exportAs: 'jobs',
                template: "<form [formGroup]=\"jobsForm\" class=\"form-horizontal\" role=\"form\" novalidate>\r\n  <div class='panel panel-primary' *ngIf=\"!!areJobsLoaded\">\r\n    <div class='panel-body'>\r\n      <div class=\"row\">\r\n\r\n        <div class=\"col-xs-12\">\r\n          <h4>{{\"JOBS\" | translate}}</h4>\r\n          <hr />\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-3 col-xs-12\">\r\n\r\n          <div class=\"form-group\">\r\n            <div class=\"col-xs-3\">\r\n              <label class=\"control-label\">{{\"FILTER\" | translate:true}}</label>\r\n            </div>\r\n            <div class=\"col-xs-6\">\r\n              <input autocomplete=\"off\" [disabled]=\"editingProject || editingJob || jobsForm.dirty\" type='text' title=\"{{'TYPE_TO_FILTER' | translate:true}}\" class=\"form-control\" placeholder=\"{{'TYPE_TO_FILTER' | translate:true}}...\"  (keyup)='updateFilter($event)' />\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"col-md-6 col-xs-12\">\r\n          <button id=\"openJob\" \t[disabled]=\"editingProject || editingJob || jobsForm.dirty || (!!this.selectedJob && !this.selectedJob.id) || !jobHasModuleAccess\" class=\"btn btn-jobs btn-primary pull-left\" (click)=\"openJob()\" [title]=\"'OPEN_JOB' | translate\"><p id=\"noMargins\"><i class=\"fa fa-folder-open\"></i>  {{'OPEN_JOB' | translate}}</p></button>\r\n          <button id=\"newJob\" \t[disabled]=\"editingProject || editingJob || jobsForm.dirty || (!selectedProjectId)\" class=\"btn btn-jobs btn-primary pull-left\" (click)=\"newJob()\" [title]=\"'ADD_NEW_JOB' | translate\"><p id=\"noMargins\"><i class=\"fa fa-plus\"></i>  {{'ADD_NEW_JOB' | translate}}</p></button>\r\n          <button id=\"saveJob\" \t[disabled]=\"editingProject || !jobsForm.dirty || !jobsForm.valid || jobsForm.status !== 'VALID' || formSubmitted\" class=\"btn btn-jobs btn-primary pull-left\" (click)=\" checkJobNameDuplication(jobName.value, selectedJob.id)\" [title]=\"'SAVE_JOB' | translate\"><p id=\"noMargins\"><i class=\"fa fa-save\"></i>  {{'SAVE_JOB' | translate}}</p></button>\r\n          <button id=\"cancelEditJob\" \t[disabled]=\"editingProject || (!editingJob && !jobsForm.dirty)\" class=\"btn btn-jobs btn-primary pull-left\" (click)=\"(jobsForm.dirty && jobsForm.valid)? saveChangesModal.open() : cancelEditsForJob()\" [title]=\"'CANCEL' | translate\"><p id=\"noMargins\"><i class=\"fa fa-times\"></i>  {{'CANCEL' | translate}}</p></button>\r\n          <button id=\"deleteJob\" \t[disabled]=\"editingProject || editingJob || jobsForm.dirty || (!!this.selectedJob && !this.selectedJob.id)\" class=\"btn btn-jobs btn-primary pull-left\" (click)=\"delteConfirmationModal.open()\" [title]=\"'DELETE_JOB' | translate\"><p id=\"noMargins\"><i class=\"fa fa-trash\"></i>  {{'DELETE_JOB' | translate}}</p></button>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <!-- Left section -->\r\n        <div class=\"col-md-3 col-xs-12\">\r\n          <!-- If User starts editing the job form, then marked as \"jobsForm.dirty\" and load disabled Jobs List (code below) other wise load active Jobs List from code section tha starts at line 52+-) -->\r\n          <!-- Note that rowIndex is not sort safe, use rows[rows.indexOf(row)] for the real index of the row data. -->\r\n          <ngx-datatable *ngIf=\"jobsForm.dirty\" class=\"bootstrap\" style=\"opacity: 0.4; pointer-events:none; font-size: larger; font-weight: lighter\" [selected]=\"selected\" [selectionType]=\"'singleClick'\" (activate)=\"onActivate($event)\" (select)=\"onSelect($event)\" [headerHeight]=\"40\" [limit]=\"6\" [columnMode]=\"'force'\" [footerHeight]=\"60\" [rowHeight]=\"'auto'\" [rows]=\"jobs\" (page)=\"onPage($event)\" [messages]=\"{emptyMessage: translatePipe.transform('NO_DATA_TO_DISPLAY', true), totalMessage: translatePipe.transform('TOTAL', true), selectedMessage: false}\" #jobsTable>\r\n            <ngx-datatable-column class=\"\" headerClass=\"text-bold\" style=\"\" name=\"{{'JOB_NAME' | translate}}\" prop=\"name\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\" maxWidth=\"100px\" let->\r\n                <div>\r\n                  <span title=\"{{'JOB_NAME' | translate:true}}\">\r\n                    {{value}}\r\n                  </span>\r\n                </div>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n          </ngx-datatable>\r\n\r\n          <!-- If User IS NOT editing the job form, then marked as\"!jobsForm.dirty\" and load Jobs List other wise load inactive Jobs List from code above-->\r\n          <!-- Note that rowIndex is not sort safe, use rows[rows.indexOf(row)] for the real index of the row data. -->\r\n          <ngx-datatable *ngIf=\"!jobsForm.dirty\" class=\"bootstrap\" style=\"font-size: larger; font-weight: lighter\" [selected]=\"selected\" [selectionType]=\"'singleClick'\" (activate)=\"onActivate($event)\" (select)=\"onSelect($event)\" [headerHeight]=\"40\" [limit]=\"6\" [columnMode]=\"'force'\" [footerHeight]=\"60\" [rowHeight]=\"'auto'\" [rows]=\"jobs\" (page)=\"onPage($event)\" [messages]=\"{emptyMessage: translatePipe.transform('NO_DATA_TO_DISPLAY', true), totalMessage: translatePipe.transform('TOTAL', true), selectedMessage: false}\" #jobsTable>\r\n            <ngx-datatable-column class=\"\" headerClass=\"text-bold\" style=\"\" name=\"{{'JOB_NAME' | translate}}\" prop=\"name\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\" maxWidth=\"100px\" let->\r\n                <div>\r\n                  <span title=\"{{'JOB_NAME' | translate:true}}\">\r\n                    {{value}}\r\n                  </span>\r\n                </div>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n          </ngx-datatable>\r\n        </div> <!-- end of data table -->\r\n        <!-- fields section -->\r\n        <div class=\"col-md-9 col-xs-12\">\r\n\r\n          <div class=\"row\">\r\n\r\n            <!-- Left hand controls -->\r\n            <div class=\"col-xs-12 col-md-6\">\r\n\r\n              <!-- Job Name -->\r\n              <div class=\"form-group\">\r\n                <div class=\"col-xs-3 text-right\">\r\n                  <label class=\"control-label\">{{\"JOB_NAME\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-6\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"text\" formControlName=\"jobName\" #jobName value=\"selectedJob.name\" />\r\n                    <span class=\"text-danger\" *ngIf=\"jobsForm.controls['jobName'].hasError('required') && (jobsForm.controls['jobName'].dirty || jobsForm.controls['jobName'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- Plant Owner -->\r\n              <div class=\"form-group\">\r\n                <div class=\"col-xs-3 text-right\">\r\n                  <label class=\"control-label\">{{\"PLANT_OWNER\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-6\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"text\" formControlName=\"plantOwner\" value=\"selectedJob.plantOwner\" />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- Job Created -->\r\n              <div class=\"form-group\">\r\n                <div class=\"col-xs-3 text-right\">\r\n                  <label class=\"control-label\">{{\"JOB_DATE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-6\">\r\n                  <div class=\"input-group\">\r\n                    <label class=\"control-label\">{{selectedJob.created | date:'fullDate'}} {{selectedJob.created | date:'shortTime'}}</label>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- Job LastExported -->\r\n              <div *ngIf=\"showLastExported()\" class=\"form-group\">\r\n                <div class=\"col-xs-3 text-right\">\r\n                  <label class=\"control-label\">{{\"LAST_EXPORTED\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-6\">\r\n                  <div class=\"input-group\">\r\n                    <label class=\"control-label\">{{selectedJob.lastExported | date:'fullDate'}} {{selectedJob.lastExported | date:'shortTime'}}</label>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- End of Left hand controls -->\r\n            </div>\r\n\r\n\r\n\r\n            <!-- Right hand controls -->\r\n            <div class=\"col-xs-12 col-md-6\" (dblclick)=\"debugToggleEnableModuleId()\">\r\n\r\n              <!-- Product Range List (Sizing Module) -->\r\n              <div class=\"form-group\">\r\n                <div class=\"col-xs-3 text-right\">\r\n                  <label class=\"control-label\">{{\"PRODUCT_RANGE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-6\">\r\n                  <select *ngIf=\"jobHasModuleAccess\" class=\"form-control\" formControlName=\"moduleId\" id=\"moduleId\" name=\"moduleMasterTextKey\">\r\n                    <option *ngFor=\"let module of availableModuleListItems\" [value]=\"module.moduleId\">        <!-- [selected]=\"module.moduleId\">-->\r\n                      {{module.moduleGroupMasterTextKey | translate}} - {{module.moduleMasterTextKey | translate}}\r\n                    </option>\r\n                  </select>\r\n                  <label *ngIf=\"!jobHasModuleAccess\" class=\"text-danger\">{{\"YOU_DO_NOT_HAVE_ACCESS_TO_THIS_MODULE\" | translate}}</label>\r\n                  <span class=\"text-danger\" *ngIf=\"jobsForm.controls['moduleId'].hasError('required') && (jobsForm.controls['moduleId'].dirty || jobsForm.controls['moduleId'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- Sizing Satus -->\r\n              <div class=\"form-group\">\r\n                <div class=\"col-xs-3 text-right\">\r\n                  <label class=\"control-label\">{{\"SIZING_STATUS\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-6\">\r\n                  <select *ngIf=\"!!jobStatuses\" class=\"form-control\" formControlName=\"jobStatusId\" id=\"id\" name=\"masterTextKey\">\r\n                    <option *ngFor=\"let jobstatus of jobStatuses\" [value]=\"jobstatus.id\">{{jobstatus.masterTextKey | translate}}</option>\r\n                  </select>\r\n                  <!--<label *ngIf=\"!!jobStatuses\" class=\"control-label\">{ {jobStatus.masterTextKey | translate}}</label>-->\r\n                </div>\r\n              </div>\r\n\r\n              <!-- Product / Nomenclature -->\r\n              <div class=\"form-group\">\r\n                <div class=\"col-xs-3 text-right\">\r\n                  <label class=\"control-label\">{{\"PRODUCT_TEXT_DUPLICATE_ID_493\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-6\">\r\n                  <label class=\"control-label\">{{selectedJob.productName}}</label>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- End of Right hand controls -->\r\n            </div>\r\n            <!-- End of Row -->\r\n          </div>\r\n\r\n          <div>\r\n            <!-- Success confirmation message -->\r\n            <alert-block *ngIf=\"!!alertVisible && !!isSuccess\" type=\"success\" [auto-close]=\"true\" [message]=\"'JOBS_SAVED_SUCCESSFULLY_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n            <!-- Failure confirmation message-->\r\n            <alert-block *ngIf=\"!!alertVisible && !isSuccess\" type=\"danger\" [message]=\"'JOBS_FAILED_TO_SAVE_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n</form>\r\n\r\n\r\n<!-- Generic Modal Component -->\r\n<sizing-suite-modal #delteConfirmationModal\r\n                    (modal-cancel)=\"modalCallbackCancel()\"\r\n                    (modal-ok)=\"deleteJob()\"\r\n                    [modal-title]=\"'PROJECTS_AND_JOBS' | translate\"\r\n                    [modal-ok-text]=\"'DELETE_JOB' | translate\"\r\n                    [modal-ok-icon]=\"'fa fa-trash'\"\r\n                    [modal-cancel-text]=\"'CANCEL' | translate:true\"\r\n                    [modal-cancel-icon]=\"'fa fa-times'\">\r\n\r\n  <label class=\"control-label\">{{'DELETE_JOB' | translate}}: <strong>{{selectedJob.name}}</strong>?</label>\r\n</sizing-suite-modal>\r\n\r\n<!-- Generic Modal Component -->\r\n<sizing-suite-modal #saveChangesModal\r\n                    (modal-cancel)=\"cancelEditsForJob()\"\r\n                    (modal-ok)=\"updateInsertJob()\"\r\n                    [modal-title]=\"'PROJECTS_AND_JOBS' | translate\"\r\n                    [modal-ok-text]=\"'SAVE_JOB' | translate\"\r\n                    [modal-ok-icon]=\"'fa fa-save'\"\r\n                    [modal-cancel-text]=\"'DISCARD_CHANGES' | translate\"\r\n                    [modal-cancel-icon]=\"'fa fa-times'\">\r\n\r\n  <label class=\"control-label\">{{'SAVE_JOB' | translate}}: <strong>{{this.jobsForm.controls[\"jobName\"].value}}</strong>?</label>\r\n</sizing-suite-modal>\r\n\r\n",
                styles: [".btn-jobs{margin:0 2px}"]
            }] }
];
/** @nocollapse */
JobsComponent.ctorParameters = () => [
    { type: LayoutService },
    { type: MenuService },
    { type: Router },
    { type: ProjectsJobsService },
    { type: FormBuilder },
    { type: TranslatePipe },
    { type: ChangeDetectorRef }
];
JobsComponent.propDecorators = {
    editingJobDataOnChange: [{ type: Output, args: ['editingJobDataOnChange',] }],
    selectedProjectId: [{ type: Input, args: ['selectedProjectId',] }],
    editingProject: [{ type: Input, args: ['editingProject',] }],
    table: [{ type: ViewChild, args: [DatatableComponent, { static: false },] }, { type: ViewChild, args: ['jobsTable', { static: false },] }],
    jobNameInput: [{ type: ViewChild, args: ['jobName', { static: false },] }]
};
if (false) {
    /** @type {?} */
    JobsComponent.prototype.editingJobDataOnChange;
    /** @type {?} */
    JobsComponent.prototype.cloneDeep;
    /**
     * @type {?}
     * @private
     */
    JobsComponent.prototype._selectedProjectId;
    /**
     * @type {?}
     * @private
     */
    JobsComponent.prototype._editingProject;
    /**
     * @type {?}
     * @private
     */
    JobsComponent.prototype._editingJob;
    /** @type {?} */
    JobsComponent.prototype.table;
    /** @type {?} */
    JobsComponent.prototype.jobNameInput;
    /** @type {?} */
    JobsComponent.prototype.tableExp;
    /** @type {?} */
    JobsComponent.prototype.timeout;
    /** @type {?} */
    JobsComponent.prototype.projects;
    /** @type {?} */
    JobsComponent.prototype.jobs;
    /** @type {?} */
    JobsComponent.prototype.selectedJob;
    /** @type {?} */
    JobsComponent.prototype.selectedJobIndex;
    /** @type {?} */
    JobsComponent.prototype.accessibleModules;
    /** @type {?} */
    JobsComponent.prototype.jobsForm;
    /** @type {?} */
    JobsComponent.prototype.jobName;
    /** @type {?} */
    JobsComponent.prototype.customerName;
    /** @type {?} */
    JobsComponent.prototype.plantOwner;
    /** @type {?} */
    JobsComponent.prototype.moduleId;
    /** @type {?} */
    JobsComponent.prototype.jobStatusId;
    /** @type {?} */
    JobsComponent.prototype.productName;
    /** @type {?} */
    JobsComponent.prototype.created;
    /** @type {?} */
    JobsComponent.prototype.jobStatuses;
    /** @type {?} */
    JobsComponent.prototype.jobStatus;
    /** @type {?} */
    JobsComponent.prototype.areJobsLoaded;
    /** @type {?} */
    JobsComponent.prototype.isSuccess;
    /** @type {?} */
    JobsComponent.prototype.alertVisible;
    /** @type {?} */
    JobsComponent.prototype.formSubmitted;
    /** @type {?} */
    JobsComponent.prototype.rowsSel;
    /** @type {?} */
    JobsComponent.prototype.selected;
    /** @type {?} */
    JobsComponent.prototype.moduleGroupsForUser;
    /** @type {?} */
    JobsComponent.prototype.availableModuleListItems;
    /** @type {?} */
    JobsComponent.prototype.jobHasModuleAccess;
    /**
     * @type {?}
     * @private
     */
    JobsComponent.prototype.layoutService;
    /**
     * @type {?}
     * @private
     */
    JobsComponent.prototype.menuService;
    /**
     * @type {?}
     * @private
     */
    JobsComponent.prototype.router;
    /**
     * @type {?}
     * @private
     */
    JobsComponent.prototype.projectsJobsService;
    /**
     * @type {?}
     * @private
     */
    JobsComponent.prototype.fb;
    /** @type {?} */
    JobsComponent.prototype.translatePipe;
    /**
     * @type {?}
     * @private
     */
    JobsComponent.prototype.cdRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/projects-jobs/projects-jobs.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProjectsJobsModule {
}
ProjectsJobsModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule, NgxDatatableModule
                ],
                providers: [ProjectsJobsService, GenericChangesGuard],
                declarations: [ProjectsJobsComponent, JobsComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/syncClient/syncClient.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SyncClientModule {
}
SyncClientModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule
                ],
                providers: [SyncClientService],
                declarations: [SyncClientComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/user-profile/user-profile.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UserProfileModule {
}
UserProfileModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule
                ],
                providers: [GenericChangesGuard],
                declarations: [UserProfileComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/menu.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Defines the sizing module routes based on the specified type.
 * @param {?} type The route type.
 * @return {?}
 */
function sizingModuleRoutes(type) {
    if (!type) {
        return [];
    }
    /** @type {?} */
    let routePrefix = "";
    if (type === "sizingModule") {
        routePrefix = "/sizingModules/";
    }
    else if (type === "modulePreference") {
        routePrefix = "/admin/modulePreferences/";
    }
    else if (type === "moduleAccess") {
        routePrefix = "/admin/moduleAccess/";
    }
    /** @type {?} */
    const routes = [
        {
            text: "SAFETY_VALVES",
            link: `${routePrefix}safetyValves`,
            icon: "ssv2-safety-valve-white",
            isHeaderItem: false
        },
        {
            text: "CONTROL_VALVE",
            link: `${routePrefix}controlValve`,
            icon: "ssv2-control-valve-white",
            isHeaderItem: false
        },
        {
            text: "EASIHEAT",
            link: `${routePrefix}easiHeat`,
            icon: "ssv2-easiheat-white",
            isHeaderItem: false,
            displayOperatingCompany: false
        },
        {
            text: "EASIHEAT_GEN4",
            link: `${routePrefix}easiheatgen4`,
            icon: "ssv2-easiheat-white",
            isHeaderItem: false,
            displayOperatingCompany: false
        },
        {
            text: "FLOWMETER",
            link: `${routePrefix}flowmeter`,
            icon: "ssv2-flowmetering-white",
            isHeaderItem: false
        },
        {
            text: "PRESSURE_REDUCING_VALVE",
            link: `${routePrefix}pressureReducingValve`,
            icon: "ssv2-pressure-reducing-valve-white",
            isHeaderItem: false
        },
        {
            text: "SHELL_AND_TUBE",
            link: `${routePrefix}ShellAndTube`,
            icon: "ssv2-shell-tube-white",
            isHeaderItem: false
        },
        {
            text: "STEAM_GENERATION_ASSESSMENT",
            link: `${routePrefix}steamGenerationAssessment`,
            icon: "ssv2-steam-generation-efficiency-white",
            isHeaderItem: false
        },
        {
            text: "CLEAN_STEAM_GENERATOR",
            link: `${routePrefix}cleanSteamGenerator`,
            icon: "ssv2-csg-healthcare-white",
            isHeaderItem: false,
            displayOperatingCompany: false
        },
        {
            text: "CLEAN_STEAM_GENERATOR_FB",
            link: `${routePrefix}cleanSteamGeneratorFB`,
            icon: "ssv2-csg-fb-white",
            isHeaderItem: false,
            displayOperatingCompany: false
        }
    ];
    // Apply the appropriate flag on each property so that the menu system is rendered correctly.
    if (type === "sizingModule") {
        routes.forEach((/**
         * @param {?} r
         * @return {?}
         */
        r => {
            r["isSizingModule"] = true;
            r["isSidebarNav"] = true; // These routes appear on the side bar as well.
        }));
    }
    if (type === "modulePreference") {
        routes.forEach((/**
         * @param {?} r
         * @return {?}
         */
        r => {
            r["isModulePreference"] = true;
            r["displayOperatingCompany"] = true;
            r["subText"] = "MODULE_PREFERENCES";
        }));
    }
    else if (type === "moduleAccess") {
        routes.forEach((/**
         * @param {?} r
         * @return {?}
         */
        r => {
            r["isModuleAccess"] = true;
            r["displayOperatingCompany"] = true;
            r["subText"] = "MODULE_ACCESS";
        }));
    }
    return routes;
}
// Main Navigation Heading
/** @type {?} */
const headingMain = {
    text: 'MAIN_NAVIGATION',
    heading: true,
    isSidebarNav: true,
    isHeaderItem: false
};
// The Home page
/** @type {?} */
const home = {
    text: 'HOME',
    link: '/home',
    icon: 'ssv2-home-white',
    isSidebarNav: true,
    isHeaderItem: false
};
// The heading for sizing modules
/** @type {?} */
const sizingModuleHeaders = {
    text: 'SIZING_MODULES',
    heading: true,
    isSidebarNav: true,
    isHeaderItem: false
}
// The items for the administration section. These are not visible in the side-bar menu or the top header-bar.
;
// The items for the administration section. These are not visible in the side-bar menu or the top header-bar.
/** @type {?} */
const administrationItems = [
    {
        text: 'USER_FEEDBACK',
        link: '/userFeedback',
        icon: 'fa fa-comments',
        isSidebarNav: false,
        isHeaderItem: true
    },
    {
        text: 'SYNC_CLIENT',
        link: '/syncClient',
        icon: 'fa fa-exchange',
        isSidebarNav: false,
        isHeaderItem: true
    },
    {
        text: 'ADMINISTRATION_TASKS',
        link: '/admin',
        icon: 'fa fa-wrench',
        isSidebarNav: false,
        isHeaderItem: true,
        displayOperatingCompany: true
    },
    {
        text: 'PROJECTS_AND_JOBS',
        link: '/projectsJobs',
        icon: 'fa fa-file',
        isSidebarNav: false,
        isHeaderItem: true
    },
    {
        text: 'MY_PROFILE',
        link: '/profile',
        icon: 'fa fa-user',
        isSidebarNav: false,
        isHeaderItem: true
    },
    {
        text: 'MY_PREFERENCES',
        link: '/admin/preferences',
        icon: 'fa fa-cog',
        isSidebarNav: false,
        isHeaderItem: true
    },
    {
        text: "CURRENCY_INFORMATION",
        link: "/admin/currency"
    },
    {
        text: "OPERATING_COMPANY_PREFERENCES",
        subText: "HERE_YOU_CAN_SELECT_THE_DEFAULT_UNITS_OF_MEASURE_FOR_YOUR_OPERATING_COMPANY_USERS_MESSAGE",
        link: "/admin/operatingCompanyPreferences",
        displayOperatingCompany: true
    },
    {
        text: "MODULE_ACCESS",
        link: "/admin/moduleAccess",
        displayOperatingCompany: true
    },
    {
        text: "MODULE_PREFERENCES",
        link: "/admin/modulePreferences",
        displayOperatingCompany: true
    },
    {
        text: "PRODUCT_SELECTION",
        link: "/admin/productSelection",
        displayOperatingCompany: true
    }
];
/** @type {?} */
let menu = [
    headingMain,
    home,
    sizingModuleHeaders
];
// Concatenate any items that are arrays into the menu.
menu = menu.concat(administrationItems, sizingModuleRoutes("sizingModule"), // Sizing modules
sizingModuleRoutes("modulePreference"), // Module Preferences
sizingModuleRoutes("moduleAccess") // Module Access
);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/doc-gen/doc-gen.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The Operating Company Preferences model.
 */
class DocGen {
    constructor() {
        this.specItems = [];
        this.userPreference = [];
    }
}
if (false) {
    /** @type {?} */
    DocGen.prototype.moduleId;
    /** @type {?} */
    DocGen.prototype.template;
    /** @type {?} */
    DocGen.prototype.headerImage;
    /** @type {?} */
    DocGen.prototype.bodyImage;
    /** @type {?} */
    DocGen.prototype.specItems;
    /** @type {?} */
    DocGen.prototype.userLanguageId;
    /** @type {?} */
    DocGen.prototype.targetLanguage;
    /** @type {?} */
    DocGen.prototype.userPreference;
}
class SpecSheetItem {
}
if (false) {
    /** @type {?} */
    SpecSheetItem.prototype.name;
    /** @type {?} */
    SpecSheetItem.prototype.type;
    /** @type {?} */
    SpecSheetItem.prototype.masterTextKey;
    /** @type {?} */
    SpecSheetItem.prototype.sectionName;
    /** @type {?} */
    SpecSheetItem.prototype.targetLanguage;
    /** @type {?} */
    SpecSheetItem.prototype.value;
    /** @type {?} */
    SpecSheetItem.prototype.calculation;
}
class TiRequestModel {
    constructor() {
        this.languageId = -1; // not supported yet, will get default Ti language, normally 'en'
        //isOnlinePath: boolean;
    }
}
if (false) {
    /** @type {?} */
    TiRequestModel.prototype.moduleId;
    /** @type {?} */
    TiRequestModel.prototype.code;
    /** @type {?} */
    TiRequestModel.prototype.params;
    /** @type {?} */
    TiRequestModel.prototype.languageId;
}
class TiDocumentInfosModel {
}
if (false) {
    /** @type {?} */
    TiDocumentInfosModel.prototype.tiDocumentInfos;
}
class TiDocumentInfo {
}
if (false) {
    /** @type {?} */
    TiDocumentInfo.prototype.description;
    /** @type {?} */
    TiDocumentInfo.prototype.tiFileName;
    /** @type {?} */
    TiDocumentInfo.prototype.tiPath;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/units/unit-convert.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UnitsConverter {
}
if (false) {
    /** @type {?} */
    UnitsConverter.prototype.unitsConverter;
}
/**
 * Defines the UnitConvert model class.
 */
class UnitConvert {
}
if (false) {
    /**
     * Gets or sets the propertyName.
     * @type {?}
     */
    UnitConvert.prototype.propertyName;
    /**
     * Gets or sets the initialValue.
     * @type {?}
     */
    UnitConvert.prototype.initialValue;
    /**
     * Gets or sets the initialUnitId.
     * @type {?}
     */
    UnitConvert.prototype.initialUnitId;
    /**
     * Gets or sets the targetUnitId.
     * @type {?}
     */
    UnitConvert.prototype.targetUnitId;
    /**
     * Gets or sets the destinationUnitId.
     * @type {?}
     */
    UnitConvert.prototype.convertedValue;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/safetyValves/modulePreference/productSelectionAdmin/productSelectionAdminModel.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SaveSafetyValvesProductSelection$1 {
}
if (false) {
    /** @type {?} */
    SaveSafetyValvesProductSelection$1.prototype.selectedValvesIds;
    /** @type {?} */
    SaveSafetyValvesProductSelection$1.prototype.safetyValvesModuleId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/safetyValves/modulePreference/productSelectionAdmin/safetyValvesProductSelection.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SafetyValvesProductSelection$1 {
}
if (false) {
    /**
     * Gets or sets the product names for the product range.
     * @type {?}
     */
    SafetyValvesProductSelection$1.prototype.productNames;
    /**
     * Gets or sets the product range Id.
     * @type {?}
     */
    SafetyValvesProductSelection$1.prototype.productRangeId;
    /**
     * Gets or sets the product range name.
     * @type {?}
     */
    SafetyValvesProductSelection$1.prototype.productRangeName;
    /**
     * Gets or sets the module group Id.
     * @type {?}
     */
    SafetyValvesProductSelection$1.prototype.moduleGroupId;
    /**
     * Gets or sets the product type Id.
     * @type {?}
     */
    SafetyValvesProductSelection$1.prototype.productTypeId;
    /**
     * Gets or sets a value indicating whether or not the current product range is selected.
     * @type {?}
     */
    SafetyValvesProductSelection$1.prototype.isSelected;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/safetyValves/modulePreference/productSelectionAdmin/productSelectionAdmin.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductSelectionAdminComponent$1 {
    /**
     * @param {?} productSelectionAdminService
     * @param {?} fb
     * @param {?} cdr
     */
    constructor(productSelectionAdminService, fb, cdr) {
        this.productSelectionAdminService = productSelectionAdminService;
        this.fb = fb;
        this.cdr = cdr;
        this.isSuccess = false;
        this.isError = false;
        this.saveButtonFade = true;
        this.moduleGroupId = 1;
        this.moduleName = "Safety Valves";
        this.productSelectorOnChange = new EventEmitter();
        //@Input("module-name") moduleName: string;
        //@Input("module-group-id") moduleGroupId: number = 0;
        this.saveNewSafetyValvesSelection = new SaveSafetyValvesProductSelection$1();
        this.products = [];
        /* Boilerplate directive component code */
        this.internalValue = null;
        //@Input('productId') internalIdValue: number[] = null;
        this.onChange = (/**
         * @return {?}
         */
        () => { });
        this.onTouched = (/**
         * @return {?}
         */
        () => { });
    }
    /**
     * @return {?}
     */
    get selectedProducts() {
        return this.internalValue;
    }
    /**
     * @param {?} products
     * @return {?}
     */
    set selectedProducts(products) {
        this.internalValue = products;
        this.onChange(this.internalValue);
        this.onTouched();
    }
    /**
     * @param {?} __0
     * @return {?}
     */
    validate({ value }) {
        /** @type {?} */
        const isNotValid = this.selectedProducts.length === 0;
        return isNotValid && {
            invalid: true
        };
    }
    /**
     * Registers any changes to the directive and applies the provided callback function.
     * @param {?} fn The callback function.
     * @return {?}
     */
    registerOnChange(fn) {
        /** @type {?} */
        const bespokeChange = (/**
         * @param {?} newValue
         * @return {?}
         */
        (newValue) => {
            fn(newValue);
        });
        this.onChange = bespokeChange;
    }
    /**
     * Registers the touched event to the directive and applies the provided callback function.
     * @param {?} fn The callback function.
     * @return {?}
     */
    registerOnTouched(fn) {
        /** @type {?} */
        const bespokeTouched = (/**
         * @return {?}
         */
        () => {
            fn();
        });
        this.onTouched = bespokeTouched;
    }
    /**
     * Registers a final change to the provided directive's value and provides a space to apply it.
     * @param {?} value The directive's implicit value.
     * @return {?}
     */
    writeValue(value) {
        if (!!value) {
            this.selectedProducts = value;
            // Enable selected products!
            this.products.forEach((/**
             * @param {?} p
             * @return {?}
             */
            p => p.productNames.some((/**
             * @param {?} r
             * @return {?}
             */
            r => this.selectedProducts.indexOf(r) >= 0)) ? p.isSelected = true : p.isSelected = false));
        }
        else {
            // If no value is specified, use a default and set it to an empty array.
            this.selectedProducts = [];
            // Set the products to be no longer selected
            this.products.forEach((/**
             * @param {?} p
             * @return {?}
             */
            p => p.isSelected = false));
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.selectedProducts = [];
        this.valvesToSave = [];
        this.userForm = new FormGroup({
            formSelectedProducts: new FormControl(this.selectedProducts),
            formValvesToSave: new FormControl(this.valvesToSave)
        });
        // Call the service that gets the product ranges for the given module group Id.
        this.productSelectionAdminService.getProductExclusionRanges(this.moduleGroupId).toPromise().then((/**
         * @param {?} excludedProducts
         * @return {?}
         */
        excludedProducts => {
            if (!isNullOrUndefined(excludedProducts)) {
                excludedProducts.forEach((/**
                 * @param {?} valve
                 * @return {?}
                 */
                valve => this.selectedProducts.push(valve)));
            }
        }));
        if (this.moduleGroupId > 0) {
            //this.productSelectionAdminService.getAllProductRanges(this.moduleGroupId, this.productTypeId).subscribe(products => {
            this.productSelectionAdminService.getAllProductSelectionRanges(this.moduleGroupId).toPromise().then((/**
             * @param {?} products
             * @return {?}
             */
            products => {
                // The returned array of products is for every single iteration of a product for a given product range.
                // This should be condensed into product ranges only, with each product listed as an array item of that product range.
                for (const product of products) {
                    /** @type {?} */
                    const index = this.products.findIndex((/**
                     * @param {?} p
                     * @return {?}
                     */
                    p => p.productRangeId === product.productRangeId));
                    if (index > -1) {
                        // It already exists in the array, so push the product name
                        this.products[index].productNames.push(product.productName);
                    }
                    else {
                        // No item found, so create a new product selection item
                        /** @type {?} */
                        const productSelectionItem = new SafetyValvesProductSelection$1();
                        productSelectionItem.productRangeId = product.productRangeId;
                        productSelectionItem.productRangeName = product.productRangeName;
                        productSelectionItem.productNames = [];
                        productSelectionItem.productNames.push(product.productName);
                        productSelectionItem.moduleGroupId = product.moduleGroupId;
                        productSelectionItem.productTypeId = product.productTypeId;
                        // Determine the selected status depending on whether or not it is contained in the selected products property.
                        productSelectionItem.isSelected =
                            this.selectedProducts.findIndex((/**
                             * @param {?} sp
                             * @return {?}
                             */
                            sp => sp === product.productName)) > -1;
                        // Push the new item into the global products array
                        if (productSelectionItem.isSelected) {
                            this.valvesToSave.push(product.productRangeId);
                        }
                        this.products.push(productSelectionItem);
                    }
                }
            }));
        }
        ;
        this.internalModuleName = this.moduleName.toLowerCase().replace(/\s/g, '');
    }
    /**
     * Clicking on a product range should either add all the products in the range
     * or remove all the products from the range that has been de-selected.
     * @param {?} product
     * @return {?}
     */
    productRangeClick(product) {
        product.isSelected = !product.isSelected;
        // If the product range is now selected, add the products of the range to the array of selected products.
        if (product.isSelected) {
            this.selectedProducts = this.selectedProducts.concat(product.productNames);
            this.valvesToSave = this.valvesToSave.concat(product.productRangeId);
        }
        else {
            // Otherwise remove all the products from the list of products for that range.
            for (const productName of product.productNames) {
                /** @type {?} */
                const index = this.selectedProducts.findIndex((/**
                 * @param {?} sp
                 * @return {?}
                 */
                sp => sp === productName));
                this.selectedProducts.splice(index, 1);
            }
            /** @type {?} */
            const index = this.valvesToSave.findIndex((/**
             * @param {?} vts
             * @return {?}
             */
            vts => vts === product.productRangeId));
            this.valvesToSave.splice(index, 1);
        }
        this.onChange(this.selectedProducts);
        this.productSelectorOnChange.emit(this.selectedProducts);
        this.saveButtonFade = false;
        this.isSuccess = false;
    }
    /**
     * @return {?}
     */
    onSave() {
        //console.log('new Selected Safety Valves IDs: ' + this.valvesToSave.toString());
        this.saveNewSafetyValvesSelection.selectedValvesIds = this.valvesToSave;
        this.saveNewSafetyValvesSelection.safetyValvesModuleId = this.moduleGroupId;
        this.productSelectionAdminService.selectedSafetyValves(this.saveNewSafetyValvesSelection).subscribe((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            if (!isNullOrUndefined(result.selectedValvesIds)) {
                console.log('save isNullOrUndefined');
                this.saveButtonFade = true;
                this.isError = true;
            }
            else {
                console.log('save completed');
                this.isSuccess = true;
                this.saveButtonFade = true;
            }
        }));
    }
}
ProductSelectionAdminComponent$1.decorators = [
    { type: Component, args: [{
                selector: 'product-selection-admin',
                exportAs: 'product-selection-admin',
                template: "<form [formGroup]=\"userForm\">\r\n  <!-- Notification ribbons should go here -->\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <!-- Alert messages for user profile submissions -->\r\n      <alert type=\"success\" *ngIf=\"isSuccess\" dismissible=\"true\" dismissOnTimeout=\"3000\">{{'PRODUCT_SELECTION_SAVED_SUCCESSFULLY' | translate}}</alert>\r\n      <alert type=\"danger\" *ngIf=\"isError\" dismissible=\"true\">{{'PRODUCT_SELECTION_SAVE_FAILED' | translate}}</alert>\r\n\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12 text-center product-selector-container\">\r\n      <button #productSelectionButton\r\n              class=\"btn product-selection-item\"\r\n              [class.btn-default]=\"product.isSelected\"\r\n              [class.btn-primary]=\"!product.isSelected\"\r\n              *ngFor=\"let product of products\"\r\n              (click)=\"productRangeClick(product)\">\r\n\r\n        <img [src]=\"'assets/img/' + internalModuleName + '/' + product.productRangeName + '.png'\" /> <br />\r\n        {{product.productRangeName}}\r\n      </button>\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <div class=\"col-xs-12\">\r\n    <button (click)=\"onSave()\"\r\n            [disabled]=\"saveButtonFade\"\r\n            class=\"btn btn-primary pull-right\"\r\n            [title]=\"'SAVE' | translate:true\">\r\n\r\n      <i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i>\r\n\r\n    </button>\r\n  </div>\r\n\r\n</form>\r\n\r\n",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => ProductSelectionAdminComponent$1)),
                    }, {
                        provide: NG_VALIDATORS,
                        useExisting: ProductSelectionAdminComponent$1,
                        multi: true
                    }
                ],
                styles: [".home-container{margin:0 auto;max-width:970px}.home-container .home-logo{width:240px}@media only screen and (max-width:768px){.home-container .home-text{text-align:center}}.admin-module-button{margin:5px;white-space:normal}.admin-module-button em{font-size:1.6em}@media (min-width:1200px){.admin-module-button{font-size:1.4em}}.product-selector-container{background-color:#edf1f2;border-radius:8px;padding:5px}.btn-default.product-selection-item{background-color:#e4eaec}.btn-default.product-selection-item img{background-color:#fff;opacity:.5}.btn-primary.product-selection-item img{background-color:#edf1f2}.product-selection-item{margin:0 10px 10px 0;width:120px}.product-selection-item img{width:60px;height:112px;border-radius:8px;padding:5px}"]
            }] }
];
/** @nocollapse */
ProductSelectionAdminComponent$1.ctorParameters = () => [
    { type: ProductSelectionAdminService },
    { type: FormBuilder },
    { type: ChangeDetectorRef }
];
ProductSelectionAdminComponent$1.propDecorators = {
    productSelectorOnChange: [{ type: Output, args: ['productSelectorOnChange',] }],
    internalValue: [{ type: Input, args: ['value',] }]
};
if (false) {
    /** @type {?} */
    ProductSelectionAdminComponent$1.prototype.userForm;
    /** @type {?} */
    ProductSelectionAdminComponent$1.prototype.isSuccess;
    /** @type {?} */
    ProductSelectionAdminComponent$1.prototype.isError;
    /** @type {?} */
    ProductSelectionAdminComponent$1.prototype.saveButtonFade;
    /** @type {?} */
    ProductSelectionAdminComponent$1.prototype.moduleGroupId;
    /** @type {?} */
    ProductSelectionAdminComponent$1.prototype.moduleName;
    /** @type {?} */
    ProductSelectionAdminComponent$1.prototype.productSelectorOnChange;
    /** @type {?} */
    ProductSelectionAdminComponent$1.prototype.saveNewSafetyValvesSelection;
    /** @type {?} */
    ProductSelectionAdminComponent$1.prototype.products;
    /** @type {?} */
    ProductSelectionAdminComponent$1.prototype.internalModuleName;
    /** @type {?} */
    ProductSelectionAdminComponent$1.prototype.internalValue;
    /** @type {?} */
    ProductSelectionAdminComponent$1.prototype.onChange;
    /** @type {?} */
    ProductSelectionAdminComponent$1.prototype.onTouched;
    /** @type {?} */
    ProductSelectionAdminComponent$1.prototype.valvesToSave;
    /**
     * @type {?}
     * @private
     */
    ProductSelectionAdminComponent$1.prototype.productSelectionAdminService;
    /**
     * @type {?}
     * @private
     */
    ProductSelectionAdminComponent$1.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    ProductSelectionAdminComponent$1.prototype.cdr;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/sizingModule.abstract.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class BaseSizingModule {
    constructor() {
        this.saveJobSuccess = false;
        this.saveJobError = false;
        this.isSpecSheetEnabled = false;
        this.isTiEnabled = false;
        this.isImiEnabled = false;
        this.isCalculating = false;
        this.isNewSizing = true;
        this.showJobExportBtn = false;
        this.enableJobExportBtn = false;
    }
}
if (false) {
    /** @type {?} */
    BaseSizingModule.prototype.saveJobSuccess;
    /** @type {?} */
    BaseSizingModule.prototype.saveJobError;
    /** @type {?} */
    BaseSizingModule.prototype.isSpecSheetEnabled;
    /** @type {?} */
    BaseSizingModule.prototype.isTiEnabled;
    /** @type {?} */
    BaseSizingModule.prototype.isImiEnabled;
    /** @type {?} */
    BaseSizingModule.prototype.isCalculating;
    /** @type {?} */
    BaseSizingModule.prototype.isNewSizing;
    /** @type {?} */
    BaseSizingModule.prototype.showJobExportBtn;
    /** @type {?} */
    BaseSizingModule.prototype.enableJobExportBtn;
    /** @type {?} */
    BaseSizingModule.prototype.jobId;
    /** @type {?} */
    BaseSizingModule.prototype.productName;
    /** @type {?} */
    BaseSizingModule.prototype.moduleId;
    /** @type {?} */
    BaseSizingModule.prototype.jobStatusId;
    /** @type {?} */
    BaseSizingModule.prototype.jobName;
    /** @type {?} */
    BaseSizingModule.prototype.projectName;
    /** @type {?} */
    BaseSizingModule.prototype.projectId;
    /** @type {?} */
    BaseSizingModule.prototype.existingProjectInfo;
    /** @type {?} */
    BaseSizingModule.prototype.moduleGroupId;
    /** @type {?} */
    BaseSizingModule.prototype.moduleName;
    /** @type {?} */
    BaseSizingModule.prototype.sizingModuleForm;
    /**
     * @abstract
     * @param {?} formGroup
     * @return {?}
     */
    BaseSizingModule.prototype.onCalculateSizing = function (formGroup) { };
    /**
     * @abstract
     * @return {?}
     */
    BaseSizingModule.prototype.onResetModuleForm = function () { };
    /**
     * @abstract
     * @param {?} savedProjectDetails
     * @return {?}
     */
    BaseSizingModule.prototype.onSave = function (savedProjectDetails) { };
    /**
     * @abstract
     * @return {?}
     */
    BaseSizingModule.prototype.onExcelSubmit = function () { };
    /**
     * @abstract
     * @return {?}
     */
    BaseSizingModule.prototype.onPdfSubmit = function () { };
    /**
     * @abstract
     * @return {?}
     */
    BaseSizingModule.prototype.onUnitsChanged = function () { };
    /**
     * @abstract
     * @return {?}
     */
    BaseSizingModule.prototype.onSaveJob = function () { };
    /**
     * @abstract
     * @return {?}
     */
    BaseSizingModule.prototype.repackageSizing = function () { };
    /**
     * @abstract
     * @return {?}
     */
    BaseSizingModule.prototype.onNewSizingForm = function () { };
    /**
     * @abstract
     * @return {?}
     */
    BaseSizingModule.prototype.onEnterHeaderDetailsForm = function () { };
    /**
     * @abstract
     * @return {?}
     */
    BaseSizingModule.prototype.onGetTiSheet = function () { };
    /**
     * @abstract
     * @return {?}
     */
    BaseSizingModule.prototype.onGetImiSheet = function () { };
    /**
     * @abstract
     * @return {?}
     */
    BaseSizingModule.prototype.onCheckCrmExportValid = function () { };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/sizingModule.changes.guard.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SizingModuleChangesGuard {
    /**
     * @param {?} translatePipe
     * @param {?} routesService
     * @param {?} authenticationService
     */
    constructor(translatePipe, routesService, authenticationService) {
        this.translatePipe = translatePipe;
        this.routesService = routesService;
        this.authenticationService = authenticationService;
    }
    /**
     * A Guard that decides if a route can be deactivated.
     * @param {?} component
     * @param {?} currentRoute
     * @param {?} currentState
     * @param {?=} nextState
     * @return {?}
     */
    canDeactivate(component, currentRoute, currentState, nextState) {
        if (!!component === false) {
            // If no component has been found throw an error.
            throw "Sizing Module Deactivation Guard requires a component to implement 'ISizingModule'";
        }
        // Check if the user is logged in before continuing.
        this.authenticationService.authUserChange.next();
        if (!this.authenticationService.authenticatedUser.isLoggedIn) {
            // Let the deactivation continue, because the user needs to login again.
            return Observable$1.of(true).toPromise();
        }
        this.routesService.canDeactivatePending = true;
        console.info(`Attempting to deactivate Sizing Module component '${component.constructor.name}'`);
        /** @type {?} */
        let defaultReturn = Observable$1.of(true).toPromise();
        // Check the url the app wants to navigate to
        if (!!nextState && (nextState.url === "/500")) {
            // The app is in an erroneous state, so don't even show the alert message.
            return defaultReturn;
        }
        if (!!component &&
            !component.saveJobSuccess &&
            !!component.sizingModuleForm &&
            (component.sizingModuleForm.dirty ||
                component.sizingModuleForm.touched ||
                !component.sizingModuleForm.pristine)) {
            /** @type {?} */
            const title = this.translatePipe.transform("SIZING_MODULE_CHANGES_TITLE", true);
            /** @type {?} */
            const text = this.translatePipe.transform("SIZING_MODULE_CHANGES_TEXT", true);
            /** @type {?} */
            const saveButtonText = this.translatePipe.transform("GO_BACK_AND_KEEP_CHANGES", true);
            /** @type {?} */
            const cancelButtonText = this.translatePipe.transform("DISCARD_CHANGES", true);
            // Inform the routes service that no page loading has occurred yet because the user needs to make a decision first.
            this.routesService.pageLoading = false;
            defaultReturn = swal__default({
                title: title,
                text: text,
                icon: "warning",
                dangerMode: true,
                buttons: [saveButtonText, cancelButtonText]
            }).then((/**
             * @param {?=} discardChanges
             * @return {?}
             */
            (discardChanges) => {
                console.info("Resolving unsaved changes promise");
                // The parameter can also enter as null
                /** @type {?} */
                const returnVal = !(discardChanges === null);
                // When Angular looks at a guard decision, page navigation has already occurred.
                // Reset the page load progress
                this.routesService.pageLoadProgress = 0;
                this.routesService.pageLoading = returnVal;
                // Exit the guard.
                this.routesService.canDeactivatePending = false;
                // Remove the unresolved promise
                this.routesService.removeUnresolvedPromise();
                return returnVal;
            }));
            // Register the promise so that other parts of the system are aware.
            this.routesService.registerUnresolvedPromise(defaultReturn);
        }
        return defaultReturn;
    }
}
SizingModuleChangesGuard.decorators = [
    { type: Injectable }
];
/** @nocollapse */
SizingModuleChangesGuard.ctorParameters = () => [
    { type: TranslatePipe },
    { type: RoutesService },
    { type: AuthenticationService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    SizingModuleChangesGuard.prototype.translatePipe;
    /**
     * @type {?}
     * @private
     */
    SizingModuleChangesGuard.prototype.routesService;
    /**
     * @type {?}
     * @private
     */
    SizingModuleChangesGuard.prototype.authenticationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/easiHeat/modulePreference/easiHeatPricingOptions.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//import { Message } from '../../../core/messages/message.model';
//import { Message } from "sizing-shared-lib";
/*************************************
    MODULE PREFERENCES VERSION!
**************************************/
/**
 * The CleanSteamGeneratorPricing model.
 */
class EasiHeatPricing$2 {
}
if (false) {
    /**
     * Gets or sets the modelId.
     * @type {?}
     */
    EasiHeatPricing$2.prototype.modelId;
    /**
     * Gets or sets the manufacturerId.
     * @type {?}
     */
    EasiHeatPricing$2.prototype.manufacturerId;
    /**
     * Gets or sets the basePriceOption.
     * @type {?}
     */
    EasiHeatPricing$2.prototype.basePriceOption;
    /**
     * Gets or sets the localRecommendedSalesPriceOption.
     * @type {?}
     */
    EasiHeatPricing$2.prototype.localRecommendedSalesPriceOption;
    /**
     * Gets or sets the landedCostIncreaseFactor.
     * @type {?}
     */
    EasiHeatPricing$2.prototype.landedCostIncreaseFactor;
    /**
     * Gets or sets the pricingOptions.
     * @type {?}
     */
    EasiHeatPricing$2.prototype.pricingOptions;
}
class EasiHeatPricingOption$2 {
}
if (false) {
    /**
     * Gets or sets the enumerationName.
     * @type {?}
     */
    EasiHeatPricingOption$2.prototype.enumerationName;
    /**
     * Gets or sets the selectedValue.
     * @type {?}
     */
    EasiHeatPricingOption$2.prototype.selectedValue;
}
class EasiHeatPricingOutput$2 {
}
if (false) {
    /**
     * Gets or sets the totalPrice.
     * @type {?}
     */
    EasiHeatPricingOutput$2.prototype.totalSalesPrice;
    /**
     * Gets or sets the totalRecommendedSalesPrice.
     * @type {?}
     */
    EasiHeatPricingOutput$2.prototype.totalRecommendedSalesPrice;
}
class EasiHeatBOMPriceOutput$2 {
}
if (false) {
    /**
     * Gets or sets the BOMItems.
     * @type {?}
     */
    EasiHeatBOMPriceOutput$2.prototype.bomItems;
}
class BOMItem$4 {
    constructor() {
        /**
         * Gets or sets the isEnabled.
         */
        this.isEnabled = true;
    }
}
if (false) {
    /**
     * Gets or sets the rowOrder.
     * @type {?}
     */
    BOMItem$4.prototype.rowOrder;
    /**
     * Gets or sets the itemType.
     * @type {?}
     */
    BOMItem$4.prototype.itemType;
    /**
     * Gets or sets the modelId.
     * @type {?}
     */
    BOMItem$4.prototype.modelId;
    /**
     * Gets or sets the parent.
     * @type {?}
     */
    BOMItem$4.prototype.parent;
    /**
     * Gets or sets the parentMasterTextKey.
     * @type {?}
     */
    BOMItem$4.prototype.parentMasterTextKey;
    /**
     * Gets or sets the parentTranslation.
     * @type {?}
     */
    BOMItem$4.prototype.parentTranslation;
    /**
     * Gets or sets the item.
     * @type {?}
     */
    BOMItem$4.prototype.item;
    /**
     * Gets or sets the itemTranslation.
     * @type {?}
     */
    BOMItem$4.prototype.itemTranslation;
    /**
     * Gets or sets the itemMasterTextKey.
     * @type {?}
     */
    BOMItem$4.prototype.itemMasterTextKey;
    /**
     * Gets or sets the sequenceDefault.
     * @type {?}
     */
    BOMItem$4.prototype.sequenceDefault;
    /**
     * Gets or sets the sequenceOverride.
     * @type {?}
     */
    BOMItem$4.prototype.sequenceOverride;
    /**
     * Gets or sets the landedAdjusted.
     * @type {?}
     */
    BOMItem$4.prototype.landedAdjusted;
    /**
     * Gets or sets the ssp.
     * @type {?}
     */
    BOMItem$4.prototype.ssp;
    /**
     * Gets or sets the ssPtoRSPfactor.
     * @type {?}
     */
    BOMItem$4.prototype.ssPtoRSPfactor;
    /**
     * Gets or sets the recommendedSalesPrice.
     * @type {?}
     */
    BOMItem$4.prototype.recommendedSalesPrice;
    /**
     * Gets or sets the rsPtoRSPOfactor.
     * @type {?}
     */
    BOMItem$4.prototype.rsPtoRSPOfactor;
    /**
     * Gets or sets the recommendedSalesPriceOverride.
     * @type {?}
     */
    BOMItem$4.prototype.recommendedSalesPriceOverride;
    /**
     * Gets or sets the displayedRSP.
     * @type {?}
     */
    BOMItem$4.prototype.displayedRSP;
    /**
     * Gets or sets the manCurrency.
     * @type {?}
     */
    BOMItem$4.prototype.manCurrency;
    /**
     * Gets or sets the displayedRSP.
     * @type {?}
     */
    BOMItem$4.prototype.manRateToGBP;
    /**
     * Gets or sets the displayedRSP.
     * @type {?}
     */
    BOMItem$4.prototype.manCurrencyId;
    /**
     * Gets or sets the priceDataUTCDate.
     * @type {?}
     */
    BOMItem$4.prototype.priceDataUTCDate;
    /**
     * Gets or sets the sLandedAdjusted.
     * @type {?}
     */
    BOMItem$4.prototype.sLandedAdjusted;
    /**
     * Gets or sets the sSSP.
     * @type {?}
     */
    BOMItem$4.prototype.sSSP;
    /**
     * Gets or sets the sRecommendedSalesPrice.
     * @type {?}
     */
    BOMItem$4.prototype.sRecommendedSalesPrice;
    /**
     * Gets or sets the sRecommendedSalesPriceOverride.
     * @type {?}
     */
    BOMItem$4.prototype.sRecommendedSalesPriceOverride;
    /**
     * Gets or sets the sDisplayedRSP.
     * @type {?}
     */
    BOMItem$4.prototype.sDisplayedRSP;
    /**
     * Gets or sets the sellingCurrency.
     * @type {?}
     */
    BOMItem$4.prototype.sellingCurrency;
    /**
     * Gets or sets the sellingRateToGBP.
     * @type {?}
     */
    BOMItem$4.prototype.sellingRateToGBP;
    /**
     * Gets or sets the sellingCurrencyId.
     * @type {?}
     */
    BOMItem$4.prototype.sellingCurrencyId;
    /**
     * Gets or sets the isEnabled.
     * @type {?}
     */
    BOMItem$4.prototype.isEnabled;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/easiHeat/modulePreference/easiHeat.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * **********************************
 * MODULE PREFERENCES VERSION!
 * ************************************
 */
class EasiHeatService$1 {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} ehPricing
     * @return {?}
     */
    calculateBOMPrice(ehPricing) {
        return this.http.post(`./Api/EasiHeat/CalculateBOMPrice`, ehPricing);
    }
}
EasiHeatService$1.decorators = [
    { type: Injectable }
];
/** @nocollapse */
EasiHeatService$1.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    EasiHeatService$1.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sizingModules/easiHeat/modulePreference/easiHeat.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EasiHeatPreferencesComponent$1 {
    /**
     * @param {?} routesService
     * @param {?} adminService
     * @param {?} translationService
     * @param {?} fb
     * @param {?} translatePipe
     * @param {?} modulePreferenceService
     * @param {?} easiHeatService
     * @param {?} localeService
     * @param {?} userProfileService
     * @param {?} user
     */
    constructor(routesService, adminService, translationService, fb, translatePipe, modulePreferenceService, easiHeatService, localeService, userProfileService, user) {
        this.routesService = routesService;
        this.adminService = adminService;
        this.translationService = translationService;
        this.fb = fb;
        this.translatePipe = translatePipe;
        this.modulePreferenceService = modulePreferenceService;
        this.easiHeatService = easiHeatService;
        this.localeService = localeService;
        this.userProfileService = userProfileService;
        this.user = user;
        this.moduleId = "5";
        this.moduleGroupId = 3;
        this.cloneDeep = cloneDeep_;
        this.moduleName = "EasiHeat";
        // for scroll to view
        this.componentInitialised = false;
        this.componentLoadPromises = [];
        // to drive GenericChangesGuard
        this.isSuccess = false;
        this.alertVisible = false;
        this.formSubmitted = false;
        //*** Regular module prefs ***
        // Currency Options
        this.manufacturerList = [];
        this.currencyList = [];
        this.easiHeatBOMOutputDataRows = [];
        this.showPrices = false;
        this.augmentPriceDataProcessing = true; // disable button whilst page loading
        // disable button whilst page loading
        this.overrideMarkupActive = false;
        this.cvSplitRange = false;
        this.SellSteamControl = false;
        this.MotiveInletPressureAvailable = false;
        this.YearOne = false;
        this.YearTwo = false;
        this.YearThree = false;
        this.PrvAllowed = false;
        this.HideHEmodelFromSizing = false;
        this.scrollToElement = (/**
         * @param {?} elementRef
         * @param {?=} position
         * @return {?}
         */
        (elementRef, position = "start") => {
            // ToDo: Fix fussy scroll on first sizing bug. Hence the use of timeout delay here.
            setTimeout((/**
             * @return {?}
             */
            () => {
                try {
                    elementRef.nativeElement.scrollIntoView({ block: position, behavior: "smooth" });
                }
                catch (err) {
                    console.log(`scrollToElement err=${err}`);
                }
            }), 200);
        });
        this.userProfileService.getUserDetails().subscribe((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            this.user = user;
            if (!!this.user) {
                this.operatingCompany = " : " + this.user.operatingCompanyName;
            }
        }));
        this.easiHeatBOMOutputData = new EasiHeatBOMPriceOutput$2();
        //var userType = this.
        this.easiHeatManufacturerPrefFormControl = new FormControl({ value: '' });
        this.easiHeatManufacturerCurrencyModulePreference = new FormControl({ value: '' });
        this.easiHeatSellingCurrencyPrefFormControl = new FormControl('');
        this.easiHeatLandedCostIncreasePrefFormControl = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatDeliveryCostPrefFormControl = new FormControl('', [Validators.required]);
        this.easiHeatCommissionOnlyPricePrefFormControl = new FormControl('', [Validators.required]);
        this.easiHeatWarrantyOneYearPrefFormControl = new FormControl('', [Validators.required]);
        this.easiHeatWarrantyTwoYearsPrefFormControl = new FormControl('', [Validators.required]);
        this.easiHeatWarrantyThreeYearsPrefFormControl = new FormControl('', [Validators.required]);
        this.easiHeatOptionsFormControl = new FormControl({ value: '', disabled: false });
        //Heat Exchanger
        this.easiHeatHeatExchangerTS6 = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatHeatExchangerT6 = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatHeatExchangerT8 = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatHeatExchangerT10 = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatPricingCurrency = new FormControl({ value: '', disabled: false });
        this.easiHeatOverrideMarkup = new FormControl('', [Validators.required, CustomValidators.range([0, 100])]);
        this.easiHeatOverrideMarkupActive = new FormControl(false); //checkbox  
        this.easiHeatSellingMarkup = new FormControl({ value: '', disabled: false });
        this.easiHeatLandedCostIncreaseModPref = new FormControl('', [Validators.required]);
        this.easiHeatDeliveryCostModPref = new FormControl('', [Validators.required]);
        this.easiHeatCommissionOnly = new FormControl('', [Validators.required]);
        this.easiHeatCvSplitRange = new FormControl(false); //checkbox
        this.easiHeatSteamSideControlOnHTG = new FormControl(false); //checkbox
        this.easiHeatMotiveInletPressureAvailable = new FormControl(false); //checkbox
        this.easiHeatPRVAvailableOnEHHCC = new FormControl(false); //checkbox 
        this.easiHeatHideHEModelFromSizing = new FormControl(false); //checkbox
        this.easi_Heat_DHW_And_HTG_Sc_Options_Actuator = new FormControl(null);
        this.easi_HTG_CC_Options_Actuator = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_DesignCode = new FormControl(null);
        this.easi_HTG_CC_Options_DesignCode = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_HighLimit = new FormControl(null);
        this.easi_HTG_CC_Options_HighLimit = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_HighLimitActuation = new FormControl(null);
        this.easi_HTG_CC_Options_HighLimitActuation = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_Isolation = new FormControl(null);
        this.easi_HTG_CC_Options_Isolation = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_ControlPanel = new FormControl(null);
        this.easi_HTG_CC_Options_ControlPanel = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_ServiceOffering = new FormControl(null);
        this.easi_HTG_CC_Options_ServiceOffering = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_Gasket = new FormControl(null);
        this.easi_HTG_CC_Options_Gasket = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_RemoteAccess = new FormControl(null);
        this.easi_HTG_CC_Options_RemoteAccess = new FormControl(null);
        this.easiHeatDHWandHTGScOptions_Communications = new FormControl(null);
        this.easi_HTG_CC_Options_Communications = new FormControl(null);
        this.easiHeat_DHW_AdditionalOptions = new FormControl(null);
        this.easiHeat_HTG_AdditionalOptions = new FormControl(null);
        this.easiHeatDHWAvailable = new FormControl({ value: false, disabled: false });
        this.easiHeatDHWOn = new FormControl({ value: false, disabled: false });
        this.easiHeatDHWOff = new FormControl({ value: false, disabled: false });
        this.easiHeatHTGAvailable = new FormControl({ value: false, disabled: false });
        this.easiHeatHTGOn = new FormControl({ value: false, disabled: false });
        this.easiHeatHTGOff = new FormControl({ value: false, disabled: false });
        this.easiHeatEnergyMonitoring_Available_DHW = new FormControl(false); //Checkbox
        this.easiHeatEnergyMonitoring_Default_DHW = new FormControl(false); //Checkbox
        this.easiHeatJackingWheels_Available_DHW = new FormControl(false); //Checkbox
        this.easiHeatJackingWheels_Default_DHW = new FormControl(false); //Checkbox
        this.easiHeatENCompliant_Available_DHW = new FormControl(false); //Checkbox
        this.easiHeatENCompliant_Default_DHW = new FormControl(false); //Checkbox
        this.easiHeatEnergyMonitoring_Available_HTG = new FormControl(false); //Checkbox
        this.easiHeatEnergyMonitoring_Default_HTG = new FormControl(false); //Checkbox
        this.easiHeatJackingWheels_Available_HTG = new FormControl(false); //Checkbox
        this.easiHeatJackingWheels_Default_HTG = new FormControl(false); //Checkbox
        this.easiHeatENCompliant_Available_HTG = new FormControl(false); //Checkbox
        this.easiHeatENCompliant_Default_HTG = new FormControl(false); //Checkbox
        // Setup the form group.
        this.modulePreferencesForm = this.fb.group({
            // Currency Options
            easiHeatManufacturerModulePreference: this.easiHeatManufacturerPrefFormControl,
            easiHeatManufacturerCurrencyModulePreference: this.easiHeatManufacturerCurrencyModulePreference,
            easiHeatSellingCurrencyModulePreference: this.easiHeatSellingCurrencyPrefFormControl,
            //Heat Exchanger
            easiHeatHeatExchangerTS6: this.easiHeatHeatExchangerTS6,
            easiHeatHeatExchangerT6: this.easiHeatHeatExchangerT6,
            easiHeatHeatExchangerT8: this.easiHeatHeatExchangerT8,
            easiHeatHeatExchangerT10: this.easiHeatHeatExchangerT10,
            easiHeatPricingCurrency: this.easiHeatPricingCurrency,
            easiHeatOverrideMarkup: this.easiHeatOverrideMarkup,
            easiHeatOverrideMarkupActive: this.easiHeatOverrideMarkupActive,
            easiHeatSellingMarkup: this.easiHeatSellingMarkup,
            easiHeatLandedCostIncreaseModPref: this.easiHeatLandedCostIncreaseModPref,
            easiHeatDeliveryCostModPref: this.easiHeatDeliveryCostModPref,
            easiHeatCommissionOnly: this.easiHeatCommissionOnly,
            easiHeatCvSplitRange: this.easiHeatCvSplitRange,
            easiHeatSteamSideControlOnHTG: this.easiHeatSteamSideControlOnHTG,
            easiHeatMotiveInletPressureAvailable: this.easiHeatMotiveInletPressureAvailable,
            easiHeatPRVAvailableOnEHHCC: this.easiHeatPRVAvailableOnEHHCC,
            easiHeatHideHEModelFromSizing: this.easiHeatHideHEModelFromSizing,
            easi_Heat_DHW_And_HTG_Sc_Options_Actuator: this.easi_Heat_DHW_And_HTG_Sc_Options_Actuator,
            easi_HTG_CC_Options_Actuator: this.easi_HTG_CC_Options_Actuator,
            easiHeatDHWandHTGScOptions_DesignCode: this.easiHeatDHWandHTGScOptions_DesignCode,
            easi_HTG_CC_Options_DesignCode: this.easi_HTG_CC_Options_DesignCode,
            easiHeatDHWandHTGScOptions_HighLimit: this.easiHeatDHWandHTGScOptions_HighLimit,
            easi_HTG_CC_Options_HighLimit: this.easi_HTG_CC_Options_HighLimit,
            easiHeatDHWandHTGScOptions_HighLimitActuation: this.easiHeatDHWandHTGScOptions_HighLimitActuation,
            easi_HTG_CC_Options_HighLimitActuation: this.easi_HTG_CC_Options_HighLimitActuation,
            easiHeatDHWandHTGScOptions_Isolation: this.easiHeatDHWandHTGScOptions_Isolation,
            easi_HTG_CC_Options_Isolation: this.easi_HTG_CC_Options_Isolation,
            easiHeatDHWandHTGScOptions_ControlPanel: this.easiHeatDHWandHTGScOptions_ControlPanel,
            easi_HTG_CC_Options_ControlPanel: this.easi_HTG_CC_Options_ControlPanel,
            easiHeatDHWandHTGScOptions_ServiceOffering: this.easiHeatDHWandHTGScOptions_ServiceOffering,
            easi_HTG_CC_Options_ServiceOffering: this.easi_HTG_CC_Options_ServiceOffering,
            easiHeatDHWandHTGScOptions_Gasket: this.easiHeatDHWandHTGScOptions_Gasket,
            easi_HTG_CC_Options_Gasket: this.easi_HTG_CC_Options_Gasket,
            easiHeatDHWandHTGScOptions_RemoteAccess: this.easiHeatDHWandHTGScOptions_RemoteAccess,
            easi_HTG_CC_Options_RemoteAccess: this.easi_HTG_CC_Options_RemoteAccess,
            easiHeatDHWandHTGScOptions_Communications: this.easiHeatDHWandHTGScOptions_Communications,
            easi_HTG_CC_Options_Communications: this.easi_HTG_CC_Options_Communications,
            easiHeat_DHW_AdditionalOptions: this.easiHeat_DHW_AdditionalOptions,
            easiHeat_HTG_AdditionalOptions: this.easiHeat_HTG_AdditionalOptions,
            easiHeatDHWAvailable: this.easiHeatDHWAvailable,
            easiHeatDHWOn: this.easiHeatDHWOn,
            easiHeatDHWOff: this.easiHeatDHWOff,
            easiHeatHTGAvailable: this.easiHeatHTGAvailable,
            easiHeatHTGOn: this.easiHeatHTGOn,
            easiHeatHTGOff: this.easiHeatHTGOff,
            easiHeatEnergyMonitoring_Available_DHW: this.easiHeatEnergyMonitoring_Available_DHW,
            easiHeatEnergyMonitoring_Default_DHW: this.easiHeatEnergyMonitoring_Default_DHW,
            easiHeatJackingWheels_Available_DHW: this.easiHeatJackingWheels_Available_DHW,
            easiHeatJackingWheels_Default_DHW: this.easiHeatJackingWheels_Default_DHW,
            easiHeatENCompliant_Available_DHW: this.easiHeatENCompliant_Available_DHW,
            easiHeatENCompliant_Default_DHW: this.easiHeatENCompliant_Default_DHW,
            easiHeatEnergyMonitoring_Available_HTG: this.easiHeatEnergyMonitoring_Available_HTG,
            easiHeatEnergyMonitoring_Default_HTG: this.easiHeatEnergyMonitoring_Default_HTG,
            easiHeatJackingWheels_Available_HTG: this.easiHeatJackingWheels_Available_HTG,
            easiHeatJackingWheels_Default_HTG: this.easiHeatJackingWheels_Default_HTG,
            easiHeatENCompliant_Available_HTG: this.easiHeatENCompliant_Available_HTG,
            easiHeatENCompliant_Default_HTG: this.easiHeatENCompliant_Default_HTG,
            // Pricing Options
            easiHeatLandedCostIncreaseModulePreference: this.easiHeatLandedCostIncreasePrefFormControl,
            easiHeatDeliveryCostModulePreference: this.easiHeatDeliveryCostPrefFormControl,
            easiHeatCommissionOnlyPriceModulePreference: this.easiHeatCommissionOnlyPricePrefFormControl,
            easiHeatWarrantyOneYearModulePreference: this.easiHeatWarrantyOneYearPrefFormControl,
            easiHeatWarrantyTwoYearsModulePreference: this.easiHeatWarrantyTwoYearsPrefFormControl,
            easiHeatWarrantyThreeYearsModulePreference: this.easiHeatWarrantyThreeYearsPrefFormControl,
            // Option Configuration
            easiHeatOptionsSelection: this.easiHeatOptionsFormControl,
        }, { updateOn: "change" });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        console.log("Initializing EasiHeat module prefs component");
        // First, get all the module preferences.
        //this.modulePreferencesForm.markAsPristine();
        // this.easiHeatCvSplitRange.markAsDirty();
        this.componentLoadPromises.push(this.userProfileService.getUserDetails().toPromise().then((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            this.user = user;
            //3 = sales admin
            //4 = super admin
            if (this.user.roleId == 3 || this.user.roleId == 4) {
            }
            else {
                this.easiHeatManufacturerPrefFormControl.disable();
                this.easiHeatManufacturerCurrencyModulePreference.disable();
            }
        })));
        //    this.easiHeatManufacturerPrefFormControl = new FormControl({ value: '', disabled: true });
        //    this.easiHeatManufacturerCurrencyModulePreference = new FormControl({ value: '', disabled: true });
        this.componentLoadPromises.push(this.modulePreferenceService.getOperatingCompanyModulePreferences(this.moduleId).toPromise().then((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            if (result && result.length > 0) {
                // And set their values accordingly.
                this.manufacturerId = +this.getModulePreferenceValue(result, "Manufacturer");
                this.easiHeatManufacturerPrefFormControl.setValue(this.manufacturerId);
                this.easiHeatManufacturerCurrencyId = +this.getModulePreferenceValue(result, "ManufacturerCurrency");
                this.easiHeatManufacturerCurrencyModulePreference.setValue(this.easiHeatManufacturerCurrencyId);
                this.easiHeatSellingCurrencyId = +this.getModulePreferenceValue(result, "SellingCurrency");
                this.easiHeatSellingCurrencyPrefFormControl.setValue(this.easiHeatSellingCurrencyId);
                // Calculate the currency conversion rate.
                this.onSellingCurrencyChange(this.easiHeatSellingCurrencyId);
                //this.easiHeatManufacturerCurrencyModulePreference.setValue(this.getModulePreferenceValue(result, "CurrencyConversion"));
                this.easiHeatHeatExchangerTS6.setValue(this.getModulePreferenceValue(result, "HETS6Discount")); //ts6
                this.easiHeatHeatExchangerT6.setValue(this.getModulePreferenceValue(result, "HEM6Discount")); //t6
                this.easiHeatHeatExchangerT8.setValue(this.getModulePreferenceValue(result, "HEM10Discount")); //t8
                this.easiHeatHeatExchangerT10.setValue(this.getModulePreferenceValue(result, "HET10")); //t10 
                this.easiHeatPricingCurrency.setValue(this.getModulePreferenceValue(result, "HEPricingCurrency"));
                this.easiHeatOverrideMarkup.setValue(this.getModulePreferenceValue(result, "HEOverridenP251MarkupValue"));
                this.easiHeatSellingMarkup.setValue(this.getModulePreferenceValue(result, "SellingMarkup"));
                this.easiHeatLandedCostIncrease = this.getModulePreferenceValue(result, "LandCostIncrease");
                this.easiHeatLandedCostIncreaseModPref.setValue(this.easiHeatLandedCostIncrease);
                this.easiHeatDeliveryCostModPref.setValue(this.getModulePreferenceValue(result, "DeliveryCost"));
                this.easiHeatCommissionOnly.setValue(this.getModulePreferenceValue(result, "Commission"));
                //Below is a temporary fix as to ensure that a boolean is passed through for the checkboxes.
                //Fix is necessary as the data reads as a string and not a boolean. The data types needs changing/fixing in the database.
                //Table:  OperatingCompanyModulePreferences
                if (this.getModulePreferenceValue(result, "HEOverridenP251Markup") == "True" || this.getModulePreferenceValue(result, "HEOverridenP251Markup") == "true") {
                    this.overrideMarkupActive = true;
                }
                else {
                    this.overrideMarkupActive = false;
                }
                if (this.getModulePreferenceValue(result, "CVSplitRange") == "True" || this.getModulePreferenceValue(result, "CVSplitRange") == "true") {
                    this.cvSplitRange = true;
                }
                else {
                    this.cvSplitRange = false;
                }
                if (this.getModulePreferenceValue(result, "SellSteamControl") == "True" || this.getModulePreferenceValue(result, "SellSteamControl") == "true") {
                    this.SellSteamControl = true;
                }
                else {
                    this.SellSteamControl = false;
                }
                if (this.getModulePreferenceValue(result, "MotiveInletPressureAvailable") == "True" || this.getModulePreferenceValue(result, "MotiveInletPressureAvailable") == "true") {
                    this.MotiveInletPressureAvailable = true;
                }
                else {
                    this.MotiveInletPressureAvailable = false;
                }
                if (this.getModulePreferenceValue(result, "PrvAllowed") == "True" || this.getModulePreferenceValue(result, "PrvAllowed") == "true") {
                    this.PrvAllowed = true;
                }
                else {
                    this.PrvAllowed = false;
                }
                if (this.getModulePreferenceValue(result, "HideHEmodelFromSizing") == "True" || this.getModulePreferenceValue(result, "HideHEmodelFromSizing") == "true") {
                    this.HideHEmodelFromSizing = true;
                }
                else {
                    this.HideHEmodelFromSizing = false;
                }
                this.easiHeatOverrideMarkupActive.setValue(this.overrideMarkupActive);
                this.easiHeatCvSplitRange.setValue(this.cvSplitRange);
                this.easiHeatSteamSideControlOnHTG.setValue(this.SellSteamControl);
                this.easiHeatMotiveInletPressureAvailable.setValue(this.MotiveInletPressureAvailable);
                this.easiHeatPRVAvailableOnEHHCC.setValue(this.PrvAllowed);
                this.easiHeatHideHEModelFromSizing.setValue(this.HideHEmodelFromSizing);
                this.easiHeatWarrantyOneYearPrefFormControl.setValue(this.getModulePreferenceValue(result, "YearOne"));
                this.easiHeatWarrantyTwoYearsPrefFormControl.setValue(this.getModulePreferenceValue(result, "YearTwo"));
                this.easiHeatWarrantyThreeYearsPrefFormControl.setValue(this.getModulePreferenceValue(result, "YearThree"));
                if (this.getModulePreferenceValue(result, "EnergyMonitoringAvailableDHW") == "True" || this.getModulePreferenceValue(result, "EnergyMonitoringAvailableDHW") == "true") {
                    this.easiHeatEnergyMonitoring_Available_DHW.setValue(true);
                }
                else {
                    this.easiHeatEnergyMonitoring_Available_DHW.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "EnergyMonitoringDefaultDHW") == "True" || this.getModulePreferenceValue(result, "EnergyMonitoringDefaultDHW") == "true") {
                    this.easiHeatEnergyMonitoring_Default_DHW.setValue(true);
                }
                else {
                    this.easiHeatEnergyMonitoring_Default_DHW.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "JackingWheelsAvailableDHW") == "True" || this.getModulePreferenceValue(result, "JackingWheelsAvailableDHW") == "true") {
                    this.easiHeatJackingWheels_Available_DHW.setValue(true);
                }
                else {
                    this.easiHeatJackingWheels_Available_DHW.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "JackingWheelsDefaultDHW") == "True" || this.getModulePreferenceValue(result, "JackingWheelsDefaultDHW") == "true") {
                    this.easiHeatJackingWheels_Default_DHW.setValue(true);
                }
                else {
                    this.easiHeatJackingWheels_Default_DHW.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "ENCompliantAvailableDHW") == "True" || this.getModulePreferenceValue(result, "ENCompliantAvailableDHW") == "true") {
                    this.easiHeatENCompliant_Available_DHW.setValue(true);
                }
                else {
                    this.easiHeatENCompliant_Available_DHW.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "ENCompliantDefaultDHW") == "True" || this.getModulePreferenceValue(result, "ENCompliantDefaultDHW") == "true") {
                    this.easiHeatENCompliant_Default_DHW.setValue(true);
                }
                else {
                    this.easiHeatENCompliant_Default_DHW.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "EnergyMonitoringAvailableHTG") == "True" || this.getModulePreferenceValue(result, "EnergyMonitoringAvailableHTG") == "true") {
                    this.easiHeatEnergyMonitoring_Available_HTG.setValue(true);
                }
                else {
                    this.easiHeatEnergyMonitoring_Available_HTG.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "EnergyMonitoringDefaultHTG") == "True" || this.getModulePreferenceValue(result, "EnergyMonitoringDefaultHTG") == "true") {
                    this.easiHeatEnergyMonitoring_Default_HTG.setValue(true);
                }
                else {
                    this.easiHeatEnergyMonitoring_Default_HTG.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "JackingWheelsAvailableHTG") == "True" || this.getModulePreferenceValue(result, "JackingWheelsAvailableHTG") == "true") {
                    this.easiHeatJackingWheels_Available_HTG.setValue(true);
                }
                else {
                    this.easiHeatJackingWheels_Available_HTG.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "JackingWheelsDefaultHTG") == "True" || this.getModulePreferenceValue(result, "JackingWheelsDefaultHTG") == "true") {
                    this.easiHeatJackingWheels_Default_HTG.setValue(true);
                }
                else {
                    this.easiHeatJackingWheels_Default_HTG.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "ENCompliantAvailableHTG") == "True" || this.getModulePreferenceValue(result, "ENCompliantAvailableHTG") == "true") {
                    this.easiHeatENCompliant_Available_HTG.setValue(true);
                }
                else {
                    this.easiHeatENCompliant_Available_HTG.setValue(false);
                }
                if (this.getModulePreferenceValue(result, "ENCompliantDefaultHTG") == "True" || this.getModulePreferenceValue(result, "ENCompliantDefaultHTG") == "true") {
                    this.easiHeatENCompliant_Default_HTG.setValue(true);
                }
                else {
                    this.easiHeatENCompliant_Default_HTG.setValue(false);
                }
                // Get the currency data.
                this.adminService.getCurrencyData().subscribe((/**
                 * @param {?} data
                 * @return {?}
                 */
                data => {
                    this.currencyList = data;
                    //this.easiHeatManufacturerCurrencyId = data.find(c => c.id === this.easiHeatManufacturerCurrencyId)
                    // Selling currency found, so try to calculate the currency conversion rate.
                    this.onSellingCurrencyChange(this.easiHeatSellingCurrencyId);
                    this.augmentPriceDataProcessing = false; // loaded enable toggle prices button
                }));
            }
            // Get the currency data.
            this.adminService.getCurrencyData().subscribe((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                this.currencyList = data;
                //this.easiHeatManufacturerCurrencyId = data.find(c => c.id === this.easiHeatManufacturerCurrencyId)
                // Selling currency found, so try to calculate the currency conversion rate.
                this.onSellingCurrencyChange(this.easiHeatSellingCurrencyId);
                this.augmentPriceDataProcessing = false; // loaded enable toggle prices button
            }));
        })));
        // Get the list of manufacturers.
        this.componentLoadPromises.push(this.adminService.getManufacturerData(this.moduleGroupId).toPromise().then((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            // Update the subject with the data that's just been retrieved (see the constructor).  
            this.manufacturerList = result;
        })));
        // Now, set the "OpCo Selected Options" for the different EasiHeat options.
        // Actuator
        this.setOpCoPreferences("NomActuatorDHW_EasiHeat", this.easi_Heat_DHW_And_HTG_Sc_Options_Actuator);
        this.setOpCoPreferences("NomActuatorHTG_EasiHeat", this.easi_HTG_CC_Options_Actuator);
        // Design Code
        this.setOpCoPreferences("NomDesignCodeDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_DesignCode);
        this.setOpCoPreferences("NomDesignCodeHTG_EasiHeat", this.easi_HTG_CC_Options_DesignCode);
        // High Limit
        this.setOpCoPreferences("NomHighLimitDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_HighLimit);
        this.setOpCoPreferences("NomHighLimitHTG_EasiHeat", this.easi_HTG_CC_Options_HighLimit);
        // High Limit Actuation
        this.setOpCoPreferences("NomHighLimitActuationDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_HighLimitActuation);
        this.setOpCoPreferences("NomHighLimitActuationHTG_EasiHeat", this.easi_HTG_CC_Options_HighLimitActuation);
        // Isolation
        this.setOpCoPreferences("NomIsolationDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_Isolation);
        this.setOpCoPreferences("NomIsolationHTG_EasiHeat", this.easi_HTG_CC_Options_Isolation);
        // Control Panel
        this.setOpCoPreferences("NomPanelTypeDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_ControlPanel);
        this.setOpCoPreferences("NomPanelTypeHTG_EasiHeat", this.easi_HTG_CC_Options_ControlPanel);
        // Service Offering
        this.setOpCoPreferences("WarrantyDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_ServiceOffering);
        this.setOpCoPreferences("WarrantyHTG_EasiHeat", this.easi_HTG_CC_Options_ServiceOffering);
        // Gasket
        this.setOpCoPreferences("NomGasketDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_Gasket);
        this.setOpCoPreferences("NomGasketHTG_EasiHeat", this.easi_HTG_CC_Options_Gasket);
        // Remote Access
        this.setOpCoPreferences("NomRemoteAccessDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_RemoteAccess);
        this.setOpCoPreferences("NomRemoteAccessHTG_EasiHeat", this.easi_HTG_CC_Options_RemoteAccess);
        // Communications
        this.setOpCoPreferences("NomCommunicationsDHW_EasiHeat", this.easiHeatDHWandHTGScOptions_Communications);
        this.setOpCoPreferences("NomCommunicationsHTG_EasiHeat", this.easi_HTG_CC_Options_Communications);
        //Additional Options
        this.setOpCoPreferences("NomAdditionalOptionsDHW_EasiHeat", this.easiHeat_DHW_AdditionalOptions);
        this.setOpCoPreferences("NomAdditionalOptionsHTG_EasiHeat", this.easiHeat_HTG_AdditionalOptions);
        this.easiHeatOptionsSelectedItem = "Actuator";
        this.theFormGroup = this.modulePreferencesForm; // to drive GenericChangesGuard
        // Info ToolTip message translations
        this.serviceOffereingMessage = this.translatePipe.transform('SERVICE_OFFERING_MESSAGE', false);
        this.deliveryCostMessage = this.translatePipe.transform('DELIVERY_COST_MESSAGE', false);
        Promise.all(this.componentLoadPromises).then((/**
         * @return {?}
         */
        () => {
            console.log("Initialization promises complete for Easiheat Component");
            this.componentInitialised = true;
        }));
    }
    /**
     * @return {?}
     */
    togglePrices() {
        this.showPrices = !this.showPrices;
        this.augmentPriceDataProcessing = true;
        this.augmentPricesToOptionsLists(this.showPrices);
    }
    /**
     * @return {?}
     */
    onChangeData() {
        //debugger;
        //this.modulePreferencesForm.markAsPristine(); 
    }
    /**
     * @return {?}
     */
    toggleSave() {
        if (this.easiHeatHeatExchangerTS6.valid == false || this.easiHeatHeatExchangerT6.valid == false || this.easiHeatHeatExchangerT8.valid == false ||
            this.easiHeatHeatExchangerT10.valid == false || this.easiHeatOverrideMarkup.valid == false || this.easiHeatSellingMarkup.valid == false ||
            this.easiHeatLandedCostIncreaseModPref.valid == false || this.easiHeatDeliveryCostModPref.valid == false || this.easiHeatCommissionOnly.valid == false ||
            this.easiHeatWarrantyOneYearPrefFormControl.valid == false || this.easiHeatWarrantyTwoYearsPrefFormControl.valid == false || this.easiHeatWarrantyThreeYearsPrefFormControl.valid == false) {
            this.modulePreferencesForm.markAsPristine();
        }
    }
    /**
     * @param {?=} showPrices
     * @return {?}
     */
    augmentPricesToOptionsLists(showPrices = true) {
        this.easiHeatPricing = new EasiHeatPricing$2();
        this.easiHeatPricing.modelId = -1; // All BOM items    
        this.easiHeatPricing.pricingOptions = [];
        this.easiHeatPricing.basePriceOption = -1;
        this.easiHeatPricing.localRecommendedSalesPriceOption = -1;
        this.easiHeatPricing.landedCostIncreaseFactor = -1;
        this.easiHeatSellingCurrencySymbol = !!this.easiHeatSellingCurrencySymbol ? this.easiHeatSellingCurrencySymbol : "?";
        this.easiHeatPricing.manufacturerId = +(!!this.manufacturerId ? this.manufacturerId : -1);
        this.easiHeatManufacturerCurrency = this.currencyList.find((/**
         * @param {?} c
         * @return {?}
         */
        c => c.id === this.easiHeatManufacturerCurrencyId));
        this.easiHeatManufacturerCurrencySymbol = !!this.easiHeatManufacturerCurrency ? this.easiHeatManufacturerCurrency.symbol : "?";
        if (showPrices) {
            // Get RSP Display price data for List item Augmentation
            this.easiHeatService.calculateBOMPrice(this.easiHeatPricing).subscribe((/**
             * @param {?} response
             * @return {?}
             */
            (response) => {
                if (response) {
                    this.easiHeatBOMOutputData = response;
                    /** @type {?} */
                    let manPrice = "";
                    /** @type {?} */
                    let localPrices = "";
                    /** @type {?} */
                    let isOverride = "";
                    this.easiHeatBOMOutputData.bomItems.forEach((/**
                     * @param {?} t
                     * @return {?}
                     */
                    t => {
                        if (showPrices && t.itemType == "Base") {
                            // Price the models
                            if (t.sRecommendedSalesPrice != 0.0 && t.sRecommendedSalesPrice != parseFloat(t.sDisplayedRSP)) {
                                isOverride = 'o';
                            }
                            manPrice = ' SSP=' + this.easiHeatManufacturerCurrencySymbol + ' ' + this.localizeValue(t.ssp, 0);
                            localPrices = ' RSP' + isOverride + '=' + this.easiHeatManufacturerCurrencySymbol + ' ' + this.localizeValue(t.displayedRSP, 0);
                            if (t.ssp != t.sSSP) { // if not the same currency data
                                manPrice = manPrice + ' (' + this.easiHeatSellingCurrencySymbol + ' ' + this.localizeValue(t.sSSP, 0) + ')';
                                localPrices = localPrices + ' (' + this.easiHeatSellingCurrencySymbol + ' ' + this.localizeValue(t.sDisplayedRSP, 0) + ')';
                            }
                        }
                        // Set option item enabled?
                        /** @type {?} */
                        var newEnumerationModulePreferences = this.GetNewEnumerationModulePreferences();
                        this.easiHeatBOMOutputData.bomItems.forEach((/**
                         * @param {?} p
                         * @return {?}
                         */
                        p => {
                            /** @type {?} */
                            var elist = newEnumerationModulePreferences.find((/**
                             * @param {?} e
                             * @return {?}
                             */
                            e => e.enumerationName == p.parent));
                            //if (!!elist) { can't support on EH gen3 data
                            //  var elistItem = elist.enumerationDefinitions.find(l => l.value == p.item);
                            //}
                            p.isEnabled = true;
                            //p.isEnabled = !!elistItem ? true : false;
                            //// Set enabled if base CSG model item or add on (Commisoining, Voltage, Warranty etc.)
                            //if (!p.parentMasterTextKey
                            //  || (!!p.parentMasterTextKey && p.parentMasterTextKey.indexOf('xxxlegacy_') === 0) // no list override for it
                            //  || (!!p.parentMasterTextKey && p.parentMasterTextKey.indexOf('xxxlegacy_') === 0)) {
                            //  p.isEnabled = true;
                            //}
                        }));
                        // Append prices to list translation on UI
                        this.translationService.displayGroup.enumerations.forEach((/**
                         * @param {?} e
                         * @return {?}
                         */
                        e => {
                            e.enumerationDefinitions.forEach((/**
                             * @param {?} d
                             * @return {?}
                             */
                            d => {
                                if ((e.enumerationName == t.parent && d.value == t.item)
                                    || (t.parentMasterTextKey.indexOf(e.enumerationName) > -1 && d.value == t.item.split('_')[1])) { // && d.translationText.indexOf(' ' + this.sellingCurrencySymbol + ' ') < 0) {
                                    if (showPrices) {
                                        if (t.sRecommendedSalesPrice != 0.0 && (t.sRecommendedSalesPrice != parseFloat(t.sDisplayedRSP))) {
                                            isOverride = 'o';
                                        }
                                        /** @type {?} */
                                        var nomCode = '';
                                        if (!!t.item.split('_')[1]) {
                                            nomCode = '(' + t.item.split('_')[1] + ') ';
                                        }
                                        manPrice = ' SSP=' + this.easiHeatManufacturerCurrencySymbol + ' ' + this.localizeValue(t.ssp, 0);
                                        localPrices = ' RSP' + isOverride + '=' + this.easiHeatManufacturerCurrencySymbol + ' ' + this.localizeValue(t.displayedRSP, 0);
                                        if (t.ssp != t.sSSP) { // if not the same currency data
                                            manPrice = manPrice + ' (' + this.easiHeatSellingCurrencySymbol + ' ' + this.localizeValue(t.sSSP, 0) + ')';
                                            localPrices = localPrices + ' (' + this.easiHeatSellingCurrencySymbol + ' ' + this.localizeValue(t.sDisplayedRSP, 0) + ')';
                                        }
                                        t.itemMasterTextKey = d.masterTextKey;
                                        t.parentMasterTextKey = e.enumerationName.split('_')[0].replace('Nom', '');
                                        // Set the UI text
                                        //d.extraPostText = manPrice + localPrices; RSPs for 15 models on 2 list sets not representative!
                                        //if (!d.extraPreText) {                       
                                        //    d.extraPreText = nomCode;
                                        //}
                                    }
                                    else {
                                        //d.extraPostText = ""; // clear augmented data
                                        //d.extraPreText = "";
                                    }
                                } // end of e.enumerationDefinitions.forEach...
                                if (!d.extraPreText && d.defaultText !== d.value) {
                                    d.extraPreText = '(' + d.value + ') ';
                                }
                            }));
                        }));
                    })); // of append prices
                    this.augmentPriceDataProcessing = false; // finished, enable button again
                    this.scrollToElement(this.collapsePriceDataTop, "start");
                }
            })); // end of service response
        } // end of if showPrices
        else {
            // remove price augmentation
            //this.CSG_HS_020_Price = "";
            //this.CSG_HS_055_Price = "";
            //this.CSG_HS_125_Price = "";
            //this.CSG_HS_180_Price = "";
            this.translationService.displayGroup.enumerations.forEach((/**
             * @param {?} e
             * @return {?}
             */
            e => {
                e.enumerationDefinitions.forEach((/**
                 * @param {?} d
                 * @return {?}
                 */
                d => d.extraPostText = "")); // clear augmented data                              
            }));
            this.augmentPriceDataProcessing = false; // finished, enable button again
        }
    }
    /**
     * Method to localize values.
     * @param {?} value
     * @param {?} decimalPoints
     * @return {?}
     */
    localizeValue(value, decimalPoints) {
        return this.localeService.formatDecimal(value.toFixed(decimalPoints));
    }
    /*
      * Method to get and set the OpCo selected options.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} formControlName
     * @return {?}
     */
    setOpCoPreferences(enumerationPickerName, formControlName) {
        // Get the collection list first.
        /** @type {?} */
        let easiHeatOpCoPref = this.getEnumerationPickerCollection(enumerationPickerName, true);
        // Check if any OpCo Overrides Data found? If NOT then get the base list populated.
        if (!easiHeatOpCoPref) {
            easiHeatOpCoPref = this.cloneDeep(this.getEnumerationPickerCollection(enumerationPickerName, false));
        }
        // Check and set the list.
        if (!!easiHeatOpCoPref && easiHeatOpCoPref.length > 0) {
            formControlName.setValue(easiHeatOpCoPref);
        }
    }
    /*
      * Method to get the Enumeration list by Name.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} opCoOverride
     * @return {?}
     */
    getEnumerationPickerCollection(enumerationPickerName, opCoOverride) {
        /** @type {?} */
        const enumeration = this.translationService.displayGroup.enumerations.filter((/**
         * @param {?} us
         * @return {?}
         */
        us => us.enumerationName === enumerationPickerName && us.opCoOverride === opCoOverride));
        if (!!enumeration && enumeration.length > 0) {
            /** @type {?} */
            let definitions = enumeration[0].enumerationDefinitions.sort((/**
             * @param {?} currentenumeration
             * @param {?} nextenumeration
             * @return {?}
             */
            (currentenumeration, nextenumeration) => {
                if (currentenumeration.sequence > nextenumeration.sequence) {
                    return 1;
                }
                if (currentenumeration.sequence < nextenumeration.sequence) {
                    return -1;
                }
                return 0;
            }));
            //this.onChange(definitions);
            definitions.forEach((/**
             * @param {?} i
             * @return {?}
             */
            i => i.isDeleted = false));
            return definitions;
        }
    }
    /**
     * Submits the form for saving to the server.
     * @param {?} $event
     * @return {?}
     */
    submitForm($event) {
        $event.preventDefault();
        // Mark the form as submitted.
        this.formSubmitted = true;
        // Regular Module Preferences.
        /** @type {?} */
        const newModulePreferences = [];
        /** @type {?} */
        var sellingCurrency = this.getSelectedPreferences("SellingCurrency", "easiHeatSellingCurrencyModulePreference");
        /** @type {?} */
        var manufacturer = this.getSelectedPreferences("Manufacturer", "easiHeatManufacturerModulePreference");
        /** @type {?} */
        var manufacturerCurrency = this.getSelectedPreferences("ManufacturerCurrency", "easiHeatManufacturerCurrencyModulePreference");
        //Heat exchanger options
        /** @type {?} */
        var HETS6Discount = this.getSelectedPreferences("HETS6Discount", "easiHeatHeatExchangerTS6");
        //TS6
        /** @type {?} */
        var HEM6Discount = this.getSelectedPreferences("HEM6Discount", "easiHeatHeatExchangerT6");
        //T6
        /** @type {?} */
        var HEM8Discount = this.getSelectedPreferences("HEM10Discount", "easiHeatHeatExchangerT8");
        //T8
        /** @type {?} */
        var HEM10Discount = this.getSelectedPreferences("HET10", "easiHeatHeatExchangerT10");
        //T10  
        /** @type {?} */
        var HEPricingCurrency = this.getSelectedPreferences("HEPricingCurrency", "easiHeatPricingCurrency");
        /** @type {?} */
        var HEOverridenP251MarkupValue = this.getSelectedPreferences("HEOverridenP251MarkupValue", "easiHeatOverrideMarkup");
        /** @type {?} */
        var HEOverridenP251Markup = this.getSelectedPreferences("HEOverridenP251Markup", "easiHeatOverrideMarkupActive");
        //Pricing Options
        /** @type {?} */
        var SellingMarkup = this.getSelectedPreferences("SellingMarkup", "easiHeatSellingMarkup");
        /** @type {?} */
        var LandedCostIncrease = this.getSelectedPreferences("LandCostIncrease", "easiHeatLandedCostIncreaseModPref") //easiHeatLandedCostIncreaseModPref
        ;
        //easiHeatLandedCostIncreaseModPref
        /** @type {?} */
        var DeliveryCost = this.getSelectedPreferences("DeliveryCost", "easiHeatDeliveryCostModPref");
        /** @type {?} */
        var Commission = this.getSelectedPreferences("Commission", "easiHeatCommissionOnly");
        /** @type {?} */
        var CVSplitRange = this.getSelectedPreferences("CVSplitRange", "easiHeatCvSplitRange");
        /** @type {?} */
        var SellSteamControl = this.getSelectedPreferences("SellSteamControl", "easiHeatSteamSideControlOnHTG");
        /** @type {?} */
        var MotiveInletPressureAvailable = this.getSelectedPreferences("MotiveInletPressureAvailable", "easiHeatMotiveInletPressureAvailable");
        /** @type {?} */
        var YearOne = this.getSelectedPreferences("YearOne", "easiHeatWarrantyOneYearModulePreference");
        /** @type {?} */
        var YearTwo = this.getSelectedPreferences("YearTwo", "easiHeatWarrantyTwoYearsModulePreference");
        /** @type {?} */
        var YearThree = this.getSelectedPreferences("YearThree", "easiHeatWarrantyThreeYearsModulePreference");
        /** @type {?} */
        var PrvAllowed = this.getSelectedPreferences("PrvAllowed", "easiHeatPRVAvailableOnEHHCC");
        /** @type {?} */
        var HideHEmodelFromSizing = this.getSelectedPreferences("HideHEmodelFromSizing", "easiHeatHideHEModelFromSizing");
        /** @type {?} */
        var EnergyMonitoringAvailableDHW = this.getSelectedPreferences("EnergyMonitoringAvailableDHW", "easiHeatEnergyMonitoring_Available_DHW");
        /** @type {?} */
        var EnergyMonitoringDefaultDHW = this.getSelectedPreferences("EnergyMonitoringDefaultDHW", "easiHeatEnergyMonitoring_Default_DHW");
        /** @type {?} */
        var JackingWheelsAvailableDHW = this.getSelectedPreferences("JackingWheelsAvailableDHW", "easiHeatJackingWheels_Available_DHW");
        /** @type {?} */
        var JackingWheelsDefaultDHW = this.getSelectedPreferences("JackingWheelsDefaultDHW", "easiHeatJackingWheels_Default_DHW");
        /** @type {?} */
        var ENCompliantAvailableDHW = this.getSelectedPreferences("ENCompliantAvailableDHW", "easiHeatENCompliant_Available_DHW");
        /** @type {?} */
        var ENCompliantDefaultDHW = this.getSelectedPreferences("ENCompliantDefaultDHW", "easiHeatENCompliant_Default_DHW");
        /** @type {?} */
        var EnergyMonitoringAvailableHTG = this.getSelectedPreferences("EnergyMonitoringAvailableHTG", "easiHeatEnergyMonitoring_Available_HTG");
        /** @type {?} */
        var EnergyMonitoringDefaultHTG = this.getSelectedPreferences("EnergyMonitoringDefaultHTG", "easiHeatEnergyMonitoring_Default_HTG");
        /** @type {?} */
        var JackingWheelsAvailableHTG = this.getSelectedPreferences("JackingWheelsAvailableHTG", "easiHeatJackingWheels_Available_HTG");
        /** @type {?} */
        var JackingWheelsDefaultHTG = this.getSelectedPreferences("JackingWheelsDefaultHTG", "easiHeatJackingWheels_Default_HTG");
        /** @type {?} */
        var ENCompliantAvailableHTG = this.getSelectedPreferences("ENCompliantAvailableHTG", "easiHeatENCompliant_Available_HTG");
        /** @type {?} */
        var ENCompliantDefaultHTG = this.getSelectedPreferences("ENCompliantDefaultHTG", "easiHeatENCompliant_Default_HTG");
        newModulePreferences.push(sellingCurrency);
        newModulePreferences.push(manufacturer);
        newModulePreferences.push(manufacturerCurrency);
        newModulePreferences.push(HETS6Discount);
        newModulePreferences.push(HEM6Discount);
        newModulePreferences.push(HEM8Discount);
        newModulePreferences.push(HEM10Discount);
        newModulePreferences.push(HEPricingCurrency);
        newModulePreferences.push(HEOverridenP251MarkupValue);
        newModulePreferences.push(HEOverridenP251Markup);
        newModulePreferences.push(SellingMarkup);
        newModulePreferences.push(LandedCostIncrease);
        newModulePreferences.push(DeliveryCost);
        newModulePreferences.push(Commission);
        newModulePreferences.push(CVSplitRange);
        newModulePreferences.push(SellSteamControl);
        newModulePreferences.push(MotiveInletPressureAvailable);
        newModulePreferences.push(YearOne);
        newModulePreferences.push(YearTwo);
        newModulePreferences.push(YearThree);
        newModulePreferences.push(PrvAllowed);
        newModulePreferences.push(HideHEmodelFromSizing);
        newModulePreferences.push(EnergyMonitoringAvailableDHW);
        newModulePreferences.push(EnergyMonitoringDefaultDHW);
        newModulePreferences.push(JackingWheelsAvailableDHW);
        newModulePreferences.push(JackingWheelsDefaultDHW);
        newModulePreferences.push(ENCompliantAvailableDHW);
        newModulePreferences.push(ENCompliantDefaultDHW);
        newModulePreferences.push(EnergyMonitoringAvailableHTG);
        newModulePreferences.push(EnergyMonitoringDefaultHTG);
        newModulePreferences.push(JackingWheelsAvailableHTG);
        newModulePreferences.push(JackingWheelsDefaultHTG);
        newModulePreferences.push(ENCompliantAvailableHTG);
        newModulePreferences.push(ENCompliantDefaultHTG);
        // Save the changed preferences as an array of preferences
        this.adminService.manageModulePreferences(newModulePreferences).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            // The form can be submitted again.
            this.formSubmitted = false;
            // Set the operation based on the response.
            this.isSuccess = response;
            this.alertVisible = true;
        }));
        /** @type {?} */
        var newEnumerationModulePreferences = this.GetNewEnumerationModulePreferences();
        // Save the changed preferences as an array of preferences
        this.adminService.manageEnumerationModulePreferences(newEnumerationModulePreferences).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        (response) => {
            // The form can be submitted again.
            this.formSubmitted = false;
            // Set the operation based on the response.
            this.isSuccess = response;
            this.alertVisible = true;
            this.modulePreferencesForm.markAsPristine(); // to drive GenericChangesGuard
        }));
    }
    /**
     * @return {?}
     */
    GetNewEnumerationModulePreferences() {
        // Enumeration Module Preferences.
        /** @type {?} */
        const newEnumerationModulePreferences = [];
        // Actuator
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomActuatorDHW_EasiHeat", "easi_Heat_DHW_And_HTG_Sc_Options_Actuator"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomActuatorHTG_EasiHeat", "easi_HTG_CC_Options_Actuator"));
        // Design Code
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomDesignCodeDHW_EasiHeat", "easiHeatDHWandHTGScOptions_DesignCode"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomDesignCodeHTG_EasiHeat", "easi_HTG_CC_Options_DesignCode"));
        // High Limit
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomHighLimitDHW_EasiHeat", "easiHeatDHWandHTGScOptions_HighLimit"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomHighLimitHTG_EasiHeat", "easi_HTG_CC_Options_HighLimit"));
        // High Limit Actuation
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomHighLimitActuationDHW_EasiHeat", "easiHeatDHWandHTGScOptions_HighLimitActuation"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomHighLimitActuationHTG_EasiHeat", "easi_HTG_CC_Options_HighLimitActuation"));
        // Isolation
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomIsolationDHW_EasiHeat", "easiHeatDHWandHTGScOptions_Isolation"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomIsolationHTG_EasiHeat", "easi_HTG_CC_Options_Isolation"));
        // Control Panel
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomPanelTypeDHW_EasiHeat", "easiHeatDHWandHTGScOptions_ControlPanel"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomPanelTypeHTG_EasiHeat", "easi_HTG_CC_Options_ControlPanel"));
        // Service Offering
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("WarrantyDHW_EasiHeat", "easiHeatDHWandHTGScOptions_ServiceOffering"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("WarrantyHTG_EasiHeat", "easi_HTG_CC_Options_ServiceOffering"));
        // Gasket
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomGasketDHW_EasiHeat", "easiHeatDHWandHTGScOptions_Gasket"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomGasketHTG_EasiHeat", "easi_HTG_CC_Options_Gasket"));
        // Remote Access
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomRemoteAccessDHW_EasiHeat", "easiHeatDHWandHTGScOptions_RemoteAccess"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomRemoteAccessHTG_EasiHeat", "easi_HTG_CC_Options_RemoteAccess"));
        // Communications
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomCommunicationsDHW_EasiHeat", "easiHeatDHWandHTGScOptions_Communications"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("NomCommunicationsHTG_EasiHeat", "easi_HTG_CC_Options_Communications"));
        // Additional Options
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("easiHeat_DHW_AdditionalOptions", "easiHeat_DHW_AdditionalOptions"));
        newEnumerationModulePreferences.push(this.getSelectedEnumerationPreferences("easiHeat_HTG_AdditionalOptions", "easiHeat_HTG_AdditionalOptions"));
        return newEnumerationModulePreferences;
    }
    /*
      * Method to get opco selected enumeration module prefernce details for each options.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} prefsFormKeyName
     * @return {?}
     */
    getSelectedEnumerationPreferences(enumerationPickerName, prefsFormKeyName) {
        /** @type {?} */
        var modPrefs = new Enumeration;
        modPrefs.enumerationName = enumerationPickerName;
        modPrefs.opCoOverride = true;
        modPrefs.enumerationDefinitions = this.modulePreferencesForm.controls[prefsFormKeyName].value;
        //modPrefs.enumerationDefinitions.find(e => e.value == prefsFormKeyName);
        //this.modulePreferencesForm.controls[prefsFormKeyName].value;
        return modPrefs;
    }
    /*
      * Method to get opco selected module prefernce details.
      */
    /**
     * @param {?} enumerationPickerName
     * @param {?} prefsFormKeyName
     * @return {?}
     */
    getSelectedPreferences(enumerationPickerName, prefsFormKeyName) {
        /** @type {?} */
        var modPrefs = new ModulePreferenceDetails;
        modPrefs.name = enumerationPickerName;
        modPrefs.value = "" + this.modulePreferencesForm.controls[prefsFormKeyName].value;
        modPrefs.moduleId = +this.moduleId;
        modPrefs.isDeleted = false;
        modPrefs.OperatingCompanyId = 42;
        return modPrefs;
    }
    /**
     * @return {?}
     */
    closeAlert() {
        // Reset the flag
        this.alertVisible = false;
    }
    /**
     * @return {?}
     */
    onChange() {
        this.modulePreferencesForm.markAsDirty();
        // this.modulePreferencesForm.disabled == false;
    }
    /**
     * @return {?}
     */
    onChangeAnyOption() {
        // Any enumeration-picker (on-change) set the form data to dirty.
        this.modulePreferencesForm.markAsDirty();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onEasiHeatOptionsChange(event) {
        this.easiHeatOptionsSelectedItem = event.selectedValue;
        this.easiHeatOptionsFormControl.markAsPristine(); // Options list selector is not a data change item, so ignore changes.
    }
    /*
      * Method to calculate the currency conversion rate.
      */
    /**
     * @param {?} selectedValue
     * @return {?}
     */
    onSellingCurrencyChange(selectedValue) {
        this.easiHeatManufacturerCurrencyId = +this.easiHeatManufacturerCurrencyModulePreference.value;
        if (selectedValue > 0 && this.easiHeatManufacturerCurrencyId > 0 && this.currencyList.length > 0) {
            /** @type {?} */
            let sellingCurrency = this.currencyList.find((/**
             * @param {?} c
             * @return {?}
             */
            c => c.id === +selectedValue));
            /** @type {?} */
            let manufacturerCurrency = this.currencyList.find((/**
             * @param {?} c
             * @return {?}
             */
            c => c.id === this.easiHeatManufacturerCurrencyId));
            this.easiHeatSellingCurrencySymbol = sellingCurrency.symbol;
            this.easiHeatCurrencyConversion = +((manufacturerCurrency.rateToGbp * (1 / sellingCurrency.rateToGbp)).toFixed(5));
        }
    }
    /*
      * Method to retrieve the module pref value from the list.
      */
    /**
     * @param {?} modulePrefList
     * @param {?} modulePrefName
     * @return {?}
     */
    getModulePreferenceValue(modulePrefList, modulePrefName) {
        /** @type {?} */
        let modPref = modulePrefList.filter((/**
         * @param {?} r
         * @return {?}
         */
        r => r.name === modulePrefName));
        if (modPref && modPref.length > 0) {
            return modPref[0].value;
        }
    }
    /**
     * @param {?} row
     * @return {?}
     */
    getRowClass(row) {
        if (row.isEnabled) {
            return 'row-color-enabled';
        }
        return 'row-color-disabled';
    }
    /**
     * @return {?}
     */
    setOverrideMarkup() {
        this.overrideMarkupActive = !this.overrideMarkupActive;
        this.easiHeatOverrideMarkupActive.setValue(this.overrideMarkupActive);
        if (this.overrideMarkupActive == false) {
            this.easiHeatOverrideMarkup.setValue("0");
        }
        this.toggleSave();
    }
}
EasiHeatPreferencesComponent$1.decorators = [
    { type: Component, args: [{
                selector: 'easiHeat-module-preferences',
                template: "<!--Easiheat module preferences component works!-->\r\n<div *ngIf=\"!componentInitialised\">\r\n  <div class=\"ball-clip-rotate\">\r\n    <div></div>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"componentInitialised\">\r\n  <form [formGroup]=\"modulePreferencesForm\" class=\"form-horizontal\" role=\"form\" (click)=\"toggleSave();\" (submit)=\"submitForm($event)\" novalidate>\r\n    <!--[disabled]=\"!modulePreferencesForm.dirty || !modulePreferencesForm.valid || modulePreferencesForm.status !== 'VALID' || formSubmitted\"-->\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <button [disabled]=\"!modulePreferencesForm.dirty || formSubmitted\" type=\"submit\" class=\"btn btn-dynamic btn-primary pull-right\" [title]=\"'SAVE' | translate:true\"><i class=\"fa fa-save\">  {{'SAVE' | translate:true}}</i></button>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\">\r\n        <br>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Success confirmation message -->\r\n    <alert-block *ngIf=\"!!alertVisible && !!isSuccess\" type=\"success\" [auto-close]=\"true\" [message]=\"'MODULE_PREFERENCES_SAVED_SUCCESSFULLY_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n    <!-- Failure confirmation message-->\r\n    <alert-block *ngIf=\"!!alertVisible && !isSuccess\" type=\"danger\" [message]=\"'MODULE_PREFERENCES_FAILED_TO_SAVE_MESSAGE' | translate\" (close-callback)=\"closeAlert()\"></alert-block>\r\n\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"currencyOptionsHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseCurrencyOptions\" aria-expanded=\"true\" aria-controls=\"collapseCurrencyOptions\">\r\n            {{\"CURRENCY_OPTIONS\" | translate}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapseCurrencyOptions\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"currencyOptionsHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-10px\">\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"row\" style=\"padding-bottom:15px\">\r\n\r\n              <!--Manufacturer-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"MANUFACTURER\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"easiHeatManufacturerModulePreference\">\r\n                  <option *ngFor=\"let manufacturer of manufacturerList\" [value]=\"manufacturer.id\">{{manufacturer.name}}</option>\r\n                </select>\r\n              </div>\r\n\r\n              <!--Selling currency-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"SELLING_CURRENCY\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"easiHeatSellingCurrencyModulePreference\" (ngModelChange)=\"onSellingCurrencyChange($event)\">\r\n                  <option *ngFor=\"let currency of currencyList\" [value]=\"currency.id\">{{currency.currencyCode}} - {{currency.symbol}}</option>\r\n                </select>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n              <!--Manufacturer currency-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"MANUFACTURER_CURRENCY\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <select class=\"form-control\" formControlName=\"easiHeatManufacturerCurrencyModulePreference\">\r\n                  <option *ngFor=\"let currency of currencyList\" [value]=\"currency.id\">{{currency.currencyCode}} - {{currency.symbol}}</option>\r\n                </select>\r\n              </div>\r\n\r\n              <!--Currency conversion-->\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12 text-right\">\r\n                <label class=\"control-label\">{{\"CURRENCY_CONVERSION\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-6 col-xs-12\">\r\n                <label class=\"control-label\">{{easiHeatCurrencyConversion}}</label>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Heat Exchanger Options -->\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"pricingOptionsHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseHeatExchangerOptions\" aria-expanded=\"true\" aria-controls=\"collapsePricingOptions\">\r\n            {{\"HEAT_EXCHANGER_OPTIONS\" | translate}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapseHeatExchangerOptions\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"heatExchangerOptionsHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-30px\">\r\n          <div class=\"form-group\">\r\n            <!--Column 1-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-8 text-right\">\r\n                  <label class=\"control-label\">{{\"DISCOUNT_RATE\" | translate}}</label>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <!--TS6-->\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"TS6\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatHeatExchangerTS6\" value=\"easiHeatTS6\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatHeatExchangerTS6'].hasError('required') && (modulePreferencesForm.controls['easiHeatHeatExchangerTS6'].dirty || modulePreferencesForm.controls['easiHeatHeatExchangerTS6'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!--T6-->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"T6\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatHeatExchangerT6\" value=\"easiHeatT6\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatHeatExchangerT6'].hasError('required') && (modulePreferencesForm.controls['easiHeatHeatExchangerT6'].dirty || modulePreferencesForm.controls['easiHeatHeatExchangerT6'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!--T8-->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"T8\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatHeatExchangerT8\" value=\"easiHeatT8\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatHeatExchangerT8'].hasError('required') && (modulePreferencesForm.controls['easiHeatHeatExchangerT8'].dirty || modulePreferencesForm.controls['easiHeatHeatExchangerT8'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!--T10-->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"T10\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatHeatExchangerT10\" value=\"easiHeatT10\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatHeatExchangerT10'].hasError('required') && (modulePreferencesForm.controls['easiHeatHeatExchangerT10'].dirty || modulePreferencesForm.controls['easiHeatHeatExchangerT10'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Column 2-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"row\" style=\"padding-bottom: 20px;\">\r\n                <!-- Pricing Currency -->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"PRICING_CURRENCY\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <select class=\"form-control\" formControlName=\"easiHeatPricingCurrency\" (ngModelChange)=\"onSellingCurrencyChange($event)\">\r\n                      <option *ngFor=\"let currency of currencyList\" [value]=\"currency.id\">{{currency.currencyCode}} - {{currency.symbol}}</option>\r\n                    </select>\r\n                  </div>\r\n                </div>\r\n\r\n                <!-- Override Markup Active available -->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"OVERRIDE_GROUP_MARKUP\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <input autocomplete=\"off\"\r\n                             class=\"control-check\"\r\n                             type=\"checkbox\"\r\n                             style=\"width:15px; height:15px;\"\r\n                             formControlName=\"easiHeatOverrideMarkupActive\"\r\n                             value=\"easiHeatOverrideMarkupActive\"\r\n                             (change)=\"setOverrideMarkup()\" />\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n                <!--Override Markup-->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"OVERRIDE_MARKUP\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <input *ngIf=\"overrideMarkupActive\" autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatOverrideMarkup\" value=\"easiHeatOverrideMarkup\" twoDigitDecimalNumber />\r\n                      <input *ngIf=\"!overrideMarkupActive\" disabled=\"disabled\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" />\r\n                      <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatOverrideMarkup'].hasError('required') && (modulePreferencesForm.controls['easiHeatOverrideMarkup'].dirty || modulePreferencesForm.controls['easiHeatOverrideMarkup'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n\r\n\r\n    <!--Pricing Options-->\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"pricingOptionsHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapsePricingOptions\" aria-expanded=\"true\" aria-controls=\"collapsePricingOptions\">\r\n            {{\"PRICING_OPTIONS\" | translate}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapsePricingOptions\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"pricingOptionsHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-30px\">\r\n          <div class=\"form-group\">\r\n            <!--Column 1-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <!--Selling Markup-->\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"SELLING_MARKUP\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" (input)=\"onChange();\" formControlName=\"easiHeatSellingMarkup\" value=\"easiHeatSellingMarkup\" twoDigitDecimalNumber />\r\n\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatSellingMarkup'].hasError('required') && (modulePreferencesForm.controls['easiHeatSellingMarkup'].dirty || modulePreferencesForm.controls['easiHeatSellingMarkup'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <!--Landed Cost-->\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"LANDED_COST_INCREASE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatLandedCostIncreaseModPref\" value=\"easiHeatLandedCostIncreaseModPref\" twoDigitDecimalNumber />\r\n                    <span class=\"input-group-addon\">{{\"PERCENT\" | translate}}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatLandedCostIncreaseModPref'].hasError('required') && (modulePreferencesForm.controls['easiHeatLandedCostIncreaseModPref'].dirty || modulePreferencesForm.controls['easiHeatLandedCostIncreaseModPref'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!--Delivery Cost-->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"DELIVERY_COST\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-addon\">{{easiHeatSellingCurrencySymbol}}</span>\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatDeliveryCostModPref\" value=\"easiHeatDeliveryCost\" (input)=\"onChange();\" twoDigitDecimalNumber />\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatDeliveryCostModPref'].hasError('required') && (modulePreferencesForm.controls['easiHeatDeliveryCostModPref'].dirty || modulePreferencesForm.controls['easiHeatDeliveryCostModPref'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!-- Commission only price -->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"COMMISSION_ONLY_PRICE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-addon\">{{easiHeatSellingCurrencySymbol}}</span>\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatCommissionOnly\" value=\"easiHeatCommissionOnly\" twoDigitDecimalNumber />\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatCommissionOnly'].hasError('required') && (modulePreferencesForm.controls['easiHeatCommissionOnly'].dirty || modulePreferencesForm.controls['easiHeatCommissionOnly'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                </div>\r\n              </div>\r\n              <!-- CV Split Range available -->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"CV_SPLIT_RANGE_AVAILABLE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\"\r\n                           class=\"control-check\"\r\n                           type=\"checkbox\"\r\n                           style=\"width:15px; height:15px;\"\r\n                           formControlName=\"easiHeatCvSplitRange\"\r\n                           value=\"easiHeatCvSplitRange\"\r\n                           (change)=\"toggleSave()\" />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <!-- Steam side control on HTG -->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"STEAM_SIDE_CONTROL_ON_HTG\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"checkbox\" style=\"width:15px; height:15px;\" formControlName=\"easiHeatSteamSideControlOnHTG\" value=\"easiHeatSteamSideControlOnHTG\" (change)=\"toggleSave()\" />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <!-- Motive Inlet Pressure Available -->\r\n              <div class=\"row\" style=\"padding-bottom:15px\">\r\n                <div class=\"col-xs-6 text-right\">\r\n                  <label class=\"control-label\">{{\"MOTIVE_INLET_PRESSURE_AVAILABLE\" | translate}}</label>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <div class=\"input-group\">\r\n                    <input autocomplete=\"off\" class=\"form-control\" type=\"checkbox\" style=\"width:15px; height:15px;\" formControlName=\"easiHeatMotiveInletPressureAvailable\" value=\"easiHeatMotiveInletPressureAvailable\" (change)=\"toggleSave()\" />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Column 2-->\r\n            <div class=\"col-lg-6\">\r\n              <div class=\"panel-body\" style=\"margin-bottom:-30px\">\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-8 text-right\">\r\n                    <h4>{{\"EXTENDED_WARRANTY_PRICE\" | translate}}</h4>\r\n                  </div>\r\n                  <!--<div class=\"col-xs-3 cross-validation-error-class\" *ngIf=\"serviceOffereingMessage\">\r\n                    <div><i class=\"fa fa-info-circle cross-validation-error-class\" [tooltip]=\"serviceOffereingMessage\" placement=\"top,right\"></i></div>\r\n                  </div>-->\r\n                </div>\r\n                <!--</fieldset>-->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--One Year-->\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"ONE_YEAR\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{easiHeatSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatWarrantyOneYearModulePreference\" value=\"easiHeatWarrantyOneYearModulePreference\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatWarrantyOneYearModulePreference'].hasError('required') && (modulePreferencesForm.controls['easiHeatWarrantyOneYearModulePreference'].dirty || modulePreferencesForm.controls['easiHeatWarrantyOneYearModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--Two Years-->\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"TWO_YEARS\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{easiHeatSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatWarrantyTwoYearsModulePreference\" value=\"easiHeatWarrantyTwoYearsModulePreference\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatWarrantyTwoYearsModulePreference'].hasError('required') && (modulePreferencesForm.controls['easiHeatWarrantyTwoYearsModulePreference'].dirty || modulePreferencesForm.controls['easiHeatWarrantyTwoYearsModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <!--Three Years-->\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"THREE_YEARS\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">{{easiHeatSellingCurrencySymbol}}</span>\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"number\" style=\"min-width:55px;\" formControlName=\"easiHeatWarrantyThreeYearsModulePreference\" value=\"easiHeatWarrantyTwoYearsModulePreference\" twoDigitDecimalNumber />\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-2\">\r\n                    <span class=\"text-danger\" *ngIf=\"modulePreferencesForm.controls['easiHeatWarrantyThreeYearsModulePreference'].hasError('required') && (modulePreferencesForm.controls['easiHeatWarrantyThreeYearsModulePreference'].dirty || modulePreferencesForm.controls['easiHeatWarrantyThreeYearsModulePreference'].touched)\">{{ \"REQUIRED_FIELD\" | translate }}</span>\r\n                  </div>\r\n                </div>\r\n\r\n                <!-- PRV available on EHHCC -->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"PRV_AVAILABLE_ON_EHHCC\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"checkbox\" style=\"width:15px; height:15px;\" formControlName=\"easiHeatPRVAvailableOnEHHCC\" value=\"easiHeatPRVAvailableOnEHHCC\" (change)=\"toggleSave()\" />\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n                <!-- Hide HE model from sizing -->\r\n                <div class=\"row\" style=\"padding-bottom:15px\">\r\n                  <div class=\"col-xs-6 text-right\">\r\n                    <label class=\"control-label\">{{\"HIDE_HE_MODEL_FROM_SIZING\" | translate}}</label>\r\n                  </div>\r\n                  <div class=\"col-xs-4\">\r\n                    <div class=\"input-group\">\r\n                      <input autocomplete=\"off\" class=\"form-control\" type=\"checkbox\" style=\"width:15px; height:15px;\" formControlName=\"easiHeatHideHEModelFromSizing\" value=\"easiHeatHideHEModelFromSizing\" (change)=\"toggleSave()\" />\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--Configurartion Options-->\r\n    <div class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"optionConfigurartionHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseOptionConfigurartion\" aria-expanded=\"true\" aria-controls=\"collapseOptionConfigurartion\">\r\n            {{\"OPTION_CONFIGURATION\" | translate}}{{operatingCompany}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <div id=\"collapseOptionConfigurartion\" class=\"panel-collapse collapse show\" role=\"tabpanel\" aria-labelledby=\"optionConfigurartionHeading\">\r\n        <div class=\"panel-body\" style=\"margin-bottom:-20px\">\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-2 text-right\">\r\n                <label class=\"control-label\">{{\"PLEASE_SELECT\" | translate}}</label>\r\n              </div>\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                <enumeration formControlName=\"easiHeatOptionsSelection\" enumeration-name=\"EasiHeat_Options\" (on-change)=\"onEasiHeatOptionsChange($event)\"></enumeration>\r\n              </div>\r\n              <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                <button [disabled]=\"augmentPriceDataProcessing\" class=\"btn btn-dynamic btn-primary pull-right\" type='button' (click)=\"togglePrices();\" [title]=\"'TOGGLE_PRICES' | translate\"><i class=\"fa fa-exchange\">  {{'TOGGLE_PRICES' | translate}}</i></button>\r\n              </div>\r\n            </div>\r\n            <hr>\r\n            <!--Actuator-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Actuator'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_Heat_DHW_And_HTG_Sc_Options_Actuator\" enumeration-picker-name=\"NomActuatorDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_Actuator\" enumeration-picker-name=\"NomActuatorHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Design Code-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Design Code'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_DesignCode\" enumeration-picker-name=\"NomDesignCodeDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_DesignCode\" enumeration-picker-name=\"NomDesignCodeHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--High Limit-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'High Limit'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_HighLimit\" enumeration-picker-name=\"NomHighLimitDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_HighLimit\" enumeration-picker-name=\"NomHighLimitHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--High Limit Actuation-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'High Limit Actuation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_HighLimitActuation\" enumeration-picker-name=\"NomHighLimitActuationDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_HighLimitActuation\" enumeration-picker-name=\"NomHighLimitActuationHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Isolation-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Isolation'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_Isolation\" enumeration-picker-name=\"NomIsolationDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_Isolation\" enumeration-picker-name=\"NomIsolationHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Control Panel-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Control Panel'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_ControlPanel\" enumeration-picker-name=\"NomPanelTypeDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_ControlPanel\" enumeration-picker-name=\"NomPanelTypeHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Service Offering-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Service Offering'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_ServiceOffering\" enumeration-picker-name=\"WarrantyDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_ServiceOffering\" enumeration-picker-name=\"WarrantyHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Gasket-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Gasket'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_OPTIONS}}\">DHW Options</h4><label>{{DHW_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_Gasket\" enumeration-picker-name=\"NomGasketDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_AND_SC_OPTIONS}}\">HTG CC & SC Options</h4><label>{{HTG_CC_AND_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_Gasket\" enumeration-picker-name=\"NomGasketHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Remote Access-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Remote Access'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_RemoteAccess\" enumeration-picker-name=\"NomRemoteAccessDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_RemoteAccess\" enumeration-picker-name=\"NomRemoteAccessHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Communications-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Communications'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW and HTG SC Options {{DHW_AND_HTG_SC_OPTIONS}}\">DHW and HTG SC Options</h4><label>{{DHW_AND_HTG_SC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeatDHWandHTGScOptions_Communications\" enumeration-picker-name=\"NomCommunicationsDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG CC Options {{HTG_CC_OPTIONS}}\">HTG CC Options</h4><label>{{HTG_CC_OPTIONS}}</label>\r\n                  <enumeration-picker formControlName=\"easi_HTG_CC_Options_Communications\" enumeration-picker-name=\"NomCommunicationsHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Additonal Options-->\r\n            <div class=\"panel-body\" [hidden]=\"easiHeatOptionsSelectedItem !== 'Additional Options'\">\r\n              <div class=\"form-group\">\r\n                <!--Column 1-->\r\n                <div class=\"col-lg-6\">\r\n                  <div class=\"row\" style=\"padding-bottom:15px; \">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"DHW\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4 \" style=\"display:inline-block; border:thick; border-color:red;\">\r\n                      <label class=\"control-label\" style=\"display:inline-block; padding-right:10px;\">\r\n                        {{\"AVAILABLE\" | translate}}\r\n                      </label>\r\n                      <label class=\"control-label\" style=\"display:inline-block; border:thick; border-color:red;\">\r\n                        {{\"DEFAULT\" | translate}}\r\n                      </label>\r\n                    </div>\r\n                  </div>\r\n\r\n                  <!-- Energy Monitoring -->\r\n                  <div class=\"row\" style=\"padding-bottom:15px; \">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"ENERGY_MONITORING\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4\">\r\n                      <div class=\"input-group\" style=\"display:inline-block; padding-right: 60px;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatEnergyMonitoring_Available_DHW\"\r\n                               value=\"easiHeatEM_Available_DHW\" />\r\n                      </div>\r\n                      <div class=\"input-group\" style=\"display:inline-block;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatEnergyMonitoring_Default_DHW\"\r\n                               value=\"easiHeatEM_Default_DHW\" />\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <!--<div class=\"row\" style=\"padding-bottom:15px\">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"ENERGY_MONITORING\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4\">\r\n                      <div class=\"input-group\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatCvSplitRange\"\r\n                               value=\"easiHeatCvSplitRange\" />\r\n                      </div>\r\n\r\n                    </div>\r\n                  </div>-->\r\n                  <!-- Jacking Wheels -->\r\n                  <div class=\"row\" style=\"padding-bottom:15px\">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"JACKING_WHEELS\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4\">\r\n                      <div class=\"input-group\" style=\"display:inline-block; padding-right: 60px;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatJackingWheels_Available_DHW\"\r\n                               value=\"easiHeatJW_Available_DHW\" />\r\n                      </div>\r\n                      <div class=\"input-group\" style=\"display:inline-block;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatJackingWheels_Default_DHW\"\r\n                               value=\"easiHeatJW_Default_DHW\" />\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <!-- EN12828 Compliant -->\r\n                  <div class=\"row\" style=\"padding-bottom:15px\">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"EN12828_COMPLIANT\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4\">\r\n                      <div class=\"input-group\" style=\"display:inline-block; padding-right: 60px;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatENCompliant_Available_DHW\"\r\n                               value=\"easiHeatENC_Available_DHW\" />\r\n                      </div>\r\n                      <div class=\"input-group\" style=\"display:inline-block;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatENCompliant_Default_DHW\"\r\n                               value=\"easiHeatENC_Default_DHW\" />\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <!--Column 2-->\r\n                <div class=\"col-lg-6\">\r\n                  <div class=\"row\" style=\"padding-bottom:15px; \">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"HTG\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4 \" style=\"display:inline-block;\">\r\n                      <label class=\"control-label\" style=\"display:inline-block; padding-right:10px; border:thick; border-color:red;\">\r\n                        {{\"AVAILABLE\" | translate}}\r\n                      </label>\r\n                      <label class=\"control-label\" style=\"display:inline-block; border:thick; border-color:red;\">\r\n                        {{\"DEFAULT\" | translate}}\r\n                      </label>\r\n                    </div>\r\n                  </div>\r\n\r\n                  <!-- Energy Monitoring -->\r\n                  <div class=\"row\" style=\"padding-bottom:15px; \">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"ENERGY_MONITORING\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4\">\r\n                      <div class=\"input-group\" style=\"display:inline-block; padding-right: 60px;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatEnergyMonitoring_Available_HTG\"\r\n                               value=\"easiHeatEM_Available_HTG\" />\r\n                      </div>\r\n                      <div class=\"input-group\" style=\"display:inline-block;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatEnergyMonitoring_Default_HTG\"\r\n                               value=\"easiHeatEM_Default_HTG\" />\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <!--<div class=\"row\" style=\"padding-bottom:15px\">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"ENERGY_MONITORING\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4\">\r\n                      <div class=\"input-group\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatCvSplitRange\"\r\n                               value=\"easiHeatCvSplitRange\" />\r\n                      </div>\r\n\r\n                    </div>\r\n                  </div>-->\r\n                  <!-- Jacking Wheels -->\r\n                  <div class=\"row\" style=\"padding-bottom:15px\">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"JACKING_WHEELS\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4\">\r\n                      <div class=\"input-group\" style=\"display:inline-block; padding-right: 60px;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatJackingWheels_Available_HTG\"\r\n                               value=\"easiHeatJW_Available_HTG\" />\r\n                      </div>\r\n                      <div class=\"input-group\" style=\"display:inline-block;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatJackingWheels_Default_HTG\"\r\n                               value=\"easiHeatJW_Default_HTG\" />\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <!-- EN12828 Compliant -->\r\n                  <div class=\"row\" style=\"padding-bottom:15px\">\r\n                    <div class=\"col-xs-6 text-right\">\r\n                      <label class=\"control-label\">{{\"EN12828_COMPLIANT\" | translate}}</label>\r\n                    </div>\r\n                    <div class=\"col-xs-4\">\r\n                      <div class=\"input-group\" style=\"display:inline-block; padding-right: 60px;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatENCompliant_Available_HTG\"\r\n                               value=\"easiHeatENC_Available_HTG\" />\r\n                      </div>\r\n                      <div class=\"input-group\" style=\"display:inline-block;\">\r\n                        <input autocomplete=\"off\"\r\n                               class=\"control-check\"\r\n                               type=\"checkbox\"\r\n                               style=\"width:15px; height:15px;\"\r\n                               formControlName=\"easiHeatENCompliant_Default_HTG\"\r\n                               value=\"easiHeatENC_Default_HTG\" />\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!--<div class=\"row\">\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"DHW {{DHW}}\">DHW</h4><label>{{DHW}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeat_DHW_AdditionalOptions\" enumeration-picker-name=\"NomAdditionalOptionsDHW_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n                <div class=\"col-lg-3 col-md-6 col-xs-12\">\r\n                  <h4 title=\"HTG {{HTG}}\">HTG</h4><label>{{HTG}}</label>\r\n                  <enumeration-picker formControlName=\"easiHeat_HTG_AdditionalOptions\" enumeration-picker-name=\"NomAdditionalOptionsHTG_EasiHeat\" (on-change)=\"onChangeAnyOption();\"></enumeration-picker>\r\n                </div>\r\n              </div>-->\r\n\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n\r\n    <a #collapsePriceDataTop href=\"#collapsePriceDataTop\"> </a>\r\n\r\n\r\n<!--Price Data Grid -->\r\n    <div *ngIf=\"!!easiHeatBOMOutputData.bomItems && easiHeatBOMOutputData.bomItems.length > 0 && showPrices\" class=\"panel panel-primary\">\r\n      <div class=\"panel-heading\" role=\"tab\" id=\"priceDataHeading\">\r\n        <h4 class=\"panel-title\">\r\n          <a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapsePriceData\" aria-expanded=\"true\" aria-controls=\"collapsePriceData\">\r\n            {{\"Price Data\"}} - {{'EASIHEAT' | translate:true}}{{operatingCompany}}\r\n          </a>\r\n        </h4>\r\n      </div>\r\n      <!-- Price Data Grid  -->\r\n      <div class=\"panel-body\">\r\n        <div class=\"col-xs-12\">\r\n\r\n          <ngx-datatable #easiHeatBOMOutputDataTable\r\n                         class=\"bootstrap\"\r\n                         [headerHeight]=\"40\"\r\n                         [limit]=\"50\"\r\n                         [columnMode]=\"'force'\"\r\n                         [footerHeight]=\"40\"\r\n                         [rowHeight]=\"'auto'\"\r\n                         [rows]=\"easiHeatBOMOutputData.bomItems\">\r\n\r\n\r\n\r\n            <!--[rowClass]=\"getRowClass\">-->\r\n            <!--  [selected]=\"selectedOutputData\"\r\n             [selectionType]=\"'single'\"\r\n             (select)=\"onSelect($event)\"\r\n        -->\r\n            <!-- Row Detail Template -->\r\n            <!--<ngx-datatable-row-detail [rowHeight]=\"getHeight\" #myDetailRow>\r\n          <ng-template let-row=\"row\" let-expanded=\"expanded\" ngx-datatable-row-detail-template>\r\n            <div *ngFor=\"let m of row.modelSizingMessages\">\r\n              <div class=\"row col-xs-12\">\r\n                <div class=\"col-xs-1 text-center\">\r\n                  <i [class]=\"getSeverityIcon(m.severity)\"></i>\r\n                </div>\r\n                <div class=\"col-xs-10\">\r\n                  <span>{{m.messageKey | translate}}</span>\r\n                  <span *ngIf=\"m.value !== 0 && m.unitKey\"> ({{m.value}} {{m.unitKey | translate:false}})</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </ng-template>\r\n        </ngx-datatable-row-detail>-->\r\n            <!-- Column Template -->\r\n            <!--<ngx-datatable-column>\r\n          <ng-template let-row=\"row\" let-expanded=\"expanded\" ngx-datatable-cell-template>\r\n            <i [class]=\"getRowSeverityIcon(row)\"></i>\r\n          </ng-template>\r\n        </ngx-datatable-column>-->\r\n            <!--Columns-->\r\n            <ngx-datatable-column [name]=\"'Number'\" prop=\"rowOrder\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Type'\" prop=\"itemType\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'ModelId'\" prop=\"modelId\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Option Group'\" prop=\"parentMasterTextKey\" [width]=\"200\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <!--<span *ngIf=\"!!value && value.indexOf('easiHeat_')!==0\">{{value | translate}}</span>\r\n                <span *ngIf=\"!!value && value.indexOf('easiHeat_')==0\">{{value.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>-->\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Option'\" prop=\"itemMasterTextKey\" [width]=\"200\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span [style.background]=\"!row.isEnabled ? 'Plum' : ' '\" *ngIf=\"!!value && value.indexOf('EH')!==0 && value.indexOf('Easiheat_')!==0 && value.indexOf('Nom')!==0\">{{value | translate}}</span>\r\n                <span [style.background]=\"!row.isEnabled ? 'Plum' : ' '\" *ngIf=\"!!value && value.indexOf('EH')==0\">{{value.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'SSP'\" prop=\"ssp\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol==easiHeatSellingCurrencySymbol\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol!==easiHeatSellingCurrencySymbol || row.modelId==0\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{easiHeatSellingCurrencySymbol}} {{localizeValue(row.sSSP,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Updated (yyyy-mm-dd)'\" prop=\"priceDataUTCDate\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">                \r\n                <span *ngIf=\"!!value\">{{value.split('T')[0]}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <!--<ngx-datatable-column [name]=\"'x'\" prop=\"ssPtoRSPfactor\" [width]=\"40\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"value!==0\">x {{value}} =</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>-->\r\n\r\n            <ngx-datatable-column [name]=\"'RSP'\" prop=\"recommendedSalesPrice\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <!--<span *ngIf=\"easiHeatManufacturerCurrencySymbol==easiHeatSellingCurrencySymbol\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol!==easiHeatSellingCurrencySymbol || row.modelId==0\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{easiHeatSellingCurrencySymbol}} {{localizeValue(row.sRecommendedSalesPrice,0)}})</span>-->\r\n                Unsupported\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <!--<ngx-datatable-column [name]=\"'RSP override'\" prop=\"recommendedSalesPriceOverride\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol==easiHeatSellingCurrencySymbol\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol!==easiHeatSellingCurrencySymbol || row.modelId==0\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{easiHeatSellingCurrencySymbol}} {{localizeValue(row.sRecommendedSalesPriceOverride,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>-->\r\n\r\n            <!--<ngx-datatable-column [name]=\"'Display Price'\" prop=\"displayedRSP\" [width]=\"100\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol==easiHeatSellingCurrencySymbol\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}}</span>\r\n                <span *ngIf=\"easiHeatManufacturerCurrencySymbol!==easiHeatSellingCurrencySymbol || row.modelId==0\">{{easiHeatManufacturerCurrencySymbol}} {{localizeValue(value,0)}} ({{easiHeatSellingCurrencySymbol}} {{localizeValue(row.sDisplayedRSP,0)}})</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>-->\r\n\r\n            <ngx-datatable-column [name]=\"'Model'\" prop=\"parent\" [width]=\"30\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <!--<span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('easiHeat_')!==0\">{{value}}</span>\r\n  <span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('easiHeat_')==0\">{{value}} {{row.parentMasterTextKey.split('_')[1]}} {{row.parentMasterTextKey.split('_')[2]}}</span>-->\r\n                {{value}}\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <ngx-datatable-column [name]=\"'Nomenclature'\" prop=\"item\" [width]=\"50\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"!!value.split('_')[1]\">{{value.split('_')[1]}}</span>\r\n                <!--<span *ngIf=\"!value.split('_')[1]\">{{value}}</span>-->\r\n                <span *ngIf=\"!!row.parentMasterTextKey && row.parentMasterTextKey.indexOf('easiHeat_')==0\">{{row.parentMasterTextKey.replace(\"_\",\" \").replace(\"_\",\" \")}}</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>\r\n\r\n            <!--[style.background]=\"row.isEnabled ? 'White' : 'SlateGray'\"-->\r\n            <!--<ngx-datatable-column [name]=\"'Enabled'\" prop=\"isEnabled\" [width]=\"20\">\r\n              <ng-template ngx-datatable-cell-template let-rowIndex=\"rowIndex\" let-value=\"value\" let-row=\"row\">\r\n                <span *ngIf=\"value\">+</span>\r\n                <span *ngIf=\"!value\">-</span>\r\n              </ng-template>\r\n            </ngx-datatable-column>-->\r\n\r\n          </ngx-datatable>\r\n\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n</form>\r\n  </div>\r\n",
                providers: [EasiHeatService$1],
                styles: [".cross-validation-error-class{font-size:25px;color:#708090}"]
            }] }
];
/** @nocollapse */
EasiHeatPreferencesComponent$1.ctorParameters = () => [
    { type: RoutesService },
    { type: AdminService },
    { type: TranslationService },
    { type: FormBuilder },
    { type: TranslatePipe },
    { type: ModulePreferenceService },
    { type: EasiHeatService$1 },
    { type: LocaleService$1 },
    { type: UserProfileService },
    { type: User }
];
EasiHeatPreferencesComponent$1.propDecorators = {
    easiHeatBOMOutputDataTable: [{ type: ViewChild, args: ["easiHeatBOMOutputDataTable", { static: false },] }],
    collapsePriceDataTop: [{ type: ViewChild, args: ['collapsePriceDataTop', { static: false },] }]
};
if (false) {
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.moduleId;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.moduleGroupId;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.cloneDeep;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.moduleName;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatBOMOutputDataTable;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.collapsePriceDataTop;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.componentInitialised;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.componentLoadPromises;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.theFormGroup;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.hasUnsavedDataChanges;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.isSuccess;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.alertVisible;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.formSubmitted;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatOptionsSelectedItem;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.manufacturerList;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.currencyList;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatManufacturerCurrencyId;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatManufacturerCurrency;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatManufacturerCurrencySymbol;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatSellingCurrencyId;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatSellingCurrencySymbol;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatCurrencyConversion;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatLandedCostIncrease;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatDeliveryCost;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatCommissionOnlyPrice;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatWarrantyOneYear;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatWarrantyTwoYears;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatWarrantyThreeYears;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatHeatExchangerTS6;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatHeatExchangerT6;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatHeatExchangerT8;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatHeatExchangerT10;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatPricingCurrency;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatOverrideMarkup;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatOverrideMarkupActive;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatSellingMarkup;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatLandedCostIncreaseModPref;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatDeliveryCostModPref;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatCommissionOnly;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatCvSplitRange;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatSteamSideControlOnHTG;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatMotiveInletPressureAvailable;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatPRVAvailableOnEHHCC;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatHideHEModelFromSizing;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easi_Heat_DHW_And_HTG_Sc_Options_Actuator;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easi_HTG_CC_Options_Actuator;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatDHWandHTGScOptions_DesignCode;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easi_HTG_CC_Options_DesignCode;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatDHWandHTGScOptions_HighLimit;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easi_HTG_CC_Options_HighLimit;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatDHWandHTGScOptions_HighLimitActuation;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easi_HTG_CC_Options_HighLimitActuation;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatDHWandHTGScOptions_Isolation;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easi_HTG_CC_Options_Isolation;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatDHWandHTGScOptions_ControlPanel;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easi_HTG_CC_Options_ControlPanel;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatDHWandHTGScOptions_ServiceOffering;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easi_HTG_CC_Options_ServiceOffering;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatDHWandHTGScOptions_Gasket;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easi_HTG_CC_Options_Gasket;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatDHWandHTGScOptions_RemoteAccess;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easi_HTG_CC_Options_RemoteAccess;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatDHWandHTGScOptions_Communications;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easi_HTG_CC_Options_Communications;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeat_DHW_AdditionalOptions;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeat_HTG_AdditionalOptions;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatDHWAvailable;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatDHWOn;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatDHWOff;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatHTGAvailable;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatHTGOn;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatHTGOff;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatEnergyMonitoring_Available_DHW;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatEnergyMonitoring_Default_DHW;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatJackingWheels_Available_DHW;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatJackingWheels_Default_DHW;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatENCompliant_Available_DHW;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatENCompliant_Default_DHW;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatEnergyMonitoring_Available_HTG;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatEnergyMonitoring_Default_HTG;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatJackingWheels_Available_HTG;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatJackingWheels_Default_HTG;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatENCompliant_Available_HTG;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatENCompliant_Default_HTG;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.modulePreferencesForm;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatManufacturerPrefFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatManufacturerCurrencyModulePreference;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatSellingCurrencyPrefFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatLandedCostIncreasePrefFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatDeliveryCostPrefFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatCommissionOnlyPricePrefFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatWarrantyOneYearPrefFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatWarrantyTwoYearsPrefFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatWarrantyThreeYearsPrefFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatOptionsFormControl;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.serviceOffereingMessage;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.deliveryCostMessage;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatPricing;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatBOMOutputData;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.easiHeatBOMOutputDataRows;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.manufacturerId;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.DHW_OPTIONS;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.HTG_CC_AND_SC_OPTIONS;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.DHW_AND_HTG_SC_OPTIONS;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.HTG_CC_OPTIONS;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.DHW;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.HTG;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.showPrices;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.augmentPriceDataProcessing;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.overrideMarkupActive;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.cvSplitRange;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.SellSteamControl;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.MotiveInletPressureAvailable;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.YearOne;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.YearTwo;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.YearThree;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.PrvAllowed;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.HideHEmodelFromSizing;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.operatingCompany;
    /** @type {?} */
    EasiHeatPreferencesComponent$1.prototype.scrollToElement;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent$1.prototype.routesService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent$1.prototype.adminService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent$1.prototype.translationService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent$1.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent$1.prototype.translatePipe;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent$1.prototype.modulePreferenceService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent$1.prototype.easiHeatService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent$1.prototype.localeService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent$1.prototype.userProfileService;
    /**
     * @type {?}
     * @private
     */
    EasiHeatPreferencesComponent$1.prototype.user;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/admin/passwordReset.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PasswordResetResponse {
}
if (false) {
    /** @type {?} */
    PasswordResetResponse.prototype.id;
    /** @type {?} */
    PasswordResetResponse.prototype.userId;
    /** @type {?} */
    PasswordResetResponse.prototype.created;
    /** @type {?} */
    PasswordResetResponse.prototype.expiry;
    /** @type {?} */
    PasswordResetResponse.prototype.uniqueCode;
    /** @type {?} */
    PasswordResetResponse.prototype.message;
    /** @type {?} */
    PasswordResetResponse.prototype.verificationSucceeded;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: sizing-shared-lib.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AdminComponent, AdminModule, AdminService, AuthenticatedUser, AuthenticationGuard, AuthenticationModule, AuthenticationService, BaseSizingModule, CalculationsService, CleanSteamGeneratorFBHalfPipeModulePreferencesComponent, CleanSteamGeneratorFBMiniModulePreferencesComponent, CleanSteamGeneratorFBModulePreferencesComponent, CleanSteamGeneratorModulePreferencesComponent, CoreModule, Country, Currency, CurrencyComponent, DisplayGroup, DisplayPreferenceDirective, DocGen, DocGenService, EasiHeatGen4PreferencesComponent, EasiHeatPreferencesComponent$1 as EasiHeatPreferencesComponent, Enumeration, EnumerationComponent, EnumerationDefinition, GenericChangesGuard, GetJobRequest, GetSizingJobRequest, Job, JobResponse, JobSizing, JobStatus, JobStatusesResponse, Language, LayoutService, MenuService, Message, MessagesModule, MessagesService, Module, ModuleAccessComponent, ModuleGroup, ModuleListItem, ModulePreferenceDetails, ModulePreferenceResolver, ModulePreferenceService, ModulePreferencesComponent, OperatingCompanyPreferencesComponent, OutputGrid, OutputGridRow, OutputGridRowMessageItem, OutputItem, PasswordResetResponse, Preference, PreferenceDecimalPipe, PreferenceModule, PreferenceResolver, PreferenceService, ProcessCondition, ProcessInput, ProductSelectionAdminComponent$1 as ProductSelectionAdminComponent, ProductSelectionComponent, Project, ProjectResponse, ProjectsAndJobs, ProjectsJobsComponent, ProjectsJobsModule, ProjectsJobsService, RoutesService, RoutingState, SaveLoadModalComponent, SettingsService, SharedModule, SharedService, SizingData, SizingModuleAccessGuard, SizingModuleAccessModule, SizingModuleAccessService, SizingModuleChangesGuard, SizingOutput, SizingSharedLibComponent, SizingSharedLibModule, SizingSuiteModalComponent, SizingSuiteModalModule, SpecSheetItem, SyncClientComponent, SyncClientModule, TiDocumentInfo, TiDocumentInfosModel, TiRequestModel, TranslatePipe, Translation, TranslationComponent, TranslationModule, TranslationResolver, TranslationService, UnitConvert, UnitsConverter, UnitsModalComponent, UnitsService, User, UserPreferencesComponent, UserProfileComponent, UserProfileModule, UserProfileService, UserValidator, menu, AlertsModule as ɵa, AlertsComponent as ɵb, NumberOnlyDirective as ɵba, TwoDigitDecimalNumberDirective as ɵbb, ModuleRibbonComponent as ɵbc, SpiraxTextareaDirective as ɵbd, MessagesComponent as ɵbe, HttpInterceptorService as ɵbf, SyncClientService as ɵbg, ErrorInterceptor as ɵbh, GlobalErrorHandler as ɵbi, CleanSteamGeneratorService as ɵbj, CleanSteamGeneratorFBService as ɵbk, EasiHeatPreferencesComponent as ɵbl, EasiHeatService as ɵbm, EasiHeatGen4Service as ɵbn, SteamGenerationAssessmentModulePreferencesComponent as ɵbo, ProductSelectionAdminComponent as ɵbp, ProductSelectionAdminService$1 as ɵbq, FlowmeterProductSelectionAdminComponent as ɵbr, FlowmeterProductSelectionAdminService$1 as ɵbs, ProductSelectionAdminService as ɵbt, FlowmeterProductSelectionAdminService as ɵbu, JobsComponent as ɵbv, EasiHeatService$1 as ɵbw, EnumerationModule as ɵc, SpiraxInputDirectiveModule as ɵd, SpiraxInputDirective as ɵe, EnumerationPickerModule as ɵf, EnumerationPickerComponent as ɵg, PreferenceComponent as ɵh, ProductSelectorModule as ɵi, ProductSelectorComponent as ɵj, ProductSelectorService as ɵk, UnitsModule as ɵl, SaveLoadModule as ɵm, SaveLoadService as ɵn, SpiraxFormsModule as ɵo, SpiraxPanelComponent as ɵp, SpiraxFormRadioGroupComponent as ɵq, SpiraxToggleComponent as ɵr, SpecSheetHeaderDetailsModule as ɵs, SpecSheetHeaderDetailsComponent as ɵt, ColorsService as ɵu, SparklineDirective as ɵv, CheckallDirective as ɵw, NowDirective as ɵx, ScrollableDirective as ɵy, JqcloudDirective as ɵz };
//# sourceMappingURL=sizing-shared-lib.js.map
